(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './korge-root-korge-foundation.js', './korge-root-korlibs-datastructure.js', './korge-root-korlibs-crypto.js', './korge-root-korlibs-time.js', './korge-root-korlibs-logger.js', './korge-root-korlibs-platform.js', './korge-root-korlibs-concurrent.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./korge-root-korge-foundation.js'), require('./korge-root-korlibs-datastructure.js'), require('./korge-root-korlibs-crypto.js'), require('./korge-root-korlibs-time.js'), require('./korge-root-korlibs-logger.js'), require('./korge-root-korlibs-platform.js'), require('./korge-root-korlibs-concurrent.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'korge-root-korge-core'.");
    }
    if (typeof this['korge-root-korge-foundation'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge-core'. Its dependency 'korge-root-korge-foundation' was not found. Please, check whether 'korge-root-korge-foundation' is loaded prior to 'korge-root-korge-core'.");
    }
    if (typeof this['korge-root-korlibs-datastructure'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge-core'. Its dependency 'korge-root-korlibs-datastructure' was not found. Please, check whether 'korge-root-korlibs-datastructure' is loaded prior to 'korge-root-korge-core'.");
    }
    if (typeof this['korge-root-korlibs-crypto'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge-core'. Its dependency 'korge-root-korlibs-crypto' was not found. Please, check whether 'korge-root-korlibs-crypto' is loaded prior to 'korge-root-korge-core'.");
    }
    if (typeof this['korge-root-korlibs-time'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge-core'. Its dependency 'korge-root-korlibs-time' was not found. Please, check whether 'korge-root-korlibs-time' is loaded prior to 'korge-root-korge-core'.");
    }
    if (typeof this['korge-root-korlibs-logger'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge-core'. Its dependency 'korge-root-korlibs-logger' was not found. Please, check whether 'korge-root-korlibs-logger' is loaded prior to 'korge-root-korge-core'.");
    }
    if (typeof this['korge-root-korlibs-platform'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge-core'. Its dependency 'korge-root-korlibs-platform' was not found. Please, check whether 'korge-root-korlibs-platform' is loaded prior to 'korge-root-korge-core'.");
    }
    if (typeof this['korge-root-korlibs-concurrent'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge-core'. Its dependency 'korge-root-korlibs-concurrent' was not found. Please, check whether 'korge-root-korlibs-concurrent' is loaded prior to 'korge-root-korge-core'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge-core'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'korge-root-korge-core'.");
    }
    root['korge-root-korge-core'] = factory(typeof this['korge-root-korge-core'] === 'undefined' ? {} : this['korge-root-korge-core'], this['kotlin-kotlin-stdlib'], this['korge-root-korge-foundation'], this['korge-root-korlibs-datastructure'], this['korge-root-korlibs-crypto'], this['korge-root-korlibs-time'], this['korge-root-korlibs-logger'], this['korge-root-korlibs-platform'], this['korge-root-korlibs-concurrent'], this['kotlinx-coroutines-core']);
  }
}(this, function (_, kotlin_kotlin, kotlin_com_soywiz_korge_korge_foundation, kotlin_com_soywiz_korge_korlibs_datastructure, kotlin_com_soywiz_korge_korlibs_crypto, kotlin_com_soywiz_korge_korlibs_time, kotlin_com_soywiz_korge_korlibs_logger, kotlin_com_soywiz_korge_korlibs_platform, kotlin_com_soywiz_korge_korlibs_concurrent, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var hypot = Math.hypot;
  var log2 = Math.log2;
  var protoOf = kotlin_kotlin.$_$.uc;
  var objectMeta = kotlin_kotlin.$_$.tc;
  var setMetadataFor = kotlin_kotlin.$_$.vc;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.o;
  var addAll = kotlin_kotlin.$_$.u5;
  var Unit_instance = kotlin_kotlin.$_$.a5;
  var toSet = kotlin_kotlin.$_$.w9;
  var ensureNotNull = kotlin_kotlin.$_$.ih;
  var addAll_0 = kotlin_kotlin.$_$.t5;
  var classMeta = kotlin_kotlin.$_$.jb;
  var VOID = kotlin_kotlin.$_$.f;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
  var THROW_CCE = kotlin_kotlin.$_$.qg;
  var isCharSequence = kotlin_kotlin.$_$.bc;
  var trim = kotlin_kotlin.$_$.xf;
  var toString = kotlin_kotlin.$_$.zc;
  var sorted = kotlin_kotlin.$_$.e9;
  var KProperty0 = kotlin_kotlin.$_$.td;
  var getPropertyCallableRef = kotlin_kotlin.$_$.sb;
  var lazy = kotlin_kotlin.$_$.ph;
  var Companion_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.s3;
  var Companion_instance = kotlin_com_soywiz_korge_korge_foundation.$_$.z2;
  var objectCreate = kotlin_kotlin.$_$.sc;
  var Enum = kotlin_kotlin.$_$.gg;
  var hashCode = kotlin_kotlin.$_$.ub;
  var equals = kotlin_kotlin.$_$.lb;
  var toList = kotlin_kotlin.$_$.o9;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.t1;
  var MarginInt_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.l;
  var arrayListOf = kotlin_kotlin.$_$.w5;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.x;
  var numberToInt = kotlin_kotlin.$_$.qc;
  var RectSlice = kotlin_com_soywiz_korge_korge_foundation.$_$.h4;
  var RectangleI = kotlin_com_soywiz_korge_korge_foundation.$_$.t5;
  var ImageDoNotFitException = kotlin_com_soywiz_korge_korge_foundation.$_$.e4;
  var setExtra = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.u2;
  var hasExtra = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.o2;
  var Mixin = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.y;
  var SizeInt = kotlin_com_soywiz_korge_korge_foundation.$_$.w5;
  var Companion_instance_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.o3;
  var NotImplementedError = kotlin_kotlin.$_$.mg;
  var toIntFloor = kotlin_com_soywiz_korge_korge_foundation.$_$.a8;
  var toIntCeil = kotlin_com_soywiz_korge_korge_foundation.$_$.x7;
  var toRatio = kotlin_com_soywiz_korge_korge_foundation.$_$.r6;
  var clamp = kotlin_com_soywiz_korge_korge_foundation.$_$.y6;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.qh;
  var _SliceOrientation___get_flipX__impl__lgb7bx = kotlin_com_soywiz_korge_korge_foundation.$_$.c1;
  var _SliceOrientation___get_rotation__impl__m65r0o = kotlin_com_soywiz_korge_korge_foundation.$_$.e1;
  var IntArray2 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.k1;
  var Companion_instance_1 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.r;
  var isIntArray = kotlin_kotlin.$_$.fc;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.f2;
  var KMutableProperty1 = kotlin_kotlin.$_$.sd;
  var KProperty1 = kotlin_kotlin.$_$.ud;
  var Property = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.a1;
  var fill = kotlin_kotlin.$_$.e7;
  var toByte = kotlin_kotlin.$_$.wc;
  var CoroutineImpl = kotlin_kotlin.$_$.wa;
  var SequenceScope = kotlin_kotlin.$_$.wd;
  var until = kotlin_kotlin.$_$.pd;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.fa;
  var RuntimeException_init_$Create$ = kotlin_kotlin.$_$.b2;
  var arraycopy = kotlin_com_soywiz_korge_korge_foundation.$_$.q8;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.h1;
  var iterator = kotlin_kotlin.$_$.xd;
  var Iterable = kotlin_kotlin.$_$.h5;
  var UByteArrayInt__get_impl_px6q8a = kotlin_com_soywiz_korge_korge_foundation.$_$.q2;
  var UByteArrayInt__set_impl_gn4532 = kotlin_com_soywiz_korge_korge_foundation.$_$.r2;
  var arraycopy_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.p8;
  var _UByteArrayInt___init__impl__xif7bu = kotlin_com_soywiz_korge_korge_foundation.$_$.o2;
  var ilog2 = kotlin_com_soywiz_korge_korge_foundation.$_$.f7;
  var extract = kotlin_com_soywiz_korge_korge_foundation.$_$.j9;
  var insert = kotlin_com_soywiz_korge_korge_foundation.$_$.ta;
  var Companion_getInstance_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.b3;
  var Companion_getInstance_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.j3;
  var _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq = kotlin_com_soywiz_korge_korge_foundation.$_$.d1;
  var AssertionError_init_$Create$ = kotlin_kotlin.$_$.i1;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.k4;
  var clamp01 = kotlin_com_soywiz_korge_korge_foundation.$_$.u6;
  var min = kotlin_com_soywiz_korge_korge_foundation.$_$.o7;
  var max = kotlin_com_soywiz_korge_korge_foundation.$_$.j7;
  var convertRange = kotlin_com_soywiz_korge_korge_foundation.$_$.c7;
  var clamp_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.x6;
  var interfaceMeta = kotlin_kotlin.$_$.wb;
  var to = kotlin_kotlin.$_$.yh;
  var listOf = kotlin_kotlin.$_$.j8;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b6;
  var toFastList = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.c3;
  var coerceAtMost = kotlin_kotlin.$_$.id;
  var toIntFloor_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.z7;
  var round = kotlin_kotlin.$_$.dd;
  var getU8 = kotlin_com_soywiz_korge_korge_foundation.$_$.ga;
  var getNumberHashCode = kotlin_kotlin.$_$.rb;
  var Companion_instance_2 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.q;
  var isFloatArray = kotlin_kotlin.$_$.ec;
  var FloatArray2 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.h1;
  var _UShortArrayInt___init__impl__kdofb8 = kotlin_com_soywiz_korge_korge_foundation.$_$.t2;
  var toIntRound = kotlin_com_soywiz_korge_korge_foundation.$_$.b8;
  var divCeil = kotlin_com_soywiz_korge_korge_foundation.$_$.e7;
  var UShortArrayInt__set_impl_38wgvc = kotlin_com_soywiz_korge_korge_foundation.$_$.v2;
  var UShortArrayInt__get_impl_ciz20k = kotlin_com_soywiz_korge_korge_foundation.$_$.u2;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.q1;
  var getU16LE = kotlin_com_soywiz_korge_korge_foundation.$_$.ca;
  var getU16BE = kotlin_com_soywiz_korge_korge_foundation.$_$.ba;
  var getU24LE = kotlin_com_soywiz_korge_korge_foundation.$_$.fa;
  var getU24BE = kotlin_com_soywiz_korge_korge_foundation.$_$.ea;
  var getS32LE = kotlin_com_soywiz_korge_korge_foundation.$_$.v9;
  var getS32BE = kotlin_com_soywiz_korge_korge_foundation.$_$.u9;
  var mapOf = kotlin_kotlin.$_$.l8;
  var removePrefix = kotlin_kotlin.$_$.pe;
  var removeSuffix = kotlin_kotlin.$_$.qe;
  var split = kotlin_kotlin.$_$.we;
  var get_lastIndex = kotlin_kotlin.$_$.b8;
  var toIntOrNull = kotlin_kotlin.$_$.if;
  var toDoubleOrNull = kotlin_kotlin.$_$.ff;
  var startsWith = kotlin_kotlin.$_$.xe;
  var setOf = kotlin_kotlin.$_$.z8;
  var toInt = kotlin_kotlin.$_$.kf;
  var printStackTrace = kotlin_kotlin.$_$.sh;
  var GenericSubList = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.j1;
  var contains = kotlin_kotlin.$_$.c6;
  var Collection = kotlin_kotlin.$_$.e5;
  var isInterface = kotlin_kotlin.$_$.gc;
  var GenericListIterator = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.i1;
  var List = kotlin_kotlin.$_$.k5;
  var Ratio__toFloat_impl_1ftup5 = kotlin_com_soywiz_korge_korge_foundation.$_$.h2;
  var clampUByte = kotlin_com_soywiz_korge_korge_foundation.$_$.w6;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r2;
  var appendHexByte = kotlin_com_soywiz_korge_korlibs_crypto.$_$.a;
  var get_niceStr = kotlin_com_soywiz_korge_korge_foundation.$_$.gb;
  var compareTo = kotlin_kotlin.$_$.kb;
  var interpolate = kotlin_com_soywiz_korge_korge_foundation.$_$.p6;
  var Comparable = kotlin_kotlin.$_$.cg;
  var clamp01_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.v6;
  var Companion_getInstance_2 = kotlin_com_soywiz_korge_korge_foundation.$_$.n3;
  var numberToDouble = kotlin_kotlin.$_$.pc;
  var Vector2D = kotlin_com_soywiz_korge_korge_foundation.$_$.x5;
  var Size2D = kotlin_com_soywiz_korge_korge_foundation.$_$.v5;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.r;
  var startsWith_0 = kotlin_kotlin.$_$.ye;
  var firstOrNull = kotlin_kotlin.$_$.j7;
  var first = kotlin_kotlin.$_$.l7;
  var toMap = kotlin_kotlin.$_$.r9;
  var toIntMap = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.f3;
  var lines = kotlin_kotlin.$_$.oe;
  var charArrayOf = kotlin_kotlin.$_$.eb;
  var split_0 = kotlin_kotlin.$_$.ve;
  var plus = kotlin_kotlin.$_$.r8;
  var numberToChar = kotlin_kotlin.$_$.oc;
  var toString_0 = kotlin_kotlin.$_$.y2;
  var toInt_0 = kotlin_kotlin.$_$.jf;
  var toDouble = kotlin_kotlin.$_$.gf;
  var mapCapacity = kotlin_kotlin.$_$.k8;
  var coerceAtLeast = kotlin_kotlin.$_$.hd;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.w;
  var associateByInt = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.w1;
  var PerformanceCounter_instance = kotlin_com_soywiz_korge_korlibs_time.$_$.f;
  var DurationUnit_MICROSECONDS_getInstance = kotlin_kotlin.$_$.g;
  var toDuration = kotlin_kotlin.$_$.zf;
  var TimedResult = kotlin_com_soywiz_korge_korlibs_time.$_$.l;
  var fromBase64 = kotlin_com_soywiz_korge_korlibs_crypto.$_$.b;
  var toIntCeil_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.w7;
  var Companion_getInstance_3 = kotlin_com_soywiz_korge_korge_foundation.$_$.k3;
  var listOf_0 = kotlin_kotlin.$_$.i8;
  var VectorPath = kotlin_com_soywiz_korge_korge_foundation.$_$.z4;
  var applyTransform = kotlin_com_soywiz_korge_korge_foundation.$_$.a5;
  var getCurves = kotlin_com_soywiz_korge_korge_foundation.$_$.b5;
  var println = kotlin_kotlin.$_$.ab;
  var Line2D = kotlin_com_soywiz_korge_korge_foundation.$_$.m5;
  var emptyList = kotlin_kotlin.$_$.b7;
  var Companion_getInstance_4 = kotlin_com_soywiz_korge_korge_foundation.$_$.r3;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.l4;
  var Companion_getInstance_5 = kotlin_com_soywiz_korge_korge_foundation.$_$.g3;
  var plus_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.c5;
  var _BoundsBuilder___get_bounds__impl__s1l1gx = kotlin_com_soywiz_korge_korge_foundation.$_$.q1;
  var BoundsBuilder__plus_impl_cz7f7x = kotlin_com_soywiz_korge_korge_foundation.$_$.u1;
  var FastArrayList_init_$Create$ = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.c;
  var RectangleD = kotlin_com_soywiz_korge_korge_foundation.$_$.s5;
  var BoundsBuilder__plus_impl_cz7f7x_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.w1;
  var get_immutable = kotlin_com_soywiz_korge_korge_foundation.$_$.c6;
  var Vector2D_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.x;
  var Scale_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.q;
  var toFloat = kotlin_com_soywiz_korge_korge_foundation.$_$.h6;
  var getExtraTyped = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.l2;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x2;
  var IntMap_init_$Create$ = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.g;
  var numberRangeToNumber = kotlin_kotlin.$_$.nc;
  var IntArrayList = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.l1;
  var first_0 = kotlin_kotlin.$_$.k7;
  var PropertyThis = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.z;
  var niceStr = kotlin_com_soywiz_korge_korge_foundation.$_$.hb;
  var roundToInt = kotlin_kotlin.$_$.cd;
  var getBooleanHashCode = kotlin_kotlin.$_$.pb;
  var firstOrNull_0 = kotlin_kotlin.$_$.i7;
  var get_niceStr_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.fb;
  var copyOfRange = kotlin_kotlin.$_$.o6;
  var toList_0 = kotlin_kotlin.$_$.m9;
  var emptyMap = kotlin_kotlin.$_$.c7;
  var last = kotlin_kotlin.$_$.f8;
  var Level_DEBUG_getInstance = kotlin_com_soywiz_korge_korlibs_logger.$_$.a;
  var THROW_IAE = kotlin_kotlin.$_$.rg;
  var getProgressionLastElement = kotlin_kotlin.$_$.za;
  var isNumber = kotlin_kotlin.$_$.ic;
  var toShort = kotlin_kotlin.$_$.yc;
  var Char__plus_impl_qi7pgj = kotlin_kotlin.$_$.v2;
  var Default_getInstance = kotlin_kotlin.$_$.p4;
  var step = kotlin_kotlin.$_$.nd;
  var reverse = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.s2;
  var DoubleArrayList = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.x;
  var Companion_getInstance_6 = kotlin_com_soywiz_korge_korlibs_logger.$_$.g;
  var fillArrayVal = kotlin_kotlin.$_$.nb;
  var charSequenceLength = kotlin_kotlin.$_$.hb;
  var charSequenceGet = kotlin_kotlin.$_$.gb;
  var getStringHashCode = kotlin_kotlin.$_$.tb;
  var IntIntMap_init_$Create$ = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.f;
  var getCyclic = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.k2;
  var toList_1 = kotlin_kotlin.$_$.p9;
  var arc$default = kotlin_com_soywiz_korge_korge_foundation.$_$.k;
  var VectorBuilder = kotlin_com_soywiz_korge_korge_foundation.$_$.y4;
  var Scale = kotlin_com_soywiz_korge_korge_foundation.$_$.u5;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.vh;
  var get_hex = kotlin_com_soywiz_korge_korlibs_crypto.$_$.d;
  var Long = kotlin_kotlin.$_$.kg;
  var copyOfRange_0 = kotlin_kotlin.$_$.n6;
  var toIntArrayList = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.e3;
  var Matrix = kotlin_com_soywiz_korge_korge_foundation.$_$.p5;
  var repeat = kotlin_kotlin.$_$.re;
  var getOrNull = kotlin_kotlin.$_$.o7;
  var joinToString = kotlin_kotlin.$_$.w7;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.x1;
  var primitiveArrayConcat = kotlin_kotlin.$_$.e;
  var Level_INFO_getInstance = kotlin_com_soywiz_korge_korlibs_logger.$_$.c;
  var toIntArray = kotlin_kotlin.$_$.l9;
  var first_1 = kotlin_kotlin.$_$.m7;
  var getOrNull_0 = kotlin_kotlin.$_$.q7;
  var extractSigned = kotlin_com_soywiz_korge_korge_foundation.$_$.i9;
  var lastOrNull = kotlin_kotlin.$_$.e8;
  var insert16 = kotlin_com_soywiz_korge_korge_foundation.$_$.ma;
  var Comparator = kotlin_kotlin.$_$.dg;
  var compareValues = kotlin_kotlin.$_$.ba;
  var hasBitSet = kotlin_com_soywiz_korge_korge_foundation.$_$.ha;
  var FastIntMap = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.e1;
  var sortWith = kotlin_kotlin.$_$.c9;
  var getExtra = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.m2;
  var contains_0 = kotlin_kotlin.$_$.be;
  var toLong = kotlin_kotlin.$_$.xc;
  var getS32Array = kotlin_com_soywiz_korge_korge_foundation.$_$.t9;
  var getS32ArrayLE = kotlin_com_soywiz_korge_korge_foundation.$_$.s9;
  var splitInRows = kotlin_com_soywiz_korge_korge_foundation.$_$.j4;
  var toLinkedMap = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.g3;
  var Companion_getInstance_7 = kotlin_kotlin.$_$.r4;
  var DurationUnit_MILLISECONDS_getInstance = kotlin_kotlin.$_$.h;
  var slice = kotlin_kotlin.$_$.b9;
  var checkIndexOverflow = kotlin_kotlin.$_$.a6;
  var getU16 = kotlin_com_soywiz_korge_korge_foundation.$_$.da;
  var getS32 = kotlin_com_soywiz_korge_korge_foundation.$_$.w9;
  var Endian_LITTLE_ENDIAN_getInstance = kotlin_com_soywiz_korge_korlibs_platform.$_$.b;
  var Endian_BIG_ENDIAN_getInstance = kotlin_com_soywiz_korge_korlibs_platform.$_$.a;
  var Level_ERROR_getInstance = kotlin_com_soywiz_korge_korlibs_logger.$_$.b;
  var distinct = kotlin_kotlin.$_$.z6;
  var sortedWith = kotlin_kotlin.$_$.d9;
  var fastArrayListOf = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.d2;
  var Exception = kotlin_kotlin.$_$.ig;
  var get_hex_0 = kotlin_com_soywiz_korge_korlibs_crypto.$_$.c;
  var minus = kotlin_kotlin.$_$.o8;
  var CancellationException = kotlin_kotlin.$_$.ea;
  var toMutableSet = kotlin_kotlin.$_$.v9;
  var setOf_0 = kotlin_kotlin.$_$.y8;
  var NonRecursiveLock = kotlin_com_soywiz_korge_korlibs_concurrent.$_$.b;
  var plus_1 = kotlin_kotlin.$_$.p8;
  var DurationUnit_SECONDS_getInstance = kotlin_kotlin.$_$.j;
  var Duration = kotlin_kotlin.$_$.yf;
  var toMap_0 = kotlin_kotlin.$_$.q9;
  var SliceOrientation = kotlin_com_soywiz_korge_korge_foundation.$_$.i4;
  var ByteArrayBuilder_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.a1;
  var _UByteArrayInt___init__impl__xif7bu_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.p2;
  var toIntArray_0 = kotlin_kotlin.$_$.k9;
  var asByteArray = kotlin_com_soywiz_korge_korge_foundation.$_$.c9;
  var abs = kotlin_kotlin.$_$.bd;
  var _UByteArrayInt___get_size__impl__bcjnte = kotlin_com_soywiz_korge_korge_foundation.$_$.s2;
  var UByteArrayInt = kotlin_com_soywiz_korge_korge_foundation.$_$.i8;
  var toIntRound_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.c8;
  var Vector2D_init_$Create$_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.y;
  var _Ratio___init__impl__9mwvn2 = kotlin_com_soywiz_korge_korge_foundation.$_$.c2;
  var Companion_getInstance_8 = kotlin_com_soywiz_korge_korge_foundation.$_$.f3;
  var clamp_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.z6;
  var Angle_between = kotlin_com_soywiz_korge_korge_foundation.$_$.i5;
  var Angle__unaryMinus_impl_7901fr = kotlin_com_soywiz_korge_korge_foundation.$_$.p1;
  var get_degrees = kotlin_com_soywiz_korge_korge_foundation.$_$.b6;
  var Angle__div_impl_ut2btd = kotlin_com_soywiz_korge_korge_foundation.$_$.j1;
  var Angle = kotlin_com_soywiz_korge_korge_foundation.$_$.j5;
  var Angle__hashCode_impl_szcndt = kotlin_com_soywiz_korge_korge_foundation.$_$.k1;
  var DoubleCompanionObject_instance = kotlin_kotlin.$_$.j4;
  var toRatio_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.s6;
  var interpolate_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.q6;
  var Anchor2D = kotlin_com_soywiz_korge_korge_foundation.$_$.h5;
  var BoundsBuilder__xminOr_impl_k3l1m2 = kotlin_com_soywiz_korge_korge_foundation.$_$.z1;
  var BoundsBuilder = kotlin_com_soywiz_korge_korge_foundation.$_$.k5;
  var BoundsBuilder__hashCode_impl_649zbo = kotlin_com_soywiz_korge_korge_foundation.$_$.s1;
  var BoundsBuilder__plus_impl_cz7f7x_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.t1;
  var getOrNull_1 = kotlin_kotlin.$_$.p7;
  var get_radians = kotlin_com_soywiz_korge_korge_foundation.$_$.e6;
  var _Angle___get_degrees__impl__qg56vw = kotlin_com_soywiz_korge_korge_foundation.$_$.i1;
  var doubleArrayListOf = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.a2;
  var DoubleVectorArrayList = kotlin_com_soywiz_korge_korge_foundation.$_$.l5;
  var MatrixTransform_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.n;
  var get_PI2 = kotlin_com_soywiz_korge_korge_foundation.$_$.q5;
  var Ratio__times_impl_ucdh7y = kotlin_com_soywiz_korge_korge_foundation.$_$.f2;
  var _Angle___init__impl__g23q1m = kotlin_com_soywiz_korge_korge_foundation.$_$.f1;
  var _Angle___get_ratio__impl__ap3on4 = kotlin_com_soywiz_korge_korge_foundation.$_$.m1;
  var Ratio__toDouble_impl_o7epze = kotlin_com_soywiz_korge_korge_foundation.$_$.g2;
  var get_nextPowerOfTwo = kotlin_com_soywiz_korge_korge_foundation.$_$.s7;
  var maxOrNull = kotlin_kotlin.$_$.n8;
  var intArrayListOf = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.p2;
  var fill_0 = kotlin_kotlin.$_$.f7;
  var Companion_instance_3 = kotlin_com_soywiz_korge_korge_foundation.$_$.c3;
  var coerceIn = kotlin_kotlin.$_$.jd;
  var Winding_EVEN_ODD_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.g;
  var StrokeToFill = kotlin_com_soywiz_korge_korge_foundation.$_$.n4;
  var strokeToFill = kotlin_com_soywiz_korge_korge_foundation.$_$.e5;
  var Vector2D_init_$Create$_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.v;
  var Command_instance = kotlin_com_soywiz_korge_korge_foundation.$_$.d3;
  var Companion_getInstance_9 = kotlin_com_soywiz_korge_korge_foundation.$_$.u3;
  var Companion_getInstance_10 = kotlin_com_soywiz_korge_korge_foundation.$_$.y2;
  var _Ratio___init__impl__9mwvn2_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.d2;
  var LineScaleMode_NORMAL_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.f;
  var LineCap_BUTT_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.c;
  var LineJoin_MITER_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.d;
  var _TGenStack___init__impl__yynjgt = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.n;
  var TGenStack__push_impl_9yh33t = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.p;
  var TGenStack__pop_impl_qisxa0 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.o;
  var Winding_NON_ZERO_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.h;
  var line = kotlin_com_soywiz_korge_korge_foundation.$_$.r4;
  var isEmpty = kotlin_com_soywiz_korge_korge_foundation.$_$.q4;
  var rect = kotlin_com_soywiz_korge_korge_foundation.$_$.w4;
  var rect_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.u4;
  var rect_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.v4;
  var arc = kotlin_com_soywiz_korge_korge_foundation.$_$.o4;
  var circle = kotlin_com_soywiz_korge_korge_foundation.$_$.p4;
  var rMoveTo = kotlin_com_soywiz_korge_korge_foundation.$_$.t4;
  var rLineTo = kotlin_com_soywiz_korge_korge_foundation.$_$.s4;
  var transformed = kotlin_com_soywiz_korge_korge_foundation.$_$.x4;
  var umod = kotlin_com_soywiz_korge_korge_foundation.$_$.f8;
  var insert8 = kotlin_com_soywiz_korge_korge_foundation.$_$.ra;
  var toCurvesList = kotlin_com_soywiz_korge_korge_foundation.$_$.f5;
  var ProjectedPoint = kotlin_com_soywiz_korge_korge_foundation.$_$.b4;
  var Companion_getInstance_11 = kotlin_com_soywiz_korge_korge_foundation.$_$.h3;
  var write = kotlin_com_soywiz_korge_korge_foundation.$_$.g5;
  var get_isConvex = kotlin_com_soywiz_korge_korge_foundation.$_$.c4;
  var strokeToFill_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.d5;
  var BoundsBuilder__boundsOrNull_impl_se9lyg = kotlin_com_soywiz_korge_korge_foundation.$_$.r1;
  var get_mutable = kotlin_com_soywiz_korge_korge_foundation.$_$.d6;
  var StrokeInfo = kotlin_com_soywiz_korge_korge_foundation.$_$.m4;
  var RastScale = kotlin_com_soywiz_korge_korge_foundation.$_$.l4;
  var PolygonScanline = kotlin_com_soywiz_korge_korge_foundation.$_$.k4;
  var IntSegmentSet = kotlin_com_soywiz_korge_korge_foundation.$_$.t6;
  var MatrixType_IDENTITY_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.i;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
  var startCoroutine = kotlin_kotlin.$_$.xa;
  var CoroutineStart_UNDISPATCHED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a;
  var async = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.z;
  var CompletableDeferred = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var Result__exceptionOrNull_impl_p6xea9 = kotlin_kotlin.$_$.a3;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.b3;
  var Continuation = kotlin_kotlin.$_$.pa;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.m;
  var completeWith = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y;
  var get_millisecondsLong = kotlin_com_soywiz_korge_korlibs_time.$_$.s;
  var delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.e;
  var get_isNil = kotlin_com_soywiz_korge_korlibs_time.$_$.o;
  var withTimeout = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g;
  var get = kotlin_kotlin.$_$.ra;
  var fold = kotlin_kotlin.$_$.qa;
  var minusKey = kotlin_kotlin.$_$.sa;
  var plus_2 = kotlin_kotlin.$_$.ua;
  var Element = kotlin_kotlin.$_$.ta;
  var Closeable = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.u;
  var Companion_instance_4 = kotlin_kotlin.$_$.v4;
  var createFailure = kotlin_kotlin.$_$.hh;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z2;
  var AbstractCoroutineContextElement = kotlin_kotlin.$_$.ja;
  var Key_instance = kotlin_kotlin.$_$.f4;
  var get_0 = kotlin_kotlin.$_$.la;
  var minusKey_0 = kotlin_kotlin.$_$.ma;
  var releaseInterceptedContinuation = kotlin_kotlin.$_$.na;
  var invokeOnTimeout = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
  var ContinuationInterceptor = kotlin_kotlin.$_$.oa;
  var Delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p;
  var throwOnFailure = kotlin_kotlin.$_$.uh;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.c3;
  var FixedSizeByteArrayBuilder_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.b1;
  var RingBuffer = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.r1;
  var numberToLong = kotlin_kotlin.$_$.rc;
  var isComparable = kotlin_kotlin.$_$.cc;
  var getKClassFromExpression = kotlin_kotlin.$_$.c;
  var toList_2 = kotlin_kotlin.$_$.n9;
  var Map = kotlin_kotlin.$_$.m5;
  var toList_3 = kotlin_kotlin.$_$.lf;
  var toString_1 = kotlin_kotlin.$_$.xh;
  var MutableList = kotlin_kotlin.$_$.o5;
  var MutableMap = kotlin_kotlin.$_$.p5;
  var NullPointerException_init_$Create$ = kotlin_kotlin.$_$.y1;
  var toIntOrNull_0 = kotlin_kotlin.$_$.hf;
  var toLongOrNull = kotlin_kotlin.$_$.mf;
  var substringAfterLast = kotlin_kotlin.$_$.ze;
  var replace = kotlin_kotlin.$_$.te;
  var indexOf = kotlin_kotlin.$_$.he;
  var substringBefore = kotlin_kotlin.$_$.df;
  var contains_1 = kotlin_kotlin.$_$.ce;
  var trimEnd = kotlin_kotlin.$_$.tf;
  var trim_0 = kotlin_kotlin.$_$.wf;
  var Companion_getInstance_12 = kotlin_com_soywiz_korge_korlibs_time.$_$.e;
  var DateTime = kotlin_com_soywiz_korge_korlibs_time.$_$.h;
  var DateTime__hashCode_impl_yf0bc9 = kotlin_com_soywiz_korge_korlibs_time.$_$.a;
  var withContext = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.f;
  var endsWith = kotlin_kotlin.$_$.fe;
  var FastStringMap = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.g1;
  var removeAll = kotlin_kotlin.$_$.s8;
  var Companion_instance_5 = kotlin_com_soywiz_korge_korlibs_platform.$_$.e;
  var until_0 = kotlin_kotlin.$_$.od;
  var RuntimeException = kotlin_kotlin.$_$.pg;
  var linkedHashMapOf = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.r2;
  var toLongOrNull_0 = kotlin_kotlin.$_$.nf;
  var Pool_init_$Create$ = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.h;
  var getS16 = kotlin_com_soywiz_korge_korge_foundation.$_$.q9;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.g1;
  var charArray = kotlin_kotlin.$_$.fb;
  var concatToString = kotlin_kotlin.$_$.zd;
  var CancellationException_init_$Create$ = kotlin_kotlin.$_$.d1;
  var CancellationException_init_$Create$_0 = kotlin_kotlin.$_$.b1;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.l1;
  var captureStack = kotlin_kotlin.$_$.db;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.m1;
  var stackTraceToString = kotlin_kotlin.$_$.th;
  var concatToString_0 = kotlin_kotlin.$_$.ae;
  var get_lastIndex_0 = kotlin_kotlin.$_$.le;
  var lastIndexOf = kotlin_kotlin.$_$.me;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.f1;
  var copyOf = kotlin_kotlin.$_$.x6;
  var contentHashCode = kotlin_kotlin.$_$.i6;
  var contentEquals = kotlin_kotlin.$_$.h6;
  var dropLast = kotlin_kotlin.$_$.de;
  var substringAfter = kotlin_kotlin.$_$.af;
  var substringBefore_0 = kotlin_kotlin.$_$.cf;
  var isBlank = kotlin_kotlin.$_$.je;
  var substringBeforeLast = kotlin_kotlin.$_$.bf;
  var trimStart = kotlin_kotlin.$_$.vf;
  var Char__toByte_impl_7s7yt0 = kotlin_kotlin.$_$.w2;
  var Char = kotlin_kotlin.$_$.bg;
  var toMutableList = kotlin_kotlin.$_$.s9;
  var filterNotNull = kotlin_kotlin.$_$.h7;
  var equals_0 = kotlin_kotlin.$_$.ge;
  var linkedMapOf = kotlin_kotlin.$_$.h8;
  var UnsupportedOperationException = kotlin_kotlin.$_$.dh;
  var UnsupportedOperationException_init_$Create$_0 = kotlin_kotlin.$_$.e2;
  var ClosedRange = kotlin_kotlin.$_$.fd;
  var contains_2 = kotlin_kotlin.$_$.ld;
  var clamp_2 = kotlin_com_soywiz_korge_korge_foundation.$_$.a7;
  var Pair = kotlin_kotlin.$_$.ng;
  var nextAlignedTo = kotlin_com_soywiz_korge_korge_foundation.$_$.p7;
  var toIntClamp = kotlin_com_soywiz_korge_korge_foundation.$_$.y7;
  var copyOf_0 = kotlin_kotlin.$_$.t6;
  var getS8 = kotlin_com_soywiz_korge_korge_foundation.$_$.z9;
  var getS16BE = kotlin_com_soywiz_korge_korge_foundation.$_$.p9;
  var getS64BE = kotlin_com_soywiz_korge_korge_foundation.$_$.x9;
  var getS8Array = kotlin_com_soywiz_korge_korge_foundation.$_$.y9;
  var getS16ArrayBE = kotlin_com_soywiz_korge_korge_foundation.$_$.o9;
  var getU16ArrayBE = kotlin_com_soywiz_korge_korge_foundation.$_$.aa;
  var getS32ArrayBE = kotlin_com_soywiz_korge_korge_foundation.$_$.r9;
  var ByteArrayBuilder = kotlin_com_soywiz_korge_korge_foundation.$_$.h8;
  var indexOf_0 = kotlin_kotlin.$_$.s7;
  var signExtend = kotlin_com_soywiz_korge_korge_foundation.$_$.ab;
  var isNanOrInfinite = kotlin_com_soywiz_korge_korge_foundation.$_$.h7;
  var roundDecimalPlaces = kotlin_com_soywiz_korge_korge_foundation.$_$.u7;
  var indexOf_1 = kotlin_kotlin.$_$.ie;
  var replace_0 = kotlin_kotlin.$_$.se;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.u2;
  var Char__compareTo_impl_ypi4mb = kotlin_kotlin.$_$.s2;
  var Companion_getInstance_13 = kotlin_kotlin.$_$.u4;
  var reversed = kotlin_kotlin.$_$.w8;
  var copyToArray = kotlin_kotlin.$_$.y6;
  var joinToString_0 = kotlin_kotlin.$_$.x7;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.n4;
  var endsWith_0 = kotlin_kotlin.$_$.ee;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.g4;
  var sequence = kotlin_kotlin.$_$.yd;
  var NoSuchElementException = kotlin_kotlin.$_$.lg;
  var flip = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.e2;
  var toCaseInsensitiveMap = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.a3;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q;
  var Deferred = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.n;
  var Duration__minus_impl_q5cfm7 = kotlin_kotlin.$_$.m2;
  var Duration__compareTo_impl_pchp0f = kotlin_kotlin.$_$.g2;
  var asInt32Array = kotlin_com_soywiz_korge_korge_foundation.$_$.d9;
  var intercepted = kotlin_kotlin.$_$.ha;
  var get_MODE_CANCELLABLE = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i;
  var _Angle___get_radians__impl__n00yt5 = kotlin_com_soywiz_korge_korge_foundation.$_$.l1;
  var isArray = kotlin_kotlin.$_$.xb;
  var newThrowable = kotlin_kotlin.$_$.mc;
  var await_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b;
  var toTypedArray = kotlin_kotlin.$_$.y9;
  var returnIfSuspended = kotlin_kotlin.$_$.l;
  var isByteArray = kotlin_kotlin.$_$.zb;
  var drop = kotlin_kotlin.$_$.a7;
  var get_jsGlobalThis = kotlin_com_soywiz_korge_korlibs_platform.$_$.f;
  var Companion_instance_6 = kotlin_com_soywiz_korge_korge_foundation.$_$.x2;
  var lastOrNull_0 = kotlin_kotlin.$_$.d8;
  var Exception_init_$Create$_0 = kotlin_kotlin.$_$.k1;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(AudioFormat, 'AudioFormat', classMeta, VOID, VOID, VOID, VOID, VOID, [2, 4]);
  setMetadataFor(AudioFormats, 'AudioFormats', classMeta, AudioFormat, VOID, AudioFormats, VOID, VOID, [2, 4]);
  setMetadataFor(MP3Decoder, 'MP3Decoder', classMeta, AudioFormat, VOID, MP3Decoder, VOID, VOID, [2, 4]);
  setMetadataFor(Companion_0, 'Companion', objectMeta, MP3Decoder, VOID, VOID, VOID, VOID, [2, 4]);
  setMetadataFor(BaseMinimp3AudioFormat, 'BaseMinimp3AudioFormat', classMeta, AudioFormat, VOID, VOID, VOID, VOID, [2, 3, 4]);
  setMetadataFor(Minimp3AudioFormat, 'Minimp3AudioFormat', objectMeta, BaseMinimp3AudioFormat, VOID, VOID, VOID, VOID, [2, 4]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(WAV, 'WAV', classMeta, AudioFormat, VOID, WAV, VOID, VOID, [2, 4]);
  setMetadataFor(Companion_2, 'Companion', objectMeta, WAV, VOID, VOID, VOID, VOID, [2, 4]);
  setMetadataFor(NativeSoundProvider, 'NativeSoundProvider', classMeta, VOID, VOID, NativeSoundProvider, VOID, VOID, [1, 3, 4, 2]);
  setMetadataFor(NativeSoundProviderNew, 'NativeSoundProviderNew', classMeta, NativeSoundProvider, VOID, NativeSoundProviderNew, VOID, VOID, [1, 3, 4, 2]);
  setMetadataFor(DummyNativeSoundProvider, 'DummyNativeSoundProvider', classMeta, NativeSoundProvider, VOID, DummyNativeSoundProvider, VOID, VOID, [1, 3, 4, 2]);
  setMetadataFor(Companion_3, 'Companion', objectMeta, DummyNativeSoundProvider, VOID, VOID, VOID, VOID, [1, 3, 4, 2]);
  setMetadataFor(GrowMethod, 'GrowMethod', classMeta, Enum);
  setMetadataFor(Entry, 'Entry', classMeta);
  setMetadataFor(MutableAtlas, 'MutableAtlas', classMeta, VOID, VOID, MutableAtlas_init_$Create$);
  setMetadataFor(Bitmap, 'Bitmap', classMeta);
  setMetadataFor(Companion_4, 'Companion', objectMeta, VOID, VOID, VOID, VOID, VOID, [2, 3]);
  setMetadataFor(Bitmap32$iterator$slambda, 'Bitmap32$iterator$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(Bitmap32, 'Bitmap32', classMeta, Bitmap, [Bitmap, Iterable]);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor(BitmapIndexed, 'BitmapIndexed', classMeta, Bitmap);
  setMetadataFor(Bitmap8, 'Bitmap8', classMeta, BitmapIndexed);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(BitmapChannel, 'BitmapChannel', classMeta, Enum);
  setMetadataFor(Bitmaps, 'Bitmaps', objectMeta);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(DistanceBitmap, 'DistanceBitmap', classMeta);
  setMetadataFor(FloatBitmap32, 'FloatBitmap32', classMeta, Bitmap);
  setMetadataFor(MultiBitmap, 'MultiBitmap', classMeta, Bitmap);
  setMetadataFor(NativeImage, 'NativeImage', classMeta, Bitmap);
  function get_forcedTexTarget() {
    return 3553;
  }
  setMetadataFor(ForcedTexId, 'ForcedTexId', interfaceMeta);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor(NinePatchBmpSlice, 'NinePatchBmpSlice', classMeta);
  setMetadataFor(AxisSegment, 'AxisSegment', classMeta);
  setMetadataFor(AxisInfo, 'AxisInfo', classMeta);
  setMetadataFor(Segment, 'Segment', classMeta);
  setMetadataFor(NinePatchInfo, 'NinePatchInfo', classMeta);
  setMetadataFor(NullBitmap, 'NullBitmap', classMeta, Bitmap);
  setMetadataFor(Palette, 'Palette', classMeta);
  setMetadataFor(Result, 'Result', classMeta);
  setMetadataFor(NewSDF, 'NewSDF', objectMeta);
  setMetadataFor(ColorFormat32, 'ColorFormat32', classMeta);
  setMetadataFor(ColorFormat24, 'ColorFormat24', classMeta);
  setMetadataFor(ColorTransformMul, 'ColorTransformMul', classMeta, VOID, VOID, ColorTransformMul);
  setMetadataFor(Colors, 'Colors', objectMeta);
  setMetadataFor(RGB, 'RGB', classMeta, ColorFormat24);
  setMetadataFor(Companion_9, 'Companion', objectMeta, RGB);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor(RgbaArray, 'RgbaArray', classMeta, VOID, [List]);
  setMetadataFor(Companion_11, 'Companion', objectMeta, ColorFormat32);
  setMetadataFor(RGBA, 'RGBA', classMeta, VOID, [Comparable]);
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor(RgbaPremultipliedArray, 'RgbaPremultipliedArray', classMeta);
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor(Companion_15, 'Companion', objectMeta);
  setMetadataFor(Kerning, 'Kerning', classMeta);
  setMetadataFor(Glyph, 'Glyph', classMeta);
  function getOrNull_2() {
    return this;
  }
  function getFontMetrics$default(size, metrics, $super) {
    metrics = metrics === VOID ? new FontMetrics() : metrics;
    return $super === VOID ? this.t3t(size, metrics) : $super.t3t.call(this, size, metrics);
  }
  function getGlyphMetrics$default(size, codePoint, metrics, reader, $super) {
    metrics = metrics === VOID ? new GlyphMetrics() : metrics;
    reader = reader === VOID ? null : reader;
    return $super === VOID ? this.f3u(size, codePoint, metrics, reader) : $super.f3u.call(this, size, codePoint, metrics, reader);
  }
  function renderGlyph$default(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw, $super) {
    reader = reader === VOID ? null : reader;
    beforeDraw = beforeDraw === VOID ? null : beforeDraw;
    return $super === VOID ? this.q3u(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) : $super.q3u.call(this, ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw);
  }
  setMetadataFor(Font, 'Font', interfaceMeta, VOID, VOID, VOID, VOID, VOID, [0]);
  function get_baseBmp() {
    return get_bmp(this.q3t().a3t_1);
  }
  function getFontMetrics(size, metrics) {
    return metrics.d3u(this.r3t(), size);
  }
  function getGlyphMetrics(size, codePoint, metrics, reader) {
    var tmp0_safe_receiver = this.g3u(codePoint);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f3t_1;
    return metrics.m3u(tmp1_elvis_lhs == null ? this.s3t() : tmp1_elvis_lhs, size, codePoint);
  }
  function getTextScale(size) {
    return size / this.k3t();
  }
  function get_1(charCode) {
    var tmp0_elvis_lhs = this.g3u(charCode);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.g3u(32) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? this.q3t() : tmp1_elvis_lhs;
  }
  function renderGlyph(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
    var scale = this.p3u(size);
    var tmp0_elvis_lhs = this.n3t().f1(codePoint);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.f3u(size, codePoint, metrics, reader);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
    if (this_0.i3u_1) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    if (tmp_0 == null)
      return false;
    if (metrics.x1q() === 0.0 ? metrics.y1q() === 0.0 : false)
      return false;
    var texX = pos.g28_1 + metrics.r2d();
    var texY = pos.h28_1 + metrics.t2d();
    var swidth = metrics.x1q();
    var sheight = metrics.y1q();
    var tmp_1;
    if (equals(ctx.n3v(), new RGBA(get_DefaultPaint()))) {
      tmp_1 = g.j3t();
    } else {
      // Inline function 'korlibs.image.bitmap.context2d' call
      var this_1 = new Bitmap32(g.j3t().t39_1, g.j3t().u39_1, VOID, true);
      // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
      var rect = this_1.y39_1;
      if (true) {
        this_1.h3a();
      }
      var result;
      try {
        // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
        var ctx_0 = this_1.d3i(true);
        try {
          // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
          // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
          var t = ctx_0.i3i_1.r3u_1;
          try {
            // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>.<anonymous>' call
            ctx_0.m3v(1.0 / scale);
            ctx_0.o3v(ctx.n3v());
            // Inline function 'korlibs.image.vector.Context2d.fillRect' call
            var width = ctx_0.x1q() * scale;
            var height = ctx_0.y1q() * scale;
            ctx_0.p3v(numberToDouble(0), numberToDouble(0), numberToDouble(width), numberToDouble(height));
          }finally {
            ctx_0.i3i_1.r3u_1 = t;
          }
        }finally {
          ctx_0.f1e();
        }
      }finally {
        result = true ? this_1.z3a(rect) : 0;
      }
      var bmpFill = this_1;
      bmpFill.x3k(BitmapChannel_ALPHA_getInstance(), g.j3t(), BitmapChannel_ALPHA_getInstance());
      tmp_1 = bmpFill;
    }
    var bmp = tmp_1;
    if (beforeDraw == null)
      null;
    else
      beforeDraw();
    ctx.q3v(bmp, new Vector2D(texX, texY - metrics.u2d()), new Size2D(swidth, sheight));
    return true;
  }
  function getKerning(size, leftCodePoint, rightCodePoint) {
    var tmp = this.p3u(size);
    var tmp0_safe_receiver = this.o3u(leftCodePoint, rightCodePoint);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i3t_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
    return tmp * (tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs);
  }
  setMetadataFor(BitmapFont, 'BitmapFont', interfaceMeta, VOID, [Font], VOID, VOID, VOID, [0]);
  setMetadataFor(BitmapFontImpl, 'BitmapFontImpl', classMeta, VOID, [BitmapFont], VOID, VOID, VOID, [0]);
  setMetadataFor($readBitmapFontCOROUTINE$35, '$readBitmapFontCOROUTINE$35', classMeta, CoroutineImpl);
  setMetadataFor($readBitmapFontXmlCOROUTINE$36, '$readBitmapFontXmlCOROUTINE$36', classMeta, CoroutineImpl);
  setMetadataFor($readBitmapFontJsonCOROUTINE$37, '$readBitmapFontJsonCOROUTINE$37', classMeta, CoroutineImpl);
  setMetadataFor($readBitmapFontTxtCOROUTINE$38, '$readBitmapFontTxtCOROUTINE$38', classMeta, CoroutineImpl);
  setMetadataFor(TextToBitmapResult, 'TextToBitmapResult', classMeta);
  setMetadataFor(PlacedGlyphMetrics, 'PlacedGlyphMetrics', classMeta);
  setMetadataFor(TextMetricsResult, 'TextMetricsResult', classMeta, VOID, VOID, TextMetricsResult);
  setMetadataFor(MultiplePlacedGlyphMetrics, 'MultiplePlacedGlyphMetrics', classMeta, VOID, VOID, MultiplePlacedGlyphMetrics);
  function reset() {
    this.u46(Companion_getInstance_4().d2d_1);
  }
  function advance(x) {
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var this_0 = this.n46();
    var that = new Vector2D(x, 0.0);
    var tmp$ret$0 = new Vector2D(this_0.g28_1 + that.g28_1, this_0.h28_1 + that.h28_1);
    this.u46(tmp$ret$0);
  }
  function newLine(y, end) {
    this.u46(new Vector2D(0.0, this.n46().h28_1 + y));
    var tmp1 = this.l46();
    this.s46(tmp1 + 1 | 0);
  }
  setMetadataFor(ITextRendererActions, 'ITextRendererActions', interfaceMeta);
  setMetadataFor(TextRendererActions, 'TextRendererActions', classMeta, VOID, [ITextRendererActions]);
  setMetadataFor(drawText$actions$1, VOID, classMeta, TextRendererActions);
  setMetadataFor($readFontCOROUTINE$39, '$readFontCOROUTINE$39', classMeta, CoroutineImpl);
  setMetadataFor(GlyphPath, 'GlyphPath', classMeta, VOID, VOID, GlyphPath);
  setMetadataFor(Companion_16, 'Companion', objectMeta);
  setMetadataFor(LazyBitmapFont, 'LazyBitmapFont', classMeta, VOID, [BitmapFont], VOID, VOID, VOID, [0]);
  setMetadataFor(FontMetrics, 'FontMetrics', classMeta, VOID, VOID, FontMetrics);
  setMetadataFor(GlyphMetrics, 'GlyphMetrics', classMeta, VOID, VOID, GlyphMetrics);
  setMetadataFor(TextMetrics, 'TextMetrics', classMeta, VOID, VOID, TextMetrics);
  setMetadataFor(Companion_17, 'Companion', objectMeta);
  setMetadataFor(GlyphPath_0, 'GlyphPath', classMeta);
  setMetadataFor(CFFResult, 'CFFResult', classMeta);
  setMetadataFor(DataIndex, 'DataIndex', classMeta, VOID, [Iterable], DataIndex_init_$Create$);
  setMetadataFor(Op, 'Op', classMeta, Enum);
  setMetadataFor(Companion_18, 'Companion', objectMeta);
  setMetadataFor(EvalContext, 'EvalContext', classMeta, VOID, VOID, EvalContext);
  setMetadataFor(Op_0, 'Op', classMeta, Enum);
  setMetadataFor(CFF, 'CFF', objectMeta);
  setMetadataFor(CharStringType2, 'CharStringType2', objectMeta);
  setMetadataFor(TtfCIDFont, 'TtfCIDFont', objectMeta);
  setMetadataFor(Companion_19, 'Companion', objectMeta, VOID, VOID, VOID, VOID, VOID, [1]);
  function getGlyphPath$default(size, codePoint, path, reader, $super) {
    path = path === VOID ? new GlyphPath() : path;
    reader = reader === VOID ? null : reader;
    return $super === VOID ? this.x4g(size, codePoint, path, reader) : $super.x4g.call(this, size, codePoint, path, reader);
  }
  function renderGlyph_0(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp1_elvis_lhs = reader == null ? null : reader.a4r_1;
      var old = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      try {
        // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
        this.f3u(size, codePoint, metrics, reader);
        break $l$block;
      }finally {
        if (reader != null)
          reader.a4r_1 = old;
      }
    }
    var g = this.y4g(size, codePoint, VOID, reader);
    if (!(g == null)) {
      if (!(fill == null)) {
        ctx.c43();
      }
      if (!g.w47()) {
        if (beforeDraw == null)
          null;
        else
          beforeDraw();
      }
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = ctx.i3i_1.r3u_1;
      try {
        // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
        // Inline function 'korlibs.image.vector.Context2d.translate' call
        ctx.o46(pos.g28_1, pos.h28_1);
        g.x47(ctx);
      }finally {
        ctx.i3i_1.r3u_1 = t;
      }
      switch (fill) {
        case true:
          ctx.l44();
          break;
        case false:
          ctx.k44();
          break;
        case null:
          break;
      }
      return !g.w47();
    }
    return false;
  }
  setMetadataFor(VectorFont, 'VectorFont', interfaceMeta, VOID, [Font], VOID, VOID, VOID, [0]);
  setMetadataFor(BaseTtfFont, 'BaseTtfFont', classMeta, VOID, [VectorFont], VOID, VOID, VOID, [0]);
  setMetadataFor(TtfFont, 'TtfFont', classMeta, BaseTtfFont, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(Companion_20, 'Companion', objectMeta);
  setMetadataFor(Companion_21, 'Companion', objectMeta);
  setMetadataFor(NamesInfo, 'NamesInfo', classMeta, VOID, VOID, NamesInfo);
  setMetadataFor(SubstitutionInfo, 'SubstitutionInfo', classMeta);
  setMetadataFor(Table, 'Table', classMeta);
  setMetadataFor(HorMetric, 'HorMetric', classMeta);
  setMetadataFor(Companion_22, 'Companion', objectMeta);
  setMetadataFor(NameId, 'NameId', classMeta, Enum);
  setMetadataFor(ColorBitmapInfo, 'ColorBitmapInfo', classMeta, VOID, VOID, ColorBitmapInfo);
  setMetadataFor(SbitLineMetrics, 'SbitLineMetrics', classMeta, VOID, VOID, SbitLineMetrics);
  setMetadataFor(BitmapGlyphInfo, 'BitmapGlyphInfo', classMeta);
  setMetadataFor(ColorLine, 'ColorLine', classMeta);
  setMetadataFor(ColorStop, 'ColorStop', classMeta);
  setMetadataFor(Colrv1Paint, 'Colrv1Paint', classMeta, Enum);
  setMetadataFor(COLRv1, 'COLRv1', classMeta, VOID, VOID, COLRv1);
  setMetadataFor(Contour, 'Contour', classMeta, VOID, VOID, Contour);
  setMetadataFor(GlyphReference, 'GlyphReference', classMeta);
  setMetadataFor(ColrLayerInfo, 'ColrLayerInfo', classMeta);
  function getColorShape$default(pal, $super) {
    pal = pal === VOID ? 0 : pal;
    return $super === VOID ? this.i4o(pal) : $super.i4o.call(this, pal);
  }
  setMetadataFor(ColrGlyphInfo, 'ColrGlyphInfo', interfaceMeta);
  setMetadataFor(ColrGlyphInfoV1, 'ColrGlyphInfoV1', classMeta, VOID, [ColrGlyphInfo]);
  setMetadataFor(ColrGlyphInfoV0, 'ColrGlyphInfoV0', classMeta, VOID, [ColrGlyphInfo]);
  setMetadataFor(GlyphGraphicsPath, 'GlyphGraphicsPath', classMeta, VOID, [VectorBuilder]);
  setMetadataFor(Glyph_0, 'Glyph', classMeta);
  setMetadataFor(CompositeGlyph, 'CompositeGlyph', classMeta, Glyph_0);
  setMetadataFor(CFFGlyph, 'CFFGlyph', classMeta, Glyph_0);
  setMetadataFor(SimpleGlyph, 'SimpleGlyph', classMeta, Glyph_0);
  setMetadataFor(BaseTtfFont$readCblc$1$Subtable, 'Subtable', classMeta);
  setMetadataFor(BaseTtfFont$readSbix$1$StrikeInfo, 'StrikeInfo', classMeta);
  setMetadataFor(BaseTtfFont$readCoverage$RangeInfo, 'RangeInfo', classMeta);
  setMetadataFor(BaseTtfFont$readCmap$1$EncodingRecord, 'EncodingRecord', classMeta);
  setMetadataFor(Companion_23, 'Companion', objectMeta);
  setMetadataFor($readTtfFontCOROUTINE$46, '$readTtfFontCOROUTINE$46', classMeta, CoroutineImpl);
  setMetadataFor(Companion_24, 'Companion', objectMeta);
  setMetadataFor(Mixin_0, 'Mixin', classMeta, VOID, VOID, Mixin_0);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  function resolve() {
    return this;
  }
  setMetadataFor(AseCell, 'AseCell', interfaceMeta);
  setMetadataFor(AseBitmapCell, 'AseBitmapCell', classMeta, VOID, [AseCell]);
  setMetadataFor(AseLinkedCell, 'AseLinkedCell', classMeta, VOID, [AseCell]);
  setMetadataFor(AseTilemapCell, 'AseTilemapCell', classMeta, VOID, [AseCell]);
  setMetadataFor(ImageLayer, 'ImageLayer', classMeta);
  setMetadataFor(AseLayer, 'AseLayer', classMeta, ImageLayer);
  setMetadataFor(AseFrame, 'AseFrame', classMeta);
  setMetadataFor(AsePalette, 'AsePalette', classMeta, Palette);
  setMetadataFor(AseTileset, 'AseTileset', classMeta);
  setMetadataFor(AseSliceKey, 'AseSliceKey', classMeta);
  setMetadataFor(AseSlice, 'AseSlice', classMeta);
  setMetadataFor(AseTag, 'AseTag', classMeta);
  setMetadataFor(AseImage, 'AseImage', classMeta, VOID, VOID, AseImage);
  setMetadataFor(ImageFormat, 'ImageFormat', classMeta, VOID, VOID, VOID, VOID, VOID, [2, 1]);
  setMetadataFor(ImageFormatWithContainer, 'ImageFormatWithContainer', classMeta, ImageFormat, VOID, VOID, VOID, VOID, [2, 1]);
  setMetadataFor(ASE, 'ASE', objectMeta, ImageFormatWithContainer, VOID, VOID, VOID, VOID, [2, 1]);
  setMetadataFor(Companion_25, 'Companion', objectMeta);
  setMetadataFor(DataFormat, 'DataFormat', classMeta, Enum);
  setMetadataFor($readExifBaseCOROUTINE$50, '$readExifBaseCOROUTINE$50', classMeta, CoroutineImpl);
  setMetadataFor(EXIF, 'EXIF', objectMeta, VOID, VOID, VOID, VOID, VOID, [3]);
  setMetadataFor(Direction, 'Direction', classMeta, Enum);
  setMetadataFor(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(ImageAnimation, 'ImageAnimation', classMeta);
  setMetadataFor(Companion_26, 'Companion', objectMeta);
  setMetadataFor(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(ImageData, 'ImageData', classMeta);
  setMetadataFor(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(ImageDataContainer, 'ImageDataContainer', classMeta);
  setMetadataFor(Companion_27, 'Companion', objectMeta);
  setMetadataFor(ImageDecodingProps, 'ImageDecodingProps', classMeta, VOID, VOID, ImageDecodingProps);
  setMetadataFor($decodeCOROUTINE$55, '$decodeCOROUTINE$55', classMeta, CoroutineImpl);
  setMetadataFor(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException', classMeta, Exception);
  setMetadataFor($decodeSuspendCOROUTINE$60, '$decodeSuspendCOROUTINE$60', classMeta, CoroutineImpl);
  setMetadataFor(ImageFormats, 'ImageFormats', classMeta, ImageFormat, VOID, VOID, VOID, VOID, [2, 1]);
  setMetadataFor(ImageFormatsMutable, 'ImageFormatsMutable', classMeta, ImageFormats, VOID, ImageFormatsMutable, VOID, VOID, [2, 1]);
  setMetadataFor(Companion_28, 'Companion', objectMeta);
  setMetadataFor(ImageFrame, 'ImageFrame', classMeta);
  setMetadataFor(ImageFrameLayer, 'ImageFrameLayer', classMeta);
  setMetadataFor(ImageInfo, 'ImageInfo', classMeta, VOID, VOID, ImageInfo);
  setMetadataFor(Companion_29, 'Companion', objectMeta);
  setMetadataFor(Type, 'Type', classMeta, Enum);
  setMetadataFor($readBitmapCOROUTINE$61, '$readBitmapCOROUTINE$61', classMeta, CoroutineImpl);
  setMetadataFor($readImageDataContainerCOROUTINE$62, '$readImageDataContainerCOROUTINE$62', classMeta, CoroutineImpl);
  setMetadataFor($readBitmapSliceCOROUTINE$63, '$readBitmapSliceCOROUTINE$63', classMeta, CoroutineImpl);
  setMetadataFor($_readBitmapCOROUTINE$64, '$_readBitmapCOROUTINE$64', classMeta, CoroutineImpl);
  setMetadataFor(NativeImageFormatProvider, 'NativeImageFormatProvider', classMeta, VOID, VOID, VOID, VOID, VOID, [1, 2, 3]);
  setMetadataFor(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', classMeta, NativeImageFormatProvider, VOID, BaseNativeImageFormatProvider, VOID, VOID, [2, 1, 3]);
  setMetadataFor(NativeImageResult, 'NativeImageResult', classMeta);
  setMetadataFor(BitmapNativeImage, 'BitmapNativeImage', classMeta, NativeImage);
  setMetadataFor($decodeInternalCOROUTINE$67, '$decodeInternalCOROUTINE$67', classMeta, CoroutineImpl);
  setMetadataFor($decodeSuspendCOROUTINE$71, '$decodeSuspendCOROUTINE$71', classMeta, CoroutineImpl);
  setMetadataFor($decodeCOROUTINE$72, '$decodeCOROUTINE$72', classMeta, CoroutineImpl);
  setMetadataFor($decodeCOROUTINE$73, '$decodeCOROUTINE$73', classMeta, CoroutineImpl);
  setMetadataFor(Companion_30, 'Companion', objectMeta);
  setMetadataFor(InterlacedPass, 'InterlacedPass', classMeta);
  setMetadataFor(Colorspace, 'Colorspace', classMeta, Enum);
  setMetadataFor(Header, 'Header', classMeta);
  setMetadataFor(DecodingContext, 'DecodingContext', classMeta);
  setMetadataFor(PNG$readCommon$readChunk$slambda, 'PNG$readCommon$readChunk$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(PNG, 'PNG', objectMeta, ImageFormat, VOID, VOID, VOID, VOID, [2, 1]);
  setMetadataFor(BaseFiller, 'BaseFiller', classMeta);
  setMetadataFor(ColorFiller, 'ColorFiller', classMeta, BaseFiller, VOID, ColorFiller);
  setMetadataFor(Companion_31, 'Companion', objectMeta);
  setMetadataFor(GradientFiller, 'GradientFiller', classMeta, BaseFiller, VOID, GradientFiller);
  setMetadataFor(BitmapFiller, 'BitmapFiller', classMeta, BaseFiller, VOID, BitmapFiller);
  setMetadataFor(NoneFiller, 'NoneFiller', objectMeta, BaseFiller);
  setMetadataFor(Companion_32, 'Companion', objectMeta);
  setMetadataFor(TransformedPaint, 'TransformedPaint', interfaceMeta);
  setMetadataFor(GradientPaint, 'GradientPaint', classMeta, VOID, [TransformedPaint]);
  setMetadataFor(GradientKind, 'GradientKind', classMeta, Enum);
  setMetadataFor(GradientInterpolationMethod, 'GradientInterpolationMethod', classMeta, Enum);
  setMetadataFor(GradientUnits, 'GradientUnits', classMeta, Enum);
  setMetadataFor(NonePaint, 'NonePaint', objectMeta);
  setMetadataFor(BitmapPaint, 'BitmapPaint', classMeta, VOID, [TransformedPaint]);
  setMetadataFor(Companion_33, 'Companion', objectMeta);
  setMetadataFor(VerticalAlign, 'VerticalAlign', classMeta);
  setMetadataFor(Companion_34, 'Companion', objectMeta);
  setMetadataFor(HorizontalAlign, 'HorizontalAlign', classMeta);
  setMetadataFor(Companion_35, 'Companion', objectMeta);
  setMetadataFor(TextAlignment, 'TextAlignment', classMeta);
  function get_version() {
    return 0;
  }
  setMetadataFor(TextRenderer, 'TextRenderer', interfaceMeta);
  setMetadataFor(LineStats, 'LineStats', classMeta, VOID, VOID, LineStats);
  setMetadataFor(BoundBuilderTextRendererActions, 'BoundBuilderTextRendererActions', classMeta, TextRendererActions, VOID, BoundBuilderTextRendererActions);
  setMetadataFor(LineInfo, 'LineInfo', classMeta, VOID, VOID, LineInfo);
  setMetadataFor(Entry_0, 'Entry', classMeta, VOID, VOID, Entry_0);
  setMetadataFor(Text2TextRendererActions, 'Text2TextRendererActions', classMeta, TextRendererActions, VOID, Text2TextRendererActions);
  setMetadataFor(CreateWStringTextRenderer$2, VOID, classMeta, VOID, [TextRenderer]);
  setMetadataFor(CreateStringTextRenderer$2, VOID, classMeta, VOID, [TextRenderer]);
  setMetadataFor(TileMapData, 'TileMapData', classMeta);
  setMetadataFor(Companion_36, 'Companion', objectMeta);
  setMetadataFor(TileSet, 'TileSet', classMeta);
  setMetadataFor(TileSetTileInfo, 'TileSetTileInfo', classMeta);
  setMetadataFor(SegmentHandler, 'SegmentHandler', classMeta, VOID, VOID, SegmentHandler);
  setMetadataFor(ScanlineWriter, 'ScanlineWriter', classMeta);
  setMetadataFor(Renderer, 'Renderer', classMeta);
  setMetadataFor(Bitmap32Context2d, 'Bitmap32Context2d', classMeta, Renderer);
  setMetadataFor(CompositeOperation$Companion$invoke$1, VOID, classMeta);
  setMetadataFor(Companion_37, 'Companion', objectMeta);
  setMetadataFor(Companion_38, 'Companion', objectMeta);
  setMetadataFor(CompositeMode, 'CompositeMode', classMeta, Enum);
  setMetadataFor(BlendMode, 'BlendMode', classMeta, Enum);
  setMetadataFor(State, 'State', classMeta, VOID, VOID, State);
  setMetadataFor(Context2d, 'Context2d', classMeta, VOID, [VectorBuilder]);
  setMetadataFor(Companion_39, 'Companion', objectMeta);
  setMetadataFor(CycleMethod, 'CycleMethod', classMeta, Enum);
  setMetadataFor(ColorizedBeziers, 'ColorizedBeziers', classMeta);
  setMetadataFor(ColoredBezier, 'ColoredBezier', classMeta);
  setMetadataFor(ProjectCurvesLookup, 'ProjectCurvesLookup', classMeta);
  function getPath(path) {
    return path;
  }
  function getPath$default(path, $super) {
    path = path === VOID ? new VectorPath() : path;
    return $super === VOID ? this.p5j(path) : getPath(path);
  }
  function get_bounds() {
    return this.q5j(true);
  }
  setMetadataFor(Shape, 'Shape', interfaceMeta);
  function get_path() {
    return null;
  }
  function getBounds(includeStrokes) {
    var tmp0_safe_receiver = this.f4o();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.StyledShape.getBounds.<anonymous>' call
      tmp = _BoundsBuilder___get_bounds__impl__s1l1gx(plus_0(Companion_getInstance_5().a2e(), tmp0_safe_receiver));
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? Companion_getInstance_2().z2d() : tmp1_elvis_lhs;
  }
  function getPath_0(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.StyledShape.getPath.<anonymous>' call
    var tmp0_safe_receiver = this.f4o();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      path.k34(tmp0_safe_receiver);
    }
    return path;
  }
  function draw(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.i3i_1.r3u_1;
    try {
      // Inline function 'korlibs.image.vector.StyledShape.draw.<anonymous>' call
      c.c43();
      var tmp0_safe_receiver = this.f4o();
      if (tmp0_safe_receiver == null)
        null;
      else {
        draw_0(tmp0_safe_receiver, c);
      }
      if (!(this.y5j() == null)) {
        draw_0(ensureNotNull(this.y5j()), c);
        c.p5i();
      }
      c.q46(get_immutable(this.p46()));
      this.c5k(c);
    }finally {
      c.i3i_1.r3u_1 = t;
    }
  }
  function drawInternal(c) {
  }
  setMetadataFor(StyledShape, 'StyledShape', interfaceMeta, VOID, [Shape]);
  setMetadataFor(FillShape, 'FillShape', classMeta, VOID, [StyledShape]);
  setMetadataFor(CompoundShape, 'CompoundShape', classMeta, VOID, [Shape]);
  setMetadataFor(PolylineShape, 'PolylineShape', classMeta, VOID, [StyledShape]);
  setMetadataFor(TextShape, 'TextShape', classMeta, VOID, [StyledShape]);
  setMetadataFor(EmptyShape, 'EmptyShape', objectMeta, VOID, [Shape]);
  setMetadataFor(ShapeBuilder, 'ShapeBuilder', classMeta, Context2d);
  setMetadataFor(SvgPath, 'SvgPath', objectMeta);
  setMetadataFor(Rasterizer, 'Rasterizer', classMeta, RastScale, VOID, Rasterizer);
  setMetadataFor(DummyRenderer, 'DummyRenderer', classMeta, Renderer);
  setMetadataFor(Companion_40, 'Companion', objectMeta, DummyRenderer);
  setMetadataFor(launchUnscoped$1, VOID, classMeta, VOID, [Continuation]);
  setMetadataFor(_async$slambda, '_async$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(_launch$slambda, '_launch$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(launchUnscopedAndWait$1, VOID, classMeta, VOID, [Continuation]);
  setMetadataFor(AsyncThread$sync$slambda, 'AsyncThread$sync$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(AsyncThread, 'AsyncThread', classMeta, VOID, VOID, AsyncThread, VOID, VOID, [0, 1]);
  setMetadataFor($withTimeoutNullableCOROUTINE$85, '$withTimeoutNullableCOROUTINE$85', classMeta, CoroutineImpl);
  setMetadataFor(Companion_41, 'Companion', objectMeta);
  setMetadataFor(PreferSyncIo, 'PreferSyncIo', classMeta, VOID, [Element]);
  setMetadataFor(BaseSignal, 'BaseSignal', classMeta, VOID, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(Signal, 'Signal', classMeta, BaseSignal, VOID, Signal, VOID, VOID, [0]);
  setMetadataFor(Node, 'Node', classMeta, VOID, [Closeable]);
  setMetadataFor($invokeCOROUTINE$86, '$invokeCOROUTINE$86', classMeta, CoroutineImpl);
  setMetadataFor(AsyncSignal, 'AsyncSignal', classMeta, BaseSignal, VOID, AsyncSignal, VOID, VOID, [1, 0]);
  setMetadataFor(runBlockingNoSuspensions$1$context$1, VOID, classMeta, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, ContinuationInterceptor, Delay], VOID, VOID, VOID, [1]);
  setMetadataFor(runBlockingNoSuspensions$1, VOID, classMeta, VOID, [Continuation]);
  function uncompress(reader, out, $completion) {
    unsupported_0();
  }
  setMetadataFor(CompressionMethod, 'CompressionMethod', interfaceMeta, VOID, VOID, VOID, VOID, VOID, [2, 3]);
  setMetadataFor(uncompress$slambda, 'uncompress$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor($uncompressCOROUTINE$88, '$uncompressCOROUTINE$88', classMeta, CoroutineImpl);
  setMetadataFor(Companion_42, 'Companion', objectMeta);
  setMetadataFor(SlidingWindowWithOutput, 'SlidingWindowWithOutput', classMeta, VOID, VOID, VOID, VOID, VOID, [0, 1]);
  setMetadataFor(DeflatePortable, 'DeflatePortable', classMeta, VOID, [CompressionMethod], VOID, VOID, VOID, [3, 2]);
  setMetadataFor(Companion_43, 'Companion', objectMeta, DeflatePortable, VOID, VOID, VOID, VOID, [3, 2]);
  setMetadataFor($uncompressCOROUTINE$90, '$uncompressCOROUTINE$90', classMeta, CoroutineImpl);
  setMetadataFor($writeCOROUTINE$99, '$writeCOROUTINE$99', classMeta, CoroutineImpl);
  setMetadataFor(ZLib, 'ZLib', classMeta, VOID, [CompressionMethod], VOID, VOID, VOID, [2, 3]);
  setMetadataFor(Companion_44, 'Companion', objectMeta, ZLib, VOID, VOID, VOID, VOID, [2, 3]);
  setMetadataFor(ZLib$uncompress$2, VOID, classMeta, VOID, VOID, VOID, VOID, VOID, [0, 3, 1]);
  setMetadataFor($uncompressCOROUTINE$97, '$uncompressCOROUTINE$97', classMeta, CoroutineImpl);
  setMetadataFor($forInputCOROUTINE$101, '$forInputCOROUTINE$101', classMeta, CoroutineImpl);
  setMetadataFor(Companion_45, 'Companion', objectMeta, VOID, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor($prepareBytesUpToCOROUTINE$103, '$prepareBytesUpToCOROUTINE$103', classMeta, CoroutineImpl);
  setMetadataFor($abytesCOROUTINE$104, '$abytesCOROUTINE$104', classMeta, CoroutineImpl);
  setMetadataFor($readCOROUTINE$105, '$readCOROUTINE$105', classMeta, CoroutineImpl);
  setMetadataFor($hasLengthCOROUTINE$108, '$hasLengthCOROUTINE$108', classMeta, CoroutineImpl);
  setMetadataFor($getLengthCOROUTINE$109, '$getLengthCOROUTINE$109', classMeta, CoroutineImpl);
  function hasLength($completion) {
    var tmp = new $hasLengthCOROUTINE$248(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function getLength($completion) {
    throw UnsupportedOperationException_init_$Create$_0();
  }
  setMetadataFor(AsyncGetLengthStream, 'AsyncGetLengthStream', interfaceMeta, VOID, VOID, VOID, VOID, VOID, [0]);
  function getPosition($completion) {
    throw UnsupportedOperationException_init_$Create$_0();
  }
  setMetadataFor(AsyncGetPositionStream, 'AsyncGetPositionStream', interfaceMeta, VOID, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(BitReader, 'BitReader', classMeta, VOID, [AsyncGetLengthStream, AsyncGetPositionStream], VOID, VOID, VOID, [0, 1, 2, 3]);
  setMetadataFor(Companion_46, 'Companion', objectMeta);
  setMetadataFor(HuffmanTree, 'HuffmanTree', classMeta, VOID, VOID, HuffmanTree);
  setMetadataFor(SlidingWindow, 'SlidingWindow', classMeta);
  setMetadataFor(KorAtomicRef, 'KorAtomicRef', classMeta);
  setMetadataFor(KorAtomicLong, 'KorAtomicLong', classMeta);
  setMetadataFor(KorAtomicInt, 'KorAtomicInt', classMeta);
  setMetadataFor(Companion_47, 'Companion', objectMeta);
  setMetadataFor(Dyn, 'Dyn', classMeta, VOID, [Comparable], VOID, VOID, VOID, [2, 1]);
  function get_global() {
    return null;
  }
  setMetadataFor(DynApi, 'DynApi', interfaceMeta, VOID, VOID, VOID, VOID, VOID, [2, 3]);
  setMetadataFor(VfsNamed, 'VfsNamed', classMeta);
  setMetadataFor(Vfs$Proxy$initOnce$slambda, 'Vfs$Proxy$initOnce$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor($getUnderlyingUnscapedFileCOROUTINE$124, '$getUnderlyingUnscapedFileCOROUTINE$124', classMeta, CoroutineImpl);
  setMetadataFor($initOnceCOROUTINE$125, '$initOnceCOROUTINE$125', classMeta, CoroutineImpl);
  setMetadataFor($openCOROUTINE$127, '$openCOROUTINE$127', classMeta, CoroutineImpl);
  setMetadataFor($readRangeCOROUTINE$128, '$readRangeCOROUTINE$128', classMeta, CoroutineImpl);
  setMetadataFor($statCOROUTINE$131, '$statCOROUTINE$131', classMeta, CoroutineImpl);
  setMetadataFor(Vfs, 'Vfs', classMeta, VOID, VOID, VOID, VOID, VOID, [0, 3, 2, 4, 1]);
  setMetadataFor(Proxy, 'Proxy', classMeta, Vfs, VOID, VOID, VOID, VOID, [1, 0, 4, 2, 3]);
  setMetadataFor($readRangeCOROUTINE$115, '$readRangeCOROUTINE$115', classMeta, CoroutineImpl);
  setMetadataFor(VfsStat, 'VfsStat', classMeta);
  setMetadataFor(VfsOpenMode, 'VfsOpenMode', classMeta, Enum);
  setMetadataFor(Companion_48, 'Companion', objectMeta);
  setMetadataFor(VfsCachedStatContext, 'VfsCachedStatContext', classMeta, VOID, [Element]);
  setMetadataFor($readStringCOROUTINE$147, '$readStringCOROUTINE$147', classMeta, CoroutineImpl);
  setMetadataFor($readAsSyncStreamCOROUTINE$149, '$readAsSyncStreamCOROUTINE$149', classMeta, CoroutineImpl);
  setMetadataFor($statCOROUTINE$150, '$statCOROUTINE$150', classMeta, CoroutineImpl);
  setMetadataFor(VfsFile, 'VfsFile', classMeta, VfsNamed, VOID, VOID, VOID, VOID, [2, 3, 0, 1, 4, 5]);
  setMetadataFor(FinalVfsFile, 'FinalVfsFile', classMeta);
  setMetadataFor($getLengthCOROUTINE$170, '$getLengthCOROUTINE$170', classMeta, CoroutineImpl);
  setMetadataFor(CatalogVfs$open$slambda, 'CatalogVfs$open$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(AsyncStreamBase, 'AsyncStreamBase', classMeta, VOID, [AsyncGetLengthStream], AsyncStreamBase, VOID, VOID, [4, 1, 0]);
  setMetadataFor(CatalogVfs$open$2, VOID, classMeta, AsyncStreamBase, VOID, VOID, VOID, VOID, [4, 1, 0]);
  setMetadataFor($openCOROUTINE$163, '$openCOROUTINE$163', classMeta, CoroutineImpl);
  setMetadataFor($statCOROUTINE$164, '$statCOROUTINE$164', classMeta, CoroutineImpl);
  setMetadataFor($statOrNullCOROUTINE$165, '$statOrNullCOROUTINE$165', classMeta, CoroutineImpl);
  setMetadataFor($cachedListSimpleStatsOrNullCOROUTINE$168, '$cachedListSimpleStatsOrNullCOROUTINE$168', classMeta, CoroutineImpl);
  setMetadataFor($listSimpleStatsOrNullCOROUTINE$169, '$listSimpleStatsOrNullCOROUTINE$169', classMeta, CoroutineImpl);
  setMetadataFor(CatalogVfs, 'CatalogVfs', classMeta, Proxy, VOID, VOID, VOID, VOID, [2, 1, 0, 4, 3]);
  setMetadataFor(Companion_49, 'Companion', objectMeta);
  setMetadataFor(JailVfs, 'JailVfs', classMeta, Proxy, VOID, VOID, VOID, VOID, [1, 0, 4, 3, 2]);
  setMetadataFor(Companion_50, 'Companion', objectMeta);
  setMetadataFor(LocalVfs, 'LocalVfs', classMeta, Vfs, VOID, VOID, VOID, VOID, [1, 0, 3, 4, 2]);
  setMetadataFor(StandardVfs, 'StandardVfs', classMeta, VOID, VOID, StandardVfs);
  setMetadataFor(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor($closeCOROUTINE$188, '$closeCOROUTINE$188', classMeta, CoroutineImpl);
  setMetadataFor(MountableVfs, 'MountableVfs', classMeta, Proxy, VOID, VOID, VOID, VOID, [0, 1, 4, 3, 2]);
  function appPreferencesFolder(appId) {
    return Companion_instance_5.k1p() ? '/Users/' + Companion_instance_60.s13('USER') + '/Library/Preferences/' + appId : Companion_instance_5.i1p() ? '' + Companion_instance_60.s13('APPDATA') + '/' + appId : '' + Companion_instance_60.s13('HOME') + '/.config/' + appId;
  }
  setMetadataFor(StandardPathsBase, 'StandardPathsBase', interfaceMeta);
  setMetadataFor($readCOROUTINE$196, '$readCOROUTINE$196', classMeta, CoroutineImpl);
  setMetadataFor($getLengthCOROUTINE$197, '$getLengthCOROUTINE$197', classMeta, CoroutineImpl);
  setMetadataFor(UrlVfs$open$2, VOID, classMeta, AsyncStreamBase, VOID, VOID, VOID, VOID, [4, 0, 1]);
  setMetadataFor($openCOROUTINE$190, '$openCOROUTINE$190', classMeta, CoroutineImpl);
  setMetadataFor($_readRangeBaseCOROUTINE$192, '$_readRangeBaseCOROUTINE$192', classMeta, CoroutineImpl);
  setMetadataFor($readRangeCOROUTINE$193, '$readRangeCOROUTINE$193', classMeta, CoroutineImpl);
  setMetadataFor($statCOROUTINE$195, '$statCOROUTINE$195', classMeta, CoroutineImpl);
  setMetadataFor(UrlVfs_0, 'UrlVfs', classMeta, Vfs, VOID, VOID, VOID, VOID, [2, 1, 3, 0, 4]);
  setMetadataFor(Companion_51, 'Companion', objectMeta);
  setMetadataFor(Charset, 'Charset', classMeta);
  setMetadataFor(UTF16Charset, 'UTF16Charset', classMeta, Charset);
  setMetadataFor(BaseSingleByteCharset, 'BaseSingleByteCharset', classMeta, Charset);
  setMetadataFor(SingleByteCharset, 'SingleByteCharset', classMeta, BaseSingleByteCharset);
  setMetadataFor(ASCII, 'ASCII', objectMeta, SingleByteCharset);
  setMetadataFor(ISO_8859_1, 'ISO_8859_1', objectMeta, SingleByteCharset);
  setMetadataFor(UTC8CharsetBase, 'UTC8CharsetBase', classMeta, Charset);
  setMetadataFor(Charsets, 'Charsets', objectMeta);
  function cancel(e) {
    this.p21();
  }
  setMetadataFor(CloseableCancellable, 'CloseableCancellable', interfaceMeta, VOID, [Closeable]);
  setMetadataFor(CancellableGroup, 'CancellableGroup', classMeta, VOID, [CloseableCancellable], CancellableGroup);
  setMetadataFor(sam$korlibs_io_lang_Disposable$0, 'sam$korlibs_io_lang_Disposable$0', classMeta);
  setMetadataFor(sam$korlibs_io_lang_Cancellable$0, 'sam$korlibs_io_lang_Cancellable$0', classMeta);
  setMetadataFor(Companion_52, 'Companion', objectMeta);
  setMetadataFor(InvalidOperationException, 'InvalidOperationException', classMeta, Exception, VOID, InvalidOperationException);
  setMetadataFor(MalformedInputException, 'MalformedInputException', classMeta, Exception);
  setMetadataFor(IOException, 'IOException', classMeta, Exception);
  setMetadataFor(FileAlreadyExistsException, 'FileAlreadyExistsException', classMeta, IOException);
  setMetadataFor(ReservedException, 'ReservedException', classMeta, Exception, VOID, ReservedException);
  setMetadataFor(UnreachableException, 'UnreachableException', classMeta, Exception, VOID, UnreachableException);
  setMetadataFor(NativeThreadLocal, 'NativeThreadLocal', classMeta);
  setMetadataFor(threadLocal$local$1, VOID, classMeta, NativeThreadLocal);
  setMetadataFor(threadLocal, 'threadLocal', classMeta);
  setMetadataFor(WStringReader, 'WStringReader', classMeta);
  setMetadataFor(Companion_53, 'Companion', objectMeta);
  setMetadataFor(WString, 'WString', classMeta);
  setMetadataFor(QueryString, 'QueryString', objectMeta);
  setMetadataFor(Companion_54, 'Companion', objectMeta);
  setMetadataFor(URL_0, 'URL', classMeta);
  setMetadataFor(Companion_55, 'Companion', objectMeta);
  setMetadataFor(Companion_56, 'Companion', objectMeta);
  setMetadataFor(Companion_57, 'Companion', objectMeta);
  setMetadataFor(sam$kotlin_Comparator$0_4, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(Methods, 'Methods', classMeta, Enum);
  setMetadataFor(HttpException, 'HttpException', classMeta, IOException);
  setMetadataFor(Headers, 'Headers', classMeta, VOID, [Iterable]);
  setMetadataFor(Companion_58, 'Companion', objectMeta, VOID, VOID, VOID, VOID, VOID, [4]);
  setMetadataFor($readAllBytesCOROUTINE$201, '$readAllBytesCOROUTINE$201', classMeta, CoroutineImpl);
  setMetadataFor($readAllStringCOROUTINE$202, '$readAllStringCOROUTINE$202', classMeta, CoroutineImpl);
  setMetadataFor($checkErrorsCOROUTINE$203, '$checkErrorsCOROUTINE$203', classMeta, CoroutineImpl);
  setMetadataFor(Companion_59, 'Companion', objectMeta);
  setMetadataFor(Response, 'Response', classMeta, VOID, VOID, VOID, VOID, VOID, [0, 1]);
  setMetadataFor(CompletedResponse, 'CompletedResponse', classMeta);
  setMetadataFor(RequestConfig, 'RequestConfig', classMeta, VOID, VOID, RequestConfig);
  setMetadataFor(Companion_60, 'Companion', objectMeta);
  setMetadataFor($requestCOROUTINE$206, '$requestCOROUTINE$206', classMeta, CoroutineImpl);
  setMetadataFor($requestAsBytesCOROUTINE$208, '$requestAsBytesCOROUTINE$208', classMeta, CoroutineImpl);
  setMetadataFor($readBytesCOROUTINE$209, '$readBytesCOROUTINE$209', classMeta, CoroutineImpl);
  setMetadataFor(HttpClient, 'HttpClient', classMeta, VOID, VOID, VOID, VOID, VOID, [4, 5, 2]);
  setMetadataFor(HttpStatusMessage, 'HttpStatusMessage', objectMeta);
  setMetadataFor(ProxiedHttpFactory, 'ProxiedHttpFactory', classMeta);
  setMetadataFor(Fixed, 'Fixed', classMeta, VOID, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(Resources, 'Resources', classMeta);
  setMetadataFor(AsyncStream$read$slambda, 'AsyncStream$read$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(AsyncStream$write$slambda, 'AsyncStream$write$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor($readCOROUTINE$230, '$readCOROUTINE$230', classMeta, CoroutineImpl);
  setMetadataFor($writeCOROUTINE$231, '$writeCOROUTINE$231', classMeta, CoroutineImpl);
  setMetadataFor($readInternalCOROUTINE$232, '$readInternalCOROUTINE$232', classMeta, CoroutineImpl);
  setMetadataFor($writeInternalCOROUTINE$233, '$writeInternalCOROUTINE$233', classMeta, CoroutineImpl);
  setMetadataFor($getAvailableCOROUTINE$234, '$getAvailableCOROUTINE$234', classMeta, CoroutineImpl);
  setMetadataFor(AsyncPositionLengthStream, 'AsyncPositionLengthStream', interfaceMeta, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], VOID, VOID, VOID, [1, 0]);
  setMetadataFor(AsyncStream, 'AsyncStream', classMeta, VOID, [AsyncGetLengthStream, AsyncGetPositionStream, AsyncPositionLengthStream], VOID, VOID, VOID, [3, 1, 0]);
  setMetadataFor($hasLengthCOROUTINE$248, '$hasLengthCOROUTINE$248', classMeta, CoroutineImpl);
  setMetadataFor(MemoryAsyncStreamBase, 'MemoryAsyncStreamBase', classMeta, AsyncStreamBase, VOID, MemoryAsyncStreamBase_init_$Create$, VOID, VOID, [1, 0, 4]);
  setMetadataFor($_readCOROUTINE$260, '$_readCOROUTINE$260', classMeta, CoroutineImpl);
  setMetadataFor(BufferedStreamBase, 'BufferedStreamBase', classMeta, AsyncStreamBase, VOID, VOID, VOID, VOID, [4, 1, 0]);
  setMetadataFor($closeCOROUTINE$265, '$closeCOROUTINE$265', classMeta, CoroutineImpl);
  setMetadataFor(SliceAsyncStreamBase, 'SliceAsyncStreamBase', classMeta, AsyncStreamBase, VOID, VOID, VOID, VOID, [4, 0, 1]);
  setMetadataFor($getPositionCOROUTINE$275, '$getPositionCOROUTINE$275', classMeta, CoroutineImpl);
  setMetadataFor($getLengthCOROUTINE$276, '$getLengthCOROUTINE$276', classMeta, CoroutineImpl);
  setMetadataFor(toAsyncInputStream$1, VOID, classMeta, VOID, [AsyncGetLengthStream, AsyncGetPositionStream], VOID, VOID, VOID, [3, 0]);
  setMetadataFor(toAsyncOutputStream$1, VOID, classMeta, VOID, VOID, VOID, VOID, VOID, [3, 0, 1]);
  setMetadataFor($readBytesUpToCOROUTINE$237, '$readBytesUpToCOROUTINE$237', classMeta, CoroutineImpl);
  setMetadataFor($readS32LECOROUTINE$241, '$readS32LECOROUTINE$241', classMeta, CoroutineImpl);
  setMetadataFor($readStringCOROUTINE$243, '$readStringCOROUTINE$243', classMeta, CoroutineImpl);
  setMetadataFor($readAllCOROUTINE$246, '$readAllCOROUTINE$246', classMeta, CoroutineImpl);
  setMetadataFor($readBytesExactCOROUTINE$251, '$readBytesExactCOROUTINE$251', classMeta, CoroutineImpl);
  setMetadataFor($readU16BECOROUTINE$252, '$readU16BECOROUTINE$252', classMeta, CoroutineImpl);
  setMetadataFor($readS32BECOROUTINE$253, '$readS32BECOROUTINE$253', classMeta, CoroutineImpl);
  setMetadataFor($readBytesUpToCopyCOROUTINE$254, '$readBytesUpToCopyCOROUTINE$254', classMeta, CoroutineImpl);
  setMetadataFor($getAvailableCOROUTINE$255, '$getAvailableCOROUTINE$255', classMeta, CoroutineImpl);
  setMetadataFor($readExactCOROUTINE$261, '$readExactCOROUTINE$261', classMeta, CoroutineImpl);
  setMetadataFor($sliceWithBoundsCOROUTINE$262, '$sliceWithBoundsCOROUTINE$262', classMeta, CoroutineImpl);
  setMetadataFor($readBytesUpToCOROUTINE$263, '$readBytesUpToCOROUTINE$263', classMeta, CoroutineImpl);
  setMetadataFor($readBytesCOROUTINE$264, '$readBytesCOROUTINE$264', classMeta, CoroutineImpl);
  setMetadataFor($sliceStartCOROUTINE$266, '$sliceStartCOROUTINE$266', classMeta, CoroutineImpl);
  setMetadataFor($sliceHereCOROUTINE$268, '$sliceHereCOROUTINE$268', classMeta, CoroutineImpl);
  setMetadataFor($readU16COROUTINE$269, '$readU16COROUTINE$269', classMeta, CoroutineImpl);
  setMetadataFor($readS32COROUTINE$270, '$readS32COROUTINE$270', classMeta, CoroutineImpl);
  setMetadataFor($readStringzCOROUTINE$271, '$readStringzCOROUTINE$271', classMeta, CoroutineImpl);
  setMetadataFor($readU16LECOROUTINE$274, '$readU16LECOROUTINE$274', classMeta, CoroutineImpl);
  setMetadataFor(FastByteArrayInputStream, 'FastByteArrayInputStream', classMeta);
  function read() {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.Pool.alloc' call
      var this_0 = get_smallBytesPool();
      var temp = this_0.z1x();
      try {
        // Inline function 'korlibs.io.stream.SyncInputStream.read.<anonymous>' call
        var tmp;
        if (this.t1z(temp, 0, 1) > 0) {
          // Inline function 'korlibs.math.unsigned' call
          tmp = temp[0] & 255;
        } else {
          tmp = -1;
        }
        tmp$ret$2 = tmp;
        break $l$block;
      }finally {
        this_0.e1y(temp);
      }
    }
    return tmp$ret$2;
  }
  setMetadataFor(SyncInputStream, 'SyncInputStream', interfaceMeta, VOID, [Closeable]);
  setMetadataFor(SyncPositionStream, 'SyncPositionStream', interfaceMeta);
  setMetadataFor(SyncLengthStream, 'SyncLengthStream', interfaceMeta);
  setMetadataFor(SyncStream, 'SyncStream', classMeta, VOID, [Closeable, SyncInputStream, SyncPositionStream, SyncLengthStream]);
  setMetadataFor(SyncStreamBase, 'SyncStreamBase', classMeta, VOID, [Closeable, SyncLengthStream], SyncStreamBase);
  setMetadataFor(MemorySyncStreamBase, 'MemorySyncStreamBase', classMeta, SyncStreamBase, VOID, MemorySyncStreamBase_init_$Create$);
  setMetadataFor(ReadonlySyncStreamBase, 'ReadonlySyncStreamBase', classMeta, SyncStreamBase);
  setMetadataFor(SliceSyncStreamBase, 'SliceSyncStreamBase', classMeta, SyncStreamBase);
  setMetadataFor(Text, 'Text', interfaceMeta);
  setMetadataFor(Marker, 'Marker', classMeta);
  setMetadataFor(Line, 'Line', classMeta, VOID, [Text]);
  setMetadataFor(LineDeferred, 'LineDeferred', classMeta);
  setMetadataFor(EmptyLineOnce, 'EmptyLineOnce', objectMeta);
  setMetadataFor(Indent, 'Indent', objectMeta);
  setMetadataFor(Unindent, 'Unindent', objectMeta);
  setMetadataFor(INDENTS, 'INDENTS', objectMeta);
  setMetadataFor(Companion_61, 'Companion', objectMeta);
  setMetadataFor(IndenterEvaluator, 'IndenterEvaluator', classMeta);
  setMetadataFor(Indenter, 'Indenter', classMeta, VOID, VOID, Indenter);
  setMetadataFor(NumberParser, 'NumberParser', objectMeta);
  setMetadataFor(Companion_62, 'Companion', objectMeta);
  setMetadataFor(Companion_63, 'Companion', objectMeta);
  setMetadataFor(Literals, 'Literals', classMeta);
  setMetadataFor(BaseStrReader, 'BaseStrReader', classMeta);
  setMetadataFor(StrReader, 'StrReader', classMeta, BaseStrReader);
  setMetadataFor(Adler32, 'Adler32', objectMeta);
  setMetadataFor(DemoWorkerTask$execute$slambda, 'DemoWorkerTask$execute$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(WorkerTask, 'WorkerTask', classMeta, VOID, VOID, WorkerTask);
  setMetadataFor(DemoWorkerTask, 'DemoWorkerTask', classMeta, WorkerTask, VOID, DemoWorkerTask);
  setMetadataFor(WorkerTask$runSuspend$slambda, 'WorkerTask$runSuspend$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(_WorkerImpl, '_WorkerImpl', classMeta, VOID, VOID, _WorkerImpl, VOID, VOID, [4]);
  setMetadataFor(Companion_64, 'Companion', objectMeta);
  setMetadataFor(Companion_65, 'Companion', objectMeta);
  setMetadataFor(Context, 'Context', classMeta);
  setMetadataFor(Json, 'Json', objectMeta);
  setMetadataFor(Xml$Companion$parse$Level, 'Level', classMeta);
  setMetadataFor(Element_0, 'Element', classMeta);
  setMetadataFor(ProcessingInstructionTag, 'ProcessingInstructionTag', classMeta, Element_0);
  setMetadataFor(OpenCloseTag, 'OpenCloseTag', classMeta, Element_0);
  setMetadataFor(OpenTag, 'OpenTag', classMeta, Element_0);
  setMetadataFor(CommentTag, 'CommentTag', classMeta, Element_0);
  setMetadataFor(CloseTag, 'CloseTag', classMeta, Element_0);
  setMetadataFor(Text_0, 'Text', classMeta, Element_0);
  setMetadataFor(Xml2Iterable, 'Xml2Iterable', classMeta, VOID, [Iterable]);
  setMetadataFor(Xml$Stream$xmlSequence$slambda, 'Xml$Stream$xmlSequence$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(Companion_66, 'Companion', objectMeta);
  setMetadataFor(Type_0, 'Type', classMeta, Enum);
  setMetadataFor(Entities, 'Entities', objectMeta);
  setMetadataFor(Stream, 'Stream', objectMeta);
  setMetadataFor(Xml, 'Xml', classMeta);
  setMetadataFor(HtmlNativeSoundProvider, 'HtmlNativeSoundProvider', classMeta, NativeSoundProviderNew, VOID, HtmlNativeSoundProvider, VOID, VOID, [4, 1, 3, 2]);
  setMetadataFor(HtmlSimpleSound, 'HtmlSimpleSound', objectMeta, VOID, VOID, VOID, VOID, VOID, [0, 2, 1]);
  setMetadataFor(HtmlCanvas, 'HtmlCanvas', objectMeta);
  setMetadataFor(HtmlImage, 'HtmlImage', objectMeta);
  setMetadataFor(NodeJsNativeImageFormatProvider, 'NodeJsNativeImageFormatProvider', objectMeta, BaseNativeImageFormatProvider, VOID, VOID, VOID, VOID, [2, 3, 1]);
  setMetadataFor($decodeInternalCOROUTINE$286, '$decodeInternalCOROUTINE$286', classMeta, CoroutineImpl);
  setMetadataFor($decodeInternalCOROUTINE$287, '$decodeInternalCOROUTINE$287', classMeta, CoroutineImpl);
  setMetadataFor(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', objectMeta, NativeImageFormatProvider, VOID, VOID, VOID, VOID, [2, 3, 1]);
  setMetadataFor(HtmlNativeImage, 'HtmlNativeImage', classMeta, NativeImage);
  setMetadataFor($decodeToCanvasCOROUTINE$288, '$decodeToCanvasCOROUTINE$288', classMeta, CoroutineImpl);
  setMetadataFor($loadCanvasCOROUTINE$289, '$loadCanvasCOROUTINE$289', classMeta, CoroutineImpl);
  setMetadataFor(BrowserImage, 'BrowserImage', objectMeta, VOID, VOID, VOID, VOID, VOID, [2, 1]);
  setMetadataFor(CanvasContext2dRenderer, 'CanvasContext2dRenderer', classMeta, Renderer);
  setMetadataFor(DynamicInternal, 'DynamicInternal', objectMeta, VOID, [DynApi], VOID, VOID, VOID, [2, 3]);
  setMetadataFor(BlobAsyncBaseStream, 'BlobAsyncBaseStream', classMeta, AsyncStreamBase, VOID, VOID, VOID, VOID, [0, 4, 1]);
  setMetadataFor(toVfs$1, VOID, classMeta, Vfs, VOID, VOID, VOID, VOID, [2, 1, 0, 3, 4]);
  setMetadataFor(standardVfs$1, VOID, classMeta, StandardVfs);
  setMetadataFor(StandardPaths, 'StandardPaths', objectMeta, VOID, [StandardPathsBase]);
  setMetadataFor(EnvironmentInternal, 'EnvironmentInternal', objectMeta);
  setMetadataFor(FileNotFoundException, 'FileNotFoundException', classMeta, IOException);
  setMetadataFor(EOFException, 'EOFException', classMeta, IOException);
  setMetadataFor(JS_UTF8$1, VOID, classMeta, UTC8CharsetBase);
  setMetadataFor(httpFactory$2$1, VOID, classMeta);
  setMetadataFor(Companion_67, 'Companion', objectMeta);
  setMetadataFor(JsRuntime, 'JsRuntime', classMeta, VOID, VOID, VOID, VOID, VOID, [1, 4]);
  setMetadataFor(JsRuntimeBrowser, 'JsRuntimeBrowser', objectMeta, JsRuntime, VOID, VOID, VOID, VOID, [1, 4]);
  setMetadataFor(Companion_68, 'Companion', objectMeta);
  setMetadataFor($requestInternalCOROUTINE$290, '$requestInternalCOROUTINE$290', classMeta, CoroutineImpl);
  setMetadataFor(HttpClientBrowserJs, 'HttpClientBrowserJs', classMeta, HttpClient, VOID, HttpClientBrowserJs, VOID, VOID, [4, 5, 2]);
  setMetadataFor(JsRuntimeDeno, 'JsRuntimeDeno', objectMeta, JsRuntime, VOID, VOID, VOID, VOID, [1, 4]);
  setMetadataFor($openCOROUTINE$291, '$openCOROUTINE$291', classMeta, CoroutineImpl);
  setMetadataFor($statCOROUTINE$296, '$statCOROUTINE$296', classMeta, CoroutineImpl);
  setMetadataFor(DenoLocalVfs, 'DenoLocalVfs', classMeta, Vfs, VOID, DenoLocalVfs, VOID, VOID, [2, 1, 0, 3, 4]);
  setMetadataFor($readCOROUTINE$298, '$readCOROUTINE$298', classMeta, CoroutineImpl);
  setMetadataFor($writeCOROUTINE$299, '$writeCOROUTINE$299', classMeta, CoroutineImpl);
  setMetadataFor($getLengthCOROUTINE$300, '$getLengthCOROUTINE$300', classMeta, CoroutineImpl);
  setMetadataFor(DenoAsyncStreamBase, 'DenoAsyncStreamBase', classMeta, AsyncStreamBase, VOID, VOID, VOID, VOID, [4, 1, 0]);
  setMetadataFor(JsRuntimeNode, 'JsRuntimeNode', objectMeta, JsRuntime, VOID, VOID, VOID, VOID, [1, 4]);
  setMetadataFor($openCOROUTINE$304, '$openCOROUTINE$304', classMeta, CoroutineImpl);
  setMetadataFor(NodeJsLocalVfs, 'NodeJsLocalVfs', classMeta, LocalVfs, VOID, NodeJsLocalVfs, VOID, VOID, [2, 1, 4, 0, 3]);
  setMetadataFor($requestInternalCOROUTINE$309, '$requestInternalCOROUTINE$309', classMeta, CoroutineImpl);
  setMetadataFor(HttpClientNodeJs, 'HttpClientNodeJs', classMeta, HttpClient, VOID, HttpClientNodeJs, VOID, VOID, [4, 5, 2]);
  setMetadataFor($closeCOROUTINE$312, '$closeCOROUTINE$312', classMeta, CoroutineImpl);
  setMetadataFor(NodeFDStream, 'NodeFDStream', classMeta, AsyncStreamBase, VOID, VOID, VOID, VOID, [4, 1, 0]);
  setMetadataFor(workerImpl$o$insideWorker$lambda$lambda$slambda, 'workerImpl$o$insideWorker$lambda$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(workerImpl$1, VOID, classMeta, _WorkerImpl, VOID, VOID, VOID, VOID, [4]);
  //endregion
  function get_defaultAudioFormats() {
    _init_properties_AudioFormat_kt__9os7np();
    // Inline function 'kotlin.getValue' call
    var this_0 = defaultAudioFormats$delegate;
    defaultAudioFormats$factory();
    return this_0.m2();
  }
  var defaultAudioFormats$delegate;
  function Companion() {
  }
  protoOf(Companion).l38 = function (formats) {
    return (new AudioFormats()).p38(formats.slice());
  };
  var Companion_instance_7;
  function Companion_getInstance_14() {
    return Companion_instance_7;
  }
  function invalidate($this) {
    $this.o38_1 = null;
    return $this;
  }
  function AudioFormats() {
    AudioFormat.call(this, []);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.n38_1 = ArrayList_init_$Create$();
    this.o38_1 = null;
  }
  protoOf(AudioFormats).q38 = function () {
    if (this.o38_1 == null) {
      var tmp = this;
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.n38_1;
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.audio.format.AudioFormats.<get-extensions>.<anonymous>' call
        var list = element.q38();
        addAll(destination, list);
      }
      tmp.o38_1 = toSet(destination);
    }
    return ensureNotNull(this.o38_1);
  };
  protoOf(AudioFormats).p38 = function (formats) {
    // Inline function 'kotlin.apply' call
    var this_0 = invalidate(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.AudioFormats.register.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this_0.n38_1;
    addAll_0(this_1, formats);
    return this_0;
  };
  function standardAudioFormats() {
    _init_properties_AudioFormat_kt__9os7np();
    return Companion_instance_7.l38([Companion_getInstance_17(), Companion_getInstance_15()]);
  }
  function AudioFormat(exts) {
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.audio.format.AudioFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.r(tmp$ret$3);
    }
    tmp.r38_1 = toSet(destination);
  }
  protoOf(AudioFormat).q38 = function () {
    return this.r38_1;
  };
  protoOf(AudioFormat).zb = function () {
    return 'AudioFormat';
  };
  protoOf(AudioFormat).toString = function () {
    return this.zb() + '(' + sorted(this.q38()) + ')';
  };
  function defaultAudioFormats$delegate$lambda() {
    _init_properties_AudioFormat_kt__9os7np();
    return standardAudioFormats();
  }
  function defaultAudioFormats$factory() {
    return getPropertyCallableRef('defaultAudioFormats', 0, KProperty0, function () {
      return get_defaultAudioFormats();
    }, null);
  }
  var properties_initialized_AudioFormat_kt_2wpbb7;
  function _init_properties_AudioFormat_kt__9os7np() {
    if (!properties_initialized_AudioFormat_kt_2wpbb7) {
      properties_initialized_AudioFormat_kt_2wpbb7 = true;
      defaultAudioFormats$delegate = lazy(defaultAudioFormats$delegate$lambda);
    }
  }
  function Companion_0() {
    Companion_instance_8 = this;
    MP3Decoder.call(this);
  }
  var Companion_instance_8;
  function Companion_getInstance_15() {
    if (Companion_instance_8 == null)
      new Companion_0();
    return Companion_instance_8;
  }
  function MP3Decoder() {
    Companion_getInstance_15();
    AudioFormat.call(this, ['mp3']);
    this.t38_1 = Minimp3AudioFormat_getInstance();
  }
  protoOf(MP3Decoder).toString = function () {
    return 'NativeMp3DecoderFormat';
  };
  function Minimp3AudioFormat() {
    Minimp3AudioFormat_instance = this;
    BaseMinimp3AudioFormat.call(this);
  }
  var Minimp3AudioFormat_instance;
  function Minimp3AudioFormat_getInstance() {
    if (Minimp3AudioFormat_instance == null)
      new Minimp3AudioFormat();
    return Minimp3AudioFormat_instance;
  }
  function Companion_1() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.u38_1 = new Int8Array([88, 105, 110, 103]);
    var tmp_0 = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp_0.v38_1 = new Int8Array([73, 110, 102, 111]);
  }
  var Companion_instance_9;
  function Companion_getInstance_16() {
    if (Companion_instance_9 == null)
      new Companion_1();
    return Companion_instance_9;
  }
  function BaseMinimp3AudioFormat() {
    Companion_getInstance_16();
    AudioFormat.call(this, ['mp3']);
  }
  function Companion_2() {
    Companion_instance_10 = this;
    WAV.call(this);
  }
  var Companion_instance_10;
  function Companion_getInstance_17() {
    if (Companion_instance_10 == null)
      new Companion_2();
    return Companion_instance_10;
  }
  function WAV() {
    Companion_getInstance_17();
    AudioFormat.call(this, ['wav']);
  }
  var DEFAULT_MAX_SAMPLES;
  function NativeSoundProvider$audioFormats$delegate$lambda() {
    return get_defaultAudioFormats();
  }
  function NativeSoundProvider() {
    this.w38_1 = 'unknown';
    this.x38_1 = false;
    this.y38_1 = Companion_getInstance().j2o_1;
    this.z38_1 = Companion_getInstance().l2o_1;
    this.a39_1 = Companion_getInstance().p2o_1;
    this.b39_1 = Companion_getInstance().j2o_1;
    var tmp = this;
    tmp.c39_1 = lazy(NativeSoundProvider$audioFormats$delegate$lambda);
  }
  protoOf(NativeSoundProvider).f23 = function (_set____db54di) {
    this.x38_1 = _set____db54di;
  };
  protoOf(NativeSoundProvider).f1e = function () {
  };
  function NativeSoundProviderNew() {
    NativeSoundProvider.call(this);
  }
  function Companion_3() {
    Companion_instance_11 = this;
    DummyNativeSoundProvider.call(this);
  }
  var Companion_instance_11;
  function Companion_getInstance_18() {
    if (Companion_instance_11 == null)
      new Companion_3();
    return Companion_instance_11;
  }
  function DummyNativeSoundProvider() {
    Companion_getInstance_18();
    NativeSoundProvider.call(this);
  }
  function get_isLow(_this__u8e3s4) {
    return _this__u8e3s4.d25() <= 0.25;
  }
  var GrowMethod_GROW_IMAGE_instance;
  var GrowMethod_NEW_IMAGES_instance;
  var GrowMethod_entriesInitialized;
  function GrowMethod_initEntries() {
    if (GrowMethod_entriesInitialized)
      return Unit_instance;
    GrowMethod_entriesInitialized = true;
    GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
    GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
  }
  function MutableAtlas_init_$Init$(width, height, border, premultiplied, allowToGrow, growMethod, $this) {
    width = width === VOID ? 2048 : width;
    height = height === VOID ? width : height;
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    MutableAtlas.call($this, Companion_instance.k2v(width, height), border, premultiplied, allowToGrow, growMethod);
    return $this;
  }
  function MutableAtlas_init_$Create$(width, height, border, premultiplied, allowToGrow, growMethod) {
    return MutableAtlas_init_$Init$(width, height, border, premultiplied, allowToGrow, growMethod, objectCreate(protoOf(MutableAtlas)));
  }
  function GrowMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Entry(slice, data) {
    this.d39_1 = slice;
    this.e39_1 = data;
  }
  protoOf(Entry).toString = function () {
    return 'Entry(slice=' + this.d39_1 + ', data=' + this.e39_1 + ')';
  };
  protoOf(Entry).hashCode = function () {
    var result = this.d39_1.hashCode();
    result = imul(result, 31) + (this.e39_1 == null ? 0 : hashCode(this.e39_1)) | 0;
    return result;
  };
  protoOf(Entry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!this.d39_1.equals(tmp0_other_with_cast.d39_1))
      return false;
    if (!equals(this.e39_1, tmp0_other_with_cast.e39_1))
      return false;
    return true;
  };
  function reconstructWithSize($this, width, height) {
    var slices = toList($this.n39_1);
    $this.f39_1 = Companion_instance.k2v(width, height);
    $this.l39_1 = new Bitmap32(width, height, VOID, $this.h39_1);
    $this.m39_1.b3();
    $this.m39_1.r($this.l39_1);
    $this.o39_1.b3();
    $this.n39_1.b3();
    var tmp0_iterator = slices.u();
    while (tmp0_iterator.v()) {
      var entry = tmp0_iterator.x();
      $this.q39(entry.d39_1, entry.e39_1, entry.d39_1.q2w_1);
    }
  }
  function growAtlas($this, bmp) {
    var tmp0 = $this.j39_1.ka_1;
    if (tmp0 === 0) {
      reconstructWithSize($this, imul($this.x1q(), 2), imul($this.y1q(), 2));
    } else if (tmp0 === 1) {
      if (bmp.v2w_1 > $this.x1q() ? true : bmp.w2w_1 > $this.y1q()) {
        // Inline function 'kotlin.error' call
        var message = 'Atlas is too small (' + $this.x1q() + 'x' + $this.y1q() + ') to hold a slice of (' + bmp.v2w_1 + 'x' + bmp.w2w_1 + ')';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      $this.f39_1 = Companion_instance.k2v($this.x1q(), $this.y1q());
      $this.l39_1 = new Bitmap32($this.x1q(), $this.y1q(), VOID, $this.h39_1);
      $this.m39_1.r($this.l39_1);
    }
  }
  function GrowMethod_NEW_IMAGES_getInstance() {
    GrowMethod_initEntries();
    return GrowMethod_NEW_IMAGES_instance;
  }
  function MutableAtlas(binPacker, border, premultiplied, allowToGrow, growMethod) {
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    this.f39_1 = binPacker;
    this.g39_1 = border;
    this.h39_1 = premultiplied;
    this.i39_1 = allowToGrow;
    this.j39_1 = growMethod;
    this.k39_1 = MarginInt_init_$Create$(this.g39_1);
    this.l39_1 = new Bitmap32(this.x1q(), this.y1q(), VOID, this.h39_1);
    this.m39_1 = arrayListOf([this.l39_1]);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.n39_1 = ArrayList_init_$Create$();
    this.o39_1 = LinkedHashMap_init_$Create$();
    this.p39_1 = null;
  }
  protoOf(MutableAtlas).x1q = function () {
    return numberToInt(this.f39_1.x1q());
  };
  protoOf(MutableAtlas).y1q = function () {
    return numberToInt(this.f39_1.y1q());
  };
  protoOf(MutableAtlas).n = function () {
    return this.n39_1.n();
  };
  protoOf(MutableAtlas).r39 = function (bmp, data, name) {
    return this.q39(slice_0(bmp, VOID, name), data, name);
  };
  protoOf(MutableAtlas).s39 = function (bmp, data, name, $super) {
    name = name === VOID ? 'Slice' + this.n() : name;
    return $super === VOID ? this.r39(bmp, data, name) : $super.r39.call(this, bmp, data, name);
  };
  protoOf(MutableAtlas).q39 = function (bmp, data, name) {
    var tmp = get_bmp(bmp);
    if (!(tmp instanceof Bitmap32)) {
      return this.r39(extract_0(bmp).g3a(), data, name);
    }
    if (!(bmp instanceof RectSlice))
      THROW_CCE();
    try {
      var rname = name == null ? 'Slice' + this.n() : name;
      var isEmpty = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty ? !(this.p39_1 == null) : false) {
        var bigEmptySlice = ensureNotNull(this.p39_1).d39_1;
        if (bigEmptySlice.v2w_1 >= bmp.v2w_1 ? bigEmptySlice.w2w_1 >= bmp.w2w_1 : false) {
          entry = new Entry(bigEmptySlice.f2y(new RectangleI(0, 0, bmp.v2w_1, bmp.w2w_1)), data);
        }
      }
      if (entry == null) {
        var rect = this.f39_1.h2p(bmp.v2w_1 + imul(this.g39_1, 2), bmp.w2w_1 + imul(this.g39_1, 2));
        var slice = sliceWithSize(this.l39_1, numberToInt(rect.r2d() + this.g39_1), numberToInt(rect.t2d() + this.g39_1), bmp.v2w_1, bmp.w2w_1, rname);
        var dstX = slice.r2d();
        var dstY = slice.t2d();
        var boundsWithBorder = get_bounds_0(slice).n2l(this.k39_1);
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
        var this_0 = this.l39_1;
        if (true) {
          this_0.h3a();
        }
        var result;
        try {
          // Inline function 'korlibs.image.atlas.MutableAtlas.add.<anonymous>' call
          this.l39_1.y3a(bmp, dstX, dstY);
          expandBorder(this.l39_1, slice.n2w_1, this.g39_1);
        }finally {
          result = true ? this_0.z3a(boundsWithBorder) : 0;
        }
        entry = new Entry(slice, data);
        if (this.p39_1 == null ? true : bmp.e2m() > ensureNotNull(this.p39_1).d39_1.e2m()) {
          this.p39_1 = entry;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.n39_1;
      var element = entry;
      this_1.r(element);
      // Inline function 'kotlin.collections.set' call
      var this_2 = this.o39_1;
      var value = entry;
      this_2.i2(rname, value);
      return entry;
    } catch ($p) {
      if ($p instanceof ImageDoNotFitException) {
        var e = $p;
        if (!this.i39_1)
          throw e;
        growAtlas(this, bmp);
        return this.q39(bmp, data, name);
      } else {
        throw $p;
      }
    }
  };
  protoOf(MutableAtlas).a3b = function (bmp, data, name, $super) {
    name = name === VOID ? bmp.q2w_1 : name;
    return $super === VOID ? this.q39(bmp, data, name) : $super.q39.call(this, bmp, data, name);
  };
  function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
    _init_properties_Bitmap_kt__y1ku1b();
    var this_0 = baseMipmapLevel$delegate;
    var property = baseMipmapLevel$factory();
    var tmp0_elvis_lhs = this_0.j23_1;
    var tmp = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    // Inline function 'korlibs.datastructure.fastCastTo' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    setExtra(_this__u8e3s4, tmp, _set____db54di);
    return Unit_instance;
  }
  function get_baseMipmapLevel(_this__u8e3s4) {
    _init_properties_Bitmap_kt__y1ku1b();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'korlibs.datastructure.Property.getValue' call
      var this_0 = baseMipmapLevel$delegate;
      var property = baseMipmapLevel$factory_0();
      // Inline function 'korlibs.datastructure.fastCastTo' call
      var tmp1_safe_receiver = _this__u8e3s4.i23();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs = this_0.j23_1;
        tmp = tmp1_safe_receiver.s13(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      }
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = tmp;
      if (res == null) {
        var r = this_0.k23_1();
        var tmp_0;
        if (!(r == null)) {
          tmp_0 = true;
        } else {
          var tmp2_elvis_lhs = this_0.j23_1;
          tmp_0 = hasExtra(_this__u8e3s4, tmp2_elvis_lhs == null ? property.callableName : tmp2_elvis_lhs);
        }
        if (tmp_0) {
          // Inline function 'korlibs.datastructure.Property.setValue' call
          var tmp0_elvis_lhs_0 = this_0.j23_1;
          var tmp_1 = tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0;
          // Inline function 'korlibs.datastructure.fastCastTo' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          setExtra(_this__u8e3s4, tmp_1, r);
        }
        tmp$ret$6 = r;
        break $l$block;
      }
      tmp$ret$6 = res;
    }
    return tmp$ret$6;
  }
  var baseMipmapLevel$delegate;
  function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
    _init_properties_Bitmap_kt__y1ku1b();
    var this_0 = maxMipmapLevel$delegate;
    var property = maxMipmapLevel$factory();
    var tmp0_elvis_lhs = this_0.j23_1;
    var tmp = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    // Inline function 'korlibs.datastructure.fastCastTo' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    setExtra(_this__u8e3s4, tmp, _set____db54di);
    return Unit_instance;
  }
  function get_maxMipmapLevel(_this__u8e3s4) {
    _init_properties_Bitmap_kt__y1ku1b();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'korlibs.datastructure.Property.getValue' call
      var this_0 = maxMipmapLevel$delegate;
      var property = maxMipmapLevel$factory_0();
      // Inline function 'korlibs.datastructure.fastCastTo' call
      var tmp1_safe_receiver = _this__u8e3s4.i23();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs = this_0.j23_1;
        tmp = tmp1_safe_receiver.s13(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      }
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = tmp;
      if (res == null) {
        var r = this_0.k23_1();
        var tmp_0;
        if (!(r == null)) {
          tmp_0 = true;
        } else {
          var tmp2_elvis_lhs = this_0.j23_1;
          tmp_0 = hasExtra(_this__u8e3s4, tmp2_elvis_lhs == null ? property.callableName : tmp2_elvis_lhs);
        }
        if (tmp_0) {
          // Inline function 'korlibs.datastructure.Property.setValue' call
          var tmp0_elvis_lhs_0 = this_0.j23_1;
          var tmp_1 = tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0;
          // Inline function 'korlibs.datastructure.fastCastTo' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          setExtra(_this__u8e3s4, tmp_1, r);
        }
        tmp$ret$6 = r;
        break $l$block;
      }
      tmp$ret$6 = res;
    }
    return tmp$ret$6;
  }
  var maxMipmapLevel$delegate;
  function Bitmap$tempInts$delegate$lambda(this$0) {
    return function () {
      return new Int32Array(imul(this$0.t39_1, 2));
    };
  }
  function Bitmap(width, height, bpp, premultiplied, backingArray) {
    this.t39_1 = width;
    this.u39_1 = height;
    this.v39_1 = bpp;
    this.w39_1 = backingArray;
    this.x39_1 = new Mixin();
    this.y39_1 = new RectangleI(0, 0, this.t39_1, this.u39_1);
    this.z39_1 = null;
    this.a3a_1 = premultiplied;
    this.b3a_1 = false;
    var tmp = this;
    tmp.c3a_1 = lazy(Bitmap$tempInts$delegate$lambda(this));
    this.d3a_1 = 0;
    this.e3a_1 = null;
    this.f3a_1 = false;
  }
  protoOf(Bitmap).h23 = function (_set____db54di) {
    this.x39_1.h23(_set____db54di);
  };
  protoOf(Bitmap).i23 = function () {
    return this.x39_1.i23();
  };
  protoOf(Bitmap).n = function () {
    return new SizeInt(this.t39_1, this.u39_1);
  };
  protoOf(Bitmap).b3b = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c3a_1;
    tempInts$factory();
    return this_0.m2();
  };
  protoOf(Bitmap).c3b = function () {
    return _RgbaArray___init__impl__oib4y4(this.b3b());
  };
  protoOf(Bitmap).d3b = function () {
    return imul(this.t39_1, this.v39_1) / 8 | 0;
  };
  protoOf(Bitmap).e2m = function () {
    return imul(this.t39_1, this.u39_1);
  };
  protoOf(Bitmap).e3b = function (x, y) {
    return imul(y, this.t39_1) + x | 0;
  };
  protoOf(Bitmap).f3b = function () {
    if (!(this.e3a_1 == null)) {
      this.e3a_1 = null;
    }
  };
  protoOf(Bitmap).h3a = function () {
    return Unit_instance;
  };
  protoOf(Bitmap).z3a = function (rect) {
    if (this.e3a_1 == null)
      this.e3a_1 = rect;
    else
      this.e3a_1 = Companion_instance_0.w2l(ensureNotNull(this.e3a_1), rect);
    this.d3a_1 = this.d3a_1 + 1 | 0;
    return this.d3a_1;
  };
  protoOf(Bitmap).g3b = function (x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            out[tmp2] = _RGBA___get_value__impl__hhco8v(this.h3b(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap).i3b = function (x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            this.j3b(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[tmp2]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap).k3b = function (x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.i3b(x, y, width, height, out, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.i3b.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  };
  protoOf(Bitmap).j3b = function (x, y, v) {
    // Inline function 'kotlin.TODO' call
    throw new NotImplementedError();
  };
  protoOf(Bitmap).h3b = function (x, y) {
    return Colors_getInstance().q3b_1;
  };
  protoOf(Bitmap).d3h = function (x, y, color) {
    return Unit_instance;
  };
  protoOf(Bitmap).e3h = function (x, y) {
    return 0;
  };
  protoOf(Bitmap).f3h = function (x, y) {
    var x0 = toIntFloor(x);
    var y0 = toIntFloor(y);
    if (((x0 < 0 ? true : y0 < 0) ? true : x0 >= this.t39_1) ? true : y0 >= this.u39_1)
      return Colors_getInstance().q3b_1;
    var x1 = toIntCeil(x);
    var y1 = toIntCeil(y);
    var x1Inside = x1 < (this.t39_1 - 1 | 0);
    var y1Inside = y1 < (this.u39_1 - 1 | 0);
    // Inline function 'korlibs.math.fract' call
    var xratio = x - toIntFloor(x);
    // Inline function 'korlibs.math.fract' call
    var yratio = y - toIntFloor(y);
    var c00 = this.h3b(x0, y0);
    var c10 = x1Inside ? this.h3b(x1, y0) : c00;
    var c01 = y1Inside ? this.h3b(x0, y1) : c00;
    var c11 = (x1Inside ? y1Inside : false) ? this.h3b(x1, y1) : c01;
    return Companion_getInstance_26().l3h(c00, c10, c01, c11, toRatio(xratio), toRatio(yratio));
  };
  protoOf(Bitmap).m3h = function (srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.n3h(srcX);
    var srcX1 = src.n3h(srcX + width | 0);
    var srcY0 = src.o3h(srcY);
    var srcY1 = src.o3h(srcY + height | 0);
    var dstX0 = dst.n3h(dstX);
    var dstX1 = dst.n3h(dstX + width | 0);
    var dstY0 = dst.o3h(dstY);
    var dstY1 = dst.o3h(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    // Inline function 'kotlin.math.min' call
    var a = srcX1 - srcX0 | 0;
    var b = dstX1 - dstX0 | 0;
    var width_0 = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = srcY1 - srcY0 | 0;
    var b_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(a_0, b_0);
    this.p3h(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  };
  protoOf(Bitmap).p3h = function (srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.g3b(srcX, srcY + y | 0, width, 1, this.b3b(), 0);
        dst.i3b(dstX, dstY + y | 0, width, 1, this.b3b(), 0);
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap).q3h = function (x) {
    return x >= 0 ? x < this.t39_1 : false;
  };
  protoOf(Bitmap).r3h = function (y) {
    return y >= 0 ? y < this.u39_1 : false;
  };
  protoOf(Bitmap).s3h = function (x, y) {
    return this.q3h(x) ? this.r3h(y) : false;
  };
  protoOf(Bitmap).t3h = function (x) {
    return clamp(x, 0, this.t39_1 - 1 | 0);
  };
  protoOf(Bitmap).u3h = function (y) {
    return clamp(y, 0, this.u39_1 - 1 | 0);
  };
  protoOf(Bitmap).n3h = function (x) {
    return clamp(x, 0, this.t39_1);
  };
  protoOf(Bitmap).o3h = function (y) {
    return clamp(y, 0, this.u39_1);
  };
  protoOf(Bitmap).v3h = function () {
    var inductionVariable = 0;
    var last = this.u39_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.w3h(y, (this.u39_1 - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  };
  protoOf(Bitmap).x3h = function () {
    var inductionVariable = 0;
    var last = this.t39_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.y3h(x, (this.t39_1 - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  };
  protoOf(Bitmap).z3h = function (rotation) {
    var tmp;
    switch (rotation.ka_1) {
      case 0:
        tmp = this.g1s();
        break;
      case 1:
        tmp = this.a3i().x3h();
        break;
      case 2:
        tmp = this.a3i().x3h().a3i().x3h();
        break;
      case 3:
        tmp = this.a3i().v3h();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(Bitmap).b3i = function (orientation) {
    var out = this.g1s();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.x3h();
    }
    return out.z3h(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  };
  protoOf(Bitmap).a3i = function () {
    var temp = new IntArray2(this.t39_1, this.u39_1, readPixelsUnsafe(this, 0, 0, this.t39_1, this.u39_1));
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = this.u39_1;
    var height = this.t39_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var out = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    var inductionVariable = 0;
    var last = this.u39_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.t39_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.d1r(y, x, temp.c1r(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = this.c3i(this.u39_1, this.t39_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.transposed.<anonymous>' call
    this_0.k3b(0, 0, this.u39_1, this.t39_1, out.v1q_1);
    return this_0;
  };
  protoOf(Bitmap).w3h = function (y0, y1) {
    var inductionVariable = 0;
    var last = this.t39_1;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.e3h(x, y0);
        var c1 = this.e3h(x, y1);
        this.d3h(x, y0, c1);
        this.d3h(x, y1, c0);
      }
       while (inductionVariable < last);
  };
  protoOf(Bitmap).y3h = function (x0, x1) {
    var inductionVariable = 0;
    var last = this.u39_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.e3h(x0, y);
        var c1 = this.e3h(x1, y);
        this.d3h(x0, y, c1);
        this.d3h(x1, y, c0);
      }
       while (inductionVariable < last);
  };
  protoOf(Bitmap).d3i = function (antialiasing) {
    throw UnsupportedOperationException_init_$Create$('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  };
  protoOf(Bitmap).c3i = function (width, height) {
    invalidOp('Unsupported createWithThisFormat (' + this + ')');
  };
  protoOf(Bitmap).g3a = function () {
    // Inline function 'kotlin.also' call
    var this_0 = new Bitmap32(this.t39_1, this.u39_1, VOID, this.a3a_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.toBMP32.<anonymous>' call
    this.g3b(0, 0, this.t39_1, this.u39_1, this_0.v3a_1, 0);
    return this_0;
  };
  protoOf(Bitmap).e3i = function () {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.g3a();
    }
    return tmp;
  };
  protoOf(Bitmap).g1s = function () {
    var out = this.c3i(this.t39_1, this.u39_1);
    this.p3h(0, 0, out, 0, 0, this.t39_1, this.u39_1);
    return out;
  };
  function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
    _init_properties_Bitmap_kt__y1ku1b();
    var out = new Int32Array(imul(width, height));
    _this__u8e3s4.g3b(x, y, width, height, out, 0);
    return out;
  }
  function mipmaps(_this__u8e3s4, enable) {
    enable = enable === VOID ? true : enable;
    _init_properties_Bitmap_kt__y1ku1b();
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.mipmaps.<anonymous>' call
    _this__u8e3s4.f3a_1 = enable;
    return _this__u8e3s4;
  }
  function NativeImageContext2d(width, height, antialiased, block) {
    antialiased = antialiased === VOID ? true : antialiased;
    _init_properties_Bitmap_kt__y1ku1b();
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_0 = NativeImage_0(width, height, true);
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.y39_1;
    if (false) {
      this_0.h3a();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = this_0.d3i(antialiased);
      try {
        // Inline function 'korlibs.image.bitmap.NativeImageContext2d.<anonymous>' call
        block(ctx);
      }finally {
        ctx.f1e();
      }
    }finally {
      result = false ? this_0.z3a(rect) : 0;
    }
    return this_0;
  }
  function asumePremultiplied(_this__u8e3s4) {
    _init_properties_Bitmap_kt__y1ku1b();
    _this__u8e3s4.a3a_1 = true;
    _this__u8e3s4.b3a_1 = true;
    return _this__u8e3s4;
  }
  function baseMipmapLevel$delegate$lambda() {
    _init_properties_Bitmap_kt__y1ku1b();
    return null;
  }
  function maxMipmapLevel$delegate$lambda() {
    _init_properties_Bitmap_kt__y1ku1b();
    return null;
  }
  function baseMipmapLevel$factory() {
    return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
      return get_baseMipmapLevel(receiver);
    }, function (receiver, value) {
      return set_baseMipmapLevel(receiver, value);
    });
  }
  function baseMipmapLevel$factory_0() {
    return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
      return get_baseMipmapLevel(receiver);
    }, function (receiver, value) {
      return set_baseMipmapLevel(receiver, value);
    });
  }
  function maxMipmapLevel$factory() {
    return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
      return get_maxMipmapLevel(receiver);
    }, function (receiver, value) {
      return set_maxMipmapLevel(receiver, value);
    });
  }
  function maxMipmapLevel$factory_0() {
    return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
      return get_maxMipmapLevel(receiver);
    }, function (receiver, value) {
      return set_maxMipmapLevel(receiver, value);
    });
  }
  function tempInts$factory() {
    return getPropertyCallableRef('tempInts', 1, KProperty1, function (receiver) {
      return receiver.b3b();
    }, null);
  }
  var properties_initialized_Bitmap_kt_sxrn69;
  function _init_properties_Bitmap_kt__y1ku1b() {
    if (!properties_initialized_Bitmap_kt_sxrn69) {
      properties_initialized_Bitmap_kt_sxrn69 = true;
      baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
      maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
    }
  }
  function Bitmap32_init_$Init$(width, height, value, $this) {
    Bitmap32.call($this, width, height, _RgbaArray___get_ints__impl__u2kps1(value), false);
    return $this;
  }
  function Bitmap32_init_$Create$(width, height, value) {
    return Bitmap32_init_$Init$(width, height, value, objectCreate(protoOf(Bitmap32)));
  }
  function Companion_4() {
    Companion_instance_12 = this;
    this.m3i_1 = new Bitmap32(0, 0, VOID, true);
  }
  protoOf(Companion_4).n3i = function (width, height, value) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Bitmap32(width, height, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Companion.invoke.<anonymous>' call
    fill(this_0.v3a_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    return this_0;
  };
  protoOf(Companion_4).o3i = function (width, height, premultiplied) {
    return new Bitmap32(width, height, new Int32Array(imul(width, height)), premultiplied);
  };
  protoOf(Companion_4).p3i = function (src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel.t3i_1;
    var dstShift = dstChannel.t3i_1;
    var dstClear = dstChannel.v3i_1;
    var dstData = dst.v3a_1;
    var srcData = src.v3a_1;
    var inductionVariable = 0;
    var last = dst.e2m();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = (srcData[n] >>> srcShift | 0) & 255;
        dstData[n] = dstData[n] & dstClear | c << dstShift;
      }
       while (inductionVariable < last);
  };
  protoOf(Companion_4).w3i = function (src, dst, dstChannel) {
    var destShift = imul(dstChannel.s3i_1, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last = dst.e2m();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src.r3j()[n] & 255;
        dst.v3a_1[n] = dst.v3a_1[n] & destClear | c << destShift;
      }
       while (inductionVariable < last);
  };
  protoOf(Companion_4).s3j = function (src, srcChannel, dst) {
    var shift = srcChannel.t3i_1;
    var inductionVariable = 0;
    var last = src.e2m();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst.r3j()[n] = toByte((src.v3a_1[n] >>> shift | 0) & 255);
      }
       while (inductionVariable < last);
  };
  var Companion_instance_12;
  function Companion_getInstance_19() {
    if (Companion_instance_12 == null)
      new Companion_4();
    return Companion_instance_12;
  }
  function Bitmap32$iterator$slambda(this$0, resultContinuation) {
    this.b3k_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Bitmap32$iterator$slambda).f3k = function ($this$iterator, $completion) {
    var tmp = this.g3k($this$iterator, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Bitmap32$iterator$slambda).ne = function (p1, $completion) {
    return this.f3k(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Bitmap32$iterator$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.d3k_1 = until(0, this.b3k_1.e2m()).u();
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!this.d3k_1.v()) {
              this.fd_1 = 3;
              continue $sm;
            }

            this.e3k_1 = this.d3k_1.x();
            this.fd_1 = 2;
            suspendResult = this.c3k_1.ig(new RGBA(this.b3k_1.h3k(this.e3k_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.fd_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(Bitmap32$iterator$slambda).g3k = function ($this$iterator, completion) {
    var i = new Bitmap32$iterator$slambda(this.b3k_1, completion);
    i.c3k_1 = $this$iterator;
    return i;
  };
  function Bitmap32$iterator$slambda_0(this$0, resultContinuation) {
    var i = new Bitmap32$iterator$slambda(this$0, resultContinuation);
    var l = function ($this$iterator, $completion) {
      return i.f3k($this$iterator, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function Bitmap32(width, height, ints, premultiplied) {
    Companion_getInstance_19();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    Bitmap.call(this, width, height, 32, premultiplied, ints);
    this.v3a_1 = ints;
    if (this.v3a_1.length < imul(width, height))
      throw RuntimeException_init_$Create$('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + this.v3a_1.length + '), area=' + imul(width, height));
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.w3a_1 = new Int32Array(tmp$ret$0);
    this.x3a_1 = new RectangleI(0, 0, width, height);
  }
  protoOf(Bitmap32).c3i = function (width, height) {
    return new Bitmap32(width, height, VOID, this.a3a_1);
  };
  protoOf(Bitmap32).p3h = function (srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return protoOf(Bitmap).p3h.call(this, srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.v3a_1;
    var dstArray = dst.v3a_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(srcArray, src.e3b(srcX, srcY + y | 0), dstArray, dst.e3b(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap32).i3k = function (x, y, color) {
    this.j3k(x, y, color);
  };
  protoOf(Bitmap32).k3k = function (x, y) {
    return this.l3k(x, y);
  };
  protoOf(Bitmap32).d3h = function (x, y, color) {
    this.v3a_1[this.e3b(x, y)] = color;
  };
  protoOf(Bitmap32).e3h = function (x, y) {
    return this.v3a_1[this.e3b(x, y)];
  };
  protoOf(Bitmap32).h3b = function (x, y) {
    return _RGBA___init__impl__lqpay5(this.e3h(x, y));
  };
  protoOf(Bitmap32).j3b = function (x, y, v) {
    return this.d3h(x, y, _RGBA___get_value__impl__hhco8v(v));
  };
  protoOf(Bitmap32).j3k = function (x, y, v) {
    return this.m3k(this.e3b(x, y), v);
  };
  protoOf(Bitmap32).l3k = function (x, y) {
    return this.h3k(this.e3b(x, y));
  };
  protoOf(Bitmap32).m3k = function (n, color) {
    this.v3a_1[n] = this.a3a_1 ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  };
  protoOf(Bitmap32).n3k = function (n, color) {
    var tmp;
    if (this.a3a_1) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.v3a_1[n] = tmp;
  };
  protoOf(Bitmap32).h3k = function (n) {
    var tmp;
    if (this.a3a_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.v3a_1[n]);
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.v3a_1[n]);
    }
    return tmp;
  };
  protoOf(Bitmap32).o3k = function (n) {
    return this.a3a_1 ? _RGBAPremultiplied___init__impl__uos02x(this.v3a_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.v3a_1[n]));
  };
  protoOf(Bitmap32).p3k = function (src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.e3b(dx, dy + y | 0);
        var srcOffset = src.e3b(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.n3k(dstOffset + x | 0, mix(dst.o3k(dstOffset + x | 0), src.o3k(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.a3a_1 === src.a3a_1) {
            arraycopy(src.v3a_1, srcOffset, dst.v3a_1, dstOffset, width);
          } else if (!dst.a3a_1) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.m3k(dstOffset + x_0 | 0, src.h3k(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.n3k(dstOffset + x_1 | 0, src.o3k(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap32).q3k = function (src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.t39_1 - dx_0 | 0;
    var availableHeight = this.u39_1 - dy_0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, b_0);
    this.p3k(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  };
  protoOf(Bitmap32).r3k = function (mix, other, _dx, _dy) {
    this.q3k(other, _dx, _dy, 0, 0, other.t39_1, other.u39_1, mix);
  };
  protoOf(Bitmap32).s3k = function (color, x, y, width, height) {
    var x1 = this.t3h(x);
    var x2 = this.t3h((x + width | 0) - 1 | 0);
    var y1 = this.u3h(y);
    var y2 = this.u3h((y + height | 0) - 1 | 0);
    var colorInt = RGBA__premultipliedValue_impl_oja55q(color, this.a3a_1);
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        fill(this.v3a_1, colorInt, this.e3b(x1, cy), this.e3b(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  };
  protoOf(Bitmap32).t3k = function (color, x, y, width, height, $super) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? this.t39_1 - x | 0 : width;
    height = height === VOID ? this.u39_1 - y | 0 : height;
    var tmp;
    if ($super === VOID) {
      this.s3k(color, x, y, width, height);
      tmp = Unit_instance;
    } else {
      tmp = $super.s3k.call(this, new RGBA(color), x, y, width, height);
    }
    return tmp;
  };
  protoOf(Bitmap32).u3k = function (src, dx, dy, mix) {
    var b = get_bounds_0(src);
    this.q3k(get_bmp(src), dx, dy, b.r2d(), b.t2d(), b.s2d(), b.u2d(), mix);
  };
  protoOf(Bitmap32).v3k = function (src, dx, dy) {
    return this.r3k(false, src, dx, dy);
  };
  protoOf(Bitmap32).w3k = function (src, dx, dy) {
    return this.r3k(true, src, dx, dy);
  };
  protoOf(Bitmap32).y3a = function (src, dx, dy) {
    return this.u3k(src, dx, dy, true);
  };
  protoOf(Bitmap32).x3k = function (destination, input, source) {
    return Companion_getInstance_19().p3i(input, source, this, destination);
  };
  protoOf(Bitmap32).y3k = function (destination, input) {
    return Companion_getInstance_19().w3i(input, this, destination);
  };
  protoOf(Bitmap32).z3k = function (channel, out) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.extractChannel.<anonymous>' call
    Companion_getInstance_19().s3j(this, channel, out);
    return out;
  };
  protoOf(Bitmap32).a3l = function (channel, out, $super) {
    out = out === VOID ? new Bitmap8(this.t39_1, this.u39_1) : out;
    return $super === VOID ? this.z3k(channel, out) : $super.z3k.call(this, channel, out);
  };
  protoOf(Bitmap32).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.toString.<anonymous>' call
    this_0.u5('Bitmap32(');
    this_0.j8(this.t39_1);
    this_0.u5(', ');
    this_0.j8(this.u39_1);
    if (!(this.z39_1 == null)) {
      this_0.u5(', name=');
      this_0.u5(this.z39_1);
    }
    this_0.u5(')');
    return this_0.toString();
  };
  protoOf(Bitmap32).w3h = function (y0, y1) {
    var s0 = this.e3b(0, y0);
    var s1 = this.e3b(0, y1);
    arraycopy(this.v3a_1, s0, this.w3a_1, 0, this.t39_1);
    arraycopy(this.v3a_1, s1, this.v3a_1, s0, this.t39_1);
    arraycopy(this.w3a_1, 0, this.v3a_1, s1, this.t39_1);
  };
  protoOf(Bitmap32).g1s = function () {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.v3a_1.slice();
    return new Bitmap32(this.t39_1, this.u39_1, tmp$ret$1, this.a3a_1);
  };
  protoOf(Bitmap32).d3i = function (antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  };
  protoOf(Bitmap32).b3l = function () {
    return this.a3a_1 ? this : this.copyPremultiplied();
  };
  protoOf(Bitmap32).c3l = function () {
    return !this.a3a_1 ? this : this.d3l();
  };
  protoOf(Bitmap32).copyPremultiplied = function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this.g1s();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.premultiplied.<anonymous>' call
    this_0.e3l();
    return this_0;
  };
  protoOf(Bitmap32).d3l = function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this.g1s();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.depremultiplied.<anonymous>' call
    this_0.f3l();
    return this_0;
  };
  protoOf(Bitmap32).e3l = function () {
    if (this.a3a_1)
      return Unit_instance;
    this.a3a_1 = true;
    var inductionVariable = 0;
    var last = this.e2m();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.v3a_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.v3a_1[n])));
      }
       while (inductionVariable < last);
  };
  protoOf(Bitmap32).f3l = function () {
    if (!this.a3a_1)
      return Unit_instance;
    this.a3a_1 = false;
    var inductionVariable = 0;
    var last = this.e2m();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.v3a_1[n]);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        this.v3a_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  };
  protoOf(Bitmap32).u = function () {
    return iterator(Bitmap32$iterator$slambda_0(this, null));
  };
  protoOf(Bitmap32).g3l = function (x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.v3a_1, this.e3b(x, y), width);
    } else {
      var m = this.e3b(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.v3a_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  };
  protoOf(Bitmap32).g3a = function () {
    return this;
  };
  function isFullyTransparent(_this__u8e3s4) {
    var bmp = get_bmp(_this__u8e3s4);
    var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).v3a_1);
    var width = _this__u8e3s4.s2d() - _this__u8e3s4.r2d() | 0;
    var inductionVariable = _this__u8e3s4.t2d();
    var last = _this__u8e3s4.u2d();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var index = bmp.e3b(_this__u8e3s4.r2d(), y);
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(index >= 0 ? index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0) : false)) {
          // Inline function 'korlibs.image.bitmap.isFullyTransparent.<anonymous>' call
          var message = 'left=' + _this__u8e3s4.r2d() + ', top=' + _this__u8e3s4.t2d() + ', right=' + _this__u8e3s4.s2d() + ', bottom=' + _this__u8e3s4.u2d();
          throw IllegalStateException_init_$Create$(toString(message));
        }
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
              return false;
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < last);
    return true;
  }
  function expandBorder(_this__u8e3s4, area, border) {
    return expandBorder_0(_this__u8e3s4, area.t2d(), area.r2d(), area.u2d(), area.s2d(), border);
  }
  function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
    var data = _this__u8e3s4.v3a_1;
    var x0Index = _this__u8e3s4.e3b(areaLeft, areaTop);
    var x1Index = _this__u8e3s4.e3b(areaRight - 1 | 0, areaTop);
    var areaWidth = areaRight - areaLeft | 0;
    var areaHeight = areaBottom - areaTop | 0;
    var inductionVariable = 0;
    if (inductionVariable < areaHeight)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x0Color = data[x0Index];
        var x1Color = data[x1Index];
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < border)
          do {
            var m = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            data[(x0Index - m | 0) - 1 | 0] = x0Color;
            data[(x1Index + m | 0) + 1 | 0] = x1Color;
          }
           while (inductionVariable_0 < border);
        x0Index = x0Index + _this__u8e3s4.t39_1 | 0;
        x1Index = x1Index + _this__u8e3s4.t39_1 | 0;
      }
       while (inductionVariable < areaHeight);
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < border)
      do {
        var m_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var x = areaLeft - border | 0;
        var npixels = areaWidth + imul(border, 2) | 0;
        arraycopy(data, _this__u8e3s4.e3b(x, areaTop), data, _this__u8e3s4.e3b(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
        arraycopy(data, _this__u8e3s4.e3b(x, areaBottom - 1 | 0), data, _this__u8e3s4.e3b(x, areaBottom + m_0 | 0), npixels);
      }
       while (inductionVariable_1 < border);
  }
  function Companion_5() {
  }
  protoOf(Companion_5).h3l = function (src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.m3h(srcX, srcY, dst, dstX, dstY, width, height);
  };
  var Companion_instance_13;
  function Companion_getInstance_20() {
    return Companion_instance_13;
  }
  function Bitmap8(width, height, data, palette) {
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_instance_18.i3l(256) : palette;
    BitmapIndexed.call(this, 8, width, height, data, palette);
  }
  protoOf(Bitmap8).c3i = function (width, height) {
    return new Bitmap8(width, height, VOID, this.l3j_1);
  };
  protoOf(Bitmap8).d3h = function (x, y, color) {
    return this.d3m(this.e3b(x, y), color);
  };
  protoOf(Bitmap8).e3h = function (x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.n3j_1, this.e3b(x, y));
  };
  protoOf(Bitmap8).h3b = function (x, y) {
    var tmp = this.l3j_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.e3h(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  };
  protoOf(Bitmap8).e3m = function (n) {
    return UByteArrayInt__get_impl_px6q8a(this.n3j_1, n);
  };
  protoOf(Bitmap8).d3m = function (n, color) {
    UByteArrayInt__set_impl_gn4532(this.n3j_1, n, color);
  };
  protoOf(Bitmap8).p3h = function (srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return protoOf(BitmapIndexed).p3h.call(this, srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.r3j();
        var tmp_0 = this.e3b(srcX, srcY + y | 0);
        arraycopy_0(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).r3j(), dst.e3b(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap8).g1s = function () {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this.r3j().slice();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = _RgbaArray___get_ints__impl__u2kps1(this.l3j_1).slice();
    return new Bitmap8(this.t39_1, this.u39_1, tmp, _RgbaArray___init__impl__oib4y4(tmp$ret$3));
  };
  protoOf(Bitmap8).toString = function () {
    return 'Bitmap8(' + this.t39_1 + ', ' + this.u39_1 + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.l3j_1) + ')';
  };
  var BitmapChannel_RED_instance;
  var BitmapChannel_GREEN_instance;
  var BitmapChannel_BLUE_instance;
  var BitmapChannel_ALPHA_instance;
  function Companion_6() {
    Companion_instance_14 = this;
    this.j3m_1 = values();
  }
  protoOf(Companion_6).f1 = function (index) {
    return this.j3m_1[index];
  };
  var Companion_instance_14;
  function Companion_getInstance_21() {
    BitmapChannel_initEntries();
    if (Companion_instance_14 == null)
      new Companion_6();
    return Companion_instance_14;
  }
  function values() {
    return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
  }
  var BitmapChannel_entriesInitialized;
  function BitmapChannel_initEntries() {
    if (BitmapChannel_entriesInitialized)
      return Unit_instance;
    BitmapChannel_entriesInitialized = true;
    BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
    BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
    BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
    BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
    Companion_getInstance_21();
  }
  function BitmapChannel(name, ordinal, index) {
    Enum.call(this, name, ordinal);
    this.s3i_1 = index;
    this.t3i_1 = imul(this.s3i_1, 8);
    this.u3i_1 = 255 << this.t3i_1;
    this.v3i_1 = ~this.u3i_1;
  }
  function BitmapChannel_RED_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_RED_instance;
  }
  function BitmapChannel_GREEN_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_GREEN_instance;
  }
  function BitmapChannel_BLUE_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_BLUE_instance;
  }
  function BitmapChannel_ALPHA_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_ALPHA_instance;
  }
  function putSliceWithBorder(_this__u8e3s4, x, y, bmp, border) {
    border = border === VOID ? 1 : border;
    var width = bmp.v2w_1;
    var height = bmp.w2w_1;
    get_bmp(bmp).m3h(bmp.r2d(), bmp.t2d(), _this__u8e3s4, x, y, width, height);
    var inductionVariable = 1;
    if (inductionVariable <= border)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _this__u8e3s4.m3h(x, y, _this__u8e3s4, x - n | 0, y, 1, height);
        _this__u8e3s4.m3h((x + width | 0) - 1 | 0, y, _this__u8e3s4, ((x + width | 0) - 1 | 0) + n | 0, y, 1, height);
      }
       while (!(n === border));
    var inductionVariable_0 = 1;
    if (inductionVariable_0 <= border)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var rwidth = width + imul(border, 2) | 0;
        _this__u8e3s4.m3h(x - border | 0, y, _this__u8e3s4, x - border | 0, y - n_0 | 0, rwidth, 1);
        _this__u8e3s4.m3h(x - border | 0, (y + height | 0) - 1 | 0, _this__u8e3s4, x - border | 0, ((y + height | 0) - 1 | 0) + n_0 | 0, rwidth, 1);
      }
       while (!(n_0 === border));
  }
  function BitmapIndexed(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_instance_18.i3l(1 << bpp) : palette;
    Bitmap.call(this, width, height, bpp, false, bytes);
    this.k3j_1 = bytes;
    this.l3j_1 = palette;
    if (this.k3j_1.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException_init_$Create$('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + this.r3j().length + '), area=' + imul(width, height));
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.m3j_1 = new Int8Array(tmp$ret$0);
    this.n3j_1 = _UByteArrayInt___init__impl__xif7bu(this.r3j());
    this.o3j_1 = 8 / bpp | 0;
    this.p3j_1 = ilog2(this.o3j_1);
    this.q3j_1 = this.o3j_1 - 1 | 0;
  }
  protoOf(BitmapIndexed).r3j = function () {
    return this.k3j_1;
  };
  protoOf(BitmapIndexed).toString = function () {
    return 'BitmapIndexed(bpp=' + this.v39_1 + ', width=' + this.t39_1 + ', height=' + this.u39_1 + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.l3j_1) + ')';
  };
  protoOf(BitmapIndexed).e3h = function (x, y) {
    return this.e3m(this.e3b(x, y));
  };
  protoOf(BitmapIndexed).d3h = function (x, y, color) {
    return this.d3m(this.e3b(x, y), color);
  };
  protoOf(BitmapIndexed).e3m = function (n) {
    var iD = this.g3m(n);
    var iM = this.h3m(n);
    return extract(UByteArrayInt__get_impl_px6q8a(this.n3j_1, iD), imul(this.v39_1, iM), this.v39_1);
  };
  protoOf(BitmapIndexed).d3m = function (n, color) {
    var iD = this.g3m(n);
    var iM = this.h3m(n);
    UByteArrayInt__set_impl_gn4532(this.n3j_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.n3j_1, iD), color, imul(this.v39_1, iM), this.v39_1));
  };
  protoOf(BitmapIndexed).h3b = function (x, y) {
    var tmp = this.l3j_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.e3h(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  };
  protoOf(BitmapIndexed).f3m = function (x, y) {
    return this.g3m(this.e3b(x, y));
  };
  protoOf(BitmapIndexed).g3m = function (n) {
    return n >>> this.p3j_1 | 0;
  };
  protoOf(BitmapIndexed).h3m = function (n) {
    return n & this.q3j_1;
  };
  protoOf(BitmapIndexed).w3h = function (y0, y1) {
    var s0 = this.f3m(0, y0);
    var s1 = this.f3m(0, y1);
    arraycopy_0(this.r3j(), s0, this.m3j_1, 0, this.d3b());
    arraycopy_0(this.r3j(), s1, this.r3j(), s0, this.d3b());
    arraycopy_0(this.m3j_1, 0, this.r3j(), s1, this.d3b());
  };
  protoOf(BitmapIndexed).i3m = function (x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_0(data, 0, this.r3j(), this.e3b(x, y), width / this.o3j_1 | 0);
    } else {
      var m = this.e3b(x, y);
      var inductionVariable = 0;
      var last = width / this.o3j_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.r3j()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  };
  protoOf(BitmapIndexed).g3a = function () {
    // Inline function 'kotlin.also' call
    var this_0 = new Bitmap32(this.t39_1, this.u39_1, VOID, this.a3a_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.toBMP32.<anonymous>' call
    var out = this_0.v3a_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.l3j_1);
    var inductionVariable = 0;
    var last = this.e2m();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.e3m(n)];
      }
       while (inductionVariable < last);
    return this_0;
  };
  function get_bounds_0(_this__u8e3s4) {
    return _this__u8e3s4.n2w_1;
  }
  function get_bmp(_this__u8e3s4) {
    return get_container(_this__u8e3s4);
  }
  function get_container(_this__u8e3s4) {
    return _this__u8e3s4.v2x();
  }
  function slice_0(_this__u8e3s4, bounds, name, orientation, padding) {
    bounds = bounds === VOID ? new RectangleI(0, 0, _this__u8e3s4.t39_1, _this__u8e3s4.u39_1) : bounds;
    name = name === VOID ? null : name;
    orientation = orientation === VOID ? Companion_getInstance_0().c2w_1 : orientation;
    padding = padding === VOID ? Companion_getInstance_1().y2e_1 : padding;
    var left = clamp(bounds.r2d(), 0, _this__u8e3s4.t39_1);
    var top = clamp(bounds.t2d(), 0, _this__u8e3s4.u39_1);
    return new RectSlice(_this__u8e3s4, Companion_instance_0.u2k(left, top, clamp(bounds.s2d(), left, _this__u8e3s4.t39_1), clamp(bounds.u2d(), top, _this__u8e3s4.u39_1)), orientation, padding, name);
  }
  function extract_0(_this__u8e3s4) {
    var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.o2w_1) ? _this__u8e3s4.n2w_1.z2l_1 : _this__u8e3s4.n2w_1.a2m_1;
    var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.o2w_1) ? _this__u8e3s4.n2w_1.a2m_1 : _this__u8e3s4.n2w_1.z2l_1;
    var tmp = get_container(_this__u8e3s4).c3i(w + _this__u8e3s4.p2w_1.w2e() | 0, h + _this__u8e3s4.p2w_1.x2e() | 0);
    var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
    var raw = extractUntransformed(_this__u8e3s4).b3i(_this__u8e3s4.o2w_1);
    raw.p3h(0, 0, out, _this__u8e3s4.p2w_1.c2f_1, _this__u8e3s4.p2w_1.z2e_1, raw.t39_1, raw.u39_1);
    return out;
  }
  function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
    name = name === VOID ? null : name;
    orientation = orientation === VOID ? Companion_getInstance_0().c2w_1 : orientation;
    padding = padding === VOID ? Companion_getInstance_1().y2e_1 : padding;
    return slice_0(_this__u8e3s4, new RectangleI(x, y, width, height), name, orientation, padding);
  }
  function extractUntransformed(_this__u8e3s4) {
    var tmp = get_container(_this__u8e3s4).c3i(_this__u8e3s4.n2w_1.z2l_1, _this__u8e3s4.n2w_1.a2m_1);
    var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
    get_container(_this__u8e3s4).m3h(_this__u8e3s4.n2w_1.x2l_1, _this__u8e3s4.n2w_1.y2l_1, out, 0, 0, _this__u8e3s4.n2w_1.z2l_1, _this__u8e3s4.n2w_1.a2m_1);
    return out;
  }
  function get_Bitmaps_transparent() {
    _init_properties_Bitmaps_kt__92w93i();
    return Bitmaps_transparent;
  }
  var Bitmaps_transparent;
  function get_Bitmaps_white() {
    _init_properties_Bitmaps_kt__92w93i();
    return Bitmaps_white;
  }
  var Bitmaps_white;
  function Bitmaps() {
  }
  var Bitmaps_instance;
  function Bitmaps_getInstance() {
    return Bitmaps_instance;
  }
  var properties_initialized_Bitmaps_kt_qcuk18;
  function _init_properties_Bitmaps_kt__92w93i() {
    if (!properties_initialized_Bitmaps_kt_qcuk18) {
      properties_initialized_Bitmaps_kt_qcuk18 = true;
      Bitmaps_transparent = slice_0(Companion_getInstance_19().n3i(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().q3b_1)), VOID, 'transparent');
      Bitmaps_white = slice_0(Companion_getInstance_19().n3i(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().l3b_1)), VOID, 'white');
    }
  }
  function Companion_7() {
    this.k3m_1 = 1.0;
    this.l3m_1 = 1.4142135;
  }
  var Companion_instance_15;
  function Companion_getInstance_22() {
    return Companion_instance_15;
  }
  function setFromBitmap$getAlpha(_this__u8e3s4, x, y, min) {
    return _this__u8e3s4.s3h(x, y) ? _RGBA___get_a__impl__6msvu7(_this__u8e3s4.h3b(x, y)) >= min : false;
  }
  function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
    if (this$0.w3m(x + dx | 0, y + dy | 0) + d < this$0.w3m(x, y)) {
      this$0.s3m(x, y, x + dx | 0, y + dy | 0);
      // Inline function 'kotlin.math.hypot' call
      var x_0 = x - this$0.t3m(x, y) | 0;
      var y_0 = y - this$0.u3m(x, y) | 0;
      var tmp$ret$0 = hypot(x_0, y_0);
      this$0.v3m(x, y, tmp$ret$0);
    }
  }
  function DistanceBitmap(width, height, d, px, py) {
    d = d === VOID ? new Float32Array(imul(width, height)) : d;
    px = px === VOID ? new Int32Array(imul(width, height)) : px;
    py = py === VOID ? new Int32Array(imul(width, height)) : py;
    this.m3m_1 = width;
    this.n3m_1 = height;
    this.o3m_1 = d;
    this.p3m_1 = px;
    this.q3m_1 = py;
    this.r3m_1 = imul(this.m3m_1, this.n3m_1);
    // Inline function 'korlibs.io.lang.assert' call
    if (!(this.o3m_1.length >= this.r3m_1))
      throw AssertionError_init_$Create$();
    // Inline function 'korlibs.io.lang.assert' call
    if (!(this.p3m_1.length >= this.r3m_1))
      throw AssertionError_init_$Create$();
    // Inline function 'korlibs.io.lang.assert' call
    if (!(this.q3m_1.length >= this.r3m_1))
      throw AssertionError_init_$Create$();
  }
  protoOf(DistanceBitmap).q3h = function (x) {
    return x >= 0 ? x < this.m3m_1 : false;
  };
  protoOf(DistanceBitmap).r3h = function (y) {
    return y >= 0 ? y < this.n3m_1 : false;
  };
  protoOf(DistanceBitmap).s3h = function (x, y) {
    return this.q3h(x) ? this.r3h(y) : false;
  };
  protoOf(DistanceBitmap).e3b = function (x, y) {
    return imul(y, this.m3m_1) + x | 0;
  };
  protoOf(DistanceBitmap).w3m = function (x, y) {
    var tmp;
    if (this.s3h(x, y)) {
      tmp = this.o3m_1[this.e3b(x, y)];
    } else {
      tmp = Infinity;
    }
    return tmp;
  };
  protoOf(DistanceBitmap).t3m = function (x, y) {
    return this.s3h(x, y) ? this.p3m_1[this.e3b(x, y)] : -1;
  };
  protoOf(DistanceBitmap).u3m = function (x, y) {
    return this.s3h(x, y) ? this.q3m_1[this.e3b(x, y)] : -1;
  };
  protoOf(DistanceBitmap).v3m = function (x, y, d) {
    if (!this.s3h(x, y))
      return Unit_instance;
    this.o3m_1[this.e3b(x, y)] = d;
  };
  protoOf(DistanceBitmap).x3m = function (x, y, px, py) {
    if (!this.s3h(x, y))
      return Unit_instance;
    var index = this.e3b(x, y);
    this.p3m_1[index] = px;
    this.q3m_1[index] = py;
  };
  protoOf(DistanceBitmap).s3m = function (x, y, px, py) {
    return this.x3m(x, y, this.t3m(px, py), this.u3m(px, py));
  };
  protoOf(DistanceBitmap).y3m = function (bmp, thresold) {
    // Inline function 'korlibs.io.lang.assert' call
    if (!(this.m3m_1 === bmp.t39_1))
      throw AssertionError_init_$Create$();
    // Inline function 'korlibs.io.lang.assert' call
    if (!(this.n3m_1 === bmp.u39_1))
      throw AssertionError_init_$Create$();
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last = this.n3m_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.m3m_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.v3m(x, y, Infinity);
            this.x3m(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var inductionVariable_1 = 0;
    var last_1 = this.n3m_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = this.m3m_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (((!(left === cur) ? true : !(right === cur)) ? true : !(up === cur)) ? true : !(down === cur)) {
              this.v3m(x_0, y_0, 0.0);
              this.x3m(x_0, y_0, x_0, y_0);
            }
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_3 = 0;
    var last_3 = this.n3m_1;
    if (inductionVariable_3 < last_3)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_4 = this.m3m_1;
        if (inductionVariable_4 < last_4)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_4);
      }
       while (inductionVariable_3 < last_3);
    var inductionVariable_5 = this.n3m_1 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this.m3m_1 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this.n3m_1 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this.m3m_1 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.v3m(x_3, y_3, -this.w3m(x_3, y_3));
            }
          }
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  };
  function distanceMap(_this__u8e3s4, out, thresold) {
    out = out === VOID ? new DistanceBitmap(_this__u8e3s4.t39_1, _this__u8e3s4.u39_1) : out;
    thresold = thresold === VOID ? 0.5 : thresold;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.distanceMap.<anonymous>' call
    out.y3m(_this__u8e3s4, thresold);
    return out;
  }
  function index4($this, x, y) {
    return imul($this.e3b(x, y), 4);
  }
  function FloatBitmap32(width, height, data, premultiplied) {
    data = data === VOID ? new Float32Array(imul(imul(width, height), 4)) : data;
    premultiplied = premultiplied === VOID ? false : premultiplied;
    Bitmap.call(this, width, height, 32, premultiplied, data);
    this.m3n_1 = data;
  }
  protoOf(FloatBitmap32).j3b = function (x, y, v) {
    var rindex = index4(this, x, y);
    this.m3n_1[rindex + 0 | 0] = _RGBA___get_rf__impl__kvz75k(v);
    this.m3n_1[rindex + 1 | 0] = _RGBA___get_gf__impl__5gcu1f(v);
    this.m3n_1[rindex + 2 | 0] = _RGBA___get_bf__impl__1xz5yg(v);
    this.m3n_1[rindex + 3 | 0] = _RGBA___get_af__impl__vu36qv(v);
  };
  protoOf(FloatBitmap32).h3b = function (x, y) {
    var rindex = index4(this, x, y);
    return Companion_getInstance_26().n3n(this.m3n_1[rindex + 0 | 0], this.m3n_1[rindex + 1 | 0], this.m3n_1[rindex + 2 | 0], this.m3n_1[rindex + 3 | 0]);
  };
  protoOf(FloatBitmap32).o3n = function (x, y) {
    return this.m3n_1[index4(this, x, y) + 0 | 0];
  };
  protoOf(FloatBitmap32).p3n = function (x, y) {
    return this.m3n_1[index4(this, x, y) + 1 | 0];
  };
  protoOf(FloatBitmap32).q3n = function (x, y) {
    return this.m3n_1[index4(this, x, y) + 2 | 0];
  };
  protoOf(FloatBitmap32).r3n = function (x, y) {
    return this.m3n_1[index4(this, x, y) + 3 | 0];
  };
  protoOf(FloatBitmap32).s3n = function (x, y, r, g, b, a) {
    var rindex = index4(this, x, y);
    this.m3n_1[rindex + 0 | 0] = r;
    this.m3n_1[rindex + 1 | 0] = g;
    this.m3n_1[rindex + 2 | 0] = b;
    this.m3n_1[rindex + 3 | 0] = a;
  };
  protoOf(FloatBitmap32).t3n = function (x, y, out) {
    var rindex = index4(this, x, y);
    _RGBAf___set_r__impl__pz5j5e(out, this.m3n_1[rindex + 0 | 0]);
    _RGBAf___set_g__impl__c4jj21(out, this.m3n_1[rindex + 1 | 0]);
    _RGBAf___set_b__impl__a2n9pa(out, this.m3n_1[rindex + 2 | 0]);
    _RGBAf___set_a__impl__iqz7cx(out, this.m3n_1[rindex + 3 | 0]);
    return out;
  };
  protoOf(FloatBitmap32).u3n = function (out) {
    var min_0 = Infinity;
    var max_0 = -Infinity;
    var temp = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.t39_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.u39_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.e3b(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.getMinMax.<anonymous>' call
            n = n + 1 | 0;
            var c = this.t3n(x, y, temp);
            min_0 = min(min_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
            max_0 = max(max_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    out[0] = min_0;
    out[1] = max_0;
    return out;
  };
  protoOf(FloatBitmap32).v3n = function (out, $super) {
    out = out === VOID ? new Float32Array(2) : out;
    return $super === VOID ? this.u3n(out) : $super.u3n.call(this, out);
  };
  protoOf(FloatBitmap32).w3n = function (minSrc, maxSrc, minDst, maxDst) {
    var out = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.t39_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.u39_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.e3b(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.convertRange.<anonymous>' call
            n = n + 1 | 0;
            var rgbaf = this.t3n(x, y, out);
            this.s3n(x, y, convertRange(_RGBAf___get_r__impl__jfq8gq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_g__impl__dhoraz(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_b__impl__fjl0nq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_a__impl__qnwk97(rgbaf), minSrc, maxSrc, minDst, maxDst));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  };
  protoOf(FloatBitmap32).x3n = function (minSrc, maxSrc, minDst, maxDst, $super) {
    minDst = minDst === VOID ? 0.0 : minDst;
    maxDst = maxDst === VOID ? 1.0 : maxDst;
    var tmp;
    if ($super === VOID) {
      this.w3n(minSrc, maxSrc, minDst, maxDst);
      tmp = Unit_instance;
    } else {
      tmp = $super.w3n.call(this, minSrc, maxSrc, minDst, maxDst);
    }
    return tmp;
  };
  protoOf(FloatBitmap32).y3n = function () {
    var tmp0_container = this.v3n();
    // Inline function 'kotlin.collections.component1' call
    var min = tmp0_container[0];
    // Inline function 'kotlin.collections.component2' call
    var max = tmp0_container[1];
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.absoluteValue' call
    var a = Math.abs(min);
    // Inline function 'kotlin.math.absoluteValue' call
    var b = Math.abs(max);
    var range = Math.max(a, b);
    this.x3n(-range, +range);
  };
  protoOf(FloatBitmap32).z3n = function (scale) {
    return this.a3o(scale, scale, scale, scale);
  };
  protoOf(FloatBitmap32).a3o = function (scaleRed, scaleGreen, scaleBlue, scaleAlpha) {
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.t39_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.u39_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.e3b(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.scale.<anonymous>' call
            n = n + 1 | 0;
            this.s3n(x, y, this.o3n(x, y) * scaleRed, this.p3n(x, y) * scaleGreen, this.q3n(x, y) * scaleBlue, this.r3n(x, y) * scaleAlpha);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  };
  protoOf(FloatBitmap32).b3o = function (min, max) {
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.t39_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.u39_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.e3b(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            n = n + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value = this.o3n(x, y);
            var tmp = clamp_0(value, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_0 = this.p3n(x, y);
            var tmp_0 = clamp_0(value_0, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_1 = this.q3n(x, y);
            var tmp_1 = clamp_0(value_1, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_2 = this.r3n(x, y);
            var tmp$ret$3 = clamp_0(value_2, min, max);
            this.s3n(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  };
  function MultiBitmap() {
  }
  function NativeImageOrBitmap32(width, height, native, premultiplied) {
    native = native === VOID ? true : native;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    var tmp;
    if (native) {
      tmp = NativeImage_0(width, height, premultiplied);
    } else {
      tmp = new Bitmap32(width, height, VOID, premultiplied == null ? true : premultiplied);
    }
    return tmp;
  }
  function NativeImage(width, height, data, premultiplied) {
    Bitmap.call(this, width, height, 32, premultiplied, null);
    this.p3o_1 = data;
  }
  protoOf(NativeImage).g3a = function () {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_19().o3i(this.t39_1, this.u39_1, this.a3a_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.NativeImage.toBMP32.<anonymous>' call
    this.g3b(0, 0, this.t39_1, this.u39_1, this_0.v3a_1, 0);
    return this_0;
  };
  protoOf(NativeImage).j3b = function (x, y, v) {
    RgbaArray__set_impl_epw2wg(this.c3b(), 0, v);
    this.i3b(x, y, 1, 1, this.b3b(), 0);
  };
  protoOf(NativeImage).h3b = function (x, y) {
    this.g3b(x, y, 1, 1, this.b3b(), 0);
    return RgbaArray__get_impl_nzyo1o(this.c3b(), 0);
  };
  protoOf(NativeImage).d3h = function (x, y, color) {
    return this.j3b(x, y, _RGBA___init__impl__lqpay5(color));
  };
  protoOf(NativeImage).e3h = function (x, y) {
    return _RGBA___get_value__impl__hhco8v(this.h3b(x, y));
  };
  protoOf(NativeImage).v3h = function () {
    var tmp = this.g3a().v3h();
    this.k3b(0, 0, this.t39_1, this.u39_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).v3a_1);
    return this;
  };
  protoOf(NativeImage).x3h = function () {
    var tmp = this.g3a().x3h();
    this.k3b(0, 0, this.t39_1, this.u39_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).v3a_1);
    return this;
  };
  protoOf(NativeImage).w3h = function (y0, y1) {
    this.g3b(0, y0, this.t39_1, 1, this.b3b(), 0);
    this.g3b(0, y1, this.t39_1, 1, this.b3b(), this.t39_1);
    this.i3b(0, y1, this.t39_1, 1, this.b3b(), 0);
    this.i3b(0, y0, this.t39_1, 1, this.b3b(), this.t39_1);
  };
  protoOf(NativeImage).y3h = function (x0, x1) {
    this.g3b(x0, 0, 1, this.u39_1, this.b3b(), 0);
    this.g3b(x1, 0, 1, this.u39_1, this.b3b(), this.t39_1);
    this.i3b(x1, 0, 1, this.u39_1, this.b3b(), 0);
    this.i3b(x0, 0, 1, this.u39_1, this.b3b(), this.t39_1);
  };
  protoOf(NativeImage).c3i = function (width, height) {
    return NativeImage_0(width, height);
  };
  protoOf(NativeImage).toString = function () {
    return this.zb() + '(' + this.t39_1 + ', ' + this.u39_1 + ')';
  };
  function ensureNative(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NativeImage) {
      tmp = _this__u8e3s4;
    } else {
      tmp = get_nativeImageFormatProvider().q3o(_this__u8e3s4);
    }
    return tmp;
  }
  function NativeImage_0(width, height, premultiplied) {
    premultiplied = premultiplied === VOID ? null : premultiplied;
    return get_nativeImageFormatProvider().r3o(width, height, premultiplied);
  }
  function ForcedTexId() {
  }
  function Companion_8() {
  }
  protoOf(Companion_8).t3o = function (bmp, left, top, right, bottom) {
    return new NinePatchBmpSlice(bmp, NinePatchInfo_init_$Create$(bmp.v2w_1, bmp.w2w_1, left, top, right, bottom, bmp));
  };
  var Companion_instance_16;
  function Companion_getInstance_23() {
    return Companion_instance_16;
  }
  function NinePatchBmpSlice(content, info, bmpSlice) {
    bmpSlice = bmpSlice === VOID ? content : bmpSlice;
    this.u3o_1 = content;
    this.v3o_1 = info;
    this.w3o_1 = bmpSlice;
  }
  function NinePatchInfo$Segment$bmp$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.e3p_1;
      return tmp0_safe_receiver == null ? null : extract_0(tmp0_safe_receiver);
    };
  }
  function NinePatchInfo_init_$Init$(width, height, left, top, right, bottom, content, $this) {
    content = content === VOID ? null : content;
    NinePatchInfo.call($this, listOf([to(false, until(0, left)), to(true, until(left, right)), to(false, until(right, width))]), listOf([to(false, until(0, top)), to(true, until(top, bottom)), to(false, until(bottom, height))]), width, height, content);
    return $this;
  }
  function NinePatchInfo_init_$Create$(width, height, left, top, right, bottom, content) {
    return NinePatchInfo_init_$Init$(width, height, left, top, right, bottom, content, objectCreate(protoOf(NinePatchInfo)));
  }
  function AxisSegment(scaled, range) {
    this.g3p_1 = scaled;
    this.h3p_1 = range;
  }
  protoOf(AxisSegment).i3p = function () {
    return !this.g3p_1;
  };
  protoOf(AxisSegment).a = function () {
    return get_length(this.h3p_1);
  };
  function AxisInfo(ranges, totalLen) {
    this.j3p_1 = ranges;
    this.k3p_1 = totalLen;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.j3p_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.image.bitmap.AxisInfo.segments.<anonymous>' call
      var tmp$ret$0 = new AxisSegment(item.ag_1, item.bg_1);
      destination.r(tmp$ret$0);
    }
    tmp.l3p_1 = toFastList(destination);
    var tmp_0 = this;
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.collections.sumOf' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = this.l3p_1;
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = this_1.u();
    while (tmp0_iterator_0.v()) {
      var element = tmp0_iterator_0.x();
      // Inline function 'korlibs.image.bitmap.AxisInfo.fixedLen.<anonymous>' call
      if (element.i3p()) {
        destination_0.r(element);
      }
    }
    var sum = 0;
    var tmp0_iterator_1 = destination_0.u();
    while (tmp0_iterator_1.v()) {
      var element_0 = tmp0_iterator_1.x();
      var tmp_1 = sum;
      // Inline function 'korlibs.image.bitmap.AxisInfo.fixedLen.<anonymous>' call
      sum = tmp_1 + element_0.a() | 0;
    }
    var b = sum;
    tmp_0.m3p_1 = Math.max(1, b);
    var tmp_2 = this;
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.collections.sumOf' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_2 = this.l3p_1;
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_2 = this_2.u();
    while (tmp0_iterator_2.v()) {
      var element_1 = tmp0_iterator_2.x();
      // Inline function 'korlibs.image.bitmap.AxisInfo.scaledLen.<anonymous>' call
      if (element_1.g3p_1) {
        destination_1.r(element_1);
      }
    }
    var sum_0 = 0;
    var tmp0_iterator_3 = destination_1.u();
    while (tmp0_iterator_3.v()) {
      var element_2 = tmp0_iterator_3.x();
      var tmp_3 = sum_0;
      // Inline function 'korlibs.image.bitmap.AxisInfo.scaledLen.<anonymous>' call
      sum_0 = tmp_3 + element_2.a() | 0;
    }
    var b_0 = sum_0;
    tmp_2.n3p_1 = Math.max(1, b_0);
  }
  protoOf(AxisInfo).toString = function () {
    return 'AxisInfo(ranges=' + this.j3p_1 + ', totalLen=' + this.k3p_1 + ')';
  };
  protoOf(AxisInfo).hashCode = function () {
    var result = hashCode(this.j3p_1);
    result = imul(result, 31) + this.k3p_1 | 0;
    return result;
  };
  protoOf(AxisInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AxisInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AxisInfo ? other : THROW_CCE();
    if (!equals(this.j3p_1, tmp0_other_with_cast.j3p_1))
      return false;
    if (!(this.k3p_1 === tmp0_other_with_cast.k3p_1))
      return false;
    return true;
  };
  function Segment(info, rect, x, y) {
    this.x3o_1 = info;
    this.y3o_1 = rect;
    this.z3o_1 = x;
    this.a3p_1 = y;
    this.b3p_1 = new Mixin();
    this.c3p_1 = this.z3o_1.g3p_1;
    this.d3p_1 = this.a3p_1.g3p_1;
    var tmp = this;
    var tmp0_safe_receiver = this.x3o_1.s3p_1;
    tmp.e3p_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f2y(this.y3o_1);
    var tmp_0 = this;
    tmp_0.f3p_1 = lazy(NinePatchInfo$Segment$bmp$delegate$lambda(this));
  }
  protoOf(Segment).h23 = function (_set____db54di) {
    this.b3p_1.h23(_set____db54di);
  };
  protoOf(Segment).i23 = function () {
    return this.b3p_1.i23();
  };
  function NinePatchInfo(xranges, yranges, width, height, content) {
    content = content === VOID ? null : content;
    this.o3p_1 = xranges;
    this.p3p_1 = yranges;
    this.q3p_1 = width;
    this.r3p_1 = height;
    this.s3p_1 = content;
    this.t3p_1 = new AxisInfo(this.o3p_1, this.q3p_1);
    this.u3p_1 = new AxisInfo(this.p3p_1, this.r3p_1);
    this.v3p_1 = this.t3p_1.l3p_1;
    this.w3p_1 = this.u3p_1.l3p_1;
    this.x3p_1 = this.t3p_1.m3p_1;
    this.y3p_1 = this.u3p_1.m3p_1;
    this.z3p_1 = this.t3p_1.n3p_1;
    this.a3q_1 = this.u3p_1.n3p_1;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.w3p_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.image.bitmap.NinePatchInfo.segments.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = this.v3p_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.u();
      while (tmp0_iterator_0.v()) {
        var item_0 = tmp0_iterator_0.x();
        // Inline function 'korlibs.image.bitmap.NinePatchInfo.segments.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new Segment(this, Companion_instance_0.u2k(item_0.h3p_1.fb_1, item.h3p_1.fb_1, item_0.h3p_1.gb_1 + 1 | 0, item.h3p_1.gb_1 + 1 | 0), item_0, item);
        destination_0.r(tmp$ret$0);
      }
      var tmp$ret$3 = toFastList(destination_0);
      destination.r(tmp$ret$3);
    }
    tmp.b3q_1 = toFastList(destination);
    this.c3q_1 = new Int32Array(64);
    this.d3q_1 = new Int32Array(64);
  }
  protoOf(NinePatchInfo).toString = function () {
    return 'NinePatchInfo(xranges=' + this.o3p_1 + ', yranges=' + this.p3p_1 + ', width=' + this.q3p_1 + ', height=' + this.r3p_1 + ', content=' + this.s3p_1 + ')';
  };
  protoOf(NinePatchInfo).hashCode = function () {
    var result = hashCode(this.o3p_1);
    result = imul(result, 31) + hashCode(this.p3p_1) | 0;
    result = imul(result, 31) + this.q3p_1 | 0;
    result = imul(result, 31) + this.r3p_1 | 0;
    result = imul(result, 31) + (this.s3p_1 == null ? 0 : this.s3p_1.hashCode()) | 0;
    return result;
  };
  protoOf(NinePatchInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NinePatchInfo))
      return false;
    var tmp0_other_with_cast = other instanceof NinePatchInfo ? other : THROW_CCE();
    if (!equals(this.o3p_1, tmp0_other_with_cast.o3p_1))
      return false;
    if (!equals(this.p3p_1, tmp0_other_with_cast.p3p_1))
      return false;
    if (!(this.q3p_1 === tmp0_other_with_cast.q3p_1))
      return false;
    if (!(this.r3p_1 === tmp0_other_with_cast.r3p_1))
      return false;
    if (!equals(this.s3p_1, tmp0_other_with_cast.s3p_1))
      return false;
    return true;
  };
  function asNinePatchSimple(_this__u8e3s4, left, top, right, bottom) {
    return Companion_instance_16.t3o(_this__u8e3s4, left, top, right, bottom);
  }
  function NullBitmap(width, height, premultiplied) {
    premultiplied = premultiplied === VOID ? true : premultiplied;
    Bitmap.call(this, width, height, 32, premultiplied, null);
  }
  function Palette(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    this.e3q_1 = colors;
    this.f3q_1 = names;
    this.g3q_1 = changeStart;
    this.h3q_1 = changeEnd;
  }
  protoOf(Palette).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Palette.toString.<anonymous>' call
    this_0.u5('Palette(');
    var inductionVariable = 0;
    var last = _RgbaArray___get_size__impl__imxef8(this.e3q_1);
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color = RgbaArray__get_impl_nzyo1o(this.e3q_1, n);
        var tmp1_safe_receiver = this.f3q_1;
        var name = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[n];
        if (n > 0) {
          this_0.u5(', ');
        }
        if (!(name == null)) {
          this_0.u5(name);
          this_0.u5(': ');
        }
        this_0.u5(RGBA__toString_impl_4lw6dp(color));
      }
       while (inductionVariable < last);
    this_0.u5(')');
    return this_0.toString();
  };
  function applyEffect(_this__u8e3s4, effect) {
    var safeBorder = get_safeBorder(effect);
    var out = Companion_getInstance_19().o3i(_this__u8e3s4.t39_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.u39_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.a3a_1);
    out.v3k(_this__u8e3s4, safeBorder, safeBorder);
    applyEffectInline(out, effect);
    return out;
  }
  function get_safeBorder(_this__u8e3s4) {
    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.p3q();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  function applyEffectInline(_this__u8e3s4, effect) {
    if (effect == null)
      return Unit_instance;
    if (!(effect.i3q_1 === 0)) {
      blurInplace(_this__u8e3s4, effect.i3q_1);
    }
    if ((!(effect.l3q_1 === 0) ? true : !(effect.j3q_1 === 0)) ? true : !(effect.k3q_1 === 0)) {
      dropShadowInplace(_this__u8e3s4, effect.j3q_1, effect.k3q_1, effect.l3q_1, effect.m3q_1);
    }
    if (!(effect.n3q_1 === 0)) {
      borderInline(_this__u8e3s4, effect.n3q_1, effect.o3q_1);
    }
  }
  function blurInplace(_this__u8e3s4, r) {
    var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.t39_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.u39_1 / 2 | 0) - 1 | 0);
    var t1 = new Bitmap8(_this__u8e3s4.t39_1, _this__u8e3s4.u39_1);
    var t2 = new Bitmap8(_this__u8e3s4.t39_1, _this__u8e3s4.u39_1);
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var channel = Companion_getInstance_21().f1(n);
        _this__u8e3s4.z3k(channel, t1);
        arraycopy_0(t1.r3j(), 0, t2.r3j(), 0, t2.e2m());
        gaussBlur(t1.r3j(), t2.r3j(), _this__u8e3s4.t39_1, _this__u8e3s4.u39_1, r_0);
        _this__u8e3s4.y3k(channel, t2);
      }
       while (inductionVariable < 4);
  }
  function gaussBlur(scl, tcl, w, h, r) {
    var a = 0;
    var b = 0;
    var c = 0;
    // Inline function 'korlibs.image.bitmap.effect.boxesForGaussN3' call
    var n = 3;
    // Inline function 'kotlin.math.sqrt' call
    var x = 12.0 * r * r / n + 1;
    var wIdeal = Math.sqrt(x);
    var wl = toIntFloor_0(wIdeal);
    if ((wl % 2 | 0) === 0) {
      wl = wl - 1 | 0;
    }
    var wu = wl + 2 | 0;
    var mIdeal = (12.0 * r * r - imul(imul(n, wl), wl) - imul(imul(4, n), wl) - imul(3, n)) / (imul(-4, wl) - 4 | 0);
    var m = round(mIdeal);
    // Inline function 'korlibs.image.bitmap.effect.gaussBlur.<anonymous>' call
    a = 0.0 < m ? wl : wu;
    b = 1.0 < m ? wl : wu;
    c = 2.0 < m ? wl : wu;
    boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
    boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
    boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
  }
  function boxBlur(scl, tcl, w, h, r) {
    arraycopy_0(scl, 0, tcl, 0, scl.length);
    boxBlurH(tcl, scl, w, h, r);
    boxBlurT(scl, tcl, w, h, r);
  }
  function boxBlurH(scl, tcl, w, h, r) {
    var arr = (r + r | 0) + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < h)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ti = imul(i, w);
        var li = ti;
        var ri = ti + r | 0;
        var fv = getU8(scl, ti);
        var lv = getU8(scl, (ti + w | 0) - 1 | 0);
        var v = imul(r + 1 | 0, fv);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < r)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            v = v + getU8(scl, ti + j | 0) | 0;
          }
           while (inductionVariable_0 < r);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= r)
          do {
            var j_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp = v;
            var tmp3 = ri;
            ri = tmp3 + 1 | 0;
            v = tmp + (getU8(scl, tmp3) - fv | 0) | 0;
            var tmp4 = ti;
            ti = tmp4 + 1 | 0;
            tcl[tmp4] = toByte(v / arr | 0);
          }
           while (!(j_0 === r));
        var inductionVariable_2 = r + 1 | 0;
        var last = w - r | 0;
        if (inductionVariable_2 < last)
          do {
            var j_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var tmp_0 = v;
            var tmp7 = ri;
            ri = tmp7 + 1 | 0;
            var tmp_1 = getU8(scl, tmp7);
            var tmp6 = li;
            li = tmp6 + 1 | 0;
            v = tmp_0 + (tmp_1 - getU8(scl, tmp6) | 0) | 0;
            var tmp8 = ti;
            ti = tmp8 + 1 | 0;
            tcl[tmp8] = toByte(v / arr | 0);
          }
           while (inductionVariable_2 < last);
        var inductionVariable_3 = w - r | 0;
        if (inductionVariable_3 < w)
          do {
            var j_2 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var tmp_2 = v;
            var tmp10 = li;
            li = tmp10 + 1 | 0;
            v = tmp_2 + (lv - getU8(scl, tmp10) | 0) | 0;
            var tmp11 = ti;
            ti = tmp11 + 1 | 0;
            tcl[tmp11] = toByte(v / arr | 0);
          }
           while (inductionVariable_3 < w);
      }
       while (inductionVariable < h);
  }
  function boxBlurT(scl, tcl, w, h, r) {
    var arr = (r + r | 0) + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < w)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ti = i;
        var li = ti;
        var ri = ti + imul(r, w) | 0;
        var fv = getU8(scl, ti);
        var lv = getU8(scl, ti + imul(w, h - 1 | 0) | 0);
        var v = imul(r + 1 | 0, fv);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < r)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            v = v + getU8(scl, ti + imul(j, w) | 0) | 0;
          }
           while (inductionVariable_0 < r);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= r)
          do {
            var j_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            v = v + (getU8(scl, ri) - fv | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            ri = ri + w | 0;
            ti = ti + w | 0;
          }
           while (!(j_0 === r));
        var inductionVariable_2 = r + 1 | 0;
        var last = h - r | 0;
        if (inductionVariable_2 < last)
          do {
            var j_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            v = v + (getU8(scl, ri) - getU8(scl, li) | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            li = li + w | 0;
            ri = ri + w | 0;
            ti = ti + w | 0;
          }
           while (inductionVariable_2 < last);
        var inductionVariable_3 = h - r | 0;
        if (inductionVariable_3 < h)
          do {
            var j_2 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            v = v + (lv - getU8(scl, li) | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            li = li + w | 0;
            ti = ti + w | 0;
          }
           while (inductionVariable_3 < h);
      }
       while (inductionVariable < w);
  }
  function blur(_this__u8e3s4, r) {
    var out = new Bitmap8(_this__u8e3s4.t39_1 + imul(r, 2) | 0, _this__u8e3s4.u39_1 + imul(r, 2) | 0);
    Companion_instance_13.h3l(_this__u8e3s4, 0, 0, out, r, r, _this__u8e3s4.t39_1, _this__u8e3s4.u39_1);
    blurInplace_0(out, r);
    return out;
  }
  function blurInplace_0(_this__u8e3s4, r) {
    var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.t39_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.u39_1 / 2 | 0) - 1 | 0);
    var t2 = new Bitmap8(_this__u8e3s4.t39_1, _this__u8e3s4.u39_1);
    arraycopy_0(_this__u8e3s4.r3j(), 0, t2.r3j(), 0, _this__u8e3s4.e2m());
    gaussBlur(t2.r3j(), _this__u8e3s4.r3j(), _this__u8e3s4.t39_1, _this__u8e3s4.u39_1, r_0);
  }
  function borderInline(_this__u8e3s4, r, color) {
    color = color === VOID ? Colors_getInstance().m3b_1 : color;
    var out = _this__u8e3s4;
    var distance = distanceMap(out);
    var inductionVariable = 0;
    var last = out.u39_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = out.t39_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var dist = distance.w3m(x, y);
            if (dist < (r + 1 | 0)) {
              var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
              var rcolor = alpha === 1.0 ? color : RGBA__withAf_impl_dpdu32(color, _RGBA___get_af__impl__vu36qv(color) * alpha);
              out.i3k(x, y, Companion_getInstance_26().q3q(rcolor, out.k3k(x, y)));
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  function dropShadowInplace(_this__u8e3s4, x, y, r, color) {
    color = color === VOID ? Colors_getInstance().m3b_1 : color;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>' call
    var copy = _this__u8e3s4.g1s();
    var pcolor = _RGBA___get_premultiplied__impl__3bulqc(color);
    // Inline function 'kotlin.also' call
    var this_0 = blur(_this__u8e3s4.a3l(BitmapChannel_ALPHA_getInstance()), r);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>.<anonymous>' call
    this_0.a3a_1 = true;
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaArray__set_impl_epw2wg(this_0.l3j_1, n, Companion_getInstance_26().r3q(imul(_RGBAPremultiplied___get_r__impl__m8nz5i(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl__fv131x(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl__dt4tp6(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl__f0hnd1(pcolor), n) / 255 | 0));
      }
       while (inductionVariable < 256);
    var shadow = this_0.g3a();
    _this__u8e3s4.t3k(Colors_getInstance().q3b_1);
    _this__u8e3s4.w3k(shadow, x - r | 0, y - r | 0);
    _this__u8e3s4.w3k(copy, 0, 0);
    return _this__u8e3s4;
  }
  function Result(bmp, buffer, radius, cutoff) {
    this.s3q_1 = bmp;
    this.t3q_1 = buffer;
    this.u3q_1 = radius;
    this.v3q_1 = cutoff;
  }
  protoOf(Result).toString = function () {
    return 'Result(bmp=' + this.s3q_1 + ', buffer=' + this.t3q_1 + ', radius=' + this.u3q_1 + ', cutoff=' + this.v3q_1 + ')';
  };
  protoOf(Result).hashCode = function () {
    var result = hashCode(this.s3q_1);
    result = imul(result, 31) + this.t3q_1 | 0;
    result = imul(result, 31) + this.u3q_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.v3q_1) | 0;
    return result;
  };
  protoOf(Result).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.s3q_1, tmp0_other_with_cast.s3q_1))
      return false;
    if (!(this.t3q_1 === tmp0_other_with_cast.t3q_1))
      return false;
    if (!(this.u3q_1 === tmp0_other_with_cast.u3q_1))
      return false;
    if (!equals(this.v3q_1, tmp0_other_with_cast.v3q_1))
      return false;
    return true;
  };
  function NewSDF() {
    this.w3q_1 = 1.0E10;
  }
  protoOf(NewSDF).x3q = function (bmp, maxSide, buffer, radius, cutoff) {
    var size = maxSide + imul(buffer, 4) | 0;
    var out = new Bitmap32(bmp.t39_1 + imul(buffer, 2) | 0, bmp.u39_1 + imul(buffer, 2) | 0);
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = out.t39_1;
    var height = out.u39_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Float32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 1.0E10;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var gridOuter = new FloatArray2(width, height, isFloatArray(tmp_2) ? tmp_2 : THROW_CCE());
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width_0 = out.t39_1;
    var height_0 = out.u39_1;
    var tmp_3 = 0;
    var tmp_4 = imul(width_0, height_0);
    var tmp_5 = new Float32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      tmp_5[tmp_3] = 0.0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    var tmp_6 = tmp_5;
    var gridInner = new FloatArray2(width_0, height_0, isFloatArray(tmp_6) ? tmp_6 : THROW_CCE());
    var f = new Float32Array(size);
    var z = new Float32Array(size + 1 | 0);
    var v = _UShortArrayInt___init__impl__kdofb8(size);
    var inductionVariable = 0;
    var last = bmp.u39_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = bmp.t39_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = _RGBA___get_af__impl__vu36qv(bmp.k3k(x, y));
            var x0 = x + buffer | 0;
            var y0 = y + buffer | 0;
            switch (a) {
              case 0.0:
                gridOuter.k1r(x0, y0, 1.0E10);
                gridInner.k1r(x0, y0, 0.0);
                break;
              case 1.0:
                gridOuter.k1r(x0, y0, 0.0);
                gridInner.k1r(x0, y0, 1.0E10);
                break;
              default:
                var d = 0.5 - a;
                gridOuter.k1r(x0, y0, d > 0.0 ? d * d : 0.0);
                gridInner.k1r(x0, y0, d < 0.0 ? d * d : 0.0);
                break;
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    this.y3q(gridOuter.i1r_1, 0, 0, out.t39_1, out.u39_1, gridOuter.g1r_1, f, v, z);
    this.y3q(gridInner.i1r_1, buffer, buffer, bmp.t39_1, bmp.u39_1, gridInner.g1r_1, f, v, z);
    var inductionVariable_1 = 0;
    var last_1 = out.u39_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = out.t39_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var gout = gridOuter.c1r(x_0, y_0);
            var gin = gridInner.c1r(x_0, y_0);
            // Inline function 'kotlin.math.sqrt' call
            var tmp_7 = Math.sqrt(gout);
            // Inline function 'kotlin.math.sqrt' call
            var d_0 = tmp_7 - Math.sqrt(gin);
            var a_0 = toIntRound(255 - 255 * (d_0 / radius + cutoff));
            out.i3k(x_0, y_0, Companion_getInstance_26().r3q(255, 255, 255, clamp(a_0, 0, 255)));
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    return new Result(out, buffer, radius, cutoff);
  };
  protoOf(NewSDF).z3q = function (bmp, maxSide, buffer, radius, cutoff, $super) {
    var tmp;
    if (maxSide === VOID) {
      // Inline function 'kotlin.math.max' call
      var a = bmp.t39_1;
      var b = bmp.u39_1;
      tmp = Math.max(a, b);
    } else {
      tmp = maxSide;
    }
    maxSide = tmp;
    buffer = buffer === VOID ? divCeil(maxSide, 8) : buffer;
    radius = radius === VOID ? divCeil(maxSide, 3) : radius;
    cutoff = cutoff === VOID ? 0.5 : cutoff;
    return $super === VOID ? this.x3q(bmp, maxSide, buffer, radius, cutoff) : $super.x3q.call(this, bmp, maxSide, buffer, radius, cutoff);
  };
  protoOf(NewSDF).y3q = function (data, x0, y0, width, height, gridSize, f, v, z) {
    var inductionVariable = x0;
    var last = x0 + width | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.a3r(data, imul(y0, gridSize) + x | 0, gridSize, height, f, v, z);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = y0;
    var last_0 = y0 + height | 0;
    if (inductionVariable_0 < last_0)
      do {
        var y = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.a3r(data, imul(y, gridSize) + x0 | 0, 1, width, f, v, z);
      }
       while (inductionVariable_0 < last_0);
  };
  protoOf(NewSDF).a3r = function (grid, offset, stride, length, f, v, z) {
    UShortArrayInt__set_impl_38wgvc(v, 0, 0);
    z[0] = -1.0E10;
    z[1] = 1.0E10;
    f[0] = grid[offset];
    var k = 0;
    var s = 0.0;
    var inductionVariable = 1;
    if (inductionVariable < length)
      do {
        var q = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        f[q] = grid[offset + imul(q, stride) | 0];
        var q2 = imul(q, q);
        $l$1: do {
          $l$0: do {
            var r = UShortArrayInt__get_impl_ciz20k(v, k);
            s = (f[q] - f[r] + q2 - imul(r, r)) / (q - r | 0) / 2.0;
          }
           while (false);
          var tmp;
          if (s <= z[k]) {
            k = k - 1 | 0;
            tmp = k > -1;
          } else {
            tmp = false;
          }
        }
         while (tmp);
        k = k + 1 | 0;
        UShortArrayInt__set_impl_38wgvc(v, k, q);
        z[k] = s;
        z[k + 1 | 0] = 1.0E10;
      }
       while (inductionVariable < length);
    k = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < length)
      do {
        var q_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        while (z[k + 1 | 0] < q_0) {
          k = k + 1 | 0;
        }
        var r_0 = UShortArrayInt__get_impl_ciz20k(v, k);
        var qr = q_0 - r_0 | 0;
        grid[offset + imul(q_0, stride) | 0] = f[r_0] + imul(qr, qr);
      }
       while (inductionVariable_0 < length);
  };
  var NewSDF_instance;
  function NewSDF_getInstance() {
    return NewSDF_instance;
  }
  function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
    littleEndian = littleEndian === VOID ? true : littleEndian;
    var tmp;
    switch (_this__u8e3s4.b3r()) {
      case 16:
        var tmp_0;
        if (littleEndian) {
          tmp_0 = getU16LE$ref();
        } else {
          tmp_0 = getU16BE$ref();
        }

        tmp = tmp_0;
        break;
      case 24:
        var tmp_1;
        if (littleEndian) {
          tmp_1 = getU24LE$ref();
        } else {
          tmp_1 = getU24BE$ref();
        }

        tmp = tmp_1;
        break;
      case 32:
        var tmp_2;
        if (littleEndian) {
          tmp_2 = getS32LE$ref();
        } else {
          tmp_2 = getS32BE$ref();
        }

        tmp = tmp_2;
        break;
      default:
        throw IllegalArgumentException_init_$Create$('Unsupported bpp ' + _this__u8e3s4.b3r());
    }
    var readFunc = tmp;
    // Inline function 'korlibs.image.color.decodeInternal' call
    var io = dataOffset;
    var oo = outOffset;
    var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
    var outdata = out;
    var Bpp = numberToInt(bytesPerPixel);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = readFunc(data, io);
        io = io + Bpp | 0;
        var tmp1 = oo;
        oo = tmp1 + 1 | 0;
        RgbaArray__set_impl_epw2wg(outdata, tmp1, Companion_getInstance_26().r3q(_this__u8e3s4.c3r(c), _this__u8e3s4.d3r(c), _this__u8e3s4.e3r(c), _this__u8e3s4.f3r(c)));
      }
       while (inductionVariable < size);
  }
  function get_bytesPerPixel(_this__u8e3s4) {
    return _this__u8e3s4.b3r() / 8;
  }
  function ColorFormat32() {
    this.g3r_1 = 32;
  }
  protoOf(ColorFormat32).b3r = function () {
    return this.g3r_1;
  };
  function ColorFormat24() {
    this.h3r_1 = 24;
  }
  protoOf(ColorFormat24).b3r = function () {
    return this.h3r_1;
  };
  function getU16LE$ref() {
    var l = function (p0, p1) {
      return getU16LE(p0, p1);
    };
    l.callableName = 'getU16LE';
    return l;
  }
  function getU16BE$ref() {
    var l = function (p0, p1) {
      return getU16BE(p0, p1);
    };
    l.callableName = 'getU16BE';
    return l;
  }
  function getU24LE$ref() {
    var l = function (p0, p1) {
      return getU24LE(p0, p1);
    };
    l.callableName = 'getU24LE';
    return l;
  }
  function getU24BE$ref() {
    var l = function (p0, p1) {
      return getU24BE(p0, p1);
    };
    l.callableName = 'getU24BE';
    return l;
  }
  function getS32LE$ref() {
    var l = function (p0, p1) {
      return getS32LE(p0, p1);
    };
    l.callableName = 'getS32LE';
    return l;
  }
  function getS32BE$ref() {
    var l = function (p0, p1) {
      return getS32BE(p0, p1);
    };
    l.callableName = 'getS32BE';
    return l;
  }
  function ColorTransformMul(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.i3r_1 = _r;
    this.j3r_1 = _g;
    this.k3r_1 = _b;
    this.l3r_1 = _a;
    this.m3r_1 = true;
    this.n3r_1 = Colors_getInstance().l3b_1;
  }
  protoOf(ColorTransformMul).o3r = function () {
    return this.i3r_1;
  };
  protoOf(ColorTransformMul).p3r = function () {
    return this.j3r_1;
  };
  protoOf(ColorTransformMul).q3r = function () {
    return this.k3r_1;
  };
  protoOf(ColorTransformMul).r3r = function (value) {
    this.l3r_1 = value;
    this.m3r_1 = true;
  };
  protoOf(ColorTransformMul).s3r = function () {
    return this.l3r_1;
  };
  protoOf(ColorTransformMul).t3r = function (v) {
    this.u3r(_RGBA___get_rf__impl__kvz75k(v), _RGBA___get_gf__impl__5gcu1f(v), _RGBA___get_bf__impl__1xz5yg(v), _RGBA___get_af__impl__vu36qv(v));
    this.n3r_1 = v;
    this.m3r_1 = false;
  };
  protoOf(ColorTransformMul).v3r = function () {
    if (this.m3r_1) {
      this.m3r_1 = false;
      this.n3r_1 = Companion_getInstance_26().n3n(this.i3r_1, this.j3r_1, this.k3r_1, this.l3r_1);
    }
    return this.n3r_1;
  };
  protoOf(ColorTransformMul).u3r = function (r, g, b, a) {
    this.i3r_1 = r;
    this.j3r_1 = g;
    this.k3r_1 = b;
    this.l3r_1 = a;
    this.m3r_1 = true;
  };
  protoOf(ColorTransformMul).w3r = function (other) {
    return this.u3r(other.i3r_1, other.j3r_1, other.k3r_1, other.l3r_1);
  };
  protoOf(ColorTransformMul).x3r = function (a, b) {
    return this.u3r(a.o3r() * b.o3r(), a.p3r() * b.p3r(), a.q3r() * b.q3r(), a.s3r() * b.s3r());
  };
  protoOf(ColorTransformMul).toString = function () {
    return 'ColorTransformMul(_r=' + this.i3r_1 + ', _g=' + this.j3r_1 + ', _b=' + this.k3r_1 + ', _a=' + this.l3r_1 + ')';
  };
  protoOf(ColorTransformMul).hashCode = function () {
    var result = getNumberHashCode(this.i3r_1);
    result = imul(result, 31) + getNumberHashCode(this.j3r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k3r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l3r_1) | 0;
    return result;
  };
  protoOf(ColorTransformMul).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.i3r_1, tmp0_other_with_cast.i3r_1))
      return false;
    if (!equals(this.j3r_1, tmp0_other_with_cast.j3r_1))
      return false;
    if (!equals(this.k3r_1, tmp0_other_with_cast.k3r_1))
      return false;
    if (!equals(this.l3r_1, tmp0_other_with_cast.l3r_1))
      return false;
    return true;
  };
  function Colors() {
    Colors_instance = this;
    this.l3b_1 = Companion_getInstance_26().r3q(255, 255, 255, 255);
    this.m3b_1 = Companion_getInstance_26().r3q(0, 0, 0, 255);
    this.n3b_1 = Companion_getInstance_26().r3q(255, 0, 0, 255);
    this.o3b_1 = Companion_getInstance_26().r3q(0, 255, 0, 255);
    this.p3b_1 = Companion_getInstance_26().r3q(0, 0, 255, 255);
    this.q3b_1 = Companion_getInstance_26().r3q(0, 0, 0, 0);
    this.r3b_1 = Companion_getInstance_26().r3q(255, 255, 255, 0);
    this.s3b_1 = Companion_getInstance_26().y3r(240, 248, 255);
    this.t3b_1 = Companion_getInstance_26().y3r(250, 235, 215);
    this.u3b_1 = Companion_getInstance_26().y3r(0, 255, 255);
    this.v3b_1 = Companion_getInstance_26().y3r(127, 255, 212);
    this.w3b_1 = Companion_getInstance_26().y3r(240, 255, 255);
    this.x3b_1 = Companion_getInstance_26().y3r(245, 245, 220);
    this.y3b_1 = Companion_getInstance_26().y3r(255, 228, 196);
    this.z3b_1 = Companion_getInstance_26().y3r(255, 235, 205);
    this.a3c_1 = Companion_getInstance_26().y3r(138, 43, 226);
    this.b3c_1 = Companion_getInstance_26().y3r(165, 42, 42);
    this.c3c_1 = Companion_getInstance_26().y3r(222, 184, 135);
    this.d3c_1 = Companion_getInstance_26().y3r(95, 158, 160);
    this.e3c_1 = Companion_getInstance_26().y3r(127, 255, 0);
    this.f3c_1 = Companion_getInstance_26().y3r(210, 105, 30);
    this.g3c_1 = Companion_getInstance_26().y3r(255, 127, 80);
    this.h3c_1 = Companion_getInstance_26().y3r(100, 149, 237);
    this.i3c_1 = Companion_getInstance_26().y3r(255, 248, 220);
    this.j3c_1 = Companion_getInstance_26().y3r(220, 20, 60);
    this.k3c_1 = Companion_getInstance_26().y3r(0, 0, 139);
    this.l3c_1 = Companion_getInstance_26().y3r(0, 255, 255);
    this.m3c_1 = Companion_getInstance_26().y3r(0, 139, 139);
    this.n3c_1 = Companion_getInstance_26().y3r(184, 134, 11);
    this.o3c_1 = Companion_getInstance_26().y3r(169, 169, 169);
    this.p3c_1 = Companion_getInstance_26().y3r(0, 100, 0);
    this.q3c_1 = Companion_getInstance_26().y3r(169, 169, 169);
    this.r3c_1 = Companion_getInstance_26().y3r(189, 183, 107);
    this.s3c_1 = Companion_getInstance_26().y3r(255, 0, 255);
    this.t3c_1 = Companion_getInstance_26().y3r(139, 0, 139);
    this.u3c_1 = Companion_getInstance_26().y3r(85, 107, 47);
    this.v3c_1 = Companion_getInstance_26().y3r(255, 140, 0);
    this.w3c_1 = Companion_getInstance_26().y3r(153, 50, 204);
    this.x3c_1 = Companion_getInstance_26().y3r(139, 0, 0);
    this.y3c_1 = Companion_getInstance_26().y3r(233, 150, 122);
    this.z3c_1 = Companion_getInstance_26().y3r(143, 188, 143);
    this.a3d_1 = Companion_getInstance_26().y3r(72, 61, 139);
    this.b3d_1 = Companion_getInstance_26().y3r(47, 79, 79);
    this.c3d_1 = Companion_getInstance_26().y3r(47, 79, 79);
    this.d3d_1 = Companion_getInstance_26().y3r(0, 206, 209);
    this.e3d_1 = Companion_getInstance_26().y3r(148, 0, 211);
    this.f3d_1 = Companion_getInstance_26().y3r(255, 20, 147);
    this.g3d_1 = Companion_getInstance_26().y3r(0, 191, 255);
    this.h3d_1 = Companion_getInstance_26().y3r(105, 105, 105);
    this.i3d_1 = Companion_getInstance_26().y3r(105, 105, 105);
    this.j3d_1 = Companion_getInstance_26().y3r(30, 144, 255);
    this.k3d_1 = Companion_getInstance_26().y3r(178, 34, 34);
    this.l3d_1 = Companion_getInstance_26().y3r(255, 250, 240);
    this.m3d_1 = Companion_getInstance_26().y3r(34, 139, 34);
    this.n3d_1 = Companion_getInstance_26().y3r(255, 0, 255);
    this.o3d_1 = Companion_getInstance_26().y3r(220, 220, 220);
    this.p3d_1 = Companion_getInstance_26().y3r(248, 248, 255);
    this.q3d_1 = Companion_getInstance_26().y3r(255, 215, 0);
    this.r3d_1 = Companion_getInstance_26().y3r(218, 165, 32);
    this.s3d_1 = Companion_getInstance_26().y3r(173, 255, 47);
    this.t3d_1 = Companion_getInstance_26().y3r(240, 255, 240);
    this.u3d_1 = Companion_getInstance_26().y3r(255, 105, 180);
    this.v3d_1 = Companion_getInstance_26().y3r(205, 92, 92);
    this.w3d_1 = Companion_getInstance_26().y3r(75, 0, 130);
    this.x3d_1 = Companion_getInstance_26().y3r(255, 255, 240);
    this.y3d_1 = Companion_getInstance_26().y3r(240, 230, 140);
    this.z3d_1 = Companion_getInstance_26().y3r(230, 230, 250);
    this.a3e_1 = Companion_getInstance_26().y3r(255, 240, 245);
    this.b3e_1 = Companion_getInstance_26().y3r(124, 252, 0);
    this.c3e_1 = Companion_getInstance_26().y3r(255, 250, 205);
    this.d3e_1 = Companion_getInstance_26().y3r(173, 216, 230);
    this.e3e_1 = Companion_getInstance_26().y3r(240, 128, 128);
    this.f3e_1 = Companion_getInstance_26().y3r(224, 255, 255);
    this.g3e_1 = Companion_getInstance_26().y3r(250, 250, 210);
    this.h3e_1 = Companion_getInstance_26().y3r(211, 211, 211);
    this.i3e_1 = Companion_getInstance_26().y3r(144, 238, 144);
    this.j3e_1 = Companion_getInstance_26().y3r(211, 211, 211);
    this.k3e_1 = Companion_getInstance_26().y3r(255, 182, 193);
    this.l3e_1 = Companion_getInstance_26().y3r(255, 160, 122);
    this.m3e_1 = Companion_getInstance_26().y3r(32, 178, 170);
    this.n3e_1 = Companion_getInstance_26().y3r(135, 206, 250);
    this.o3e_1 = Companion_getInstance_26().y3r(119, 136, 153);
    this.p3e_1 = Companion_getInstance_26().y3r(119, 136, 153);
    this.q3e_1 = Companion_getInstance_26().y3r(176, 196, 222);
    this.r3e_1 = Companion_getInstance_26().y3r(255, 255, 224);
    this.s3e_1 = Companion_getInstance_26().y3r(0, 255, 0);
    this.t3e_1 = Companion_getInstance_26().y3r(50, 205, 50);
    this.u3e_1 = Companion_getInstance_26().y3r(250, 240, 230);
    this.v3e_1 = Companion_getInstance_26().y3r(128, 0, 0);
    this.w3e_1 = Companion_getInstance_26().y3r(102, 205, 170);
    this.x3e_1 = Companion_getInstance_26().y3r(0, 0, 205);
    this.y3e_1 = Companion_getInstance_26().y3r(186, 85, 211);
    this.z3e_1 = Companion_getInstance_26().y3r(147, 112, 219);
    this.a3f_1 = Companion_getInstance_26().y3r(60, 179, 113);
    this.b3f_1 = Companion_getInstance_26().y3r(123, 104, 238);
    this.c3f_1 = Companion_getInstance_26().y3r(0, 250, 154);
    this.d3f_1 = Companion_getInstance_26().y3r(72, 209, 204);
    this.e3f_1 = Companion_getInstance_26().y3r(199, 21, 133);
    this.f3f_1 = Companion_getInstance_26().y3r(25, 25, 112);
    this.g3f_1 = Companion_getInstance_26().y3r(245, 255, 250);
    this.h3f_1 = Companion_getInstance_26().y3r(255, 228, 225);
    this.i3f_1 = Companion_getInstance_26().y3r(255, 228, 181);
    this.j3f_1 = Companion_getInstance_26().y3r(255, 222, 173);
    this.k3f_1 = Companion_getInstance_26().y3r(0, 0, 128);
    this.l3f_1 = Companion_getInstance_26().y3r(253, 245, 230);
    this.m3f_1 = Companion_getInstance_26().y3r(128, 128, 0);
    this.n3f_1 = Companion_getInstance_26().y3r(107, 142, 35);
    this.o3f_1 = Companion_getInstance_26().y3r(255, 165, 0);
    this.p3f_1 = Companion_getInstance_26().y3r(255, 69, 0);
    this.q3f_1 = Companion_getInstance_26().y3r(218, 112, 214);
    this.r3f_1 = Companion_getInstance_26().y3r(238, 232, 170);
    this.s3f_1 = Companion_getInstance_26().y3r(152, 251, 152);
    this.t3f_1 = Companion_getInstance_26().y3r(175, 238, 238);
    this.u3f_1 = Companion_getInstance_26().y3r(219, 112, 147);
    this.v3f_1 = Companion_getInstance_26().y3r(255, 239, 213);
    this.w3f_1 = Companion_getInstance_26().y3r(255, 218, 185);
    this.x3f_1 = Companion_getInstance_26().y3r(205, 133, 63);
    this.y3f_1 = Companion_getInstance_26().y3r(255, 192, 203);
    this.z3f_1 = Companion_getInstance_26().y3r(221, 160, 221);
    this.a3g_1 = Companion_getInstance_26().y3r(176, 224, 230);
    this.b3g_1 = Companion_getInstance_26().y3r(128, 0, 128);
    this.c3g_1 = Companion_getInstance_26().y3r(188, 143, 143);
    this.d3g_1 = Companion_getInstance_26().y3r(65, 105, 225);
    this.e3g_1 = Companion_getInstance_26().y3r(139, 69, 19);
    this.f3g_1 = Companion_getInstance_26().y3r(250, 128, 114);
    this.g3g_1 = Companion_getInstance_26().y3r(244, 164, 96);
    this.h3g_1 = Companion_getInstance_26().y3r(46, 139, 87);
    this.i3g_1 = Companion_getInstance_26().y3r(255, 245, 238);
    this.j3g_1 = Companion_getInstance_26().y3r(160, 82, 45);
    this.k3g_1 = Companion_getInstance_26().y3r(192, 192, 192);
    this.l3g_1 = Companion_getInstance_26().y3r(135, 206, 235);
    this.m3g_1 = Companion_getInstance_26().y3r(106, 90, 205);
    this.n3g_1 = Companion_getInstance_26().y3r(112, 128, 144);
    this.o3g_1 = Companion_getInstance_26().y3r(112, 128, 144);
    this.p3g_1 = Companion_getInstance_26().y3r(255, 250, 250);
    this.q3g_1 = Companion_getInstance_26().y3r(0, 255, 127);
    this.r3g_1 = Companion_getInstance_26().y3r(70, 130, 180);
    this.s3g_1 = Companion_getInstance_26().y3r(210, 180, 140);
    this.t3g_1 = Companion_getInstance_26().y3r(0, 128, 128);
    this.u3g_1 = Companion_getInstance_26().y3r(216, 191, 216);
    this.v3g_1 = Companion_getInstance_26().y3r(255, 99, 71);
    this.w3g_1 = Companion_getInstance_26().y3r(64, 224, 208);
    this.x3g_1 = Companion_getInstance_26().y3r(238, 130, 238);
    this.y3g_1 = Companion_getInstance_26().y3r(245, 222, 179);
    this.z3g_1 = Companion_getInstance_26().y3r(245, 245, 245);
    this.a3h_1 = Companion_getInstance_26().y3r(154, 205, 50);
    this.b3h_1 = Companion_getInstance_26().y3r(255, 255, 0);
    this.c3h_1 = mapOf([to('black', new RGBA(this.m3b_1)), to('white', new RGBA(this.l3b_1)), to('red', new RGBA(this.n3b_1)), to('green', new RGBA(this.o3b_1)), to('blue', new RGBA(this.p3b_1)), to('aliceblue', new RGBA(this.s3b_1)), to('antiquewhite', new RGBA(this.t3b_1)), to('aqua', new RGBA(this.u3b_1)), to('aquamarine', new RGBA(this.v3b_1)), to('azure', new RGBA(this.w3b_1)), to('beige', new RGBA(this.x3b_1)), to('bisque', new RGBA(this.y3b_1)), to('blanchedalmond', new RGBA(this.z3b_1)), to('blueviolet', new RGBA(this.a3c_1)), to('brown', new RGBA(this.b3c_1)), to('burlywood', new RGBA(this.c3c_1)), to('cadetblue', new RGBA(this.d3c_1)), to('chartreuse', new RGBA(this.e3c_1)), to('chocolate', new RGBA(this.f3c_1)), to('coral', new RGBA(this.g3c_1)), to('cornflowerblue', new RGBA(this.h3c_1)), to('cornsilk', new RGBA(this.i3c_1)), to('crimson', new RGBA(this.j3c_1)), to('cyan', new RGBA(this.l3c_1)), to('darkblue', new RGBA(this.k3c_1)), to('darkcyan', new RGBA(this.m3c_1)), to('darkgoldenrod', new RGBA(this.n3c_1)), to('darkgray', new RGBA(this.o3c_1)), to('darkgreen', new RGBA(this.p3c_1)), to('darkgrey', new RGBA(this.q3c_1)), to('darkkhaki', new RGBA(this.r3c_1)), to('darkmagenta', new RGBA(this.t3c_1)), to('darkolivegreen', new RGBA(this.u3c_1)), to('darkorange', new RGBA(this.v3c_1)), to('darkorchid', new RGBA(this.w3c_1)), to('darkred', new RGBA(this.x3c_1)), to('darksalmon', new RGBA(this.y3c_1)), to('darkseagreen', new RGBA(this.z3c_1)), to('darkslateblue', new RGBA(this.a3d_1)), to('darkslategray', new RGBA(this.b3d_1)), to('darkslategrey', new RGBA(this.c3d_1)), to('darkturquoise', new RGBA(this.d3d_1)), to('darkviolet', new RGBA(this.e3d_1)), to('deeppink', new RGBA(this.f3d_1)), to('deepskyblue', new RGBA(this.g3d_1)), to('dimgray', new RGBA(this.h3d_1)), to('dimgrey', new RGBA(this.i3d_1)), to('dodgerblue', new RGBA(this.j3d_1)), to('firebrick', new RGBA(this.k3d_1)), to('floralwhite', new RGBA(this.l3d_1)), to('forestgreen', new RGBA(this.m3d_1)), to('fuchsia', new RGBA(this.n3d_1)), to('gainsboro', new RGBA(this.o3d_1)), to('ghostwhite', new RGBA(this.p3d_1)), to('gold', new RGBA(this.q3d_1)), to('goldenrod', new RGBA(this.r3d_1)), to('greenyellow', new RGBA(this.s3d_1)), to('honeydew', new RGBA(this.t3d_1)), to('hotpink', new RGBA(this.u3d_1)), to('indianred', new RGBA(this.v3d_1)), to('indigo', new RGBA(this.w3d_1)), to('ivory', new RGBA(this.x3d_1)), to('khaki', new RGBA(this.y3d_1)), to('lavender', new RGBA(this.z3d_1)), to('lavenderblush', new RGBA(this.a3e_1)), to('lawngreen', new RGBA(this.b3e_1)), to('lemonchiffon', new RGBA(this.c3e_1)), to('lightblue', new RGBA(this.d3e_1)), to('lightcoral', new RGBA(this.e3e_1)), to('lightcyan', new RGBA(this.f3e_1)), to('lightgoldenrodyellow', new RGBA(this.g3e_1)), to('lightgray', new RGBA(this.h3e_1)), to('lightgreen', new RGBA(this.i3e_1)), to('lightgrey', new RGBA(this.j3e_1)), to('lightpink', new RGBA(this.k3e_1)), to('lightsalmon', new RGBA(this.l3e_1)), to('lightseagreen', new RGBA(this.m3e_1)), to('lightskyblue', new RGBA(this.n3e_1)), to('lightslategray', new RGBA(this.o3e_1)), to('lightslategrey', new RGBA(this.p3e_1)), to('lightsteelblue', new RGBA(this.q3e_1)), to('lightyellow', new RGBA(this.r3e_1)), to('lime', new RGBA(this.s3e_1)), to('limegreen', new RGBA(this.t3e_1)), to('linen', new RGBA(this.u3e_1)), to('magenta', new RGBA(this.s3c_1)), to('maroon', new RGBA(this.v3e_1)), to('mediumaquamarine', new RGBA(this.w3e_1)), to('mediumblue', new RGBA(this.x3e_1)), to('mediumorchid', new RGBA(this.y3e_1)), to('mediumpurple', new RGBA(this.z3e_1)), to('mediumseagreen', new RGBA(this.a3f_1)), to('mediumslateblue', new RGBA(this.b3f_1)), to('mediumspringgreen', new RGBA(this.c3f_1)), to('mediumturquoise', new RGBA(this.d3f_1)), to('mediumvioletred', new RGBA(this.e3f_1)), to('midnightblue', new RGBA(this.f3f_1)), to('mintcream', new RGBA(this.g3f_1)), to('mistyrose', new RGBA(this.h3f_1)), to('moccasin', new RGBA(this.i3f_1)), to('navajowhite', new RGBA(this.j3f_1)), to('navy', new RGBA(this.k3f_1)), to('oldlace', new RGBA(this.l3f_1)), to('olive', new RGBA(this.m3f_1)), to('olivedrab', new RGBA(this.n3f_1)), to('orange', new RGBA(this.o3f_1)), to('orangered', new RGBA(this.p3f_1)), to('orchid', new RGBA(this.q3f_1)), to('palegoldenrod', new RGBA(this.r3f_1)), to('palegreen', new RGBA(this.s3f_1)), to('paleturquoise', new RGBA(this.t3f_1)), to('palevioletred', new RGBA(this.u3f_1)), to('papayawhip', new RGBA(this.v3f_1)), to('peachpuff', new RGBA(this.w3f_1)), to('peru', new RGBA(this.x3f_1)), to('pink', new RGBA(this.y3f_1)), to('plum', new RGBA(this.z3f_1)), to('powderblue', new RGBA(this.a3g_1)), to('purple', new RGBA(this.b3g_1)), to('rosybrown', new RGBA(this.c3g_1)), to('royalblue', new RGBA(this.d3g_1)), to('saddlebrown', new RGBA(this.e3g_1)), to('salmon', new RGBA(this.f3g_1)), to('sandybrown', new RGBA(this.g3g_1)), to('seagreen', new RGBA(this.h3g_1)), to('seashell', new RGBA(this.i3g_1)), to('sienna', new RGBA(this.j3g_1)), to('silver', new RGBA(this.k3g_1)), to('skyblue', new RGBA(this.l3g_1)), to('slateblue', new RGBA(this.m3g_1)), to('slategray', new RGBA(this.n3g_1)), to('slategrey', new RGBA(this.o3g_1)), to('snow', new RGBA(this.p3g_1)), to('springgreen', new RGBA(this.q3g_1)), to('steelblue', new RGBA(this.r3g_1)), to('tan', new RGBA(this.s3g_1)), to('teal', new RGBA(this.t3g_1)), to('thistle', new RGBA(this.u3g_1)), to('tomato', new RGBA(this.v3g_1)), to('turquoise', new RGBA(this.w3g_1)), to('violet', new RGBA(this.x3g_1)), to('wheat', new RGBA(this.y3g_1)), to('whitesmoke', new RGBA(this.z3g_1)), to('yellowgreen', new RGBA(this.a3h_1)), to('yellow', new RGBA(this.b3h_1))]);
  }
  protoOf(Colors).z3r = function (str) {
    return this.a3s(str, this.q3b_1, true);
  };
  protoOf(Colors).a3s = function (str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr(str, 1);
        if (!setOf([3, 4, 6, 8]).z(hex.length))
          return this.m3b_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 17.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt(substr_0(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt(substr_0(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt(substr_0(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt(substr_0(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_26().r3q(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = str.toUpperCase();
        var parts = split(removeSuffix(removePrefix(tmp$ret$1, 'RGBA('), ')'), [',']);
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp;
        if (0 >= 0 ? 0 <= get_lastIndex(parts) : false) {
          tmp = parts.f1(0);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp = '0';
        }
        var tmp$ret$3 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$3);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp_0;
        if (1 >= 0 ? 1 <= get_lastIndex(parts) : false) {
          tmp_0 = parts.f1(1);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_0 = '0';
        }
        var tmp$ret$5 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$5);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp_1;
        if (2 >= 0 ? 2 <= get_lastIndex(parts) : false) {
          tmp_1 = parts.f1(2);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_1 = '0';
        }
        var tmp$ret$7 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$7);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp_2;
        if (3 >= 0 ? 3 <= get_lastIndex(parts) : false) {
          tmp_2 = parts.f1(3);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_2 = '1.0';
        }
        var tmp$ret$9 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$9);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_26().r3q(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = str.toLowerCase();
        var tmp_3 = this.c3h_1.s2(tmp$ret$11);
        var col = tmp_3 == null ? null : tmp_3.b3s_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.c3s('#' + str, default_0);
        var tmp_6;
        var tmp_7 = col;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = col;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().n3b_1;
      } else {
        throw $p;
      }
    }
  };
  protoOf(Colors).c3s = function (str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.a3s(str, default_0, errorOnDefault) : $super.a3s.call(this, str, new RGBA(default_0), errorOnDefault).b3s_1;
  };
  var Colors_instance;
  function Colors_getInstance() {
    if (Colors_instance == null)
      new Colors();
    return Colors_instance;
  }
  function Companion_9() {
    Companion_instance_17 = this;
    RGB.call(this, 0, 8, 16);
  }
  var Companion_instance_17;
  function Companion_getInstance_24() {
    if (Companion_instance_17 == null)
      new Companion_9();
    return Companion_instance_17;
  }
  function RGB(rOffset, gOffset, bOffset) {
    Companion_getInstance_24();
    ColorFormat24.call(this);
    this.e3s_1 = rOffset;
    this.f3s_1 = gOffset;
    this.g3s_1 = bOffset;
  }
  protoOf(RGB).c3r = function (v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.e3s_1 | 0) & 255;
  };
  protoOf(RGB).d3r = function (v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.f3s_1 | 0) & 255;
  };
  protoOf(RGB).e3r = function (v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.g3s_1 | 0) & 255;
  };
  protoOf(RGB).f3r = function (v) {
    return 255;
  };
  function _RgbaArray___init__impl__oib4y4(ints) {
    return ints;
  }
  function _RgbaArray___get_ints__impl__u2kps1($this) {
    return $this;
  }
  function Companion_10() {
  }
  protoOf(Companion_10).i3l = function (size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  };
  var Companion_instance_18;
  function Companion_getInstance_25() {
    return Companion_instance_18;
  }
  function RgbaArray__subList_impl_rbyi98($this, fromIndex, toIndex) {
    return new GenericSubList(new RgbaArray($this), fromIndex, toIndex);
  }
  function RgbaArray__contains_impl_ofn00n($this, element) {
    return contains(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
  }
  function RgbaArray__containsAll_impl_l6gz5c($this, elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.b1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x().b3s_1;
        // Inline function 'korlibs.image.color.RgbaArray.containsAll.<anonymous>' call
        if (!RgbaArray__contains_impl_ofn00n($this, element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  function RgbaArray__containsAll_impl_l6gz5c_0($this, elements) {
    return RgbaArray__containsAll_impl_l6gz5c($this.h3s_1, elements);
  }
  function RgbaArray__isEmpty_impl_nch3ip($this) {
    // Inline function 'kotlin.collections.isEmpty' call
    return _RgbaArray___get_ints__impl__u2kps1($this).length === 0;
  }
  function RgbaArray__iterator_impl_5wfwsm($this) {
    return RgbaArray__listIterator_impl_m4kjt0($this, 0);
  }
  function RgbaArray__listIterator_impl_m4kjt0($this, index) {
    return new GenericListIterator(new RgbaArray($this), index);
  }
  function _RgbaArray___get_size__impl__imxef8($this) {
    return _RgbaArray___get_ints__impl__u2kps1($this).length;
  }
  function RgbaArray__get_impl_nzyo1o($this, index) {
    return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
  }
  function RgbaArray__get_impl_nzyo1o_0($this, index) {
    return new RGBA(RgbaArray__get_impl_nzyo1o($this.h3s_1, index));
  }
  function RgbaArray__set_impl_epw2wg($this, index, color) {
    _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
  }
  function RgbaArray__toString_impl_vgvk04($this) {
    return 'RgbaArray(' + _RgbaArray___get_size__impl__imxef8($this) + ')';
  }
  function RgbaArray__hashCode_impl_ht2l65($this) {
    return hashCode($this);
  }
  function RgbaArray__equals_impl_6qvuf($this, other) {
    if (!(other instanceof RgbaArray))
      return false;
    var tmp0_other_with_cast = other instanceof RgbaArray ? other.h3s_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function RgbaArray(ints) {
    this.h3s_1 = ints;
  }
  protoOf(RgbaArray).x1 = function (fromIndex, toIndex) {
    return RgbaArray__subList_impl_rbyi98(this.h3s_1, fromIndex, toIndex);
  };
  protoOf(RgbaArray).i3s = function (elements) {
    return RgbaArray__containsAll_impl_l6gz5c(this.h3s_1, elements);
  };
  protoOf(RgbaArray).a1 = function (elements) {
    return RgbaArray__containsAll_impl_l6gz5c_0(this, elements);
  };
  protoOf(RgbaArray).b1 = function () {
    return RgbaArray__isEmpty_impl_nch3ip(this.h3s_1);
  };
  protoOf(RgbaArray).u = function () {
    return RgbaArray__iterator_impl_5wfwsm(this.h3s_1);
  };
  protoOf(RgbaArray).w1 = function (index) {
    return RgbaArray__listIterator_impl_m4kjt0(this.h3s_1, index);
  };
  protoOf(RgbaArray).n = function () {
    return _RgbaArray___get_size__impl__imxef8(this.h3s_1);
  };
  protoOf(RgbaArray).j3s = function (index) {
    return RgbaArray__get_impl_nzyo1o(this.h3s_1, index);
  };
  protoOf(RgbaArray).f1 = function (index) {
    return RgbaArray__get_impl_nzyo1o_0(this, index);
  };
  protoOf(RgbaArray).toString = function () {
    return RgbaArray__toString_impl_vgvk04(this.h3s_1);
  };
  protoOf(RgbaArray).hashCode = function () {
    return RgbaArray__hashCode_impl_ht2l65(this.h3s_1);
  };
  protoOf(RgbaArray).equals = function (other) {
    return RgbaArray__equals_impl_6qvuf(this.h3s_1, other);
  };
  function blendComponent($this, c1, c2, factor) {
    return numberToInt(c1 * (1.0 - Ratio__toFloat_impl_1ftup5(factor)) + c2 * Ratio__toFloat_impl_1ftup5(factor)) & 255;
  }
  function _RGBA___init__impl__lqpay5(value) {
    return value;
  }
  function _RGBA___get_value__impl__hhco8v($this) {
    return $this;
  }
  function RGBA__clone_impl_w007z0($this) {
    return new RGBA($this);
  }
  function _RGBA___get_color__impl__8x3sb3($this) {
    return $this;
  }
  function _RGBA___get_r__impl__duz7mo($this) {
    // Inline function 'korlibs.memory.extract8' call
    return (_RGBA___get_value__impl__hhco8v($this) >>> 0 | 0) & 255;
  }
  function _RGBA___get_g__impl__o8pukr($this) {
    // Inline function 'korlibs.memory.extract8' call
    return (_RGBA___get_value__impl__hhco8v($this) >>> 8 | 0) & 255;
  }
  function _RGBA___get_b__impl__m6tl80($this) {
    // Inline function 'korlibs.memory.extract8' call
    return (_RGBA___get_value__impl__hhco8v($this) >>> 16 | 0) & 255;
  }
  function _RGBA___get_a__impl__6msvu7($this) {
    // Inline function 'korlibs.memory.extract8' call
    return (_RGBA___get_value__impl__hhco8v($this) >>> 24 | 0) & 255;
  }
  function _RGBA___get_rf__impl__kvz75k($this) {
    return _RGBA___get_r__impl__duz7mo($this) / 255.0;
  }
  function _RGBA___get_gf__impl__5gcu1f($this) {
    return _RGBA___get_g__impl__o8pukr($this) / 255.0;
  }
  function _RGBA___get_bf__impl__1xz5yg($this) {
    return _RGBA___get_b__impl__m6tl80($this) / 255.0;
  }
  function _RGBA___get_af__impl__vu36qv($this) {
    return _RGBA___get_a__impl__6msvu7($this) / 255.0;
  }
  function _RGBA___get_rgb__impl__tijaqt($this) {
    return _RGBA___get_value__impl__hhco8v($this) & 16777215;
  }
  function RGBA__withA_impl_vogscm($this, v) {
    return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v($this) & 16777215 | clampUByte(v) << 24);
  }
  function RGBA__withAf_impl_dpdu32($this, v) {
    return RGBA__withA_impl_vogscm($this, f2i(v));
  }
  function RGBA__concatAd_impl_gwhfm($this, v) {
    return RGBA__withA_impl_vogscm($this, numberToInt(_RGBA___get_a__impl__6msvu7($this) * v));
  }
  function _RGBA___get_hexString__impl__kocngm($this) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.color.RGBA.<get-hexString>.<anonymous>' call
    this_0.v5(_Char___init__impl__6a9atx(35));
    appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
    appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
    appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
    appendHexByte(this_0, _RGBA___get_a__impl__6msvu7($this));
    return this_0.toString();
  }
  function _RGBA___get_hexStringNoAlpha__impl__j315et($this) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.color.RGBA.<get-hexStringNoAlpha>.<anonymous>' call
    this_0.v5(_Char___init__impl__6a9atx(35));
    appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
    appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
    appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
    return this_0.toString();
  }
  function _RGBA___get_htmlColor__impl__bzw5k6($this) {
    return 'rgba(' + _RGBA___get_r__impl__duz7mo($this) + ', ' + _RGBA___get_g__impl__o8pukr($this) + ', ' + _RGBA___get_b__impl__m6tl80($this) + ', ' + get_niceStr(_RGBA___get_af__impl__vu36qv($this)) + ')';
  }
  function _RGBA___get_htmlStringSimple__impl__l4nu0u($this) {
    return _RGBA___get_hexStringNoAlpha__impl__j315et($this);
  }
  function RGBA__toString_impl_4lw6dp($this) {
    return _RGBA___get_hexString__impl__kocngm($this);
  }
  function RGBA__compareTo_impl_lrfjc1($this, other) {
    return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
  }
  function RGBA__compareTo_impl_lrfjc1_0($this, other) {
    return RGBA__compareTo_impl_lrfjc1($this.b3s_1, other instanceof RGBA ? other.b3s_1 : THROW_CCE());
  }
  function RGBA__premultipliedValue_impl_oja55q($this, premultiplied) {
    return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($this)) : _RGBA___get_value__impl__hhco8v($this);
  }
  function _RGBA___get_premultiplied__impl__3bulqc($this) {
    return _RGBA___get_premultipliedFast__impl__qiau4g($this);
  }
  function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
    var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
    if (A >= 255)
      return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
    if (A <= 1)
      return _RGBAPremultiplied___init__impl__uos02x(0);
    var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
    var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
  }
  function Companion_11() {
    Companion_instance_19 = this;
    ColorFormat32.call(this);
    this.h3h_1 = 0;
    this.i3h_1 = 8;
    this.j3h_1 = 16;
    this.k3h_1 = 24;
  }
  protoOf(Companion_11).n3n = function (r, g, b, a) {
    return this.k3s(f2i(r), f2i(g), f2i(b), f2i(a));
  };
  protoOf(Companion_11).k3s = function (r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  };
  protoOf(Companion_11).r3q = function (r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  };
  protoOf(Companion_11).y3r = function (r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  };
  protoOf(Companion_11).l3s = function (rgb, a) {
    return _RGBA___init__impl__lqpay5(rgb & 16777215 | a << 24);
  };
  protoOf(Companion_11).c3r = function (v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  };
  protoOf(Companion_11).d3r = function (v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  };
  protoOf(Companion_11).e3r = function (v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  };
  protoOf(Companion_11).f3r = function (v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  };
  protoOf(Companion_11).m3s = function (c1, c2, factor256) {
    return _RGBA___init__impl__lqpay5(this.n3s(_RGBA___get_value__impl__hhco8v(c1), _RGBA___get_value__impl__hhco8v(c2), factor256));
  };
  protoOf(Companion_11).n3s = function (c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8 | 0;
  };
  protoOf(Companion_11).o3s = function (c1, c2, factor) {
    return this.m3s(c1, c2, numberToInt(Ratio__toFloat_impl_1ftup5(factor) * 256));
  };
  protoOf(Companion_11).p3s = function (c1, c2, factor) {
    return Companion_getInstance_26().l3s(_RGBA___get_rgb__impl__tijaqt(this.o3s(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2), factor));
  };
  protoOf(Companion_11).l3h = function (c00, c10, c01, c11, factorX, factorY) {
    var c1 = this.p3s(c00, c10, factorX);
    var c2 = this.p3s(c01, c11, factorX);
    return this.p3s(c1, c2, factorY);
  };
  protoOf(Companion_11).q3q = function (dst, src) {
    var srcA = _RGBA___get_a__impl__6msvu7(src);
    var iSrcA = 255 - srcA | 0;
    switch (srcA) {
      case 0:
        return dst;
      case 255:
        return src;
      default:
        return Companion_getInstance_26().l3s(_RGBA___get_rgb__impl__tijaqt(this.m3s(dst, src, srcA + 1 | 0)), clampUByte(srcA + (imul(_RGBA___get_a__impl__6msvu7(dst), iSrcA) / 255 | 0) | 0));
    }
  };
  protoOf(Companion_11).q3s = function (src, dst, ratio) {
    return Companion_getInstance_26().r3q(interpolate(ratio, _RGBA___get_r__impl__duz7mo(src), _RGBA___get_r__impl__duz7mo(dst)), interpolate(ratio, _RGBA___get_g__impl__o8pukr(src), _RGBA___get_g__impl__o8pukr(dst)), interpolate(ratio, _RGBA___get_b__impl__m6tl80(src), _RGBA___get_b__impl__m6tl80(dst)), interpolate(ratio, _RGBA___get_a__impl__6msvu7(src), _RGBA___get_a__impl__6msvu7(dst)));
  };
  var Companion_instance_19;
  function Companion_getInstance_26() {
    if (Companion_instance_19 == null)
      new Companion_11();
    return Companion_instance_19;
  }
  function RGBA__hashCode_impl_h59qf6($this) {
    return $this;
  }
  function RGBA__equals_impl_4vjmca($this, other) {
    if (!(other instanceof RGBA))
      return false;
    if (!($this === (other instanceof RGBA ? other.b3s_1 : THROW_CCE())))
      return false;
    return true;
  }
  function RGBA(value) {
    Companion_getInstance_26();
    this.b3s_1 = value;
  }
  protoOf(RGBA).g1s = function () {
    return RGBA__clone_impl_w007z0(this.b3s_1);
  };
  protoOf(RGBA).toString = function () {
    return RGBA__toString_impl_4lw6dp(this.b3s_1);
  };
  protoOf(RGBA).r3s = function (other) {
    return RGBA__compareTo_impl_lrfjc1(this.b3s_1, other);
  };
  protoOf(RGBA).d = function (other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  };
  protoOf(RGBA).hashCode = function () {
    return RGBA__hashCode_impl_h59qf6(this.b3s_1);
  };
  protoOf(RGBA).equals = function (other) {
    return RGBA__equals_impl_4vjmca(this.b3s_1, other);
  };
  function _RGBAPremultiplied___init__impl__uos02x(value) {
    return value;
  }
  function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
    return $this;
  }
  function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
    return _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
  }
  function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
    return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
  }
  function _RGBAPremultiplied___get_g__impl__fv131x($this) {
    return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
  }
  function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
    return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
  }
  function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
    return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
  }
  function _RGBAPremultiplied___get_rf__impl__pt0c4y($this) {
    return _RGBAPremultiplied___get_r__impl__m8nz5i($this) / 255.0;
  }
  function _RGBAPremultiplied___get_gf__impl__ivron7($this) {
    return _RGBAPremultiplied___get_g__impl__fv131x($this) / 255.0;
  }
  function _RGBAPremultiplied___get_bf__impl__qa3on2($this) {
    return _RGBAPremultiplied___get_b__impl__dt4tp6($this) / 255.0;
  }
  function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
    return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
  }
  function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
    var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
    var tmp;
    if (alpha === 0) {
      tmp = Colors_getInstance().q3b_1;
    } else {
      var ialpha = 255.0 / alpha;
      tmp = Companion_getInstance_26().r3q(numberToInt(_RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha), numberToInt(_RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha), numberToInt(_RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha), alpha);
    }
    return tmp;
  }
  function RGBAPremultiplied__scaled256_impl_hjm9ii($this, s) {
    var rb = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 16711935, s) >>> 8 | 0) & 16711935;
    var g = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 65280, s) >>> 8 | 0) & 65280;
    var a = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0, s) >>> 8 | 0) << 24;
    return _RGBAPremultiplied___init__impl__uos02x(rb | g | a);
  }
  function RGBAPremultiplied__scaled_impl_qz7lg1($this, alpha) {
    return RGBAPremultiplied__scaled256_impl_hjm9ii($this, numberToInt(clamp01_0(alpha) * 256));
  }
  function Companion_12() {
    this.s3s_1 = 16711935;
    this.t3s_1 = -16711936;
  }
  protoOf(Companion_12).u3s = function (dst, src) {
    return _RGBAPremultiplied___init__impl__uos02x(sumPacked4MulR(_RGBAPremultiplied___get_value__impl__bqfhud(src), _RGBAPremultiplied___get_value__impl__bqfhud(dst), 256 - _RGBAPremultiplied___get_a__impl__f0hnd1(src) | 0));
  };
  var Companion_instance_20;
  function Companion_getInstance_27() {
    return Companion_instance_20;
  }
  function mix(_this__u8e3s4, src) {
    var dst = _this__u8e3s4;
    var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
    var oneMSrcAf = 1.0 - srcAf;
    var outA = numberToInt(_RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf);
    var outR = numberToInt(_RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf);
    var outG = numberToInt(_RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf);
    var outB = numberToInt(_RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf);
    return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
  }
  function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
    return ints;
  }
  function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
    return $this;
  }
  function Companion_13() {
  }
  protoOf(Companion_13).v3s = function (size) {
    return _RgbaPremultipliedArray___init__impl__lx83hy(new Int32Array(size));
  };
  var Companion_instance_21;
  function Companion_getInstance_28() {
    return Companion_instance_21;
  }
  function _RgbaPremultipliedArray___get_size__impl__6lte0e($this) {
    return _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this).length;
  }
  function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
    return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
  }
  function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
    _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
  }
  function RgbaPremultipliedArray__fill_impl_sem38t($this, value, start, end) {
    return fill(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this), _RGBAPremultiplied___get_value__impl__bqfhud(value), start, end);
  }
  function RgbaPremultipliedArray__toString_impl_seal6e($this) {
    return 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl__6lte0e($this) + ')';
  }
  function RgbaPremultipliedArray__hashCode_impl_kvnjzv($this) {
    return hashCode($this);
  }
  function RgbaPremultipliedArray__equals_impl_vav5d5($this, other) {
    if (!(other instanceof RgbaPremultipliedArray))
      return false;
    var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other.w3s_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function RgbaPremultipliedArray(ints) {
    this.w3s_1 = ints;
  }
  protoOf(RgbaPremultipliedArray).toString = function () {
    return RgbaPremultipliedArray__toString_impl_seal6e(this.w3s_1);
  };
  protoOf(RgbaPremultipliedArray).hashCode = function () {
    return RgbaPremultipliedArray__hashCode_impl_kvnjzv(this.w3s_1);
  };
  protoOf(RgbaPremultipliedArray).equals = function (other) {
    return RgbaPremultipliedArray__equals_impl_vav5d5(this.w3s_1, other);
  };
  function scale(color, colorOffset, alpha, alphaOffset, count) {
    var inductionVariable = 0;
    if (inductionVariable < count)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var a = clamp01_0(alpha[alphaOffset + n | 0]);
        if (a === 1.0)
          continue $l$loop;
        RgbaPremultipliedArray__set_impl_7fwbby(color, colorOffset + n | 0, RGBAPremultiplied__scaled_impl_qz7lg1(RgbaPremultipliedArray__get_impl_1u69ta(color, colorOffset + n | 0), a));
      }
       while (inductionVariable < count);
  }
  function premultiply(src, srcN, dst, dstN, count) {
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
      }
       while (inductionVariable < count);
  }
  function depremultiply(src, srcN, dst, dstN, count) {
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = dstN + n | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
      }
       while (inductionVariable < count);
  }
  function mix_0(dst, dstX, src, srcX, count) {
    return mix_1(dst, dstX, dst, dstX, src, srcX, count);
  }
  function mix_1(tgt, tgtX, dst, dstX, src, srcX, count) {
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var srcC = RgbaPremultipliedArray__get_impl_1u69ta(src, srcX + n | 0);
        RgbaPremultipliedArray__set_impl_7fwbby(tgt, tgtX + n | 0, _RGBAPremultiplied___get_a__impl__f0hnd1(srcC) === 255 ? srcC : Companion_instance_20.u3s(RgbaPremultipliedArray__get_impl_1u69ta(dst, dstX + n | 0), srcC));
      }
       while (inductionVariable < count);
  }
  function _RGBAf___init__impl__idjpgn(data) {
    return data;
  }
  function _RGBAf___get_data__impl__yt2t4($this) {
    return $this;
  }
  function _RGBAf___init__impl__idjpgn_0(r, g, b, a) {
    r = r === VOID ? 1.0 : r;
    g = g === VOID ? 1.0 : g;
    b = b === VOID ? 1.0 : b;
    a = a === VOID ? 1.0 : a;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([r, g, b, a]);
    return _RGBAf___init__impl__idjpgn(tmp$ret$0);
  }
  function _RGBAf___set_r__impl__pz5j5e($this, v) {
    _RGBAf___get_data__impl__yt2t4($this)[0] = v;
  }
  function _RGBAf___get_r__impl__jfq8gq($this) {
    return _RGBAf___get_data__impl__yt2t4($this)[0];
  }
  function _RGBAf___set_g__impl__c4jj21($this, v) {
    _RGBAf___get_data__impl__yt2t4($this)[1] = v;
  }
  function _RGBAf___get_g__impl__dhoraz($this) {
    return _RGBAf___get_data__impl__yt2t4($this)[1];
  }
  function _RGBAf___set_b__impl__a2n9pa($this, v) {
    _RGBAf___get_data__impl__yt2t4($this)[2] = v;
  }
  function _RGBAf___get_b__impl__fjl0nq($this) {
    return _RGBAf___get_data__impl__yt2t4($this)[2];
  }
  function _RGBAf___set_a__impl__iqz7cx($this, v) {
    _RGBAf___get_data__impl__yt2t4($this)[3] = v;
  }
  function _RGBAf___get_a__impl__qnwk97($this) {
    return _RGBAf___get_data__impl__yt2t4($this)[3];
  }
  function Companion_14() {
  }
  protoOf(Companion_14).x3s = function (f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  };
  var Companion_instance_22;
  function Companion_getInstance_29() {
    return Companion_instance_22;
  }
  function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
    return function () {
      return extract_0(this$0.a3t_1).g3a();
    };
  }
  function Companion_15() {
  }
  var Companion_instance_23;
  function Companion_getInstance_30() {
    return Companion_instance_23;
  }
  function Kerning(first, second, amount) {
    this.g3t_1 = first;
    this.h3t_1 = second;
    this.i3t_1 = amount;
  }
  function Glyph(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.y3s_1 = fontSize;
    this.z3s_1 = id;
    this.a3t_1 = texture;
    this.b3t_1 = xoffset;
    this.c3t_1 = yoffset;
    this.d3t_1 = xadvance;
    var tmp = this;
    tmp.e3t_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.f3t_1 = new GlyphMetrics(this.y3s_1, true, -1, Companion_getInstance_2().p2k(this.b3t_1, this.c3t_1, this.a3t_1.v2w_1, this.a3t_1.w2w_1), this.d3t_1);
  }
  protoOf(Glyph).j3t = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e3t_1;
    bmp$factory();
    return this_0.m2();
  };
  protoOf(Glyph).toString = function () {
    return 'Glyph(fontSize=' + this.y3s_1 + ', id=' + this.z3s_1 + ', texture=' + this.a3t_1 + ', xoffset=' + this.b3t_1 + ', yoffset=' + this.c3t_1 + ', xadvance=' + this.d3t_1 + ')';
  };
  protoOf(Glyph).hashCode = function () {
    var result = getNumberHashCode(this.y3s_1);
    result = imul(result, 31) + this.z3s_1 | 0;
    result = imul(result, 31) + this.a3t_1.hashCode() | 0;
    result = imul(result, 31) + this.b3t_1 | 0;
    result = imul(result, 31) + this.c3t_1 | 0;
    result = imul(result, 31) + this.d3t_1 | 0;
    return result;
  };
  protoOf(Glyph).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.y3s_1, tmp0_other_with_cast.y3s_1))
      return false;
    if (!(this.z3s_1 === tmp0_other_with_cast.z3s_1))
      return false;
    if (!this.a3t_1.equals(tmp0_other_with_cast.a3t_1))
      return false;
    if (!(this.b3t_1 === tmp0_other_with_cast.b3t_1))
      return false;
    if (!(this.c3t_1 === tmp0_other_with_cast.c3t_1))
      return false;
    if (!(this.d3t_1 === tmp0_other_with_cast.d3t_1))
      return false;
    return true;
  };
  function BitmapFont() {
  }
  function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
    return function () {
      var ascent = this$0.w3v_1;
      var baseline = 0.0;
      var tmp = -this$0.c3w_1;
      var tmp_0 = -this$0.c3w_1;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BitmapFontImpl.naturalFontMetrics$delegate.<anonymous>.<anonymous>' call
      var width = 0.0;
      var tmp0_iterator = this$0.x3v_1.h2().u();
      while (tmp0_iterator.v()) {
        var glyph = tmp0_iterator.x();
        if (!(glyph == null)) {
          // Inline function 'kotlin.math.max' call
          var a = width;
          var b = glyph.a3t_1.v2w_1;
          width = Math.max(a, b);
        }
      }
      var tmp$ret$2 = width;
      return new FontMetrics(this$0.u3v_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$2);
    };
  }
  function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
    return function () {
      var tmp0_elvis_lhs = this$0.x3v_1.f1(this$0.x3v_1.g2().u().x());
      return tmp0_elvis_lhs == null ? this$0.h3w() : tmp0_elvis_lhs;
    };
  }
  function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
    return function () {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      return new Glyph(this$0.u3v_1, -1, tmp$ret$0, 0, 0, 0);
    };
  }
  function BitmapFontImpl(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.u3v_1 = fontSize;
    this.v3v_1 = lineHeight;
    this.w3v_1 = base;
    this.x3v_1 = glyphs;
    this.y3v_1 = kernings;
    this.z3v_1 = name;
    this.a3w_1 = distanceField;
    this.b3w_1 = new Mixin();
    this.c3w_1 = this.v3v_1 - this.w3v_1;
    var tmp = this;
    tmp.d3w_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.e3w_1 = new GlyphMetrics(this.u3v_1, false, 0, Companion_getInstance_2().h2f(), 0.0);
    var tmp_0 = this;
    tmp_0.f3w_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.g3w_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  protoOf(BitmapFontImpl).k3t = function () {
    return this.u3v_1;
  };
  protoOf(BitmapFontImpl).l3t = function () {
    return this.v3v_1;
  };
  protoOf(BitmapFontImpl).v2x = function () {
    return this.w3v_1;
  };
  protoOf(BitmapFontImpl).n3t = function () {
    return this.x3v_1;
  };
  protoOf(BitmapFontImpl).o3t = function () {
    return this.y3v_1;
  };
  protoOf(BitmapFontImpl).zb = function () {
    return this.z3v_1;
  };
  protoOf(BitmapFontImpl).m3t = function () {
    return this.a3w_1;
  };
  protoOf(BitmapFontImpl).h23 = function (_set____db54di) {
    this.b3w_1.h23(_set____db54di);
  };
  protoOf(BitmapFontImpl).i23 = function () {
    return this.b3w_1.i23();
  };
  protoOf(BitmapFontImpl).t3v = function () {
    return this;
  };
  protoOf(BitmapFontImpl).r3t = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d3w_1;
    naturalFontMetrics$factory();
    return this_0.m2();
  };
  protoOf(BitmapFontImpl).s3t = function () {
    return this.e3w_1;
  };
  protoOf(BitmapFontImpl).o3u = function (first, second) {
    return this.y3v_1.f1(Companion_instance_22.x3s(first, second));
  };
  protoOf(BitmapFontImpl).g3u = function (codePoint) {
    return this.x3v_1.f1(codePoint);
  };
  protoOf(BitmapFontImpl).q3t = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f3w_1;
    anyGlyph$factory();
    return this_0.m2();
  };
  protoOf(BitmapFontImpl).h3w = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g3w_1;
    invalidGlyph$factory();
    return this_0.m2();
  };
  function readBitmapFont(_this__u8e3s4, props, mipmaps, atlas, $completion) {
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    mipmaps = mipmaps === VOID ? true : mipmaps;
    atlas = atlas === VOID ? null : atlas;
    var tmp = new $readBitmapFontCOROUTINE$35(_this__u8e3s4, props, mipmaps, atlas, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion) {
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    mipmaps = mipmaps === VOID ? true : mipmaps;
    atlas = atlas === VOID ? null : atlas;
    var tmp = new $readBitmapFontXmlCOROUTINE$36(content, fntFile, textures, props, mipmaps, atlas, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion) {
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    mipmaps = mipmaps === VOID ? true : mipmaps;
    atlas = atlas === VOID ? null : atlas;
    var tmp = new $readBitmapFontJsonCOROUTINE$37(content, fntFile, textures, props, mipmaps, atlas, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion) {
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    mipmaps = mipmaps === VOID ? true : mipmaps;
    atlas = atlas === VOID ? null : atlas;
    var tmp = new $readBitmapFontTxtCOROUTINE$38(content, fntFile, textures, props, mipmaps, atlas, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readBitmapFontTxt$lambda(_anonymous_parameter_0__qggqh8, it) {
    return Companion_instance_22.x3s(it.g3t_1, it.h3t_1);
  }
  function $readBitmapFontCOROUTINE$35(_this__u8e3s4, props, mipmaps, atlas, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t3w_1 = _this__u8e3s4;
    this.u3w_1 = props;
    this.v3w_1 = mipmaps;
    this.w3w_1 = atlas;
  }
  protoOf($readBitmapFontCOROUTINE$35).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            this.x3w_1 = this.t3w_1;
            this.fd_1 = 1;
            suspendResult = this.x3w_1.f40(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y3w_1 = suspendResult;
            var tmp_0 = this;
            var tmp_1 = this.y3w_1;
            tmp_0.z3w_1 = toString(trim(isCharSequence(tmp_1) ? tmp_1 : THROW_CCE()));
            var tmp_2 = this;
            tmp_2.a3x_1 = HashMap_init_$Create$();
            if (startsWith_0(this.z3w_1, _Char___init__impl__6a9atx(60))) {
              this.fd_1 = 4;
              suspendResult = readBitmapFontXml(this.z3w_1, this.x3w_1, this.a3x_1, this.u3w_1, this.v3w_1, this.w3w_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (startsWith_0(this.z3w_1, _Char___init__impl__6a9atx(123))) {
                this.fd_1 = 3;
                suspendResult = readBitmapFontJson(this.z3w_1, this.x3w_1, this.a3x_1, this.u3w_1, this.v3w_1, this.w3w_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (startsWith(this.z3w_1, 'info')) {
                  this.fd_1 = 2;
                  suspendResult = readBitmapFontTxt(this.z3w_1, this.x3w_1, this.a3x_1, this.u3w_1, this.v3w_1, this.w3w_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_3 = this;
                  var reason = 'Unsupported font type starting with ' + substr_0(this.z3w_1, 0, 16);
                  throw new NotImplementedError('An operation is not implemented: ' + reason);
                }
              }
            }

          case 2:
            this.b3x_1 = suspendResult;
            this.fd_1 = 5;
            continue $sm;
          case 3:
            this.b3x_1 = suspendResult;
            this.fd_1 = 5;
            continue $sm;
          case 4:
            this.b3x_1 = suspendResult;
            this.fd_1 = 5;
            continue $sm;
          case 5:
            return this.b3x_1;
          case 6:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 6) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readBitmapFontXmlCOROUTINE$36(content, fntFile, textures, props, mipmaps, atlas, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k3x_1 = content;
    this.l3x_1 = fntFile;
    this.m3x_1 = textures;
    this.n3x_1 = props;
    this.o3x_1 = mipmaps;
    this.p3x_1 = atlas;
  }
  protoOf($readBitmapFontXmlCOROUTINE$36).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.q3x_1 = Xml_0(this.k3x_1);
            var tmp_0 = this;
            var tmp0_safe_receiver = firstOrNull(this.q3x_1.s13('info'));
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n40('size');
            tmp_0.r3x_1 = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
            var tmp_1 = this;
            var tmp2_safe_receiver = firstOrNull(this.q3x_1.s13('common'));
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.n40('lineHeight');
            tmp_1.s3x_1 = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
            var tmp_2 = this;
            var tmp4_safe_receiver = firstOrNull(this.q3x_1.s13('common'));
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.n40('base');
            tmp_2.t3x_1 = tmp5_elvis_lhs == null ? 16.0 : tmp5_elvis_lhs;
            var tmp_3 = this;
            var tmp6_safe_receiver = firstOrNull(this.q3x_1.s13('distanceField'));
            tmp_3.u3x_1 = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.o40('fieldType');
            this.v3x_1 = get_2(this.q3x_1.s13('pages'), 'page').u();
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!this.v3x_1.v()) {
              this.fd_1 = 3;
              continue $sm;
            }

            this.w3x_1 = this.v3x_1.x();
            this.x3x_1 = this.w3x_1.p40('id');
            this.y3x_1 = this.w3x_1.q40('file');
            this.z3x_1 = this.l3x_1.r40().s13(this.y3x_1);
            this.fd_1 = 2;
            suspendResult = readBitmap_0(this.z3x_1, this.n3x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = mipmaps(ARGUMENT, this.o3x_1);
            var tex = slice_0(ARGUMENT_0);
            var this_0 = this.m3x_1;
            var key = this.x3x_1;
            this_0.i2(key, tex);
            this.fd_1 = 1;
            continue $sm;
          case 3:
            var this_1 = get_2(this.q3x_1.s13('chars'), 'char');
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
            var tmp0_iterator = this_1.u();
            while (tmp0_iterator.v()) {
              var item = tmp0_iterator.x();
              var page = item.p40('page');
              var tmp0_elvis_lhs = this.m3x_1.s2(page);
              var texture = tmp0_elvis_lhs == null ? first(this.m3x_1.h2()) : tmp0_elvis_lhs;
              var tmp_4 = item.p40('id');
              var tmp1_safe_receiver = this.p3x_1;
              var tmp_5;
              if (tmp1_safe_receiver == null) {
                tmp_5 = null;
              } else {
                var tmp_6 = texture.d2y(item.p40('x'), item.p40('y'), item.p40('width'), item.p40('height'));
                tmp_5 = tmp1_safe_receiver.a3b(tmp_6 instanceof RectSlice ? tmp_6 : THROW_CCE(), Unit_instance);
              }
              var tmp2_safe_receiver_0 = tmp_5;
              var tmp3_elvis_lhs_0 = tmp2_safe_receiver_0 == null ? null : tmp2_safe_receiver_0.d39_1;
              destination.r(new Glyph(this.r3x_1, tmp_4, tmp3_elvis_lhs_0 == null ? texture.d2y(item.p40('x'), item.p40('y'), item.p40('width'), item.p40('height')) : tmp3_elvis_lhs_0, item.p40('xoffset'), item.p40('yoffset'), item.p40('xadvance')));
            }

            var glyphs = destination;
            var this_2 = get_2(this.q3x_1.s13('kernings'), 'kerning');
            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
            var tmp0_iterator_0 = this_2.u();
            while (tmp0_iterator_0.v()) {
              var item_0 = tmp0_iterator_0.x();
              destination_0.r(new Kerning(item_0.p40('first'), item_0.p40('second'), item_0.p40('amount')));
            }

            var kernings = destination_0;
            var fontSize = this.r3x_1;
            var lineHeight = this.s3x_1;
            var base = this.t3x_1;
            var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(glyphs, 10));
            var tmp0_iterator_1 = glyphs.u();
            while (tmp0_iterator_1.v()) {
              var item_1 = tmp0_iterator_1.x();
              destination_1.r(to(item_1.z3s_1, item_1));
            }

            var glyphs_0 = toIntMap(toMap(destination_1));
            var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(kernings, 10));
            var tmp0_iterator_2 = kernings.u();
            while (tmp0_iterator_2.v()) {
              var item_2 = tmp0_iterator_2.x();
              destination_2.r(to(Companion_instance_22.x3s(item_2.g3t_1, item_2.h3t_1), item_2));
            }

            var kernings_0 = toIntMap(toMap(destination_2));
            var distanceField = this.u3x_1;
            var name = 'BitmapFont';
            return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readBitmapFontJsonCOROUTINE$37(content, fntFile, textures, props, mipmaps, atlas, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i3y_1 = content;
    this.j3y_1 = fntFile;
    this.k3y_1 = textures;
    this.l3y_1 = props;
    this.m3y_1 = mipmaps;
    this.n3y_1 = atlas;
  }
  protoOf($readBitmapFontJsonCOROUTINE$37).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.o3y_1 = Json_instance.s40(this.i3y_1);
            this.p3y_1 = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80_0(Dyn__get_impl_6l2p80_0(this.o3y_1, 'info'), 'size'), 16.0);
            this.q3y_1 = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80_0(Dyn__get_impl_6l2p80_0(this.o3y_1, 'common'), 'lineHeight'), 16.0);
            this.r3y_1 = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80_0(Dyn__get_impl_6l2p80_0(this.o3y_1, 'common'), 'base'), 16.0);
            this.s3y_1 = Dyn__toStringOrNull_impl_7e6cgy(Dyn__get_impl_6l2p80_0(Dyn__get_impl_6l2p80_0(this.o3y_1, 'distanceField'), 'fieldType'));
            var tmp_0 = this;
            tmp_0.t3y_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80_0(this.o3y_1, 'pages'));
            this.u3y_1 = 0;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!(this.u3y_1 < this.t3y_1.n())) {
              this.fd_1 = 3;
              continue $sm;
            }

            var tmp_1 = this;
            tmp_1.v3y_1 = this.u3y_1;
            var tmp_2 = this;
            tmp_2.w3y_1 = this.t3y_1.f1(this.u3y_1).t40_1;
            this.x3y_1 = Dyn__toString_impl_9l0v3s(this.w3y_1);
            this.y3y_1 = this.j3y_1.r40().s13(this.x3y_1);
            this.fd_1 = 2;
            suspendResult = readBitmap_0(this.y3y_1, this.l3y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = mipmaps(ARGUMENT, this.m3y_1);
            var tex = slice_0(ARGUMENT_0);
            var this_0 = this.k3y_1;
            var key = this.v3y_1;
            this_0.i2(key, tex);
            this.u3y_1 = this.u3y_1 + 1 | 0;
            this.fd_1 = 1;
            continue $sm;
          case 3:
            var this_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80_0(this.o3y_1, 'chars'));
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
            var tmp0_iterator = this_1.u();
            while (tmp0_iterator.v()) {
              var item = tmp0_iterator.x().t40_1;
              var page = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'page'));
              var tmp0_elvis_lhs = this.k3y_1.s2(page);
              var texture = tmp0_elvis_lhs == null ? first(this.k3y_1.h2()) : tmp0_elvis_lhs;
              var tmp_3 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'id'));
              var tmp1_safe_receiver = this.n3y_1;
              var tmp_4;
              if (tmp1_safe_receiver == null) {
                tmp_4 = null;
              } else {
                var tmp_5 = texture.d2y(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'height')));
                tmp_4 = tmp1_safe_receiver.a3b(tmp_5 instanceof RectSlice ? tmp_5 : THROW_CCE(), Unit_instance);
              }
              var tmp2_safe_receiver = tmp_4;
              var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d39_1;
              destination.r(new Glyph(this.p3y_1, tmp_3, tmp3_elvis_lhs == null ? texture.d2y(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'height'))) : tmp3_elvis_lhs, _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'xoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'yoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item, 'xadvance'))));
            }

            var glyphs = destination;
            var this_2 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80_0(this.o3y_1, 'kernings'));
            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
            var tmp0_iterator_0 = this_2.u();
            while (tmp0_iterator_0.v()) {
              var item_0 = tmp0_iterator_0.x().t40_1;
              destination_0.r(new Kerning(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item_0, 'first')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item_0, 'second')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(item_0, 'amount'))));
            }

            var kernings = destination_0;
            var fontSize = this.p3y_1;
            var lineHeight = this.q3y_1;
            var base = this.r3y_1;
            var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(glyphs, 10));
            var tmp0_iterator_1 = glyphs.u();
            while (tmp0_iterator_1.v()) {
              var item_1 = tmp0_iterator_1.x();
              destination_1.r(to(item_1.z3s_1, item_1));
            }

            var glyphs_0 = toIntMap(toMap(destination_1));
            var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(kernings, 10));
            var tmp0_iterator_2 = kernings.u();
            while (tmp0_iterator_2.v()) {
              var item_2 = tmp0_iterator_2.x();
              destination_2.r(to(Companion_instance_22.x3s(item_2.g3t_1, item_2.h3t_1), item_2));
            }

            var kernings_0 = toIntMap(toMap(destination_2));
            var distanceField = this.s3y_1;
            var name = 'BitmapFont';
            return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readBitmapFontTxtCOROUTINE$38(content, fntFile, textures, props, mipmaps, atlas, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h3z_1 = content;
    this.i3z_1 = fntFile;
    this.j3z_1 = textures;
    this.k3z_1 = props;
    this.l3z_1 = mipmaps;
    this.m3z_1 = atlas;
  }
  protoOf($readBitmapFontTxtCOROUTINE$38).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 5;
            var tmp_0 = this;
            tmp_0.n3z_1 = ArrayList_init_$Create$();
            var tmp_1 = this;
            tmp_1.o3z_1 = ArrayList_init_$Create$();
            this.p3z_1 = 16.0;
            this.q3z_1 = 16.0;
            this.r3z_1 = null;
            this.s3z_1 = lines(this.h3z_1).u();
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!this.s3z_1.v()) {
              this.fd_1 = 4;
              continue $sm;
            }

            this.t3z_1 = this.s3z_1.x();
            var tmp_2 = this;
            var this_0 = this.t3z_1;
            tmp_2.u3z_1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
            this.v3z_1 = LinkedHashMap_init_$Create$();
            var tmp1_iterator = split_0(this.u3z_1, charArrayOf([_Char___init__impl__6a9atx(32)])).u();
            while (tmp1_iterator.v()) {
              var part = tmp1_iterator.x();
              var tmp2_container = plus(split_0(part, charArrayOf([_Char___init__impl__6a9atx(61)])), listOf(['', '']));
              var key = tmp2_container.f1(0);
              var value = tmp2_container.f1(1);
              this.v3z_1.i2(key, value);
            }

            if (startsWith(this.u3z_1, 'info')) {
              var tmp_3 = this;
              var tmp3_safe_receiver = this.v3z_1.s2('size');
              var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toDouble(tmp3_safe_receiver);
              var this_1 = tmp4_elvis_lhs == null ? 16.0 : tmp4_elvis_lhs;
              tmp_3.q3z_1 = Math.abs(this_1);
              this.fd_1 = 3;
              continue $sm;
            } else {
              if (startsWith(this.u3z_1, 'page')) {
                var tmp_4 = this;
                var tmp5_safe_receiver = this.v3z_1.s2('id');
                var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : toInt_0(tmp5_safe_receiver);
                tmp_4.w3z_1 = tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs;
                var tmp_5 = this;
                var tmp7_safe_receiver = this.v3z_1.s2('file');
                var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : unquote(tmp7_safe_receiver);
                var tmp_6;
                if (tmp8_elvis_lhs == null) {
                  var message = 'page without file';
                  throw IllegalStateException_init_$Create$(toString(message));
                } else {
                  tmp_6 = tmp8_elvis_lhs;
                }
                tmp_5.x3z_1 = tmp_6;
                var tmp_7 = this;
                tmp_7.y3z_1 = this.j3z_1;
                var tmp_8 = this;
                tmp_8.z3z_1 = this.w3z_1;
                this.fd_1 = 2;
                suspendResult = readBitmap_0(this.i3z_1.r40().s13(this.x3z_1), this.k3z_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (startsWith(this.u3z_1, 'common ')) {
                  var tmp_9 = this;
                  var tmp9_safe_receiver = this.v3z_1.s2('lineHeight');
                  var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : toDoubleOrNull(tmp9_safe_receiver);
                  tmp_9.p3z_1 = tmp10_elvis_lhs == null ? 16.0 : tmp10_elvis_lhs;
                  var tmp_10 = this;
                  var tmp11_safe_receiver = this.v3z_1.s2('base');
                  tmp_10.r3z_1 = tmp11_safe_receiver == null ? null : toDoubleOrNull(tmp11_safe_receiver);
                  this.fd_1 = 3;
                  continue $sm;
                } else {
                  if (startsWith(this.u3z_1, 'char ')) {
                    var tmp12_safe_receiver = this.v3z_1.s2('page');
                    var tmp13_elvis_lhs = tmp12_safe_receiver == null ? null : toIntOrNull(tmp12_safe_receiver);
                    var page = tmp13_elvis_lhs == null ? 0 : tmp13_elvis_lhs;
                    var tmp14_elvis_lhs = this.j3z_1.s2(page);
                    var texture = tmp14_elvis_lhs == null ? first(this.j3z_1.h2()) : tmp14_elvis_lhs;
                    var dmap = get_dyn(this.v3z_1);
                    var id = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'id'));
                    var this_2 = this.o3z_1;
                    var tmp18_fontSize = this.q3z_1;
                    var tmp19_xoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'xoffset'));
                    var tmp20_yoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'yoffset'));
                    var tmp21_xadvance = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'xadvance'));
                    var tmp15_safe_receiver = this.m3z_1;
                    var tmp_11;
                    if (tmp15_safe_receiver == null) {
                      tmp_11 = null;
                    } else {
                      var tmp_12 = texture.d2y(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'height')), 'glyph-' + toString_0(numberToChar(id)));
                      tmp_11 = tmp15_safe_receiver.a3b(tmp_12 instanceof RectSlice ? tmp_12 : THROW_CCE(), Unit_instance);
                    }
                    var tmp16_safe_receiver = tmp_11;
                    var tmp17_elvis_lhs = tmp16_safe_receiver == null ? null : tmp16_safe_receiver.d39_1;
                    var tmp22_texture = tmp17_elvis_lhs == null ? texture.d2y(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80_0(dmap, 'height')), 'glyph-' + toString_0(numberToChar(id))) : tmp17_elvis_lhs;
                    var element = new Glyph(tmp18_fontSize, id, tmp22_texture, tmp19_xoffset, tmp20_yoffset, tmp21_xadvance);
                    this_2.r(element);
                    this.fd_1 = 3;
                    continue $sm;
                  } else {
                    if (startsWith(this.u3z_1, 'kerning ')) {
                      var this_3 = this.n3z_1;
                      var tmp23_safe_receiver = this.v3z_1.s2('first');
                      var tmp24_elvis_lhs = tmp23_safe_receiver == null ? null : toIntOrNull(tmp23_safe_receiver);
                      var tmp_13 = tmp24_elvis_lhs == null ? 0 : tmp24_elvis_lhs;
                      var tmp25_safe_receiver = this.v3z_1.s2('second');
                      var tmp26_elvis_lhs = tmp25_safe_receiver == null ? null : toIntOrNull(tmp25_safe_receiver);
                      var tmp_14 = tmp26_elvis_lhs == null ? 0 : tmp26_elvis_lhs;
                      var tmp27_safe_receiver = this.v3z_1.s2('amount');
                      var tmp28_elvis_lhs = tmp27_safe_receiver == null ? null : toIntOrNull(tmp27_safe_receiver);
                      var element_0 = new Kerning(tmp_13, tmp_14, tmp28_elvis_lhs == null ? 0 : tmp28_elvis_lhs);
                      this_3.r(element_0);
                      this.fd_1 = 3;
                      continue $sm;
                    } else {
                      this.fd_1 = 3;
                      continue $sm;
                    }
                  }
                }
              }
            }

          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = mipmaps(ARGUMENT, this.l3z_1);
            var value_0 = slice_0(ARGUMENT_0);
            this.y3z_1.i2(this.z3z_1, value_0);
            this.fd_1 = 3;
            continue $sm;
          case 3:
            this.fd_1 = 1;
            continue $sm;
          case 4:
            var fontSize = this.q3z_1;
            var lineHeight = this.p3z_1;
            var tmp29_elvis_lhs = this.r3z_1;
            var base = tmp29_elvis_lhs == null ? this.p3z_1 : tmp29_elvis_lhs;
            var this_4 = this.o3z_1;
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_4, 10)), 16);
            var destination = LinkedHashMap_init_$Create$_0(capacity);
            var tmp0_iterator = this_4.u();
            while (tmp0_iterator.v()) {
              var element_1 = tmp0_iterator.x();
              destination.i2(element_1.z3s_1, element_1);
            }

            var glyphs = toIntMap(destination);
            var kernings = associateByInt(this.n3z_1, readBitmapFontTxt$lambda);
            var name = 'BitmapFont';
            return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs, kernings, name, null);
          case 5:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 5) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function bmp$factory() {
    return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
      return receiver.j3t();
    }, null);
  }
  function naturalFontMetrics$factory() {
    return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
      return receiver.r3t();
    }, null);
  }
  function anyGlyph$factory() {
    return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
      return receiver.q3t();
    }, null);
  }
  function invalidGlyph$factory() {
    return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
      return receiver.h3w();
    }, null);
  }
  var DefaultTtfFontOrNull;
  function get_DefaultTtfFont() {
    if (DefaultTtfFontOrNull == null) {
      // Inline function 'korlibs.time.measureTimeWithResult' call
      var start = PerformanceCounter_instance.l1q();
      // Inline function 'korlibs.image.font.<get-DefaultTtfFont>.<anonymous>' call
      var result = new TtfFont(DefaultTtfFontBytes(), 'Default Font');
      var end = PerformanceCounter_instance.l1q();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      var elapsed = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      var res = new TimedResult(result, elapsed);
      DefaultTtfFontOrNull = res.j1q_1;
    }
    return ensureNotNull(DefaultTtfFontOrNull);
  }
  function DefaultTtfFontBytes() {
    return uncompress_0(fromBase64('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'), Companion_getInstance_59());
  }
  function get_DefaultTtfFontAsBitmap() {
    return get_lazyBitmapSDF(get_DefaultTtfFont());
  }
  function Font() {
  }
  function TextToBitmapResult(bmp, fmetrics, metrics, glyphs, glyphsPerLine, shape) {
    shape = shape === VOID ? null : shape;
    this.u40_1 = bmp;
    this.v40_1 = fmetrics;
    this.w40_1 = metrics;
    this.x40_1 = glyphs;
    this.y40_1 = glyphsPerLine;
    this.z40_1 = shape;
  }
  protoOf(TextToBitmapResult).toString = function () {
    return 'TextToBitmapResult(bmp=' + this.u40_1 + ', fmetrics=' + this.v40_1 + ', metrics=' + this.w40_1 + ', glyphs=' + this.x40_1 + ', glyphsPerLine=' + this.y40_1 + ', shape=' + this.z40_1 + ')';
  };
  protoOf(TextToBitmapResult).hashCode = function () {
    var result = hashCode(this.u40_1);
    result = imul(result, 31) + this.v40_1.hashCode() | 0;
    result = imul(result, 31) + this.w40_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.x40_1) | 0;
    result = imul(result, 31) + hashCode(this.y40_1) | 0;
    result = imul(result, 31) + (this.z40_1 == null ? 0 : hashCode(this.z40_1)) | 0;
    return result;
  };
  protoOf(TextToBitmapResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals(this.u40_1, tmp0_other_with_cast.u40_1))
      return false;
    if (!this.v40_1.equals(tmp0_other_with_cast.v40_1))
      return false;
    if (!this.w40_1.equals(tmp0_other_with_cast.w40_1))
      return false;
    if (!equals(this.x40_1, tmp0_other_with_cast.x40_1))
      return false;
    if (!equals(this.y40_1, tmp0_other_with_cast.y40_1))
      return false;
    if (!equals(this.z40_1, tmp0_other_with_cast.z40_1))
      return false;
    return true;
  };
  function renderGlyphToBitmap(_this__u8e3s4, size, codePoint, paint, fill, effect, border, nativeRendering, reader) {
    paint = paint === VOID ? new RGBA(get_DefaultPaint()) : paint;
    fill = fill === VOID ? true : fill;
    effect = effect === VOID ? null : effect;
    border = border === VOID ? 1 : border;
    nativeRendering = nativeRendering === VOID ? true : nativeRendering;
    reader = reader === VOID ? null : reader;
    var font = _this__u8e3s4;
    var fmetrics = _this__u8e3s4.e3u(size);
    var gmetrics = _this__u8e3s4.n3u(size, codePoint, VOID, reader);
    var gx = -gmetrics.r2d();
    var gy = gmetrics.y1q() + gmetrics.t2d();
    var border2 = imul(border, 2);
    var iwidth = toIntCeil_0(gmetrics.x1q()) + border2 | 0;
    var iheight = toIntCeil_0(gmetrics.y1q()) + border2 | 0;
    var image = nativeRendering ? NativeImage_0(iwidth, iheight) : new Bitmap32(iwidth, iheight, VOID, true);
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = image.y39_1;
    if (true) {
      image.h3a();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.d3i(true);
      try {
        // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
        renderGlyphToBitmap$renderGlyph(ctx, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
      }finally {
        ctx.f1e();
      }
    }finally {
      result = true ? image.z3a(rect) : 0;
    }
    var imageOut = applyEffect(image.e3i(), effect);
    var glyph = new PlacedGlyphMetrics(codePoint, new Vector2D(gx + border, gy + border), gmetrics, fmetrics, Companion_getInstance_3().e2f_1, 0, 0);
    var tmp = new TextMetrics();
    var tmp_0 = listOf_0(glyph);
    var tmp_1 = listOf_0(listOf_0(glyph));
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(iwidth, iheight);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
    renderGlyphToBitmap$renderGlyph(this_0, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
    var tmp$ret$3 = this_0.k41();
    return new TextToBitmapResult(imageOut, fmetrics, tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  function PlacedGlyphMetrics$boundsPath$delegate$lambda(this$0) {
    return function () {
      // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
      // Inline function 'kotlin.apply' call
      var this_0 = new VectorPath();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.PlacedGlyphMetrics.boundsPath$delegate.<anonymous>.<anonymous>' call
      this_0.x2u_1 = false;
      this_0.t33(this$0.n41_1.r2d(), -this$0.o41_1.w3t_1, this$0.n41_1.l3u_1, this$0.o41_1.l3t());
      return applyTransform(this_0, Companion_getInstance_3().h2f().m2g(this$0.m41_1).t2g(this$0.p41_1));
    };
  }
  function PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this$0) {
    return function () {
      var curves = getCurves(this$0.w41());
      var tmp;
      if (!(curves.h2r_1.n() === 4)) {
        println('curves=' + curves.h2r_1.n());
        tmp = Unit_instance;
      }
      return curves;
    };
  }
  function PlacedGlyphMetrics$caretStart$delegate$lambda(this$0) {
    return function () {
      // Inline function 'korlibs.math.geom.Line2D.flipped' call
      var this_0 = this$0.x41().h2r_1.f1(3).k2u();
      return (new Line2D(this_0.o2e_1, this_0.n2e_1)).p2e();
    };
  }
  function PlacedGlyphMetrics$caretEnd$delegate$lambda(this$0) {
    return function () {
      return this$0.x41().h2r_1.f1(1);
    };
  }
  function PlacedGlyphMetrics(codePoint, pos, metrics, fontMetrics, transform, index, nline) {
    this.l41_1 = codePoint;
    this.m41_1 = pos;
    this.n41_1 = metrics;
    this.o41_1 = fontMetrics;
    this.p41_1 = transform;
    this.q41_1 = index;
    this.r41_1 = nline;
    var tmp = this;
    tmp.s41_1 = lazy(PlacedGlyphMetrics$boundsPath$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.t41_1 = lazy(PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.u41_1 = lazy(PlacedGlyphMetrics$caretStart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.v41_1 = lazy(PlacedGlyphMetrics$caretEnd$delegate$lambda(this));
  }
  protoOf(PlacedGlyphMetrics).w41 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s41_1;
    boundsPath$factory();
    return this_0.m2();
  };
  protoOf(PlacedGlyphMetrics).x41 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t41_1;
    boundsPathCurves$factory();
    return this_0.m2();
  };
  protoOf(PlacedGlyphMetrics).toString = function () {
    return 'PlacedGlyphMetrics(codePoint=' + this.l41_1 + ', pos=' + this.m41_1 + ', metrics=' + this.n41_1 + ', fontMetrics=' + this.o41_1 + ', transform=' + this.p41_1 + ', index=' + this.q41_1 + ', nline=' + this.r41_1 + ')';
  };
  protoOf(PlacedGlyphMetrics).hashCode = function () {
    var result = this.l41_1;
    result = imul(result, 31) + this.m41_1.hashCode() | 0;
    result = imul(result, 31) + this.n41_1.hashCode() | 0;
    result = imul(result, 31) + this.o41_1.hashCode() | 0;
    result = imul(result, 31) + this.p41_1.hashCode() | 0;
    result = imul(result, 31) + this.q41_1 | 0;
    result = imul(result, 31) + this.r41_1 | 0;
    return result;
  };
  protoOf(PlacedGlyphMetrics).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this.l41_1 === tmp0_other_with_cast.l41_1))
      return false;
    if (!this.m41_1.equals(tmp0_other_with_cast.m41_1))
      return false;
    if (!this.n41_1.equals(tmp0_other_with_cast.n41_1))
      return false;
    if (!this.o41_1.equals(tmp0_other_with_cast.o41_1))
      return false;
    if (!this.p41_1.equals(tmp0_other_with_cast.p41_1))
      return false;
    if (!(this.q41_1 === tmp0_other_with_cast.q41_1))
      return false;
    if (!(this.r41_1 === tmp0_other_with_cast.r41_1))
      return false;
    return true;
  };
  function TextMetricsResult(fmetrics, metrics, glyphs, glyphsPerLine) {
    fmetrics = fmetrics === VOID ? new FontMetrics() : fmetrics;
    metrics = metrics === VOID ? new TextMetrics() : metrics;
    glyphs = glyphs === VOID ? emptyList() : glyphs;
    glyphsPerLine = glyphsPerLine === VOID ? emptyList() : glyphsPerLine;
    this.y41_1 = fmetrics;
    this.z41_1 = metrics;
    this.a42_1 = glyphs;
    this.b42_1 = glyphsPerLine;
  }
  protoOf(TextMetricsResult).toString = function () {
    return 'TextMetricsResult(fmetrics=' + this.y41_1 + ', metrics=' + this.z41_1 + ', glyphs=' + this.a42_1 + ', glyphsPerLine=' + this.b42_1 + ')';
  };
  protoOf(TextMetricsResult).hashCode = function () {
    var result = this.y41_1.hashCode();
    result = imul(result, 31) + this.z41_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.a42_1) | 0;
    result = imul(result, 31) + hashCode(this.b42_1) | 0;
    return result;
  };
  protoOf(TextMetricsResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetricsResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetricsResult ? other : THROW_CCE();
    if (!this.y41_1.equals(tmp0_other_with_cast.y41_1))
      return false;
    if (!this.z41_1.equals(tmp0_other_with_cast.z41_1))
      return false;
    if (!equals(this.a42_1, tmp0_other_with_cast.a42_1))
      return false;
    if (!equals(this.b42_1, tmp0_other_with_cast.b42_1))
      return false;
    return true;
  };
  function drawText(_this__u8e3s4, ctx, size, text, paint, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, placed) {
    pos = pos === VOID ? Companion_getInstance_4().d2d_1 : pos;
    fill = fill === VOID ? true : fill;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? Companion_getInstance_50().m42_1 : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? IntCompanionObject_instance.MAX_VALUE : textRangeEnd;
    placed = placed === VOID ? null : placed;
    var glyphs = !(outMetrics == null) ? new MultiplePlacedGlyphMetrics() : null;
    var fnt = _this__u8e3s4;
    var doRender = drawText$lambda(fillStyle, stroke, ctx, fill);
    var actions = new drawText$actions$1(renderer, text, size, fnt, align, pos, ctx, paint, textRangeStart, textRangeEnd, doRender, glyphs, placed);
    if (ctx == null)
      null;
    else {
      ctx.c43();
    }
    invoke(renderer, actions, text, size, _this__u8e3s4);
    doRender();
    if (!(outMetrics == null)) {
      ensureNotNull(glyphs);
      outMetrics.a42_1 = glyphs.d43_1;
      outMetrics.b42_1 = glyphs.e43_1;
      var fmetrics = _this__u8e3s4.e3u(size);
      outMetrics.y41_1 = fmetrics;
      var metrics = outMetrics.z41_1;
      metrics.h43_1.j43(fmetrics);
      metrics.i43_1 = glyphs.e43_1.n();
      var tmp_1 = metrics;
      // Inline function 'kotlin.collections.map' call
      var this_0 = glyphs.e43_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.image.font.drawText.<anonymous>' call
        var bb = Companion_getInstance_5().a2e();
        var tmp0_iterator_0 = item.u();
        while (tmp0_iterator_0.v()) {
          var g = tmp0_iterator_0.x();
          bb = plus_0(bb, g.w41());
        }
        var tmp$ret$0 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
        destination.r(tmp$ret$0);
      }
      tmp_1.g43_1 = destination;
      metrics.f43_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(BoundsBuilder__plus_impl_cz7f7x(Companion_getInstance_5().a2e(), metrics.g43_1));
    }
    return outMetrics;
  }
  function getTextBounds(_this__u8e3s4, size, text, out, renderer, align) {
    out = out === VOID ? new TextMetrics() : out;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? Companion_getInstance_50().i42_1 : align;
    var actions = new BoundBuilderTextRendererActions();
    invoke(renderer, actions, text, size, _this__u8e3s4);
    _this__u8e3s4.t3t(size, out.h43_1);
    out.i43_1 = actions.z43();
    var bb = Companion_getInstance_5().a2e();
    var dy = 0.0;
    var lineBounds = FastArrayList_init_$Create$();
    var offsetY = actions.d44(align.b44_1, out.h43_1);
    var tmp0_iterator = actions.x43_1.u();
    while (tmp0_iterator.v()) {
      var line = tmp0_iterator.x();
      var offsetX = line.h44(align.a44_1);
      var rect = new RectangleD(-offsetX, +offsetY + dy - out.i44(), line.f44_1, line.e44_1);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, rect);
      lineBounds.r(rect);
      dy = dy + line.e44_1;
    }
    out.g43_1 = lineBounds;
    out.f43_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
    return out;
  }
  function MultiplePlacedGlyphMetrics() {
    this.d43_1 = FastArrayList_init_$Create$();
    this.e43_1 = FastArrayList_init_$Create$();
  }
  protoOf(MultiplePlacedGlyphMetrics).n = function () {
    return this.d43_1.n();
  };
  protoOf(MultiplePlacedGlyphMetrics).j44 = function (glyph) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.d43_1.r(glyph);
    while (this.e43_1.n() <= glyph.r41_1) {
      this.e43_1.r(FastArrayList_init_$Create$());
    }
    this.e43_1.f1(glyph.r41_1).r(glyph);
  };
  function renderGlyphToBitmap$renderGlyph(_this__u8e3s4, $paint, font, $size, $codePoint, gx, $border, gy, gmetrics, $fill) {
    _this__u8e3s4.o3v($paint);
    font.r3v(_this__u8e3s4, $size, $codePoint, new Vector2D(gx + $border, gy + $border), true, gmetrics);
    if ($fill) {
      _this__u8e3s4.l44();
    } else {
      _this__u8e3s4.k44();
    }
  }
  function drawText$lambda($fillStyle, $stroke, $ctx, $fill) {
    return function () {
      var tmp;
      if (!($fillStyle == null) ? true : !($stroke == null)) {
        var tmp0_safe_receiver = $ctx;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
          var fill = $fillStyle;
          var stroke = $stroke;
          // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
          var stroke_0 = stroke == null ? null : stroke.m44_1;
          var strokeInfo = stroke == null ? null : stroke.n44_1;
          // Inline function 'korlibs.image.vector.Context2d.fillStroke.<anonymous>' call
          if (!(fill == null)) {
            tmp0_safe_receiver.o44(fill);
          }
          if (!(stroke_0 == null)) {
            if (!(strokeInfo == null)) {
              $l$block: {
                // Inline function 'korlibs.image.vector.Context2d.stroke' call
                if (stroke_0 == null ? true : strokeInfo == null) {
                  break $l$block;
                }
                // Inline function 'korlibs.image.vector.Context2d.stroke' call
                var lineWidth = strokeInfo.y2p_1;
                var lineCap = strokeInfo.b2q_1;
                var lineJoin = strokeInfo.d2q_1;
                var miterLimit = strokeInfo.e2q_1;
                var lineDash = strokeInfo.f2q_1;
                var lineDashOffset = strokeInfo.g2q_1;
                if (false) {
                  tmp0_safe_receiver.c43();
                }
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                // Inline function 'korlibs.image.vector.Context2d.keep' call
                tmp0_safe_receiver.v44();
                try {
                  // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                  tmp0_safe_receiver.w44(numberToDouble(lineWidth));
                  tmp0_safe_receiver.x44(lineCap);
                  tmp0_safe_receiver.y44(lineJoin);
                  tmp0_safe_receiver.z44(numberToDouble(miterLimit));
                  tmp0_safe_receiver.a45(lineDash);
                  tmp0_safe_receiver.b45(numberToDouble(lineDashOffset));
                  tmp0_safe_receiver.c45(stroke_0);
                }finally {
                  tmp0_safe_receiver.d45();
                }
              }
            } else {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineWidth_0 = tmp0_safe_receiver.p44();
              var lineCap_0 = tmp0_safe_receiver.q44();
              var lineJoin_0 = tmp0_safe_receiver.r44();
              var miterLimit_0 = tmp0_safe_receiver.s44();
              var lineDash_0 = tmp0_safe_receiver.t44();
              var lineDashOffset_0 = tmp0_safe_receiver.u44();
              if (false) {
                tmp0_safe_receiver.c43();
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              tmp0_safe_receiver.v44();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                tmp0_safe_receiver.w44(numberToDouble(lineWidth_0));
                tmp0_safe_receiver.x44(lineCap_0);
                tmp0_safe_receiver.y44(lineJoin_0);
                tmp0_safe_receiver.z44(numberToDouble(miterLimit_0));
                tmp0_safe_receiver.a45(lineDash_0);
                tmp0_safe_receiver.b45(numberToDouble(lineDashOffset_0));
                tmp0_safe_receiver.c45(stroke_0);
              }finally {
                tmp0_safe_receiver.d45();
              }
            }
          }
        }
        tmp = Unit_instance;
      } else {
        var tmp_0;
        if ($fill) {
          var tmp1_safe_receiver = $ctx;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.l44();
          }
          tmp_0 = Unit_instance;
        } else {
          var tmp2_safe_receiver = $ctx;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.k44();
          }
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      var tmp3_safe_receiver = $ctx;
      if (tmp3_safe_receiver == null)
        null;
      else {
        tmp3_safe_receiver.c43();
      }
      return Unit_instance;
    };
  }
  function drawText$actions$1($renderer, $text, $size, $fnt, $align, $pos, $ctx, $paint, $textRangeStart, $textRangeEnd, $doRender, $glyphs, $placed) {
    this.q45_1 = $size;
    this.r45_1 = $align;
    this.s45_1 = $pos;
    this.t45_1 = $ctx;
    this.u45_1 = $paint;
    this.v45_1 = $textRangeStart;
    this.w45_1 = $textRangeEnd;
    this.x45_1 = $doRender;
    this.y45_1 = $glyphs;
    this.z45_1 = $placed;
    TextRendererActions.call(this);
    this.o45_1 = measure($renderer, $text, $size, $fnt);
    this.p45_1 = 0;
  }
  protoOf(drawText$actions$1).a46 = function (reader, codePoint) {
    var nline = this.l46();
    var dx = this.o45_1.m46(this.r45_1.a44_1, nline);
    var dy = this.o45_1.d44(this.r45_1.b44_1, this.d46_1);
    var px = this.n46().g28_1 + this.s45_1.g28_1 - dx;
    var py = this.n46().h28_1 + this.s45_1.h28_1 + dy;
    var tmp0_safe_receiver = this.t45_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = tmp0_safe_receiver.i3i_1.r3u_1;
      try {
        // Inline function 'korlibs.image.font.<no name provided>.put.<anonymous>' call
        this.t45_1.o46(px, py);
        this.t45_1.q46(get_immutable(this.p46()));
        var tmp0_elvis_lhs = this.j46_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.u45_1 : tmp0_elvis_lhs;
        this.t45_1.o3v(tmp1_elvis_lhs == null ? NonePaint_instance : tmp1_elvis_lhs);
        var containsLower = this.v45_1;
        var containsUpper = this.w45_1;
        var containsArg = this.p45_1;
        if (containsLower <= containsArg ? containsArg < containsUpper : false) {
          this.r46().q3u(this.t45_1, this.q45_1, codePoint, Companion_getInstance_4().d2d_1, null, this.c46_1, reader, this.x45_1);
        }
        this.p45_1 = this.p45_1 + 1 | 0;
      }finally {
        tmp0_safe_receiver.i3i_1.r3u_1 = t;
      }
    }
    if (!(this.y45_1 == null)) {
      var glyph = new PlacedGlyphMetrics(codePoint, new Vector2D(px, py), this.c46_1.g1s(), this.d46_1.g1s(), this.p46(), this.y45_1.n(), nline);
      this.y45_1.j44(glyph);
    }
    var tmp1_safe_receiver = this.z45_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver(this, codePoint, new Vector2D(px, py), this.q45_1, this.c46_1, this.d46_1, this.p46());
    return this.c46_1;
  };
  function boundsPath$factory() {
    return getPropertyCallableRef('boundsPath', 1, KProperty1, function (receiver) {
      return receiver.w41();
    }, null);
  }
  function boundsPathCurves$factory() {
    return getPropertyCallableRef('boundsPathCurves', 1, KProperty1, function (receiver) {
      return receiver.x41();
    }, null);
  }
  function readFont(_this__u8e3s4, preload, props, mipmaps, $completion) {
    preload = preload === VOID ? false : preload;
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    mipmaps = mipmaps === VOID ? true : mipmaps;
    var tmp = new $readFontCOROUTINE$39(_this__u8e3s4, preload, props, mipmaps, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function $readFontCOROUTINE$39(_this__u8e3s4, preload, props, mipmaps, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h47_1 = _this__u8e3s4;
    this.i47_1 = preload;
    this.j47_1 = props;
    this.k47_1 = mipmaps;
  }
  protoOf($readFontCOROUTINE$39).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 5;
            this.fd_1 = 1;
            suspendResult = this.h47_1.o47(until(0, 16), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.l47_1 = suspendResult;
            this.m47_1 = getS32BE(this.l47_1, 0);
            if ((this.m47_1 === 1953784678 ? true : this.m47_1 === 1330926671) ? true : this.m47_1 === 65536) {
              this.fd_1 = 3;
              suspendResult = readTtfFont(this.h47_1, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 2;
              suspendResult = readBitmapFont(this.h47_1, this.j47_1, this.k47_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.n47_1 = suspendResult;
            this.fd_1 = 4;
            continue $sm;
          case 3:
            this.n47_1 = suspendResult;
            this.fd_1 = 4;
            continue $sm;
          case 4:
            return this.n47_1;
          case 5:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 5) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  var SystemFontRegistryOrNull;
  function GlyphPath(path, colorShape, bitmap, bitmapOffset, bitmapScale, transform, scale) {
    path = path === VOID ? new VectorPath() : path;
    colorShape = colorShape === VOID ? null : colorShape;
    bitmap = bitmap === VOID ? null : bitmap;
    bitmapOffset = bitmapOffset === VOID ? Vector2D_init_$Create$(0, 0) : bitmapOffset;
    bitmapScale = bitmapScale === VOID ? Scale_init_$Create$(1, 1) : bitmapScale;
    transform = transform === VOID ? Companion_getInstance_3().h2f() : transform;
    scale = scale === VOID ? 1.0 : scale;
    this.p47_1 = path;
    this.q47_1 = colorShape;
    this.r47_1 = bitmap;
    this.s47_1 = bitmapOffset;
    this.t47_1 = bitmapScale;
    this.u47_1 = transform;
    this.v47_1 = scale;
  }
  protoOf(GlyphPath).w47 = function () {
    return this.r47_1 == null ? this.q47_1 == null : false;
  };
  protoOf(GlyphPath).x47 = function (c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.i3i_1.r3u_1;
    try {
      // Inline function 'korlibs.image.font.GlyphPath.draw.<anonymous>' call
      c.q46(this.u47_1);
      if (!(this.r47_1 == null)) {
        c.q3v(ensureNotNull(this.r47_1), this.s47_1, toFloat(ensureNotNull(this.r47_1).n()).v2m(this.t47_1));
      } else if (!(this.q47_1 == null)) {
        c.y47(ensureNotNull(this.q47_1));
        c.c43();
      } else {
        draw_1(c, this.p47_1);
      }
    }finally {
      c.i3i_1.r3u_1 = t;
    }
  };
  protoOf(GlyphPath).toString = function () {
    return 'GlyphPath(path=' + this.p47_1 + ', colorShape=' + this.q47_1 + ', bitmap=' + this.r47_1 + ', bitmapOffset=' + this.s47_1 + ', bitmapScale=' + this.t47_1 + ', transform=' + this.u47_1 + ', scale=' + this.v47_1 + ')';
  };
  protoOf(GlyphPath).hashCode = function () {
    var result = this.p47_1.hashCode();
    result = imul(result, 31) + (this.q47_1 == null ? 0 : hashCode(this.q47_1)) | 0;
    result = imul(result, 31) + (this.r47_1 == null ? 0 : hashCode(this.r47_1)) | 0;
    result = imul(result, 31) + this.s47_1.hashCode() | 0;
    result = imul(result, 31) + this.t47_1.hashCode() | 0;
    result = imul(result, 31) + this.u47_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.v47_1) | 0;
    return result;
  };
  protoOf(GlyphPath).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!this.p47_1.equals(tmp0_other_with_cast.p47_1))
      return false;
    if (!equals(this.q47_1, tmp0_other_with_cast.q47_1))
      return false;
    if (!equals(this.r47_1, tmp0_other_with_cast.r47_1))
      return false;
    if (!this.s47_1.equals(tmp0_other_with_cast.s47_1))
      return false;
    if (!this.t47_1.equals(tmp0_other_with_cast.t47_1))
      return false;
    if (!this.u47_1.equals(tmp0_other_with_cast.u47_1))
      return false;
    if (!equals(this.v47_1, tmp0_other_with_cast.v47_1))
      return false;
    return true;
  };
  var lazyBitmap$delegate;
  function get_lazyBitmapSDF(_this__u8e3s4) {
    _init_properties_LazyBitmapFont_kt__76ptri();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var this_0 = lazyBitmapSDF$delegate;
      var property = lazyBitmapSDF$factory();
      var tmp0_elvis_lhs = this_0.l23_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = this_0.m23_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = this_0.l23_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var lazyBitmapSDF$delegate;
  function Companion_16() {
    Companion_instance_24 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp.z47_1 = new Int32Array([tmp$ret$0]);
  }
  var Companion_instance_24;
  function Companion_getInstance_31() {
    if (Companion_instance_24 == null)
      new Companion_16();
    return Companion_instance_24;
  }
  function LazyBitmapFont$anyGlyph$delegate$lambda(this$0) {
    return function () {
      var tmp0_elvis_lhs = this$0.i48_1.f1(this$0.i48_1.g2().u().x());
      return tmp0_elvis_lhs == null ? this$0.h3w() : tmp0_elvis_lhs;
    };
  }
  function LazyBitmapFont$invalidGlyph$delegate$lambda(this$0) {
    return function () {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      return new Glyph(this$0.b48_1, -1, tmp$ret$0, 0, 0, 0);
    };
  }
  function LazyBitmapFont$naturalFontMetrics$delegate$lambda(this$0) {
    return function () {
      var descent = this$0.f48_1.y3t_1 - this$0.f48_1.a3u_1;
      var tmp0_size = this$0.f48_1.u3t_1;
      var tmp1_top = this$0.f48_1.v3t_1;
      var tmp2_ascent = this$0.f48_1.w3t_1;
      var tmp3_baseline = this$0.f48_1.x3t_1;
      var tmp4_maxWidth = this$0.f48_1.b3u_1;
      return new FontMetrics(tmp0_size, tmp1_top, tmp2_ascent, tmp3_baseline, descent, descent, 0.0, tmp4_maxWidth, 0.0);
    };
  }
  function LazyBitmapFont(font, fontSize, distanceField) {
    Companion_getInstance_31();
    distanceField = distanceField === VOID ? null : distanceField;
    this.a48_1 = font;
    this.b48_1 = fontSize;
    this.c48_1 = distanceField;
    this.d48_1 = new Mixin();
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = MutableAtlas_init_$Create$(1024, 1024, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.LazyBitmapFont.atlas.<anonymous>' call
    if (this.c48_1 == null) {
      mipmaps(this_0.l39_1);
    }
    tmp.e48_1 = this_0;
    this.f48_1 = this.a48_1.e3u(this.b48_1);
    this.g48_1 = this.f48_1.l3t();
    this.h48_1 = this.f48_1.x3t_1;
    this.i48_1 = IntMap_init_$Create$();
    this.j48_1 = IntMap_init_$Create$();
    var tmp_0 = this;
    tmp_0.k48_1 = lazy(LazyBitmapFont$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.l48_1 = lazy(LazyBitmapFont$invalidGlyph$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.m48_1 = lazy(LazyBitmapFont$naturalFontMetrics$delegate$lambda(this));
    this.n48_1 = new GlyphMetrics(this.b48_1, false, 0, Companion_getInstance_2().h2f(), 0.0);
  }
  protoOf(LazyBitmapFont).k3t = function () {
    return this.b48_1;
  };
  protoOf(LazyBitmapFont).m3t = function () {
    return this.c48_1;
  };
  protoOf(LazyBitmapFont).h23 = function (_set____db54di) {
    this.d48_1.h23(_set____db54di);
  };
  protoOf(LazyBitmapFont).i23 = function () {
    return this.d48_1.i23();
  };
  protoOf(LazyBitmapFont).l3t = function () {
    return this.g48_1;
  };
  protoOf(LazyBitmapFont).v2x = function () {
    return this.h48_1;
  };
  protoOf(LazyBitmapFont).n3t = function () {
    return this.i48_1;
  };
  protoOf(LazyBitmapFont).o3t = function () {
    return this.j48_1;
  };
  protoOf(LazyBitmapFont).q3t = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.k48_1;
    anyGlyph$factory_0();
    return this_0.m2();
  };
  protoOf(LazyBitmapFont).h3w = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l48_1;
    invalidGlyph$factory_0();
    return this_0.m2();
  };
  protoOf(LazyBitmapFont).zb = function () {
    return this.a48_1.zb();
  };
  protoOf(LazyBitmapFont).r3t = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m48_1;
    naturalFontMetrics$factory_0();
    return this_0.m2();
  };
  protoOf(LazyBitmapFont).s3t = function () {
    return this.n48_1;
  };
  protoOf(LazyBitmapFont).o3u = function (first, second) {
    var kerning = this.a48_1.s3v(this.b48_1, first, second);
    var tmp;
    if (kerning === 0.0) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.j48_1;
      var key = Companion_instance_22.x3s(first, second);
      var res = this_0.f1(key);
      if (res == null) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.getKerning.<anonymous>' call
        var tmp$ret$0 = new Kerning(first, second, numberToInt(kerning));
        this_0.r1w(key, tmp$ret$0);
      }
      tmp = ensureNotNull(this_0.f1(key));
    }
    return tmp;
  };
  protoOf(LazyBitmapFont).g3u = function (codePoint) {
    if (this.i48_1.f1(codePoint) == null) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(97);
      var tmp = Char__toInt_impl_vasixd(this_0);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(122);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      this.o48(codePoint, numberRangeToNumber(tmp, tmp$ret$1));
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var tmp_0 = Char__toInt_impl_vasixd(this_2);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      this.o48(codePoint, numberRangeToNumber(tmp_0, tmp$ret$3));
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(48);
      var tmp_1 = Char__toInt_impl_vasixd(this_4);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(57);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
      this.o48(codePoint, numberRangeToNumber(tmp_1, tmp$ret$5));
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$6 = new Int32Array([codePoint]);
      this.p48(tmp$ret$6);
    }
    return this.i48_1.f1(codePoint);
  };
  protoOf(LazyBitmapFont).o48 = function (codePoint, range) {
    var containsLower = range.fb_1;
    if (codePoint <= range.gb_1 ? containsLower <= codePoint : false) {
      // Inline function 'korlibs.datastructure.toIntList' call
      // Inline function 'kotlin.also' call
      var this_0 = new IntArrayList(coerceAtLeast(range.i9() - range.h9() | 0, 0));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.toIntList.<anonymous>' call
      var inductionVariable = range.h9();
      var last = range.i9();
      if (inductionVariable <= last)
        do {
          var v = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.m1s(v);
        }
         while (!(v === last));
      this.p48(this_0.x1s());
    }
  };
  protoOf(LazyBitmapFont).p48 = function (codePoints) {
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var this_0 = this.e48_1.l39_1;
    var rect = this_0.y39_1;
    if (true) {
      this_0.h3a();
    }
    var result;
    try {
      // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>' call
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < codePoints.length) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var codePoint = codePoints[tmp0];
        // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
        var this_1 = this.i48_1;
        var res = this_1.f1(codePoint);
        if (res == null) {
          // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          if (!(this.c48_1 == null)) {
            // Inline function 'kotlin.math.max' call
            var b = toIntCeil_0(this.b48_1 / 8.0);
            tmp = Math.max(4, b);
          } else {
            tmp = 1;
          }
          var border = tmp;
          var tmp0_$receiver = this.a48_1;
          var tmp1_size = this.b48_1;
          var tmp2_paint = Colors_getInstance().l3b_1;
          var result_0 = renderGlyphToBitmap(tmp0_$receiver, tmp1_size, codePoint, new RGBA(tmp2_paint), true, null, border);
          var bmp = result_0.u40_1.g3a();
          var rbmp;
          switch (this.c48_1) {
            case 'msdf':
              rbmp = msdfBmp(ensureNotNull(result_0.z40_1).q48(), bmp.t39_1, bmp.u39_1);
              break;
            case 'sdf':
              rbmp = sdfBmp(ensureNotNull(result_0.z40_1).q48(), bmp.t39_1, bmp.u39_1);
              break;
            default:
              rbmp = bmp;
              break;
          }
          var entry = this.e48_1.s39(rbmp, Unit_instance);
          var slice = entry.d39_1.b2y(border, border, entry.d39_1.v2w_1 - border | 0, entry.d39_1.w2w_1 - border | 0);
          var g = first_0(result_0.x40_1);
          var m = g.n41_1;
          var xadvance = m.l3u_1;
          var tmp$ret$1 = new Glyph(this.b48_1, codePoint, slice, -toIntRound(g.m41_1.g28_1) | 0, -toIntRound(g.m41_1.h28_1) | 0, toIntRound(xadvance));
          this_1.r1w(codePoint, tmp$ret$1);
        }
        ensureNotNull(this_1.f1(codePoint));
      }
    }finally {
      result = true ? this_0.z3a(rect) : 0;
    }
  };
  function toLazyBitmapFont(_this__u8e3s4, fontSize, distanceField) {
    distanceField = distanceField === VOID ? null : distanceField;
    _init_properties_LazyBitmapFont_kt__76ptri();
    return new LazyBitmapFont(_this__u8e3s4, fontSize, distanceField);
  }
  function lazyBitmap$delegate$lambda($this$$receiver) {
    _init_properties_LazyBitmapFont_kt__76ptri();
    return toLazyBitmapFont($this$$receiver, 32.0, null);
  }
  function lazyBitmapSDF$delegate$lambda($this$$receiver) {
    _init_properties_LazyBitmapFont_kt__76ptri();
    return toLazyBitmapFont($this$$receiver, 32.0, 'sdf');
  }
  function lazyBitmapSDF$factory() {
    return getPropertyCallableRef('lazyBitmapSDF', 1, KProperty1, function (receiver) {
      return get_lazyBitmapSDF(receiver);
    }, null);
  }
  function anyGlyph$factory_0() {
    return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
      return receiver.q3t();
    }, null);
  }
  function invalidGlyph$factory_0() {
    return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
      return receiver.h3w();
    }, null);
  }
  function naturalFontMetrics$factory_0() {
    return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
      return receiver.r3t();
    }, null);
  }
  var properties_initialized_LazyBitmapFont_kt_c74u44;
  function _init_properties_LazyBitmapFont_kt__76ptri() {
    if (!properties_initialized_LazyBitmapFont_kt_c74u44) {
      properties_initialized_LazyBitmapFont_kt_c74u44 = true;
      lazyBitmap$delegate = new PropertyThis(VOID, lazyBitmap$delegate$lambda);
      lazyBitmapSDF$delegate = new PropertyThis(VOID, lazyBitmapSDF$delegate$lambda);
    }
  }
  function FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.u3t_1 = size;
    this.v3t_1 = top;
    this.w3t_1 = ascent;
    this.x3t_1 = baseline;
    this.y3t_1 = descent;
    this.z3t_1 = bottom;
    this.a3u_1 = lineGap;
    this.b3u_1 = maxWidth;
    this.c3u_1 = unitsPerEm;
  }
  protoOf(FontMetrics).r48 = function () {
    // Inline function 'kotlin.math.max' call
    var a = this.w3t_1;
    var b = this.v3t_1;
    return Math.max(a, b);
  };
  protoOf(FontMetrics).s48 = function () {
    // Inline function 'kotlin.math.min' call
    var a = this.y3t_1;
    var b = this.z3t_1;
    return Math.min(a, b);
  };
  protoOf(FontMetrics).t48 = function () {
    return this.r48() - this.s48();
  };
  protoOf(FontMetrics).l3t = function () {
    return this.t48() + this.a3u_1;
  };
  protoOf(FontMetrics).j43 = function (other) {
    return this.u48(other, 1.0);
  };
  protoOf(FontMetrics).d3u = function (other, size) {
    return this.u48(other, size / other.u3t_1);
  };
  protoOf(FontMetrics).u48 = function (other, scale) {
    this.u3t_1 = other.u3t_1 * scale;
    this.v3t_1 = other.v3t_1 * scale;
    this.w3t_1 = other.w3t_1 * scale;
    this.x3t_1 = other.x3t_1 * scale;
    this.y3t_1 = other.y3t_1 * scale;
    this.z3t_1 = other.z3t_1 * scale;
    this.a3u_1 = other.a3u_1 * scale;
    this.c3u_1 = other.c3u_1 * scale;
    this.b3u_1 = other.b3u_1 * scale;
    return this;
  };
  protoOf(FontMetrics).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FontMetrics.toString.<anonymous>' call
    this_0.u5('FontMetrics(');
    this_0.u5('size=' + niceStr(this.u3t_1, 1) + ', ');
    this_0.u5('top=' + niceStr(this.v3t_1, 1) + ', ');
    this_0.u5('ascent=' + niceStr(this.w3t_1, 1) + ', ');
    this_0.u5('baseline=' + niceStr(this.x3t_1, 1) + ', ');
    this_0.u5('descent=' + niceStr(this.y3t_1, 1) + ', ');
    this_0.u5('bottom=' + niceStr(this.z3t_1, 1) + ', ');
    this_0.u5('lineGap=' + niceStr(this.a3u_1, 1) + ', ');
    this_0.u5('unitsPerEm=' + niceStr(this.c3u_1, 1) + ', ');
    this_0.u5('maxWidth=' + niceStr(this.b3u_1, 1) + ', ');
    this_0.u5('lineHeight=' + niceStr(this.l3t(), 1));
    this_0.u5(')');
    return this_0.toString();
  };
  protoOf(FontMetrics).g1s = function () {
    return this.v48();
  };
  protoOf(FontMetrics).w48 = function (size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    return new FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  };
  protoOf(FontMetrics).v48 = function (size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm, $super) {
    size = size === VOID ? this.u3t_1 : size;
    top = top === VOID ? this.v3t_1 : top;
    ascent = ascent === VOID ? this.w3t_1 : ascent;
    baseline = baseline === VOID ? this.x3t_1 : baseline;
    descent = descent === VOID ? this.y3t_1 : descent;
    bottom = bottom === VOID ? this.z3t_1 : bottom;
    lineGap = lineGap === VOID ? this.a3u_1 : lineGap;
    maxWidth = maxWidth === VOID ? this.b3u_1 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? this.c3u_1 : unitsPerEm;
    return $super === VOID ? this.w48(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) : $super.w48.call(this, size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  };
  protoOf(FontMetrics).hashCode = function () {
    var result = getNumberHashCode(this.u3t_1);
    result = imul(result, 31) + getNumberHashCode(this.v3t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w3t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x3t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y3t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z3t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a3u_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b3u_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c3u_1) | 0;
    return result;
  };
  protoOf(FontMetrics).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.u3t_1, tmp0_other_with_cast.u3t_1))
      return false;
    if (!equals(this.v3t_1, tmp0_other_with_cast.v3t_1))
      return false;
    if (!equals(this.w3t_1, tmp0_other_with_cast.w3t_1))
      return false;
    if (!equals(this.x3t_1, tmp0_other_with_cast.x3t_1))
      return false;
    if (!equals(this.y3t_1, tmp0_other_with_cast.y3t_1))
      return false;
    if (!equals(this.z3t_1, tmp0_other_with_cast.z3t_1))
      return false;
    if (!equals(this.a3u_1, tmp0_other_with_cast.a3u_1))
      return false;
    if (!equals(this.b3u_1, tmp0_other_with_cast.b3u_1))
      return false;
    if (!equals(this.c3u_1, tmp0_other_with_cast.c3u_1))
      return false;
    return true;
  };
  function GlyphMetrics(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_2().h2f() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.h3u_1 = size;
    this.i3u_1 = existing;
    this.j3u_1 = codePoint;
    this.k3u_1 = bounds;
    this.l3u_1 = xadvance;
  }
  protoOf(GlyphMetrics).u2d = function () {
    return this.k3u_1.u2d();
  };
  protoOf(GlyphMetrics).r2d = function () {
    return this.k3u_1.r2d();
  };
  protoOf(GlyphMetrics).t2d = function () {
    return this.k3u_1.t2d();
  };
  protoOf(GlyphMetrics).x1q = function () {
    return this.k3u_1.n2d_1;
  };
  protoOf(GlyphMetrics).y1q = function () {
    return this.k3u_1.o2d_1;
  };
  protoOf(GlyphMetrics).g1s = function () {
    return this.x48(VOID, VOID, VOID, this.k3u_1.g1s());
  };
  protoOf(GlyphMetrics).m3u = function (other, size, codePoint) {
    return this.y48(other, size / other.h3u_1, codePoint);
  };
  protoOf(GlyphMetrics).y48 = function (other, scale, codePoint) {
    this.h3u_1 = other.h3u_1;
    this.i3u_1 = other.i3u_1;
    this.j3u_1 = codePoint;
    this.k3u_1 = other.k3u_1.z2k(scale);
    this.l3u_1 = other.l3u_1 * scale;
    return this;
  };
  protoOf(GlyphMetrics).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.GlyphMetrics.toString.<anonymous>' call
    this_0.u5('GlyphMetrics(');
    this_0.u5('codePoint=' + this.j3u_1 + " ('" + toString_0(numberToChar(this.j3u_1)) + "'), ");
    this_0.u5('existing=' + this.i3u_1 + ', ');
    this_0.u5('xadvance=' + roundToInt(this.l3u_1) + ', ');
    this_0.u5('bounds=' + this.k3u_1.kb());
    this_0.u5(')');
    return this_0.toString();
  };
  protoOf(GlyphMetrics).z48 = function (size, existing, codePoint, bounds, xadvance) {
    return new GlyphMetrics(size, existing, codePoint, bounds, xadvance);
  };
  protoOf(GlyphMetrics).x48 = function (size, existing, codePoint, bounds, xadvance, $super) {
    size = size === VOID ? this.h3u_1 : size;
    existing = existing === VOID ? this.i3u_1 : existing;
    codePoint = codePoint === VOID ? this.j3u_1 : codePoint;
    bounds = bounds === VOID ? this.k3u_1 : bounds;
    xadvance = xadvance === VOID ? this.l3u_1 : xadvance;
    return $super === VOID ? this.z48(size, existing, codePoint, bounds, xadvance) : $super.z48.call(this, size, existing, codePoint, bounds, xadvance);
  };
  protoOf(GlyphMetrics).hashCode = function () {
    var result = getNumberHashCode(this.h3u_1);
    result = imul(result, 31) + getBooleanHashCode(this.i3u_1) | 0;
    result = imul(result, 31) + this.j3u_1 | 0;
    result = imul(result, 31) + this.k3u_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.l3u_1) | 0;
    return result;
  };
  protoOf(GlyphMetrics).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.h3u_1, tmp0_other_with_cast.h3u_1))
      return false;
    if (!(this.i3u_1 === tmp0_other_with_cast.i3u_1))
      return false;
    if (!(this.j3u_1 === tmp0_other_with_cast.j3u_1))
      return false;
    if (!this.k3u_1.equals(tmp0_other_with_cast.k3u_1))
      return false;
    if (!equals(this.l3u_1, tmp0_other_with_cast.l3u_1))
      return false;
    return true;
  };
  function TextMetrics(bounds, lineBounds, fontMetrics, nlines) {
    bounds = bounds === VOID ? Companion_getInstance_2().h2f() : bounds;
    lineBounds = lineBounds === VOID ? emptyList() : lineBounds;
    fontMetrics = fontMetrics === VOID ? new FontMetrics() : fontMetrics;
    nlines = nlines === VOID ? 0 : nlines;
    this.f43_1 = bounds;
    this.g43_1 = lineBounds;
    this.h43_1 = fontMetrics;
    this.i43_1 = nlines;
  }
  protoOf(TextMetrics).a49 = function () {
    var tmp0_elvis_lhs = firstOrNull_0(this.g43_1);
    return tmp0_elvis_lhs == null ? Companion_getInstance_2().w2d_1 : tmp0_elvis_lhs;
  };
  protoOf(TextMetrics).r2d = function () {
    return this.f43_1.r2d();
  };
  protoOf(TextMetrics).t2d = function () {
    return this.f43_1.t2d();
  };
  protoOf(TextMetrics).x1q = function () {
    return this.f43_1.n2d_1;
  };
  protoOf(TextMetrics).y1q = function () {
    return this.f43_1.o2d_1;
  };
  protoOf(TextMetrics).b49 = function () {
    return -this.r2d();
  };
  protoOf(TextMetrics).c49 = function () {
    return this.a49().o2d_1 + this.a49().t2d();
  };
  protoOf(TextMetrics).i44 = function () {
    return this.h43_1.w3t_1;
  };
  protoOf(TextMetrics).toString = function () {
    return 'TextMetrics[' + get_niceStr_0(this.r2d()) + ', ' + get_niceStr_0(this.t2d()) + ', ' + get_niceStr_0(this.x1q()) + ', ' + get_niceStr_0(this.y1q()) + '][' + get_niceStr_0(this.b49()) + ', ' + get_niceStr_0(this.c49()) + ']';
  };
  protoOf(TextMetrics).hashCode = function () {
    var result = this.f43_1.hashCode();
    result = imul(result, 31) + hashCode(this.g43_1) | 0;
    result = imul(result, 31) + this.h43_1.hashCode() | 0;
    result = imul(result, 31) + this.i43_1 | 0;
    return result;
  };
  protoOf(TextMetrics).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetrics ? other : THROW_CCE();
    if (!this.f43_1.equals(tmp0_other_with_cast.f43_1))
      return false;
    if (!equals(this.g43_1, tmp0_other_with_cast.g43_1))
      return false;
    if (!this.h43_1.equals(tmp0_other_with_cast.h43_1))
      return false;
    if (!(this.i43_1 === tmp0_other_with_cast.i43_1))
      return false;
    return true;
  };
  var _nativeSystemFontProvider;
  function DataIndex_init_$Init$($this) {
    // Inline function 'kotlin.intArrayOf' call
    var tmp = new Int32Array([0]);
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$1 = new Int8Array([]);
    DataIndex.call($this, tmp, tmp$ret$1);
    return $this;
  }
  function DataIndex_init_$Create$() {
    return DataIndex_init_$Init$(objectCreate(protoOf(DataIndex)));
  }
  var Op_version_instance;
  var Op_Copyright_instance;
  var Op_Notice_instance;
  var Op_isFixedPitch_instance;
  var Op_FullName_instance;
  var Op_ItalicAngle_instance;
  var Op_FamilyName_instance;
  var Op_UnderlinePosition_instance;
  var Op_Weight_instance;
  var Op_UnderlineThickness_instance;
  var Op_FontBBox_instance;
  var Op_PaintType_instance;
  var Op_BlueValues_instance;
  var Op_CharstringType_instance;
  var Op_OtherBlues_instance;
  var Op_FontMatrix_instance;
  var Op_FamilyBlues_instance;
  var Op_StrokeWidth_instance;
  var Op_FamilyOtherBlues_instance;
  var Op_BlueScale_instance;
  var Op_StdHW_instance;
  var Op_BlueShift_instance;
  var Op_StdVW_instance;
  var Op_BlueFuzz_instance;
  var Op_StemSnapH_instance;
  var Op_UniqueID_instance;
  var Op_StemSnapV_instance;
  var Op_XUID_instance;
  var Op_ForceBold_instance;
  var Op_charset_instance;
  var Op_Encoding_instance;
  var Op_CharStrings_instance;
  var Op_LanguageGroup_instance;
  var Op_Private_instance;
  var Op_ExpansionFactor_instance;
  var Op_Subrs_instance;
  var Op_initialRandomSeed_instance;
  var Op_defaultWidthX_instance;
  var Op_SyntheicBase_instance;
  var Op_nominalWidthX_instance;
  var Op_PostScript_instance;
  var Op_vsindex_instance;
  var Op_BaseFontName_instance;
  var Op_blend_instance;
  var Op_BaseFontBlend_instance;
  var Op_vstore_instance;
  var Op_maxstack_instance;
  var Op_ROS_instance;
  var Op_CIDFontVersion_instance;
  var Op_CIDFontRevision_instance;
  var Op_CIDFontType_instance;
  var Op_CIDCount_instance;
  var Op_UIDBase_instance;
  var Op_FDArray_instance;
  var Op_FDSelect_instance;
  var Op_FontName_instance;
  function Companion_17() {
    Companion_instance_25 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_0();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.VALUES_BY_ID.<anonymous>' call
      var tmp$ret$0 = element.f49_1;
      destination.i2(tmp$ret$0, element);
    }
    tmp.g49_1 = toIntMap(destination);
  }
  protoOf(Companion_17).f1 = function (id) {
    return this.g49_1.f1(id);
  };
  var Companion_instance_25;
  function Companion_getInstance_32() {
    Op_initEntries();
    if (Companion_instance_25 == null)
      new Companion_17();
    return Companion_instance_25;
  }
  function values_0() {
    return [Op_version_getInstance(), Op_Copyright_getInstance(), Op_Notice_getInstance(), Op_isFixedPitch_getInstance(), Op_FullName_getInstance(), Op_ItalicAngle_getInstance(), Op_FamilyName_getInstance(), Op_UnderlinePosition_getInstance(), Op_Weight_getInstance(), Op_UnderlineThickness_getInstance(), Op_FontBBox_getInstance(), Op_PaintType_getInstance(), Op_BlueValues_getInstance(), Op_CharstringType_getInstance(), Op_OtherBlues_getInstance(), Op_FontMatrix_getInstance(), Op_FamilyBlues_getInstance(), Op_StrokeWidth_getInstance(), Op_FamilyOtherBlues_getInstance(), Op_BlueScale_getInstance(), Op_StdHW_getInstance(), Op_BlueShift_getInstance(), Op_StdVW_getInstance(), Op_BlueFuzz_getInstance(), Op_StemSnapH_getInstance(), Op_UniqueID_getInstance(), Op_StemSnapV_getInstance(), Op_XUID_getInstance(), Op_ForceBold_getInstance(), Op_charset_getInstance(), Op_Encoding_getInstance(), Op_CharStrings_getInstance(), Op_LanguageGroup_getInstance(), Op_Private_getInstance(), Op_ExpansionFactor_getInstance(), Op_Subrs_getInstance(), Op_initialRandomSeed_getInstance(), Op_defaultWidthX_getInstance(), Op_SyntheicBase_getInstance(), Op_nominalWidthX_getInstance(), Op_PostScript_getInstance(), Op_vsindex_getInstance(), Op_BaseFontName_getInstance(), Op_blend_getInstance(), Op_BaseFontBlend_getInstance(), Op_vstore_getInstance(), Op_maxstack_getInstance(), Op_ROS_getInstance(), Op_CIDFontVersion_getInstance(), Op_CIDFontRevision_getInstance(), Op_CIDFontType_getInstance(), Op_CIDCount_getInstance(), Op_UIDBase_getInstance(), Op_FDArray_getInstance(), Op_FDSelect_getInstance(), Op_FontName_getInstance()];
  }
  var Op_entriesInitialized;
  function Op_initEntries() {
    if (Op_entriesInitialized)
      return Unit_instance;
    Op_entriesInitialized = true;
    Op_version_instance = new Op('version', 0, 0);
    Op_Copyright_instance = new Op('Copyright', 1, 3072);
    Op_Notice_instance = new Op('Notice', 2, 1);
    Op_isFixedPitch_instance = new Op('isFixedPitch', 3, 3073);
    Op_FullName_instance = new Op('FullName', 4, 2);
    Op_ItalicAngle_instance = new Op('ItalicAngle', 5, 3074);
    Op_FamilyName_instance = new Op('FamilyName', 6, 3);
    Op_UnderlinePosition_instance = new Op('UnderlinePosition', 7, 3075);
    Op_Weight_instance = new Op('Weight', 8, 4);
    Op_UnderlineThickness_instance = new Op('UnderlineThickness', 9, 3076);
    Op_FontBBox_instance = new Op('FontBBox', 10, 5);
    Op_PaintType_instance = new Op('PaintType', 11, 3077);
    Op_BlueValues_instance = new Op('BlueValues', 12, 6);
    Op_CharstringType_instance = new Op('CharstringType', 13, 3078);
    Op_OtherBlues_instance = new Op('OtherBlues', 14, 7);
    Op_FontMatrix_instance = new Op('FontMatrix', 15, 3079);
    Op_FamilyBlues_instance = new Op('FamilyBlues', 16, 8);
    Op_StrokeWidth_instance = new Op('StrokeWidth', 17, 3080);
    Op_FamilyOtherBlues_instance = new Op('FamilyOtherBlues', 18, 9);
    Op_BlueScale_instance = new Op('BlueScale', 19, 3081);
    Op_StdHW_instance = new Op('StdHW', 20, 10);
    Op_BlueShift_instance = new Op('BlueShift', 21, 3082);
    Op_StdVW_instance = new Op('StdVW', 22, 11);
    Op_BlueFuzz_instance = new Op('BlueFuzz', 23, 3083);
    Op_StemSnapH_instance = new Op('StemSnapH', 24, 3084);
    Op_UniqueID_instance = new Op('UniqueID', 25, 13);
    Op_StemSnapV_instance = new Op('StemSnapV', 26, 3085);
    Op_XUID_instance = new Op('XUID', 27, 14);
    Op_ForceBold_instance = new Op('ForceBold', 28, 3086);
    Op_charset_instance = new Op('charset', 29, 15);
    Op_Encoding_instance = new Op('Encoding', 30, 16);
    Op_CharStrings_instance = new Op('CharStrings', 31, 17);
    Op_LanguageGroup_instance = new Op('LanguageGroup', 32, 3089);
    Op_Private_instance = new Op('Private', 33, 18);
    Op_ExpansionFactor_instance = new Op('ExpansionFactor', 34, 3090);
    Op_Subrs_instance = new Op('Subrs', 35, 19);
    Op_initialRandomSeed_instance = new Op('initialRandomSeed', 36, 3091);
    Op_defaultWidthX_instance = new Op('defaultWidthX', 37, 20);
    Op_SyntheicBase_instance = new Op('SyntheicBase', 38, 3092);
    Op_nominalWidthX_instance = new Op('nominalWidthX', 39, 21);
    Op_PostScript_instance = new Op('PostScript', 40, 3093);
    Op_vsindex_instance = new Op('vsindex', 41, 22);
    Op_BaseFontName_instance = new Op('BaseFontName', 42, 3094);
    Op_blend_instance = new Op('blend', 43, 23);
    Op_BaseFontBlend_instance = new Op('BaseFontBlend', 44, 3095);
    Op_vstore_instance = new Op('vstore', 45, 24);
    Op_maxstack_instance = new Op('maxstack', 46, 25);
    Op_ROS_instance = new Op('ROS', 47, 3102);
    Op_CIDFontVersion_instance = new Op('CIDFontVersion', 48, 3103);
    Op_CIDFontRevision_instance = new Op('CIDFontRevision', 49, 3104);
    Op_CIDFontType_instance = new Op('CIDFontType', 50, 3105);
    Op_CIDCount_instance = new Op('CIDCount', 51, 3106);
    Op_UIDBase_instance = new Op('UIDBase', 52, 3107);
    Op_FDArray_instance = new Op('FDArray', 53, 3108);
    Op_FDSelect_instance = new Op('FDSelect', 54, 3109);
    Op_FontName_instance = new Op('FontName', 55, 3110);
    Companion_getInstance_32();
  }
  function GlyphPath_0(path, advanceWidth) {
    this.h49_1 = path;
    this.i49_1 = advanceWidth;
  }
  protoOf(GlyphPath_0).toString = function () {
    return 'GlyphPath(path=' + this.h49_1 + ', advanceWidth=' + this.i49_1 + ')';
  };
  protoOf(GlyphPath_0).hashCode = function () {
    var result = this.h49_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.i49_1) | 0;
    return result;
  };
  protoOf(GlyphPath_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath_0))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath_0 ? other : THROW_CCE();
    if (!this.h49_1.equals(tmp0_other_with_cast.h49_1))
      return false;
    if (!equals(this.i49_1, tmp0_other_with_cast.i49_1))
      return false;
    return true;
  };
  function CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict) {
    this.j49_1 = charstringsIndex;
    this.k49_1 = globalSubrIndex;
    this.l49_1 = localSubrsIndex;
    this.m49_1 = privateDict;
    var tmp = this;
    var tmp0_safe_receiver = this.m49_1.s2(Op_defaultWidthX_getInstance());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : numberToDouble(tmp1_safe_receiver);
    tmp.n49_1 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
    var tmp_0 = this;
    var tmp0_safe_receiver_0 = this.m49_1.s2(Op_nominalWidthX_getInstance());
    var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : firstOrNull_0(tmp0_safe_receiver_0);
    var tmp2_elvis_lhs_0 = tmp1_safe_receiver_0 == null ? null : numberToDouble(tmp1_safe_receiver_0);
    tmp_0.o49_1 = tmp2_elvis_lhs_0 == null ? 0.0 : tmp2_elvis_lhs_0;
  }
  protoOf(CFFResult).p49 = function (index, flipY) {
    var evalCtx = new EvalContext(this.k49_1, this.l49_1, this.n49_1, this.o49_1, index);
    var vp = new VectorPath();
    var bytes = this.j49_1.f1(index);
    CharStringType2_instance.s49(vp, openFastStream(bytes), evalCtx);
    if (flipY) {
      vp.m34(1.0, -1.0);
    }
    return new GlyphPath_0(vp, evalCtx.c4a_1);
  };
  protoOf(CFFResult).e4a = function (index, flipY, $super) {
    flipY = flipY === VOID ? true : flipY;
    return $super === VOID ? this.p49(index, flipY) : $super.p49.call(this, index, flipY);
  };
  function DataIndex(offsets, bytes) {
    this.q49_1 = offsets;
    this.r49_1 = bytes;
  }
  protoOf(DataIndex).n = function () {
    return this.q49_1.length - 1 | 0;
  };
  protoOf(DataIndex).f4a = function (index) {
    return this.q49_1[index + 1 | 0] - this.q49_1[index] | 0;
  };
  protoOf(DataIndex).f1 = function (index) {
    return copyOfRange(this.r49_1, this.q49_1[index], this.q49_1[index + 1 | 0]);
  };
  protoOf(DataIndex).g4a = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.n());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.image.font.DataIndex.toList.<anonymous>' call
      var tmp$ret$0 = this.f1(item);
      destination.r(tmp$ret$0);
    }
    return destination;
  };
  protoOf(DataIndex).u = function () {
    return this.g4a().u();
  };
  protoOf(DataIndex).toString = function () {
    var tmp = this.n();
    var tmp_0 = toList_0(this.q49_1);
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.n());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.image.font.DataIndex.toString.<anonymous>' call
      var tmp$ret$0 = this.f4a(item);
      destination.r(tmp$ret$0);
    }
    return 'DataIndex[' + tmp + '](' + tmp_0 + ')(' + destination + ')';
  };
  function Op(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this.f49_1 = id;
  }
  function Op_version_getInstance() {
    Op_initEntries();
    return Op_version_instance;
  }
  function Op_Copyright_getInstance() {
    Op_initEntries();
    return Op_Copyright_instance;
  }
  function Op_Notice_getInstance() {
    Op_initEntries();
    return Op_Notice_instance;
  }
  function Op_isFixedPitch_getInstance() {
    Op_initEntries();
    return Op_isFixedPitch_instance;
  }
  function Op_FullName_getInstance() {
    Op_initEntries();
    return Op_FullName_instance;
  }
  function Op_ItalicAngle_getInstance() {
    Op_initEntries();
    return Op_ItalicAngle_instance;
  }
  function Op_FamilyName_getInstance() {
    Op_initEntries();
    return Op_FamilyName_instance;
  }
  function Op_UnderlinePosition_getInstance() {
    Op_initEntries();
    return Op_UnderlinePosition_instance;
  }
  function Op_Weight_getInstance() {
    Op_initEntries();
    return Op_Weight_instance;
  }
  function Op_UnderlineThickness_getInstance() {
    Op_initEntries();
    return Op_UnderlineThickness_instance;
  }
  function Op_FontBBox_getInstance() {
    Op_initEntries();
    return Op_FontBBox_instance;
  }
  function Op_PaintType_getInstance() {
    Op_initEntries();
    return Op_PaintType_instance;
  }
  function Op_BlueValues_getInstance() {
    Op_initEntries();
    return Op_BlueValues_instance;
  }
  function Op_CharstringType_getInstance() {
    Op_initEntries();
    return Op_CharstringType_instance;
  }
  function Op_OtherBlues_getInstance() {
    Op_initEntries();
    return Op_OtherBlues_instance;
  }
  function Op_FontMatrix_getInstance() {
    Op_initEntries();
    return Op_FontMatrix_instance;
  }
  function Op_FamilyBlues_getInstance() {
    Op_initEntries();
    return Op_FamilyBlues_instance;
  }
  function Op_StrokeWidth_getInstance() {
    Op_initEntries();
    return Op_StrokeWidth_instance;
  }
  function Op_FamilyOtherBlues_getInstance() {
    Op_initEntries();
    return Op_FamilyOtherBlues_instance;
  }
  function Op_BlueScale_getInstance() {
    Op_initEntries();
    return Op_BlueScale_instance;
  }
  function Op_StdHW_getInstance() {
    Op_initEntries();
    return Op_StdHW_instance;
  }
  function Op_BlueShift_getInstance() {
    Op_initEntries();
    return Op_BlueShift_instance;
  }
  function Op_StdVW_getInstance() {
    Op_initEntries();
    return Op_StdVW_instance;
  }
  function Op_BlueFuzz_getInstance() {
    Op_initEntries();
    return Op_BlueFuzz_instance;
  }
  function Op_StemSnapH_getInstance() {
    Op_initEntries();
    return Op_StemSnapH_instance;
  }
  function Op_UniqueID_getInstance() {
    Op_initEntries();
    return Op_UniqueID_instance;
  }
  function Op_StemSnapV_getInstance() {
    Op_initEntries();
    return Op_StemSnapV_instance;
  }
  function Op_XUID_getInstance() {
    Op_initEntries();
    return Op_XUID_instance;
  }
  function Op_ForceBold_getInstance() {
    Op_initEntries();
    return Op_ForceBold_instance;
  }
  function Op_charset_getInstance() {
    Op_initEntries();
    return Op_charset_instance;
  }
  function Op_Encoding_getInstance() {
    Op_initEntries();
    return Op_Encoding_instance;
  }
  function Op_CharStrings_getInstance() {
    Op_initEntries();
    return Op_CharStrings_instance;
  }
  function Op_LanguageGroup_getInstance() {
    Op_initEntries();
    return Op_LanguageGroup_instance;
  }
  function Op_Private_getInstance() {
    Op_initEntries();
    return Op_Private_instance;
  }
  function Op_ExpansionFactor_getInstance() {
    Op_initEntries();
    return Op_ExpansionFactor_instance;
  }
  function Op_Subrs_getInstance() {
    Op_initEntries();
    return Op_Subrs_instance;
  }
  function Op_initialRandomSeed_getInstance() {
    Op_initEntries();
    return Op_initialRandomSeed_instance;
  }
  function Op_defaultWidthX_getInstance() {
    Op_initEntries();
    return Op_defaultWidthX_instance;
  }
  function Op_SyntheicBase_getInstance() {
    Op_initEntries();
    return Op_SyntheicBase_instance;
  }
  function Op_nominalWidthX_getInstance() {
    Op_initEntries();
    return Op_nominalWidthX_instance;
  }
  function Op_PostScript_getInstance() {
    Op_initEntries();
    return Op_PostScript_instance;
  }
  function Op_vsindex_getInstance() {
    Op_initEntries();
    return Op_vsindex_instance;
  }
  function Op_BaseFontName_getInstance() {
    Op_initEntries();
    return Op_BaseFontName_instance;
  }
  function Op_blend_getInstance() {
    Op_initEntries();
    return Op_blend_instance;
  }
  function Op_BaseFontBlend_getInstance() {
    Op_initEntries();
    return Op_BaseFontBlend_instance;
  }
  function Op_vstore_getInstance() {
    Op_initEntries();
    return Op_vstore_instance;
  }
  function Op_maxstack_getInstance() {
    Op_initEntries();
    return Op_maxstack_instance;
  }
  function Op_ROS_getInstance() {
    Op_initEntries();
    return Op_ROS_instance;
  }
  function Op_CIDFontVersion_getInstance() {
    Op_initEntries();
    return Op_CIDFontVersion_instance;
  }
  function Op_CIDFontRevision_getInstance() {
    Op_initEntries();
    return Op_CIDFontRevision_instance;
  }
  function Op_CIDFontType_getInstance() {
    Op_initEntries();
    return Op_CIDFontType_instance;
  }
  function Op_CIDCount_getInstance() {
    Op_initEntries();
    return Op_CIDCount_instance;
  }
  function Op_UIDBase_getInstance() {
    Op_initEntries();
    return Op_UIDBase_instance;
  }
  function Op_FDArray_getInstance() {
    Op_initEntries();
    return Op_FDArray_instance;
  }
  function Op_FDSelect_getInstance() {
    Op_initEntries();
    return Op_FDSelect_instance;
  }
  function Op_FontName_getInstance() {
    Op_initEntries();
    return Op_FontName_instance;
  }
  var Op_hstem_instance;
  var Op_vstem_instance;
  var Op_and_instance;
  var Op_vmoveto_instance;
  var Op_or_instance;
  var Op_rlineto_instance;
  var Op_not_instance;
  var Op_hlineto_instance;
  var Op_vlineto_instance;
  var Op_rrcurveto_instance;
  var Op_abs_instance;
  var Op_callsubr_instance;
  var Op_add_instance;
  var Op_return_instance;
  var Op_sub_instance;
  var Op_div_instance;
  var Op_endchar_instance;
  var Op_neg_instance;
  var Op_cff2vsidx_instance;
  var Op_eq_instance;
  var Op_cff2blend_instance;
  var Op_hstemhm_instance;
  var Op_drop_instance;
  var Op_hintmask_instance;
  var Op_cntrmask_instance;
  var Op_put_instance;
  var Op_rmoveto_instance;
  var Op_get_instance;
  var Op_hmoveto_instance;
  var Op_ifelse_instance;
  var Op_vstemhm_instance;
  var Op_random_instance;
  var Op_rcurveline_instance;
  var Op_mul_instance;
  var Op_rlinecurve_instance;
  var Op_vvcurveto_instance;
  var Op_sqrt_instance;
  var Op_hhcurveto_instance;
  var Op_dup_instance;
  var Op_exch_instance;
  var Op_callgsubr_instance;
  var Op_index_instance;
  var Op_vhcurveto_instance;
  var Op_roll_instance;
  var Op_hvcurveto_instance;
  var Op_hflex_instance;
  var Op_flex_instance;
  var Op_hflex1_instance;
  var Op_flex1_instance;
  function Companion_18() {
    Companion_instance_26 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_1();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.MAP.<anonymous>' call
      var tmp$ret$0 = element.j4a_1;
      destination.i2(tmp$ret$0, element);
    }
    tmp.k4a_1 = toIntMap(destination);
  }
  protoOf(Companion_18).f1 = function (id) {
    var tmp0_elvis_lhs = this.k4a_1.f1(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Unknown CFF CS2 operator ' + id;
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var Companion_instance_26;
  function Companion_getInstance_33() {
    Op_initEntries_0();
    if (Companion_instance_26 == null)
      new Companion_18();
    return Companion_instance_26;
  }
  function values_1() {
    return [Op_hstem_getInstance(), Op_vstem_getInstance(), Op_and_getInstance(), Op_vmoveto_getInstance(), Op_or_getInstance(), Op_rlineto_getInstance(), Op_not_getInstance(), Op_hlineto_getInstance(), Op_vlineto_getInstance(), Op_rrcurveto_getInstance(), Op_abs_getInstance(), Op_callsubr_getInstance(), Op_add_getInstance(), Op_return_getInstance(), Op_sub_getInstance(), Op_div_getInstance(), Op_endchar_getInstance(), Op_neg_getInstance(), Op_cff2vsidx_getInstance(), Op_eq_getInstance(), Op_cff2blend_getInstance(), Op_hstemhm_getInstance(), Op_drop_getInstance(), Op_hintmask_getInstance(), Op_cntrmask_getInstance(), Op_put_getInstance(), Op_rmoveto_getInstance(), Op_get_getInstance(), Op_hmoveto_getInstance(), Op_ifelse_getInstance(), Op_vstemhm_getInstance(), Op_random_getInstance(), Op_rcurveline_getInstance(), Op_mul_getInstance(), Op_rlinecurve_getInstance(), Op_vvcurveto_getInstance(), Op_sqrt_getInstance(), Op_hhcurveto_getInstance(), Op_dup_getInstance(), Op_exch_getInstance(), Op_callgsubr_getInstance(), Op_index_getInstance(), Op_vhcurveto_getInstance(), Op_roll_getInstance(), Op_hvcurveto_getInstance(), Op_hflex_getInstance(), Op_flex_getInstance(), Op_hflex1_getInstance(), Op_flex1_getInstance()];
  }
  var Op_entriesInitialized_0;
  function Op_initEntries_0() {
    if (Op_entriesInitialized_0)
      return Unit_instance;
    Op_entriesInitialized_0 = true;
    Op_hstem_instance = new Op_0('hstem', 0, 1);
    Op_vstem_instance = new Op_0('vstem', 1, 3);
    Op_and_instance = new Op_0('and', 2, 3075);
    Op_vmoveto_instance = new Op_0('vmoveto', 3, 4);
    Op_or_instance = new Op_0('or', 4, 3076);
    Op_rlineto_instance = new Op_0('rlineto', 5, 5);
    Op_not_instance = new Op_0('not', 6, 3077);
    Op_hlineto_instance = new Op_0('hlineto', 7, 6);
    Op_vlineto_instance = new Op_0('vlineto', 8, 7);
    Op_rrcurveto_instance = new Op_0('rrcurveto', 9, 8);
    Op_abs_instance = new Op_0('abs', 10, 3081);
    Op_callsubr_instance = new Op_0('callsubr', 11, 10);
    Op_add_instance = new Op_0('add', 12, 3082);
    Op_return_instance = new Op_0('return', 13, 11);
    Op_sub_instance = new Op_0('sub', 14, 3083);
    Op_div_instance = new Op_0('div', 15, 3084);
    Op_endchar_instance = new Op_0('endchar', 16, 14);
    Op_neg_instance = new Op_0('neg', 17, 3086);
    Op_cff2vsidx_instance = new Op_0('cff2vsidx', 18, 15);
    Op_eq_instance = new Op_0('eq', 19, 3087);
    Op_cff2blend_instance = new Op_0('cff2blend', 20, 16);
    Op_hstemhm_instance = new Op_0('hstemhm', 21, 18);
    Op_drop_instance = new Op_0('drop', 22, 3090);
    Op_hintmask_instance = new Op_0('hintmask', 23, 19);
    Op_cntrmask_instance = new Op_0('cntrmask', 24, 20);
    Op_put_instance = new Op_0('put', 25, 3092);
    Op_rmoveto_instance = new Op_0('rmoveto', 26, 21);
    Op_get_instance = new Op_0('get', 27, 3093);
    Op_hmoveto_instance = new Op_0('hmoveto', 28, 22);
    Op_ifelse_instance = new Op_0('ifelse', 29, 3094);
    Op_vstemhm_instance = new Op_0('vstemhm', 30, 23);
    Op_random_instance = new Op_0('random', 31, 3095);
    Op_rcurveline_instance = new Op_0('rcurveline', 32, 24);
    Op_mul_instance = new Op_0('mul', 33, 3096);
    Op_rlinecurve_instance = new Op_0('rlinecurve', 34, 25);
    Op_vvcurveto_instance = new Op_0('vvcurveto', 35, 26);
    Op_sqrt_instance = new Op_0('sqrt', 36, 3098);
    Op_hhcurveto_instance = new Op_0('hhcurveto', 37, 27);
    Op_dup_instance = new Op_0('dup', 38, 3099);
    Op_exch_instance = new Op_0('exch', 39, 3100);
    Op_callgsubr_instance = new Op_0('callgsubr', 40, 29);
    Op_index_instance = new Op_0('index', 41, 3101);
    Op_vhcurveto_instance = new Op_0('vhcurveto', 42, 30);
    Op_roll_instance = new Op_0('roll', 43, 3102);
    Op_hvcurveto_instance = new Op_0('hvcurveto', 44, 31);
    Op_hflex_instance = new Op_0('hflex', 45, 3106);
    Op_flex_instance = new Op_0('flex', 46, 3107);
    Op_hflex1_instance = new Op_0('hflex1', 47, 3108);
    Op_flex1_instance = new Op_0('flex1', 48, 3109);
    Companion_getInstance_33();
  }
  function EvalContext(globalSubrIndex, localSubrsIndex, defaultWidthX, nominalWidthX, index, heap) {
    globalSubrIndex = globalSubrIndex === VOID ? DataIndex_init_$Create$() : globalSubrIndex;
    localSubrsIndex = localSubrsIndex === VOID ? DataIndex_init_$Create$() : localSubrsIndex;
    defaultWidthX = defaultWidthX === VOID ? 0.0 : defaultWidthX;
    nominalWidthX = nominalWidthX === VOID ? 0.0 : nominalWidthX;
    index = index === VOID ? -1 : index;
    heap = heap === VOID ? new Float64Array(32) : heap;
    this.t49_1 = globalSubrIndex;
    this.u49_1 = localSubrsIndex;
    this.v49_1 = defaultWidthX;
    this.w49_1 = nominalWidthX;
    this.x49_1 = index;
    this.y49_1 = heap;
    this.z49_1 = computeSubrBias(CharStringType2_instance, this.t49_1.n());
    this.a4a_1 = computeSubrBias(CharStringType2_instance, this.u49_1.n());
    this.b4a_1 = 0;
    this.c4a_1 = this.v49_1;
    this.d4a_1 = false;
  }
  function computeSubrBias($this, count) {
    return count < 1240 ? 107 : count < 33900 ? 1131 : 32768;
  }
  function Op_0(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this.j4a_1 = id;
  }
  function Op_hstem_getInstance() {
    Op_initEntries_0();
    return Op_hstem_instance;
  }
  function Op_vstem_getInstance() {
    Op_initEntries_0();
    return Op_vstem_instance;
  }
  function Op_and_getInstance() {
    Op_initEntries_0();
    return Op_and_instance;
  }
  function Op_vmoveto_getInstance() {
    Op_initEntries_0();
    return Op_vmoveto_instance;
  }
  function Op_or_getInstance() {
    Op_initEntries_0();
    return Op_or_instance;
  }
  function Op_rlineto_getInstance() {
    Op_initEntries_0();
    return Op_rlineto_instance;
  }
  function Op_not_getInstance() {
    Op_initEntries_0();
    return Op_not_instance;
  }
  function Op_hlineto_getInstance() {
    Op_initEntries_0();
    return Op_hlineto_instance;
  }
  function Op_vlineto_getInstance() {
    Op_initEntries_0();
    return Op_vlineto_instance;
  }
  function Op_rrcurveto_getInstance() {
    Op_initEntries_0();
    return Op_rrcurveto_instance;
  }
  function Op_abs_getInstance() {
    Op_initEntries_0();
    return Op_abs_instance;
  }
  function Op_callsubr_getInstance() {
    Op_initEntries_0();
    return Op_callsubr_instance;
  }
  function Op_add_getInstance() {
    Op_initEntries_0();
    return Op_add_instance;
  }
  function Op_return_getInstance() {
    Op_initEntries_0();
    return Op_return_instance;
  }
  function Op_sub_getInstance() {
    Op_initEntries_0();
    return Op_sub_instance;
  }
  function Op_div_getInstance() {
    Op_initEntries_0();
    return Op_div_instance;
  }
  function Op_endchar_getInstance() {
    Op_initEntries_0();
    return Op_endchar_instance;
  }
  function Op_neg_getInstance() {
    Op_initEntries_0();
    return Op_neg_instance;
  }
  function Op_cff2vsidx_getInstance() {
    Op_initEntries_0();
    return Op_cff2vsidx_instance;
  }
  function Op_eq_getInstance() {
    Op_initEntries_0();
    return Op_eq_instance;
  }
  function Op_cff2blend_getInstance() {
    Op_initEntries_0();
    return Op_cff2blend_instance;
  }
  function Op_hstemhm_getInstance() {
    Op_initEntries_0();
    return Op_hstemhm_instance;
  }
  function Op_drop_getInstance() {
    Op_initEntries_0();
    return Op_drop_instance;
  }
  function Op_hintmask_getInstance() {
    Op_initEntries_0();
    return Op_hintmask_instance;
  }
  function Op_cntrmask_getInstance() {
    Op_initEntries_0();
    return Op_cntrmask_instance;
  }
  function Op_put_getInstance() {
    Op_initEntries_0();
    return Op_put_instance;
  }
  function Op_rmoveto_getInstance() {
    Op_initEntries_0();
    return Op_rmoveto_instance;
  }
  function Op_get_getInstance() {
    Op_initEntries_0();
    return Op_get_instance;
  }
  function Op_hmoveto_getInstance() {
    Op_initEntries_0();
    return Op_hmoveto_instance;
  }
  function Op_ifelse_getInstance() {
    Op_initEntries_0();
    return Op_ifelse_instance;
  }
  function Op_vstemhm_getInstance() {
    Op_initEntries_0();
    return Op_vstemhm_instance;
  }
  function Op_random_getInstance() {
    Op_initEntries_0();
    return Op_random_instance;
  }
  function Op_rcurveline_getInstance() {
    Op_initEntries_0();
    return Op_rcurveline_instance;
  }
  function Op_mul_getInstance() {
    Op_initEntries_0();
    return Op_mul_instance;
  }
  function Op_rlinecurve_getInstance() {
    Op_initEntries_0();
    return Op_rlinecurve_instance;
  }
  function Op_vvcurveto_getInstance() {
    Op_initEntries_0();
    return Op_vvcurveto_instance;
  }
  function Op_sqrt_getInstance() {
    Op_initEntries_0();
    return Op_sqrt_instance;
  }
  function Op_hhcurveto_getInstance() {
    Op_initEntries_0();
    return Op_hhcurveto_instance;
  }
  function Op_dup_getInstance() {
    Op_initEntries_0();
    return Op_dup_instance;
  }
  function Op_exch_getInstance() {
    Op_initEntries_0();
    return Op_exch_instance;
  }
  function Op_callgsubr_getInstance() {
    Op_initEntries_0();
    return Op_callgsubr_instance;
  }
  function Op_index_getInstance() {
    Op_initEntries_0();
    return Op_index_instance;
  }
  function Op_vhcurveto_getInstance() {
    Op_initEntries_0();
    return Op_vhcurveto_instance;
  }
  function Op_roll_getInstance() {
    Op_initEntries_0();
    return Op_roll_instance;
  }
  function Op_hvcurveto_getInstance() {
    Op_initEntries_0();
    return Op_hvcurveto_instance;
  }
  function Op_hflex_getInstance() {
    Op_initEntries_0();
    return Op_hflex_instance;
  }
  function Op_flex_getInstance() {
    Op_initEntries_0();
    return Op_flex_instance;
  }
  function Op_hflex1_getInstance() {
    Op_initEntries_0();
    return Op_hflex1_instance;
  }
  function Op_flex1_getInstance() {
    Op_initEntries_0();
    return Op_flex1_instance;
  }
  function CFF() {
  }
  protoOf(CFF).l4a = function (_this__u8e3s4) {
    this.m4a(_this__u8e3s4);
    var nameIndex = this.n4a(_this__u8e3s4);
    var topDictIndex = this.n4a(_this__u8e3s4);
    var topDictByte = topDictIndex.f1(0)[1];
    var topDict = this.o4a(openFastStream(topDictIndex.f1(0)));
    var stringIndex = this.n4a(_this__u8e3s4);
    var globalSubrIndex = this.n4a(_this__u8e3s4);
    var privateSizeOffset = topDict.s2(Op_Private_getInstance());
    var localSubrsIndex = DataIndex_init_$Create$();
    var privateDict = emptyMap();
    if (!(privateSizeOffset == null)) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(privateSizeOffset, 10));
      var tmp0_iterator = privateSizeOffset.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.image.font.CFF.readCFF.<anonymous>' call
        var tmp$ret$0 = numberToInt(item);
        destination.r(tmp$ret$0);
      }
      // Inline function 'kotlin.collections.component1' call
      var privateSize = destination.f1(0);
      // Inline function 'kotlin.collections.component2' call
      var privateOffset = destination.f1(1);
      privateDict = this.o4a(_this__u8e3s4.t4a(privateOffset, privateSize));
      var localSubrs = privateDict.s2(Op_Subrs_getInstance());
      if (!(localSubrs == null)) {
        var subrsOffset = privateOffset + numberToInt(last(localSubrs)) | 0;
        localSubrsIndex = this.n4a(_this__u8e3s4.u4a(subrsOffset));
      }
    }
    var charstringsOffsets = topDict.s2(Op_CharStrings_getInstance());
    var charstringsOffset = numberToInt(first_0(ensureNotNull(charstringsOffsets)));
    var charstringsIndex = this.n4a(_this__u8e3s4.u4a(charstringsOffset));
    return new CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict);
  };
  protoOf(CFF).m4a = function (_this__u8e3s4) {
    var versionMajor = _this__u8e3s4.v4a();
    var versionMinor = _this__u8e3s4.v4a();
    var headerSize = _this__u8e3s4.v4a();
    var offsetSize = _this__u8e3s4.v4a();
    if (versionMajor > 1) {
      // Inline function 'kotlin.error' call
      var message = 'Only supported CFF version 1';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = TtfCIDFont_getInstance().w4a_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.f25(level)) {
      // Inline function 'korlibs.image.font.CFF.readHeader.<anonymous>' call
      var tmp$ret$0 = 'CFF.versionMajor/Minor: ' + versionMajor + '.' + versionMinor + ' : headerSize=' + headerSize + ', offsetSize=' + offsetSize;
      this_0.g25(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  };
  protoOf(CFF).x4a = function (_this__u8e3s4) {
    return _this__u8e3s4.v4a();
  };
  protoOf(CFF).y4a = function (_this__u8e3s4, offSize) {
    var roffSize = offSize < 0 ? this.x4a(_this__u8e3s4) : offSize;
    var tmp;
    switch (roffSize) {
      case 1:
        tmp = _this__u8e3s4.v4a();
        break;
      case 2:
        tmp = _this__u8e3s4.z4a();
        break;
      case 3:
        tmp = _this__u8e3s4.a4b();
        break;
      case 4:
        tmp = _this__u8e3s4.b4b();
        break;
      default:
        reserved('' + roffSize);
        break;
    }
    return tmp;
  };
  protoOf(CFF).n4a = function (_this__u8e3s4) {
    var count = _this__u8e3s4.z4a();
    if (count === 0)
      return DataIndex_init_$Create$();
    var offSize = this.x4a(_this__u8e3s4);
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = until(0, count + 1 | 0);
    // Inline function 'kotlin.also' call
    var this_1 = new IntArrayList((coerceAtLeast(this_0.i9() - this_0.h9() | 0, 0) / this_0.hb_1 | 0) + 1 | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var nestedFirst = this_0.h9();
    var nestedLast = this_0.i9();
    var stepArg = this_0.hb_1;
    if (stepArg <= 0)
      THROW_IAE('Step must be positive, was: ' + stepArg + '.');
    var inductionVariable = nestedFirst;
    var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
    if (inductionVariable <= last)
      do {
        var v = inductionVariable;
        inductionVariable = inductionVariable + stepArg | 0;
        // Inline function 'korlibs.image.font.CFF.readIndex.<anonymous>' call
        var tmp$ret$0 = CFF_instance.y4a(_this__u8e3s4, offSize) - 1 | 0;
        this_1.m1s(tmp$ret$0);
      }
       while (!(v === last));
    var offsets = this_1;
    var bytes = _this__u8e3s4.c4b(offsets.v1s());
    return new DataIndex(offsets.x1s(), bytes);
  };
  protoOf(CFF).o4a = function (_this__u8e3s4) {
    var map = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.arrayListOf' call
    var values = ArrayList_init_$Create$();
    while (_this__u8e3s4.d4b()) {
      var item = this.e4b(_this__u8e3s4);
      if (item instanceof Op) {
        // Inline function 'kotlin.collections.set' call
        var value = toList(values);
        map.i2(item, value);
        values.b3();
      } else {
        if (isNumber(item)) {
          values.r(item);
        }
      }
    }
    return map;
  };
  protoOf(CFF).e4b = function (_this__u8e3s4) {
    var b0 = _this__u8e3s4.v4a();
    var tmp;
    if (0 <= b0 ? b0 <= 21 : false) {
      var tmp_0 = Companion_getInstance_32();
      tmp = tmp_0.f1(b0 === 12 ? b0 << 8 | _this__u8e3s4.v4a() : b0);
    } else if (22 <= b0 ? b0 <= 27 : false) {
      get_reserved();
    } else if (b0 === 28) {
      tmp = toShort(_this__u8e3s4.v4a() << 8 | _this__u8e3s4.v4a());
    } else if (b0 === 29) {
      tmp = _this__u8e3s4.v4a() << 24 | _this__u8e3s4.v4a() << 16 | _this__u8e3s4.v4a() << 8 | _this__u8e3s4.v4a();
    } else if (b0 === 30) {
      tmp = this.f4b(_this__u8e3s4, false);
    } else if (b0 === 31) {
      get_reserved();
    } else if (32 <= b0 ? b0 <= 246 : false) {
      tmp = b0 - 139 | 0;
    } else if (247 <= b0 ? b0 <= 250 : false) {
      tmp = (imul(b0 - 247 | 0, 256) + _this__u8e3s4.v4a() | 0) + 108 | 0;
    } else if (251 <= b0 ? b0 <= 254 : false) {
      tmp = ((-imul(b0 - 251 | 0, 256) | 0) - _this__u8e3s4.v4a() | 0) - 108 | 0;
    } else if (b0 === 255) {
      get_reserved();
    } else {
      get_unreachable();
    }
    return tmp;
  };
  protoOf(CFF).g4b = function (_this__u8e3s4, readHeader) {
    if (readHeader) {
      // Inline function 'korlibs.io.lang.assert' call
      if (!(_this__u8e3s4.v4a() === 30))
        throw AssertionError_init_$Create$();
    }
    var str = StringBuilder_init_$Create$();
    end: while (true) {
      var byte = _this__u8e3s4.v4a();
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var nibble = (byte >>> imul(1 - n | 0, 4) | 0) & 15;
          if (nibble === 15)
            break end;
          switch (nibble) {
            case 15:
              break end;
            case 12:
              str.u5('E-');
              break;
            default:
              str.v5((0 <= nibble ? nibble <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), nibble) : nibble === 10 ? _Char___init__impl__6a9atx(46) : nibble === 11 ? _Char___init__impl__6a9atx(69) : nibble === 14 ? _Char___init__impl__6a9atx(45) : _Char___init__impl__6a9atx(48));
              break;
          }
        }
         while (inductionVariable <= 1);
    }
    return str.toString();
  };
  protoOf(CFF).f4b = function (_this__u8e3s4, readHeader) {
    return toDouble(this.g4b(_this__u8e3s4, readHeader));
  };
  var CFF_instance;
  function CFF_getInstance() {
    return CFF_instance;
  }
  function CharStringType2() {
  }
  protoOf(CharStringType2).h4b = function (_this__u8e3s4, value) {
    _this__u8e3s4.a1s(_this__u8e3s4.n() - 1 | 0, value);
  };
  protoOf(CharStringType2).i4b = function (_this__u8e3s4) {
    return _this__u8e3s4.f1(_this__u8e3s4.n() - 1 | 0);
  };
  protoOf(CharStringType2).j4b = function (_this__u8e3s4) {
    return _this__u8e3s4.h1(_this__u8e3s4.n() - 1 | 0);
  };
  protoOf(CharStringType2).k4b = function (_this__u8e3s4, value) {
    _this__u8e3s4.s1r(value);
  };
  protoOf(CharStringType2).l4b = function (_this__u8e3s4, value) {
    _this__u8e3s4.s1r(value);
  };
  protoOf(CharStringType2).m4b = function (_this__u8e3s4) {
    var lastPoint = _this__u8e3s4.p33();
    _this__u8e3s4.p21();
    _this__u8e3s4.s2u(lastPoint);
  };
  protoOf(CharStringType2).n4b = function (_this__u8e3s4, x, y) {
    _this__u8e3s4.x33(new Vector2D(x, y));
  };
  protoOf(CharStringType2).o4b = function (_this__u8e3s4, x, y) {
    _this__u8e3s4.y33(new Vector2D(x, y));
  };
  protoOf(CharStringType2).p4b = function (_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay) {
    _this__u8e3s4.t2u(new Vector2D(fcx1, fcy1), new Vector2D(fcx2, fcy2), new Vector2D(fax, fay));
  };
  protoOf(CharStringType2).q4b = function (_this__u8e3s4, cx1, cy1, cx2, cy2, ax, ay) {
    var fcx1 = _this__u8e3s4.p33().g28_1 + cx1;
    var fcy1 = _this__u8e3s4.p33().h28_1 + cy1;
    var fcx2 = fcx1 + cx2;
    var fcy2 = fcy1 + cy2;
    var fax = fcx2 + ax;
    var fay = fcy2 + ay;
    this.p4b(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay);
  };
  protoOf(CharStringType2).r4b = function (_this__u8e3s4, v, horizontal) {
    return this.n4b(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  };
  protoOf(CharStringType2).s4b = function (_this__u8e3s4, v, horizontal) {
    return this.o4b(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  };
  protoOf(CharStringType2).t4b = function (_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CharStringType2.u8.<anonymous>' call
    return _this__u8e3s4.v4a();
  };
  protoOf(CharStringType2).u4b = function (ctx, s, evalCtx, stack, stackLevel) {
    while (s.d4b()) {
      var v0 = this.t4b(s);
      if ((0 <= v0 ? v0 <= 27 : false) ? true : 29 <= v0 ? v0 <= 31 : false) {
        var tmp = Companion_getInstance_33();
        var op = tmp.f1(v0 === 12 ? v0 << 8 | this.t4b(s) : v0);
        switch (op.ka_1) {
          case 13:
            return Unit_instance;
          case 16:
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call

            if (!stack.b1()) {
              tmp_0 = !evalCtx.d4a_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              evalCtx.c4a_1 = stack.f1(0) + evalCtx.w49_1;
              evalCtx.d4a_1 = true;
            }

            if (!(ctx.o33() === 0)) {
              this.m4b(ctx);
            }

            return Unit_instance;
          case 11:
          case 40:
            var global = op.equals(Op_callgsubr_getInstance());
            var funcOffset = numberToInt(this.j4b(stack));
            var bytes = global ? evalCtx.t49_1.f1(evalCtx.z49_1 + funcOffset | 0) : evalCtx.u49_1.f1(evalCtx.a4a_1 + funcOffset | 0);
            this.u4b(ctx, openFastStream(bytes), evalCtx, stack, stackLevel + 1 | 0);
            break;
          case 22:
            this.j4b(stack);
            break;
          case 38:
            // Inline function 'kotlin.also' call

            var this_0 = this.j4b(stack);
            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            stack.t1r(this_0, this_0);
            break;
          case 39:
            stack.d1s(stack.n() - 2 | 0, stack.n() - 1 | 0);
            break;
          case 43:
            // Inline function 'kotlin.TODO' call

            throw new NotImplementedError();
          case 41:
            // Inline function 'kotlin.TODO' call

            throw new NotImplementedError();
          case 25:
            var index = this.j4b(stack);
            var value = this.j4b(stack);
            evalCtx.y49_1[numberToInt(index)] = value;
            break;
          case 27:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var it = this.i4b(stack);
            var tmp$ret$2 = evalCtx.y49_1[numberToInt(it)];
            this.h4b(stack, tmp$ret$2);
            break;
          case 2:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r = this.j4b(stack);
            var l = this.j4b(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$4 = (!(l === 0.0) ? !(r === 0.0) : false) ? 1 : 0;
            this.k4b(stack, tmp$ret$4);
            break;
          case 4:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_0 = this.j4b(stack);
            var l_0 = this.j4b(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$6 = (!(l_0 === 0.0) ? true : !(r_0 === 0.0)) ? 1 : 0;
            this.k4b(stack, tmp$ret$6);
            break;
          case 6:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$8 = this.i4b(stack) === 0.0 ? 1 : 0;
            this.h4b(stack, tmp$ret$8);
            break;
          case 19:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_1 = this.j4b(stack);
            var l_1 = this.j4b(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$10 = l_1 === r_1 ? 1 : 0;
            this.k4b(stack, tmp$ret$10);
            break;
          case 29:
            var v2 = this.j4b(stack);
            var v1 = this.j4b(stack);
            var s2 = this.j4b(stack);
            var s1 = this.j4b(stack);
            this.k4b(stack, v1 <= v2 ? s1 : s2);
            break;
          case 31:
            stack.s1r(Default_getInstance().rh());
            break;
          case 36:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.sqrt' call

            var x = this.i4b(stack);
            var tmp$ret$12 = Math.sqrt(x);
            this.h4b(stack, tmp$ret$12);
            break;
          case 10:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.abs' call

            var x_0 = this.i4b(stack);
            var tmp$ret$14 = Math.abs(x_0);
            this.h4b(stack, tmp$ret$14);
            break;
          case 17:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$15 = -this.i4b(stack);
            this.h4b(stack, tmp$ret$15);
            break;
          case 12:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_2 = this.j4b(stack);
            var l_2 = this.j4b(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$16 = l_2 + r_2;
            this.k4b(stack, tmp$ret$16);
            break;
          case 14:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_3 = this.j4b(stack);
            var l_3 = this.j4b(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$17 = l_3 - r_3;
            this.k4b(stack, tmp$ret$17);
            break;
          case 15:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_4 = this.j4b(stack);
            var l_4 = this.j4b(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$18 = l_4 / r_4;
            this.k4b(stack, tmp$ret$18);
            break;
          case 33:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_5 = this.j4b(stack);
            var l_5 = this.j4b(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$19 = l_5 * r_5;
            this.k4b(stack, tmp$ret$19);
            break;
          case 26:
            if (stack.n() > 2) {
              evalCtx.c4a_1 = stack.f1(0) + evalCtx.w49_1;
              evalCtx.d4a_1 = true;
            }

            if (!(ctx.o33() === 0)) {
              this.m4b(ctx);
            }

            this.n4b(ctx, stack.f1(stack.n() - 2 | 0), stack.f1(stack.n() - 1 | 0));
            stack.b3();
            break;
          case 3:
          case 28:
            if (stack.n() > 1) {
              evalCtx.c4a_1 = stack.f1(0) + evalCtx.w49_1;
              evalCtx.d4a_1 = true;
            }

            this.r4b(ctx, this.j4b(stack), op.equals(Op_hmoveto_getInstance()));
            stack.b3();
            break;
          case 5:
            var progression = step(until(0, stack.n()), 2);
            var inductionVariable = progression.fb_1;
            var last = progression.gb_1;
            var step_0 = progression.hb_1;
            if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                this.o4b(ctx, stack.f1(n), stack.f1(n + 1 | 0));
              }
               while (!(n === last));
            stack.b3();
            break;
          case 7:
          case 8:
            var toggle = op.equals(Op_hlineto_getInstance());
            var inductionVariable_0 = 0;
            var last_0 = stack.n();
            if (inductionVariable_0 < last_0)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this.s4b(ctx, stack.f1(n_0), toggle);
                toggle = !toggle;
              }
               while (inductionVariable_0 < last_0);
            stack.b3();
            break;
          case 9:
          case 32:
          case 34:
            var n_1 = 0;
            if (op.equals(Op_rlinecurve_getInstance())) {
              while ((stack.n() - n_1 | 0) < 6) {
                var tmp5 = n_1;
                n_1 = tmp5 + 1 | 0;
                var tmp_1 = stack.f1(tmp5);
                var tmp6 = n_1;
                n_1 = tmp6 + 1 | 0;
                this.o4b(ctx, tmp_1, stack.f1(tmp6));
              }
            }

            while ((stack.n() - n_1 | 0) >= 6) {
              var tmp7 = n_1;
              n_1 = tmp7 + 1 | 0;
              var tmp_2 = stack.f1(tmp7);
              var tmp8 = n_1;
              n_1 = tmp8 + 1 | 0;
              var tmp_3 = stack.f1(tmp8);
              var tmp9 = n_1;
              n_1 = tmp9 + 1 | 0;
              var tmp_4 = stack.f1(tmp9);
              var tmp10 = n_1;
              n_1 = tmp10 + 1 | 0;
              var tmp_5 = stack.f1(tmp10);
              var tmp11 = n_1;
              n_1 = tmp11 + 1 | 0;
              var tmp_6 = stack.f1(tmp11);
              var tmp12 = n_1;
              n_1 = tmp12 + 1 | 0;
              this.q4b(ctx, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, stack.f1(tmp12));
            }

            if (op.equals(Op_rcurveline_getInstance())) {
              while (n_1 < stack.n()) {
                var tmp13 = n_1;
                n_1 = tmp13 + 1 | 0;
                var tmp_7 = stack.f1(tmp13);
                var tmp14 = n_1;
                n_1 = tmp14 + 1 | 0;
                this.o4b(ctx, tmp_7, stack.f1(tmp14));
              }
            }

            stack.b3();
            break;
          case 35:
          case 37:
            var horizontal = op.equals(Op_hhcurveto_getInstance());
            var n_2 = 0;
            var tmp_8;
            if ((stack.n() % 2 | 0) === 1) {
              var tmp15 = n_2;
              n_2 = tmp15 + 1 | 0;
              tmp_8 = stack.f1(tmp15);
            } else {
              tmp_8 = 0.0;
            }

            var v = tmp_8;
            var initialY = horizontal ? v : 0.0;
            var initialX = horizontal ? 0.0 : v;
            if (!(((stack.n() - n_2 | 0) % 4 | 0) === 0)) {
              // Inline function 'kotlin.error' call
              var message = 'Invalid number of operands';
              throw IllegalStateException_init_$Create$(toString(message));
            }

            while (n_2 < stack.n()) {
              var tmp16 = n_2;
              n_2 = tmp16 + 1 | 0;
              var vv = stack.f1(tmp16);
              var x1 = initialX + (horizontal ? vv : 0.0);
              var y1 = initialY + (horizontal ? 0.0 : vv);
              var tmp17 = n_2;
              n_2 = tmp17 + 1 | 0;
              var x2 = stack.f1(tmp17);
              var tmp18 = n_2;
              n_2 = tmp18 + 1 | 0;
              var y2 = stack.f1(tmp18);
              var tmp19 = n_2;
              n_2 = tmp19 + 1 | 0;
              var v1_0 = stack.f1(tmp19);
              var lastX = horizontal ? v1_0 : 0.0;
              var lastY = horizontal ? 0.0 : v1_0;
              this.q4b(ctx, x1, y1, x2, y2, lastX, lastY);
              initialX = 0.0;
              initialY = 0.0;
            }

            stack.b3();
            break;
          case 42:
          case 44:
            reverse(stack);
            var toggle_0 = op.equals(Op_hvcurveto_getInstance());
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!stack.b1()) {
                break $l$loop;
              }
              var vv_0 = this.j4b(stack);
              var x1_0 = toggle_0 ? vv_0 : 0.0;
              var y1_0 = toggle_0 ? 0.0 : vv_0;
              var x2_0 = this.j4b(stack);
              var y2_0 = this.j4b(stack);
              var v1_1 = this.j4b(stack);
              var v2_0 = stack.n() === 1 ? this.j4b(stack) : 0.0;
              var ax = toggle_0 ? v2_0 : v1_1;
              var ay = toggle_0 ? v1_1 : v2_0;
              this.q4b(ctx, x1_0, y1_0, x2_0, y2_0, ax, ay);
              toggle_0 = !toggle_0;
            }

            stack.b3();
            break;
          case 45:
          case 46:
          case 47:
          case 48:
            // Inline function 'kotlin.TODO' call

            throw new NotImplementedError();
          case 0:
          case 1:
          case 21:
          case 30:
          case 23:
          case 24:
            if (!((stack.n() % 2 | 0) === 0) ? !evalCtx.d4a_1 : false) {
              var value_0 = stack.f1(0);
              evalCtx.c4a_1 = value_0 + evalCtx.w49_1;
            }

            evalCtx.b4a_1 = evalCtx.b4a_1 + (stack.n() >>> 1 | 0) | 0;
            evalCtx.d4a_1 = true;
            stack.b3();
            if (op.equals(Op_hintmask_getInstance()) ? true : op.equals(Op_cntrmask_getInstance())) {
              var skipCount = (evalCtx.b4a_1 + 7 | 0) >>> 3 | 0;
              s.v4b(skipCount);
            }

            break;
          case 18:
            // Inline function 'kotlin.TODO' call

            throw new NotImplementedError();
          case 20:
            // Inline function 'kotlin.TODO' call

            throw new NotImplementedError();
        }
      } else if (v0 === 255) {
        var integerPart = this.t4b(s) << 8 | this.t4b(s);
        var fractionPart = this.t4b(s) << 8 | this.t4b(s);
        var value_1 = integerPart + fractionPart / 65536.0;
        this.k4b(stack, value_1);
      } else {
        var tmp_9;
        if (v0 === 28) {
          tmp_9 = toShort(this.t4b(s) << 8 | this.t4b(s));
        } else if (32 <= v0 ? v0 <= 246 : false) {
          tmp_9 = v0 - 139 | 0;
        } else if (247 <= v0 ? v0 <= 250 : false) {
          tmp_9 = (imul(v0 - 247 | 0, 256) + this.t4b(s) | 0) + 108 | 0;
        } else if (251 <= v0 ? v0 <= 254 : false) {
          tmp_9 = ((-imul(v0 - 251 | 0, 256) | 0) - this.t4b(s) | 0) - 108 | 0;
        } else {
          get_unreachable();
        }
        var value_2 = tmp_9;
        this.l4b(stack, value_2);
      }
    }
  };
  protoOf(CharStringType2).s49 = function (ctx, s, evalCtx, stack, stackLevel, $super) {
    stack = stack === VOID ? new DoubleArrayList(32) : stack;
    stackLevel = stackLevel === VOID ? 0 : stackLevel;
    var tmp;
    if ($super === VOID) {
      this.u4b(ctx, s, evalCtx, stack, stackLevel);
      tmp = Unit_instance;
    } else {
      tmp = $super.u4b.call(this, ctx, s, evalCtx, stack, stackLevel);
    }
    return tmp;
  };
  var CharStringType2_instance;
  function CharStringType2_getInstance() {
    return CharStringType2_instance;
  }
  function TtfCIDFont() {
    TtfCIDFont_instance = this;
    this.w4a_1 = Companion_getInstance_6().r24('TtfCIDFont');
  }
  var TtfCIDFont_instance;
  function TtfCIDFont_getInstance() {
    if (TtfCIDFont_instance == null)
      new TtfCIDFont();
    return TtfCIDFont_instance;
  }
  function Companion_19() {
    Companion_instance_27 = this;
    this.w4b_1 = Companion_getInstance_6().r24('TTF');
  }
  var Companion_instance_27;
  function Companion_getInstance_34() {
    if (Companion_instance_27 == null)
      new Companion_19();
    return Companion_instance_27;
  }
  function TtfFont(d, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_34();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    BaseTtfFont_init_$Init$(d, extName, onlyReadMetadata, enableLigatures, this);
    this.h4e_1 = LinkedHashMap_init_$Create$();
    this.s4g();
  }
  protoOf(TtfFont).t4g = function () {
    this.h4e_1.k3(Companion_instance_30.v4g(this.i4e_1.u4g()));
  };
  protoOf(TtfFont).w4g = function (name) {
    return this.h4e_1.s2(name);
  };
  function _get_ss__ndcawb($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.b4j_1;
    ss$factory();
    return this_0.m2();
  }
  function BaseTtfFont$Table$ss$delegate$lambda(this$0) {
    return function () {
      return ensureNotNull(this$0.a4j_1)();
    };
  }
  function BaseTtfFont$Companion$readHeaderTables$lambda($$this$run, $table) {
    return function () {
      return $$this$run.t4a($table.y4i_1, $table.z4i_1);
    };
  }
  var NameId_COPYRIGHT_instance;
  var NameId_NAME_instance;
  var NameId_STYLE_instance;
  var NameId_UNAME_instance;
  var NameId_COMPLETE_NAME_instance;
  var NameId_RELEASE_VERSION_instance;
  var NameId_POSTSCRIPT_NAME_instance;
  var NameId_TRADEMARK_instance;
  var NameId_MANUFACTURER_instance;
  var NameId_DESIGNER_instance;
  var NameId_DESCRIPTION_instance;
  var NameId_URL_VENDOR_instance;
  var NameId_URL_DESIGNER_instance;
  var NameId_LICENSE_DESCRIPTION_instance;
  var NameId_LICENSE_URL_instance;
  var NameId_RESERVED_15_instance;
  var NameId_PREFERRED_FAMILY_instance;
  var NameId_PREFERRED_SUBFAMILY_instance;
  var NameId_COMPATIBLE_FULL_instance;
  var NameId_SAMPLE_TEXT_instance;
  var NameId_POSTSCRIPT_CID_instance;
  var NameId_WWS_FAMILY_NAME_instance;
  var NameId_WWS_SUBFAMILY_NAME_instance;
  var NameId_LIGHT_BACKGROUND_instance;
  var NameId_DARK_BACKGROUND_instance;
  var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
  function Companion_20() {
    this.c4j_1 = 26;
  }
  var Companion_instance_28;
  function Companion_getInstance_35() {
    return Companion_instance_28;
  }
  function values_2() {
    return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
  }
  var NameId_entriesInitialized;
  function NameId_initEntries() {
    if (NameId_entriesInitialized)
      return Unit_instance;
    NameId_entriesInitialized = true;
    NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
    NameId_NAME_instance = new NameId('NAME', 1, 1);
    NameId_STYLE_instance = new NameId('STYLE', 2, 2);
    NameId_UNAME_instance = new NameId('UNAME', 3, 3);
    NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
    NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
    NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
    NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
    NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
    NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
    NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
    NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
    NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
    NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
    NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
    NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
    NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
    NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
    NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
    NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
    NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
    NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
    NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
    NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
    NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
    NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
  }
  var Colrv1Paint_PaintColrLayers_instance;
  var Colrv1Paint_PaintSolid_instance;
  var Colrv1Paint_PaintVarSolid_instance;
  var Colrv1Paint_PaintLinearGradient_instance;
  var Colrv1Paint_PaintVarLinearGradient_instance;
  var Colrv1Paint_PaintRadialGradient_instance;
  var Colrv1Paint_PaintVarRadialGradient_instance;
  var Colrv1Paint_PaintSweepGradient_instance;
  var Colrv1Paint_PaintVarSweepGradient_instance;
  var Colrv1Paint_PaintGlyph_instance;
  var Colrv1Paint_PaintColrGlyph_instance;
  var Colrv1Paint_PaintTransform_instance;
  var Colrv1Paint_PaintVarTransform_instance;
  var Colrv1Paint_PaintTranslate_instance;
  var Colrv1Paint_PaintVarTranslate_instance;
  var Colrv1Paint_PaintScale_instance;
  var Colrv1Paint_PaintVarScale_instance;
  var Colrv1Paint_PaintScaleAroundCenter_instance;
  var Colrv1Paint_PaintVarScaleAroundCenter_instance;
  var Colrv1Paint_PaintScaleUniform_instance;
  var Colrv1Paint_PaintVarScaleUniform_instance;
  var Colrv1Paint_PaintScaleUniformAroundCenter_instance;
  var Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
  var Colrv1Paint_PaintRotate_instance;
  var Colrv1Paint_PaintVarRotate_instance;
  var Colrv1Paint_PaintRotateAroundCenter_instance;
  var Colrv1Paint_PaintVarRotateAroundCenter_instance;
  var Colrv1Paint_PaintSkew_instance;
  var Colrv1Paint_PaintVarSkew_instance;
  var Colrv1Paint_PaintSkewAroundCenter_instance;
  var Colrv1Paint_PaintVarSkewAroundCenter_instance;
  var Colrv1Paint_PaintComposite_instance;
  function Companion_21() {
    Companion_instance_29 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.arrayOfNulls' call
    var this_0 = fillArrayVal(Array(1), null);
    var elements = values_3();
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d4j_1 = this_0.concat(elements);
  }
  var Companion_instance_29;
  function Companion_getInstance_36() {
    Colrv1Paint_initEntries();
    if (Companion_instance_29 == null)
      new Companion_21();
    return Companion_instance_29;
  }
  function values_3() {
    return [Colrv1Paint_PaintColrLayers_getInstance(), Colrv1Paint_PaintSolid_getInstance(), Colrv1Paint_PaintVarSolid_getInstance(), Colrv1Paint_PaintLinearGradient_getInstance(), Colrv1Paint_PaintVarLinearGradient_getInstance(), Colrv1Paint_PaintRadialGradient_getInstance(), Colrv1Paint_PaintVarRadialGradient_getInstance(), Colrv1Paint_PaintSweepGradient_getInstance(), Colrv1Paint_PaintVarSweepGradient_getInstance(), Colrv1Paint_PaintGlyph_getInstance(), Colrv1Paint_PaintColrGlyph_getInstance(), Colrv1Paint_PaintTransform_getInstance(), Colrv1Paint_PaintVarTransform_getInstance(), Colrv1Paint_PaintTranslate_getInstance(), Colrv1Paint_PaintVarTranslate_getInstance(), Colrv1Paint_PaintScale_getInstance(), Colrv1Paint_PaintVarScale_getInstance(), Colrv1Paint_PaintScaleAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleAroundCenter_getInstance(), Colrv1Paint_PaintScaleUniform_getInstance(), Colrv1Paint_PaintVarScaleUniform_getInstance(), Colrv1Paint_PaintScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintRotate_getInstance(), Colrv1Paint_PaintVarRotate_getInstance(), Colrv1Paint_PaintRotateAroundCenter_getInstance(), Colrv1Paint_PaintVarRotateAroundCenter_getInstance(), Colrv1Paint_PaintSkew_getInstance(), Colrv1Paint_PaintVarSkew_getInstance(), Colrv1Paint_PaintSkewAroundCenter_getInstance(), Colrv1Paint_PaintVarSkewAroundCenter_getInstance(), Colrv1Paint_PaintComposite_getInstance()];
  }
  var Colrv1Paint_entriesInitialized;
  function Colrv1Paint_initEntries() {
    if (Colrv1Paint_entriesInitialized)
      return Unit_instance;
    Colrv1Paint_entriesInitialized = true;
    Colrv1Paint_PaintColrLayers_instance = new Colrv1Paint('PaintColrLayers', 0);
    Colrv1Paint_PaintSolid_instance = new Colrv1Paint('PaintSolid', 1);
    Colrv1Paint_PaintVarSolid_instance = new Colrv1Paint('PaintVarSolid', 2);
    Colrv1Paint_PaintLinearGradient_instance = new Colrv1Paint('PaintLinearGradient', 3);
    Colrv1Paint_PaintVarLinearGradient_instance = new Colrv1Paint('PaintVarLinearGradient', 4);
    Colrv1Paint_PaintRadialGradient_instance = new Colrv1Paint('PaintRadialGradient', 5);
    Colrv1Paint_PaintVarRadialGradient_instance = new Colrv1Paint('PaintVarRadialGradient', 6);
    Colrv1Paint_PaintSweepGradient_instance = new Colrv1Paint('PaintSweepGradient', 7);
    Colrv1Paint_PaintVarSweepGradient_instance = new Colrv1Paint('PaintVarSweepGradient', 8);
    Colrv1Paint_PaintGlyph_instance = new Colrv1Paint('PaintGlyph', 9);
    Colrv1Paint_PaintColrGlyph_instance = new Colrv1Paint('PaintColrGlyph', 10);
    Colrv1Paint_PaintTransform_instance = new Colrv1Paint('PaintTransform', 11);
    Colrv1Paint_PaintVarTransform_instance = new Colrv1Paint('PaintVarTransform', 12);
    Colrv1Paint_PaintTranslate_instance = new Colrv1Paint('PaintTranslate', 13);
    Colrv1Paint_PaintVarTranslate_instance = new Colrv1Paint('PaintVarTranslate', 14);
    Colrv1Paint_PaintScale_instance = new Colrv1Paint('PaintScale', 15);
    Colrv1Paint_PaintVarScale_instance = new Colrv1Paint('PaintVarScale', 16);
    Colrv1Paint_PaintScaleAroundCenter_instance = new Colrv1Paint('PaintScaleAroundCenter', 17);
    Colrv1Paint_PaintVarScaleAroundCenter_instance = new Colrv1Paint('PaintVarScaleAroundCenter', 18);
    Colrv1Paint_PaintScaleUniform_instance = new Colrv1Paint('PaintScaleUniform', 19);
    Colrv1Paint_PaintVarScaleUniform_instance = new Colrv1Paint('PaintVarScaleUniform', 20);
    Colrv1Paint_PaintScaleUniformAroundCenter_instance = new Colrv1Paint('PaintScaleUniformAroundCenter', 21);
    Colrv1Paint_PaintVarScaleUniformAroundCenter_instance = new Colrv1Paint('PaintVarScaleUniformAroundCenter', 22);
    Colrv1Paint_PaintRotate_instance = new Colrv1Paint('PaintRotate', 23);
    Colrv1Paint_PaintVarRotate_instance = new Colrv1Paint('PaintVarRotate', 24);
    Colrv1Paint_PaintRotateAroundCenter_instance = new Colrv1Paint('PaintRotateAroundCenter', 25);
    Colrv1Paint_PaintVarRotateAroundCenter_instance = new Colrv1Paint('PaintVarRotateAroundCenter', 26);
    Colrv1Paint_PaintSkew_instance = new Colrv1Paint('PaintSkew', 27);
    Colrv1Paint_PaintVarSkew_instance = new Colrv1Paint('PaintVarSkew', 28);
    Colrv1Paint_PaintSkewAroundCenter_instance = new Colrv1Paint('PaintSkewAroundCenter', 29);
    Colrv1Paint_PaintVarSkewAroundCenter_instance = new Colrv1Paint('PaintVarSkewAroundCenter', 30);
    Colrv1Paint_PaintComposite_instance = new Colrv1Paint('PaintComposite', 31);
    Companion_getInstance_36();
  }
  function BaseTtfFont_init_$Init$(d, extName, onlyReadMetadata, enableLigatures, $this) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    BaseTtfFont.call($this, openFastStream(d), extName, onlyReadMetadata, enableLigatures);
    return $this;
  }
  function NamesInfo() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.e4j_1 = fillArrayVal(Array(26), null);
    this.f4j_1 = new Int32Array(26);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(26);
    while (tmp_1 < 26) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.g4j_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(26), null);
    while (tmp_4 < 26) {
      tmp_5[tmp_4] = get_UTF8();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.h4j_1 = tmp_5;
    this.i4j_1 = null;
  }
  protoOf(NamesInfo).d4h = function () {
    var tmp0_elvis_lhs = this.j4j(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.j4j(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  };
  protoOf(NamesInfo).k4j = function (nameId) {
    if (this.e4j_1[nameId] == null) {
      var nameLength = this.g4j_1[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this.i4j_1).l4j(this.f4j_1[nameId], nameLength, this.h4j_1[nameId]);
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(string) === 0) {
        tmp = string;
      } else {
        if (charSequenceGet(string, 0) === _Char___init__impl__6a9atx(0)) {
          // Inline function 'kotlin.text.filter' call
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder_init_$Create$();
          var inductionVariable = 0;
          var last = charSequenceLength(string);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(string, index);
              // Inline function 'korlibs.image.font.NamesInfo.getName.<anonymous>' call
              if (!(element === _Char___init__impl__6a9atx(0))) {
                destination.v5(element);
              }
            }
             while (inductionVariable < last);
          tmp = destination.toString();
        } else {
          tmp = string;
        }
      }
      this.e4j_1[nameId] = tmp;
    }
    return this.e4j_1[nameId];
  };
  protoOf(NamesInfo).j4j = function (nameId) {
    return this.k4j(nameId.o4j_1);
  };
  protoOf(NamesInfo).p4j = function () {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = values_2();
    var result = LinkedHashMap_init_$Create$_0(coerceAtLeast(mapCapacity(this_0.length), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.NamesInfo.toMap.<anonymous>' call
      var tmp$ret$0 = this.j4j(element);
      result.i2(element, tmp$ret$0);
    }
    return result;
  };
  protoOf(NamesInfo).toString = function () {
    return 'NamesInfo(' + this.p4j() + ')';
  };
  function SubstitutionInfo(maxSequence, map) {
    this.q4j_1 = maxSequence;
    this.r4j_1 = map;
  }
  function Table(id, checksum, offset, length) {
    this.w4i_1 = id;
    this.x4i_1 = checksum;
    this.y4i_1 = offset;
    this.z4i_1 = length;
    this.a4j_1 = null;
    var tmp = this;
    tmp.b4j_1 = lazy(BaseTtfFont$Table$ss$delegate$lambda(this));
  }
  protoOf(Table).s4j = function () {
    return _get_ss__ndcawb(this).g1s();
  };
  protoOf(Table).toString = function () {
    return 'Table(id=' + this.w4i_1 + ', checksum=' + this.x4i_1 + ', offset=' + this.y4i_1 + ', length=' + this.z4i_1 + ')';
  };
  protoOf(Table).hashCode = function () {
    var result = getStringHashCode(this.w4i_1);
    result = imul(result, 31) + this.x4i_1 | 0;
    result = imul(result, 31) + this.y4i_1 | 0;
    result = imul(result, 31) + this.z4i_1 | 0;
    return result;
  };
  protoOf(Table).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this.w4i_1 === tmp0_other_with_cast.w4i_1))
      return false;
    if (!(this.x4i_1 === tmp0_other_with_cast.x4i_1))
      return false;
    if (!(this.y4i_1 === tmp0_other_with_cast.y4i_1))
      return false;
    if (!(this.z4i_1 === tmp0_other_with_cast.z4i_1))
      return false;
    return true;
  };
  function HorMetric(advanceWidth, lsb) {
    this.t4j_1 = advanceWidth;
    this.u4j_1 = lsb;
  }
  protoOf(HorMetric).toString = function () {
    return 'HorMetric(advanceWidth=' + this.t4j_1 + ', lsb=' + this.u4j_1 + ')';
  };
  protoOf(HorMetric).hashCode = function () {
    var result = this.t4j_1;
    result = imul(result, 31) + this.u4j_1 | 0;
    return result;
  };
  protoOf(HorMetric).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this.t4j_1 === tmp0_other_with_cast.t4j_1))
      return false;
    if (!(this.u4j_1 === tmp0_other_with_cast.u4j_1))
      return false;
    return true;
  };
  function Companion_22() {
  }
  protoOf(Companion_22).v4j = function (s, info) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var format = s.z4a();
    var count = s.z4a();
    var stringOffset = s.z4a();
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < count) {
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId = s.z4a();
        var encodingId = s.z4a();
        var languageId = s.z4a();
        var nameId = s.z4a();
        var length = s.z4a();
        var offset = s.z4a();
        if (nameId < 0 ? true : nameId >= 26)
          continue $l$loop;
        var charset;
        switch (encodingId) {
          case 0:
            charset = get_UTF8();
            break;
          case 1:
            charset = get_UTF16_BE();
            break;
          default:
            charset = get_UTF16_BE();
            break;
        }
        if ((platformId === 0 ? languageId === 0 : false) ? true : info.g4j_1[nameId] === -1) {
          info.f4j_1[nameId] = stringOffset + offset | 0;
          info.g4j_1[nameId] = length;
          info.h4j_1[nameId] = charset;
          info.i4j_1 = s;
        }
      }
       while (inductionVariable < count);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(Companion_22).v4g = function (s) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    if (s.b4b() === 1953784678) {
      var majorVersion = s.z4a();
      var minorVersion = s.z4a();
      var numFonts = s.b4b();
      var tableDirectoryOffsets = s.x4j(numFonts);
      if (majorVersion >= 2) {
        var dsigTag = s.b4b();
        var dsigLength = s.b4b();
        var dsigOffset = s.b4b();
      }
      s.y4j(tableDirectoryOffsets[0]);
    } else {
      s.w4j(4);
    }
    // Inline function 'kotlin.apply' call
    var this_0 = s.z4a();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_0 === 1) ? !(this_0 === 20308) : false) {
      invalidOp('Not a TTF/OTF file');
    }
    var majorVersion_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = s.z4a();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_1 === 0) ? !(this_1 === 21583) : false) {
      invalidOp('Not a TTF/OTF file');
    }
    var minorVersion_0 = this_1;
    var numTables = s.z4a();
    var searchRange = s.z4a();
    var entrySelector = s.z4a();
    var rangeShift = s.z4a();
    // Inline function 'kotlin.collections.map' call
    var this_2 = until(0, numTables);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator = this_2.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
      var tmp$ret$2 = new Table(s.z4j(4), s.b4b(), s.b4b(), s.b4b());
      destination.r(tmp$ret$2);
    }
    var tables = destination;
    var tablesByName = LinkedHashMap_init_$Create$();
    var tmp0_iterator_0 = tables.u();
    while (tmp0_iterator_0.v()) {
      var table = tmp0_iterator_0.x();
      var tmp = table;
      tmp.a4j_1 = BaseTtfFont$Companion$readHeaderTables$lambda(s, table);
      // Inline function 'kotlin.collections.set' call
      var key = table.w4i_1;
      tablesByName.i2(key, table);
    }
    return tablesByName;
  };
  var Companion_instance_30;
  function Companion_getInstance_37() {
    return Companion_instance_30;
  }
  function NameId(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this.o4j_1 = id;
  }
  function ColorBitmapInfo(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    indexSubTableArrayOffset = indexSubTableArrayOffset === VOID ? 0 : indexSubTableArrayOffset;
    indexTablesSize = indexTablesSize === VOID ? 0 : indexTablesSize;
    numberofIndexSubTables = numberofIndexSubTables === VOID ? 0 : numberofIndexSubTables;
    colorRef = colorRef === VOID ? 0 : colorRef;
    hori = hori === VOID ? new SbitLineMetrics() : hori;
    vert = vert === VOID ? new SbitLineMetrics() : vert;
    startGlyphIndex = startGlyphIndex === VOID ? 0 : startGlyphIndex;
    endGlyphIndex = endGlyphIndex === VOID ? 0 : endGlyphIndex;
    ppemX = ppemX === VOID ? 0 : ppemX;
    ppemY = ppemY === VOID ? 0 : ppemY;
    bitDepth = bitDepth === VOID ? 0 : bitDepth;
    flags = flags === VOID ? 0 : flags;
    this.a4k_1 = indexSubTableArrayOffset;
    this.b4k_1 = indexTablesSize;
    this.c4k_1 = numberofIndexSubTables;
    this.d4k_1 = colorRef;
    this.e4k_1 = hori;
    this.f4k_1 = vert;
    this.g4k_1 = startGlyphIndex;
    this.h4k_1 = endGlyphIndex;
    this.i4k_1 = ppemX;
    this.j4k_1 = ppemY;
    this.k4k_1 = bitDepth;
    this.l4k_1 = flags;
  }
  protoOf(ColorBitmapInfo).toString = function () {
    return 'ColorBitmapInfo(indexSubTableArrayOffset=' + this.a4k_1 + ', indexTablesSize=' + this.b4k_1 + ', numberofIndexSubTables=' + this.c4k_1 + ', colorRef=' + this.d4k_1 + ', hori=' + this.e4k_1 + ', vert=' + this.f4k_1 + ', startGlyphIndex=' + this.g4k_1 + ', endGlyphIndex=' + this.h4k_1 + ', ppemX=' + this.i4k_1 + ', ppemY=' + this.j4k_1 + ', bitDepth=' + this.k4k_1 + ', flags=' + this.l4k_1 + ')';
  };
  protoOf(ColorBitmapInfo).hashCode = function () {
    var result = this.a4k_1;
    result = imul(result, 31) + this.b4k_1 | 0;
    result = imul(result, 31) + this.c4k_1 | 0;
    result = imul(result, 31) + this.d4k_1 | 0;
    result = imul(result, 31) + this.e4k_1.hashCode() | 0;
    result = imul(result, 31) + this.f4k_1.hashCode() | 0;
    result = imul(result, 31) + this.g4k_1 | 0;
    result = imul(result, 31) + this.h4k_1 | 0;
    result = imul(result, 31) + this.i4k_1 | 0;
    result = imul(result, 31) + this.j4k_1 | 0;
    result = imul(result, 31) + this.k4k_1 | 0;
    result = imul(result, 31) + this.l4k_1 | 0;
    return result;
  };
  protoOf(ColorBitmapInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this.a4k_1 === tmp0_other_with_cast.a4k_1))
      return false;
    if (!(this.b4k_1 === tmp0_other_with_cast.b4k_1))
      return false;
    if (!(this.c4k_1 === tmp0_other_with_cast.c4k_1))
      return false;
    if (!(this.d4k_1 === tmp0_other_with_cast.d4k_1))
      return false;
    if (!this.e4k_1.equals(tmp0_other_with_cast.e4k_1))
      return false;
    if (!this.f4k_1.equals(tmp0_other_with_cast.f4k_1))
      return false;
    if (!(this.g4k_1 === tmp0_other_with_cast.g4k_1))
      return false;
    if (!(this.h4k_1 === tmp0_other_with_cast.h4k_1))
      return false;
    if (!(this.i4k_1 === tmp0_other_with_cast.i4k_1))
      return false;
    if (!(this.j4k_1 === tmp0_other_with_cast.j4k_1))
      return false;
    if (!(this.k4k_1 === tmp0_other_with_cast.k4k_1))
      return false;
    if (!(this.l4k_1 === tmp0_other_with_cast.l4k_1))
      return false;
    return true;
  };
  function SbitLineMetrics(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    ascender = ascender === VOID ? 0 : ascender;
    descender = descender === VOID ? 0 : descender;
    widthMax = widthMax === VOID ? 0 : widthMax;
    caretSlopeNumerator = caretSlopeNumerator === VOID ? 0 : caretSlopeNumerator;
    caretSlopeDenominator = caretSlopeDenominator === VOID ? 0 : caretSlopeDenominator;
    caretOffset = caretOffset === VOID ? 0 : caretOffset;
    minOriginSB = minOriginSB === VOID ? 0 : minOriginSB;
    minAdvanceSB = minAdvanceSB === VOID ? 0 : minAdvanceSB;
    maxBeforeBL = maxBeforeBL === VOID ? 0 : maxBeforeBL;
    minAfterBL = minAfterBL === VOID ? 0 : minAfterBL;
    pad1 = pad1 === VOID ? 0 : pad1;
    pad2 = pad2 === VOID ? 0 : pad2;
    this.m4k_1 = ascender;
    this.n4k_1 = descender;
    this.o4k_1 = widthMax;
    this.p4k_1 = caretSlopeNumerator;
    this.q4k_1 = caretSlopeDenominator;
    this.r4k_1 = caretOffset;
    this.s4k_1 = minOriginSB;
    this.t4k_1 = minAdvanceSB;
    this.u4k_1 = maxBeforeBL;
    this.v4k_1 = minAfterBL;
    this.w4k_1 = pad1;
    this.x4k_1 = pad2;
  }
  protoOf(SbitLineMetrics).toString = function () {
    return 'SbitLineMetrics(ascender=' + this.m4k_1 + ', descender=' + this.n4k_1 + ', widthMax=' + this.o4k_1 + ', caretSlopeNumerator=' + this.p4k_1 + ', caretSlopeDenominator=' + this.q4k_1 + ', caretOffset=' + this.r4k_1 + ', minOriginSB=' + this.s4k_1 + ', minAdvanceSB=' + this.t4k_1 + ', maxBeforeBL=' + this.u4k_1 + ', minAfterBL=' + this.v4k_1 + ', pad1=' + this.w4k_1 + ', pad2=' + this.x4k_1 + ')';
  };
  protoOf(SbitLineMetrics).hashCode = function () {
    var result = this.m4k_1;
    result = imul(result, 31) + this.n4k_1 | 0;
    result = imul(result, 31) + this.o4k_1 | 0;
    result = imul(result, 31) + this.p4k_1 | 0;
    result = imul(result, 31) + this.q4k_1 | 0;
    result = imul(result, 31) + this.r4k_1 | 0;
    result = imul(result, 31) + this.s4k_1 | 0;
    result = imul(result, 31) + this.t4k_1 | 0;
    result = imul(result, 31) + this.u4k_1 | 0;
    result = imul(result, 31) + this.v4k_1 | 0;
    result = imul(result, 31) + this.w4k_1 | 0;
    result = imul(result, 31) + this.x4k_1 | 0;
    return result;
  };
  protoOf(SbitLineMetrics).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this.m4k_1 === tmp0_other_with_cast.m4k_1))
      return false;
    if (!(this.n4k_1 === tmp0_other_with_cast.n4k_1))
      return false;
    if (!(this.o4k_1 === tmp0_other_with_cast.o4k_1))
      return false;
    if (!(this.p4k_1 === tmp0_other_with_cast.p4k_1))
      return false;
    if (!(this.q4k_1 === tmp0_other_with_cast.q4k_1))
      return false;
    if (!(this.r4k_1 === tmp0_other_with_cast.r4k_1))
      return false;
    if (!(this.s4k_1 === tmp0_other_with_cast.s4k_1))
      return false;
    if (!(this.t4k_1 === tmp0_other_with_cast.t4k_1))
      return false;
    if (!(this.u4k_1 === tmp0_other_with_cast.u4k_1))
      return false;
    if (!(this.v4k_1 === tmp0_other_with_cast.v4k_1))
      return false;
    if (!(this.w4k_1 === tmp0_other_with_cast.w4k_1))
      return false;
    if (!(this.x4k_1 === tmp0_other_with_cast.x4k_1))
      return false;
    return true;
  };
  function BitmapGlyphInfo(glyphID, imageFormat, offset, size, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    imageFormat = imageFormat === VOID ? 0 : imageFormat;
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? 0 : size;
    height = height === VOID ? 0 : height;
    width = width === VOID ? 0 : width;
    horiBearingX = horiBearingX === VOID ? 0 : horiBearingX;
    horiBearingY = horiBearingY === VOID ? 0 : horiBearingY;
    horiAdvance = horiAdvance === VOID ? 0 : horiAdvance;
    vertBearingX = vertBearingX === VOID ? 0 : vertBearingX;
    vertBearingY = vertBearingY === VOID ? 0 : vertBearingY;
    vertAdvance = vertAdvance === VOID ? 0 : vertAdvance;
    this.y4k_1 = glyphID;
    this.z4k_1 = imageFormat;
    this.a4l_1 = offset;
    this.b4l_1 = size;
    this.c4l_1 = info;
    this.d4l_1 = height;
    this.e4l_1 = width;
    this.f4l_1 = horiBearingX;
    this.g4l_1 = horiBearingY;
    this.h4l_1 = horiAdvance;
    this.i4l_1 = vertBearingX;
    this.j4l_1 = vertBearingY;
    this.k4l_1 = vertAdvance;
    this.l4l_1 = null;
    this.m4l_1 = null;
  }
  protoOf(BitmapGlyphInfo).n4l = function () {
    return this.c4l_1.e4k_1.n4k_1;
  };
  protoOf(BitmapGlyphInfo).o4l = function (cache) {
    var tmp0_elvis_lhs = this.m4l_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      try {
        tmp_0 = PNG_getInstance().r4l(toSyncStream(ensureNotNull(this.l4l_1)));
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          println('Error in TtfFont.BitmapGlyphInfo: ' + e.message);
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp$ret$0 = get_Bitmaps_transparent();
          tmp_1 = get_bmp(tmp$ret$0);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this.m4l_1 = bmp;
    return bmp;
  };
  protoOf(BitmapGlyphInfo).s4l = function (cache, $super) {
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.o4l(cache) : $super.o4l.call(this, cache);
  };
  protoOf(BitmapGlyphInfo).toString = function () {
    return 'BitmapGlyphInfo(glyphID=' + this.y4k_1 + ', imageFormat=' + this.z4k_1 + ', offset=' + this.a4l_1 + ', size=' + this.b4l_1 + ', info=' + this.c4l_1 + ', height=' + this.d4l_1 + ', width=' + this.e4l_1 + ', horiBearingX=' + this.f4l_1 + ', horiBearingY=' + this.g4l_1 + ', horiAdvance=' + this.h4l_1 + ', vertBearingX=' + this.i4l_1 + ', vertBearingY=' + this.j4l_1 + ', vertAdvance=' + this.k4l_1 + ')';
  };
  protoOf(BitmapGlyphInfo).hashCode = function () {
    var result = this.y4k_1;
    result = imul(result, 31) + this.z4k_1 | 0;
    result = imul(result, 31) + this.a4l_1 | 0;
    result = imul(result, 31) + this.b4l_1 | 0;
    result = imul(result, 31) + this.c4l_1.hashCode() | 0;
    result = imul(result, 31) + this.d4l_1 | 0;
    result = imul(result, 31) + this.e4l_1 | 0;
    result = imul(result, 31) + this.f4l_1 | 0;
    result = imul(result, 31) + this.g4l_1 | 0;
    result = imul(result, 31) + this.h4l_1 | 0;
    result = imul(result, 31) + this.i4l_1 | 0;
    result = imul(result, 31) + this.j4l_1 | 0;
    result = imul(result, 31) + this.k4l_1 | 0;
    return result;
  };
  protoOf(BitmapGlyphInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this.y4k_1 === tmp0_other_with_cast.y4k_1))
      return false;
    if (!(this.z4k_1 === tmp0_other_with_cast.z4k_1))
      return false;
    if (!(this.a4l_1 === tmp0_other_with_cast.a4l_1))
      return false;
    if (!(this.b4l_1 === tmp0_other_with_cast.b4l_1))
      return false;
    if (!this.c4l_1.equals(tmp0_other_with_cast.c4l_1))
      return false;
    if (!(this.d4l_1 === tmp0_other_with_cast.d4l_1))
      return false;
    if (!(this.e4l_1 === tmp0_other_with_cast.e4l_1))
      return false;
    if (!(this.f4l_1 === tmp0_other_with_cast.f4l_1))
      return false;
    if (!(this.g4l_1 === tmp0_other_with_cast.g4l_1))
      return false;
    if (!(this.h4l_1 === tmp0_other_with_cast.h4l_1))
      return false;
    if (!(this.i4l_1 === tmp0_other_with_cast.i4l_1))
      return false;
    if (!(this.j4l_1 === tmp0_other_with_cast.j4l_1))
      return false;
    if (!(this.k4l_1 === tmp0_other_with_cast.k4l_1))
      return false;
    return true;
  };
  function ColorLine(cycle, stops) {
    this.t4l_1 = cycle;
    this.u4l_1 = stops;
  }
  protoOf(ColorLine).v4l = function (paint, palette) {
    var tmp0_iterator = this.u4l_1.u();
    while (tmp0_iterator.v()) {
      var stop = tmp0_iterator.x();
      paint.x4m(stop.w4l_1, RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(palette.e3q_1, stop.x4l_1), stop.y4l_1));
    }
  };
  protoOf(ColorLine).toString = function () {
    return 'ColorLine(cycle=' + this.t4l_1 + ', stops=' + this.u4l_1 + ')';
  };
  protoOf(ColorLine).hashCode = function () {
    var result = this.t4l_1.hashCode();
    result = imul(result, 31) + hashCode(this.u4l_1) | 0;
    return result;
  };
  protoOf(ColorLine).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorLine))
      return false;
    var tmp0_other_with_cast = other instanceof ColorLine ? other : THROW_CCE();
    if (!this.t4l_1.equals(tmp0_other_with_cast.t4l_1))
      return false;
    if (!equals(this.u4l_1, tmp0_other_with_cast.u4l_1))
      return false;
    return true;
  };
  function ColorStop(stopOffset, paletteIndex, alpha) {
    this.w4l_1 = stopOffset;
    this.x4l_1 = paletteIndex;
    this.y4l_1 = alpha;
  }
  function Colrv1Paint(name, ordinal) {
    Enum.call(this, name, ordinal);
    this.a4n_1 = this.ka_1 + 1 | 0;
  }
  function COLRv1(layerList, s, sBaseOffset, sLayerOffset, sClipOffset) {
    var tmp;
    if (layerList === VOID) {
      // Inline function 'kotlin.intArrayOf' call
      tmp = new Int32Array([]);
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (s === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0 = new Int8Array([]);
      tmp_0 = new FastByteArrayInputStream(tmp$ret$0);
    } else {
      tmp_0 = s;
    }
    s = tmp_0;
    var tmp_1;
    if (sBaseOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_0 = new Int8Array([]);
      tmp_1 = new FastByteArrayInputStream(tmp$ret$0_0);
    } else {
      tmp_1 = sBaseOffset;
    }
    sBaseOffset = tmp_1;
    var tmp_2;
    if (sLayerOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_1 = new Int8Array([]);
      tmp_2 = new FastByteArrayInputStream(tmp$ret$0_1);
    } else {
      tmp_2 = sLayerOffset;
    }
    sLayerOffset = tmp_2;
    sClipOffset = sClipOffset === VOID ? null : sClipOffset;
    this.b4n_1 = layerList;
    this.c4n_1 = s;
    this.d4n_1 = sBaseOffset;
    this.e4n_1 = sLayerOffset;
    this.f4n_1 = sClipOffset;
    this.g4n_1 = IntIntMap_init_$Create$();
  }
  function Contour(x, y, onCurve) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    onCurve = onCurve === VOID ? false : onCurve;
    this.h4n_1 = x;
    this.i4n_1 = y;
    this.j4n_1 = onCurve;
  }
  protoOf(Contour).toString = function () {
    return 'Contour(x=' + this.h4n_1 + ', y=' + this.i4n_1 + ', onCurve=' + this.j4n_1 + ')';
  };
  protoOf(Contour).hashCode = function () {
    var result = this.h4n_1;
    result = imul(result, 31) + this.i4n_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j4n_1) | 0;
    return result;
  };
  protoOf(Contour).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this.h4n_1 === tmp0_other_with_cast.h4n_1))
      return false;
    if (!(this.i4n_1 === tmp0_other_with_cast.i4n_1))
      return false;
    if (!(this.j4n_1 === tmp0_other_with_cast.j4n_1))
      return false;
    return true;
  };
  function GlyphReference(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this.k4n_1 = glyph;
    this.l4n_1 = x;
    this.m4n_1 = y;
    this.n4n_1 = scaleX;
    this.o4n_1 = scale01;
    this.p4n_1 = scale10;
    this.q4n_1 = scaleY;
  }
  protoOf(GlyphReference).toString = function () {
    return 'GlyphReference(glyph=' + this.k4n_1 + ', x=' + this.l4n_1 + ', y=' + this.m4n_1 + ', scaleX=' + this.n4n_1 + ', scale01=' + this.o4n_1 + ', scale10=' + this.p4n_1 + ', scaleY=' + this.q4n_1 + ')';
  };
  protoOf(GlyphReference).hashCode = function () {
    var result = hashCode(this.k4n_1);
    result = imul(result, 31) + this.l4n_1 | 0;
    result = imul(result, 31) + this.m4n_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.n4n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o4n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p4n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q4n_1) | 0;
    return result;
  };
  protoOf(GlyphReference).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals(this.k4n_1, tmp0_other_with_cast.k4n_1))
      return false;
    if (!(this.l4n_1 === tmp0_other_with_cast.l4n_1))
      return false;
    if (!(this.m4n_1 === tmp0_other_with_cast.m4n_1))
      return false;
    if (!equals(this.n4n_1, tmp0_other_with_cast.n4n_1))
      return false;
    if (!equals(this.o4n_1, tmp0_other_with_cast.o4n_1))
      return false;
    if (!equals(this.p4n_1, tmp0_other_with_cast.p4n_1))
      return false;
    if (!equals(this.q4n_1, tmp0_other_with_cast.q4n_1))
      return false;
    return true;
  };
  function ColrLayerInfo($outer, glyphID, paletteIndex) {
    this.t4n_1 = $outer;
    this.r4n_1 = glyphID;
    this.s4n_1 = paletteIndex;
  }
  protoOf(ColrLayerInfo).u4n = function (pal) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = new RgbaArray(getCyclic(this.t4n_1.j4g_1, pal).e3q_1);
    var index = this.s4n_1;
    var tmp;
    if (index >= 0 ? index <= get_lastIndex(this_0) : false) {
      tmp = this_0.f1(index).b3s_1;
    } else {
      // Inline function 'korlibs.image.font.ColrLayerInfo.color.<anonymous>' call
      tmp = Colors_getInstance().n3d_1;
    }
    return tmp;
  };
  protoOf(ColrLayerInfo).v4n = function () {
    return this.u4n(0);
  };
  protoOf(ColrLayerInfo).w4n = function (pal) {
    var tmp0_safe_receiver = this.t4n_1.r4i(this.r4n_1);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f4o();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.ColrLayerInfo.getShape.<anonymous>' call
      tmp = new FillShape(tmp1_safe_receiver.h4o_1, null, new RGBA(this.u4n(pal)));
    }
    return tmp;
  };
  protoOf(ColrLayerInfo).toString = function () {
    return 'ColrLayerInfo(' + this.r4n_1 + ', ' + this.s4n_1 + ', ' + new RGBA(this.v4n()) + ')';
  };
  function ColrGlyphInfo() {
  }
  function ColrGlyphInfoV1($outer, glyphID, paint) {
    this.m4o_1 = $outer;
    this.k4o_1 = glyphID;
    this.l4o_1 = paint;
  }
  protoOf(ColrGlyphInfoV1).i4o = function (pal) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    var paintS = this.m4o_1.k4g_1.d4n_1.u4a(this.l4o_1);
    try {
      this.m4o_1.e4i(this.k4o_1, paintS, this_0, pal, 0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    return this_0.k41();
  };
  protoOf(ColrGlyphInfoV1).toString = function () {
    return 'ColrGlyphInfoV1[' + this.k4o_1 + '][' + this.l4o_1 + ']';
  };
  function ColrGlyphInfoV0($outer, glyphID, firstLayerIndex, numLayers) {
    this.q4o_1 = $outer;
    this.n4o_1 = glyphID;
    this.o4o_1 = firstLayerIndex;
    this.p4o_1 = numLayers;
  }
  protoOf(ColrGlyphInfoV0).f1 = function (index) {
    return this.q4o_1.h4g_1[this.o4o_1 + index | 0];
  };
  protoOf(ColrGlyphInfoV0).g4a = function () {
    var tmp = 0;
    var tmp_0 = this.p4o_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this.f1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return toList_1(tmp_1);
  };
  protoOf(ColrGlyphInfoV0).i4o = function (pal) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.g4a();
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.font.ColrGlyphInfoV0.getColorShape.<anonymous>' call
      var tmp0_safe_receiver = element.w4n(pal);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.r(tmp0_safe_receiver);
      }
    }
    return new CompoundShape(destination);
  };
  protoOf(ColrGlyphInfoV0).toString = function () {
    return 'ColrGlyphInfoV0[' + this.n4o_1 + '][' + this.p4o_1 + '](' + this.g4a() + ')';
  };
  function GlyphGraphicsPath(glpyhIndex, path) {
    this.g4o_1 = glpyhIndex;
    this.h4o_1 = path;
  }
  protoOf(GlyphGraphicsPath).p33 = function () {
    return this.h4o_1.b2v_1;
  };
  protoOf(GlyphGraphicsPath).o33 = function () {
    return this.h4o_1.o33();
  };
  protoOf(GlyphGraphicsPath).u33 = function (center, r, start, end, counterclockwise) {
    this.h4o_1.u33(center, r, start, end, counterclockwise);
  };
  protoOf(GlyphGraphicsPath).w33 = function (center, radius) {
    this.h4o_1.w33(center, radius);
  };
  protoOf(GlyphGraphicsPath).p21 = function () {
    this.h4o_1.p21();
  };
  protoOf(GlyphGraphicsPath).t2u = function (c1, c2, a) {
    this.h4o_1.t2u(c1, c2, a);
  };
  protoOf(GlyphGraphicsPath).q33 = function (p0, p1) {
    this.h4o_1.q33(p0, p1);
  };
  protoOf(GlyphGraphicsPath).f2v = function (p) {
    this.h4o_1.f2v(p);
  };
  protoOf(GlyphGraphicsPath).s2u = function (p) {
    this.h4o_1.s2u(p);
  };
  protoOf(GlyphGraphicsPath).g2v = function (c, a) {
    this.h4o_1.g2v(c, a);
  };
  protoOf(GlyphGraphicsPath).y33 = function (delta) {
    this.h4o_1.y33(delta);
  };
  protoOf(GlyphGraphicsPath).x33 = function (delta) {
    this.h4o_1.x33(delta);
  };
  protoOf(GlyphGraphicsPath).s33 = function (pos, size) {
    this.h4o_1.s33(pos, size);
  };
  protoOf(GlyphGraphicsPath).r33 = function (rect) {
    this.h4o_1.r33(rect);
  };
  protoOf(GlyphGraphicsPath).t33 = function (x, y, width, height) {
    this.h4o_1.t33(x, y, width, height);
  };
  protoOf(GlyphGraphicsPath).p2l = function (m) {
    return this.h4o_1.p2l(m);
  };
  protoOf(GlyphGraphicsPath).toString = function () {
    return 'GlyphGraphicsPath(glpyhIndex=' + this.g4o_1 + ', "' + toSvgPathString(this.h4o_1) + '")';
  };
  protoOf(GlyphGraphicsPath).hashCode = function () {
    var result = this.g4o_1;
    result = imul(result, 31) + this.h4o_1.hashCode() | 0;
    return result;
  };
  protoOf(GlyphGraphicsPath).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphGraphicsPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphGraphicsPath ? other : THROW_CCE();
    if (!(this.g4o_1 === tmp0_other_with_cast.g4o_1))
      return false;
    if (!this.h4o_1.equals(tmp0_other_with_cast.h4o_1))
      return false;
    return true;
  };
  function Glyph_0($outer, index, xMin, yMin, xMax, yMax, advanceWidth) {
    this.e4o_1 = $outer;
    this.x4n_1 = index;
    this.y4n_1 = xMin;
    this.z4n_1 = yMin;
    this.a4o_1 = xMax;
    this.b4o_1 = yMax;
    this.c4o_1 = advanceWidth;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Glyph.metrics1px.<anonymous>' call
    var xMin_0 = this.y4n_1;
    var yMin_0 = this.z4n_1;
    var xMax_0 = this.a4o_1;
    var yMax_0 = this.b4o_1;
    if (((xMin_0 === 0 ? yMin_0 === 0 : false) ? xMax_0 === 0 : false) ? yMax_0 === 0 : false) {
      var sClipOffset = this.e4o_1.k4g_1.f4n_1;
      var glyphIDToClipOffset = this.e4o_1.k4g_1.g4n_1;
      var tmp_0;
      if (!(sClipOffset == null) ? glyphIDToClipOffset.zh(this.x4n_1) : false) {
        var clipOffset = glyphIDToClipOffset.f1(this.x4n_1);
        tmp_0 = this.e4o_1.c4i(sClipOffset.u4a(clipOffset));
      } else {
        var tmp0_safe_receiver = this.r4o();
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j4o();
        tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.s4o();
      }
      var bounds = tmp_0;
      if (!(bounds == null)) {
        xMin_0 = numberToInt(bounds.r2d());
        xMax_0 = numberToInt(bounds.s2d());
        yMin_0 = numberToInt(bounds.t2d());
        yMax_0 = numberToInt(bounds.u2d());
      }
    }
    var size = this.e4o_1.s4f_1;
    var scale = this.e4o_1.p3u(size);
    tmp.d4o_1 = new GlyphMetrics(size, true, -1, Companion_getInstance_2().t2k(xMin_0 * scale, yMin_0 * scale, xMax_0 * scale, yMax_0 * scale), this.c4o_1 * scale);
  }
  protoOf(Glyph_0).r4o = function () {
    return this.e4o_1.i4g_1.f1(this.x4n_1);
  };
  protoOf(Glyph_0).t4o = function () {
    return this.e4o_1.g4g_1.s2(this.x4n_1);
  };
  function CompositeGlyph($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth) {
    this.f4p_1 = $outer;
    Glyph_0.call(this, $outer, index, xMin, yMin, xMax, yMax, advanceWidth);
    this.c4p_1 = refs;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.c4p_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>' call
      var gpath = item.k4n_1.f4o().h4o_1;
      // Inline function 'kotlin.also' call
      var this_1 = new GlyphGraphicsPath(item.k4n_1.x4n_1, new VectorPath(new IntArrayList(gpath.u2u_1.n()), new DoubleArrayList(gpath.v2u_1.n())));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>.<anonymous>' call
      var m = Companion_getInstance_3().h2f().g2g(item.n4n_1, item.q4n_1).n2g(item.l4n_1, -item.m4n_1 | 0);
      this_1.h4o_1.j34(item.k4n_1.f4o().h4o_1, m);
      destination.r(this_1);
    }
    tmp.d4p_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>' call
    var commandsSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = this.d4p_1;
    var n = 0;
    while (n < this_2.n()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var gpath_0 = this_2.f1(tmp0);
      commandsSize = commandsSize + gpath_0.h4o_1.u2u_1.n() | 0;
      dataSize = dataSize + gpath_0.h4o_1.v2u_1.n() | 0;
    }
    // Inline function 'kotlin.also' call
    var this_3 = new GlyphGraphicsPath(index, new VectorPath(new IntArrayList(commandsSize), new DoubleArrayList(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = this.d4p_1;
    var n_0 = 0;
    while (n_0 < this_4.n()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      var it = this_4.f1(tmp0_0);
      this_3.h4o_1.k34(it.h4o_1);
    }
    tmp_0.e4p_1 = this_3;
  }
  protoOf(CompositeGlyph).toString = function () {
    return 'CompositeGlyph[' + this.c4o_1 + '](' + this.c4p_1 + ')';
  };
  protoOf(CompositeGlyph).f4o = function () {
    return this.e4p_1;
  };
  function CFFGlyph($outer, index, xMin, yMin, xMax, yMax, advanceWidth, path) {
    this.q4p_1 = $outer;
    Glyph_0.call(this, $outer, index, xMin, yMin, xMax, yMax, advanceWidth);
    this.o4p_1 = path;
    this.p4p_1 = listOf_0(this.o4p_1);
  }
  protoOf(CFFGlyph).f4o = function () {
    return this.o4p_1;
  };
  function SimpleGlyph($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth, dummy) {
    dummy = dummy === VOID ? false : dummy;
    this.g4q_1 = $outer;
    Glyph_0.call(this, $outer, index, xMin, yMin, xMax, yMax, advanceWidth);
    this.z4p_1 = contoursIndices;
    this.a4q_1 = flags;
    this.b4q_1 = xPos;
    this.c4q_1 = yPos;
    this.d4q_1 = dummy;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>' call
    var commandSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    this.g4q_1;
    var inductionVariable = 0;
    var last = this.z4p_1.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart = this.z4p_1[n] + 1 | 0;
        var cend = this.z4p_1[n + 1 | 0];
        var csize = (cend - cstart | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
        commandSize = commandSize + (1 + imul(csize, 2) | 0) | 0;
        dataSize = dataSize + (2 + imul(csize, 8) | 0) | 0;
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = new GlyphGraphicsPath(index, new VectorPath(new IntArrayList(commandSize), new DoubleArrayList(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var this_1 = this.g4q_1;
    var inductionVariable_0 = 0;
    var last_0 = this.z4p_1.length - 1 | 0;
    if (inductionVariable_0 < last_0)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_0 = this.z4p_1[n_0] + 1 | 0;
        var cend_0 = this.z4p_1[n_0 + 1 | 0];
        var csize_0 = (cend_0 - cstart_0 | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
        var curr = this.h4q(cend_0, this_1.o4e_1[0]);
        var next = this.h4q(cstart_0, this_1.o4e_1[1]);
        if (curr.j4n_1) {
          this_0.s2u(Vector2D_init_$Create$(curr.h4n_1, -curr.i4n_1 | 0));
        } else if (next.j4n_1) {
          this_0.s2u(Vector2D_init_$Create$(next.h4n_1, -next.i4n_1 | 0));
        } else {
          this_0.s2u(Vector2D_init_$Create$(imul(curr.h4n_1 + next.h4n_1 | 0, 0), -numberToInt((curr.i4n_1 + next.i4n_1 | 0) * 0.5) | 0));
        }
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_0)
          do {
            var cpos = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev = curr;
            curr = next;
            next = this.h4q(cstart_0 + ((cpos + 1 | 0) % csize_0 | 0) | 0, this_1.o4e_1[(cpos + 2 | 0) % 3 | 0]);
            if (curr.j4n_1) {
              this_0.f2v(Vector2D_init_$Create$(curr.h4n_1, -curr.i4n_1 | 0));
            } else {
              var prev2X = prev.h4n_1;
              var prev2Y = prev.i4n_1;
              var next2X = next.h4n_1;
              var next2Y = next.i4n_1;
              if (!prev.j4n_1) {
                prev2X = numberToInt((curr.h4n_1 + prev.h4n_1 | 0) * 0.5);
                prev2Y = numberToInt((curr.i4n_1 + prev.i4n_1 | 0) * 0.5);
                this_0.f2v(Vector2D_init_$Create$(prev2X, -prev2Y | 0));
              }
              if (!next.j4n_1) {
                next2X = numberToInt((curr.h4n_1 + next.h4n_1 | 0) * 0.5);
                next2Y = numberToInt((curr.i4n_1 + next.i4n_1 | 0) * 0.5);
              }
              this_0.f2v(Vector2D_init_$Create$(prev2X, -prev2Y | 0));
              this_0.g2v(Vector2D_init_$Create$(curr.h4n_1, -curr.i4n_1 | 0), Vector2D_init_$Create$(next2X, -next2Y | 0));
            }
          }
           while (inductionVariable_1 < csize_0);
        this_0.p21();
      }
       while (inductionVariable_0 < last_0);
    tmp.e4q_1 = this_0;
    this.f4q_1 = listOf_0(this.e4q_1);
  }
  protoOf(SimpleGlyph).toString = function () {
    return 'SimpleGlyph' + (this.d4q_1 ? 'Dummy' : '') + '[' + this.x4n_1 + '](advance=' + this.c4o_1 + ') : ' + this.e4q_1;
  };
  protoOf(SimpleGlyph).i4q = function (n) {
    return !((this.a4q_1[n] & 1) === 0);
  };
  protoOf(SimpleGlyph).h4q = function (n, out) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.contour.<anonymous>' call
    out.h4n_1 = this.b4q_1[n];
    out.i4n_1 = this.c4q_1[n];
    out.j4n_1 = this.i4q(n);
    return out;
  };
  protoOf(SimpleGlyph).f4o = function () {
    return this.e4q_1;
  };
  function BaseTtfFont$readCblc$1$Subtable(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this.j4q_1 = firstGlyphIndex;
    this.k4q_1 = lastGlyphIndex;
    this.l4q_1 = additionalOffsetToIndexSubtable;
  }
  protoOf(BaseTtfFont$readCblc$1$Subtable).m4q = function () {
    return this.k4q_1 - this.j4q_1 | 0;
  };
  protoOf(BaseTtfFont$readCblc$1$Subtable).toString = function () {
    return 'Subtable(firstGlyphIndex=' + this.j4q_1 + ', lastGlyphIndex=' + this.k4q_1 + ', additionalOffsetToIndexSubtable=' + this.l4q_1 + ')';
  };
  protoOf(BaseTtfFont$readCblc$1$Subtable).hashCode = function () {
    var result = this.j4q_1;
    result = imul(result, 31) + this.k4q_1 | 0;
    result = imul(result, 31) + this.l4q_1 | 0;
    return result;
  };
  protoOf(BaseTtfFont$readCblc$1$Subtable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCblc$1$Subtable))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCblc$1$Subtable ? other : THROW_CCE();
    if (!(this.j4q_1 === tmp0_other_with_cast.j4q_1))
      return false;
    if (!(this.k4q_1 === tmp0_other_with_cast.k4q_1))
      return false;
    if (!(this.l4q_1 === tmp0_other_with_cast.l4q_1))
      return false;
    return true;
  };
  function BaseTtfFont$readSbix$1$StrikeInfo(ppem, ppi, strikeOffset, offsets) {
    this.n4q_1 = ppem;
    this.o4q_1 = ppi;
    this.p4q_1 = strikeOffset;
    this.q4q_1 = offsets;
  }
  protoOf(BaseTtfFont$readSbix$1$StrikeInfo).toString = function () {
    return 'StrikeInfo(ppem=' + this.n4q_1 + ', ppi=' + this.o4q_1 + ', strikeOffset=' + this.p4q_1 + ', offsets=' + this.q4q_1 + ')';
  };
  protoOf(BaseTtfFont$readSbix$1$StrikeInfo).hashCode = function () {
    var result = this.n4q_1;
    result = imul(result, 31) + this.o4q_1 | 0;
    result = imul(result, 31) + this.p4q_1 | 0;
    result = imul(result, 31) + this.q4q_1.hashCode() | 0;
    return result;
  };
  protoOf(BaseTtfFont$readSbix$1$StrikeInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readSbix$1$StrikeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readSbix$1$StrikeInfo ? other : THROW_CCE();
    if (!(this.n4q_1 === tmp0_other_with_cast.n4q_1))
      return false;
    if (!(this.o4q_1 === tmp0_other_with_cast.o4q_1))
      return false;
    if (!(this.p4q_1 === tmp0_other_with_cast.p4q_1))
      return false;
    if (!this.q4q_1.equals(tmp0_other_with_cast.q4q_1))
      return false;
    return true;
  };
  function BaseTtfFont$readCoverage$RangeInfo(start, endInclusive, index) {
    this.r4q_1 = start;
    this.s4q_1 = endInclusive;
    this.t4q_1 = index;
    this.u4q_1 = (this.s4q_1 - this.r4q_1 | 0) + 1 | 0;
  }
  protoOf(BaseTtfFont$readCoverage$RangeInfo).toString = function () {
    return 'RangeInfo(start=' + this.r4q_1 + ', endInclusive=' + this.s4q_1 + ', index=' + this.t4q_1 + ')';
  };
  protoOf(BaseTtfFont$readCoverage$RangeInfo).hashCode = function () {
    var result = this.r4q_1;
    result = imul(result, 31) + this.s4q_1 | 0;
    result = imul(result, 31) + this.t4q_1 | 0;
    return result;
  };
  protoOf(BaseTtfFont$readCoverage$RangeInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCoverage$RangeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCoverage$RangeInfo ? other : THROW_CCE();
    if (!(this.r4q_1 === tmp0_other_with_cast.r4q_1))
      return false;
    if (!(this.s4q_1 === tmp0_other_with_cast.s4q_1))
      return false;
    if (!(this.t4q_1 === tmp0_other_with_cast.t4q_1))
      return false;
    return true;
  };
  function BaseTtfFont$readCmap$1$EncodingRecord(platformId, encodingId, offset) {
    this.v4q_1 = platformId;
    this.w4q_1 = encodingId;
    this.x4q_1 = offset;
  }
  protoOf(BaseTtfFont$readCmap$1$EncodingRecord).toString = function () {
    return 'EncodingRecord(platformId=' + this.v4q_1 + ', encodingId=' + this.w4q_1 + ', offset=' + this.x4q_1 + ')';
  };
  protoOf(BaseTtfFont$readCmap$1$EncodingRecord).hashCode = function () {
    var result = this.v4q_1;
    result = imul(result, 31) + this.w4q_1 | 0;
    result = imul(result, 31) + this.x4q_1 | 0;
    return result;
  };
  protoOf(BaseTtfFont$readCmap$1$EncodingRecord).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCmap$1$EncodingRecord))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCmap$1$EncodingRecord ? other : THROW_CCE();
    if (!(this.v4q_1 === tmp0_other_with_cast.v4q_1))
      return false;
    if (!(this.w4q_1 === tmp0_other_with_cast.w4q_1))
      return false;
    if (!(this.x4q_1 === tmp0_other_with_cast.x4q_1))
      return false;
    return true;
  };
  function NameId_COPYRIGHT_getInstance() {
    NameId_initEntries();
    return NameId_COPYRIGHT_instance;
  }
  function NameId_NAME_getInstance() {
    NameId_initEntries();
    return NameId_NAME_instance;
  }
  function NameId_STYLE_getInstance() {
    NameId_initEntries();
    return NameId_STYLE_instance;
  }
  function NameId_UNAME_getInstance() {
    NameId_initEntries();
    return NameId_UNAME_instance;
  }
  function NameId_COMPLETE_NAME_getInstance() {
    NameId_initEntries();
    return NameId_COMPLETE_NAME_instance;
  }
  function NameId_RELEASE_VERSION_getInstance() {
    NameId_initEntries();
    return NameId_RELEASE_VERSION_instance;
  }
  function NameId_POSTSCRIPT_NAME_getInstance() {
    NameId_initEntries();
    return NameId_POSTSCRIPT_NAME_instance;
  }
  function NameId_TRADEMARK_getInstance() {
    NameId_initEntries();
    return NameId_TRADEMARK_instance;
  }
  function NameId_MANUFACTURER_getInstance() {
    NameId_initEntries();
    return NameId_MANUFACTURER_instance;
  }
  function NameId_DESIGNER_getInstance() {
    NameId_initEntries();
    return NameId_DESIGNER_instance;
  }
  function NameId_DESCRIPTION_getInstance() {
    NameId_initEntries();
    return NameId_DESCRIPTION_instance;
  }
  function NameId_URL_VENDOR_getInstance() {
    NameId_initEntries();
    return NameId_URL_VENDOR_instance;
  }
  function NameId_URL_DESIGNER_getInstance() {
    NameId_initEntries();
    return NameId_URL_DESIGNER_instance;
  }
  function NameId_LICENSE_DESCRIPTION_getInstance() {
    NameId_initEntries();
    return NameId_LICENSE_DESCRIPTION_instance;
  }
  function NameId_LICENSE_URL_getInstance() {
    NameId_initEntries();
    return NameId_LICENSE_URL_instance;
  }
  function NameId_RESERVED_15_getInstance() {
    NameId_initEntries();
    return NameId_RESERVED_15_instance;
  }
  function NameId_PREFERRED_FAMILY_getInstance() {
    NameId_initEntries();
    return NameId_PREFERRED_FAMILY_instance;
  }
  function NameId_PREFERRED_SUBFAMILY_getInstance() {
    NameId_initEntries();
    return NameId_PREFERRED_SUBFAMILY_instance;
  }
  function NameId_COMPATIBLE_FULL_getInstance() {
    NameId_initEntries();
    return NameId_COMPATIBLE_FULL_instance;
  }
  function NameId_SAMPLE_TEXT_getInstance() {
    NameId_initEntries();
    return NameId_SAMPLE_TEXT_instance;
  }
  function NameId_POSTSCRIPT_CID_getInstance() {
    NameId_initEntries();
    return NameId_POSTSCRIPT_CID_instance;
  }
  function NameId_WWS_FAMILY_NAME_getInstance() {
    NameId_initEntries();
    return NameId_WWS_FAMILY_NAME_instance;
  }
  function NameId_WWS_SUBFAMILY_NAME_getInstance() {
    NameId_initEntries();
    return NameId_WWS_SUBFAMILY_NAME_instance;
  }
  function NameId_LIGHT_BACKGROUND_getInstance() {
    NameId_initEntries();
    return NameId_LIGHT_BACKGROUND_instance;
  }
  function NameId_DARK_BACKGROUND_getInstance() {
    NameId_initEntries();
    return NameId_DARK_BACKGROUND_instance;
  }
  function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
    NameId_initEntries();
    return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
  }
  function Colrv1Paint_PaintColrLayers_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintColrLayers_instance;
  }
  function Colrv1Paint_PaintSolid_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintSolid_instance;
  }
  function Colrv1Paint_PaintVarSolid_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarSolid_instance;
  }
  function Colrv1Paint_PaintLinearGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintLinearGradient_instance;
  }
  function Colrv1Paint_PaintVarLinearGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarLinearGradient_instance;
  }
  function Colrv1Paint_PaintRadialGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintRadialGradient_instance;
  }
  function Colrv1Paint_PaintVarRadialGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarRadialGradient_instance;
  }
  function Colrv1Paint_PaintSweepGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintSweepGradient_instance;
  }
  function Colrv1Paint_PaintVarSweepGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarSweepGradient_instance;
  }
  function Colrv1Paint_PaintGlyph_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintGlyph_instance;
  }
  function Colrv1Paint_PaintColrGlyph_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintColrGlyph_instance;
  }
  function Colrv1Paint_PaintTransform_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintTransform_instance;
  }
  function Colrv1Paint_PaintVarTransform_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarTransform_instance;
  }
  function Colrv1Paint_PaintTranslate_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintTranslate_instance;
  }
  function Colrv1Paint_PaintVarTranslate_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarTranslate_instance;
  }
  function Colrv1Paint_PaintScale_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintScale_instance;
  }
  function Colrv1Paint_PaintVarScale_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarScale_instance;
  }
  function Colrv1Paint_PaintScaleAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintScaleAroundCenter_instance;
  }
  function Colrv1Paint_PaintVarScaleAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarScaleAroundCenter_instance;
  }
  function Colrv1Paint_PaintScaleUniform_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintScaleUniform_instance;
  }
  function Colrv1Paint_PaintVarScaleUniform_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarScaleUniform_instance;
  }
  function Colrv1Paint_PaintScaleUniformAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintScaleUniformAroundCenter_instance;
  }
  function Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
  }
  function Colrv1Paint_PaintRotate_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintRotate_instance;
  }
  function Colrv1Paint_PaintVarRotate_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarRotate_instance;
  }
  function Colrv1Paint_PaintRotateAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintRotateAroundCenter_instance;
  }
  function Colrv1Paint_PaintVarRotateAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarRotateAroundCenter_instance;
  }
  function Colrv1Paint_PaintSkew_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintSkew_instance;
  }
  function Colrv1Paint_PaintVarSkew_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarSkew_instance;
  }
  function Colrv1Paint_PaintSkewAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintSkewAroundCenter_instance;
  }
  function Colrv1Paint_PaintVarSkewAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarSkewAroundCenter_instance;
  }
  function Colrv1Paint_PaintComposite_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintComposite_instance;
  }
  function BaseTtfFont(s, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    this.i4e_1 = s;
    this.j4e_1 = extName;
    this.k4e_1 = onlyReadMetadata;
    this.l4e_1 = enableLigatures;
    this.m4e_1 = new Mixin();
    this.n4e_1 = new NamesInfo();
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(3), null);
    while (tmp_0 < 3) {
      tmp_1[tmp_0] = new Contour();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.o4e_1 = tmp_1;
    this.p4e_1 = 0;
    this.q4e_1 = 0;
    this.r4e_1 = 0;
    this.s4e_1 = 0;
    this.t4e_1 = 0;
    this.u4e_1 = 0;
    this.v4e_1 = 0;
    this.w4e_1 = 0;
    this.x4e_1 = 0;
    this.y4e_1 = 0;
    this.z4e_1 = 0;
    this.a4f_1 = 0;
    this.b4f_1 = 0;
    this.c4f_1 = 0;
    this.d4f_1 = Companion_instance_31.y4q(0, 0);
    this.e4f_1 = 0;
    this.f4f_1 = 0;
    this.g4f_1 = 0;
    this.h4f_1 = 0;
    this.i4f_1 = 0;
    this.j4f_1 = 0;
    this.k4f_1 = 0;
    this.l4f_1 = 0;
    this.m4f_1 = 0;
    this.n4f_1 = 0;
    this.o4f_1 = 0;
    this.p4f_1 = 0;
    this.q4f_1 = new Int32Array(0);
    this.r4f_1 = Companion_instance_31.y4q(0, 0);
    this.s4f_1 = 128;
    this.t4f_1 = 0;
    this.u4f_1 = 0;
    this.v4f_1 = 0;
    this.w4f_1 = 0;
    this.x4f_1 = 0;
    this.y4f_1 = 0;
    this.z4f_1 = 0;
    this.a4g_1 = 0;
    this.b4g_1 = 0;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.c4g_1 = emptyList();
    this.d4g_1 = LinkedHashMap_init_$Create$();
    this.e4g_1 = LinkedHashMap_init_$Create$();
    this.f4g_1 = IntMap_init_$Create$(512);
    this.g4g_1 = LinkedHashMap_init_$Create$();
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.h4g_1 = [];
    this.i4g_1 = IntMap_init_$Create$();
    var tmp_4 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.j4g_1 = emptyList();
    this.k4g_1 = new COLRv1();
    this.l4g_1 = false;
    this.m4g_1 = IntIntMap_init_$Create$();
    this.n4g_1 = IntMap_init_$Create$();
    this.p4g_1 = new GlyphMetrics(1.0, false, 0, Companion_getInstance_2().h2f(), 0.0);
    this.q4g_1 = false;
    this.r4g_1 = null;
  }
  protoOf(BaseTtfFont).h23 = function (_set____db54di) {
    this.m4e_1.h23(_set____db54di);
  };
  protoOf(BaseTtfFont).i23 = function () {
    return this.m4e_1.i23();
  };
  protoOf(BaseTtfFont).t3t = function (size, metrics) {
    return metrics.d3u(this.c4h(), size);
  };
  protoOf(BaseTtfFont).f3u = function (size, codePoint, metrics, reader) {
    var tmp0_safe_receiver = this.n4i(reader, codePoint);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d4o_1;
    return metrics.m3u(tmp1_elvis_lhs == null ? this.p4g_1 : tmp1_elvis_lhs, size, codePoint);
  };
  protoOf(BaseTtfFont).s3v = function (size, leftCodePoint, rightCodePoint) {
    return 0.0;
  };
  protoOf(BaseTtfFont).x4g = function (size, codePoint, path, reader) {
    var spos = reader == null ? null : reader.a4r_1;
    var codePointPeek = reader == null ? null : reader.b4r(0);
    var tmp2_elvis_lhs = this.m4i(reader, codePoint, true);
    var tmp;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var g = tmp;
    var scale = this.p3u(size);
    path.p47_1 = g.f4o().h4o_1;
    var tmp_0 = path;
    var tmp3_safe_receiver = g.r4o();
    tmp_0.q47_1 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.j4o();
    var bitmapEntry = g.t4o();
    var bitmap = bitmapEntry == null ? null : bitmapEntry.s4l();
    path.r47_1 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this.s4f_1 / bitmapEntry.c4l_1.i4k_1;
      var scaleY = this.s4f_1 / bitmapEntry.c4l_1.j4k_1;
      path.s47_1 = new Vector2D(0.0, ((-bitmapEntry.d4l_1 | 0) - bitmapEntry.n4l() | 0) * scaleY);
      path.t47_1 = new Scale(scaleX, scaleY);
    }
    path.u47_1 = Companion_getInstance_3().e2f_1.h2g(scale, scale);
    path.v47_1 = scale;
    return path;
  };
  protoOf(BaseTtfFont).p3u = function (size) {
    return size / this.s4f_1;
  };
  protoOf(BaseTtfFont).z4g = function (key) {
    return this.d4g_1.s2(key);
  };
  protoOf(BaseTtfFont).a4h = function (codePoint, glyphID) {
    // Inline function 'kotlin.collections.set' call
    this.d4g_1.i2(codePoint, glyphID);
    // Inline function 'kotlin.collections.set' call
    this.e4g_1.i2(glyphID, codePoint);
  };
  protoOf(BaseTtfFont).b4h = function (codePoint, glyphID) {
  };
  protoOf(BaseTtfFont).c4h = function () {
    var tmp = this.o4g_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontMetrics1px');
    }
  };
  protoOf(BaseTtfFont).d4h = function () {
    return this.n4e_1.d4h();
  };
  protoOf(BaseTtfFont).zb = function () {
    var tmp0_elvis_lhs = this.j4e_1;
    return tmp0_elvis_lhs == null ? this.d4h() : tmp0_elvis_lhs;
  };
  protoOf(BaseTtfFont).s4g = function () {
    this.t4g();
    this.j4h();
    this.k4h();
    this.l4h();
    this.h4h();
    if (!this.k4e_1) {
      if (!(this.w4g('CFF ') == null) ? this.w4g('glyf') == null : false) {
        // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
        var tmp0_safe_receiver = this.g4h('CFF ');
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
          // Inline function 'kotlin.apply' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>.<anonymous>' call
          this.r4g_1 = CFF_instance.l4a(tmp0_safe_receiver);
        }
      }
      this.i4h();
      this.j4i();
      this.m4h();
      this.n4h();
      this.i4i();
      this.h4i();
      this.p4h();
      this.q4h();
      this.r4h();
    }
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new FontMetrics();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
    var scale = this.p3u(1.0);
    this_0.u3t_1 = 1.0;
    this_0.v3t_1 = this.w4f_1 * scale;
    this_0.w3t_1 = this.e4f_1 * scale;
    this_0.x3t_1 = 0.0 * scale;
    this_0.y3t_1 = this.f4f_1 * scale;
    this_0.z3t_1 = this.u4f_1 * scale;
    this_0.a3u_1 = this.g4f_1 * scale;
    this_0.b3u_1 = this.h4f_1 * scale;
    this_0.c3u_1 = this.s4f_1 * scale;
    tmp.o4g_1 = this_0;
  };
  protoOf(BaseTtfFont).toString = function () {
    return 'TtfFont(name=' + this.zb() + ')';
  };
  protoOf(BaseTtfFont).e4h = function (_this__u8e3s4) {
    return _FWord___init__impl__2rjyqf(_this__u8e3s4.z4a());
  };
  protoOf(BaseTtfFont).f4h = function (_this__u8e3s4) {
    return Companion_instance_31.y4q(_this__u8e3s4.c4r(), _this__u8e3s4.c4r());
  };
  protoOf(BaseTtfFont).g4h = function (name) {
    var tmp0_safe_receiver = this.w4g(name);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s4j();
  };
  protoOf(BaseTtfFont).h4h = function () {
    var tmp0_safe_receiver = this.g4h('name');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readNames.<anonymous>' call
      Companion_instance_30.v4j(tmp0_safe_receiver, this.n4e_1);
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).i4h = function () {
    var tmp0_safe_receiver = this.g4h('loca');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>' call
      var tmp;
      switch (this.a4g_1) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:
          get_invalidOp();
          break;
      }
      var bytesPerEntry = tmp;
      var data = tmp0_safe_receiver.c4b(imul(bytesPerEntry, this.p4e_1 + 1 | 0));
      var tmp_0 = this;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>' call
      var $this$run = new FastByteArrayInputStream(data);
      var tmp_1;
      switch (this.a4g_1) {
        case 0:
          // Inline function 'korlibs.datastructure.mapInt' call

          var this_0 = $this$run.d4r(this.p4e_1 + 1 | 0);
          // Inline function 'kotlin.also' call

          var this_1 = new Int32Array(this_0.length);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

          var inductionVariable = 0;
          var last = this_0.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.code' call
              var this_2 = this_0[n];
              var tmp$ret$0 = Char__toInt_impl_vasixd(this_2);
              this_1[n] = imul(tmp$ret$0, 2);
            }
             while (inductionVariable < last);
          tmp_1 = this_1;
          break;
        case 1:
          tmp_1 = $this$run.x4j(this.p4e_1 + 1 | 0);
          break;
        default:
          get_invalidOp();
          break;
      }
      tmp_0.q4f_1 = tmp_1;
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).j4h = function () {
    var tmp0_safe_receiver = this.g4h('head');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp0_safe_receiver.z4a() === 1)) {
        invalidOp('Invalid TTF');
      }
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp0_safe_receiver.z4a() === 0)) {
        invalidOp('Invalid TTF');
      }
      this.r4f_1 = this.f4h(tmp0_safe_receiver);
      var checkSumAdjustment = tmp0_safe_receiver.b4b();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp0_safe_receiver.b4b();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(this_0 === 1594834165)) {
        invalidOp('Invalid magic ' + get_hex(this_0));
      }
      var flags = tmp0_safe_receiver.z4a();
      this.s4f_1 = tmp0_safe_receiver.z4a();
      var created = tmp0_safe_receiver.e4r().na(new Long(1000, 0));
      var modified = tmp0_safe_receiver.e4r().na(new Long(1000, 0));
      this.t4f_1 = tmp0_safe_receiver.c4r();
      this.u4f_1 = tmp0_safe_receiver.c4r();
      this.v4f_1 = tmp0_safe_receiver.c4r();
      this.w4f_1 = tmp0_safe_receiver.c4r();
      this.x4f_1 = tmp0_safe_receiver.z4a();
      this.y4f_1 = tmp0_safe_receiver.z4a();
      this.z4f_1 = tmp0_safe_receiver.c4r();
      this.a4g_1 = tmp0_safe_receiver.c4r();
      this.b4g_1 = tmp0_safe_receiver.c4r();
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).k4h = function () {
    var tmp0_safe_receiver = this.g4h('maxp');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readMaxp.<anonymous>' call
      var version = this.f4h(tmp0_safe_receiver);
      this.p4e_1 = tmp0_safe_receiver.z4a();
      this.q4e_1 = tmp0_safe_receiver.z4a();
      this.r4e_1 = tmp0_safe_receiver.z4a();
      this.s4e_1 = tmp0_safe_receiver.z4a();
      this.t4e_1 = tmp0_safe_receiver.z4a();
      this.u4e_1 = tmp0_safe_receiver.z4a();
      this.v4e_1 = tmp0_safe_receiver.z4a();
      this.w4e_1 = tmp0_safe_receiver.z4a();
      this.x4e_1 = tmp0_safe_receiver.z4a();
      this.y4e_1 = tmp0_safe_receiver.z4a();
      this.z4e_1 = tmp0_safe_receiver.z4a();
      this.a4f_1 = tmp0_safe_receiver.z4a();
      this.b4f_1 = tmp0_safe_receiver.z4a();
      this.c4f_1 = tmp0_safe_receiver.z4a();
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).l4h = function () {
    var tmp0_safe_receiver = this.g4h('hhea');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHhea.<anonymous>' call
      this.d4f_1 = this.f4h(tmp0_safe_receiver);
      this.e4f_1 = tmp0_safe_receiver.c4r();
      this.f4f_1 = tmp0_safe_receiver.c4r();
      this.g4f_1 = tmp0_safe_receiver.c4r();
      this.h4f_1 = tmp0_safe_receiver.z4a();
      this.i4f_1 = tmp0_safe_receiver.c4r();
      this.j4f_1 = tmp0_safe_receiver.c4r();
      this.k4f_1 = tmp0_safe_receiver.c4r();
      this.l4f_1 = tmp0_safe_receiver.c4r();
      this.m4f_1 = tmp0_safe_receiver.c4r();
      this.n4f_1 = tmp0_safe_receiver.c4r();
      tmp0_safe_receiver.c4r();
      tmp0_safe_receiver.c4r();
      tmp0_safe_receiver.c4r();
      tmp0_safe_receiver.c4r();
      this.o4f_1 = tmp0_safe_receiver.c4r();
      this.p4f_1 = tmp0_safe_receiver.z4a();
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).m4h = function () {
    var tmp0_safe_receiver = this.g4h('hmtx');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, this.p4f_1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new HorMetric(tmp0_safe_receiver.z4a(), tmp0_safe_receiver.c4r());
        destination.r(tmp$ret$0);
      }
      var firstMetrics = destination;
      var lastAdvanceWidth = last(firstMetrics).t4j_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, this.p4e_1 - this.p4f_1 | 0);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.u();
      while (tmp0_iterator_0.v()) {
        var item_0 = tmp0_iterator_0.x();
        // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
        var tmp$ret$3 = new HorMetric(lastAdvanceWidth, tmp0_safe_receiver.c4r());
        destination_0.r(tmp$ret$3);
      }
      var compressedMetrics = destination_0;
      this.c4g_1 = plus(firstMetrics, compressedMetrics);
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).n4h = function () {
    var tmp0_safe_receiver = this.g4h('CPAL');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>' call
      var version = tmp0_safe_receiver.z4a();
      switch (version) {
        case 0:
        case 1:
          var numPaletteEntries = tmp0_safe_receiver.z4a();
          var numPalettes = tmp0_safe_receiver.z4a();
          var numColorRecords = tmp0_safe_receiver.z4a();
          var colorRecordsArrayOffset = tmp0_safe_receiver.b4b();
          var colorRecordIndices = tmp0_safe_receiver.f4r(numPalettes);
          var paletteTypesArrayOffset = version === 1 ? tmp0_safe_receiver.b4b() : -1;
          var paletteLabelsArrayOffset = version === 1 ? tmp0_safe_receiver.b4b() : -1;
          var paletteEntryLabelsArrayOffset = version === 1 ? tmp0_safe_receiver.b4b() : -1;
          tmp0_safe_receiver.y4j(colorRecordsArrayOffset);
          var colorInts = tmp0_safe_receiver.g4r(numColorRecords);
          var inductionVariable = 0;
          var last = colorInts.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c = _RGBA___init__impl__lqpay5(colorInts[n]);
              colorInts[n] = _RGBA___get_value__impl__hhco8v(Companion_getInstance_26().r3q(_RGBA___get_b__impl__m6tl80(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_r__impl__duz7mo(c), _RGBA___get_a__impl__6msvu7(c)));
            }
             while (inductionVariable < last);
          var tmp = this;
          // Inline function 'kotlin.collections.map' call

          // Inline function 'kotlin.collections.mapTo' call

          var destination = ArrayList_init_$Create$_0(colorRecordIndices.length);
          var inductionVariable_0 = 0;
          var last_0 = colorRecordIndices.length;
          while (inductionVariable_0 < last_0) {
            var item = colorRecordIndices[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>.<anonymous>' call
            var tmp$ret$0 = new Palette(_RgbaArray___init__impl__oib4y4(copyOfRange_0(colorInts, item, item + numPaletteEntries | 0)));
            destination.r(tmp$ret$0);
          }

          tmp.j4g_1 = destination;
          break;
        default:
          println('TTF WARNING CPAL version != 0,1');
          break;
      }
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).o4h = function (_this__u8e3s4) {
    return new SbitLineMetrics(_this__u8e3s4.h4r(), _this__u8e3s4.h4r(), _this__u8e3s4.v4a(), _this__u8e3s4.h4r(), _this__u8e3s4.h4r(), _this__u8e3s4.h4r(), _this__u8e3s4.h4r(), _this__u8e3s4.h4r(), _this__u8e3s4.h4r(), _this__u8e3s4.h4r(), _this__u8e3s4.h4r(), _this__u8e3s4.h4r());
  };
  protoOf(BaseTtfFont).p4h = function () {
    var tmp0_safe_receiver = this.g4h('CBLC');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>' call
      var majorVersion = tmp0_safe_receiver.z4a();
      var minorVersion = tmp0_safe_receiver.z4a();
      if (majorVersion === 3) {
        var numSizes = tmp0_safe_receiver.b4b();
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = fillArrayVal(Array(numSizes), null);
        while (tmp < numSizes) {
          tmp_0[tmp] = new ColorBitmapInfo(tmp0_safe_receiver.b4b(), tmp0_safe_receiver.b4b(), tmp0_safe_receiver.b4b(), tmp0_safe_receiver.b4b(), this.o4h(tmp0_safe_receiver), this.o4h(tmp0_safe_receiver), tmp0_safe_receiver.z4a(), tmp0_safe_receiver.z4a(), tmp0_safe_receiver.v4a(), tmp0_safe_receiver.v4a(), tmp0_safe_receiver.v4a(), tmp0_safe_receiver.h4r());
          tmp = tmp + 1 | 0;
        }
        var colorBitmapInfos = toList_1(tmp_0);
        var tmp1_iterator = colorBitmapInfos.u();
        while (tmp1_iterator.v()) {
          var cbi = tmp1_iterator.x();
          var glyphCount = cbi.h4k_1 - cbi.g4k_1 | 0;
          tmp0_safe_receiver.y4j(cbi.a4k_1);
          var tmp_1 = 0;
          var tmp_2 = cbi.c4k_1;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = new BaseTtfFont$readCblc$1$Subtable(tmp0_safe_receiver.z4a(), tmp0_safe_receiver.z4a(), tmp0_safe_receiver.b4b());
            tmp_1 = tmp_1 + 1 | 0;
          }
          var subtables = tmp_3;
          var inductionVariable = 0;
          var last = subtables.length;
          while (inductionVariable < last) {
            var subtable = subtables[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp0_safe_receiver.y4j(cbi.a4k_1 + subtable.l4q_1 | 0);
            var indexFormat = tmp0_safe_receiver.z4a();
            var imageFormat = tmp0_safe_receiver.z4a();
            var imageDataOffset = tmp0_safe_receiver.b4b();
            var tmp_4;
            if (indexFormat === 1) {
              var tmp_5 = 0;
              var tmp_6 = subtable.m4q() + 1 | 0;
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_7 = fillArrayVal(Array(tmp_6), null);
              while (tmp_5 < tmp_6) {
                tmp_7[tmp_5] = imageDataOffset + tmp0_safe_receiver.b4b() | 0;
                tmp_5 = tmp_5 + 1 | 0;
              }
              tmp_4 = tmp_7;
            } else {
              // Inline function 'kotlin.emptyArray' call
              tmp_4 = [];
            }
            var offsets = tmp_4;
            var inductionVariable_0 = 0;
            var last_0 = offsets.length - 1 | 0;
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset = offsets[n];
                var size = offsets[n + 1 | 0] - offset | 0;
                var glyphID = (subtable.j4q_1 + n | 0) - 1 | 0;
                // Inline function 'kotlin.collections.set' call
                var this_0 = this.g4g_1;
                var value = new BitmapGlyphInfo(glyphID, imageFormat, offset, size, cbi);
                this_0.i2(glyphID, value);
              }
               while (inductionVariable_0 < last_0);
          }
        }
      } else {
        println('Unsupported CBLC ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).q4h = function () {
    var tmp0_safe_receiver = this.g4h('CBDT');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCbdt.<anonymous>' call
      var majorVersion = tmp0_safe_receiver.z4a();
      var minorVersion = tmp0_safe_receiver.z4a();
      if (majorVersion === 3) {
        var tmp1_iterator = this.g4g_1.h2().u();
        while (tmp1_iterator.v()) {
          var i = tmp1_iterator.x();
          var format = i.z4k_1;
          if (format === 17 ? true : format === 18) {
            i.d4l_1 = tmp0_safe_receiver.v4a();
            i.e4l_1 = tmp0_safe_receiver.v4a();
            i.f4l_1 = tmp0_safe_receiver.h4r();
            i.g4l_1 = tmp0_safe_receiver.h4r();
            i.h4l_1 = tmp0_safe_receiver.v4a();
            i.i4l_1 = format === 18 ? tmp0_safe_receiver.h4r() : i.f4l_1;
            i.j4l_1 = format === 18 ? tmp0_safe_receiver.h4r() : i.g4l_1;
            i.k4l_1 = format === 18 ? tmp0_safe_receiver.h4r() : i.h4l_1;
          }
          var dataLen = tmp0_safe_receiver.b4b();
          i.l4l_1 = tmp0_safe_receiver.i4r(dataLen);
        }
      } else {
        println('Unsupported CBDT ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).r4h = function () {
    var tmp0_safe_receiver = this.g4h('sbix');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>' call
      var version = tmp0_safe_receiver.z4a();
      var flags = tmp0_safe_receiver.z4a();
      var numStrikes = tmp0_safe_receiver.b4b();
      var strikeOffsets = tmp0_safe_receiver.x4j(numStrikes);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(strikeOffsets.length);
      var inductionVariable = 0;
      var last = strikeOffsets.length;
      while (inductionVariable < last) {
        var item = strikeOffsets[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        tmp0_safe_receiver.y4j(item);
        var tmp$ret$0 = new BaseTtfFont$readSbix$1$StrikeInfo(tmp0_safe_receiver.z4a(), tmp0_safe_receiver.z4a(), item, toIntArrayList(tmp0_safe_receiver.x4j(this.p4e_1 + 1 | 0)));
        destination.r(tmp$ret$0);
      }
      var strikes = destination;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        var iterator = strikes.u();
        if (!iterator.v()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var maxElem = iterator.x();
        if (!iterator.v()) {
          tmp$ret$3 = maxElem;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        var maxValue = maxElem.n4q_1;
        do {
          var e = iterator.x();
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          var v = e.n4q_1;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.v());
        tmp$ret$3 = maxElem;
      }
      var strike = ensureNotNull(tmp$ret$3);
      var inductionVariable_0 = 0;
      var last_0 = this.p4e_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var glyphID = n;
          var offset = strike.q4q_1.f1(n);
          var len = strike.q4q_1.f1(n + 1 | 0) - offset | 0;
          var start = strike.p4q_1 + offset | 0;
          var end = start + len | 0;
          tmp0_safe_receiver.y4j(start);
          var originOffsetX = tmp0_safe_receiver.c4r();
          var originOffsetY = tmp0_safe_receiver.c4r();
          var graphicType = tmp0_safe_receiver.z4j(4);
          var bytes = tmp0_safe_receiver.i4r(len - 8 | 0);
          // Inline function 'kotlin.collections.set' call
          var this_0 = this.g4g_1;
          // Inline function 'kotlin.also' call
          var this_1 = new BitmapGlyphInfo(glyphID, VOID, VOID, VOID, new ColorBitmapInfo(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, strike.n4q_1, strike.n4q_1));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          this_1.l4l_1 = bytes;
          this_0.i2(glyphID, this_1);
        }
         while (inductionVariable_0 < last_0);
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).s4h = function (_this__u8e3s4) {
    return _this__u8e3s4.b4b();
  };
  protoOf(BaseTtfFont).t4h = function (_this__u8e3s4) {
    return _this__u8e3s4.z4a();
  };
  protoOf(BaseTtfFont).u4h = function (_this__u8e3s4) {
    return _this__u8e3s4.c4r();
  };
  protoOf(BaseTtfFont).v4h = function (_this__u8e3s4) {
    return _this__u8e3s4.z4a();
  };
  protoOf(BaseTtfFont).w4h = function (_this__u8e3s4) {
    return _this__u8e3s4.a4b();
  };
  protoOf(BaseTtfFont).x4h = function (_this__u8e3s4) {
    return _this__u8e3s4.b4b();
  };
  protoOf(BaseTtfFont).y4h = function (_this__u8e3s4, isVar) {
    var xx = this.t4i(_this__u8e3s4);
    var yx = this.t4i(_this__u8e3s4);
    var xy = this.t4i(_this__u8e3s4);
    var yy = this.t4i(_this__u8e3s4);
    var dx = this.t4i(_this__u8e3s4);
    var dy = this.t4i(_this__u8e3s4);
    return new Matrix(xx, yx, xy, yy, dx, -dy);
  };
  protoOf(BaseTtfFont).z4h = function (_this__u8e3s4, out) {
    out.w4l_1 = this.s4i(_this__u8e3s4);
    out.x4l_1 = _this__u8e3s4.z4a();
    out.y4l_1 = this.s4i(_this__u8e3s4);
    return out;
  };
  protoOf(BaseTtfFont).a4i = function (_this__u8e3s4, out, $super) {
    out = out === VOID ? new ColorStop(0.0, 0, 0.0) : out;
    return $super === VOID ? this.z4h(_this__u8e3s4, out) : $super.z4h.call(this, _this__u8e3s4, out);
  };
  protoOf(BaseTtfFont).b4i = function (_this__u8e3s4, doVar) {
    var format = _this__u8e3s4.v4a();
    var xMin = this.u4h(_this__u8e3s4);
    var yMin = this.u4h(_this__u8e3s4);
    var xMax = this.u4h(_this__u8e3s4);
    var yMax = this.u4h(_this__u8e3s4);
    if (format === 2) {
      var varIndexBase = this.s4h(_this__u8e3s4);
    }
    return Companion_getInstance_2().u2k(xMin, yMin, xMax, yMax);
  };
  protoOf(BaseTtfFont).c4i = function (_this__u8e3s4, doVar, $super) {
    doVar = doVar === VOID ? false : doVar;
    return $super === VOID ? this.b4i(_this__u8e3s4, doVar) : $super.b4i.call(this, _this__u8e3s4, doVar);
  };
  protoOf(BaseTtfFont).d4i = function (_this__u8e3s4) {
    var cycle;
    switch (_this__u8e3s4.v4a()) {
      case 0:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 1:
        cycle = CycleMethod_REPEAT_getInstance();
        break;
      case 2:
        cycle = CycleMethod_REFLECT_getInstance();
        break;
      default:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16' call
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.z4a();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColorLine.<anonymous>' call
      tmp_1[tmp] = this.a4i(_this__u8e3s4);
      tmp = tmp + 1 | 0;
    }
    return new ColorLine(cycle, toList_1(tmp_1));
  };
  protoOf(BaseTtfFont).e4i = function (glyphID, s, c, pal, level) {
    var nodeFormat = s.v4a();
    var isVar = (nodeFormat % 2 | 0) === 1;
    var indent = repeat('  ', level);
    var debug = false;
    var debugShape = false;
    if (debug) {
      println(indent + 'interpretColrv1[glyphID=' + glyphID + ']: ' + nodeFormat + ' - ' + getOrNull(Companion_getInstance_36().d4j_1, nodeFormat));
    }
    switch (nodeFormat) {
      case 1:
        var numLayers = s.v4a();
        var firstLayerIndex = s.b4b();
        var inductionVariable = 0;
        if (inductionVariable < numLayers)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var paint = this.k4g_1.b4n_1[firstLayerIndex + n | 0];
            this.e4i(glyphID, this.k4g_1.e4n_1.u4a(paint), c, pal, level + 1 | 0);
          }
           while (inductionVariable < numLayers);
        break;
      case 2:
      case 3:
        var paletteIndex = s.z4a();
        var alpha = this.s4i(s);
        if (isVar) {
          var varIndexBase = this.s4h(s);
          // Inline function 'kotlin.TODO' call
          throw new NotImplementedError();
        }

        var color = RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(this.j4g_1.f1(pal).e3q_1, paletteIndex), alpha);
        if (debugShape) {
          println("ctx.fillStyle = '" + _RGBA___get_htmlStringSimple__impl__l4nu0u(color) + "';");
          println('ctx.fill();');
        }

        if (debug) {
          println(indent + new RGBA(color));
        }

        c.o44(new RGBA(color));
        break;
      case 4:
      case 5:
        var colorLineOffset = this.w4h(s);
        var x0 = this.u4h(s);
        var y0 = this.u4h(s);
        var x1 = this.u4h(s);
        var y1 = this.u4h(s);
        var x2 = this.u4h(s);
        var y2 = this.u4h(s);
        var colorLine = this.d4i(s.u4a(colorLineOffset));
        if (isVar) {
          var varIndexBase_0 = this.s4h(s);
        }

        // Inline function 'korlibs.image.paint.LinearGradientPaint' call

        var y0_0 = -y0;
        var y1_0 = -y1;
        var cycle = colorLine.t4l_1;
        var transform = Companion_getInstance_3().e2f_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.LinearGradientPaint.<anonymous>' call

        var paint_0 = new GradientPaint(GradientKind_LINEAR_getInstance(), numberToDouble(x0), numberToDouble(y0_0), 0.0, numberToDouble(x1), numberToDouble(y1_0), 0.0, VOID, VOID, cycle, transform);
        colorLine.v4l(paint_0, this.j4g_1.f1(pal));
        if (debug) {
          println(indent + paint_0);
        }

        c.o44(paint_0);
        break;
      case 6:
      case 7:
        var colorLineOffset_0 = this.w4h(s);
        var x0_0 = this.u4h(s);
        var y0_1 = this.u4h(s);
        var radius0 = this.t4h(s);
        var x1_0 = this.u4h(s);
        var y1_1 = this.u4h(s);
        var radius1 = this.t4h(s);
        var colorLine_0 = this.d4i(s.u4a(colorLineOffset_0));
        if (isVar) {
          var varIndexBase_1 = this.s4h(s);
        }

        if (debugShape) {
          println('ctx.fillStyle = ctx.createRadialGradient(' + x0_0 + ', -' + y0_1 + ', ' + radius0 + ', ' + x1_0 + ', -' + y1_1 + ', ' + radius1 + ');');
          println('ctx.fill();');
        }

        // Inline function 'korlibs.image.paint.RadialGradientPaint' call

        var y0_2 = -y0_1;
        var y1_2 = -y1_1;
        var cycle_0 = colorLine_0.t4l_1;
        var transform_0 = Companion_getInstance_3().e2f_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.RadialGradientPaint.<anonymous>' call

        var paint_1 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0_0), numberToDouble(y0_2), numberToDouble(radius0), numberToDouble(x1_0), numberToDouble(y1_2), numberToDouble(radius1), VOID, VOID, cycle_0, transform_0);
        colorLine_0.v4l(paint_1, this.j4g_1.f1(pal));
        if (debug) {
          println(indent + paint_1);
        }

        c.o44(paint_1);
        break;
      case 8:
      case 9:
        var colorLine_1 = this.w4h(s);
        var centerX = this.u4h(s);
        var centerY = this.u4h(s);
        var startAngle = this.s4i(s);
        var endAngle = this.s4i(s);
        if (isVar) {
          var varIndexBase_2 = this.s4h(s);
        }

        // Inline function 'kotlin.TODO' call

        throw new NotImplementedError();
      case 10:
        var paint_2 = this.w4h(s);
        var glyphID_0 = s.z4a();
        var colr = this.i4g_1.f1(glyphID_0);
        var glyph = this.r4i(glyphID_0);
        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.v44();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (!(glyph == null)) {
            if (debugShape) {
              println(joinToString(toContext2dCommands(glyph.f4o().h4o_1), '\n'));
            }
            c.j4r(glyph.f4o().h4o_1);
            this.e4i(glyphID_0, s.u4a(paint_2), c, pal, level + 1 | 0);
          }
        }finally {
          c.d45();
        }

        break;
      case 11:
        var glyphID_1 = s.z4a();
        // Inline function 'kotlin.TODO' call

        throw new NotImplementedError();
      case 12:
      case 13:
        var paint_3 = this.w4h(s);
        var transform_1 = this.w4h(s);
        var affine = this.y4h(s.u4a(transform_1), isVar);
        if (debug) {
          println(indent + 'affine=' + affine);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.v44();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          c.q46(affine);
          this.e4i(glyphID, s.u4a(paint_3), c, pal, level + 1 | 0);
        }finally {
          c.d45();
        }

        break;
      case 14:
      case 15:
        var paint_4 = this.w4h(s);
        var dx = FWord__toDouble_impl_53j5qp(this.e4h(s));
        var dy = FWord__toDouble_impl_53j5qp(this.e4h(s));
        if (isVar) {
          var varIndexBase_3 = this.s4h(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.v44();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (debug) {
            println('translate: ' + dx + ', ' + dy);
          }
          c.o46(dx, -dy);
          this.e4i(glyphID, s.u4a(paint_4), c, pal, level + 1 | 0);
        }finally {
          c.d45();
        }

        break;
      case 16:
      case 17:
      case 18:
      case 19:
        var paint_5 = this.w4h(s);
        var scaleX = this.s4i(s);
        var scaleY = this.s4i(s);
        var aroundCenter = nodeFormat >= 18;
        if (aroundCenter) {
          var centerX_0 = this.u4h(s);
          var centerY_0 = this.u4h(s);
          // Inline function 'kotlin.TODO' call
          throw new NotImplementedError();
        }

        if (isVar) {
          var varIndexBase_4 = this.s4h(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.v44();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          // Inline function 'korlibs.image.vector.Context2d.scale' call
          c.k4r(numberToDouble(scaleX), numberToDouble(scaleY));
          this.e4i(glyphID, s.u4a(paint_5), c, pal, level + 1 | 0);
        }finally {
          c.d45();
        }

        break;
      case 20:
      case 21:
      case 22:
      case 23:
        var paint_6 = this.w4h(s);
        var scale = this.s4i(s);
        if (nodeFormat >= 22) {
          var centerX_1 = this.u4h(s);
          var centerY_1 = this.u4h(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_5 = this.s4h(s);
        }

        // Inline function 'kotlin.TODO' call

        throw new NotImplementedError();
      case 24:
      case 25:
      case 26:
      case 27:
        var paint_7 = this.w4h(s);
        var angle = this.s4i(s);
        if (nodeFormat >= 26) {
          var centerX_2 = this.u4h(s);
          var centerY_2 = this.u4h(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_6 = this.s4h(s);
        }

        // Inline function 'kotlin.TODO' call

        throw new NotImplementedError();
      case 28:
      case 29:
      case 30:
      case 31:
        var paint_8 = this.w4h(s);
        var xSkewAngle = this.s4i(s);
        var ySkewAngle = this.s4i(s);
        if (nodeFormat >= 30) {
          var centerX_3 = this.u4h(s);
          var centerY_3 = this.u4h(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_7 = this.s4h(s);
        }

        // Inline function 'kotlin.TODO' call

        throw new NotImplementedError();
      case 32:
        var sourcePaint = this.w4h(s);
        var compositeMode = s.v4a();
        var backdropPaint = this.w4h(s);
        // Inline function 'kotlin.TODO' call

        throw new NotImplementedError();
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Unknown colorv1 format=' + nodeFormat;
        throw new NotImplementedError('An operation is not implemented: ' + reason);
    }
  };
  protoOf(BaseTtfFont).f4i = function (_this__u8e3s4, hintedCount) {
    var coverageFormat = _this__u8e3s4.z4a();
    switch (coverageFormat) {
      case 1:
        var glyphCount = _this__u8e3s4.z4a();
        // Inline function 'korlibs.datastructure.mapInt' call

        var this_0 = _this__u8e3s4.d4r(glyphCount);
        // Inline function 'kotlin.also' call

        var this_1 = new Int32Array(this_0.length);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

        var inductionVariable = 0;
        var last = this_0.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            // Inline function 'kotlin.code' call
            var this_2 = this_0[n];
            this_1[n] = Char__toInt_impl_vasixd(this_2);
          }
           while (inductionVariable < last);
        return this_1;
      case 2:
        var rangeCount = _this__u8e3s4.z4a();
        // Inline function 'kotlin.collections.map' call

        var this_3 = until(0, rangeCount);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_3, 10));
        var tmp0_iterator = this_3.u();
        while (tmp0_iterator.v()) {
          var item = tmp0_iterator.x();
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var tmp$ret$4 = new BaseTtfFont$readCoverage$RangeInfo(_this__u8e3s4.z4a(), _this__u8e3s4.z4a(), _this__u8e3s4.z4a());
          destination.r(tmp$ret$4);
        }

        var ranges = destination;
        // Inline function 'kotlin.collections.maxOf' call

        var iterator = ranges.u();
        if (!iterator.v())
          throw NoSuchElementException_init_$Create$();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call

        var it = iterator.x();
        var maxValue = it.t4q_1 + it.u4q_1 | 0;
        while (iterator.v()) {
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var it_0 = iterator.x();
          var v = it_0.t4q_1 + it_0.u4q_1 | 0;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }

        var glyphCount_0 = maxValue;
        var glyphArray = new Int32Array(glyphCount_0);
        var tmp1_iterator = ranges.u();
        while (tmp1_iterator.v()) {
          var range = tmp1_iterator.x();
          var inductionVariable_0 = range.r4q_1;
          var last_0 = range.s4q_1;
          if (inductionVariable_0 <= last_0)
            do {
              var glyphID = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var offset = glyphID - range.r4q_1 | 0;
              glyphArray[range.t4q_1 + offset | 0] = glyphID;
            }
             while (!(glyphID === last_0));
        }

        return glyphArray;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'coverageFormat=' + coverageFormat;
        throw new NotImplementedError('An operation is not implemented: ' + reason);
    }
  };
  protoOf(BaseTtfFont).g4i = function (_this__u8e3s4, hintedCount, $super) {
    hintedCount = hintedCount === VOID ? -1 : hintedCount;
    return $super === VOID ? this.f4i(_this__u8e3s4, hintedCount) : $super.f4i.call(this, _this__u8e3s4, hintedCount);
  };
  protoOf(BaseTtfFont).h4i = function () {
    var tmp0_safe_receiver = this.g4h('GSUB');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>' call
      var totalLength = tmp0_safe_receiver.a();
      var majorVersion = tmp0_safe_receiver.z4a();
      var minorVersion = tmp0_safe_receiver.z4a();
      if (!(majorVersion === 1)) {
        // Inline function 'kotlin.error' call
        var message = 'Unknown GSUB majorVerrsion=' + majorVersion;
        throw IllegalStateException_init_$Create$(toString(message));
      }
      var scriptListOffset = this.v4h(tmp0_safe_receiver);
      var featureListOffset = this.v4h(tmp0_safe_receiver);
      var lookupListOffset = this.v4h(tmp0_safe_receiver);
      if (minorVersion >= 1) {
        var featureVariationsOffset = this.x4h(tmp0_safe_receiver);
      }
      // Inline function 'kotlin.apply' call
      var this_0 = tmp0_safe_receiver.u4a(scriptListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var scriptCount = this_0.z4a();
      var inductionVariable = 0;
      if (inductionVariable < scriptCount)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var scriptTag = this_0.z4j(4);
          var scriptOffset = this.v4h(this_0);
        }
         while (inductionVariable < scriptCount);
      // Inline function 'kotlin.apply' call
      var this_1 = tmp0_safe_receiver.u4a(featureListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var featureCount = this_1.z4a();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < featureCount)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var featureTag = this_1.z4j(4);
          var featureOffset = this.v4h(this_1);
        }
         while (inductionVariable_0 < featureCount);
      // Inline function 'kotlin.apply' call
      var this_2 = tmp0_safe_receiver.u4a(lookupListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var lookupCount = this_2.z4a();
      // Inline function 'korlibs.datastructure.mapInt' call
      var this_3 = until(0, lookupCount);
      // Inline function 'kotlin.also' call
      var this_4 = new IntArrayList((coerceAtLeast(this_3.i9() - this_3.h9() | 0, 0) / this_3.hb_1 | 0) + 1 | 0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
      var nestedFirst = this_3.h9();
      var nestedLast = this_3.i9();
      var stepArg = this_3.hb_1;
      if (stepArg <= 0)
        THROW_IAE('Step must be positive, was: ' + stepArg + '.');
      var inductionVariable_1 = nestedFirst;
      var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
      if (inductionVariable_1 <= last)
        do {
          var v = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + stepArg | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$2 = this.v4h(this_2);
          this_4.m1s(tmp$ret$2);
        }
         while (!(v === last));
      var lookups = this_4;
      var tmp0_iterator = lookups.u();
      while (tmp0_iterator.v()) {
        var lookupOffset = tmp0_iterator.x();
        // Inline function 'kotlin.apply' call
        var this_5 = this_2.u4a(lookupOffset);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
        var lookupType = this_5.z4a();
        var lookupFlag = this_5.z4a();
        var subTableCount = this_5.z4a();
        // Inline function 'korlibs.datastructure.mapInt' call
        var this_6 = this_5.f4r(subTableCount);
        // Inline function 'kotlin.also' call
        var this_7 = new Int32Array(this_6.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
        var inductionVariable_2 = 0;
        var last_0 = this_6.length;
        if (inductionVariable_2 < last_0)
          do {
            var n_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            this_7[n_1] = this_6[n_1] & 65535;
          }
           while (inductionVariable_2 < last_0);
        var subtableOffsets = this_7;
        var markFilteringSet = this_5.z4a();
        var inductionVariable_3 = 0;
        var last_1 = subtableOffsets.length;
        while (inductionVariable_3 < last_1) {
          var offset = subtableOffsets[inductionVariable_3];
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_8 = this_5.u4a(offset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var subsTable = this_8;
          switch (lookupType) {
            case 1:
              var substFormat = this_8.z4a();
              var coverageOffset = this.v4h(this_8);
              switch (substFormat) {
                case 1:
                  var deltaGlyphID = this_8.c4r();
                  var coverageTable = this.g4i(this_8.u4a(coverageOffset));
                  var inductionVariable_4 = 0;
                  var last_2 = coverageTable.length;
                  while (inductionVariable_4 < last_2) {
                    var glyphID = coverageTable[inductionVariable_4];
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    this.m4g_1.n1x(glyphID, glyphID + deltaGlyphID | 0);
                  }

                  break;
                case 2:
                  var glyphCount = this_8.z4a();
                  var coverageTable_0 = this.g4i(this_8.u4a(coverageOffset));
                  // Inline function 'korlibs.datastructure.mapInt' call

                  var this_9 = this_8.d4r(glyphCount);
                  // Inline function 'kotlin.also' call

                  var this_10 = new Int32Array(this_9.length);
                  // Inline function 'kotlin.contracts.contract' call

                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

                  var inductionVariable_5 = 0;
                  var last_3 = this_9.length;
                  if (inductionVariable_5 < last_3)
                    do {
                      var n_2 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_11 = this_9[n_2];
                      this_10[n_2] = Char__toInt_impl_vasixd(this_11);
                    }
                     while (inductionVariable_5 < last_3);
                  var substituteGlyphIDs = this_10;
                  // Inline function 'kotlin.repeat' call

                  // Inline function 'kotlin.contracts.contract' call

                  var inductionVariable_6 = 0;
                  if (inductionVariable_6 < glyphCount)
                    do {
                      var index = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      this.m4g_1.n1x(coverageTable_0[index], substituteGlyphIDs[index]);
                    }
                     while (inductionVariable_6 < glyphCount);
                  break;
                default:
                  // Inline function 'kotlin.error' call

                  var message_0 = 'Unsupported lookupType=1, substFormat=' + substFormat;
                  throw IllegalStateException_init_$Create$(toString(message_0));
              }

              break;
            case 4:
              var substFormat_0 = this_8.z4a();
              if (!(substFormat_0 === 1)) {
                // Inline function 'kotlin.error' call
                var message_1 = 'For lookType=4 only substFormat=1 is supported';
                throw IllegalStateException_init_$Create$(toString(message_1));
              }

              var coverageOffset_0 = this.v4h(this_8);
              var ligatureSetCount = this_8.z4a();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_12 = this_8.d4r(ligatureSetCount);
              // Inline function 'kotlin.also' call

              var this_13 = new Int32Array(this_12.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_7 = 0;
              var last_4 = this_12.length;
              if (inductionVariable_7 < last_4)
                do {
                  var n_3 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'kotlin.code' call
                  var this_14 = this_12[n_3];
                  this_13[n_3] = Char__toInt_impl_vasixd(this_14);
                }
                 while (inductionVariable_7 < last_4);
              var ligatureSetOffsets = this_13;
              var glyphArray = this.f4i(this_8.u4a(coverageOffset_0), ligatureSetCount);
              var inductionVariable_8 = 0;
              var last_5 = ligatureSetOffsets.length - 1 | 0;
              if (inductionVariable_8 <= last_5)
                do {
                  var n_4 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  var glyphID_0 = glyphArray[n_4];
                  var asetoffset = ligatureSetOffsets[n_4];
                  var map = LinkedHashMap_init_$Create$();
                  var codePoint = this.l4i(glyphID_0);
                  // Inline function 'kotlin.intArrayOf' call
                  var codePointIntArray = new Int32Array([codePoint]);
                  var maxComponentCount = 1;
                  // Inline function 'kotlin.apply' call
                  var this_15 = subsTable.u4a(asetoffset);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ligatureCount = this_15.z4a();
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var this_16 = this_15.d4r(ligatureCount);
                  // Inline function 'kotlin.also' call
                  var this_17 = new Int32Array(this_16.length);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                  var inductionVariable_9 = 0;
                  var last_6 = this_16.length;
                  if (inductionVariable_9 < last_6)
                    do {
                      var n_5 = inductionVariable_9;
                      inductionVariable_9 = inductionVariable_9 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_18 = this_16[n_5];
                      this_17[n_5] = Char__toInt_impl_vasixd(this_18);
                    }
                     while (inductionVariable_9 < last_6);
                  var ligatureOffsets = this_17;
                  var inductionVariable_10 = 0;
                  var last_7 = ligatureOffsets.length;
                  while (inductionVariable_10 < last_7) {
                    var offset_0 = ligatureOffsets[inductionVariable_10];
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    // Inline function 'kotlin.apply' call
                    var this_19 = this_15.u4a(offset_0);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ligatureGlyph = this_19.z4a();
                    var componentCount = this_19.z4a();
                    // Inline function 'kotlin.math.max' call
                    var a = maxComponentCount;
                    var b = componentCount + 1 | 0;
                    maxComponentCount = Math.max(a, b);
                    // Inline function 'korlibs.datastructure.mapInt' call
                    var this_20 = this_19.d4r(componentCount - 1 | 0);
                    // Inline function 'kotlin.also' call
                    var this_21 = new Int32Array(this_20.length);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                    var inductionVariable_11 = 0;
                    var last_8 = this_20.length;
                    if (inductionVariable_11 < last_8)
                      do {
                        var n_6 = inductionVariable_11;
                        inductionVariable_11 = inductionVariable_11 + 1 | 0;
                        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        // Inline function 'kotlin.code' call
                        var this_22 = this_20[n_6];
                        var tmp$ret$22 = Char__toInt_impl_vasixd(this_22);
                        this_21[n_6] = this.l4i(tmp$ret$22);
                      }
                       while (inductionVariable_11 < last_8);
                    var componentCodePoints = this_21;
                    var tmp = Companion_getInstance_68();
                    // Inline function 'kotlin.collections.plus' call
                    var tmp$ret$26 = primitiveArrayConcat([codePointIntArray, componentCodePoints]);
                    var ligature = tmp.p20(tmp$ret$26);
                    // Inline function 'kotlin.collections.set' call
                    // Inline function 'kotlin.intArrayOf' call
                    var value = new Int32Array([ligatureGlyph]);
                    map.i2(ligature, value);
                  }
                  this.n4g_1.r1w(codePoint, new SubstitutionInfo(maxComponentCount, map));
                }
                 while (inductionVariable_8 <= last_5);
              break;
            default:
              // Inline function 'korlibs.logger.Logger.info' call

              var this_23 = Companion_getInstance_34().w4b_1;
              var level = Level_INFO_getInstance();
              var tmp_0;
              if (this_23.f25(level)) {
                // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$30 = 'TTF.GSUB: Unsupported lookupType=' + lookupType;
                this_23.g25(level, tmp$ret$30);
                tmp_0 = Unit_instance;
              }

              break;
          }
        }
      }
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).i4i = function () {
    var tmp0_safe_receiver = this.g4h('COLR');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>' call
      var version = tmp0_safe_receiver.z4a();
      switch (version) {
        case 0:
        case 1:
          var numBaseGlyphRecords = tmp0_safe_receiver.z4a();
          var baseGlyphRecordsOffset = tmp0_safe_receiver.b4b();
          var layerRecordsOffset = tmp0_safe_receiver.b4b();
          var numLayerRecords = tmp0_safe_receiver.z4a();
          // Inline function 'kotlin.apply' call

          var this_0 = tmp0_safe_receiver.u4a(layerRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var tmp = this;
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call

          var tmp_1 = fillArrayVal(Array(numLayerRecords), null);
          while (tmp_0 < numLayerRecords) {
            tmp_1[tmp_0] = new ColrLayerInfo(this, this_0.z4a(), this_0.z4a());
            tmp_0 = tmp_0 + 1 | 0;
          }

          tmp.h4g_1 = tmp_1;
          // Inline function 'kotlin.apply' call

          var this_1 = tmp0_safe_receiver.u4a(baseGlyphRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var inductionVariable = 0;
          if (inductionVariable < numBaseGlyphRecords)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var info = new ColrGlyphInfoV0(this, this_1.z4a(), this_1.z4a(), this_1.z4a());
              this.i4g_1.r1w(info.n4o_1, info);
            }
             while (inductionVariable < numBaseGlyphRecords);
          if (version === 1) {
            var baseGlyphListOffset = this.x4h(tmp0_safe_receiver);
            var layerListOffset = this.x4h(tmp0_safe_receiver);
            var clipListOffset = this.x4h(tmp0_safe_receiver);
            var varIdxMapOffset = this.x4h(tmp0_safe_receiver);
            var varStoreOffset = this.x4h(tmp0_safe_receiver);
            this.k4g_1.g4n_1.b3();
            var tmp_2 = this;
            var tmp2_s = tmp0_safe_receiver.u4a(0);
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_2 = tmp0_safe_receiver.u4a(layerListOffset);
            var tmp_3 = 0;
            var tmp_4 = this_2.b4b();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_5 = fillArrayVal(Array(tmp_4), null);
            while (tmp_3 < tmp_4) {
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_5[tmp_3] = this.x4h(this_2);
              tmp_3 = tmp_3 + 1 | 0;
            }
            var tmp3_layerList = toIntArray(tmp_5);
            var tmp4_sBaseOffset = tmp0_safe_receiver.u4a(baseGlyphListOffset);
            var tmp5_sLayerOffset = tmp0_safe_receiver.u4a(layerListOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_6;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_6 = clipListOffset;
            } else {
              tmp_6 = null;
            }
            var tmp1_safe_receiver = tmp_6;
            var tmp_7;
            if (tmp1_safe_receiver == null) {
              tmp_7 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_7 = tmp0_safe_receiver.u4a(tmp1_safe_receiver);
            }
            var tmp6_sClipOffset = tmp_7;
            tmp_2.k4g_1 = new COLRv1(tmp3_layerList, tmp2_s, tmp4_sBaseOffset, tmp5_sLayerOffset, tmp6_sClipOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_8;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_8 = clipListOffset;
            } else {
              tmp_8 = null;
            }
            if (tmp_8 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              var s = tmp0_safe_receiver.u4a(clipListOffset);
              var format = s.v4a();
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
              var tmp_9 = 0;
              var tmp_10 = s.b4b();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_11 = fillArrayVal(Array(tmp_10), null);
              while (tmp_9 < tmp_10) {
                var tmp_12 = tmp_9;
                var startGlyphID = s.z4a();
                var endGlyphID = s.z4a();
                var clipBoxOffset = this.w4h(s);
                var inductionVariable_0 = startGlyphID;
                if (inductionVariable_0 <= endGlyphID)
                  do {
                    var glyphID = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    this.k4g_1.g4n_1.n1x(glyphID, clipBoxOffset);
                  }
                   while (!(glyphID === endGlyphID));
                tmp_11[tmp_12] = Unit_instance;
                tmp_9 = tmp_9 + 1 | 0;
              }
            }
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_3 = tmp0_safe_receiver.u4a(baseGlyphListOffset);
            var tmp_13 = 0;
            var tmp_14 = this_3.b4b();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = fillArrayVal(Array(tmp_14), null);
            while (tmp_13 < tmp_14) {
              var tmp_16 = tmp_13;
              var glyphID_0 = this_3.z4a();
              var paint = this.x4h(this_3);
              this.i4g_1.r1w(glyphID_0, new ColrGlyphInfoV1(this, glyphID_0, paint));
              tmp_15[tmp_16] = Unit_instance;
              tmp_13 = tmp_13 + 1 | 0;
            }
          }

          break;
        default:
          println('TTF WARNING CCOLv' + version + ' not supported');
          break;
      }
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).j4i = function () {
    var tmp0_safe_receiver = this.g4h('cmap');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>' call
      var version = tmp0_safe_receiver.z4a();
      var numTables = tmp0_safe_receiver.z4a();
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, numTables);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new BaseTtfFont$readCmap$1$EncodingRecord(tmp0_safe_receiver.z4a(), tmp0_safe_receiver.z4a(), tmp0_safe_receiver.b4b());
        destination.r(tmp$ret$0);
      }
      var tables = destination;
      var index = 0;
      var tmp0_iterator_0 = tables.u();
      while (tmp0_iterator_0.v()) {
        var table = tmp0_iterator_0.x();
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = tmp0_safe_receiver.u4a(table.x4q_1);
        var format = $this$run.z4a();
        var tmp;
        try {
          var tmp_0;
          switch (format) {
            case 0:
              var length = $this$run.z4a();
              var language = $this$run.z4a();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_1 = $this$run.c4b(256);
              // Inline function 'kotlin.also' call

              var this_2 = new Int32Array(this_1.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable = 0;
              var last = this_1.length;
              if (inductionVariable < last)
                do {
                  var n = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>.<anonymous>' call
                  this_2[n] = this_1[n] & 255;
                }
                 while (inductionVariable < last);
              var glyphIdArray = this_2;
              var inductionVariable_0 = 0;
              var tmp_1;
              if (inductionVariable_0 < 256) {
                do {
                  var n_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  this.b4h(n_0, glyphIdArray[n_0]);
                }
                 while (inductionVariable_0 < 256);
                tmp_1 = Unit_instance;
              }

              tmp_0 = tmp_1;
              break;
            case 2:
              println('UNSUPPORTED CMAP format = ' + format);
              tmp_0 = Unit_instance;
              break;
            case 4:
              var length_0 = $this$run.z4a();
              var language_0 = $this$run.z4a();
              var segCount = $this$run.z4a() / 2 | 0;
              var searchRangeS = $this$run.z4a();
              var entrySelector = $this$run.z4a();
              var rangeShift = $this$run.z4a();
              var endCount = $this$run.d4r(segCount);
              $this$run.z4a();
              var startCount = $this$run.d4r(segCount);
              var idDelta = $this$run.f4r(segCount);
              var rangeOffsetPos = $this$run.ks();
              var idRangeOffset = $this$run.d4r(segCount);
              var inductionVariable_1 = 0;
              var tmp_2;
              if (inductionVariable_1 < segCount) {
                do {
                  var n_1 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  var ec = Char__toInt_impl_vasixd(endCount[n_1]);
                  var sc = Char__toInt_impl_vasixd(startCount[n_1]);
                  var delta = idDelta[n_1];
                  var iro = Char__toInt_impl_vasixd(idRangeOffset[n_1]);
                  var inductionVariable_2 = sc;
                  if (inductionVariable_2 <= ec)
                    do {
                      var c = inductionVariable_2;
                      inductionVariable_2 = inductionVariable_2 + 1 | 0;
                      if (!(iro === 0)) {
                        var glyphIndexOffset = rangeOffsetPos + imul(n_1, 2) | 0;
                        glyphIndexOffset = glyphIndexOffset + iro | 0;
                        glyphIndexOffset = glyphIndexOffset + imul(c - sc | 0, 2) | 0;
                        index = $this$run.u4a(glyphIndexOffset).z4a();
                        if (!(index === 0)) {
                          index = index + delta | 0;
                        }
                      } else {
                        index = c + delta | 0;
                      }
                      this.a4h(c, index & 65535);
                    }
                     while (!(c === ec));
                }
                 while (inductionVariable_1 < segCount);
                tmp_2 = Unit_instance;
              }

              tmp_0 = tmp_2;
              break;
            case 6:
              var length_1 = $this$run.z4a();
              var language_1 = $this$run.z4a();
              var firstCode = $this$run.z4a();
              var entryCount = $this$run.z4a();
              var inductionVariable_3 = 0;
              var tmp_3;
              if (inductionVariable_3 < entryCount) {
                do {
                  var n_2 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  var codePoint = firstCode + n_2 | 0;
                  this.a4h(codePoint, $this$run.z4a());
                }
                 while (inductionVariable_3 < entryCount);
                tmp_3 = Unit_instance;
              }

              tmp_0 = tmp_3;
              break;
            case 8:
              println('UNSUPPORTED CMAP format = ' + format);
              tmp_0 = Unit_instance;
              break;
            case 10:
              println('UNSUPPORTED CMAP format = ' + format);
              tmp_0 = Unit_instance;
              break;
            case 12:
              $this$run.z4a();
              var length_2 = $this$run.b4b();
              var language_2 = $this$run.b4b();
              var numGroups = $this$run.b4b();
              var inductionVariable_4 = 0;
              var tmp_4;
              if (inductionVariable_4 < numGroups) {
                do {
                  var n_3 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var startCharCode = $this$run.b4b();
                  var endCharCode = $this$run.b4b();
                  var startGlyphId = $this$run.b4b();
                  var inductionVariable_5 = startCharCode;
                  if (inductionVariable_5 <= endCharCode)
                    do {
                      var c_0 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      var m = c_0 - startCharCode | 0;
                      this.a4h(c_0, startGlyphId + m | 0);
                    }
                     while (!(c_0 === endCharCode));
                }
                 while (inductionVariable_4 < numGroups);
                tmp_4 = Unit_instance;
              }

              tmp_0 = tmp_4;
              break;
            case 13:
              println('UNSUPPORTED CMAP format = ' + format);
              tmp_0 = Unit_instance;
              break;
            default:
              println('UNSUPPORTED CMAP format = ' + format);
              tmp_0 = Unit_instance;
              break;
          }
          tmp = tmp_0;
        } catch ($p) {
          var tmp_5;
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
            tmp_5 = Unit_instance;
          } else {
            throw $p;
          }
          tmp = tmp_5;
        }
      }
    }
    return Unit_instance;
  };
  protoOf(BaseTtfFont).k4i = function (charIndex, default_0) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.e4g_1.s2(charIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.font.BaseTtfFont.getCodePointFromCharIndexOrElse.<anonymous>' call
      tmp = default_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(BaseTtfFont).l4i = function (charIndex, default_0, $super) {
    default_0 = default_0 === VOID ? -1 : default_0;
    return $super === VOID ? this.k4i(charIndex, default_0) : $super.k4i.call(this, charIndex, default_0);
  };
  protoOf(BaseTtfFont).m4i = function (reader, codePoint, cache) {
    var g = this.p4i(codePoint);
    var skipCount = 1;
    if (this.l4e_1 ? !(g == null) : false) {
      var subs = this.n4g_1.f1(codePoint);
      if (!(reader == null) ? !(subs == null) : false) {
        // Inline function 'kotlin.math.min' call
        var a = reader.m4r();
        var b = subs.q4j_1;
        var inductionVariable = Math.min(a, b);
        if (2 <= inductionVariable)
          $l$loop_0: do {
            var count = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var sub = reader.n4r(0, count);
            var replacement = subs.r4j_1.s2(sub);
            if (!(replacement == null)) {
              skipCount = sub.a();
              var tmp1_elvis_lhs = this.r4i(first_1(replacement));
              var tmp;
              if (tmp1_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp = tmp1_elvis_lhs;
              }
              g = tmp;
              break $l$loop_0;
            }
          }
           while (2 <= inductionVariable);
      }
    }
    if (reader == null)
      null;
    else {
      reader.v4b(skipCount);
    }
    return g;
  };
  protoOf(BaseTtfFont).n4i = function (reader, codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.m4i(reader, codePoint, cache) : $super.m4i.call(this, reader, codePoint, cache);
  };
  protoOf(BaseTtfFont).o4i = function (codePoint, cache) {
    var tmp0_safe_receiver = this.z4g(codePoint);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByCodePoint.<anonymous>' call
      tmp = this.q4i(tmp0_safe_receiver, cache, codePoint);
    }
    return tmp;
  };
  protoOf(BaseTtfFont).p4i = function (codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.o4i(codePoint, cache) : $super.o4i.call(this, codePoint, cache);
  };
  protoOf(BaseTtfFont).q4i = function (index, cache, codePoint) {
    var cff = this.r4g_1;
    if (!(cff == null)) {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.f4g_1;
      var res = this_0.f1(index);
      if (res == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
        var gvector = cff.e4a(index);
        var tmp$ret$0 = new CFFGlyph(this, index, 0, 0, 0, 0, numberToInt(gvector.i49_1), new GlyphGraphicsPath(index, gvector.h49_1));
        this_0.r1w(index, tmp$ret$0);
      }
      return ensureNotNull(this_0.f1(index));
    }
    var tmp0_elvis_lhs = getOrNull_0(this.q4f_1, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this.q4f_1, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size = end - start | 0;
    var tmp;
    if (!(size === 0)) {
      var tmp2_elvis_lhs = this.f4g_1.f1(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.image.font.BaseTtfFont.runTable' call
          var tmp0_elvis_lhs_0 = this.w4g('glyf');
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$2 = null;
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var table = tmp_1;
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
          var $this$runTable = table.s4j();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>.<anonymous>' call
          tmp$ret$2 = this.v4i($this$runTable.u4a(start), index);
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var tmp_2 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_3 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_4 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$9 = new Int32Array([]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
      tmp = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp_2, tmp_3, tmp_4, tmp$ret$9, this.c4g_1.f1(index).t4j_1, true);
    }
    var glyph = tmp;
    if (cache ? !this.l4g_1 : false) {
      this.f4g_1.r1w(index, glyph);
    }
    return glyph;
  };
  protoOf(BaseTtfFont).r4i = function (index, cache, codePoint, $super) {
    cache = cache === VOID ? true : cache;
    codePoint = codePoint === VOID ? -1 : codePoint;
    return $super === VOID ? this.q4i(index, cache, codePoint) : $super.q4i.call(this, index, cache, codePoint);
  };
  protoOf(BaseTtfFont).s4i = function (_this__u8e3s4) {
    var v = _this__u8e3s4.c4r();
    var i = extractSigned(v, 14, 2);
    var f = extract(v, 0, 14);
    return i + f / 16384.0;
  };
  protoOf(BaseTtfFont).t4i = function (_this__u8e3s4) {
    var v = _this__u8e3s4.b4b();
    var i = extractSigned(v, 16, 16);
    var f = extract(v, 0, 16);
    return i + f / 65536.0;
  };
  protoOf(BaseTtfFont).u4i = function (_this__u8e3s4, signed, word) {
    var tmp;
    if (!word ? signed : false) {
      tmp = _this__u8e3s4.h4r();
    } else if (!word ? !signed : false) {
      tmp = _this__u8e3s4.v4a();
    } else if (word ? signed : false) {
      tmp = _this__u8e3s4.c4r();
    } else if (word ? !signed : false) {
      tmp = _this__u8e3s4.z4a();
    } else {
      get_invalidOp();
    }
    return tmp;
  };
  protoOf(BaseTtfFont).v4i = function (_this__u8e3s4, index) {
    var ncontours = _this__u8e3s4.c4r();
    var xMin = _this__u8e3s4.c4r();
    var yMin = _this__u8e3s4.c4r();
    var xMax = _this__u8e3s4.c4r();
    var yMax = _this__u8e3s4.c4r();
    var advanceWidth = this.c4g_1.f1(index).t4j_1;
    // Inline function 'kotlin.also' call
    var tmp;
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      // Inline function 'kotlin.collections.arrayListOf' call
      var references = ArrayList_init_$Create$();
      do {
        var flags = _this__u8e3s4.z4a();
        var glyphIndex = _this__u8e3s4.z4a();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = this.u4i(_this__u8e3s4, signed, words);
        var y = this.u4i(_this__u8e3s4, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = this.s4i(_this__u8e3s4);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = this.s4i(_this__u8e3s4);
          scaleY = this.s4i(_this__u8e3s4);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = this.s4i(_this__u8e3s4);
          scale01 = this.s4i(_this__u8e3s4);
          scale10 = this.s4i(_this__u8e3s4);
          scaleY = this.s4i(_this__u8e3s4);
        }
        var ref = new GlyphReference(ensureNotNull(this.r4i(glyphIndex)), x, y, scaleX, scale01, scale10, scaleY);
        // Inline function 'kotlin.collections.plusAssign' call
        references.r(ref);
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      tmp = new CompositeGlyph(this, index, xMin, yMin, xMax, yMax, references, advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this__u8e3s4.z4a();
        }
         while (!(n === ncontours));
      var instructionLength = _this__u8e3s4.z4a();
      var instructions = _this__u8e3s4.c4b(instructionLength);
      var tmp1_safe_receiver = lastOrNull(contoursIndices);
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver + 1 | 0;
      var numPoints = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
      var flags_0 = new IntArrayList();
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this__u8e3s4.v4a();
        flags_0.m1s(cf);
        if (!((cf & 8) === 0)) {
          var count = _this__u8e3s4.v4a();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.m1s(cf);
            }
             while (inductionVariable_0 < count);
          npos = npos + (count + 1 | 0) | 0;
        } else {
          npos = npos + 1 | 0;
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.b1r(n_1);
              var b1 = !(((flag >>> (1 + xy | 0) | 0) & 1) === 0);
              var b2 = !(((flag >>> (4 + xy | 0) | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this__u8e3s4.v4a();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this__u8e3s4.c4r() | 0;
              }
              pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      tmp = new SimpleGlyph(this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.x1s(), xPos, yPos, advanceWidth);
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.readGlyph.<anonymous>' call
    return tmp;
  };
  function Companion_23() {
  }
  protoOf(Companion_23).y4q = function (num, den) {
    return insert16(insert16(0, num, 0), den, 16);
  };
  var Companion_instance_31;
  function Companion_getInstance_38() {
    return Companion_instance_31;
  }
  function _FWord___init__impl__2rjyqf(data) {
    return data;
  }
  function _FWord___get_data__impl__9ys4ze($this) {
    return $this;
  }
  function FWord__toDouble_impl_53j5qp($this) {
    return _FWord___get_data__impl__9ys4ze($this);
  }
  function readTtfFont(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var tmp = new $readTtfFontCOROUTINE$46(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function $readTtfFontCOROUTINE$46(_this__u8e3s4, onlyReadMetadata, enableLigatures, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a4s_1 = _this__u8e3s4;
    this.b4s_1 = onlyReadMetadata;
    this.c4s_1 = enableLigatures;
  }
  protoOf($readTtfFontCOROUTINE$46).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.a4s_1.d4s(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new TtfFont(ARGUMENT, get_baseName(this.a4s_1), this.b4s_1, this.c4s_1);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function ss$factory() {
    return getPropertyCallableRef('ss', 1, KProperty1, function (receiver) {
      return _get_ss__ndcawb(receiver);
    }, null);
  }
  function VectorFont() {
  }
  function set_onlyReadVisibleLayers(_this__u8e3s4, _set____db54di) {
    _init_properties_ASE_kt__16anup();
    var this_0 = onlyReadVisibleLayers$delegate;
    var property = onlyReadVisibleLayers$factory();
    var tmp0_elvis_lhs = this_0.j23_1;
    var tmp = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    // Inline function 'korlibs.datastructure.fastCastTo' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    setExtra(_this__u8e3s4, tmp, _set____db54di);
    return Unit_instance;
  }
  function get_onlyReadVisibleLayers(_this__u8e3s4) {
    _init_properties_ASE_kt__16anup();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'korlibs.datastructure.Property.getValue' call
      var this_0 = onlyReadVisibleLayers$delegate;
      var property = onlyReadVisibleLayers$factory_0();
      // Inline function 'korlibs.datastructure.fastCastTo' call
      var tmp1_safe_receiver = _this__u8e3s4.i23();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs = this_0.j23_1;
        tmp = tmp1_safe_receiver.s13(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      }
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = tmp;
      if (res == null) {
        var r = this_0.k23_1();
        var tmp_0;
        if (!(r == null)) {
          tmp_0 = true;
        } else {
          var tmp2_elvis_lhs = this_0.j23_1;
          tmp_0 = hasExtra(_this__u8e3s4, tmp2_elvis_lhs == null ? property.callableName : tmp2_elvis_lhs);
        }
        if (tmp_0) {
          // Inline function 'korlibs.datastructure.Property.setValue' call
          var tmp0_elvis_lhs_0 = this_0.j23_1;
          var tmp_1 = tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0;
          // Inline function 'korlibs.datastructure.fastCastTo' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          setExtra(_this__u8e3s4, tmp_1, r);
        }
        tmp$ret$6 = r;
        break $l$block;
      }
      tmp$ret$6 = res;
    }
    return tmp$ret$6;
  }
  var onlyReadVisibleLayers$delegate;
  function Companion_24() {
  }
  protoOf(Companion_24).h2f = function () {
    return new Mixin_0();
  };
  var Companion_instance_32;
  function Companion_getInstance_39() {
    return Companion_instance_32;
  }
  function Mixin_0() {
    this.e4s_1 = null;
    this.f4s_1 = Colors_getInstance().q3b_1;
  }
  protoOf(Mixin_0).g4s = function (_set____db54di) {
    this.e4s_1 = _set____db54di;
  };
  protoOf(Mixin_0).h4s = function (_set____db54di) {
    this.f4s_1 = _set____db54di;
  };
  function sam$kotlin_Comparator$0(function_0) {
    this.i4s_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).aa = function (a, b) {
    return this.i4s_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.aa(a, b);
  };
  function ASE$AseSlice$sortKeys$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'korlibs.image.format.AseSlice.sortKeys.<anonymous>' call
    var tmp = a.j4s_1;
    // Inline function 'korlibs.image.format.AseSlice.sortKeys.<anonymous>' call
    var tmp$ret$1 = b.j4s_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function AseCell() {
  }
  function AseBitmapCell(bmp, x, y, opacity) {
    this.y4s_1 = bmp;
    this.z4s_1 = x;
    this.a4t_1 = y;
    this.b4t_1 = opacity;
    this.c4t_1 = Companion_instance_32.h2f();
  }
  protoOf(AseBitmapCell).j3t = function () {
    return this.y4s_1;
  };
  protoOf(AseBitmapCell).v4s = function () {
    return this.z4s_1;
  };
  protoOf(AseBitmapCell).w4s = function () {
    return this.a4t_1;
  };
  protoOf(AseBitmapCell).g4s = function (_set____db54di) {
    this.c4t_1.g4s(_set____db54di);
  };
  protoOf(AseBitmapCell).h4s = function (_set____db54di) {
    this.c4t_1.h4s(_set____db54di);
  };
  function AseLinkedCell(linkedCell, x, y, opacity) {
    this.d4t_1 = linkedCell;
    this.e4t_1 = x;
    this.f4t_1 = y;
    this.g4t_1 = opacity;
    this.h4t_1 = Companion_instance_32.h2f();
  }
  protoOf(AseLinkedCell).v4s = function () {
    return this.e4t_1;
  };
  protoOf(AseLinkedCell).w4s = function () {
    return this.f4t_1;
  };
  protoOf(AseLinkedCell).g4s = function (_set____db54di) {
    this.h4t_1.g4s(_set____db54di);
  };
  protoOf(AseLinkedCell).h4s = function (_set____db54di) {
    this.h4t_1.h4s(_set____db54di);
  };
  protoOf(AseLinkedCell).j3t = function () {
    return this.d4t_1.j3t();
  };
  protoOf(AseLinkedCell).x4s = function () {
    return this.d4t_1.x4s();
  };
  function AseTilemapCell(data, tileBitmask, bitmaskXFlip, bitmaskYFlip, bitmask90CWFlip, x, y, opacity) {
    this.i4t_1 = data;
    this.j4t_1 = tileBitmask;
    this.k4t_1 = bitmaskXFlip;
    this.l4t_1 = bitmaskYFlip;
    this.m4t_1 = bitmask90CWFlip;
    this.n4t_1 = x;
    this.o4t_1 = y;
    this.p4t_1 = opacity;
    this.q4t_1 = Companion_instance_32.h2f();
    this.r4t_1 = new Bitmap32(1, 1, VOID, true);
  }
  protoOf(AseTilemapCell).v4s = function () {
    return this.n4t_1;
  };
  protoOf(AseTilemapCell).w4s = function () {
    return this.o4t_1;
  };
  protoOf(AseTilemapCell).g4s = function (_set____db54di) {
    this.q4t_1.g4s(_set____db54di);
  };
  protoOf(AseTilemapCell).h4s = function (_set____db54di) {
    this.q4t_1.h4s(_set____db54di);
  };
  protoOf(AseTilemapCell).j3t = function () {
    return this.r4t_1;
  };
  function AseLayer(originalAseIndex, index, name, flags, type, childLevel, blendModeInt, opacity, tilesetIndex) {
    ImageLayer.call(this, index, name, type);
    this.v4t_1 = originalAseIndex;
    this.w4t_1 = flags;
    this.x4t_1 = childLevel;
    this.y4t_1 = blendModeInt;
    this.z4t_1 = opacity;
    this.a4u_1 = tilesetIndex;
    this.b4u_1 = Companion_instance_32.h2f();
    this.c4u_1 = hasBitSet(this.w4t_1, 0);
    this.d4u_1 = hasBitSet(this.w4t_1, 1);
    this.e4u_1 = hasBitSet(this.w4t_1, 2);
    this.f4u_1 = hasBitSet(this.w4t_1, 3);
    this.g4u_1 = hasBitSet(this.w4t_1, 4);
    this.h4u_1 = hasBitSet(this.w4t_1, 5);
    this.i4u_1 = hasBitSet(this.w4t_1, 6);
    var tmp = this;
    switch (this.y4t_1) {
      case 0:
        tmp.j4u_1 = BlendMode_NORMAL_getInstance();
        break;
      case 1:
        tmp.j4u_1 = BlendMode_MULTIPLY_getInstance();
        break;
      case 2:
        tmp.j4u_1 = BlendMode_SCREEN_getInstance();
        break;
      case 3:
        tmp.j4u_1 = BlendMode_OVERLAY_getInstance();
        break;
      case 4:
        tmp.j4u_1 = BlendMode_DARKEN_getInstance();
        break;
      case 5:
        tmp.j4u_1 = BlendMode_LIGHTEN_getInstance();
        break;
      case 6:
        tmp.j4u_1 = BlendMode_COLOR_DODGE_getInstance();
        break;
      case 7:
        tmp.j4u_1 = BlendMode_COLOR_BURN_getInstance();
        break;
      case 8:
        tmp.j4u_1 = BlendMode_HARD_LIGHT_getInstance();
        break;
      case 9:
        tmp.j4u_1 = BlendMode_SOFT_LIGHT_getInstance();
        break;
      case 10:
        tmp.j4u_1 = BlendMode_DIFFERENCE_getInstance();
        break;
      case 11:
        tmp.j4u_1 = BlendMode_EXCLUSION_getInstance();
        break;
      case 12:
        tmp.j4u_1 = BlendMode_HUE_getInstance();
        break;
      case 13:
        tmp.j4u_1 = BlendMode_SATURATION_getInstance();
        break;
      case 14:
        tmp.j4u_1 = BlendMode_COLOR_getInstance();
        break;
      case 15:
        tmp.j4u_1 = BlendMode_LUMINOSITY_getInstance();
        break;
      case 16:
        tmp.j4u_1 = BlendMode_ADDITION_getInstance();
        break;
      case 17:
        tmp.j4u_1 = BlendMode_SUBTRACT_getInstance();
        break;
      case 18:
        tmp.j4u_1 = BlendMode_DIVIDE_getInstance();
        break;
      default:
        tmp.j4u_1 = BlendMode_NORMAL_getInstance();
        break;
    }
  }
  protoOf(AseLayer).g4s = function (_set____db54di) {
    this.b4u_1.g4s(_set____db54di);
  };
  protoOf(AseLayer).h4s = function (_set____db54di) {
    this.b4u_1.h4s(_set____db54di);
  };
  function AseFrame(index) {
    this.k4u_1 = index;
    this.l4u_1 = Companion_instance_32.h2f();
    this.m4u_1 = 0;
    this.n4u_1 = FastIntMap();
  }
  protoOf(AseFrame).g4s = function (_set____db54di) {
    this.l4u_1.g4s(_set____db54di);
  };
  protoOf(AseFrame).h4s = function (_set____db54di) {
    this.l4u_1.h4s(_set____db54di);
  };
  function AsePalette(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    Palette.call(this, colors, names, changeStart, changeEnd);
    this.s4u_1 = Companion_instance_32.h2f();
  }
  protoOf(AsePalette).g4s = function (_set____db54di) {
    this.s4u_1.g4s(_set____db54di);
  };
  protoOf(AsePalette).h4s = function (_set____db54di) {
    this.s4u_1.h4s(_set____db54di);
  };
  function AseTileset(tilesetId, ntiles, tileWidth, tileHeight, baseIndex, tilesetName, tiles) {
    this.t4u_1 = tilesetId;
    this.u4u_1 = ntiles;
    this.v4u_1 = tileWidth;
    this.w4u_1 = tileHeight;
    this.x4u_1 = baseIndex;
    this.y4u_1 = tilesetName;
    this.z4u_1 = tiles;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = IntMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.AseTileset.tileSet.<anonymous>' call
    var inductionVariable = 0;
    var last = this.z4u_1.n() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var id = n;
        this_0.r1w(id, new TileSetTileInfo(id, this.z4u_1.f1(n)));
      }
       while (inductionVariable <= last);
    tmp.a4v_1 = new TileSet(this_0);
  }
  protoOf(AseTileset).toString = function () {
    return 'AseTileset(tilesetId=' + this.t4u_1 + ', ntiles=' + this.u4u_1 + ', tileWidth=' + this.v4u_1 + ', tileHeight=' + this.w4u_1 + ', baseIndex=' + this.x4u_1 + ', tilesetName=' + this.y4u_1 + ', tiles=' + this.z4u_1 + ')';
  };
  protoOf(AseTileset).hashCode = function () {
    var result = this.t4u_1;
    result = imul(result, 31) + this.u4u_1 | 0;
    result = imul(result, 31) + this.v4u_1 | 0;
    result = imul(result, 31) + this.w4u_1 | 0;
    result = imul(result, 31) + this.x4u_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.y4u_1) | 0;
    result = imul(result, 31) + hashCode(this.z4u_1) | 0;
    return result;
  };
  protoOf(AseTileset).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AseTileset))
      return false;
    var tmp0_other_with_cast = other instanceof AseTileset ? other : THROW_CCE();
    if (!(this.t4u_1 === tmp0_other_with_cast.t4u_1))
      return false;
    if (!(this.u4u_1 === tmp0_other_with_cast.u4u_1))
      return false;
    if (!(this.v4u_1 === tmp0_other_with_cast.v4u_1))
      return false;
    if (!(this.w4u_1 === tmp0_other_with_cast.w4u_1))
      return false;
    if (!(this.x4u_1 === tmp0_other_with_cast.x4u_1))
      return false;
    if (!(this.y4u_1 === tmp0_other_with_cast.y4u_1))
      return false;
    if (!equals(this.z4u_1, tmp0_other_with_cast.z4u_1))
      return false;
    return true;
  };
  function AseSliceKey(frameIndex, sliceXOrigin, sliceYOrigin, sliceWidth, sliceHeight, centerXPos, centerYPos, centerWidth, centerHeight, pivotX, pivotY) {
    this.j4s_1 = frameIndex;
    this.k4s_1 = sliceXOrigin;
    this.l4s_1 = sliceYOrigin;
    this.m4s_1 = sliceWidth;
    this.n4s_1 = sliceHeight;
    this.o4s_1 = centerXPos;
    this.p4s_1 = centerYPos;
    this.q4s_1 = centerWidth;
    this.r4s_1 = centerHeight;
    this.s4s_1 = pivotX;
    this.t4s_1 = pivotY;
    this.u4s_1 = new RectangleI(this.k4s_1, this.l4s_1, this.m4s_1, this.n4s_1);
  }
  function AseSlice(name, hasNinePatch, hasPivotInfo) {
    this.b4v_1 = name;
    this.c4v_1 = hasNinePatch;
    this.d4v_1 = hasPivotInfo;
    this.e4v_1 = Companion_instance_32.h2f();
    this.f4v_1 = FastArrayList_init_$Create$();
  }
  protoOf(AseSlice).g4s = function (_set____db54di) {
    this.e4v_1.g4s(_set____db54di);
  };
  protoOf(AseSlice).h4s = function (_set____db54di) {
    this.e4v_1.h4s(_set____db54di);
  };
  protoOf(AseSlice).g4v = function () {
    // Inline function 'kotlin.collections.sortBy' call
    var this_0 = this.f4v_1;
    if (this_0.n() > 1) {
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp = ASE$AseSlice$sortKeys$lambda;
      var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
      sortWith(this_0, tmp$ret$0);
    }
  };
  protoOf(AseSlice).h4v = function (index) {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
    var this_0 = this.f4v_1;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this_0.y1u_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.image.format.AseSlice.getSliceForFrame.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[(this_0.n() - n | 0) - 1 | 0];
      if (index >= it.j4s_1)
        return it;
      n = n + 1 | 0;
    }
    var tmp0_elvis_lhs = firstOrNull_0(this.f4v_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'No frames key frames for slice!';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  function AseTag(fromFrame, toFrame, directionByte, tagColor, tagName) {
    this.i4v_1 = fromFrame;
    this.j4v_1 = toFrame;
    this.k4v_1 = directionByte;
    this.l4v_1 = tagColor;
    this.m4v_1 = tagName;
    this.n4v_1 = Companion_instance_32.h2f();
    var tmp = this;
    switch (this.k4v_1) {
      case 0:
        tmp.o4v_1 = Direction_FORWARD_getInstance();
        break;
      case 1:
        tmp.o4v_1 = Direction_REVERSE_getInstance();
        break;
      case 2:
        tmp.o4v_1 = Direction_PING_PONG_getInstance();
        break;
      default:
        tmp.o4v_1 = Direction_FORWARD_getInstance();
        break;
    }
  }
  protoOf(AseTag).g4s = function (_set____db54di) {
    this.n4v_1.g4s(_set____db54di);
  };
  protoOf(AseTag).h4s = function (_set____db54di) {
    this.n4v_1.h4s(_set____db54di);
  };
  function AseImage() {
    this.p4v_1 = Companion_instance_32.h2f();
    this.q4v_1 = null;
    this.r4v_1 = FastArrayList_init_$Create$();
    this.s4v_1 = FastArrayList_init_$Create$();
    this.t4v_1 = FastArrayList_init_$Create$();
    this.u4v_1 = FastArrayList_init_$Create$();
    this.v4v_1 = IntMap_init_$Create$();
    this.w4v_1 = IntMap_init_$Create$();
  }
  protoOf(AseImage).g4s = function (_set____db54di) {
    this.p4v_1.g4s(_set____db54di);
  };
  protoOf(AseImage).h4s = function (_set____db54di) {
    this.p4v_1.h4s(_set____db54di);
  };
  function takeLayersByName(_this__u8e3s4, $this, name) {
    var tmp;
    if (getExtra(_this__u8e3s4, 'layers') == null) {
      tmp = true;
    } else {
      var tmp_0 = getExtra(_this__u8e3s4, 'layers');
      tmp = contains_0((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE(), name);
    }
    return tmp;
  }
  function slicingEnabled(_this__u8e3s4, $this) {
    return getExtraTyped(_this__u8e3s4, 'disableSlicing') == null ? true : !ensureNotNull(getExtraTyped(_this__u8e3s4, 'disableSlicing'));
  }
  function useSlicePosition(_this__u8e3s4, $this) {
    return !(getExtraTyped(_this__u8e3s4, 'useSlicePosition') == null) ? ensureNotNull(getExtraTyped(_this__u8e3s4, 'useSlicePosition')) : false;
  }
  function readImageContainer$createImageFrameLayer(imageLayers, image, key, value) {
    var resolved = value.x4s();
    var layer = imageLayers.f1(key);
    var tilemap = null;
    if (resolved instanceof AseTilemapCell) {
      var tileset = image.w4v_1.f1(layer.a4u_1);
      tilemap = new TileMapData(resolved.i4t_1, tileset == null ? null : tileset.a4v_1, resolved.j4t_1, resolved.k4t_1, resolved.l4t_1, resolved.m4t_1);
    }
    return new ImageFrameLayer(layer, slice_0(resolved.j3t()), resolved.v4s(), resolved.w4s(), false, true, tilemap);
  }
  function ASE() {
    ASE_instance = this;
    ImageFormatWithContainer.call(this, ['ase']);
  }
  protoOf(ASE).z4v = function (s, props) {
    var ss = s.g1s();
    readBytesExact_0(ss, 4);
    if (!(readU16LE_0(ss) === 42464))
      return null;
    var frames = readU16LE_0(ss);
    var width = readU16LE_0(ss);
    var height = readU16LE_0(ss);
    var bitsPerPixel = readU16LE_0(ss);
    // Inline function 'kotlin.also' call
    var this_0 = new ImageInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.ASE.decodeHeader.<anonymous>' call
    this_0.l4w_1 = bitsPerPixel;
    this_0.j4w_1 = width;
    this_0.k4w_1 = height;
    return this_0;
  };
  protoOf(ASE).m4w = function (s, props) {
    var fileSize = readS32LE_0(s);
    if (s.a().t6(toLong(fileSize)) < 0) {
      // Inline function 'kotlin.error' call
      var message = 'File too short';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (!(readU16LE_0(s) === 42464)) {
      // Inline function 'kotlin.error' call
      var message_0 = 'Not an Aseprite file';
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    var numFrames = readU16LE_0(s);
    var imageWidth = readU16LE_0(s);
    var imageHeight = readU16LE_0(s);
    var bitsPerPixel = readU16LE_0(s);
    var bytesPerPixel = bitsPerPixel / 8 | 0;
    var flags = readU32LE(s);
    var speed = readU16LE_0(s);
    s.v4b(4);
    s.v4b(4);
    var transparentIndex = readU8(s);
    s.v4b(3);
    var numColors = readU16LE_0(s);
    var pixelWidth = readU8(s);
    var pixelHeight = readU8(s);
    var gridX = readS16LE(s);
    var gridY = readS16LE(s);
    var gridWidth = readU16LE_0(s);
    var gridHeight = readU16LE_0(s);
    s.v4b(84);
    var image = new AseImage();
    var inductionVariable = 0;
    if (inductionVariable < numFrames)
      do {
        var frameIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var bytesInFrame = readS32LE_0(s);
        var fs = readStream_0(s, bytesInFrame - 4 | 0);
        if (!(readU16LE_0(fs) === 61946)) {
          // Inline function 'kotlin.error' call
          var message_1 = 'Invalid ASE sprite file or error parsing';
          throw IllegalStateException_init_$Create$(toString(message_1));
        }
        readU16LE_0(fs);
        var frameDuration = readU16LE_0(fs);
        fs.v4b(2);
        var numChunks = readS32LE_0(fs);
        var currentFrame = new AseFrame(frameIndex);
        image.s4v_1.r(currentFrame);
        currentFrame.m4u_1 = frameDuration;
        var lastEntity = null;
        var lastCell = null;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < numChunks)
          do {
            var nc = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var chunkSize = readS32LE_0(fs);
            var chunkType = readU16LE_0(fs);
            var cs = readStream_0(fs, chunkSize - 6 | 0);
            switch (chunkType) {
              case 4:
                image.q4v_1;
                break;
              case 17:
                image.q4v_1;
                break;
              case 8196:
                var flags_0 = readU16LE_0(cs);
                var type = Companion_getInstance_44().n4w_1[readU16LE_0(cs)];
                var childLevel = readU16LE_0(cs);
                var defaultLayerWidth = readU16LE_0(cs);
                var defaultLayerHeight = readU16LE_0(cs);
                var blendModeInt = readU16LE_0(cs);
                var opacity = readU8(cs);
                cs.v4b(3);
                var name = this.o4w(cs);
                var tilesetIndex = type.r4w() ? readS32LE_0(cs) : 0;
                var layer = new AseLayer(image.r4v_1.n(), image.r4v_1.n(), name, flags_0, type, childLevel, blendModeInt, opacity, tilesetIndex);
                image.r4v_1.r(layer);
                lastEntity = layer;
                break;
              case 8197:
                var layerIndex = readU16LE_0(cs);
                var x = readS16LE(cs);
                var y = readS16LE(cs);
                var opacity_0 = readU8(cs);
                var celType = readU16LE_0(cs);
                cs.v4b(7);
                var tmp;
                switch (celType) {
                  case 0:
                  case 2:
                    var width = readU16LE_0(cs);
                    var height = readU16LE_0(cs);
                    var data = readAvailable(cs);
                    var udata = celType === 2 ? uncompress_0(data, Companion_getInstance_59(), imul(imul(width, height), bytesPerPixel)) : data;
                    var tmp_0;
                    switch (bitsPerPixel) {
                      case 32:
                        // Inline function 'kotlin.also' call

                        var this_0 = Bitmap32_init_$Create$(width, height, _RgbaArray___init__impl__oib4y4(getS32Array(udata, 0, imul(width, height), true)));
                        // Inline function 'kotlin.contracts.contract' call

                        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call

                        if (props.e4x()) {
                          this_0.e3l();
                        }

                        tmp_0 = this_0;
                        break;
                      case 8:
                        tmp_0 = new Bitmap8(width, height, udata, ensureNotNull(image.q4v_1).e3q_1);
                        break;
                      default:
                        var message_2 = 'Unsupported ASE mode';
                        throw IllegalStateException_init_$Create$(toString(message_2));
                    }

                    var bmp = tmp_0;
                    tmp = new AseBitmapCell(bmp, x, y, opacity_0);
                    break;
                  case 1:
                    var linkFrame = readU16LE_0(cs);
                    // Inline function 'korlibs.datastructure.get' call

                    // Inline function 'kotlin.js.asDynamic' call

                    var tmp$ret$2 = image.s4v_1.f1(linkFrame).n4u_1.get(layerIndex);
                    var aseCell = ensureNotNull(tmp$ret$2);
                    tmp = new AseLinkedCell(aseCell, x, y, opacity_0);
                    break;
                  case 3:
                    var tilesWidth = readU16LE_0(cs);
                    var tilesHeight = readU16LE_0(cs);
                    var bitsPerTile = readU16LE_0(cs);
                    var tileBitmask = readS32LE_0(cs);
                    var bitmaskXFlip = readS32LE_0(cs);
                    var bitmaskYFlip = readS32LE_0(cs);
                    var bitmask90CWFlip = readS32LE_0(cs);
                    var bytesPerTile = bitsPerTile / 8 | 0;
                    cs.v4b(10);
                    var compressedData = uncompress_0(readAvailable(cs), Companion_getInstance_59(), imul(imul(tilesWidth, tilesHeight), bytesPerTile));
                    var tmp_1;
                    if (bitsPerTile === 32) {
                      tmp_1 = getS32ArrayLE(compressedData, 0, imul(tilesWidth, tilesHeight));
                    } else {
                      var reason = 'Only supported 32-bits per tile';
                      throw new NotImplementedError('An operation is not implemented: ' + reason);
                    }

                    var data_0 = tmp_1;
                    tmp = new AseTilemapCell(new IntArray2(tilesWidth, tilesHeight, data_0), tileBitmask, bitmaskXFlip, bitmaskYFlip, bitmask90CWFlip, x, y, opacity_0);
                    break;
                  default:
                    var message_3 = 'Aseprite: Unknown celType=' + celType;
                    throw IllegalStateException_init_$Create$(toString(message_3));
                }

                var cel = tmp;
                lastEntity = cel;
                lastCell = cel;
                if (!(cel == null)) {
                  // Inline function 'korlibs.datastructure.set' call
                  // Inline function 'kotlin.js.asDynamic' call
                  currentFrame.n4u_1.set(layerIndex, cel);
                }

                break;
              case 8198:
                var flags_1 = readS32LE_0(cs);
                var x_0 = _Fixed32___get_double__impl__wjoyf6(this.f4x(cs));
                var y_0 = _Fixed32___get_double__impl__wjoyf6(this.f4x(cs));
                var width_0 = _Fixed32___get_double__impl__wjoyf6(this.f4x(cs));
                var height_0 = _Fixed32___get_double__impl__wjoyf6(this.f4x(cs));
                cs.v4b(16);
                break;
              case 8199:
                var type_0 = readU16LE_0(cs);
                var flags_2 = readU16LE_0(cs);
                var gamma = this.f4x(cs);
                cs.v4b(8);
                break;
              case 8200:
                var nentries = readS32LE_0(cs);
                cs.v4b(8);
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < nentries)
                  do {
                    var n = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var entryId = readS32LE_0(cs);
                    cs.v4b(8);
                    var externalFileName = this.o4w(cs);
                    image.v4v_1.r1w(entryId, externalFileName);
                  }
                   while (inductionVariable_1 < nentries);
                break;
              case 8214:
                break;
              case 8215:
                break;
              case 8216:
                var numTags = readU16LE_0(cs);
                cs.v4b(8);
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < numTags)
                  do {
                    var tag = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    var fromFrame = readU16LE_0(cs);
                    var toFrame = readU16LE_0(cs);
                    var direction = readU8(cs);
                    cs.v4b(8);
                    var tagColor = RGBA__withA_impl_vogscm(this.g4x(cs), 255);
                    var tagName = this.o4w(cs);
                    var tag_0 = new AseTag(fromFrame, toFrame, direction, tagColor, tagName);
                    image.t4v_1.r(tag_0);
                  }
                   while (inductionVariable_2 < numTags);
                break;
              case 8217:
                var numEntries = readS32LE_0(cs);
                var changeStart = readS32LE_0(cs);
                var changeEnd = readS32LE_0(cs);
                var colors = Companion_instance_18.i3l(numEntries);
                // Inline function 'kotlin.arrayOfNulls' call

                var colorNames = fillArrayVal(Array(numEntries), null);
                cs.v4b(8);
                var inductionVariable_3 = 0;
                if (inductionVariable_3 < numEntries)
                  do {
                    var ncol = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var flags_3 = readU16LE_0(cs);
                    var rgba = this.g4x(cs);
                    var name_0 = hasBitSet(flags_3, 0) ? this.o4w(cs) : null;
                    RgbaArray__set_impl_epw2wg(colors, ncol, rgba);
                    colorNames[ncol] = name_0;
                  }
                   while (inductionVariable_3 < numEntries);
                image.q4v_1 = new AsePalette(colors, colorNames, changeStart, changeEnd);
                lastEntity = image.q4v_1;
                break;
              case 8224:
                var flags_4 = readS32LE_0(cs);
                if (hasBitSet(flags_4, 0)) {
                  var tmp9_safe_receiver = lastEntity;
                  if (tmp9_safe_receiver != null) {
                    tmp9_safe_receiver.g4s(this.o4w(cs));
                  }
                }

                if (hasBitSet(flags_4, 1)) {
                  var tmp10_safe_receiver = lastEntity;
                  if (tmp10_safe_receiver != null) {
                    tmp10_safe_receiver.h4s(this.g4x(cs));
                  }
                }

                break;
              case 8226:
                var numSliceKeys = readS32LE_0(cs);
                var sliceFlags = readS32LE_0(cs);
                cs.v4b(4);
                var sliceName = this.o4w(cs);
                var hasNinePatch = hasBitSet(sliceFlags, 0);
                var hasPivotInfo = hasBitSet(sliceFlags, 1);
                var slice_1 = new AseSlice(sliceName, hasNinePatch, hasPivotInfo);
                image.u4v_1.r(slice_1);
                lastEntity = slice_1;
                var inductionVariable_4 = 0;
                if (inductionVariable_4 < numSliceKeys)
                  do {
                    var nsk = inductionVariable_4;
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    var sliceFrameIndex = readS32LE_0(cs);
                    var sliceXOrigin = readS32LE_0(cs);
                    var sliceYOrigin = readS32LE_0(cs);
                    var sliceWidth = readS32LE_0(cs);
                    var sliceHeight = readS32LE_0(cs);
                    var centerXPos = hasNinePatch ? readS32LE_0(cs) : 0;
                    var centerYPos = hasNinePatch ? readS32LE_0(cs) : 0;
                    var centerWidth = hasNinePatch ? readS32LE_0(cs) : sliceWidth;
                    var centerHeight = hasNinePatch ? readS32LE_0(cs) : sliceHeight;
                    var pivotX = hasPivotInfo ? readS32LE_0(cs) : 0;
                    var pivotY = hasPivotInfo ? readS32LE_0(cs) : 0;
                    slice_1.f4v_1.r(new AseSliceKey(sliceFrameIndex, sliceXOrigin, sliceYOrigin, sliceWidth, sliceHeight, centerXPos, centerYPos, centerWidth, centerHeight, pivotX, pivotY));
                  }
                   while (inductionVariable_4 < numSliceKeys);
                break;
              case 8227:
                var tilesetId = readS32LE_0(cs);
                var tilesetFlags = readS32LE_0(cs);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var includeLinkToExternalFile = !(((tilesetFlags >>> 0 | 0) & 1) === 0);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var includeTilesInsideThisFile = !(((tilesetFlags >>> 1 | 0) & 1) === 0);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var tile0IsEmpty = !(((tilesetFlags >>> 2 | 0) & 1) === 0);
                var ntiles = readS32LE_0(cs);
                var tileWidth = readU16LE_0(cs);
                var tileHeight = readU16LE_0(cs);
                var baseIndex = readS16LE(cs);
                cs.v4b(14);
                var tilesetName = this.o4w(cs);
                // Inline function 'kotlin.collections.listOf' call

                var tiles = emptyList();
                if (includeLinkToExternalFile) {
                  var externalFileId = readS32LE_0(cs);
                  var externalTilesetId = readS32LE_0(cs);
                }

                if (includeTilesInsideThisFile) {
                  var compressedDataLength = readS32LE_0(cs);
                  var compressedData_0 = readBytesExact_0(cs, compressedDataLength);
                  var data_1 = uncompress_0(compressedData_0, Companion_getInstance_59());
                  var ints = getS32ArrayLE(data_1, 0, imul(imul(tileWidth, tileHeight), ntiles));
                  // Inline function 'kotlin.also' call
                  var this_1 = Bitmap32_init_$Create$(tileWidth, imul(tileHeight, ntiles), _RgbaArray___init__impl__oib4y4(ints));
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
                  if (props.e4x()) {
                    this_1.e3l();
                  }
                  var bitmap = this_1;
                  tiles = splitInRows(slice_0(bitmap), tileWidth, tileHeight);
                }

                image.w4v_1.r1w(tilesetId, new AseTileset(tilesetId, ntiles, tileWidth, tileHeight, baseIndex, tilesetName, tiles));
                break;
              default:
                println('WARNING: Aseprite: Not implemented chunkType=' + get_hex(chunkType));
                break;
            }
          }
           while (inductionVariable_0 < numChunks);
      }
       while (inductionVariable < numFrames);
    var imageLayers = image.r4v_1;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = imageLayers.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var shouldProcess = get_onlyReadVisibleLayers(props) ? element.c4u_1 : true;
      var tmp_2;
      if (shouldProcess) {
        var tmp_3 = ASE_getInstance();
        var tmp_4 = element.i4x_1;
        tmp_2 = takeLayersByName(props, tmp_3, (!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : THROW_CCE());
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        destination.r(element);
      }
    }
    var imageLayersToProcess = destination;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_2 = image.s4v_1;
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this_2.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.x();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_3 = toLinkedMap(element_0.n4u_1);
      var destination_1 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_1 = this_3.k2().u();
      while (tmp0_iterator_1.v()) {
        var element_1 = tmp0_iterator_1.x();
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var shouldProcess_0 = get_onlyReadVisibleLayers(props) ? imageLayers.f1(element_1.l2()).c4u_1 : true;
        var tmp_5;
        if (shouldProcess_0) {
          var tmp_6 = ASE_getInstance();
          var tmp_7 = imageLayers.f1(element_1.l2()).i4x_1;
          tmp_5 = takeLayersByName(props, tmp_6, (!(tmp_7 == null) ? typeof tmp_7 === 'string' : false) ? tmp_7 : THROW_CCE());
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          destination_1.i2(element_1.l2(), element_1.m2());
        }
      }
      var cells = destination_1;
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_2 = ArrayList_init_$Create$_0(cells.n());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_2 = cells.k2().u();
      while (tmp0_iterator_2.v()) {
        var item = tmp0_iterator_2.x();
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = item.l2();
        // Inline function 'kotlin.collections.component2' call
        var value = item.m2();
        var tmp$ret$23 = readImageContainer$createImageFrameLayer(imageLayers, image, key, value);
        destination_2.r(tmp$ret$23);
      }
      var layerData = destination_2;
      var tmp_8;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!layerData.b1()) {
        // Inline function 'korlibs.time.milliseconds' call
        var this_4 = element_0.m4u_1;
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance_7();
        var tmp$ret$28 = toDuration(this_4, DurationUnit_MILLISECONDS_getInstance());
        tmp_8 = new ImageFrame(element_0.k4u_1, tmp$ret$28, layerData);
      } else {
        tmp_8 = new ImageFrame(element_0.k4u_1);
      }
      var tmp0_safe_receiver = tmp_8;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.r(tmp0_safe_receiver);
      }
    }
    var frames = destination_0;
    // Inline function 'kotlin.collections.map' call
    var this_5 = image.t4v_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_5, 10));
    var tmp0_iterator_3 = this_5.u();
    while (tmp0_iterator_3.v()) {
      var item_0 = tmp0_iterator_3.x();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var framesRange = slice(frames, numberRangeToNumber(clamp(item_0.i4v_1, 0, frames.n()), clamp(item_0.j4v_1, 0, frames.n() - 1 | 0)));
      var tmp$ret$33 = new ImageAnimation(framesRange, item_0.o4v_1, item_0.m4v_1);
      destination_3.r(tmp$ret$33);
    }
    var animations = destination_3;
    var defaultData = new ImageData(frames, VOID, imageWidth, imageHeight, imageLayersToProcess, animations);
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_6 = image.u4v_1;
    var destination_4 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_4 = this_6.u();
    while (tmp0_iterator_4.v()) {
      var element_2 = tmp0_iterator_4.x();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      element_2.g4v();
      var tmp$ret$36;
      $l$block: {
        // Inline function 'kotlin.collections.maxOfOrNull' call
        var iterator = element_2.f4v_1.u();
        if (!iterator.v()) {
          tmp$ret$36 = null;
          break $l$block;
        }
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var maxValue = iterator.x().m4s_1;
        while (iterator.v()) {
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var v = iterator.x().m4s_1;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }
        tmp$ret$36 = maxValue;
      }
      var tmp0_elvis_lhs = tmp$ret$36;
      var maxWidth = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var tmp$ret$39;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxOfOrNull' call
        var iterator_0 = element_2.f4v_1.u();
        if (!iterator_0.v()) {
          tmp$ret$39 = null;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var maxValue_0 = iterator_0.x().n4s_1;
        while (iterator_0.v()) {
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var v_0 = iterator_0.x().n4s_1;
          if (compareTo(maxValue_0, v_0) < 0) {
            maxValue_0 = v_0;
          }
        }
        tmp$ret$39 = maxValue_0;
      }
      var tmp1_elvis_lhs = tmp$ret$39;
      var maxHeight = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_7 = image.s4v_1;
      var destination_5 = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_5 = this_7.u();
      while (tmp0_iterator_5.v()) {
        var element_3 = tmp0_iterator_5.x();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var sliceKey = element_2.h4v(element_3.k4u_1);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_8 = toLinkedMap(element_3.n4u_1);
        var destination_6 = LinkedHashMap_init_$Create$();
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_6 = this_8.k2().u();
        while (tmp0_iterator_6.v()) {
          var element_4 = tmp0_iterator_6.x();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          var shouldProcess_1 = get_onlyReadVisibleLayers(props) ? imageLayers.f1(element_4.l2()).c4u_1 : true;
          var tmp_9;
          if (shouldProcess_1) {
            var tmp_10 = ASE_getInstance();
            var tmp_11 = imageLayers.f1(element_4.l2()).i4x_1;
            tmp_9 = takeLayersByName(props, tmp_10, (!(tmp_11 == null) ? typeof tmp_11 === 'string' : false) ? tmp_11 : THROW_CCE());
          } else {
            tmp_9 = false;
          }
          if (tmp_9) {
            destination_6.i2(element_4.l2(), element_4.m2());
          }
        }
        var cells_0 = destination_6;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_7 = ArrayList_init_$Create$_0(cells_0.n());
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_7 = cells_0.k2().u();
        while (tmp0_iterator_7.v()) {
          var item_1 = tmp0_iterator_7.x();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.component1' call
          var key_0 = item_1.l2();
          // Inline function 'kotlin.collections.component2' call
          var value_0 = item_1.m2();
          var tmp$ret$49 = readImageContainer$createImageFrameLayer(imageLayers, image, key_0, value_0);
          destination_7.r(tmp$ret$49);
        }
        // Inline function 'kotlin.collections.mapTo' call
        var destination_8 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_7, 10));
        var tmp0_iterator_8 = destination_7.u();
        while (tmp0_iterator_8.v()) {
          var item_2 = tmp0_iterator_8.x();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          var sliceKeyFrame = sliceKey.u4s_1;
          var sliceFrame = new RectangleI(sliceKeyFrame.x2l_1 - item_2.l4x_1 | 0, sliceKeyFrame.y2l_1 - item_2.m4x_1 | 0, sliceKeyFrame.z2l_1, sliceKeyFrame.a2m_1);
          var sslice = item_2.t4x_1.f2y(sliceFrame, item_2.t4x_1.q2w_1);
          var ninePatchSlice = element_2.c4v_1 ? asNinePatchSimple(sslice, sliceKey.o4s_1, sliceKey.p4s_1, sliceKey.o4s_1 + sliceKey.q4s_1 | 0, sliceKey.p4s_1 + sliceKey.r4s_1 | 0) : null;
          var tmp$ret$52 = new ImageFrameLayer(item_2.k4x_1, sslice, (useSlicePosition(props, ASE_getInstance()) ? sliceKeyFrame.x2l_1 : item_2.l4x_1) - sliceKey.s4s_1 | 0, (useSlicePosition(props, ASE_getInstance()) ? sliceKeyFrame.y2l_1 : item_2.m4x_1) - sliceKey.t4s_1 | 0, item_2.n4x_1, item_2.o4x_1, VOID, ninePatchSlice);
          destination_8.r(tmp$ret$52);
        }
        var layerData_0 = destination_8;
        var tmp_12;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!layerData_0.b1()) {
          // Inline function 'korlibs.time.milliseconds' call
          var this_9 = element_3.m4u_1;
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance_7();
          var tmp$ret$57 = toDuration(this_9, DurationUnit_MILLISECONDS_getInstance());
          tmp_12 = new ImageFrame(element_3.k4u_1, tmp$ret$57, layerData_0);
        } else {
          tmp_12 = null;
        }
        var tmp0_safe_receiver_0 = tmp_12;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_5.r(tmp0_safe_receiver_0);
        }
      }
      var frames_0 = destination_5;
      var tmp_13;
      var tmp_14;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!frames_0.b1()) {
        tmp_14 = slicingEnabled(props, ASE_getInstance());
      } else {
        tmp_14 = false;
      }
      if (tmp_14) {
        // Inline function 'kotlin.collections.map' call
        var this_10 = image.t4v_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_9 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_10, 10));
        var tmp0_iterator_9 = this_10.u();
        while (tmp0_iterator_9.v()) {
          var item_3 = tmp0_iterator_9.x();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var framesRange_0 = slice(frames_0, numberRangeToNumber(clamp(item_3.i4v_1, 0, frames_0.n()), clamp(item_3.j4v_1, 0, frames_0.n() - 1 | 0)));
          var tmp$ret$63 = new ImageAnimation(framesRange_0, item_3.o4v_1, item_3.m4v_1);
          destination_9.r(tmp$ret$63);
        }
        var animations_0 = destination_9;
        tmp_13 = new ImageData(frames_0, VOID, maxWidth, maxHeight, imageLayersToProcess, animations_0, element_2.b4v_1);
      } else {
        tmp_13 = null;
      }
      var tmp0_safe_receiver_1 = tmp_13;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_4.r(tmp0_safe_receiver_1);
      }
    }
    var datas = destination_4;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator_10 = imageLayersToProcess.u();
    while (tmp0_iterator_10.v()) {
      var item_4 = tmp0_iterator_10.x();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      item_4.h4x_1 = checkIndexOverflow(tmp1);
    }
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp_15;
    if (datas.b1()) {
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      tmp_15 = listOf_0(defaultData);
    } else {
      tmp_15 = datas;
    }
    var tmp$ret$71 = tmp_15;
    return new ImageDataContainer(tmp$ret$71);
  };
  protoOf(ASE).g4x = function (_this__u8e3s4) {
    return _RGBA___init__impl__lqpay5(readS32LE_0(_this__u8e3s4));
  };
  protoOf(ASE).f4x = function (_this__u8e3s4) {
    return _Fixed32___init__impl__8jizkq(readS32LE_0(_this__u8e3s4));
  };
  protoOf(ASE).o4w = function (_this__u8e3s4) {
    return readString_0(_this__u8e3s4, readU16LE_0(_this__u8e3s4));
  };
  var ASE_instance;
  function ASE_getInstance() {
    if (ASE_instance == null)
      new ASE();
    return ASE_instance;
  }
  function _Fixed32___init__impl__8jizkq(value) {
    return value;
  }
  function _Fixed32___get_double__impl__wjoyf6($this) {
    throw new NotImplementedError();
  }
  function onlyReadVisibleLayers$delegate$lambda() {
    _init_properties_ASE_kt__16anup();
    return true;
  }
  function onlyReadVisibleLayers$factory() {
    return getPropertyCallableRef('onlyReadVisibleLayers', 1, KMutableProperty1, function (receiver) {
      return get_onlyReadVisibleLayers(receiver);
    }, function (receiver, value) {
      return set_onlyReadVisibleLayers(receiver, value);
    });
  }
  function onlyReadVisibleLayers$factory_0() {
    return getPropertyCallableRef('onlyReadVisibleLayers', 1, KMutableProperty1, function (receiver) {
      return get_onlyReadVisibleLayers(receiver);
    }, function (receiver, value) {
      return set_onlyReadVisibleLayers(receiver, value);
    });
  }
  var properties_initialized_ASE_kt_jtvwzh;
  function _init_properties_ASE_kt__16anup() {
    if (!properties_initialized_ASE_kt_jtvwzh) {
      properties_initialized_ASE_kt_jtvwzh = true;
      // Inline function 'korlibs.datastructure.extraProperty' call
      var default_0 = onlyReadVisibleLayers$delegate$lambda;
      onlyReadVisibleLayers$delegate = new Property(null, default_0);
    }
  }
  var DataFormat_UBYTE_instance;
  var DataFormat_STRING_instance;
  var DataFormat_USHORT_instance;
  var DataFormat_ULONG_instance;
  var DataFormat_URATIO_instance;
  var DataFormat_SBYTE_instance;
  var DataFormat_UNDEFINED_instance;
  var DataFormat_SSHORT_instance;
  var DataFormat_SLONG_instance;
  var DataFormat_SRATIO_instance;
  var DataFormat_SFLOAT_instance;
  var DataFormat_DFLOAT_instance;
  var DataFormat_UNKNOWN_instance;
  function Companion_25() {
    Companion_instance_33 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_4();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.g4y_1;
      destination.i2(tmp$ret$0, element);
    }
    tmp.i4y_1 = destination;
  }
  protoOf(Companion_25).f1 = function (index) {
    var tmp0_elvis_lhs = this.i4y_1.s2(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  };
  var Companion_instance_33;
  function Companion_getInstance_40() {
    DataFormat_initEntries();
    if (Companion_instance_33 == null)
      new Companion_25();
    return Companion_instance_33;
  }
  function values_4() {
    return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
  }
  function EXIF$DataFormat$lambda(it) {
    return it;
  }
  function EXIF$DataFormat$lambda_0(it) {
    return 4;
  }
  function EXIF$DataFormat$lambda_1(it) {
    return imul(it, 2);
  }
  function EXIF$DataFormat$lambda_2(it) {
    return imul(it, 4);
  }
  function EXIF$DataFormat$lambda_3(it) {
    return imul(it, 4);
  }
  function EXIF$DataFormat$lambda_4(it) {
    return it;
  }
  function EXIF$DataFormat$lambda_5(it) {
    return it;
  }
  function EXIF$DataFormat$lambda_6(it) {
    return imul(it, 2);
  }
  function EXIF$DataFormat$lambda_7(it) {
    return imul(it, 4);
  }
  function EXIF$DataFormat$lambda_8(it) {
    return imul(it, 4);
  }
  function EXIF$DataFormat$lambda_9(it) {
    return imul(it, 4);
  }
  function EXIF$DataFormat$lambda_10(it) {
    return imul(it, 8);
  }
  function EXIF$DataFormat$lambda_11(it) {
    return 0;
  }
  var DataFormat_entriesInitialized;
  function DataFormat_initEntries() {
    if (DataFormat_entriesInitialized)
      return Unit_instance;
    DataFormat_entriesInitialized = true;
    DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
    DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
    DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
    DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
    DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
    DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
    DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
    DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
    DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
    DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
    DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
    DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
    DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
    Companion_getInstance_40();
  }
  function DataFormat(name, ordinal, id, indexBytes) {
    Enum.call(this, name, ordinal);
    this.g4y_1 = id;
    this.h4y_1 = indexBytes;
  }
  function readExifBase$readUShort(data, endian, index) {
    return getU16(data, imul(index, 2), endian.e1p());
  }
  function readExifBase$readInt(data, endian, index) {
    return getS32(data, imul(index, 4), endian.e1p());
  }
  function DataFormat_UBYTE_getInstance() {
    DataFormat_initEntries();
    return DataFormat_UBYTE_instance;
  }
  function DataFormat_STRING_getInstance() {
    DataFormat_initEntries();
    return DataFormat_STRING_instance;
  }
  function DataFormat_USHORT_getInstance() {
    DataFormat_initEntries();
    return DataFormat_USHORT_instance;
  }
  function DataFormat_ULONG_getInstance() {
    DataFormat_initEntries();
    return DataFormat_ULONG_instance;
  }
  function DataFormat_URATIO_getInstance() {
    DataFormat_initEntries();
    return DataFormat_URATIO_instance;
  }
  function DataFormat_SBYTE_getInstance() {
    DataFormat_initEntries();
    return DataFormat_SBYTE_instance;
  }
  function DataFormat_UNDEFINED_getInstance() {
    DataFormat_initEntries();
    return DataFormat_UNDEFINED_instance;
  }
  function DataFormat_SSHORT_getInstance() {
    DataFormat_initEntries();
    return DataFormat_SSHORT_instance;
  }
  function DataFormat_SLONG_getInstance() {
    DataFormat_initEntries();
    return DataFormat_SLONG_instance;
  }
  function DataFormat_SRATIO_getInstance() {
    DataFormat_initEntries();
    return DataFormat_SRATIO_instance;
  }
  function DataFormat_SFLOAT_getInstance() {
    DataFormat_initEntries();
    return DataFormat_SFLOAT_instance;
  }
  function DataFormat_DFLOAT_getInstance() {
    DataFormat_initEntries();
    return DataFormat_DFLOAT_instance;
  }
  function DataFormat_UNKNOWN_getInstance() {
    DataFormat_initEntries();
    return DataFormat_UNKNOWN_instance;
  }
  function $readExifBaseCOROUTINE$50(_this__u8e3s4, ss, info, debug, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r4y_1 = _this__u8e3s4;
    this.s4y_1 = ss;
    this.t4y_1 = info;
    this.u4y_1 = debug;
  }
  protoOf($readExifBaseCOROUTINE$50).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 17;
            this.fd_1 = 1;
            suspendResult = sliceHere(this.s4y_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.v4y_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = readString(this.v4y_1, 2, Charsets_instance.o4z(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.w4y_1 = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (this.w4y_1 === 'MM') {
              tmp_1 = Endian_BIG_ENDIAN_getInstance();
            } else if (this.w4y_1 === 'II') {
              tmp_1 = Endian_LITTLE_ENDIAN_getInstance();
            } else {
              var message = "Not Exif data (not starting with MM or II but '" + this.w4y_1 + "')";
              throw IllegalStateException_init_$Create$(toString(message));
            }

            tmp_0.x4y_1 = tmp_1;
            this.fd_1 = 3;
            suspendResult = readU16(this.v4y_1, this.x4y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.y4y_1 = suspendResult;
            this.fd_1 = 4;
            suspendResult = readS32(this.v4y_1, this.x4y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.z4y_1 = suspendResult;
            this.fd_1 = 5;
            suspendResult = readU16(this.v4y_1, this.x4y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.a4z_1 = suspendResult;
            if (this.u4y_1) {
              var this_0 = this.r4y_1.p4z_1;
              var level = Level_ERROR_getInstance();
              if (this_0.f25(level)) {
                this_0.g25(level, 'nDirEntry=' + this.a4z_1 + ', tagMark=' + this.y4y_1 + ', offsetFirstFID=' + this.z4y_1);
              }
            }

            this.b4z_1 = until(0, this.a4z_1).u();
            this.fd_1 = 6;
            continue $sm;
          case 6:
            if (!this.b4z_1.v()) {
              this.fd_1 = 16;
              continue $sm;
            }

            this.c4z_1 = this.b4z_1.x();
            this.d4z_1 = this.v4y_1.r4z_1.kb();
            this.fd_1 = 7;
            suspendResult = readU16(this.v4y_1, this.x4y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.e4z_1 = suspendResult;
            this.f4z_1 = Companion_getInstance_40();
            this.fd_1 = 8;
            suspendResult = readU16(this.v4y_1, this.x4y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.g4z_1 = suspendResult;
            this.h4z_1 = this.f4z_1.f1(this.g4z_1);
            this.fd_1 = 9;
            suspendResult = readS32(this.v4y_1, this.x4y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            this.i4z_1 = suspendResult;
            if (this.u4y_1) {
              var this_1 = this.r4y_1.p4z_1;
              var level_0 = Level_ERROR_getInstance();
              if (this_1.f25(level_0)) {
                this_1.g25(level_0, 'tagPos=' + get_hex(this.d4z_1) + ', tagNumber=' + get_hex(this.e4z_1) + ', dataFormat=' + this.h4z_1 + ', nComponent=' + this.i4z_1 + ', size=' + this.h4z_1.h4y_1(this.i4z_1));
              }
            }

            this.fd_1 = 10;
            suspendResult = readBytesExact(this.v4y_1, this.h4z_1.h4y_1(this.i4z_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            this.j4z_1 = suspendResult;
            if (this.u4y_1) {
              if (this.h4z_1.equals(DataFormat_STRING_getInstance())) {
                var tmp_2 = this;
                tmp_2.k4z_1 = this.r4y_1.p4z_1;
                var tmp_3 = this;
                tmp_3.l4z_1 = this.k4z_1;
                var tmp_4 = this;
                tmp_4.m4z_1 = Level_ERROR_getInstance();
                if (this.l4z_1.f25(this.m4z_1)) {
                  this.fd_1 = 11;
                  suspendResult = sliceStart(this.v4y_1, toLong(readExifBase$readInt(this.j4z_1, this.x4y_1, 0)), VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.fd_1 = 13;
                  continue $sm;
                }
              } else {
                this.fd_1 = 14;
                continue $sm;
              }
            } else {
              this.fd_1 = 15;
              continue $sm;
            }

          case 11:
            this.n4z_1 = suspendResult;
            this.fd_1 = 12;
            suspendResult = readStringz(this.n4z_1, this.i4z_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = "  - '" + ARGUMENT + "'";
            this.l4z_1.g25(this.m4z_1, ARGUMENT_0);
            this.fd_1 = 13;
            continue $sm;
          case 13:
            this.fd_1 = 14;
            continue $sm;
          case 14:
            this.fd_1 = 15;
            continue $sm;
          case 15:
            if (this.e4z_1 === 274) {
              var tmp_5;
              switch (readExifBase$readUShort(this.j4z_1, this.x4y_1, 0)) {
                case 1:
                  tmp_5 = Companion_getInstance_0().c2w_1;
                  break;
                case 2:
                  tmp_5 = Companion_getInstance_0().g2w_1;
                  break;
                case 3:
                  tmp_5 = Companion_getInstance_0().e2w_1;
                  break;
                case 4:
                  tmp_5 = Companion_getInstance_0().i2w_1;
                  break;
                case 5:
                  tmp_5 = Companion_getInstance_0().j2w_1;
                  break;
                case 6:
                  tmp_5 = Companion_getInstance_0().d2w_1;
                  break;
                case 7:
                  tmp_5 = Companion_getInstance_0().h2w_1;
                  break;
                case 8:
                  tmp_5 = Companion_getInstance_0().f2w_1;
                  break;
                default:
                  tmp_5 = Companion_getInstance_0().c2w_1;
                  break;
              }
              set_orientation(this.t4y_1, tmp_5);
            }

            skipToAlign(this.v4y_1, 4, 2);
            this.fd_1 = 6;
            continue $sm;
          case 16:
            return this.t4y_1;
          case 17:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 17) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function EXIF() {
    EXIF_instance = this;
    this.p4z_1 = Companion_getInstance_6().r24('EXIF');
  }
  protoOf(EXIF).w4z = function (ss, info, debug, $completion) {
    var tmp = new $readExifBaseCOROUTINE$50(this, ss, info, debug, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(EXIF).x4z = function (ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.w4z(ss, info, debug, $completion) : $super.w4z.call(this, ss, info, debug, $completion);
  };
  var EXIF_instance;
  function EXIF_getInstance() {
    if (EXIF_instance == null)
      new EXIF();
    return EXIF_instance;
  }
  var Direction_ONCE_FORWARD_instance;
  var Direction_ONCE_REVERSE_instance;
  var Direction_FORWARD_instance;
  var Direction_REVERSE_instance;
  var Direction_PING_PONG_instance;
  var Direction_entriesInitialized;
  function Direction_initEntries() {
    if (Direction_entriesInitialized)
      return Unit_instance;
    Direction_entriesInitialized = true;
    Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
    Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
    Direction_FORWARD_instance = new Direction('FORWARD', 2);
    Direction_REVERSE_instance = new Direction('REVERSE', 3);
    Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
  }
  function Direction(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.y4z_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).aa = function (a, b) {
    return this.y4z_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.aa(a, b);
  };
  function ImageAnimation$_init_$lambda_bxp50i(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
    var tmp = a.h4x_1;
    // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
    var tmp$ret$1 = b.h4x_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function Direction_ONCE_REVERSE_getInstance() {
    Direction_initEntries();
    return Direction_ONCE_REVERSE_instance;
  }
  function Direction_FORWARD_getInstance() {
    Direction_initEntries();
    return Direction_FORWARD_instance;
  }
  function Direction_REVERSE_getInstance() {
    Direction_initEntries();
    return Direction_REVERSE_instance;
  }
  function Direction_PING_PONG_getInstance() {
    Direction_initEntries();
    return Direction_PING_PONG_instance;
  }
  function ImageAnimation(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = frames.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var list = element.b50_1;
        addAll(destination, list);
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_0 = destination.u();
      while (tmp0_iterator_0.v()) {
        var item = tmp0_iterator_0.x();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var tmp$ret$3 = item.k4x_1;
        destination_0.r(tmp$ret$3);
      }
      var this_0 = distinct(destination_0);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_0);
      tmp = sortedWith(this_0, tmp$ret$6);
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.e50_1 = frames;
    this.f50_1 = direction;
    this.g50_1 = name;
    this.h50_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull_0(this.e50_1);
    tmp_1.i50_1 = tmp0_elvis_lhs == null ? new ImageFrame(0) : tmp0_elvis_lhs;
  }
  var info$delegate;
  function Companion_26() {
  }
  protoOf(Companion_26).j50 = function (simple) {
    return new ImageData(listOf_0(Companion_instance_36.k50(simple)));
  };
  var Companion_instance_34;
  function Companion_getInstance_41() {
    return Companion_instance_34;
  }
  function sam$kotlin_Comparator$0_1(function_0) {
    this.l50_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_1).aa = function (a, b) {
    return this.l50_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
    return this.aa(a, b);
  };
  function ImageData$framesSortedByPriority$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
    var tmp;
    if (b.n50()) {
      tmp = IntCompanionObject_instance.MAX_VALUE;
    } else {
      tmp = imul(imul(b.m50().t39_1, b.m50().u39_1), imul(b.m50().v39_1, b.m50().v39_1));
    }
    var tmp_0 = tmp;
    // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
    var tmp_1;
    if (a.n50()) {
      tmp_1 = IntCompanionObject_instance.MAX_VALUE;
    } else {
      tmp_1 = imul(imul(a.m50().t39_1, a.m50().u39_1), imul(a.m50().v39_1, a.m50().v39_1));
    }
    var tmp$ret$1 = tmp_1;
    return compareValues(tmp_0, tmp$ret$1);
  }
  function ImageData(frames, loopCount, width, height, layers, animations, name) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp0_safe_receiver = firstOrNull_0(frames);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1q();
      tmp = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp2_safe_receiver = firstOrNull_0(frames);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.y1q();
      tmp_0 = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.o50_1 = frames;
    this.p50_1 = loopCount;
    this.q50_1 = width;
    this.r50_1 = height;
    this.s50_1 = layers;
    this.t50_1 = animations;
    this.u50_1 = name;
    this.v50_1 = new Mixin();
    this.w50_1 = new ImageAnimation(this.o50_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.t50_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.image.format.ImageData.animationsByName.<anonymous>' call
      var tmp$ret$0 = element.g50_1;
      destination.i2(tmp$ret$0, element);
    }
    tmp_1.x50_1 = destination;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = this.o50_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap_init_$Create$_0(capacity_0);
    var tmp0_iterator_0 = this_1.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.x();
      // Inline function 'korlibs.image.format.ImageData.framesByName.<anonymous>' call
      var tmp$ret$3 = element_0.zb();
      destination_0.i2(tmp$ret$3, element_0);
    }
    tmp_2.y50_1 = destination_0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_2 = this.o50_1;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_1(tmp_4);
    tmp_3.z50_1 = sortedWith(this_2, tmp$ret$6);
  }
  protoOf(ImageData).h23 = function (_set____db54di) {
    this.v50_1.h23(_set____db54di);
  };
  protoOf(ImageData).i23 = function () {
    return this.v50_1.i23();
  };
  protoOf(ImageData).a51 = function () {
    var tmp0_safe_receiver = firstOrNull_0(this.z50_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m50();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('No bitmap found');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ImageData).toString = function () {
    return 'ImageData(' + this.o50_1 + ')';
  };
  function packInMutableAtlas(_this__u8e3s4, mutableAtlas) {
    _init_properties_ImageData_kt__fnvt4j();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = _this__u8e3s4.b51_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = this_0.f1(tmp0);
      packInMutableAtlas_0(it, mutableAtlas);
    }
    return _this__u8e3s4;
  }
  function packInMutableAtlas_0(_this__u8e3s4, mutableAtlas) {
    _init_properties_ImageData_kt__fnvt4j();
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = _this__u8e3s4.o50_1;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
      var list = element.b50_1;
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = destination.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.x();
      // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
      if (element_0.o4x_1) {
        destination_0.r(element_0);
      }
    }
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = packInMutableAtlas$lambda;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_2(tmp);
    var frameLayers = sortedWith(destination_0, tmp$ret$6);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < frameLayers.n()) {
      // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var frameLayer = frameLayers.f1(tmp0);
      frameLayer.e51(mutableAtlas.q39(frameLayer.t4x_1, Unit_instance, frameLayer.t4x_1.q2w_1).d39_1);
    }
    return _this__u8e3s4;
  }
  function sam$kotlin_Comparator$0_2(function_0) {
    this.f51_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_2).aa = function (a, b) {
    return this.f51_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_2).compare = function (a, b) {
    return this.aa(a, b);
  };
  function info$delegate$lambda() {
    _init_properties_ImageData_kt__fnvt4j();
    return null;
  }
  function packInMutableAtlas$lambda(a, b) {
    _init_properties_ImageData_kt__fnvt4j();
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
    var tmp = b.e2m();
    // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
    var tmp$ret$1 = a.e2m();
    return compareValues(tmp, tmp$ret$1);
  }
  var properties_initialized_ImageData_kt_3o5pbp;
  function _init_properties_ImageData_kt__fnvt4j() {
    if (!properties_initialized_ImageData_kt_3o5pbp) {
      properties_initialized_ImageData_kt_3o5pbp = true;
      info$delegate = new Property(VOID, info$delegate$lambda);
    }
  }
  function ImageDataContainer(imageDatas) {
    this.b51_1 = imageDatas;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.b51_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.image.format.ImageDataContainer.imageDatasByName.<anonymous>' call
      var tmp$ret$0 = element.u50_1;
      destination.i2(tmp$ret$0, element);
    }
    tmp.c51_1 = destination;
    var tmp_0 = this;
    var tmp0_elvis_lhs = this.c51_1.s2(null);
    tmp_0.d51_1 = tmp0_elvis_lhs == null ? first_0(this.b51_1) : tmp0_elvis_lhs;
  }
  protoOf(ImageDataContainer).g51 = function (name) {
    return this.c51_1.s2(name);
  };
  function Companion_27() {
    Companion_instance_35 = this;
    this.i3w_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.j3w_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.k3w_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
  var Companion_instance_35;
  function Companion_getInstance_42() {
    if (Companion_instance_35 == null)
      new Companion_27();
    return Companion_instance_35;
  }
  function ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_42();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.s4w_1 = filename;
    this.t4w_1 = width;
    this.u4w_1 = height;
    this.v4w_1 = premultiplied;
    this.w4w_1 = asumePremultiplied;
    this.x4w_1 = requestedMaxSize;
    this.y4w_1 = debug;
    this.z4w_1 = preferKotlinDecoder;
    this.a4x_1 = tryNativeDecode;
    this.b4x_1 = format;
    this.c4x_1 = out;
    this.d4x_1 = extra;
  }
  protoOf(ImageDecodingProps).h23 = function (_set____db54di) {
    this.d4x_1 = _set____db54di;
  };
  protoOf(ImageDecodingProps).i23 = function () {
    return this.d4x_1;
  };
  protoOf(ImageDecodingProps).x4x = function () {
    return this;
  };
  protoOf(ImageDecodingProps).e4x = function () {
    var tmp0_elvis_lhs = this.v4w_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  };
  protoOf(ImageDecodingProps).h51 = function () {
    var tmp0_elvis_lhs = this.b4x_1;
    return tmp0_elvis_lhs == null ? get_RegisteredImageFormats() : tmp0_elvis_lhs;
  };
  protoOf(ImageDecodingProps).i51 = function (filename) {
    return this.j51(filename);
  };
  protoOf(ImageDecodingProps).k51 = function (file) {
    return this.i51(get_baseName(file));
  };
  protoOf(ImageDecodingProps).l51 = function (filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  };
  protoOf(ImageDecodingProps).j51 = function (filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.s4w_1 : filename;
    width = width === VOID ? this.t4w_1 : width;
    height = height === VOID ? this.u4w_1 : height;
    premultiplied = premultiplied === VOID ? this.v4w_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.w4w_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.x4w_1 : requestedMaxSize;
    debug = debug === VOID ? this.y4w_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.z4w_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.a4x_1 : tryNativeDecode;
    format = format === VOID ? this.b4x_1 : format;
    out = out === VOID ? this.c4x_1 : out;
    extra = extra === VOID ? this.d4x_1 : extra;
    return $super === VOID ? this.l51(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.l51.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  };
  protoOf(ImageDecodingProps).toString = function () {
    return 'ImageDecodingProps(filename=' + this.s4w_1 + ', width=' + this.t4w_1 + ', height=' + this.u4w_1 + ', premultiplied=' + this.v4w_1 + ', asumePremultiplied=' + this.w4w_1 + ', requestedMaxSize=' + this.x4w_1 + ', debug=' + this.y4w_1 + ', preferKotlinDecoder=' + this.z4w_1 + ', tryNativeDecode=' + this.a4x_1 + ', format=' + this.b4x_1 + ', out=' + this.c4x_1 + ', extra=' + this.d4x_1 + ')';
  };
  protoOf(ImageDecodingProps).hashCode = function () {
    var result = getStringHashCode(this.s4w_1);
    result = imul(result, 31) + (this.t4w_1 == null ? 0 : this.t4w_1) | 0;
    result = imul(result, 31) + (this.u4w_1 == null ? 0 : this.u4w_1) | 0;
    result = imul(result, 31) + (this.v4w_1 == null ? 0 : getBooleanHashCode(this.v4w_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w4w_1) | 0;
    result = imul(result, 31) + (this.x4w_1 == null ? 0 : this.x4w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y4w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z4w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a4x_1) | 0;
    result = imul(result, 31) + (this.b4x_1 == null ? 0 : hashCode(this.b4x_1)) | 0;
    result = imul(result, 31) + (this.c4x_1 == null ? 0 : hashCode(this.c4x_1)) | 0;
    result = imul(result, 31) + (this.d4x_1 == null ? 0 : hashCode(this.d4x_1)) | 0;
    return result;
  };
  protoOf(ImageDecodingProps).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.s4w_1 === tmp0_other_with_cast.s4w_1))
      return false;
    if (!(this.t4w_1 == tmp0_other_with_cast.t4w_1))
      return false;
    if (!(this.u4w_1 == tmp0_other_with_cast.u4w_1))
      return false;
    if (!(this.v4w_1 == tmp0_other_with_cast.v4w_1))
      return false;
    if (!(this.w4w_1 === tmp0_other_with_cast.w4w_1))
      return false;
    if (!(this.x4w_1 == tmp0_other_with_cast.x4w_1))
      return false;
    if (!(this.y4w_1 === tmp0_other_with_cast.y4w_1))
      return false;
    if (!(this.z4w_1 === tmp0_other_with_cast.z4w_1))
      return false;
    if (!(this.a4x_1 === tmp0_other_with_cast.a4x_1))
      return false;
    if (!equals(this.b4x_1, tmp0_other_with_cast.b4x_1))
      return false;
    if (!equals(this.c4x_1, tmp0_other_with_cast.c4x_1))
      return false;
    if (!equals(this.d4x_1, tmp0_other_with_cast.d4x_1))
      return false;
    return true;
  };
  function ImageFormat$decodingProps$delegate$lambda(this$0) {
    return function () {
      return toProps(this$0);
    };
  }
  function $decodeCOROUTINE$55(_this__u8e3s4, file, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u51_1 = _this__u8e3s4;
    this.v51_1 = file;
    this.w51_1 = props;
  }
  protoOf($decodeCOROUTINE$55).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.v51_1.x51(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return this.u51_1.y4x(ARGUMENT, this.w51_1.k51(this.v51_1));
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function ImageFormat(exts) {
    var tmp = this;
    tmp.p4l_1 = lazy(ImageFormat$decodingProps$delegate$lambda(this));
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.ImageFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.r(tmp$ret$3);
    }
    tmp_0.q4l_1 = toSet(destination);
  }
  protoOf(ImageFormat).x4x = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p4l_1;
    decodingProps$factory();
    return this_0.m2();
  };
  protoOf(ImageFormat).m4w = function (s, props) {
    return new ImageDataContainer(listOf_0(this.w4x(s, props)));
  };
  protoOf(ImageFormat).w4x = function (s, props) {
    throw new NotImplementedError();
  };
  protoOf(ImageFormat).z4v = function (s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>' call
      var bmp = this.y4x(s, props);
      // Inline function 'kotlin.apply' call
      var this_0 = new ImageInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>.<anonymous>' call
      this_0.j4w_1 = bmp.t39_1;
      this_0.k4w_1 = bmp.u39_1;
      this_0.l4w_1 = bmp.v39_1;
      tmp = this_0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(ImageFormat).y4x = function (s, props) {
    return this.w4x(s, props).a51();
  };
  protoOf(ImageFormat).z4x = function (s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.check.<anonymous>' call
      tmp = !(this.z4v(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  };
  protoOf(ImageFormat).a4y = function (s, props) {
    return this.y4x(s, props);
  };
  protoOf(ImageFormat).r4l = function (s, props, $super) {
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    return $super === VOID ? this.a4y(s, props) : $super.a4y.call(this, s, props);
  };
  protoOf(ImageFormat).b4y = function (data, props) {
    return this.y4x(openSync(data), props);
  };
  protoOf(ImageFormat).d4y = function (data, props, $completion) {
    return this.b4y(data, props);
  };
  protoOf(ImageFormat).c4y = function (file, props, $completion) {
    var tmp = new $decodeCOROUTINE$55(this, file, props, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(ImageFormat).toString = function () {
    return 'ImageFormat(' + this.q4l_1 + ')';
  };
  function toProps(_this__u8e3s4, props) {
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    return props.j51(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
  }
  function ImageDecoderNotFoundException() {
  }
  function ImageFormatWithContainer(exts) {
    ImageFormat.call(this, exts.slice());
  }
  protoOf(ImageFormatWithContainer).m4w = function (s, props) {
    throw new NotImplementedError();
  };
  protoOf(ImageFormatWithContainer).w4x = function (s, props) {
    return first_0(this.m4w(s, props).b51_1);
  };
  function decodingProps$factory() {
    return getPropertyCallableRef('decodingProps', 1, KProperty1, function (receiver) {
      return receiver.x4x();
    }, null);
  }
  function ImageFormats_init_$Init$(formats, $this) {
    ImageFormats.call($this, toList_1(formats));
    return $this;
  }
  function $decodeSuspendCOROUTINE$60(_this__u8e3s4, data, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g52_1 = _this__u8e3s4;
    this.h52_1 = data;
    this.i52_1 = props;
  }
  protoOf($decodeSuspendCOROUTINE$60).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 7;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.k52_1 = this.g52_1;
            var tmp_1 = this;
            tmp_1.l52_1 = openSync(this.h52_1);
            var tmp_2 = this;
            tmp_2.m52_1 = this.i52_1;
            this.n52_1 = this.k52_1.v52().u();
            this.fd_1 = 2;
            continue $sm;
          case 2:
            if (!this.n52_1.v()) {
              this.fd_1 = 5;
              continue $sm;
            }

            this.o52_1 = this.n52_1.x();
            if (this.o52_1.z4x(sliceStart_0(this.l52_1), this.m52_1)) {
              var tmp_3 = this;
              tmp_3.p52_1 = this.o52_1;
              var tmp_4 = this;
              tmp_4.q52_1 = sliceStart_0(this.l52_1);
              var tmp_5 = this;
              tmp_5.r52_1 = this.m52_1;
              this.fd_1 = 4;
              suspendResult = this.p52_1.d4y(this.h52_1, this.r52_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 3;
              continue $sm;
            }

          case 3:
            this.fd_1 = 2;
            continue $sm;
          case 4:
            this.j52_1 = suspendResult;
            this.fd_1 = 6;
            continue $sm;
          case 5:
            throw UnsupportedOperationException_init_$Create$('No suitable image format : MAGIC:' + readString_0(sliceStart_0(this.l52_1), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes_0(sliceStart_0(this.l52_1), 4)) + ') (' + toString_3(readBytes_0(sliceStart_0(this.l52_1), 4), ASCII_getInstance()) + ')');
          case 6:
            return this.j52_1;
          case 7:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 7) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function ImageFormats(formats) {
    ImageFormat.call(this, ['']);
    this.u52_1 = KorAtomicRef_0(minus(listFormats(formats), this));
  }
  protoOf(ImageFormats).w52 = function (_set____db54di) {
    var this_0 = this.u52_1;
    _formats$factory();
    this_0.y52(_set____db54di);
    return Unit_instance;
  };
  protoOf(ImageFormats).z52 = function () {
    // Inline function 'korlibs.io.concurrent.atomic.getValue' call
    var this_0 = this.u52_1;
    _formats$factory_0();
    return this_0.m2();
  };
  protoOf(ImageFormats).v52 = function () {
    return this.z52();
  };
  protoOf(ImageFormats).a53 = function (ext) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.v52().u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.image.format.ImageFormats.formatByExtOrNull.<anonymous>' call
        if (element.q4l_1.z(ext)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(ImageFormats).b53 = function (ext) {
    var tmp0_elvis_lhs = this.a53(ext);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.v52();
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.image.format.ImageFormats.formatByExt.<anonymous>' call
        var list = element.q4l_1;
        addAll(destination, list);
      }
      throw UnsupportedOperationException_init_$Create$("Don't know how to generate file for extension '" + ext + "' (supported extensions " + destination + ')');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ImageFormats).toString = function () {
    return 'ImageFormats(' + this.v52().n() + ')' + this.v52();
  };
  protoOf(ImageFormats).z4v = function (s, props) {
    if (this.v52().b1())
      return null;
    var tmp0_iterator = this.v52().u();
    $l$loop_0: while (tmp0_iterator.v()) {
      var format = tmp0_iterator.x();
      var tmp;
      try {
        var tmp1_elvis_lhs = format.z4v(sliceStart_0(s), props);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
      }
      return tmp;
    }
    return null;
  };
  protoOf(ImageFormats).w4x = function (s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var tmp0_iterator = this.v52().u();
      while (tmp0_iterator.v()) {
        var format = tmp0_iterator.x();
        if (format.z4x(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImage.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.w4x(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException_init_$Create$('No suitable image format : MAGIC:' + readString_0(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes_0(sliceStart_0(s), 4)) + ') (' + toString_3(readBytes_0(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  };
  protoOf(ImageFormats).m4w = function (s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var tmp0_iterator = this.v52().u();
      while (tmp0_iterator.v()) {
        var format = tmp0_iterator.x();
        if (format.z4x(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImageContainer.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.m4w(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException_init_$Create$('No suitable image format : MAGIC:' + readString_0(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes_0(sliceStart_0(s), 4)) + ') (' + toString_3(readBytes_0(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  };
  protoOf(ImageFormats).d4y = function (data, props, $completion) {
    var tmp = new $decodeSuspendCOROUTINE$60(this, data, props, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(ImageFormats).c4y = function (file, props, $completion) {
    return this.b53(get_extensionLC_0(file)).c4y(file, props, $completion);
  };
  function listFormats(_this__u8e3s4) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = _this__u8e3s4.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.image.format.listFormats.<anonymous>' call
      var list = listFormats_0(element);
      addAll(destination, list);
    }
    return toMutableSet(destination);
  }
  function listFormats_0(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ImageFormats) {
      tmp = _this__u8e3s4.v52();
    } else {
      tmp = setOf_0(_this__u8e3s4);
    }
    return tmp;
  }
  function _formats$factory() {
    return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
      return receiver.z52();
    }, function (receiver, value) {
      return receiver.w52(value);
    });
  }
  function _formats$factory_0() {
    return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
      return receiver.z52();
    }, function (receiver, value) {
      return receiver.w52(value);
    });
  }
  function ImageFormatsMutable() {
    ImageFormats_init_$Init$([], this);
    this.f53_1 = new NonRecursiveLock();
  }
  protoOf(ImageFormatsMutable).g53 = function (formats) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    this.f53_1;
    this.w52(minus(plus_1(this.z52(), formats), this));
  };
  function Companion_28() {
  }
  protoOf(Companion_28).h53 = function (bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return new ImageFrame(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice_0(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  };
  protoOf(Companion_28).k50 = function (bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.h53(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.h53.call(this, bitmap, new Duration(time), targetX, targetY, main, includeInAtlas, name, index);
  };
  var Companion_instance_36;
  function Companion_getInstance_43() {
    return Companion_instance_36;
  }
  function ImageFrame(index, time, layerData) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    layerData = layerData === VOID ? emptyList() : layerData;
    this.z4z_1 = index;
    this.a50_1 = time;
    this.b50_1 = layerData;
    this.c50_1 = new Mixin();
    this.d50_1 = firstOrNull_0(this.b50_1);
  }
  protoOf(ImageFrame).h23 = function (_set____db54di) {
    this.c50_1.h23(_set____db54di);
  };
  protoOf(ImageFrame).i23 = function () {
    return this.c50_1.i23();
  };
  protoOf(ImageFrame).i53 = function () {
    var tmp0_safe_receiver = this.d50_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t4x_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ImageFrame).j53 = function () {
    var tmp0_safe_receiver = this.d50_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l4x_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ImageFrame).k53 = function () {
    var tmp0_safe_receiver = this.d50_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m4x_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ImageFrame).n50 = function () {
    var tmp0_safe_receiver = this.d50_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n4x_1;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(ImageFrame).l53 = function () {
    return this.a50_1;
  };
  protoOf(ImageFrame).x1q = function () {
    return this.i53().v2w_1;
  };
  protoOf(ImageFrame).y1q = function () {
    return this.i53().w2w_1;
  };
  protoOf(ImageFrame).m50 = function () {
    var tmp0_safe_receiver = this.d50_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m50();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ImageFrame).zb = function () {
    return this.i53().q2w_1;
  };
  protoOf(ImageFrame).toString = function () {
    return 'ImageFrame(' + this.i53() + ', time=' + new Duration(this.a50_1) + ', targetX=' + this.j53() + ', targetY=' + this.k53() + ', main=' + this.n50() + ')';
  };
  function ImageFrameLayer(layer, slice, targetX, targetY, main, includeInAtlas, tilemap, ninePatchSlice) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    ninePatchSlice = ninePatchSlice === VOID ? null : ninePatchSlice;
    this.k4x_1 = layer;
    this.l4x_1 = targetX;
    this.m4x_1 = targetY;
    this.n4x_1 = main;
    this.o4x_1 = includeInAtlas;
    this.p4x_1 = tilemap;
    this.q4x_1 = ninePatchSlice;
    this.r4x_1 = null;
    this.s4x_1 = null;
    this.t4x_1 = slice;
  }
  protoOf(ImageFrameLayer).e51 = function (value) {
    this.t4x_1 = value;
    this.r4x_1 = null;
    this.s4x_1 = null;
  };
  protoOf(ImageFrameLayer).x1q = function () {
    return this.t4x_1.v2w_1;
  };
  protoOf(ImageFrameLayer).y1q = function () {
    return this.t4x_1.w2w_1;
  };
  protoOf(ImageFrameLayer).e2m = function () {
    return this.t4x_1.e2m();
  };
  protoOf(ImageFrameLayer).m50 = function () {
    if (get_bmp(this.t4x_1).t39_1 === this.x1q() ? get_bmp(this.t4x_1).u39_1 === this.y1q() : false)
      return get_bmp(this.t4x_1);
    if (this.r4x_1 == null)
      this.r4x_1 = extract_0(this.t4x_1);
    return ensureNotNull(this.r4x_1);
  };
  function ImageInfo() {
    this.i4w_1 = new Mixin();
    this.j4w_1 = 0;
    this.k4w_1 = 0;
    this.l4w_1 = 8;
  }
  protoOf(ImageInfo).h23 = function (_set____db54di) {
    this.i4w_1.h23(_set____db54di);
  };
  protoOf(ImageInfo).i23 = function () {
    return this.i4w_1.i23();
  };
  protoOf(ImageInfo).toString = function () {
    var tmp = this.j4w_1;
    var tmp_0 = this.k4w_1;
    var tmp_1 = this.l4w_1;
    var tmp0_safe_receiver = this.i23();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + (tmp0_safe_receiver == null ? null : toMap_0(tmp0_safe_receiver)) + ')';
  };
  var Type_NORMAL_instance;
  var Type_GROUP_instance;
  var Type_TILEMAP_instance;
  function Companion_29() {
    Companion_instance_37 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n4w_1 = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
  }
  var Companion_instance_37;
  function Companion_getInstance_44() {
    Type_initEntries();
    if (Companion_instance_37 == null)
      new Companion_29();
    return Companion_instance_37;
  }
  var Type_entriesInitialized;
  function Type_initEntries() {
    if (Type_entriesInitialized)
      return Unit_instance;
    Type_entriesInitialized = true;
    Type_NORMAL_instance = new Type('NORMAL', 0);
    Type_GROUP_instance = new Type('GROUP', 1);
    Type_TILEMAP_instance = new Type('TILEMAP', 2);
    Companion_getInstance_44();
  }
  function Type(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(Type).r4w = function () {
    return this.equals(Type_TILEMAP_getInstance());
  };
  function Type_NORMAL_getInstance() {
    Type_initEntries();
    return Type_NORMAL_instance;
  }
  function Type_GROUP_getInstance() {
    Type_initEntries();
    return Type_GROUP_instance;
  }
  function Type_TILEMAP_getInstance() {
    Type_initEntries();
    return Type_TILEMAP_instance;
  }
  function ImageLayer(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.h4x_1 = index;
    this.i4x_1 = name;
    this.j4x_1 = type;
  }
  function set_orientation(_this__u8e3s4, _set____db54di) {
    _init_properties_ImageOrientation_kt__rodtsl();
    var this_0 = orientation$delegate;
    var property = orientation$factory();
    var tmp = _set____db54di;
    var value = tmp == null ? null : new SliceOrientation(tmp);
    var tmp0_elvis_lhs = this_0.j23_1;
    var tmp_0 = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    // Inline function 'korlibs.datastructure.fastCastTo' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    setExtra(_this__u8e3s4, tmp_0, value);
    return Unit_instance;
  }
  function get_orientation(_this__u8e3s4) {
    _init_properties_ImageOrientation_kt__rodtsl();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'korlibs.datastructure.Property.getValue' call
      var this_0 = orientation$delegate;
      var property = orientation$factory_0();
      // Inline function 'korlibs.datastructure.fastCastTo' call
      var tmp1_safe_receiver = _this__u8e3s4.i23();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs = this_0.j23_1;
        tmp = tmp1_safe_receiver.s13(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      }
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = tmp;
      if (res == null) {
        var r = this_0.k23_1();
        var tmp_0;
        if (!(r == null)) {
          tmp_0 = true;
        } else {
          var tmp2_elvis_lhs = this_0.j23_1;
          tmp_0 = hasExtra(_this__u8e3s4, tmp2_elvis_lhs == null ? property.callableName : tmp2_elvis_lhs);
        }
        if (tmp_0) {
          // Inline function 'korlibs.datastructure.Property.setValue' call
          var tmp0_elvis_lhs_0 = this_0.j23_1;
          var tmp_1 = tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0;
          // Inline function 'korlibs.datastructure.fastCastTo' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          setExtra(_this__u8e3s4, tmp_1, r);
        }
        var tmp_2 = r;
        tmp$ret$6 = tmp_2 == null ? null : tmp_2.l2w_1;
        break $l$block;
      }
      var tmp_3 = res;
      tmp$ret$6 = tmp_3 == null ? null : tmp_3.l2w_1;
    }
    return tmp$ret$6;
  }
  var orientation$delegate;
  function orientation$delegate$lambda() {
    _init_properties_ImageOrientation_kt__rodtsl();
    return null;
  }
  function orientation$factory() {
    return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
      var tmp = get_orientation(receiver);
      return tmp == null ? null : new SliceOrientation(tmp);
    }, function (receiver, value) {
      var tmp = value;
      return set_orientation(receiver, tmp == null ? null : tmp.l2w_1);
    });
  }
  function orientation$factory_0() {
    return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
      var tmp = get_orientation(receiver);
      return tmp == null ? null : new SliceOrientation(tmp);
    }, function (receiver, value) {
      var tmp = value;
      return set_orientation(receiver, tmp == null ? null : tmp.l2w_1);
    });
  }
  var properties_initialized_ImageOrientation_kt_37wzbr;
  function _init_properties_ImageOrientation_kt__rodtsl() {
    if (!properties_initialized_ImageOrientation_kt_37wzbr) {
      properties_initialized_ImageOrientation_kt_37wzbr = true;
      orientation$delegate = new Property(VOID, orientation$delegate$lambda);
    }
  }
  function get_imageLoadingLogger() {
    _init_properties_KorioExt_kt__tiega5();
    return imageLoadingLogger;
  }
  var imageLoadingLogger;
  function readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
    name = name === VOID ? null : name;
    atlas = atlas === VOID ? null : atlas;
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    return readBitmapSlice_0(_this__u8e3s4, props, name, atlas, $completion);
  }
  function readBitmap(_this__u8e3s4, props, $completion) {
    props = props === VOID ? new ImageDecodingProps('file.bin') : props;
    var tmp = new $readBitmapCOROUTINE$61(_this__u8e3s4, props, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readBitmap_0(_this__u8e3s4, props, $completion) {
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    return _readBitmap(_this__u8e3s4, VOID, props.x4x(), $completion);
  }
  function readImageDataContainer(_this__u8e3s4, props, atlas, $completion) {
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    atlas = atlas === VOID ? null : atlas;
    var tmp = new $readImageDataContainerCOROUTINE$62(_this__u8e3s4, props, atlas, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readBitmapSlice_0(_this__u8e3s4, bprops, name, atlas, $completion) {
    name = name === VOID ? null : name;
    atlas = atlas === VOID ? null : atlas;
    var tmp = new $readBitmapSliceCOROUTINE$63(_this__u8e3s4, bprops, name, atlas, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function _readBitmap(file, bytes, props, $completion) {
    file = file === VOID ? null : file;
    bytes = bytes === VOID ? null : bytes;
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    var tmp = new $_readBitmapCOROUTINE$64(file, bytes, props, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function $readBitmapCOROUTINE$61(_this__u8e3s4, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u53_1 = _this__u8e3s4;
    this.v53_1 = props;
  }
  protoOf($readBitmapCOROUTINE$61).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = readAll(this.u53_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.w53_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = _readBitmap(VOID, this.w53_1, this.v53_1.x4x(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readImageDataContainerCOROUTINE$62(_this__u8e3s4, props, atlas, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f54_1 = _this__u8e3s4;
    this.g54_1 = props;
    this.h54_1 = atlas;
  }
  protoOf($readImageDataContainerCOROUTINE$62).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.i54_1 = this.g54_1.x4x().h51();
            this.fd_1 = 1;
            suspendResult = this.f54_1.x51(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var out = this.i54_1.m4w(ARGUMENT, this.g54_1.x4x().k51(this.f54_1));
            return !(this.h54_1 == null) ? packInMutableAtlas(out, this.h54_1) : out;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readBitmapSliceCOROUTINE$63(_this__u8e3s4, bprops, name, atlas, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r54_1 = _this__u8e3s4;
    this.s54_1 = bprops;
    this.t54_1 = name;
    this.u54_1 = atlas;
  }
  protoOf($readBitmapSliceCOROUTINE$63).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = readBitmap_0(this.r54_1, this.s54_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            return !(this.u54_1 == null) ? this.u54_1.r39(result.e3i(), Unit_instance, this.t54_1).d39_1 : slice_0(result, VOID, this.t54_1);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $_readBitmapCOROUTINE$64(file, bytes, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d55_1 = file;
    this.e55_1 = bytes;
    this.f55_1 = props;
  }
  protoOf($_readBitmapCOROUTINE$64).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 8;
            this.g55_1 = !(this.d55_1 == null) ? this.f55_1.k51(this.d55_1) : this.f55_1;
            this.h55_1 = !this.g55_1.a4x_1 ? listOf_0(this.g55_1.b4x_1) : this.g55_1.b4x_1 == null ? listOf_0(null) : this.g55_1.z4w_1 ? listOf([this.g55_1.b4x_1, null]) : listOf([null, this.g55_1.b4x_1]);
            this.i55_1 = null;
            this.j55_1 = this.h55_1.u();
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!this.j55_1.v()) {
              this.fd_1 = 7;
              continue $sm;
            }

            this.k55_1 = this.j55_1.x();
            this.gd_1 = 5;
            var tmp_0 = this;
            var tmp1_elvis_lhs = this.k55_1;
            tmp_0.l55_1 = tmp1_elvis_lhs == null ? get_nativeImageFormatProvider() : tmp1_elvis_lhs;
            if (!(this.e55_1 == null)) {
              this.fd_1 = 3;
              suspendResult = this.l55_1.d4y(this.e55_1, this.g55_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(this.d55_1 == null)) {
                this.fd_1 = 2;
                suspendResult = this.l55_1.c4y(this.d55_1, this.g55_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_1 = this;
                throw new NotImplementedError();
              }
            }

          case 2:
            this.m55_1 = suspendResult;
            this.fd_1 = 4;
            continue $sm;
          case 3:
            this.m55_1 = suspendResult;
            this.fd_1 = 4;
            continue $sm;
          case 4:
            var bmp = this.m55_1;
            if (this.g55_1.w4w_1) {
              asumePremultiplied(bmp);
            }

            return bmp;
          case 5:
            this.gd_1 = 8;
            var tmp_2 = this.id_1;
            if (tmp_2 instanceof Error) {
              var e = this.id_1;
              this.i55_1 = e;
              if (e instanceof CancellationException)
                throw e;
              else {
                var tmp_3;
                if (e instanceof FileNotFoundException) {
                  tmp_3 = true;
                } else {
                  tmp_3 = e instanceof ImageDecoderNotFoundException;
                }
                if (!tmp_3) {
                  var this_0 = get_imageLoadingLogger();
                  var level = Level_INFO_getInstance();
                  if (this_0.f25(level)) {
                    this_0.g25(level, e);
                  }
                }
              }
              this.fd_1 = 6;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 6:
            this.gd_1 = 8;
            this.fd_1 = 1;
            continue $sm;
          case 7:
            throw ensureNotNull(this.i55_1);
          case 8:
            throw this.id_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 8) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  var properties_initialized_KorioExt_kt_kjvlu9;
  function _init_properties_KorioExt_kt__tiega5() {
    if (!properties_initialized_KorioExt_kt_kjvlu9) {
      properties_initialized_KorioExt_kt_kjvlu9 = true;
      imageLoadingLogger = Companion_getInstance_6().r24('ImageLoading');
    }
  }
  function BaseNativeImageFormatProvider() {
    NativeImageFormatProvider.call(this);
  }
  protoOf(BaseNativeImageFormatProvider).v52 = function () {
    return get_RegisteredImageFormats();
  };
  protoOf(BaseNativeImageFormatProvider).n55 = function (data, props, $completion) {
    return this.o55(this.v52().b4y(data, props), props);
  };
  protoOf(BaseNativeImageFormatProvider).p55 = function (bmp) {
    return BitmapNativeImage_init_$Create$(bmp);
  };
  protoOf(BaseNativeImageFormatProvider).o55 = function (bmp, props) {
    var bmp32 = bmp.e3i();
    return new NativeImageResult(this.p55(props.w4w_1 ? asumePremultiplied(bmp32) : props.e4x() ? bmp32.b3l() : bmp32.c3l()));
  };
  protoOf(BaseNativeImageFormatProvider).r3o = function (width, height, premultiplied) {
    return this.p55(new Bitmap32(width, height, VOID, premultiplied == null ? true : premultiplied));
  };
  protoOf(BaseNativeImageFormatProvider).q3o = function (bmp) {
    return this.p55(bmp);
  };
  function NativeImageResult(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.t39_1 : originalWidth;
    originalHeight = originalHeight === VOID ? image.u39_1 : originalHeight;
    this.t55_1 = image;
    this.u55_1 = originalWidth;
    this.v55_1 = originalHeight;
  }
  protoOf(NativeImageResult).toString = function () {
    return 'NativeImageResult(image=' + this.t55_1 + ', originalWidth=' + this.u55_1 + ', originalHeight=' + this.v55_1 + ')';
  };
  protoOf(NativeImageResult).hashCode = function () {
    var result = hashCode(this.t55_1);
    result = imul(result, 31) + this.u55_1 | 0;
    result = imul(result, 31) + this.v55_1 | 0;
    return result;
  };
  protoOf(NativeImageResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.t55_1, tmp0_other_with_cast.t55_1))
      return false;
    if (!(this.u55_1 === tmp0_other_with_cast.u55_1))
      return false;
    if (!(this.v55_1 === tmp0_other_with_cast.v55_1))
      return false;
    return true;
  };
  function BitmapNativeImage_init_$Init$(bitmap, $this) {
    BitmapNativeImage.call($this, bitmap.e3i());
    return $this;
  }
  function BitmapNativeImage_init_$Create$(bitmap) {
    return BitmapNativeImage_init_$Init$(bitmap, objectCreate(protoOf(BitmapNativeImage)));
  }
  function BitmapNativeImage(bitmap) {
    NativeImage.call(this, bitmap.t39_1, bitmap.u39_1, bitmap, bitmap.a3a_1);
    this.k56_1 = bitmap;
    this.l56_1 = this.k56_1.v3a_1;
  }
  protoOf(BitmapNativeImage).zb = function () {
    return 'BitmapNativeImage';
  };
  protoOf(BitmapNativeImage).d3i = function (antialiasing) {
    return this.k56_1.d3i(antialiasing);
  };
  protoOf(BitmapNativeImage).g3a = function () {
    return this.k56_1;
  };
  protoOf(BitmapNativeImage).g3b = function (x, y, width, height, out, offset) {
    return this.k56_1.g3b(x, y, width, height, out, offset);
  };
  protoOf(BitmapNativeImage).i3b = function (x, y, width, height, out, offset) {
    return this.k56_1.i3b(x, y, width, height, out, offset);
  };
  protoOf(BitmapNativeImage).j3b = function (x, y, v) {
    return this.k56_1.j3b(x, y, v);
  };
  protoOf(BitmapNativeImage).h3b = function (x, y) {
    return this.k56_1.h3b(x, y);
  };
  function $decodeInternalCOROUTINE$67(_this__u8e3s4, vfs, path, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u56_1 = _this__u8e3s4;
    this.v56_1 = vfs;
    this.w56_1 = path;
    this.x56_1 = props;
  }
  protoOf($decodeInternalCOROUTINE$67).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = this.v56_1.z56(this.w56_1).a57(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y56_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = this.u56_1.n55(this.y56_1, this.x56_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $decodeSuspendCOROUTINE$71(_this__u8e3s4, data, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j57_1 = _this__u8e3s4;
    this.k57_1 = data;
    this.l57_1 = props;
  }
  protoOf($decodeSuspendCOROUTINE$71).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.j57_1.n55(this.k57_1, this.l57_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.t55_1;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $decodeCOROUTINE$72(_this__u8e3s4, file, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u57_1 = _this__u8e3s4;
    this.v57_1 = file;
    this.w57_1 = props;
  }
  protoOf($decodeCOROUTINE$72).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.u57_1.q55(this.v57_1.y57(), this.v57_1.f4o(), this.w57_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.t55_1;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $decodeCOROUTINE$73(_this__u8e3s4, file, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h58_1 = _this__u8e3s4;
    this.i58_1 = file;
    this.j58_1 = props;
  }
  protoOf($decodeCOROUTINE$73).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = this.i58_1.l58(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.k58_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = this.h58_1.r55(this.k58_1, this.j58_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function NativeImageFormatProvider() {
  }
  protoOf(NativeImageFormatProvider).q55 = function (vfs, path, props, $completion) {
    var tmp = new $decodeInternalCOROUTINE$67(this, vfs, path, props, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(NativeImageFormatProvider).s55 = function (data, props, $completion) {
    var tmp = new $decodeSuspendCOROUTINE$71(this, data, props, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(NativeImageFormatProvider).d4y = function (data, props, $completion) {
    return this.s55(data, props, $completion);
  };
  protoOf(NativeImageFormatProvider).r55 = function (file, props, $completion) {
    var tmp = new $decodeCOROUTINE$72(this, file, props, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(NativeImageFormatProvider).c4y = function (file, props, $completion) {
    var tmp = new $decodeCOROUTINE$73(this, file, props, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(NativeImageFormatProvider).q3o = function (bmp) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.r3o(bmp.t39_1, bmp.u39_1, bmp.a3a_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>' call
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.y39_1;
    if (true) {
      this_0.h3a();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = this_0.d3i(true);
      try {
        // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>.<anonymous>' call
        ctx.m58(bmp, Companion_getInstance_4().d2d_1);
      }finally {
        ctx.f1e();
      }
    }finally {
      result = true ? this_0.z3a(rect) : 0;
    }
    return this_0;
  };
  var Colorspace_GRAYSCALE_instance;
  var Colorspace_RGB_instance;
  var Colorspace_INDEXED_instance;
  var Colorspace_GRAYSCALE_ALPHA_instance;
  var Colorspace_RGBA_instance;
  function Companion_30() {
    Companion_instance_38 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_5();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.p58_1;
      destination.i2(tmp$ret$0, element);
    }
    tmp.r58_1 = destination;
  }
  var Companion_instance_38;
  function Companion_getInstance_45() {
    Colorspace_initEntries();
    if (Companion_instance_38 == null)
      new Companion_30();
    return Companion_instance_38;
  }
  function values_5() {
    return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
  }
  var Colorspace_entriesInitialized;
  function Colorspace_initEntries() {
    if (Colorspace_entriesInitialized)
      return Unit_instance;
    Colorspace_entriesInitialized = true;
    Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
    Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
    Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
    Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
    Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
    Companion_getInstance_45();
  }
  function InterlacedPass(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.s58_1 = startingRow;
    this.t58_1 = startingCol;
    this.u58_1 = rowIncrement;
    this.v58_1 = colIncrement;
    this.w58_1 = blockHeight;
    this.x58_1 = blockWidth;
    var tmp = this;
    // Inline function 'kotlin.math.log2' call
    var x = this.v58_1;
    var tmp$ret$0 = log2(x);
    tmp.y58_1 = numberToInt(tmp$ret$0);
  }
  protoOf(InterlacedPass).toString = function () {
    return 'InterlacedPass(startingRow=' + this.s58_1 + ', startingCol=' + this.t58_1 + ', rowIncrement=' + this.u58_1 + ', colIncrement=' + this.v58_1 + ', blockHeight=' + this.w58_1 + ', blockWidth=' + this.x58_1 + ')';
  };
  protoOf(InterlacedPass).hashCode = function () {
    var result = this.s58_1;
    result = imul(result, 31) + this.t58_1 | 0;
    result = imul(result, 31) + this.u58_1 | 0;
    result = imul(result, 31) + this.v58_1 | 0;
    result = imul(result, 31) + this.w58_1 | 0;
    result = imul(result, 31) + this.x58_1 | 0;
    return result;
  };
  protoOf(InterlacedPass).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.s58_1 === tmp0_other_with_cast.s58_1))
      return false;
    if (!(this.t58_1 === tmp0_other_with_cast.t58_1))
      return false;
    if (!(this.u58_1 === tmp0_other_with_cast.u58_1))
      return false;
    if (!(this.v58_1 === tmp0_other_with_cast.v58_1))
      return false;
    if (!(this.w58_1 === tmp0_other_with_cast.w58_1))
      return false;
    if (!(this.x58_1 === tmp0_other_with_cast.x58_1))
      return false;
    return true;
  };
  function Colorspace(name, ordinal, id, nchannels) {
    Enum.call(this, name, ordinal);
    this.p58_1 = id;
    this.q58_1 = nchannels;
  }
  function Header(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.z58_1 = width;
    this.a59_1 = height;
    this.b59_1 = bitsPerChannel;
    this.c59_1 = colorspace;
    this.d59_1 = compressionmethod;
    this.e59_1 = filtermethod;
    this.f59_1 = interlacemethod;
    var tmp = this;
    var tmp_0;
    switch (this.c59_1.ka_1) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.g59_1 = tmp_0;
    this.h59_1 = imul(imul(this.z58_1, this.g59_1), this.b59_1) / 8 | 0;
  }
  function readCommon($this, s, readHeader, info) {
    var magic = readS32BE_0(s);
    if (!(magic === -1991225785))
      throw IllegalArgumentException_init_$Create$('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
    readS32BE_0(s);
    var pheader = {_v: null};
    var pngdata = ByteArrayBuilder_init_$Create$();
    var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
    var tmp = 0;
    var tmp_0 = new Int8Array(256);
    while (tmp < 256) {
      tmp_0[tmp] = -1;
      tmp = tmp + 1 | 0;
    }
    var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_0);
    var paletteCount = {_v: 0};
    while (!get_eof(s) ? readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata) : false) {
    }
    if (readHeader)
      return pheader._v;
    var tmp0_elvis_lhs = pheader._v;
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('PNG without header!');
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var header = tmp_1;
    var width = header.z58_1;
    var height = header.a59_1;
    var outputSizeHint = imul(imul(1 + width | 0, height), header.g59_1);
    var databb = uncompress_0(pngdata.t37(), Companion_getInstance_59());
    var databbp = 0;
    var context = new DecodingContext(header);
    var bpp = context.i59_1.g59_1;
    var row32 = context.l59_1;
    var tmp_2;
    if (header.g59_1 === 1) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, paletteCount._v);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
        var tmp$ret$1 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_26().r3q(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, item)));
        destination.r(tmp$ret$1);
      }
      tmp_2 = new Bitmap8(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray_0(destination)));
    } else {
      tmp_2 = new Bitmap32(width, height, VOID, false);
    }
    var bmp = tmp_2;
    var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
    var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
    var passes = header.f59_1 === 1 ? $this.q59_1 : $this.r59_1;
    var tmp2_iterator = passes.u();
    while (tmp2_iterator.v()) {
      var pass = tmp2_iterator.x();
      var progression = step(until(pass.s58_1, height), pass.u58_1);
      var inductionVariable = progression.fb_1;
      var last = progression.gb_1;
      var step_0 = progression.hb_1;
      if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
        do {
          var row = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var col = pass.t58_1;
          var colIncrement = pass.v58_1;
          var pixelsInThisRow = width >>> pass.y58_1 | 0;
          var bytesInThisRow = imul(imul(pixelsInThisRow, header.g59_1), header.b59_1) / 8 | 0;
          var tmp4 = databbp;
          databbp = tmp4 + 1 | 0;
          var filter = databb[tmp4] & 255;
          var currentRow = context.k59_1;
          var lastRow = context.j59_1;
          arraycopy_0(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
          databbp = databbp + bytesInThisRow | 0;
          if (!(bmp8 == null)) {
            $this.t59(filter, lastRow, currentRow, header.g59_1);
            switch (header.b59_1) {
              case 1:
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < width)
                  do {
                    var n = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                    var x = col + n | 0;
                    var y = row;
                    var color = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n / 8 | 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                    bmp.d3h(x, y, color);
                  }
                   while (inductionVariable_0 < width);
                break;
              case 2:
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < width)
                  do {
                    var n_0 = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                    var x_0 = col + n_0 | 0;
                    var y_0 = row;
                    var color_0 = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n_0 / 4 | 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                    bmp.d3h(x_0, y_0, color_0);
                  }
                   while (inductionVariable_1 < width);
                break;
              case 4:
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < width)
                  do {
                    var n_1 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                    var x_1 = col + n_1 | 0;
                    var y_1 = row;
                    var color_1 = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n_1 / 2 | 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                    bmp.d3h(x_1, y_1, color_1);
                  }
                   while (inductionVariable_2 < width);
                break;
              case 8:
                bmp8.i3m(col, row, asByteArray(currentRow), width, colIncrement);
                break;
              default:
                // Inline function 'kotlin.error' call

                var message = 'Unsupported header.bitsPerChannel=' + header.b59_1;
                throw IllegalStateException_init_$Create$(toString(message));
            }
          } else if (!(bmp32 == null)) {
            if (header.b59_1 === 8) {
              $this.s59(filter, lastRow, currentRow, bpp, bytesInThisRow);
              switch (bpp) {
                case 3:
                  decode(Companion_getInstance_24(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                  break;
                case 4:
                  decode(Companion_getInstance_26(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                  break;
                default:
                  // Inline function 'kotlin.TODO' call

                  var reason = 'Bytes: ' + bpp;
                  throw new NotImplementedError('An operation is not implemented: ' + reason);
              }
              bmp32.g3l(col, row, row32, width, colIncrement);
            } else {
              // Inline function 'kotlin.error' call
              var message_0 = 'Unsupported header.bitsPerChannel=' + header.b59_1;
              throw IllegalStateException_init_$Create$(toString(message_0));
            }
          }
          context.u59();
        }
         while (!(row === last));
    }
    return bmp;
  }
  function readCommon$default($this, s, readHeader, info, $super) {
    info = info === VOID ? new ImageInfo() : info;
    return readCommon($this, s, readHeader, info);
  }
  function DecodingContext(header) {
    this.i59_1 = header;
    this.j59_1 = _UByteArrayInt___init__impl__xif7bu_0(this.i59_1.h59_1);
    this.k59_1 = _UByteArrayInt___init__impl__xif7bu_0(this.i59_1.h59_1);
    this.l59_1 = Companion_instance_18.i3l(this.i59_1.z58_1);
  }
  protoOf(DecodingContext).u59 = function () {
    var temp = this.k59_1;
    this.k59_1 = this.j59_1;
    this.j59_1 = temp;
  };
  function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
    if (get_eof(_this__u8e3s4))
      return false;
    var length = readS32BE_0(_this__u8e3s4);
    var type = readStringz_0(_this__u8e3s4, 4);
    var data = readStream(_this__u8e3s4, toLong(length));
    var crc = readS32BE_0(_this__u8e3s4);
    switch (type) {
      case 'IHDR':
        // Inline function 'kotlin.run' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>' call

        // Inline function 'kotlin.also' call

        var tmp = readS32BE_0(data);
        var tmp_0 = readS32BE_0(data);
        var tmp_1 = readU8(data);
        var tmp0_elvis_lhs = Companion_getInstance_45().r58_1.s2(readU8(data));
        var this_0 = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8(data), readU8(data), readU8(data));
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>.<anonymous>' call

        $info.j4w_1 = this_0.z58_1;
        $info.k4w_1 = this_0.a59_1;
        $info.l4w_1 = imul(this_0.b59_1, this_0.c59_1.q58_1);
        pheader._v = this_0;
        break;
      case 'PLTE':
        // Inline function 'kotlin.math.max' call

        var a = paletteCount._v;
        var b = data.a().kb() / 3 | 0;
        paletteCount._v = Math.max(a, b);
        data.t1z(asByteArray(rgbPalette), 0, data.a().kb());
        break;
      case 'tRNS':
        // Inline function 'kotlin.math.max' call

        var a_0 = paletteCount._v;
        var b_0 = data.a().kb();
        paletteCount._v = Math.max(a_0, b_0);
        data.t1z(asByteArray(aPalette), 0, data.a().kb());
        break;
      case 'IDAT':
        if ($readHeader) {
          return false;
        }

        pngdata.r37(readAll_0(data));
        break;
      case 'eXIf':
        runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda_0(data, $info, null));
        break;
      case 'IEND':
        return false;
    }
    return true;
  }
  function PNG$readCommon$readChunk$slambda($data, $info, resultContinuation) {
    this.d5a_1 = $data;
    this.e5a_1 = $info;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PNG$readCommon$readChunk$slambda).f5a = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(PNG$readCommon$readChunk$slambda).be = function ($completion) {
    return this.f5a($completion);
  };
  protoOf(PNG$readCommon$readChunk$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = EXIF_getInstance().x4z(openAsync(readAll_0(this.d5a_1)), this.e5a_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(PNG$readCommon$readChunk$slambda).g5a = function (completion) {
    return new PNG$readCommon$readChunk$slambda(this.d5a_1, this.e5a_1, completion);
  };
  function PNG$readCommon$readChunk$slambda_0($data, $info, resultContinuation) {
    var i = new PNG$readCommon$readChunk$slambda($data, $info, resultContinuation);
    var l = function ($completion) {
      return i.f5a($completion);
    };
    l.$arity = 0;
    return l;
  }
  function Colorspace_GRAYSCALE_getInstance() {
    Colorspace_initEntries();
    return Colorspace_GRAYSCALE_instance;
  }
  function Colorspace_RGB_getInstance() {
    Colorspace_initEntries();
    return Colorspace_RGB_instance;
  }
  function Colorspace_INDEXED_getInstance() {
    Colorspace_initEntries();
    return Colorspace_INDEXED_instance;
  }
  function Colorspace_GRAYSCALE_ALPHA_getInstance() {
    Colorspace_initEntries();
    return Colorspace_GRAYSCALE_ALPHA_instance;
  }
  function Colorspace_RGBA_getInstance() {
    Colorspace_initEntries();
    return Colorspace_RGBA_instance;
  }
  function PNG() {
    PNG_instance = this;
    ImageFormat.call(this, ['png']);
    this.o59_1 = -1991225785;
    this.p59_1 = 218765834;
    this.q59_1 = listOf([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    this.r59_1 = listOf_0(new InterlacedPass(0, 0, 1, 1, 1, 1));
  }
  protoOf(PNG).z4v = function (s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  };
  protoOf(PNG).w4x = function (s, props) {
    var tmp = Companion_instance_34;
    var tmp_0 = readCommon$default(this, s, false);
    return tmp.j50(tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE());
  };
  protoOf(PNG).h5a = function (a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return (pa <= pb ? pa <= pc : false) ? a : pb <= pc ? b : c;
  };
  protoOf(PNG).s59 = function (filter, p, c, bpp, size) {
    switch (filter) {
      case 0:
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n, UByteArrayInt__get_impl_px6q8a(c, n) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_0, UByteArrayInt__get_impl_px6q8a(c, n_0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_1, UByteArrayInt__get_impl_px6q8a(c, n_1) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_2, UByteArrayInt__get_impl_px6q8a(c, n_2) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_3, UByteArrayInt__get_impl_px6q8a(c, n_3) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_4, UByteArrayInt__get_impl_px6q8a(c, n_4) + this.h5a(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Filter: ' + filter;
        throw new NotImplementedError('An operation is not implemented: ' + reason);
    }
  };
  protoOf(PNG).t59 = function (filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.s59(filter, p, c, bpp, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.s59.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  };
  var PNG_instance;
  function PNG_getInstance() {
    if (PNG_instance == null)
      new PNG();
    return PNG_instance;
  }
  function get_RegisteredImageFormats() {
    _init_properties_RegisteredImageFormats_kt__dq34zn();
    return RegisteredImageFormats;
  }
  var RegisteredImageFormats;
  var properties_initialized_RegisteredImageFormats_kt_ribwxx;
  function _init_properties_RegisteredImageFormats_kt__dq34zn() {
    if (!properties_initialized_RegisteredImageFormats_kt_ribwxx) {
      properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
      RegisteredImageFormats = new ImageFormatsMutable();
    }
  }
  function sumPacked4MulR(a, b, mul) {
    var dstRB = imul(b & 16711935, mul) >>> 8 | 0;
    var dstGA = imul((b >>> 8 | 0) & 16711935, mul) >>> 8 | 0;
    var r = ((a >>> 0 | 0) & 255) + ((dstRB >>> 0 | 0) & 255) | 0;
    var g = ((a >>> 8 | 0) & 255) + ((dstGA >>> 0 | 0) & 255) | 0;
    var b_0 = ((a >>> 16 | 0) & 255) + ((dstRB >>> 16 | 0) & 255) | 0;
    var a_0 = ((a >>> 24 | 0) & 255) + ((dstGA >>> 16 | 0) & 255) | 0;
    return packIntClamped(r, g, b_0, a_0);
  }
  function f2i(v) {
    return toIntRound_0(clamp01_0(v) * 255);
  }
  function packIntUnchecked(r, g, b, a) {
    return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
  }
  function packIntClamped(r, g, b, a) {
    return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
  }
  function ColorFiller() {
    BaseFiller.call(this);
    this.i5a_1 = _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().n3b_1);
  }
  protoOf(ColorFiller).j5a = function (fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.ColorFiller.set.<anonymous>' call
    this.i5a_1 = _RGBA___get_premultiplied__impl__3bulqc(_RGBA___get_color__impl__8x3sb3(fill));
    return this;
  };
  protoOf(ColorFiller).k5a = function (x, y) {
    return this.i5a_1;
  };
  protoOf(ColorFiller).l5a = function (data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl_sem38t(data, this.i5a_1, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  };
  function Companion_31() {
    this.o5a_1 = 256;
  }
  var Companion_instance_39;
  function Companion_getInstance_46() {
    return Companion_instance_39;
  }
  function _get_fill__d6ivc8($this) {
    var tmp = $this.q5a_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fill');
    }
  }
  function color($this, ratio) {
    return RgbaPremultipliedArray__get_impl_1u69ta($this.p5a_1, numberToInt(clamp01_0(ratio) * 255));
  }
  function GradientFiller() {
    BaseFiller.call(this);
    this.p5a_1 = Companion_instance_21.v3s(256);
  }
  protoOf(GradientFiller).r5a = function (fill, state) {
    fill.s5a(this.p5a_1);
    this.q5a_1 = fill.t5a(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_3().e2f_1.a2h(fill.j4m_1).a2h(state.r3u_1));
    return this;
  };
  protoOf(GradientFiller).u5a = function (x, y) {
    return _get_fill__d6ivc8(this).v5a(Vector2D_init_$Create$_0(x, y));
  };
  protoOf(GradientFiller).k5a = function (x, y) {
    return color(this, this.u5a(x, y));
  };
  function _set_texture__qu271y($this, value) {
    $this.b5b_1 = value;
    $this.x5a_1 = $this.b5b_1.t39_1;
    $this.y5a_1 = $this.b5b_1.u39_1;
    $this.z5a_1 = 1.0 / $this.x5a_1;
    $this.a5b_1 = 1.0 / $this.y5a_1;
  }
  function BitmapFiller() {
    BaseFiller.call(this);
    this.w5a_1 = _CycleMethodPair___init__impl__y6jlco_0(CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_getInstance());
    this.x5a_1 = 0.0;
    this.y5a_1 = 0.0;
    this.z5a_1 = 0.0;
    this.a5b_1 = 0.0;
    var tmp = this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    tmp.b5b_1 = get_bmp(tmp$ret$0);
    this.c5b_1 = Companion_getInstance_3().e2f_1;
    this.d5b_1 = true;
    this.e5b_1 = Companion_getInstance_3().e2f_1;
  }
  protoOf(BitmapFiller).f5b = function (fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.BitmapFiller.set.<anonymous>' call
    this.w5a_1 = _CycleMethodPair___init__impl__y6jlco_0(fill.i5b_1, fill.j5b_1);
    _set_texture__qu271y(this, fill.m5b_1);
    this.c5b_1 = fill.h5b_1;
    this.d5b_1 = fill.k5b_1;
    this.e5b_1 = Companion_getInstance_3().e2f_1.t2g(state.r3u_1).t2g(fill.h5b_1).u2g();
    return this;
  };
  protoOf(BitmapFiller).n5b = function (x, y) {
    return this.b5b_1.f3h(x, y);
  };
  protoOf(BitmapFiller).o5b = function (x, y) {
    return this.b5b_1.k3k(numberToInt(x), numberToInt(y));
  };
  protoOf(BitmapFiller).k5a = function (x, y) {
    var mat = this.e5b_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = Vector2D_init_$Create$_0(x, y);
      if (mat.p2d()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = new Vector2D(mat.w2f(p.g28_1, p.h28_1), mat.z2f(p.g28_1, p.h28_1));
    }
    var this_0 = tmp$ret$0;
    var that = Vector2D_init_$Create$_0(this.z5a_1, this.a5b_1);
    var p_0 = new Vector2D(this_0.g28_1 * that.g28_1, this_0.h28_1 * that.h28_1);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = CycleMethodPair__apply_impl_g3sekg(this.w5a_1, p_0);
    var that_0 = Vector2D_init_$Create$_0(this.x5a_1, this.y5a_1);
    var t = new Vector2D(this_1.g28_1 * that_0.g28_1, this_1.h28_1 * that_0.h28_1);
    return this.d5b_1 ? _RGBA___get_premultiplied__impl__3bulqc(this.n5b(t.g28_1, t.h28_1)) : _RGBA___get_premultiplied__impl__3bulqc(this.o5b(t.g28_1, t.h28_1));
  };
  function BaseFiller() {
  }
  protoOf(BaseFiller).l5a = function (data, offset, x0, x1, y) {
    var yFloat = y;
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(data, offset + n | 0, this.k5a(n, yFloat));
      }
       while (!(n === x1));
  };
  protoOf(BaseFiller).m5a = function (bmp, rect) {
    var cols = _RgbaPremultipliedArray___init__impl__lx83hy(bmp.v3a_1);
    var inductionVariable = rect.t2d();
    var last = rect.u2d();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var offset = imul(y, bmp.t39_1);
        this.l5a(cols, offset, rect.r2d(), rect.s2d() - 1 | 0, y);
      }
       while (inductionVariable < last);
  };
  protoOf(BaseFiller).n5a = function (bmp, rect, $super) {
    rect = rect === VOID ? bmp.x3a_1 : rect;
    var tmp;
    if ($super === VOID) {
      this.m5a(bmp, rect);
      tmp = Unit_instance;
    } else {
      tmp = $super.m5a.call(this, bmp, rect);
    }
    return tmp;
  };
  function NoneFiller() {
    NoneFiller_instance = this;
    BaseFiller.call(this);
  }
  protoOf(NoneFiller).k5a = function (x, y) {
    return _RGBAPremultiplied___init__impl__uos02x(0);
  };
  protoOf(NoneFiller).l5a = function (data, offset, x0, x1, y) {
    return Unit_instance;
  };
  var NoneFiller_instance;
  function NoneFiller_getInstance() {
    if (NoneFiller_instance == null)
      new NoneFiller();
    return NoneFiller_instance;
  }
  function toFiller(_this__u8e3s4, state) {
    var tmp;
    if (_this__u8e3s4 instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (_this__u8e3s4 instanceof RGBA) {
        // Inline function 'kotlin.also' call
        var this_0 = new ColorFiller();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
        this_0.j5a(_this__u8e3s4.b3s_1, state);
        tmp = this_0;
      } else {
        if (_this__u8e3s4 instanceof GradientPaint) {
          // Inline function 'kotlin.also' call
          var this_1 = new GradientFiller();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
          this_1.r5a(_this__u8e3s4, state);
          tmp = this_1;
        } else {
          if (_this__u8e3s4 instanceof BitmapPaint) {
            // Inline function 'kotlin.also' call
            var this_2 = new BitmapFiller();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
            this_2.f5b(_this__u8e3s4, state);
            tmp = this_2;
          } else {
            throw new NotImplementedError();
          }
        }
      }
    }
    return tmp;
  }
  function colorInt(_this__u8e3s4, $this, premultiplied) {
    return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_this__u8e3s4)) : _RGBA___get_value__impl__hhco8v(_this__u8e3s4);
  }
  function _fillColors($this, out, stops, colors, premultiplied) {
    var numberOfStops = stops.n();
    var NCOLORS = out.length;
    switch (numberOfStops) {
      case 0:
      case 1:
        var color = numberOfStops === 0 ? Colors_getInstance().n3d_1 : _RGBA___init__impl__lqpay5(colors.u1s());
        var pcolor = colorInt(color, $this, premultiplied);
        var inductionVariable = 0;
        if (inductionVariable < NCOLORS)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            out[n] = pcolor;
          }
           while (inductionVariable < NCOLORS);
        break;
      default:
        var inductionVariable_0 = 0;
        var last = _fillColors$stopN(stops, NCOLORS, 0);
        if (inductionVariable_0 < last)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out[n_0] = colorInt(_RGBA___init__impl__lqpay5(colors.u1s()), $this, premultiplied);
          }
           while (inductionVariable_0 < last);
        var inductionVariable_1 = 0;
        var last_0 = numberOfStops - 1 | 0;
        if (inductionVariable_1 < last_0)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var stop0 = _fillColors$stopN(stops, NCOLORS, n_1 + 0 | 0);
            var stop1 = _fillColors$stopN(stops, NCOLORS, n_1 + 1 | 0);
            var color0 = _RGBA___init__impl__lqpay5(colors.b1r(n_1 + 0 | 0));
            var color1 = _RGBA___init__impl__lqpay5(colors.b1r(n_1 + 1 | 0));
            var inductionVariable_2 = stop0;
            if (inductionVariable_2 < stop1)
              do {
                var s = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var ratio = _Ratio___init__impl__9mwvn2(s - stop0 | 0, stop1 - stop0 | 0);
                out[s] = colorInt(Companion_getInstance_26().q3s(color0, color1, ratio), $this, premultiplied);
              }
               while (inductionVariable_2 < stop1);
          }
           while (inductionVariable_1 < last_0);
        var inductionVariable_3 = _fillColors$stopN(stops, NCOLORS, numberOfStops - 1 | 0);
        if (inductionVariable_3 < NCOLORS)
          do {
            var n_2 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            out[n_2] = colorInt(_RGBA___init__impl__lqpay5(colors.v1s()), $this, premultiplied);
          }
           while (inductionVariable_3 < NCOLORS);
        break;
    }
  }
  function _fillColors$stopN($stops, NCOLORS, n) {
    return numberToInt($stops.f1(n) * NCOLORS);
  }
  function Companion_32() {
  }
  var Companion_instance_40;
  function Companion_getInstance_47() {
    return Companion_instance_40;
  }
  function colorsToString($this, colors) {
    return '[' + joinToString(new RgbaArray(colors), ', ', VOID, VOID, VOID, VOID, GradientPaint$colorsToString$lambda) + ']';
  }
  function colorsToString_0($this, colors) {
    return colorsToString($this, _RgbaArray___init__impl__oib4y4(colors.x1s()));
  }
  function GradientPaint$colorsToString$lambda(it) {
    return _RGBA___get_hexString__impl__kocngm(it.b3s_1);
  }
  function GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    stops = stops === VOID ? new DoubleArrayList() : stops;
    colors = colors === VOID ? new IntArrayList() : colors;
    cycle = cycle === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycle;
    transform = transform === VOID ? Companion_getInstance_3().e2f_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? GradientInterpolationMethod_NORMAL_getInstance() : interpolationMethod;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    startAngle = startAngle === VOID ? Companion_getInstance_8().u2c_1 : startAngle;
    this.z4l_1 = kind;
    this.a4m_1 = x0;
    this.b4m_1 = y0;
    this.c4m_1 = r0;
    this.d4m_1 = x1;
    this.e4m_1 = y1;
    this.f4m_1 = r1;
    this.g4m_1 = stops;
    this.h4m_1 = colors;
    this.i4m_1 = cycle;
    this.j4m_1 = transform;
    this.k4m_1 = interpolationMethod;
    this.l4m_1 = units;
    this.m4m_1 = startAngle;
    var tmp = this;
    var tmp_0 = Companion_getInstance_3().e2f_1.o2g(-this.a4m_1, -this.b4m_1).i2g(1.0 / clamp_1(Companion_getInstance_4().i2l(this.a4m_1, this.b4m_1, this.d4m_1, this.e4m_1), 1.0, 16000.0));
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_8();
    var x0_0 = this.a4m_1;
    var y0_0 = this.b4m_1;
    var x1_0 = this.d4m_1;
    var y1_0 = this.e4m_1;
    var up = Companion_getInstance_4().h2d_1;
    var tmp$ret$0 = Angle_between(x0_0, y0_0, x1_0, y1_0, up);
    tmp.n4m_1 = tmp_0.c2g(Angle__unaryMinus_impl_7901fr(tmp$ret$0));
    this.o4m_1 = this.j4m_1.u2g();
    this.p4m_1 = Companion_getInstance_3().e2f_1.t2g(this.n4m_1).t2g(this.o4m_1);
    this.q4m_1 = 2 * this.c4m_1 * this.f4m_1;
    this.r4m_1 = this.p5b(this.c4m_1);
    this.s4m_1 = this.p5b(this.f4m_1);
    this.t4m_1 = this.b4m_1 - this.e4m_1;
    this.u4m_1 = this.c4m_1 - this.f4m_1;
    this.v4m_1 = this.a4m_1 - this.d4m_1;
    this.w4m_1 = 1.0 / (this.p5b(this.c4m_1 - this.f4m_1) - this.p5b(this.a4m_1 - this.d4m_1) - this.p5b(this.b4m_1 - this.e4m_1));
  }
  protoOf(GradientPaint).p46 = function () {
    return this.j4m_1;
  };
  protoOf(GradientPaint).s5a = function (out) {
    return _fillColors(Companion_instance_40, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(out), this.g4m_1, this.h4m_1, true);
  };
  protoOf(GradientPaint).x4m = function (stop, color) {
    return this.q5b(stop, color);
  };
  protoOf(GradientPaint).q5b = function (stop, color) {
    this.g4m_1.w1r(stop);
    this.h4m_1.n1s(_RGBA___get_value__impl__hhco8v(color));
    return this;
  };
  protoOf(GradientPaint).v5a = function (p) {
    var tmp;
    switch (this.z4l_1.ka_1) {
      case 2:
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_0 = this.o4m_1;
          if (this_0.p2d()) {
            tmp$ret$0 = p;
            break $l$block;
          }
          tmp$ret$0 = new Vector2D(this_0.w2f(p.g28_1, p.h28_1), this_0.z2f(p.g28_1, p.h28_1));
        }

        var p_0 = tmp$ret$0;
        tmp = Angle__div_impl_ut2btd(Companion_getInstance_4().z2m(new Vector2D(this.a4m_1, this.b4m_1), p_0), get_degrees(360));
        break;
      case 1:
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_1 = this.o4m_1;
          if (this_1.p2d()) {
            tmp$ret$1 = p;
            break $l$block_0;
          }
          tmp$ret$1 = new Vector2D(this_1.w2f(p.g28_1, p.h28_1), this_1.z2f(p.g28_1, p.h28_1));
        }

        var tmp1_container = tmp$ret$1;
        var x = tmp1_container.cg();
        var y = tmp1_container.dg();
        var tmp_0 = -this.f4m_1 * this.u4m_1 + this.v4m_1 * (this.d4m_1 - x) + this.t4m_1 * (this.e4m_1 - y);
        // Inline function 'kotlin.math.sqrt' call

        var x_0 = this.s4m_1 * (this.p5b(this.a4m_1 - x) + this.p5b(this.b4m_1 - y)) - this.q4m_1 * ((this.a4m_1 - x) * (this.d4m_1 - x) + (this.b4m_1 - y) * (this.e4m_1 - y)) + this.r4m_1 * (this.p5b(this.d4m_1 - x) + this.p5b(this.e4m_1 - y)) - this.p5b(this.d4m_1 * this.b4m_1 - x * this.b4m_1 - this.a4m_1 * this.e4m_1 + x * this.e4m_1 + this.a4m_1 * y - this.d4m_1 * y);
        tmp = 1.0 - (tmp_0 - Math.sqrt(x_0)) * this.w4m_1;
        break;
      default:
        tmp = this.p4m_1.v2f(p);
        break;
    }
    return this.i4m_1.t5b(tmp);
  };
  protoOf(GradientPaint).p5b = function (_this__u8e3s4) {
    return _this__u8e3s4 * _this__u8e3s4;
  };
  protoOf(GradientPaint).g1s = function () {
    return this.t5a(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.j4m_1);
  };
  protoOf(GradientPaint).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.GradientPaint.toString.<anonymous>' call
    var tmp;
    switch (this.z4l_1.ka_1) {
      case 0:
        tmp = 'LinearGradient([' + this.a4m_1 + ', ' + this.b4m_1 + '], [' + this.d4m_1 + ', ' + this.e4m_1 + ']';
        break;
      case 1:
        tmp = 'RadialGradient([' + this.a4m_1 + ', ' + this.b4m_1 + ', ' + this.c4m_1 + '], [' + this.d4m_1 + ', ' + this.e4m_1 + ', ' + this.f4m_1 + ']';
        break;
      case 2:
        tmp = 'ConicGradient([' + this.a4m_1 + ', ' + this.b4m_1 + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this_0.u5(tmp);
    this_0.u5(', stops=' + this.g4m_1 + ', colors=' + colorsToString_0(this, this.h4m_1) + ', cycle=' + this.i4m_1 + ', transform=' + this.j4m_1 + ', interpolationMethod=' + this.k4m_1 + ', units=' + this.l4m_1 + ')');
    return this_0.toString();
  };
  protoOf(GradientPaint).u5b = function (kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    return new GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle);
  };
  protoOf(GradientPaint).t5a = function (kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle, $super) {
    kind = kind === VOID ? this.z4l_1 : kind;
    x0 = x0 === VOID ? this.a4m_1 : x0;
    y0 = y0 === VOID ? this.b4m_1 : y0;
    r0 = r0 === VOID ? this.c4m_1 : r0;
    x1 = x1 === VOID ? this.d4m_1 : x1;
    y1 = y1 === VOID ? this.e4m_1 : y1;
    r1 = r1 === VOID ? this.f4m_1 : r1;
    stops = stops === VOID ? this.g4m_1 : stops;
    colors = colors === VOID ? this.h4m_1 : colors;
    cycle = cycle === VOID ? this.i4m_1 : cycle;
    transform = transform === VOID ? this.j4m_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? this.k4m_1 : interpolationMethod;
    units = units === VOID ? this.l4m_1 : units;
    startAngle = startAngle === VOID ? this.m4m_1 : startAngle;
    return $super === VOID ? this.u5b(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) : $super.u5b.call(this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, new Angle(startAngle));
  };
  protoOf(GradientPaint).hashCode = function () {
    var result = this.z4l_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.a4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f4m_1) | 0;
    result = imul(result, 31) + this.g4m_1.hashCode() | 0;
    result = imul(result, 31) + this.h4m_1.hashCode() | 0;
    result = imul(result, 31) + this.i4m_1.hashCode() | 0;
    result = imul(result, 31) + this.j4m_1.hashCode() | 0;
    result = imul(result, 31) + this.k4m_1.hashCode() | 0;
    result = imul(result, 31) + this.l4m_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.m4m_1) | 0;
    return result;
  };
  protoOf(GradientPaint).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this.z4l_1.equals(tmp0_other_with_cast.z4l_1))
      return false;
    if (!equals(this.a4m_1, tmp0_other_with_cast.a4m_1))
      return false;
    if (!equals(this.b4m_1, tmp0_other_with_cast.b4m_1))
      return false;
    if (!equals(this.c4m_1, tmp0_other_with_cast.c4m_1))
      return false;
    if (!equals(this.d4m_1, tmp0_other_with_cast.d4m_1))
      return false;
    if (!equals(this.e4m_1, tmp0_other_with_cast.e4m_1))
      return false;
    if (!equals(this.f4m_1, tmp0_other_with_cast.f4m_1))
      return false;
    if (!this.g4m_1.equals(tmp0_other_with_cast.g4m_1))
      return false;
    if (!this.h4m_1.equals(tmp0_other_with_cast.h4m_1))
      return false;
    if (!this.i4m_1.equals(tmp0_other_with_cast.i4m_1))
      return false;
    if (!this.j4m_1.equals(tmp0_other_with_cast.j4m_1))
      return false;
    if (!this.k4m_1.equals(tmp0_other_with_cast.k4m_1))
      return false;
    if (!this.l4m_1.equals(tmp0_other_with_cast.l4m_1))
      return false;
    if (!equals(this.m4m_1, tmp0_other_with_cast.m4m_1))
      return false;
    return true;
  };
  function TransformedPaint() {
  }
  var GradientKind_LINEAR_instance;
  var GradientKind_RADIAL_instance;
  var GradientKind_SWEEP_instance;
  var GradientKind_entriesInitialized;
  function GradientKind_initEntries() {
    if (GradientKind_entriesInitialized)
      return Unit_instance;
    GradientKind_entriesInitialized = true;
    GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
    GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
    GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
  }
  function GradientKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  var GradientInterpolationMethod_LINEAR_instance;
  var GradientInterpolationMethod_NORMAL_instance;
  var GradientInterpolationMethod_entriesInitialized;
  function GradientInterpolationMethod_initEntries() {
    if (GradientInterpolationMethod_entriesInitialized)
      return Unit_instance;
    GradientInterpolationMethod_entriesInitialized = true;
    GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
    GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
  }
  function GradientInterpolationMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  var GradientUnits_USER_SPACE_ON_USE_instance;
  var GradientUnits_OBJECT_BOUNDING_BOX_instance;
  var GradientUnits_entriesInitialized;
  function GradientUnits_initEntries() {
    if (GradientUnits_entriesInitialized)
      return Unit_instance;
    GradientUnits_entriesInitialized = true;
    GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
    GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
  }
  function GradientUnits(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function NonePaint() {
  }
  protoOf(NonePaint).g1s = function () {
    return this;
  };
  var NonePaint_instance;
  function NonePaint_getInstance() {
    return NonePaint_instance;
  }
  function BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units) {
    transform = transform === VOID ? Companion_getInstance_3().e2f_1 : transform;
    cycleX = cycleX === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleX;
    cycleY = cycleY === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleY;
    smooth = smooth === VOID ? true : smooth;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    this.g5b_1 = bitmap;
    this.h5b_1 = transform;
    this.i5b_1 = cycleX;
    this.j5b_1 = cycleY;
    this.k5b_1 = smooth;
    this.l5b_1 = units;
    this.m5b_1 = this.g5b_1.g3a();
  }
  protoOf(BitmapPaint).p46 = function () {
    return this.h5b_1;
  };
  protoOf(BitmapPaint).v5b = function () {
    return this.i5b_1.w5b();
  };
  protoOf(BitmapPaint).x5b = function () {
    return this.j5b_1.w5b();
  };
  protoOf(BitmapPaint).g1s = function () {
    return this.y5b(VOID, this.h5b_1);
  };
  protoOf(BitmapPaint).toString = function () {
    return 'BitmapPaint(' + this.g5b_1 + ', cycle=(' + this.i5b_1 + ', ' + this.j5b_1 + '), smooth=' + this.k5b_1 + ', transform=' + this.h5b_1 + ')';
  };
  protoOf(BitmapPaint).z5b = function (bitmap, transform, cycleX, cycleY, smooth, units) {
    return new BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units);
  };
  protoOf(BitmapPaint).y5b = function (bitmap, transform, cycleX, cycleY, smooth, units, $super) {
    bitmap = bitmap === VOID ? this.g5b_1 : bitmap;
    transform = transform === VOID ? this.h5b_1 : transform;
    cycleX = cycleX === VOID ? this.i5b_1 : cycleX;
    cycleY = cycleY === VOID ? this.j5b_1 : cycleY;
    smooth = smooth === VOID ? this.k5b_1 : smooth;
    units = units === VOID ? this.l5b_1 : units;
    return $super === VOID ? this.z5b(bitmap, transform, cycleX, cycleY, smooth, units) : $super.z5b.call(this, bitmap, transform, cycleX, cycleY, smooth, units);
  };
  protoOf(BitmapPaint).hashCode = function () {
    var result = hashCode(this.g5b_1);
    result = imul(result, 31) + this.h5b_1.hashCode() | 0;
    result = imul(result, 31) + this.i5b_1.hashCode() | 0;
    result = imul(result, 31) + this.j5b_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k5b_1) | 0;
    result = imul(result, 31) + this.l5b_1.hashCode() | 0;
    return result;
  };
  protoOf(BitmapPaint).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPaint))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapPaint ? other : THROW_CCE();
    if (!equals(this.g5b_1, tmp0_other_with_cast.g5b_1))
      return false;
    if (!this.h5b_1.equals(tmp0_other_with_cast.h5b_1))
      return false;
    if (!this.i5b_1.equals(tmp0_other_with_cast.i5b_1))
      return false;
    if (!this.j5b_1.equals(tmp0_other_with_cast.j5b_1))
      return false;
    if (!(this.k5b_1 === tmp0_other_with_cast.k5b_1))
      return false;
    if (!this.l5b_1.equals(tmp0_other_with_cast.l5b_1))
      return false;
    return true;
  };
  function get_DefaultPaint() {
    return Colors_getInstance().m3b_1;
  }
  function GradientKind_LINEAR_getInstance() {
    GradientKind_initEntries();
    return GradientKind_LINEAR_instance;
  }
  function GradientKind_RADIAL_getInstance() {
    GradientKind_initEntries();
    return GradientKind_RADIAL_instance;
  }
  function GradientInterpolationMethod_NORMAL_getInstance() {
    GradientInterpolationMethod_initEntries();
    return GradientInterpolationMethod_NORMAL_instance;
  }
  function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
    GradientUnits_initEntries();
    return GradientUnits_OBJECT_BOUNDING_BOX_instance;
  }
  function _VerticalAlign___init__impl__f42kfq(ratio) {
    return ratio;
  }
  function _VerticalAlign___get_ratio__impl__b3ilr8($this) {
    return $this;
  }
  function _VerticalAlign___get_ratioFake__impl__1h2fwv($this) {
    return equals($this, Companion_getInstance_48().d5c_1) ? 1.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
  }
  function Companion_33() {
    Companion_instance_41 = this;
    this.a5c_1 = _VerticalAlign___init__impl__f42kfq(0.0);
    this.b5c_1 = _VerticalAlign___init__impl__f42kfq(0.5);
    this.c5c_1 = _VerticalAlign___init__impl__f42kfq(1.0);
    var tmp = this;
    tmp.d5c_1 = _VerticalAlign___init__impl__f42kfq(Infinity);
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.e5c_1 = [new VerticalAlign(this.a5c_1), new VerticalAlign(this.b5c_1), new VerticalAlign(this.d5c_1), new VerticalAlign(this.c5c_1)];
    this.f5c_1 = toList_1(this.e5c_1);
  }
  var Companion_instance_41;
  function Companion_getInstance_48() {
    if (Companion_instance_41 == null)
      new Companion_33();
    return Companion_instance_41;
  }
  function VerticalAlign__getOffsetY_impl_iso0y6($this, height, baseline) {
    return equals($this, Companion_getInstance_48().d5c_1) ? baseline : -height * _VerticalAlign___get_ratio__impl__b3ilr8($this);
  }
  function VerticalAlign__getOffsetYRespectBaseline_impl_62po5b($this, font, totalHeight) {
    return equals($this, Companion_getInstance_48().d5c_1) ? 0.0 : interpolate_0(toRatio_0(_VerticalAlign___get_ratio__impl__b3ilr8($this)), font.v3t_1, font.v3t_1 - totalHeight);
  }
  function VerticalAlign__toString_impl_hcpnn2($this) {
    return equals($this, Companion_getInstance_48().a5c_1) ? 'TOP' : equals($this, Companion_getInstance_48().b5c_1) ? 'MIDDLE' : equals($this, Companion_getInstance_48().c5c_1) ? 'BOTTOM' : equals($this, Companion_getInstance_48().d5c_1) ? 'BASELINE' : 'VerticalAlign(' + _VerticalAlign___get_ratio__impl__b3ilr8($this) + ')';
  }
  function VerticalAlign__hashCode_impl_vx8hj7($this) {
    return getNumberHashCode($this);
  }
  function VerticalAlign__equals_impl_xp13z($this, other) {
    if (!(other instanceof VerticalAlign))
      return false;
    var tmp0_other_with_cast = other instanceof VerticalAlign ? other.g5c_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function VerticalAlign(ratio) {
    Companion_getInstance_48();
    this.g5c_1 = ratio;
  }
  protoOf(VerticalAlign).toString = function () {
    return VerticalAlign__toString_impl_hcpnn2(this.g5c_1);
  };
  protoOf(VerticalAlign).hashCode = function () {
    return VerticalAlign__hashCode_impl_vx8hj7(this.g5c_1);
  };
  protoOf(VerticalAlign).equals = function (other) {
    return VerticalAlign__equals_impl_xp13z(this.g5c_1, other);
  };
  function _HorizontalAlign___init__impl__ad654o(ratio) {
    return ratio;
  }
  function _HorizontalAlign___get_ratio__impl__x9wlea($this) {
    return $this;
  }
  function _HorizontalAlign___get_ratioFake__impl__h46z0d($this) {
    return equals($this, Companion_getInstance_49().h5c_1) ? 0.0 : _HorizontalAlign___get_ratio__impl__x9wlea($this);
  }
  function Companion_34() {
    Companion_instance_42 = this;
    this.h5c_1 = _HorizontalAlign___init__impl__ad654o(-4.8828125E-4);
    this.i5c_1 = _HorizontalAlign___init__impl__ad654o(0.0);
    this.j5c_1 = _HorizontalAlign___init__impl__ad654o(0.5);
    this.k5c_1 = _HorizontalAlign___init__impl__ad654o(1.0);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l5c_1 = [new HorizontalAlign(this.i5c_1), new HorizontalAlign(this.j5c_1), new HorizontalAlign(this.k5c_1), new HorizontalAlign(this.h5c_1)];
    this.m5c_1 = toList_1(this.l5c_1);
  }
  var Companion_instance_42;
  function Companion_getInstance_49() {
    if (Companion_instance_42 == null)
      new Companion_34();
    return Companion_instance_42;
  }
  function HorizontalAlign__getOffsetX_impl_urzzxf($this, width) {
    return equals($this, Companion_getInstance_49().h5c_1) ? 0.0 : width * _HorizontalAlign___get_ratio__impl__x9wlea($this);
  }
  function HorizontalAlign__toString_impl_toflc0($this) {
    return equals($this, Companion_getInstance_49().i5c_1) ? 'LEFT' : equals($this, Companion_getInstance_49().j5c_1) ? 'CENTER' : equals($this, Companion_getInstance_49().k5c_1) ? 'RIGHT' : equals($this, Companion_getInstance_49().h5c_1) ? 'JUSTIFY' : 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl__x9wlea($this) + ')';
  }
  function HorizontalAlign__hashCode_impl_7x9oj5($this) {
    return getNumberHashCode($this);
  }
  function HorizontalAlign__equals_impl_hkfbhv($this, other) {
    if (!(other instanceof HorizontalAlign))
      return false;
    var tmp0_other_with_cast = other instanceof HorizontalAlign ? other.n5c_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function HorizontalAlign(ratio) {
    Companion_getInstance_49();
    this.n5c_1 = ratio;
  }
  protoOf(HorizontalAlign).toString = function () {
    return HorizontalAlign__toString_impl_toflc0(this.n5c_1);
  };
  protoOf(HorizontalAlign).hashCode = function () {
    return HorizontalAlign__hashCode_impl_7x9oj5(this.n5c_1);
  };
  protoOf(HorizontalAlign).equals = function (other) {
    return HorizontalAlign__equals_impl_hkfbhv(this.n5c_1, other);
  };
  function Companion_35() {
    Companion_instance_43 = this;
    this.c42_1 = listOf([new HorizontalAlign(Companion_getInstance_49().i5c_1), new HorizontalAlign(Companion_getInstance_49().j5c_1), new HorizontalAlign(Companion_getInstance_49().k5c_1), new HorizontalAlign(Companion_getInstance_49().h5c_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.c42_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x().n5c_1;
      // Inline function 'korlibs.image.text.Companion.TOP.<anonymous>' call
      var tmp$ret$0 = new TextAlignment(item, Companion_getInstance_48().a5c_1);
      destination.r(tmp$ret$0);
    }
    tmp.d42_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.c42_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.u();
    while (tmp0_iterator_0.v()) {
      var item_0 = tmp0_iterator_0.x().n5c_1;
      // Inline function 'korlibs.image.text.Companion.BASELINE.<anonymous>' call
      var tmp$ret$3 = new TextAlignment(item_0, Companion_getInstance_48().d5c_1);
      destination_0.r(tmp$ret$3);
    }
    tmp_0.e42_1 = destination_0;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = this.c42_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator_1 = this_2.u();
    while (tmp0_iterator_1.v()) {
      var item_1 = tmp0_iterator_1.x().n5c_1;
      // Inline function 'korlibs.image.text.Companion.MIDDLE.<anonymous>' call
      var tmp$ret$6 = new TextAlignment(item_1, Companion_getInstance_48().b5c_1);
      destination_1.r(tmp$ret$6);
    }
    tmp_1.f42_1 = destination_1;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.map' call
    var this_3 = this.c42_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator_2 = this_3.u();
    while (tmp0_iterator_2.v()) {
      var item_2 = tmp0_iterator_2.x().n5c_1;
      // Inline function 'korlibs.image.text.Companion.BOTTOM.<anonymous>' call
      var tmp$ret$9 = new TextAlignment(item_2, Companion_getInstance_48().c5c_1);
      destination_2.r(tmp$ret$9);
    }
    tmp_2.g42_1 = destination_2;
    this.h42_1 = plus(plus(plus(this.d42_1, this.e42_1), this.f42_1), this.g42_1);
    this.i42_1 = this.d42_1.f1(0);
    this.j42_1 = this.d42_1.f1(1);
    this.k42_1 = this.d42_1.f1(2);
    this.l42_1 = this.d42_1.f1(3);
    this.m42_1 = this.e42_1.f1(0);
    this.n42_1 = this.e42_1.f1(1);
    this.o42_1 = this.e42_1.f1(2);
    this.p42_1 = this.e42_1.f1(3);
    this.q42_1 = this.d42_1.f1(0);
    this.r42_1 = this.d42_1.f1(1);
    this.s42_1 = this.d42_1.f1(2);
    this.t42_1 = this.d42_1.f1(3);
    this.u42_1 = this.f42_1.f1(0);
    this.v42_1 = this.f42_1.f1(1);
    this.w42_1 = this.f42_1.f1(2);
    this.x42_1 = this.f42_1.f1(3);
    this.y42_1 = this.g42_1.f1(0);
    this.z42_1 = this.g42_1.f1(1);
    this.a43_1 = this.g42_1.f1(2);
    this.b43_1 = this.g42_1.f1(3);
  }
  protoOf(Companion_35).o5c = function (horizontal, vertical) {
    var tmp;
    if (equals(horizontal, Companion_getInstance_49().i5c_1)) {
      tmp = 0;
    } else if (equals(horizontal, Companion_getInstance_49().j5c_1)) {
      tmp = 1;
    } else if (equals(horizontal, Companion_getInstance_49().k5c_1)) {
      tmp = 2;
    } else if (equals(horizontal, Companion_getInstance_49().h5c_1)) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    return equals(vertical, Companion_getInstance_48().a5c_1) ? this.d42_1.f1(horizontalIndex) : equals(vertical, Companion_getInstance_48().d5c_1) ? this.e42_1.f1(horizontalIndex) : equals(vertical, Companion_getInstance_48().b5c_1) ? this.f42_1.f1(horizontalIndex) : equals(vertical, Companion_getInstance_48().c5c_1) ? this.g42_1.f1(horizontalIndex) : new TextAlignment(horizontal, vertical);
  };
  var Companion_instance_43;
  function Companion_getInstance_50() {
    if (Companion_instance_43 == null)
      new Companion_35();
    return Companion_instance_43;
  }
  function TextAlignment(horizontal, vertical) {
    Companion_getInstance_50();
    this.a44_1 = horizontal;
    this.b44_1 = vertical;
    this.c44_1 = new Anchor2D(_HorizontalAlign___get_ratioFake__impl__h46z0d(this.a44_1), _VerticalAlign___get_ratioFake__impl__1h2fwv(this.b44_1));
  }
  protoOf(TextAlignment).toString = function () {
    return '' + new VerticalAlign(this.b44_1) + '_' + new HorizontalAlign(this.a44_1);
  };
  protoOf(TextAlignment).hashCode = function () {
    var result = HorizontalAlign__hashCode_impl_7x9oj5(this.a44_1);
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.b44_1) | 0;
    return result;
  };
  protoOf(TextAlignment).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals(this.a44_1, tmp0_other_with_cast.a44_1))
      return false;
    if (!equals(this.b44_1, tmp0_other_with_cast.b44_1))
      return false;
    return true;
  };
  var DefaultWStringTextRenderer;
  function get_DefaultStringTextRenderer() {
    _init_properties_TextRenderer_kt__4uayeo();
    return DefaultStringTextRenderer;
  }
  var DefaultStringTextRenderer;
  function TextRenderer() {
  }
  function CreateWStringTextRenderer(getVersion, handler) {
    var tmp;
    if (getVersion === VOID) {
      tmp = CreateWStringTextRenderer$lambda;
    } else {
      tmp = getVersion;
    }
    getVersion = tmp;
    _init_properties_TextRenderer_kt__4uayeo();
    return new CreateWStringTextRenderer$2(getVersion, handler);
  }
  function ITextRendererActions() {
  }
  function CreateStringTextRenderer(getVersion, handler) {
    var tmp;
    if (getVersion === VOID) {
      tmp = CreateStringTextRenderer$lambda;
    } else {
      tmp = getVersion;
    }
    getVersion = tmp;
    _init_properties_TextRenderer_kt__4uayeo();
    return new CreateStringTextRenderer$2(getVersion, handler);
  }
  function TextRendererActions() {
    this.b46_1 = new GlyphPath();
    this.c46_1 = new GlyphMetrics();
    this.d46_1 = new FontMetrics();
    this.e46_1 = 0;
    this.g46_1 = 0.0;
    this.h46_1 = Companion_getInstance_4().d2d_1;
    this.i46_1 = Companion_getInstance_3().e2f_1;
    this.j46_1 = null;
    this.k46_1 = Colors_getInstance().l3b_1;
  }
  protoOf(TextRendererActions).l3t = function () {
    return this.d46_1.l3t();
  };
  protoOf(TextRendererActions).s46 = function (_set____db54di) {
    this.e46_1 = _set____db54di;
  };
  protoOf(TextRendererActions).l46 = function () {
    return this.e46_1;
  };
  protoOf(TextRendererActions).r46 = function () {
    var tmp = this.f46_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  };
  protoOf(TextRendererActions).t46 = function (font, size) {
    this.f46_1 = font;
    this.g46_1 = size;
    font.t3t(size, this.d46_1);
  };
  protoOf(TextRendererActions).u46 = function (_set____db54di) {
    this.h46_1 = _set____db54di;
  };
  protoOf(TextRendererActions).n46 = function () {
    return this.h46_1;
  };
  protoOf(TextRendererActions).v46 = function (reader, codePoint) {
    return this.r46().f3u(this.g46_1, codePoint, this.c46_1, reader);
  };
  protoOf(TextRendererActions).w46 = function (_set____db54di) {
    this.i46_1 = _set____db54di;
  };
  protoOf(TextRendererActions).p46 = function () {
    return this.i46_1;
  };
  protoOf(TextRendererActions).o3u = function (leftCodePoint, rightCodePoint) {
    return this.r46().s3v(this.g46_1, leftCodePoint, rightCodePoint);
  };
  function LineStats(maxLineHeight, maxX, bounds) {
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    maxX = maxX === VOID ? 0.0 : maxX;
    bounds = bounds === VOID ? Companion_getInstance_5().a2e() : bounds;
    this.e44_1 = maxLineHeight;
    this.f44_1 = maxX;
    this.g44_1 = bounds;
  }
  protoOf(LineStats).h44 = function (align) {
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, this.f44_1) + BoundsBuilder__xminOr_impl_k3l1m2(this.g44_1, 0.0);
  };
  protoOf(LineStats).x46 = function (dx) {
    this.f44_1 = this.f44_1 + dx;
  };
  protoOf(LineStats).r5c = function (fontMetrics) {
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var a = this.e44_1;
    var b = fontMetrics.l3t();
    tmp.e44_1 = Math.max(a, b);
  };
  protoOf(LineStats).s5c = function () {
  };
  protoOf(LineStats).n1y = function () {
    this.f44_1 = 0.0;
    this.g44_1 = Companion_getInstance_5().v2d_1;
    this.e44_1 = 0.0;
  };
  protoOf(LineStats).toString = function () {
    return 'LineStats(maxLineHeight=' + this.e44_1 + ', maxX=' + this.f44_1 + ', bounds=' + new BoundsBuilder(this.g44_1) + ')';
  };
  protoOf(LineStats).hashCode = function () {
    var result = getNumberHashCode(this.e44_1);
    result = imul(result, 31) + getNumberHashCode(this.f44_1) | 0;
    result = imul(result, 31) + BoundsBuilder__hashCode_impl_649zbo(this.g44_1) | 0;
    return result;
  };
  protoOf(LineStats).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LineStats))
      return false;
    var tmp0_other_with_cast = other instanceof LineStats ? other : THROW_CCE();
    if (!equals(this.e44_1, tmp0_other_with_cast.e44_1))
      return false;
    if (!equals(this.f44_1, tmp0_other_with_cast.f44_1))
      return false;
    if (!equals(this.g44_1, tmp0_other_with_cast.g44_1))
      return false;
    return true;
  };
  function add($this, x, y) {
    var rx = $this.n46().g28_1 + $this.p46().w2f(x, y);
    var ry = $this.n46().h28_1 + $this.p46().z2f(x, y);
    $this.v43_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.v43_1, new Vector2D(rx, ry));
    if ($this.w43_1 === 0) {
      $this.u43_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.u43_1, new Vector2D(rx, ry));
    }
    var tmp2_this = $this.y43_1;
    tmp2_this.g44_1 = BoundsBuilder__plus_impl_cz7f7x_1(tmp2_this.g44_1, new Vector2D(rx, ry));
  }
  function add_0($this, rect) {
    var fx = rect.r2d();
    var fy = rect.t2d();
    var w = rect.n2d_1;
    var h = rect.o2d_1;
    add($this, fx, fy);
    add($this, fx + w, fy);
    add($this, fx + w, fy + h);
    add($this, fx, fy + h);
  }
  function BoundBuilderTextRendererActions() {
    TextRendererActions.call(this);
    this.u43_1 = Companion_getInstance_5().a2e();
    this.v43_1 = Companion_getInstance_5().a2e();
    this.w43_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.x43_1 = ArrayList_init_$Create$();
    this.y43_1 = new LineStats();
  }
  protoOf(BoundBuilderTextRendererActions).z43 = function () {
    return this.w43_1;
  };
  protoOf(BoundBuilderTextRendererActions).t5c = function () {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0.0;
    var tmp0_iterator = this.x43_1.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      var tmp = sum;
      // Inline function 'korlibs.image.text.BoundBuilderTextRendererActions.<get-totalMaxLineHeight>.<anonymous>' call
      sum = tmp + element.e44_1;
    }
    return sum;
  };
  protoOf(BoundBuilderTextRendererActions).m46 = function (align, line) {
    var tmp0_elvis_lhs = getOrNull_1(this.x43_1, line);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return HorizontalAlign__getOffsetX_impl_urzzxf(align, 0.0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var line_0 = tmp;
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, line_0.f44_1);
  };
  protoOf(BoundBuilderTextRendererActions).d44 = function (align, fontMetrics) {
    return VerticalAlign__getOffsetYRespectBaseline_impl_62po5b(align, fontMetrics, this.t5c());
  };
  protoOf(BoundBuilderTextRendererActions).n1y = function () {
    protoOf(TextRendererActions).n1y.call(this);
    this.w43_1 = 0;
    this.v43_1 = Companion_getInstance_5().v2d_1;
    this.u43_1 = Companion_getInstance_5().v2d_1;
    this.y43_1.n1y();
    this.x43_1.b3();
  };
  protoOf(BoundBuilderTextRendererActions).a46 = function (reader, codePoint) {
    var g = this.v46(reader, codePoint);
    add_0(this, g.k3u_1);
    this.y43_1.r5c(this.d46_1);
    return g;
  };
  protoOf(BoundBuilderTextRendererActions).x46 = function (x) {
    protoOf(TextRendererActions).x46.call(this, x);
    this.y43_1.x46(x);
  };
  protoOf(BoundBuilderTextRendererActions).y46 = function (y, end) {
    protoOf(TextRendererActions).y46.call(this, y, end);
    this.w43_1 = this.w43_1 + 1 | 0;
    this.y43_1.r5c(this.d46_1);
    this.y43_1.s5c();
    this.x43_1.r(this.y43_1);
    this.y43_1 = new LineStats();
  };
  function measure(_this__u8e3s4, text, size, defaultFont) {
    _init_properties_TextRenderer_kt__4uayeo();
    var actions = new BoundBuilderTextRendererActions();
    invoke(_this__u8e3s4, actions, text, size, defaultFont);
    return actions;
  }
  function invoke(_this__u8e3s4, actions, text, size, defaultFont) {
    _init_properties_TextRenderer_kt__4uayeo();
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.invoke.<anonymous>' call
    _this__u8e3s4.q5c(actions, text, size, defaultFont);
  }
  function LineInfo(maxTop, minBottom, maxLineHeight) {
    maxTop = maxTop === VOID ? 0.0 : maxTop;
    minBottom = minBottom === VOID ? 0.0 : minBottom;
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    this.u5c_1 = maxTop;
    this.v5c_1 = minBottom;
    this.w5c_1 = maxLineHeight;
  }
  protoOf(LineInfo).toString = function () {
    return 'LineInfo(maxTop=' + this.u5c_1 + ', minBottom=' + this.v5c_1 + ', maxLineHeight=' + this.w5c_1 + ')';
  };
  protoOf(LineInfo).hashCode = function () {
    var result = getNumberHashCode(this.u5c_1);
    result = imul(result, 31) + getNumberHashCode(this.v5c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w5c_1) | 0;
    return result;
  };
  protoOf(LineInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LineInfo))
      return false;
    var tmp0_other_with_cast = other instanceof LineInfo ? other : THROW_CCE();
    if (!equals(this.u5c_1, tmp0_other_with_cast.u5c_1))
      return false;
    if (!equals(this.v5c_1, tmp0_other_with_cast.v5c_1))
      return false;
    if (!equals(this.w5c_1, tmp0_other_with_cast.w5c_1))
      return false;
    return true;
  };
  function Entry_0(tex, x, y, sx, sy, rot) {
    var tmp;
    if (tex === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tex;
    }
    tex = tmp;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    sx = sx === VOID ? 1.0 : sx;
    sy = sy === VOID ? 1.0 : sy;
    rot = rot === VOID ? get_radians(0) : rot;
    this.x5c_1 = tex;
    this.y5c_1 = x;
    this.z5c_1 = y;
    this.a5d_1 = sx;
    this.b5d_1 = sy;
    this.c5d_1 = rot;
  }
  protoOf(Entry_0).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Entry.toString.<anonymous>' call
    this_0.u5('Entry(');
    this_0.u5("'" + this.x5c_1.q2w_1 + "', " + numberToInt(this.y5c_1) + ', ' + numberToInt(this.z5c_1) + ', ' + this.x5c_1.v2w_1 + ', ' + this.x5c_1.w2w_1);
    if (!(this.a5d_1 === 1.0)) {
      this_0.u5(', sx=' + get_niceStr_0(this.a5d_1));
    }
    if (!(this.b5d_1 === 1.0)) {
      this_0.u5(', sy=' + get_niceStr_0(this.b5d_1));
    }
    if (!equals(this.c5d_1, get_radians(0))) {
      this_0.u5(', rot=' + get_niceStr_0(_Angle___get_degrees__impl__qg56vw(this.c5d_1)));
    }
    this_0.u5(')');
    return this_0.toString();
  };
  protoOf(Entry_0).hashCode = function () {
    var result = this.x5c_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.y5c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z5c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a5d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b5d_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.c5d_1) | 0;
    return result;
  };
  protoOf(Entry_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!this.x5c_1.equals(tmp0_other_with_cast.x5c_1))
      return false;
    if (!equals(this.y5c_1, tmp0_other_with_cast.y5c_1))
      return false;
    if (!equals(this.z5c_1, tmp0_other_with_cast.z5c_1))
      return false;
    if (!equals(this.a5d_1, tmp0_other_with_cast.a5d_1))
      return false;
    if (!equals(this.b5d_1, tmp0_other_with_cast.b5d_1))
      return false;
    if (!equals(this.c5d_1, tmp0_other_with_cast.c5d_1))
      return false;
    return true;
  };
  function Text2TextRendererActions() {
    TextRendererActions.call(this);
    this.n5d_1 = Companion_getInstance_50().i42_1;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.o5d_1 = ArrayList_init_$Create$();
    this.p5d_1 = doubleArrayListOf(new Float64Array([]));
    this.q5d_1 = doubleArrayListOf(new Float64Array([]));
    this.r5d_1 = doubleArrayListOf(new Float64Array([]));
    this.s5d_1 = doubleArrayListOf(new Float64Array([]));
    this.t5d_1 = doubleArrayListOf(new Float64Array([]));
    this.u5d_1 = new DoubleVectorArrayList(4);
    this.v5d_1 = MatrixTransform_init_$Create$();
  }
  protoOf(Text2TextRendererActions).w5d = function () {
    return this.n5d_1.b44_1;
  };
  protoOf(Text2TextRendererActions).n = function () {
    return this.p5d_1.n();
  };
  protoOf(Text2TextRendererActions).x5d = function () {
    var out = arrayListOf([new LineInfo()]);
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var this_0 = this.u5d_1;
    var inductionVariable = 0;
    var last = this_0.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.text.Text2TextRendererActions.getLineInfos.<anonymous>' call
        var line = numberToInt(this_0.c1r(n, 0));
        while (out.n() <= line) {
          out.r(new LineInfo());
        }
        var lineInfo = out.f1(line);
        var top = this_0.c1r(n, 1);
        var bottom = this_0.c1r(n, 2);
        var lineHeight = this_0.c1r(n, 3);
        var tmp = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a = lineInfo.u5c_1;
        tmp.u5c_1 = Math.max(a, top);
        var tmp_0 = lineInfo;
        // Inline function 'kotlin.math.min' call
        var a_0 = lineInfo.v5c_1;
        tmp_0.v5c_1 = Math.min(a_0, bottom);
        var tmp_1 = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a_1 = lineInfo.w5c_1;
        tmp_1.w5c_1 = Math.max(a_1, lineHeight);
      }
       while (inductionVariable < last);
    return out;
  };
  protoOf(Text2TextRendererActions).y5d = function (n) {
    return n >= this.n() ? Companion_getInstance_2().w2d_1 : Companion_getInstance_2().t2k(this.p5d_1.f1(n), this.q5d_1.f1(n), this.p5d_1.f1(n) + this.o5d_1.f1(n).v2w_1 * this.r5d_1.f1(n), this.q5d_1.f1(n) + this.o5d_1.f1(n).w2w_1 * this.s5d_1.f1(n));
  };
  protoOf(Text2TextRendererActions).u2r = function () {
    if (this.n() === 0) {
      return Companion_getInstance_2().w2d_1;
    }
    var bb = Companion_getInstance_5().a2e();
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, this.y5d(n));
      }
       while (inductionVariable < last);
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  };
  protoOf(Text2TextRendererActions).z5d = function (n, out) {
    out.x5c_1 = this.o5d_1.f1(n);
    out.y5c_1 = this.p5d_1.f1(n);
    out.z5c_1 = this.q5d_1.f1(n);
    out.a5d_1 = this.r5d_1.f1(n);
    out.b5d_1 = this.s5d_1.f1(n);
    var tmp = out;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_8();
    var ratio = this.t5d_1.f1(n);
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = toRatio_0(ratio);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, get_PI2());
    tmp.c5d_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    return out;
  };
  protoOf(Text2TextRendererActions).a5e = function () {
    this.u46(Companion_getInstance_4().d2d_1);
    this.o5d_1.b3();
    this.p5d_1.b3();
    this.q5d_1.b3();
    this.r5d_1.b3();
    this.s5d_1.b3();
    this.t5d_1.b3();
    this.u5d_1.b3();
    this.s46(0);
  };
  protoOf(Text2TextRendererActions).a46 = function (reader, codePoint) {
    var tmp = this.r46();
    var bf = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp1_elvis_lhs = reader == null ? null : reader.a4r_1;
      var old = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      try {
        // Inline function 'korlibs.image.text.Text2TextRendererActions.put.<anonymous>' call
        tmp$ret$1 = this.v46(reader, codePoint);
        break $l$block;
      }finally {
        if (reader != null)
          reader.a4r_1 = old;
      }
    }
    var m = tmp$ret$1;
    var g = bf.f1(codePoint);
    var x = g.b3t_1;
    var tmp_0 = g.c3t_1;
    var tmp0_subject = this.w5d();
    var y = tmp_0 - (equals(tmp0_subject, Companion_getInstance_48().d5c_1) ? bf.v2x() : bf.l3t() * _VerticalAlign___get_ratio__impl__b3ilr8(this.w5d()));
    var fontScale = this.g46_1 / bf.k3t();
    this.v5d_1 = get_immutable(this.p46()).v2g();
    this.o5d_1.r(g.a3t_1);
    this.p5d_1.s1r(this.n46().g28_1 + this.p46().w2f(x, y) * fontScale);
    this.q5d_1.s1r(this.n46().h28_1 + this.p46().z2f(x, y) * fontScale);
    this.r5d_1.s1r(this.v5d_1.l2h_1 * fontScale);
    this.s5d_1.s1r(this.v5d_1.m2h_1 * fontScale);
    this.t5d_1.s1r(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4(this.v5d_1.p2h_1)));
    this.u5d_1.u1r(this.l46(), this.d46_1.v3t_1, this.d46_1.z3t_1, this.d46_1.l3t());
    return m;
  };
  function DefaultWStringTextRenderer$lambda($this$CreateWStringTextRenderer, text, c, g, advance) {
    _init_properties_TextRenderer_kt__4uayeo();
    $this$CreateWStringTextRenderer.a46(text, c);
    $this$CreateWStringTextRenderer.x46(advance);
    return Unit_instance;
  }
  function DefaultStringTextRenderer$lambda($this$CreateStringTextRenderer, text, c, g, advance) {
    _init_properties_TextRenderer_kt__4uayeo();
    $this$CreateStringTextRenderer.a46(text, c);
    $this$CreateStringTextRenderer.x46(advance);
    return Unit_instance;
  }
  function CreateWStringTextRenderer$lambda() {
    _init_properties_TextRenderer_kt__4uayeo();
    return 0;
  }
  function CreateWStringTextRenderer$2($getVersion, $handler) {
    this.b5e_1 = $getVersion;
    this.c5e_1 = $handler;
  }
  protoOf(CreateWStringTextRenderer$2).p5c = function () {
    return this.b5e_1();
  };
  protoOf(CreateWStringTextRenderer$2).d5e = function (_this__u8e3s4, text, size, defaultFont) {
    _this__u8e3s4.n1y();
    _this__u8e3s4.t46(defaultFont, size);
    var reader = new WStringReader(text);
    while (reader.d4b()) {
      var c = _WChar___get_codePoint__impl__c8brwu(reader.e5e());
      var c1 = _WChar___get_codePoint__impl__c8brwu(reader.b4r(1));
      var startPos = reader.a4r_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (c === Char__toInt_impl_vasixd(this_0)) {
        _this__u8e3s4.y46(_this__u8e3s4.l3t(), false);
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.io.lang.keep' call
          var tmp1_elvis_lhs = reader == null ? null : reader.a4r_1;
          var old = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
          try {
            // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
            tmp$ret$2 = _this__u8e3s4.v46(reader, c);
            break $l$block;
          }finally {
            if (reader != null)
              reader.a4r_1 = old;
          }
        }
        var g = tmp$ret$2;
        _this__u8e3s4.w46(Companion_getInstance_3().e2f_1);
        this.c5e_1(_this__u8e3s4, reader, c, g, g.l3u_1 + _this__u8e3s4.o3u(c, c1));
      }
      if (reader.a4r_1 <= startPos) {
        reader.v4b(1);
      }
    }
    _this__u8e3s4.y46(_this__u8e3s4.l3t(), true);
  };
  protoOf(CreateWStringTextRenderer$2).q5c = function (_this__u8e3s4, text, size, defaultFont) {
    return this.d5e(_this__u8e3s4, text instanceof WString ? text : THROW_CCE(), size, defaultFont);
  };
  function CreateStringTextRenderer$lambda() {
    _init_properties_TextRenderer_kt__4uayeo();
    return 0;
  }
  function CreateStringTextRenderer$o$wstring$lambda($handler) {
    return function ($this$CreateWStringTextRenderer, text, c, g, advance) {
      $handler($this$CreateWStringTextRenderer, text, c, g, advance);
      return Unit_instance;
    };
  }
  function CreateStringTextRenderer$2($getVersion, $handler) {
    var tmp = this;
    tmp.f5e_1 = CreateWStringTextRenderer($getVersion, CreateStringTextRenderer$o$wstring$lambda($handler));
  }
  protoOf(CreateStringTextRenderer$2).p5c = function () {
    return this.f5e_1.p5c();
  };
  protoOf(CreateStringTextRenderer$2).g5e = function (_this__u8e3s4, text, size, defaultFont) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
    this.f5e_1.q5c(_this__u8e3s4, Companion_getInstance_68().r24(text), size, defaultFont);
  };
  protoOf(CreateStringTextRenderer$2).q5c = function (_this__u8e3s4, text, size, defaultFont) {
    return this.g5e(_this__u8e3s4, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size, defaultFont);
  };
  var properties_initialized_TextRenderer_kt_lfmsb6;
  function _init_properties_TextRenderer_kt__4uayeo() {
    if (!properties_initialized_TextRenderer_kt_lfmsb6) {
      properties_initialized_TextRenderer_kt_lfmsb6 = true;
      DefaultWStringTextRenderer = CreateWStringTextRenderer(VOID, DefaultWStringTextRenderer$lambda);
      DefaultStringTextRenderer = CreateStringTextRenderer(VOID, DefaultStringTextRenderer$lambda);
    }
  }
  function TileMapData(data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate) {
    tileSet = tileSet === VOID ? null : tileSet;
    maskData = maskData === VOID ? 268435455 : maskData;
    maskFlipX = maskFlipX === VOID ? -2147483648 : maskFlipX;
    maskFlipY = maskFlipY === VOID ? 1073741824 : maskFlipY;
    maskRotate = maskRotate === VOID ? 536870912 : maskRotate;
    this.h5e_1 = data;
    this.i5e_1 = tileSet;
    this.j5e_1 = maskData;
    this.k5e_1 = maskFlipX;
    this.l5e_1 = maskFlipY;
    this.m5e_1 = maskRotate;
  }
  protoOf(TileMapData).toString = function () {
    return 'TileMapData(data=' + this.h5e_1 + ', tileSet=' + this.i5e_1 + ', maskData=' + this.j5e_1 + ', maskFlipX=' + this.k5e_1 + ', maskFlipY=' + this.l5e_1 + ', maskRotate=' + this.m5e_1 + ')';
  };
  protoOf(TileMapData).hashCode = function () {
    var result = this.h5e_1.hashCode();
    result = imul(result, 31) + (this.i5e_1 == null ? 0 : hashCode(this.i5e_1)) | 0;
    result = imul(result, 31) + this.j5e_1 | 0;
    result = imul(result, 31) + this.k5e_1 | 0;
    result = imul(result, 31) + this.l5e_1 | 0;
    result = imul(result, 31) + this.m5e_1 | 0;
    return result;
  };
  protoOf(TileMapData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TileMapData))
      return false;
    var tmp0_other_with_cast = other instanceof TileMapData ? other : THROW_CCE();
    if (!this.h5e_1.equals(tmp0_other_with_cast.h5e_1))
      return false;
    if (!equals(this.i5e_1, tmp0_other_with_cast.i5e_1))
      return false;
    if (!(this.j5e_1 === tmp0_other_with_cast.j5e_1))
      return false;
    if (!(this.k5e_1 === tmp0_other_with_cast.k5e_1))
      return false;
    if (!(this.l5e_1 === tmp0_other_with_cast.l5e_1))
      return false;
    if (!(this.m5e_1 === tmp0_other_with_cast.m5e_1))
      return false;
    return true;
  };
  function Companion_36() {
    Companion_instance_44 = this;
    this.n5e_1 = new TileSet(IntMap_init_$Create$());
  }
  protoOf(Companion_36).o5e = function (tiles, width, height) {
    var map = IntMap_init_$Create$();
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var n = 0;
    while (n < tiles.n()) {
      // Inline function 'korlibs.image.tiles.Companion.invoke.<anonymous>' call
      var index = n;
      var value = tiles.f1(n);
      map.r1w(index, value);
      n = n + 1 | 0;
    }
    return new TileSet(map, width, height);
  };
  protoOf(Companion_36).p5e = function (tiles, width, height, $super) {
    width = width === VOID ? first_0(tiles).r5e_1.v2w_1 : width;
    height = height === VOID ? first_0(tiles).r5e_1.w2w_1 : height;
    return $super === VOID ? this.o5e(tiles, width, height) : $super.o5e.call(this, tiles, width, height);
  };
  protoOf(Companion_36).v5e = function (base, tileWidth, tileHeight, columns, totalTiles) {
    var out = IntMap_init_$Create$();
    var rows = base.w2w_1 / tileHeight | 0;
    var actualColumns = columns < 0 ? base.v2w_1 / tileWidth | 0 : columns;
    var actualTotalTiles = totalTiles < 0 ? imul(rows, actualColumns) : totalTiles;
    var n = 0;
    var inductionVariable = 0;
    if (inductionVariable < rows)
      complete: do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < actualColumns)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.r1w(n, new TileSetTileInfo(n + 1 | 0, base.d2y(imul(x, tileWidth), imul(y, tileHeight), tileWidth, tileHeight)));
            n = n + 1 | 0;
            if (out.k1w_1 >= actualTotalTiles)
              break complete;
          }
           while (inductionVariable_0 < actualColumns);
      }
       while (inductionVariable < rows);
    return new TileSet(out, tileWidth, tileHeight);
  };
  protoOf(Companion_36).w5e = function (base, tileWidth, tileHeight, columns, totalTiles, $super) {
    tileWidth = tileWidth === VOID ? base.v2w_1 : tileWidth;
    tileHeight = tileHeight === VOID ? base.w2w_1 : tileHeight;
    columns = columns === VOID ? -1 : columns;
    totalTiles = totalTiles === VOID ? -1 : totalTiles;
    return $super === VOID ? this.v5e(base, tileWidth, tileHeight, columns, totalTiles) : $super.v5e.call(this, base, tileWidth, tileHeight, columns, totalTiles);
  };
  protoOf(Companion_36).x5e = function (tilewidth, tileheight, bitmaps, border, mipmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(bitmaps, 10));
    var tmp0_iterator = bitmaps.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.image.tiles.Companion.fromBitmaps.<anonymous>' call
      var tmp$ret$0 = slice_0(item);
      destination.r(tmp$ret$0);
    }
    return this.y5e(tilewidth, tileheight, destination, border, mipmaps);
  };
  protoOf(Companion_36).y5e = function (tilewidth, tileheight, bmpSlices, border, mipmaps_0) {
    // Inline function 'kotlin.check' call
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(bmpSlices, Collection)) {
        tmp = bmpSlices.b1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = bmpSlices.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.image.tiles.Companion.fromBitmapSlices.<anonymous>' call
        if (!(element.v2w_1 === tilewidth ? element.w2w_1 === tileheight : false)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp$ret$0) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (bmpSlices.b1())
      return new TileSet(IntMap_init_$Create$(), tilewidth, tileheight);
    var border2 = imul(border, 2);
    var btilewidth = tilewidth + border2 | 0;
    var btileheight = tileheight + border2 | 0;
    var barea = imul(btilewidth, btileheight);
    var fullArea = imul(get_nextPowerOfTwo(bmpSlices.n()), barea);
    // Inline function 'kotlin.math.sqrt' call
    var tmp$ret$3 = Math.sqrt(fullArea);
    var expectedSide = get_nextPowerOfTwo(toIntCeil_0(tmp$ret$3));
    var tmp$ret$4;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(bmpSlices, Collection)) {
        tmp_0 = bmpSlices.b1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$4 = false;
        break $l$block_2;
      }
      var tmp0_iterator_0 = bmpSlices.u();
      while (tmp0_iterator_0.v()) {
        var element_0 = tmp0_iterator_0.x();
        // Inline function 'korlibs.image.tiles.Companion.fromBitmapSlices.<anonymous>' call
        if (element_0.m2w_1.a3a_1) {
          tmp$ret$4 = true;
          break $l$block_2;
        }
      }
      tmp$ret$4 = false;
    }
    var premultiplied = tmp$ret$4;
    var out = mipmaps(new Bitmap32(expectedSide, expectedSide, VOID, premultiplied), mipmaps_0);
    var texs = IntMap_init_$Create$();
    var columns = out.t39_1 / btilewidth | 0;
    var tex = null;
    var nn = 0;
    var inductionVariable = 0;
    if (inductionVariable < 2)
      do {
        var m = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last = bmpSlices.n();
        if (inductionVariable_0 < last)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var y = n / columns | 0;
            var x = n % columns | 0;
            var px = imul(x, btilewidth) + border | 0;
            var py = imul(y, btileheight) + border | 0;
            if (m === 0) {
              putSliceWithBorder(out, px, py, bmpSlices.f1(n), border);
            } else {
              var tmp_1 = nn;
              var tmp_2 = nn;
              var tmp_3;
              if (tex == null) {
                throwUninitializedPropertyAccessException('tex');
              } else {
                tmp_3 = tex;
              }
              texs.r1w(tmp_1, new TileSetTileInfo(tmp_2, sliceWithSize(tmp_3, px, py, tilewidth, tileheight, bmpSlices.f1(n).q2w_1)));
              nn = nn + 1 | 0;
            }
          }
           while (inductionVariable_0 < last);
        if (m === 0) {
          tex = out;
        }
      }
       while (inductionVariable < 2);
    return new TileSet(texs, tilewidth, tileheight);
  };
  var Companion_instance_44;
  function Companion_getInstance_51() {
    if (Companion_instance_44 == null)
      new Companion_36();
    return Companion_instance_44;
  }
  function TileSet$base$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.z5e_1.k1w_1 === 0) {
        // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
        var tmp$ret$0 = get_Bitmaps_transparent();
        tmp = get_bmp(tmp$ret$0);
      } else {
        tmp = get_bmp(this$0.z5e_1.y1w().r5e_1);
      }
      return tmp;
    };
  }
  function TileSet$hasMultipleBaseBitmaps$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var this_0 = this$0.z5e_1.h2();
        var tmp;
        if (isInterface(this_0, Collection)) {
          tmp = this_0.b1();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var tmp0_iterator = this_0.u();
        while (tmp0_iterator.v()) {
          var element = tmp0_iterator.x();
          // Inline function 'korlibs.image.tiles.TileSet.hasMultipleBaseBitmaps$delegate.<anonymous>.<anonymous>' call
          if (!(element === null) ? !(get_bmp(element.r5e_1) === this$0.v2x()) : false) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      return tmp$ret$0;
    };
  }
  function TileSet$infos$delegate$lambda(this$0) {
    return function () {
      var tmp = 0;
      var tmp0_safe_receiver = maxOrNull(this$0.z5e_1.g2());
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver + 1 | 0;
      var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = this$0.z5e_1.f1(tmp_2);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function TileSet$textures$delegate$lambda(this$0) {
    return function () {
      var tmp = 0;
      var tmp0_safe_receiver = maxOrNull(this$0.z5e_1.g2());
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver + 1 | 0;
      var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        var tmp0_safe_receiver_0 = this$0.z5e_1.f1(tmp_2);
        tmp_1[tmp_2] = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.r5e_1;
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function TileSet(tilesMap, width, height) {
    Companion_getInstance_51();
    width = width === VOID ? tilesMap.k1w_1 === 0 ? 0 : tilesMap.y1w().r5e_1.v2w_1 : width;
    height = height === VOID ? tilesMap.k1w_1 === 0 ? 0 : tilesMap.y1w().r5e_1.w2w_1 : height;
    this.z5e_1 = tilesMap;
    this.a5f_1 = width;
    this.b5f_1 = height;
    var tmp = this;
    tmp.c5f_1 = lazy(TileSet$base$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.d5f_1 = lazy(TileSet$hasMultipleBaseBitmaps$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.e5f_1 = lazy(TileSet$infos$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.f5f_1 = lazy(TileSet$textures$delegate$lambda(this));
  }
  protoOf(TileSet).g5f = function () {
    return new SizeInt(this.a5f_1, this.b5f_1);
  };
  protoOf(TileSet).toString = function () {
    return 'TileSet(size=' + this.a5f_1 + 'x' + this.b5f_1 + ', tiles=' + toList(this.z5e_1.g2()) + ')';
  };
  protoOf(TileSet).v2x = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c5f_1;
    base$factory();
    return this_0.m2();
  };
  protoOf(TileSet).v2r = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e5f_1;
    infos$factory();
    return this_0.m2();
  };
  protoOf(TileSet).h5f = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f5f_1;
    textures$factory();
    return this_0.m2();
  };
  function TileSetTileInfo(id, slice, frames, collision) {
    frames = frames === VOID ? emptyList() : frames;
    collision = collision === VOID ? null : collision;
    this.q5e_1 = id;
    this.r5e_1 = slice;
    this.s5e_1 = frames;
    this.t5e_1 = collision;
    this.u5e_1 = new Mixin();
  }
  protoOf(TileSetTileInfo).h23 = function (_set____db54di) {
    this.u5e_1.h23(_set____db54di);
  };
  protoOf(TileSetTileInfo).i23 = function () {
    return this.u5e_1.i23();
  };
  protoOf(TileSetTileInfo).toString = function () {
    return 'TileSetTileInfo(id=' + this.q5e_1 + ', slice=' + this.r5e_1 + ', frames=' + this.s5e_1 + ', collision=' + this.t5e_1 + ')';
  };
  protoOf(TileSetTileInfo).hashCode = function () {
    var result = this.q5e_1;
    result = imul(result, 31) + this.r5e_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.s5e_1) | 0;
    result = imul(result, 31) + (this.t5e_1 == null ? 0 : hashCode(this.t5e_1)) | 0;
    return result;
  };
  protoOf(TileSetTileInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TileSetTileInfo))
      return false;
    var tmp0_other_with_cast = other instanceof TileSetTileInfo ? other : THROW_CCE();
    if (!(this.q5e_1 === tmp0_other_with_cast.q5e_1))
      return false;
    if (!this.r5e_1.equals(tmp0_other_with_cast.r5e_1))
      return false;
    if (!equals(this.s5e_1, tmp0_other_with_cast.s5e_1))
      return false;
    if (!equals(this.t5e_1, tmp0_other_with_cast.t5e_1))
      return false;
    return true;
  };
  function base$factory() {
    return getPropertyCallableRef('base', 1, KProperty1, function (receiver) {
      return receiver.v2x();
    }, null);
  }
  function infos$factory() {
    return getPropertyCallableRef('infos', 1, KProperty1, function (receiver) {
      return receiver.v2r();
    }, null);
  }
  function textures$factory() {
    return getPropertyCallableRef('textures', 1, KProperty1, function (receiver) {
      return receiver.h5f();
    }, null);
  }
  function overlaps($this, a0, a1, b0, b1) {
    // Inline function 'kotlin.math.min' call
    var min = Math.min(a0, a0);
    // Inline function 'kotlin.math.max' call
    var max = Math.max(a1, a1);
    // Inline function 'kotlin.math.max' call
    var maxMinor = Math.max(a0, b0);
    // Inline function 'kotlin.math.min' call
    var minMajor = Math.min(a1, b1);
    return (min <= maxMinor ? maxMinor <= max : false) ? true : min <= minMajor ? minMajor <= max : false;
  }
  function SegmentHandler() {
    this.i5f_1 = intArrayListOf(new Int32Array([]));
    this.j5f_1 = intArrayListOf(new Int32Array([]));
    this.n1y();
  }
  protoOf(SegmentHandler).n = function () {
    return this.i5f_1.n();
  };
  protoOf(SegmentHandler).n1y = function () {
    this.i5f_1.b3();
    this.j5f_1.b3();
  };
  protoOf(SegmentHandler).b31 = function (x0, x1) {
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this.i5f_1.b1r(n);
        var xmax = this.j5f_1.b1r(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          // Inline function 'kotlin.math.min' call
          var tmp$ret$0 = Math.min(x0, xmin);
          this.i5f_1.r1s(n, tmp$ret$0);
          // Inline function 'kotlin.math.max' call
          var tmp$ret$1 = Math.max(x1, xmax);
          this.j5f_1.r1s(n, tmp$ret$1);
          return Unit_instance;
        }
      }
       while (inductionVariable < last);
    this.i5f_1.m1s(x0);
    this.j5f_1.m1s(x1);
  };
  function ScanlineWriter($outer) {
    this.v5f_1 = $outer;
    this.k5f_1 = get_DEFAULT(Companion_getInstance_52());
    this.l5f_1 = NoneFiller_getInstance();
    this.m5f_1 = -1;
    this.n5f_1 = -1;
    this.o5f_1 = new Float32Array(this.n());
    this.p5f_1 = new Int32Array(this.n());
    this.q5f_1 = Companion_instance_21.v3s(this.n());
    this.r5f_1 = Companion_instance_21.v3s(this.n());
    this.s5f_1 = new SegmentHandler();
    this.t5f_1 = 0;
    this.u5f_1 = 1.0;
  }
  protoOf(ScanlineWriter).n = function () {
    return this.v5f_1.y5f_1.t39_1;
  };
  protoOf(ScanlineWriter).i5g = function () {
    return this.v5f_1.y5f_1.t39_1 - 1 | 0;
  };
  protoOf(ScanlineWriter).n1y = function () {
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.s5f_1;
    var inductionVariable = 0;
    var last = this_0.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.reset.<anonymous>' call
        var xmin = this_0.i5f_1.b1r(n);
        var xmax = this_0.j5f_1.b1r(n);
        fill_0(this.o5f_1, 0.0, xmin, xmax + 1 | 0);
        fill(this.p5f_1, 0, xmin, xmax + 1 | 0);
      }
       while (inductionVariable < last);
    this.t5f_1 = 0;
    this.s5f_1.n1y();
  };
  protoOf(ScanlineWriter).j5g = function (x0, x1, y0) {
    if (this.i5g() < 1)
      return Unit_instance;
    var tmp = this.i5g();
    var x0_0 = coerceIn(x0, 0, imul(tmp, 20));
    var tmp_0 = this.i5g();
    var x1_0 = coerceIn(x1, 0, imul(tmp_0, 20));
    var a = x0_0 / 20 | 0;
    var b = x1_0 / 20 | 0;
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this.i5g());
    var i1 = coerceIn(b, 0, this.i5g());
    var i0m = x0_0 % 20 | 0;
    var i1m = x1_0 % 20 | 0;
    if (!(this.n5f_1 === y)) {
      if (y >= 0) {
        this.m6();
      }
      this.n5f_1 = y;
      this.n1y();
    }
    if (!(this.m5f_1 === y0)) {
      this.m5f_1 = y0;
      this.t5f_1 = this.t5f_1 + 1 | 0;
    }
    if (i1 > i0) {
      this.s5f_1.b31(i0, i1);
      var tmp_1 = i0m;
      this.k5g(i0, 1.0 - tmp_1 / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.k5g(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        var tmp_2 = i1m;
        this.k5g(i1, tmp_2 / 20);
      }
    }
  };
  protoOf(ScanlineWriter).k5g = function (x, ratio) {
    var mask = 1 << this.t5f_1;
    if ((this.p5f_1[x] & mask) === 0) {
      this.p5f_1[x] = this.p5f_1[x] | mask;
      var tmp0_array = this.o5f_1;
      tmp0_array[x] = tmp0_array[x] + ratio;
    }
  };
  protoOf(ScanlineWriter).m6 = function () {
    var containsUpper = this.v5f_1.y5f_1.u39_1;
    var containsArg = this.n5f_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_instance;
    var galpha = clamp01_0(this.u5f_1);
    var scale_0 = 1.0 / this.t5f_1 * galpha;
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.s5f_1;
    var inductionVariable = 0;
    var last = this_0.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.flush.<anonymous>' call
        var xmin = this_0.i5f_1.b1r(n);
        var xmax = this_0.j5f_1.b1r(n);
        var x = xmin;
        var count = (xmax - xmin | 0) + 1 | 0;
        this.l5f_1.l5a(this.r5f_1, 0, xmin, xmax, this.n5f_1);
        var inductionVariable_0 = xmin;
        if (inductionVariable_0 <= xmax)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp1_array = this.o5f_1;
            var tmp2_index0 = n_0;
            tmp1_array[tmp2_index0] = tmp1_array[tmp2_index0] * scale_0;
          }
           while (!(n_0 === xmax));
        scale(this.r5f_1, xmin, this.o5f_1, xmin, count);
        var index = this.v5f_1.y5f_1.e3b(0, this.n5f_1) + x | 0;
        if (this.v5f_1.y5f_1.a3a_1) {
          arraycopy(this.v5f_1.y5f_1.v3a_1, index, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.q5f_1), x, count);
        } else {
          premultiply(_RgbaArray___init__impl__oib4y4(this.v5f_1.y5f_1.v3a_1), index, this.q5f_1, x, count);
        }
        this.k5f_1.l5g(this.q5f_1, x, this.r5f_1, x, count);
        if (this.v5f_1.y5f_1.a3a_1) {
          arraycopy(_RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.q5f_1), x, this.v5f_1.y5f_1.v3a_1, index, count);
        } else {
          depremultiply(this.q5f_1, x, _RgbaArray___init__impl__oib4y4(this.v5f_1.y5f_1.v3a_1), index, count);
        }
      }
       while (inductionVariable < last);
  };
  function renderFinal$flush(this$0, filler, $state, $winding, fillPath) {
    if (this$0.b5g_1.p5g_1.t1s()) {
      this$0.b5g_1.n5g_1 = this$0.z5f_1 ? 4 : 1;
      this$0.f5g_1.l5f_1 = filler;
      this$0.f5g_1.u5f_1 = $state.h3v_1;
      this$0.f5g_1.n1y();
      var tmp = $winding == null ? fillPath.w2u_1 : $winding;
      this$0.b5g_1.v5g(this$0.a5g_1, VOID, VOID, tmp, Bitmap32Context2d$renderFinal$flush$lambda(this$0));
      this$0.f5g_1.m6();
      this$0.b5g_1.p5g_1.n1y();
    }
  }
  function Bitmap32Context2d$renderFinal$flush$lambda(this$0) {
    return function (x0, x1, y) {
      this$0.f5g_1.j5g(x0, x1, y);
      return Unit_instance;
    };
  }
  function Bitmap32Context2d(bmp, antialiasing) {
    Renderer.call(this);
    this.y5f_1 = bmp;
    this.z5f_1 = antialiasing;
    this.a5g_1 = this.y5f_1.x3a_1.d2m();
    this.b5g_1 = new Rasterizer();
    this.c5g_1 = new ColorFiller();
    this.d5g_1 = new GradientFiller();
    this.e5g_1 = new BitmapFiller();
    this.f5g_1 = new ScanlineWriter(this);
    this.g5g_1 = new VectorPath(VOID, VOID, Winding_EVEN_ODD_getInstance());
    this.h5g_1 = new StrokeToFill();
  }
  protoOf(Bitmap32Context2d).x1q = function () {
    return this.y5f_1.t39_1;
  };
  protoOf(Bitmap32Context2d).y1q = function () {
    return this.y5f_1.u39_1;
  };
  protoOf(Bitmap32Context2d).w5g = function (state, fill, winding) {
    var style = fill ? state.b3v_1 : state.a3v_1;
    var tmp;
    if (style instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (style instanceof RGBA) {
        tmp = this.c5g_1.j5a(style.b3s_1, state);
      } else {
        if (style instanceof GradientPaint) {
          tmp = this.d5g_1.r5a(style, state);
        } else {
          if (style instanceof BitmapPaint) {
            tmp = this.e5g_1.f5b(style, state);
          } else {
            throw new NotImplementedError();
          }
        }
      }
    }
    var filler = tmp;
    this.f5g_1.k5f_1 = state.i3v_1;
    this.b5g_1.n1y();
    this.b5g_1.m5g_1 = this.x5g_1;
    var doingStroke = !fill;
    var tmp_0;
    if (fill) {
      tmp_0 = state.t3u_1;
    } else {
      this.g5g_1.b3();
      var tmp1_$receiver = state.t3u_1;
      var tmp2_lineWidth = state.z5g();
      var tmp3_joins = state.y3u_1;
      var tmp4_startCap = state.w3u_1;
      var tmp5_endCap = state.x3u_1;
      var tmp6_miterLimit = state.z3u_1;
      var tmp7_temp = this.h5g_1;
      var tmp8_outFill = this.g5g_1;
      var tmp9_lineDash = state.j3v_1;
      var tmp10_lineDashOffset = state.k3v_1;
      tmp_0 = strokeToFill(tmp1_$receiver, tmp2_lineWidth, tmp3_joins, tmp4_startCap, tmp5_endCap, tmp6_miterLimit, tmp9_lineDash, tmp10_lineDashOffset, tmp7_temp, tmp8_outFill);
    }
    var fillPath = tmp_0;
    if (!(state.s3u_1 == null)) {
      this.b5g_1.q5g_1.g30_1 = ensureNotNull(state.s3u_1).w2u_1;
      // Inline function 'korlibs.math.geom.shape.emitPoints2' call
      var this_0 = ensureNotNull(state.s3u_1);
      var i = Vector2D_init_$Create$_1();
      var l = Vector2D_init_$Create$_1();
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.b5g_1.q5g_1.p21();
      }
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
      var n = 0;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = this_0.u2u_1;
      var n_0 = 0;
      while (n_0 < this_1.n()) {
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
        var tmp0 = n_0;
        n_0 = tmp0 + 1 | 0;
        var tmp0_subject = this_1.b1r(tmp0);
        if (tmp0_subject === 0) {
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
          var tmp1 = n;
          n = tmp1 + 1 | 0;
          var tmp_1 = this_0.v2u_1.f1(tmp1);
          var tmp2 = n;
          n = tmp2 + 1 | 0;
          var it = new Vector2D(tmp_1, this_0.v2u_1.f1(tmp2));
          i = it;
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
          var x = it.cg();
          var y = it.dg();
          this.b5g_1.q5g_1.j31(x, y, true);
          l = it;
        } else {
          if (tmp0_subject === 1) {
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            var tmp3 = n;
            n = tmp3 + 1 | 0;
            var tmp_2 = this_0.v2u_1.f1(tmp3);
            var tmp4 = n;
            n = tmp4 + 1 | 0;
            var it_0 = new Vector2D(tmp_2, this_0.v2u_1.f1(tmp4));
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
            var x_0 = it_0.cg();
            var y_0 = it_0.dg();
            this.b5g_1.q5g_1.j31(x_0, y_0, false);
            l = it_0;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
          } else {
            if (tmp0_subject === 2) {
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
              var tmp5 = n;
              n = tmp5 + 1 | 0;
              var tmp_3 = this_0.v2u_1.f1(tmp5);
              var tmp6 = n;
              n = tmp6 + 1 | 0;
              var c = new Vector2D(tmp_3, this_0.v2u_1.f1(tmp6));
              var tmp7 = n;
              n = tmp7 + 1 | 0;
              var tmp_4 = this_0.v2u_1.f1(tmp7);
              var tmp8 = n;
              n = tmp8 + 1 | 0;
              var a = new Vector2D(tmp_4, this_0.v2u_1.f1(tmp8));
              var sum = Companion_getInstance_4().c2n(l, c) + Companion_getInstance_4().c2n(c, a);
              // Inline function 'korlibs.math.geom.shape.approximateCurve' call
              // Inline function 'kotlin.math.max' call
              var a_0 = numberToInt(sum);
              var rcurveSteps = Math.max(a_0, 20);
              var dt = 1.0 / rcurveSteps;
              var lastPos = {_v: Vector2D_init_$Create$_1()};
              var prevPos = {_v: Vector2D_init_$Create$_1()};
              var emittedCount = {_v: 0};
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              var ratio = Companion_getInstance_9().a28_1;
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              lastPos._v = Companion_getInstance_10().d2t(l, c, a, ratio);
              var nStart = false ? 0 : 1;
              var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
              var inductionVariable = nStart;
              if (inductionVariable <= nEnd)
                do {
                  var n_1 = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                  var it_1 = Companion_getInstance_10().d2t(l, c, a, ratio_0);
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                  var x_1 = it_1.cg();
                  var y_1 = it_1.dg();
                  this.b5g_1.q5g_1.j31(x_1, y_1, false);
                  emittedCount._v = emittedCount._v + 1 | 0;
                  lastPos._v = prevPos._v;
                  prevPos._v = it_1;
                }
                 while (!(n_1 === nEnd));
              l = a;
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            } else {
              if (tmp0_subject === 3) {
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                var tmp9 = n;
                n = tmp9 + 1 | 0;
                var tmp_5 = this_0.v2u_1.f1(tmp9);
                var tmp10 = n;
                n = tmp10 + 1 | 0;
                var c0 = new Vector2D(tmp_5, this_0.v2u_1.f1(tmp10));
                var tmp11 = n;
                n = tmp11 + 1 | 0;
                var tmp_6 = this_0.v2u_1.f1(tmp11);
                var tmp12 = n;
                n = tmp12 + 1 | 0;
                var c1 = new Vector2D(tmp_6, this_0.v2u_1.f1(tmp12));
                var tmp13 = n;
                n = tmp13 + 1 | 0;
                var tmp_7 = this_0.v2u_1.f1(tmp13);
                var tmp14 = n;
                n = tmp14 + 1 | 0;
                var a_1 = new Vector2D(tmp_7, this_0.v2u_1.f1(tmp14));
                var sum_0 = Companion_getInstance_4().c2n(l, c0) + Companion_getInstance_4().c2n(c0, c1) + Companion_getInstance_4().c2n(c1, a_1);
                // Inline function 'korlibs.math.geom.shape.approximateCurve' call
                // Inline function 'kotlin.math.max' call
                var a_2 = numberToInt(sum_0);
                var rcurveSteps_0 = Math.max(a_2, 20);
                var dt_0 = 1.0 / rcurveSteps_0;
                var lastPos_0 = {_v: Vector2D_init_$Create$_1()};
                var prevPos_0 = {_v: Vector2D_init_$Create$_1()};
                var emittedCount_0 = {_v: 0};
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                var ratio_1 = Companion_getInstance_9().a28_1;
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                lastPos_0._v = Companion_getInstance_10().c2t(l, c0, c1, a_1, ratio_1);
                var nStart_0 = false ? 0 : 1;
                var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
                var inductionVariable_0 = nStart_0;
                if (inductionVariable_0 <= nEnd_0)
                  do {
                    var n_2 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
                    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                    // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                    var it_2 = Companion_getInstance_10().c2t(l, c0, c1, a_1, ratio_2);
                    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                    var x_2 = it_2.cg();
                    var y_2 = it_2.dg();
                    this.b5g_1.q5g_1.j31(x_2, y_2, false);
                    emittedCount_0._v = emittedCount_0._v + 1 | 0;
                    lastPos_0._v = prevPos_0._v;
                    prevPos_0._v = it_2;
                  }
                   while (!(n_2 === nEnd_0));
                l = a_1;
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
              } else {
                if (tmp0_subject === 4) {
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                  // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                  var name_for_destructuring_parameter_0_fjsvno = i;
                  var x_3 = name_for_destructuring_parameter_0_fjsvno.cg();
                  var y_3 = name_for_destructuring_parameter_0_fjsvno.dg();
                  this.b5g_1.q5g_1.j31(x_3, y_3, false);
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                  // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                  if (true) {
                    this.b5g_1.q5g_1.p21();
                  }
                }
              }
            }
          }
        }
      }
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.b5g_1.q5g_1.p21();
      }
    }
    var tmp_8 = this.b5g_1.p5g_1;
    tmp_8.g30_1 = winding == null ? ensureNotNull(state.t3u_1).w2u_1 : winding;
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i_0 = Vector2D_init_$Create$_1();
    var l_0 = Vector2D_init_$Create$_1();
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.b5g_1.p5g_1.p21();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n_3 = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = fillPath.u2u_1;
    var n_4 = 0;
    while (n_4 < this_2.n()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0_0 = n_4;
      n_4 = tmp0_0 + 1 | 0;
      var tmp0_subject_0 = this_2.b1r(tmp0_0);
      if (tmp0_subject_0 === 0) {
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
        var tmp1_0 = n_3;
        n_3 = tmp1_0 + 1 | 0;
        var tmp_9 = fillPath.v2u_1.f1(tmp1_0);
        var tmp2_0 = n_3;
        n_3 = tmp2_0 + 1 | 0;
        var it_3 = new Vector2D(tmp_9, fillPath.v2u_1.f1(tmp2_0));
        i_0 = it_3;
        // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
        var x_4 = it_3.cg();
        var y_4 = it_3.dg();
        if (doingStroke) {
          if (true) {
            renderFinal$flush(this, filler, state, winding, fillPath);
          }
        }
        this.b5g_1.p5g_1.j31(x_4, y_4, true);
        l_0 = it_3;
      } else {
        if (tmp0_subject_0 === 1) {
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
          var tmp3_0 = n_3;
          n_3 = tmp3_0 + 1 | 0;
          var tmp_10 = fillPath.v2u_1.f1(tmp3_0);
          var tmp4_0 = n_3;
          n_3 = tmp4_0 + 1 | 0;
          var it_4 = new Vector2D(tmp_10, fillPath.v2u_1.f1(tmp4_0));
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
          var x_5 = it_4.cg();
          var y_5 = it_4.dg();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }
          this.b5g_1.p5g_1.j31(x_5, y_5, false);
          l_0 = it_4;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
        } else {
          if (tmp0_subject_0 === 2) {
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            var tmp5_0 = n_3;
            n_3 = tmp5_0 + 1 | 0;
            var tmp_11 = fillPath.v2u_1.f1(tmp5_0);
            var tmp6_0 = n_3;
            n_3 = tmp6_0 + 1 | 0;
            var c_0 = new Vector2D(tmp_11, fillPath.v2u_1.f1(tmp6_0));
            var tmp7_0 = n_3;
            n_3 = tmp7_0 + 1 | 0;
            var tmp_12 = fillPath.v2u_1.f1(tmp7_0);
            var tmp8_0 = n_3;
            n_3 = tmp8_0 + 1 | 0;
            var a_3 = new Vector2D(tmp_12, fillPath.v2u_1.f1(tmp8_0));
            var sum_1 = Companion_getInstance_4().c2n(l_0, c_0) + Companion_getInstance_4().c2n(c_0, a_3);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call
            // Inline function 'kotlin.math.max' call
            var a_4 = numberToInt(sum_1);
            var rcurveSteps_1 = Math.max(a_4, 20);
            var dt_1 = 1.0 / rcurveSteps_1;
            var lastPos_1 = {_v: Vector2D_init_$Create$_1()};
            var prevPos_1 = {_v: Vector2D_init_$Create$_1()};
            var emittedCount_1 = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            var ratio_3 = Companion_getInstance_9().a28_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            lastPos_1._v = Companion_getInstance_10().d2t(l_0, c_0, a_3, ratio_3);
            var nStart_1 = false ? 0 : 1;
            var nEnd_1 = true ? rcurveSteps_1 : rcurveSteps_1 - 1 | 0;
            var inductionVariable_1 = nStart_1;
            if (inductionVariable_1 <= nEnd_1)
              do {
                var n_5 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var ratio_4 = _Ratio___init__impl__9mwvn2_0(n_5 * dt_1);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_5 = Companion_getInstance_10().d2t(l_0, c_0, a_3, ratio_4);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_6 = it_5.cg();
                var y_6 = it_5.dg();
                if (doingStroke) {
                  if (false) {
                    renderFinal$flush(this, filler, state, winding, fillPath);
                  }
                }
                this.b5g_1.p5g_1.j31(x_6, y_6, false);
                emittedCount_1._v = emittedCount_1._v + 1 | 0;
                lastPos_1._v = prevPos_1._v;
                prevPos_1._v = it_5;
              }
               while (!(n_5 === nEnd_1));
            l_0 = a_3;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
          } else {
            if (tmp0_subject_0 === 3) {
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
              var tmp9_0 = n_3;
              n_3 = tmp9_0 + 1 | 0;
              var tmp_13 = fillPath.v2u_1.f1(tmp9_0);
              var tmp10_0 = n_3;
              n_3 = tmp10_0 + 1 | 0;
              var c0_0 = new Vector2D(tmp_13, fillPath.v2u_1.f1(tmp10_0));
              var tmp11_0 = n_3;
              n_3 = tmp11_0 + 1 | 0;
              var tmp_14 = fillPath.v2u_1.f1(tmp11_0);
              var tmp12_0 = n_3;
              n_3 = tmp12_0 + 1 | 0;
              var c1_0 = new Vector2D(tmp_14, fillPath.v2u_1.f1(tmp12_0));
              var tmp13_0 = n_3;
              n_3 = tmp13_0 + 1 | 0;
              var tmp_15 = fillPath.v2u_1.f1(tmp13_0);
              var tmp14_0 = n_3;
              n_3 = tmp14_0 + 1 | 0;
              var a_5 = new Vector2D(tmp_15, fillPath.v2u_1.f1(tmp14_0));
              var sum_2 = Companion_getInstance_4().c2n(l_0, c0_0) + Companion_getInstance_4().c2n(c0_0, c1_0) + Companion_getInstance_4().c2n(c1_0, a_5);
              // Inline function 'korlibs.math.geom.shape.approximateCurve' call
              // Inline function 'kotlin.math.max' call
              var a_6 = numberToInt(sum_2);
              var rcurveSteps_2 = Math.max(a_6, 20);
              var dt_2 = 1.0 / rcurveSteps_2;
              var lastPos_2 = {_v: Vector2D_init_$Create$_1()};
              var prevPos_2 = {_v: Vector2D_init_$Create$_1()};
              var emittedCount_2 = {_v: 0};
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              var ratio_5 = Companion_getInstance_9().a28_1;
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              lastPos_2._v = Companion_getInstance_10().c2t(l_0, c0_0, c1_0, a_5, ratio_5);
              var nStart_2 = false ? 0 : 1;
              var nEnd_2 = true ? rcurveSteps_2 : rcurveSteps_2 - 1 | 0;
              var inductionVariable_2 = nStart_2;
              if (inductionVariable_2 <= nEnd_2)
                do {
                  var n_6 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var ratio_6 = _Ratio___init__impl__9mwvn2_0(n_6 * dt_2);
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                  var it_6 = Companion_getInstance_10().c2t(l_0, c0_0, c1_0, a_5, ratio_6);
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                  var x_7 = it_6.cg();
                  var y_7 = it_6.dg();
                  if (doingStroke) {
                    if (false) {
                      renderFinal$flush(this, filler, state, winding, fillPath);
                    }
                  }
                  this.b5g_1.p5g_1.j31(x_7, y_7, false);
                  emittedCount_2._v = emittedCount_2._v + 1 | 0;
                  lastPos_2._v = prevPos_2._v;
                  prevPos_2._v = it_6;
                }
                 while (!(n_6 === nEnd_2));
              l_0 = a_5;
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            } else {
              if (tmp0_subject_0 === 4) {
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var name_for_destructuring_parameter_0_fjsvno_0 = i_0;
                var x_8 = name_for_destructuring_parameter_0_fjsvno_0.cg();
                var y_8 = name_for_destructuring_parameter_0_fjsvno_0.dg();
                if (doingStroke) {
                  if (false) {
                    renderFinal$flush(this, filler, state, winding, fillPath);
                  }
                }
                this.b5g_1.p5g_1.j31(x_8, y_8, false);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                if (true) {
                  this.b5g_1.p5g_1.p21();
                }
              }
            }
          }
        }
      }
    }
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.b5g_1.p5g_1.p21();
    }
    renderFinal$flush(this, filler, state, winding, fillPath);
  };
  function CompositeOperation$Companion$UNIMPLEMENTED$lambda(dst, dstN, src, srcN, count) {
    mix_0(dst.w3s_1, dstN, src.w3s_1, srcN, count);
    return Unit_instance;
  }
  function CompositeOperation$Companion$invoke$1($func) {
    this.g5h_1 = $func;
  }
  protoOf(CompositeOperation$Companion$invoke$1).l5g = function (dst, dstN, src, srcN, count) {
    return this.g5h_1(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count);
  };
  function Companion_37() {
    Companion_instance_45 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_52();
    tmp.h5h_1 = tmp_0.i5h(CompositeOperation$Companion$UNIMPLEMENTED$lambda);
  }
  protoOf(Companion_37).i5h = function (func) {
    return new CompositeOperation$Companion$invoke$1(func);
  };
  var Companion_instance_45;
  function Companion_getInstance_52() {
    if (Companion_instance_45 == null)
      new Companion_37();
    return Companion_instance_45;
  }
  var CompositeMode_CLEAR_instance;
  var CompositeMode_COPY_instance;
  var CompositeMode_SOURCE_OVER_instance;
  var CompositeMode_DESTINATION_OVER_instance;
  var CompositeMode_SOURCE_IN_instance;
  var CompositeMode_DESTINATION_IN_instance;
  var CompositeMode_SOURCE_OUT_instance;
  var CompositeMode_DESTINATION_OUT_instance;
  var CompositeMode_SOURCE_ATOP_instance;
  var CompositeMode_DESTINATION_ATOP_instance;
  var CompositeMode_XOR_instance;
  var CompositeMode_LIGHTER_instance;
  function Companion_38() {
  }
  protoOf(Companion_38).f34 = function () {
    return CompositeMode_SOURCE_OVER_getInstance();
  };
  var Companion_instance_46;
  function Companion_getInstance_53() {
    return Companion_instance_46;
  }
  function CompositeMode$lambda(dst, dstN, src, srcN, count) {
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = RgbaPremultipliedArray__get_impl_1u69ta(dst.w3s_1, dstN + n | 0);
        var s = RgbaPremultipliedArray__get_impl_1u69ta(src.w3s_1, srcN + n | 0);
        var tmp = dstN + n | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(d);
        RgbaPremultipliedArray__set_impl_7fwbby(dst.w3s_1, tmp, _RGBA___get_premultiplied__impl__3bulqc(RGBA__withA_impl_vogscm(tmp$ret$0, clampUByte(_RGBAPremultiplied___get_a__impl__f0hnd1(d) - _RGBAPremultiplied___get_a__impl__f0hnd1(s) | 0))));
      }
       while (inductionVariable < count);
    return Unit_instance;
  }
  function CompositeMode$lambda_0(dst, dstN, src, srcN, count) {
    mix_1(dst.w3s_1, dstN, dst.w3s_1, dstN, src.w3s_1, srcN, count);
    return Unit_instance;
  }
  function CompositeMode$lambda_1(dst, dstN, src, srcN, count) {
    mix_1(dst.w3s_1, dstN, src.w3s_1, srcN, dst.w3s_1, dstN, count);
    return Unit_instance;
  }
  var CompositeMode_entriesInitialized;
  function CompositeMode_initEntries() {
    if (CompositeMode_entriesInitialized)
      return Unit_instance;
    CompositeMode_entriesInitialized = true;
    var tmp = Companion_getInstance_52();
    CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.i5h(CompositeMode$lambda));
    CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_52().h5h_1);
    var tmp_0 = Companion_getInstance_52();
    CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.i5h(CompositeMode$lambda_0));
    var tmp_1 = Companion_getInstance_52();
    CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.i5h(CompositeMode$lambda_1));
    CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_52().h5h_1);
    CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_52().h5h_1);
    CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_52().h5h_1);
    CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_52().h5h_1);
    CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_52().h5h_1);
    CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_52().h5h_1);
    CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_52().h5h_1);
    CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_52().h5h_1);
  }
  function CompositeMode(name, ordinal, op) {
    Enum.call(this, name, ordinal);
    this.l5h_1 = op;
  }
  protoOf(CompositeMode).l5g = function (dst, dstN, src, srcN, count) {
    this.l5h_1.l5g(dst, dstN, src, srcN, count);
  };
  function get_DEFAULT(_this__u8e3s4) {
    return Companion_instance_46.f34();
  }
  var BlendMode_NORMAL_instance;
  var BlendMode_MULTIPLY_instance;
  var BlendMode_SCREEN_instance;
  var BlendMode_OVERLAY_instance;
  var BlendMode_DARKEN_instance;
  var BlendMode_LIGHTEN_instance;
  var BlendMode_COLOR_DODGE_instance;
  var BlendMode_COLOR_BURN_instance;
  var BlendMode_HARD_LIGHT_instance;
  var BlendMode_SOFT_LIGHT_instance;
  var BlendMode_DIFFERENCE_instance;
  var BlendMode_EXCLUSION_instance;
  var BlendMode_HUE_instance;
  var BlendMode_SATURATION_instance;
  var BlendMode_COLOR_instance;
  var BlendMode_LUMINOSITY_instance;
  var BlendMode_ADDITION_instance;
  var BlendMode_SUBTRACT_instance;
  var BlendMode_DIVIDE_instance;
  var BlendMode_entriesInitialized;
  function BlendMode_initEntries() {
    if (BlendMode_entriesInitialized)
      return Unit_instance;
    BlendMode_entriesInitialized = true;
    BlendMode_NORMAL_instance = new BlendMode('NORMAL', 0, Companion_getInstance_52().h5h_1);
    BlendMode_MULTIPLY_instance = new BlendMode('MULTIPLY', 1, Companion_getInstance_52().h5h_1);
    BlendMode_SCREEN_instance = new BlendMode('SCREEN', 2, Companion_getInstance_52().h5h_1);
    BlendMode_OVERLAY_instance = new BlendMode('OVERLAY', 3, Companion_getInstance_52().h5h_1);
    BlendMode_DARKEN_instance = new BlendMode('DARKEN', 4, Companion_getInstance_52().h5h_1);
    BlendMode_LIGHTEN_instance = new BlendMode('LIGHTEN', 5, Companion_getInstance_52().h5h_1);
    BlendMode_COLOR_DODGE_instance = new BlendMode('COLOR_DODGE', 6, Companion_getInstance_52().h5h_1);
    BlendMode_COLOR_BURN_instance = new BlendMode('COLOR_BURN', 7, Companion_getInstance_52().h5h_1);
    BlendMode_HARD_LIGHT_instance = new BlendMode('HARD_LIGHT', 8, Companion_getInstance_52().h5h_1);
    BlendMode_SOFT_LIGHT_instance = new BlendMode('SOFT_LIGHT', 9, Companion_getInstance_52().h5h_1);
    BlendMode_DIFFERENCE_instance = new BlendMode('DIFFERENCE', 10, Companion_getInstance_52().h5h_1);
    BlendMode_EXCLUSION_instance = new BlendMode('EXCLUSION', 11, Companion_getInstance_52().h5h_1);
    BlendMode_HUE_instance = new BlendMode('HUE', 12, Companion_getInstance_52().h5h_1);
    BlendMode_SATURATION_instance = new BlendMode('SATURATION', 13, Companion_getInstance_52().h5h_1);
    BlendMode_COLOR_instance = new BlendMode('COLOR', 14, Companion_getInstance_52().h5h_1);
    BlendMode_LUMINOSITY_instance = new BlendMode('LUMINOSITY', 15, Companion_getInstance_52().h5h_1);
    BlendMode_ADDITION_instance = new BlendMode('ADDITION', 16, Companion_getInstance_52().h5h_1);
    BlendMode_SUBTRACT_instance = new BlendMode('SUBTRACT', 17, Companion_getInstance_52().h5h_1);
    BlendMode_DIVIDE_instance = new BlendMode('DIVIDE', 18, Companion_getInstance_52().h5h_1);
  }
  function BlendMode(name, ordinal, op) {
    Enum.call(this, name, ordinal);
    this.o5h_1 = op;
  }
  protoOf(BlendMode).l5g = function (dst, dstN, src, srcN, count) {
    this.o5h_1.l5g(dst, dstN, src, srcN, count);
  };
  function CompositeMode_SOURCE_OVER_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_SOURCE_OVER_instance;
  }
  function BlendMode_NORMAL_getInstance() {
    BlendMode_initEntries();
    return BlendMode_NORMAL_instance;
  }
  function BlendMode_MULTIPLY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_MULTIPLY_instance;
  }
  function BlendMode_SCREEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SCREEN_instance;
  }
  function BlendMode_OVERLAY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_OVERLAY_instance;
  }
  function BlendMode_DARKEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DARKEN_instance;
  }
  function BlendMode_LIGHTEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_LIGHTEN_instance;
  }
  function BlendMode_COLOR_DODGE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_DODGE_instance;
  }
  function BlendMode_COLOR_BURN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_BURN_instance;
  }
  function BlendMode_HARD_LIGHT_getInstance() {
    BlendMode_initEntries();
    return BlendMode_HARD_LIGHT_instance;
  }
  function BlendMode_SOFT_LIGHT_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SOFT_LIGHT_instance;
  }
  function BlendMode_DIFFERENCE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DIFFERENCE_instance;
  }
  function BlendMode_EXCLUSION_getInstance() {
    BlendMode_initEntries();
    return BlendMode_EXCLUSION_instance;
  }
  function BlendMode_HUE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_HUE_instance;
  }
  function BlendMode_SATURATION_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SATURATION_instance;
  }
  function BlendMode_COLOR_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_instance;
  }
  function BlendMode_LUMINOSITY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_LUMINOSITY_instance;
  }
  function BlendMode_ADDITION_getInstance() {
    BlendMode_initEntries();
    return BlendMode_ADDITION_instance;
  }
  function BlendMode_SUBTRACT_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SUBTRACT_instance;
  }
  function BlendMode_DIVIDE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DIVIDE_instance;
  }
  function Context2d$State$transformTransform$delegate$lambda(this$0) {
    return function () {
      return this$0.r3u_1.v2g();
    };
  }
  function State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    transform = transform === VOID ? Companion_getInstance_3().e2f_1 : transform;
    clip = clip === VOID ? null : clip;
    path = path === VOID ? new VectorPath() : path;
    lineScaleMode = lineScaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : lineScaleMode;
    lineWidth = lineWidth === VOID ? 1.0 : lineWidth;
    startLineCap = startLineCap === VOID ? LineCap_BUTT_getInstance() : startLineCap;
    endLineCap = endLineCap === VOID ? LineCap_BUTT_getInstance() : endLineCap;
    lineJoin = lineJoin === VOID ? LineJoin_MITER_getInstance() : lineJoin;
    miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
    strokeStyle = strokeStyle === VOID ? new RGBA(get_DefaultPaint()) : strokeStyle;
    fillStyle = fillStyle === VOID ? new RGBA(get_DefaultPaint()) : fillStyle;
    fontRegistry = fontRegistry === VOID ? null : fontRegistry;
    font = font === VOID ? null : font;
    fontSize = fontSize === VOID ? 24.0 : fontSize;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_48().d5c_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_49().i5c_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? CompositeMode_SOURCE_OVER_getInstance() : globalCompositeOperation;
    lineDash = lineDash === VOID ? null : lineDash;
    lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
    this.r3u_1 = transform;
    this.s3u_1 = clip;
    this.t3u_1 = path;
    this.u3u_1 = lineScaleMode;
    this.v3u_1 = lineWidth;
    this.w3u_1 = startLineCap;
    this.x3u_1 = endLineCap;
    this.y3u_1 = lineJoin;
    this.z3u_1 = miterLimit;
    this.a3v_1 = strokeStyle;
    this.b3v_1 = fillStyle;
    this.c3v_1 = fontRegistry;
    this.d3v_1 = font;
    this.e3v_1 = fontSize;
    this.f3v_1 = verticalAlign;
    this.g3v_1 = horizontalAlign;
    this.h3v_1 = globalAlpha;
    this.i3v_1 = globalCompositeOperation;
    this.j3v_1 = lineDash;
    this.k3v_1 = lineDashOffset;
    var tmp = this;
    tmp.l3v_1 = lazy(Context2d$State$transformTransform$delegate$lambda(this));
  }
  protoOf(State).p5h = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l3v_1;
    transformTransform$factory();
    return this_0.m2();
  };
  protoOf(State).z5g = function () {
    var tmp = this.v3u_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.p5h().s2h();
    return tmp * Math.abs(this_0);
  };
  protoOf(State).x44 = function (value) {
    this.w3u_1 = value;
    this.x3u_1 = value;
  };
  protoOf(State).q44 = function () {
    return this.w3u_1;
  };
  protoOf(State).g1s = function () {
    var tmp = this.r3u_1;
    var tmp0_safe_receiver = this.s3u_1;
    var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g1s();
    var tmp_1 = this.t3u_1.g1s();
    var tmp1_safe_receiver = this.j3v_1;
    return this.q5h(tmp, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.g1s());
  };
  protoOf(State).r5h = function (transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    return new State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  };
  protoOf(State).q5h = function (transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset, $super) {
    transform = transform === VOID ? this.r3u_1 : transform;
    clip = clip === VOID ? this.s3u_1 : clip;
    path = path === VOID ? this.t3u_1 : path;
    lineScaleMode = lineScaleMode === VOID ? this.u3u_1 : lineScaleMode;
    lineWidth = lineWidth === VOID ? this.v3u_1 : lineWidth;
    startLineCap = startLineCap === VOID ? this.w3u_1 : startLineCap;
    endLineCap = endLineCap === VOID ? this.x3u_1 : endLineCap;
    lineJoin = lineJoin === VOID ? this.y3u_1 : lineJoin;
    miterLimit = miterLimit === VOID ? this.z3u_1 : miterLimit;
    strokeStyle = strokeStyle === VOID ? this.a3v_1 : strokeStyle;
    fillStyle = fillStyle === VOID ? this.b3v_1 : fillStyle;
    fontRegistry = fontRegistry === VOID ? this.c3v_1 : fontRegistry;
    font = font === VOID ? this.d3v_1 : font;
    fontSize = fontSize === VOID ? this.e3v_1 : fontSize;
    verticalAlign = verticalAlign === VOID ? this.f3v_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? this.g3v_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? this.h3v_1 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? this.i3v_1 : globalCompositeOperation;
    lineDash = lineDash === VOID ? this.j3v_1 : lineDash;
    lineDashOffset = lineDashOffset === VOID ? this.k3v_1 : lineDashOffset;
    return $super === VOID ? this.r5h(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) : $super.r5h.call(this, transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, new VerticalAlign(verticalAlign), new HorizontalAlign(horizontalAlign), globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  };
  protoOf(State).toString = function () {
    return 'State(transform=' + this.r3u_1 + ', clip=' + this.s3u_1 + ', path=' + this.t3u_1 + ', lineScaleMode=' + this.u3u_1 + ', lineWidth=' + this.v3u_1 + ', startLineCap=' + this.w3u_1 + ', endLineCap=' + this.x3u_1 + ', lineJoin=' + this.y3u_1 + ', miterLimit=' + this.z3u_1 + ', strokeStyle=' + this.a3v_1 + ', fillStyle=' + this.b3v_1 + ', fontRegistry=' + this.c3v_1 + ', font=' + this.d3v_1 + ', fontSize=' + this.e3v_1 + ', verticalAlign=' + new VerticalAlign(this.f3v_1) + ', horizontalAlign=' + new HorizontalAlign(this.g3v_1) + ', globalAlpha=' + this.h3v_1 + ', globalCompositeOperation=' + this.i3v_1 + ', lineDash=' + this.j3v_1 + ', lineDashOffset=' + this.k3v_1 + ')';
  };
  protoOf(State).hashCode = function () {
    var result = this.r3u_1.hashCode();
    result = imul(result, 31) + (this.s3u_1 == null ? 0 : this.s3u_1.hashCode()) | 0;
    result = imul(result, 31) + this.t3u_1.hashCode() | 0;
    result = imul(result, 31) + this.u3u_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.v3u_1) | 0;
    result = imul(result, 31) + this.w3u_1.hashCode() | 0;
    result = imul(result, 31) + this.x3u_1.hashCode() | 0;
    result = imul(result, 31) + this.y3u_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.z3u_1) | 0;
    result = imul(result, 31) + hashCode(this.a3v_1) | 0;
    result = imul(result, 31) + hashCode(this.b3v_1) | 0;
    result = imul(result, 31) + (this.c3v_1 == null ? 0 : hashCode(this.c3v_1)) | 0;
    result = imul(result, 31) + (this.d3v_1 == null ? 0 : hashCode(this.d3v_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e3v_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.f3v_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.g3v_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h3v_1) | 0;
    result = imul(result, 31) + hashCode(this.i3v_1) | 0;
    result = imul(result, 31) + (this.j3v_1 == null ? 0 : hashCode(this.j3v_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k3v_1) | 0;
    return result;
  };
  protoOf(State).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this.r3u_1.equals(tmp0_other_with_cast.r3u_1))
      return false;
    if (!equals(this.s3u_1, tmp0_other_with_cast.s3u_1))
      return false;
    if (!this.t3u_1.equals(tmp0_other_with_cast.t3u_1))
      return false;
    if (!this.u3u_1.equals(tmp0_other_with_cast.u3u_1))
      return false;
    if (!equals(this.v3u_1, tmp0_other_with_cast.v3u_1))
      return false;
    if (!this.w3u_1.equals(tmp0_other_with_cast.w3u_1))
      return false;
    if (!this.x3u_1.equals(tmp0_other_with_cast.x3u_1))
      return false;
    if (!this.y3u_1.equals(tmp0_other_with_cast.y3u_1))
      return false;
    if (!equals(this.z3u_1, tmp0_other_with_cast.z3u_1))
      return false;
    if (!equals(this.a3v_1, tmp0_other_with_cast.a3v_1))
      return false;
    if (!equals(this.b3v_1, tmp0_other_with_cast.b3v_1))
      return false;
    if (!equals(this.c3v_1, tmp0_other_with_cast.c3v_1))
      return false;
    if (!equals(this.d3v_1, tmp0_other_with_cast.d3v_1))
      return false;
    if (!equals(this.e3v_1, tmp0_other_with_cast.e3v_1))
      return false;
    if (!equals(this.f3v_1, tmp0_other_with_cast.f3v_1))
      return false;
    if (!equals(this.g3v_1, tmp0_other_with_cast.g3v_1))
      return false;
    if (!equals(this.h3v_1, tmp0_other_with_cast.h3v_1))
      return false;
    if (!equals(this.i3v_1, tmp0_other_with_cast.i3v_1))
      return false;
    if (!equals(this.j3v_1, tmp0_other_with_cast.j3v_1))
      return false;
    if (!equals(this.k3v_1, tmp0_other_with_cast.k3v_1))
      return false;
    return true;
  };
  function trans($this, p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = $this.i3i_1.r3u_1;
      if (this_0.p2d()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = new Vector2D(this_0.w2f(p.g28_1, p.h28_1), this_0.z2f(p.g28_1, p.h28_1));
    }
    return tmp$ret$0;
  }
  function Context2d(renderer, defaultFontRegistry, defaultFont) {
    defaultFontRegistry = defaultFontRegistry === VOID ? null : defaultFontRegistry;
    defaultFont = defaultFont === VOID ? null : defaultFont;
    this.f3i_1 = renderer;
    this.g3i_1 = defaultFontRegistry;
    this.h3i_1 = defaultFont;
    this.i3i_1 = new State(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.g3i_1, this.h3i_1);
    this.j3i_1 = _TGenStack___init__impl__yynjgt();
    this.k3i_1 = Vector2D_init_$Create$_1();
    this.l3i_1 = Vector2D_init_$Create$_1();
  }
  protoOf(Context2d).s5h = function () {
    return this.f3i_1.x1q();
  };
  protoOf(Context2d).t5h = function () {
    return this.f3i_1.y1q();
  };
  protoOf(Context2d).u5h = function (state, fill, winding) {
    return this.f3i_1.c5h(state, fill, winding);
  };
  protoOf(Context2d).v5h = function (state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.u5h(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.u5h.call(this, state, fill, winding);
    }
    return tmp;
  };
  protoOf(Context2d).w5h = function (image, pos, size, transform) {
    return this.f3i_1.f5h(image, pos, size, transform);
  };
  protoOf(Context2d).x5h = function () {
    return this.f3i_1.f1e();
  };
  protoOf(Context2d).y5h = function () {
    return this.f3i_1.a5h();
  };
  protoOf(Context2d).z5h = function () {
    return this.f3i_1.b5h();
  };
  protoOf(Context2d).x1q = function () {
    return this.s5h();
  };
  protoOf(Context2d).y1q = function () {
    return this.t5h();
  };
  protoOf(Context2d).f1e = function () {
    this.x5h();
  };
  protoOf(Context2d).a5i = function () {
    return this.y5h();
  };
  protoOf(Context2d).b5i = function () {
    return this.z5h();
  };
  protoOf(Context2d).c5i = function (value) {
    this.i3i_1.u3u_1 = value;
  };
  protoOf(Context2d).w44 = function (value) {
    this.i3i_1.v3u_1 = value;
  };
  protoOf(Context2d).p44 = function () {
    return this.i3i_1.v3u_1;
  };
  protoOf(Context2d).x44 = function (value) {
    this.i3i_1.x44(value);
  };
  protoOf(Context2d).q44 = function () {
    return this.i3i_1.q44();
  };
  protoOf(Context2d).z44 = function (value) {
    this.i3i_1.z3u_1 = value;
  };
  protoOf(Context2d).s44 = function () {
    return this.i3i_1.z3u_1;
  };
  protoOf(Context2d).d5i = function (value) {
    this.i3i_1.w3u_1 = value;
  };
  protoOf(Context2d).e5i = function (value) {
    this.i3i_1.x3u_1 = value;
  };
  protoOf(Context2d).y44 = function (value) {
    this.i3i_1.y3u_1 = value;
  };
  protoOf(Context2d).r44 = function () {
    return this.i3i_1.y3u_1;
  };
  protoOf(Context2d).f5i = function (value) {
    this.i3i_1.a3v_1 = value;
  };
  protoOf(Context2d).g5i = function () {
    return this.i3i_1.a3v_1;
  };
  protoOf(Context2d).o3v = function (value) {
    this.i3i_1.b3v_1 = value;
  };
  protoOf(Context2d).n3v = function () {
    return this.i3i_1.b3v_1;
  };
  protoOf(Context2d).r46 = function () {
    return this.i3i_1.d3v_1;
  };
  protoOf(Context2d).k3t = function () {
    return this.i3i_1.e3v_1;
  };
  protoOf(Context2d).w5d = function () {
    return this.i3i_1.f3v_1;
  };
  protoOf(Context2d).h5i = function () {
    return this.i3i_1.g3v_1;
  };
  protoOf(Context2d).i5i = function () {
    return Companion_getInstance_50().o5c(this.h5i(), this.w5d());
  };
  protoOf(Context2d).a45 = function (value) {
    this.i3i_1.j3v_1 = value;
  };
  protoOf(Context2d).t44 = function () {
    return this.i3i_1.j3v_1;
  };
  protoOf(Context2d).b45 = function (value) {
    this.i3i_1.k3v_1 = value;
  };
  protoOf(Context2d).u44 = function () {
    return this.i3i_1.k3v_1;
  };
  protoOf(Context2d).v44 = function () {
    TGenStack__push_impl_9yh33t(this.j3i_1, this.i3i_1.g1s());
  };
  protoOf(Context2d).d45 = function () {
    this.i3i_1 = TGenStack__pop_impl_qisxa0(this.j3i_1);
  };
  protoOf(Context2d).k4r = function (sx, sy) {
    this.i3i_1.r3u_1 = this.i3i_1.r3u_1.k2g(sx, sy);
  };
  protoOf(Context2d).m3v = function (sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    var tmp;
    if ($super === VOID) {
      this.k4r(sx, sy);
      tmp = Unit_instance;
    } else {
      tmp = $super.k4r.call(this, sx, sy);
    }
    return tmp;
  };
  protoOf(Context2d).o46 = function (tx, ty) {
    this.i3i_1.r3u_1 = this.i3i_1.r3u_1.s2g(tx, ty);
  };
  protoOf(Context2d).q46 = function (m) {
    this.i3i_1.r3u_1 = this.i3i_1.r3u_1.t2g(m);
  };
  protoOf(Context2d).j5i = function (_set____db54di) {
    this.k3i_1 = _set____db54di;
  };
  protoOf(Context2d).k5i = function () {
    return this.k3i_1;
  };
  protoOf(Context2d).l5i = function (_set____db54di) {
    this.l3i_1 = _set____db54di;
  };
  protoOf(Context2d).p33 = function () {
    return this.l3i_1;
  };
  protoOf(Context2d).o33 = function () {
    return this.i3i_1.t3u_1.o33();
  };
  protoOf(Context2d).p21 = function () {
    this.i3i_1.t3u_1.p21();
    this.l5i(this.k5i());
  };
  protoOf(Context2d).s2u = function (p) {
    this.i3i_1.t3u_1.s2u(trans(this, p));
    this.l5i(p);
    this.j5i(p);
  };
  protoOf(Context2d).f2v = function (p) {
    this.i3i_1.t3u_1.f2v(trans(this, p));
    this.l5i(p);
  };
  protoOf(Context2d).g2v = function (c, a) {
    this.i3i_1.t3u_1.g2v(trans(this, c), trans(this, a));
    this.l5i(a);
  };
  protoOf(Context2d).t2u = function (c1, c2, a) {
    this.i3i_1.t3u_1.t2u(trans(this, c1), trans(this, c2), trans(this, a));
    this.l5i(a);
  };
  protoOf(Context2d).j4r = function (path) {
    if (this.b1())
      this.i3i_1.t3u_1.w2u_1 = path.w2u_1;
    write_0(this, path);
  };
  protoOf(Context2d).y47 = function (d) {
    d.x47(this);
  };
  protoOf(Context2d).p3v = function (x, y, width, height) {
    this.c43();
    this.t33(x, y, width, height);
    this.l44();
  };
  protoOf(Context2d).c43 = function () {
    this.i3i_1.t3u_1 = new VectorPath();
  };
  protoOf(Context2d).k44 = function () {
    if (!equals(this.i3i_1.a3v_1, NonePaint_instance)) {
      this.v5h(this.i3i_1, false);
    }
  };
  protoOf(Context2d).m5i = function (winding) {
    if (!equals(this.i3i_1.b3v_1, NonePaint_instance)) {
      this.u5h(this.i3i_1, true, winding);
    }
  };
  protoOf(Context2d).l44 = function (winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.m5i(winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.m5i.call(this, winding);
    }
    return tmp;
  };
  protoOf(Context2d).n5i = function (paint, winding) {
    if (paint == null)
      return Unit_instance;
    // Inline function 'korlibs.image.vector.Context2d.fillStyle' call
    var oldStyle = this.n3v();
    this.o3v(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.fill.<anonymous>' call
      this.m5i(winding);
    }finally {
      this.o3v(oldStyle);
    }
  };
  protoOf(Context2d).o44 = function (paint, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.n5i(paint, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.n5i.call(this, paint, winding);
    }
    return tmp;
  };
  protoOf(Context2d).c45 = function (paint) {
    // Inline function 'korlibs.image.vector.Context2d.strokeStyle' call
    var oldStyle = this.g5i();
    this.f5i(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this.k44();
    }finally {
      this.f5i(oldStyle);
    }
  };
  protoOf(Context2d).o5i = function (path, winding) {
    if (!(path == null)) {
      if (this.i3i_1.s3u_1 == null) {
        this.i3i_1.s3u_1 = new VectorPath();
      }
      ensureNotNull(this.i3i_1.s3u_1).b3();
      ensureNotNull(this.i3i_1.s3u_1).w2u_1 = winding;
      ensureNotNull(this.i3i_1.s3u_1).k34(path);
      if (path === this.i3i_1.t3u_1) {
        path.b3();
      }
    } else {
      this.i3i_1.s3u_1 = null;
    }
  };
  protoOf(Context2d).p5i = function (path, winding, $super) {
    path = path === VOID ? this.i3i_1.t3u_1 : path;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.o5i(path, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.o5i.call(this, path, winding);
    }
    return tmp;
  };
  protoOf(Context2d).q5i = function (text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) {
    var paint_0 = paint == null ? fill ? this.n3v() : this.g5i() : paint;
    return font == null ? null : drawText(font, this, size, text, paint_0, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  };
  protoOf(Context2d).r5i = function (text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, $super) {
    pos = pos === VOID ? Companion_getInstance_4().d2d_1 : pos;
    fill = fill === VOID ? true : fill;
    paint = paint === VOID ? null : paint;
    font = font === VOID ? this.r46() : font;
    size = size === VOID ? this.k3t() : size;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? this.i5i() : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? IntCompanionObject_instance.MAX_VALUE : textRangeEnd;
    return $super === VOID ? this.q5i(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) : $super.q5i.call(this, text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  };
  protoOf(Context2d).q3v = function (image, pos, size) {
    return this.w5h(image, pos, size, this.i3i_1.r3u_1);
  };
  protoOf(Context2d).m58 = function (image, pos, size, $super) {
    size = size === VOID ? toFloat(image.n()) : size;
    var tmp;
    if ($super === VOID) {
      this.q3v(image, pos, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.q3v.call(this, image, pos, size);
    }
    return tmp;
  };
  function write_0(_this__u8e3s4, path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.u2u_1;
    var n_0 = 0;
    while (n_0 < this_0.n()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var tmp0_subject = this_0.b1r(tmp0);
      if (tmp0_subject === 0) {
        // Inline function 'korlibs.image.vector.write.<anonymous>' call
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var tmp = path.v2u_1.f1(tmp1);
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var it = new Vector2D(tmp, path.v2u_1.f1(tmp2));
        _this__u8e3s4.s2u(it);
      } else {
        if (tmp0_subject === 1) {
          // Inline function 'korlibs.image.vector.write.<anonymous>' call
          var tmp3 = n;
          n = tmp3 + 1 | 0;
          var tmp_0 = path.v2u_1.f1(tmp3);
          var tmp4 = n;
          n = tmp4 + 1 | 0;
          var it_0 = new Vector2D(tmp_0, path.v2u_1.f1(tmp4));
          _this__u8e3s4.f2v(it_0);
        } else {
          if (tmp0_subject === 2) {
            // Inline function 'korlibs.image.vector.write.<anonymous>' call
            var tmp5 = n;
            n = tmp5 + 1 | 0;
            var tmp_1 = path.v2u_1.f1(tmp5);
            var tmp6 = n;
            n = tmp6 + 1 | 0;
            var c = new Vector2D(tmp_1, path.v2u_1.f1(tmp6));
            var tmp7 = n;
            n = tmp7 + 1 | 0;
            var tmp_2 = path.v2u_1.f1(tmp7);
            var tmp8 = n;
            n = tmp8 + 1 | 0;
            var a = new Vector2D(tmp_2, path.v2u_1.f1(tmp8));
            _this__u8e3s4.g2v(c, a);
          } else {
            if (tmp0_subject === 3) {
              // Inline function 'korlibs.image.vector.write.<anonymous>' call
              var tmp9 = n;
              n = tmp9 + 1 | 0;
              var tmp_3 = path.v2u_1.f1(tmp9);
              var tmp10 = n;
              n = tmp10 + 1 | 0;
              var c1 = new Vector2D(tmp_3, path.v2u_1.f1(tmp10));
              var tmp11 = n;
              n = tmp11 + 1 | 0;
              var tmp_4 = path.v2u_1.f1(tmp11);
              var tmp12 = n;
              n = tmp12 + 1 | 0;
              var c2 = new Vector2D(tmp_4, path.v2u_1.f1(tmp12));
              var tmp13 = n;
              n = tmp13 + 1 | 0;
              var tmp_5 = path.v2u_1.f1(tmp13);
              var tmp14 = n;
              n = tmp14 + 1 | 0;
              var a_0 = new Vector2D(tmp_5, path.v2u_1.f1(tmp14));
              _this__u8e3s4.t2u(c1, c2, a_0);
            } else {
              if (tmp0_subject === 4) {
                // Inline function 'korlibs.image.vector.write.<anonymous>' call
                _this__u8e3s4.p21();
              }
            }
          }
        }
      }
    }
  }
  function toBitmapPaint(_this__u8e3s4, state) {
    var filler = toFiller(_this__u8e3s4, state);
    var bb = Companion_getInstance_5().a2e();
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, state.t3u_1.u2r());
    var tmp = bb;
    var tmp0_safe_receiver = state.s3u_1;
    bb = BoundsBuilder__plus_impl_cz7f7x_0(tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u2r());
    var bounds = _BoundsBuilder___get_bounds__impl__s1l1gx(bb).p2l(state.r3u_1);
    // Inline function 'kotlin.also' call
    var this_0 = new Bitmap32(toIntCeil_0(bounds.n2d_1), toIntCeil_0(bounds.o2d_1), VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.toBitmapPaint.<anonymous>' call
    filler.n5a(this_0);
    var bmp = this_0;
    return new BitmapPaint(bmp, Companion_getInstance_3().h2f().o2g(-bounds.r2d(), -bounds.t2d()));
  }
  function transformTransform$factory() {
    return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
      return receiver.p5h();
    }, null);
  }
  var CycleMethod_NO_CYCLE_instance;
  var CycleMethod_NO_CYCLE_CLAMP_instance;
  var CycleMethod_REPEAT_instance;
  var CycleMethod_REFLECT_instance;
  function Companion_39() {
    Companion_instance_47 = this;
    this.s5i_1 = values_6();
  }
  var Companion_instance_47;
  function Companion_getInstance_54() {
    CycleMethod_initEntries();
    if (Companion_instance_47 == null)
      new Companion_39();
    return Companion_instance_47;
  }
  function values_6() {
    return [CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_CLAMP_getInstance(), CycleMethod_REPEAT_getInstance(), CycleMethod_REFLECT_getInstance()];
  }
  var CycleMethod_entriesInitialized;
  function CycleMethod_initEntries() {
    if (CycleMethod_entriesInitialized)
      return Unit_instance;
    CycleMethod_entriesInitialized = true;
    CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
    CycleMethod_NO_CYCLE_CLAMP_instance = new CycleMethod('NO_CYCLE_CLAMP', 1);
    CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
    CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 3);
    Companion_getInstance_54();
  }
  function CycleMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(CycleMethod).w5b = function () {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance()) ? !this.equals(CycleMethod_NO_CYCLE_CLAMP_getInstance()) : false;
  };
  protoOf(CycleMethod).t5b = function (ratio) {
    var tmp;
    switch (this.ka_1) {
      case 0:
        tmp = ratio;
        break;
      case 1:
        tmp = clamp01_0(ratio);
        break;
      case 2:
        // Inline function 'korlibs.math.fract' call

        tmp = ratio - toIntFloor(ratio);
        break;
      case 3:
        var part = umod(ratio, 2.0);
        tmp = part > 1.0 ? 2.0 - part : part;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(CycleMethod).t5i = function (ratio) {
    return this.t5b(ratio);
  };
  function _CycleMethodPair___init__impl__y6jlco(data) {
    return data;
  }
  function _CycleMethodPair___get_data__impl__r5ik0n($this) {
    return $this;
  }
  function _CycleMethodPair___init__impl__y6jlco_0(x, y) {
    return _CycleMethodPair___init__impl__y6jlco(insert8(insert8(0, x.ka_1, 0), y.ka_1, 8));
  }
  function _CycleMethodPair___get_x__impl__dgz5uj($this) {
    var tmp = Companion_getInstance_54().s5i_1;
    // Inline function 'korlibs.memory.extract8' call
    return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 0 | 0) & 255];
  }
  function _CycleMethodPair___get_y__impl__fcnb7o($this) {
    var tmp = Companion_getInstance_54().s5i_1;
    // Inline function 'korlibs.memory.extract8' call
    return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 8 | 0) & 255];
  }
  function CycleMethodPair__apply_impl_g3sekg($this, ratio) {
    return new Vector2D(_CycleMethodPair___get_x__impl__dgz5uj($this).t5i(ratio.g28_1), _CycleMethodPair___get_y__impl__fcnb7o($this).t5i(ratio.h28_1));
  }
  function CycleMethod_NO_CYCLE_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_NO_CYCLE_instance;
  }
  function CycleMethod_NO_CYCLE_CLAMP_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_NO_CYCLE_CLAMP_instance;
  }
  function CycleMethod_REPEAT_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_REPEAT_instance;
  }
  function CycleMethod_REFLECT_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_REFLECT_instance;
  }
  function draw_0(_this__u8e3s4, c) {
    c.j4r(_this__u8e3s4);
  }
  function draw_1(_this__u8e3s4, path) {
    _this__u8e3s4.j4r(path);
  }
  function msdfBmp(_this__u8e3s4, width, height) {
    var msdf_0 = msdf(_this__u8e3s4, width, height);
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width_0 = msdf_0.t39_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (msdf_0.u39_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = msdf_0.e3b(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width_0 | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            n = n + 1 | 0;
            // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
            var value = msdf_0.o3n(x, y);
            var tmp = 0 === 3 ? -100.0 : value;
            // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
            var value_0 = msdf_0.p3n(x, y);
            var tmp_0 = 1 === 3 ? -100.0 : value_0;
            // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
            var value_1 = msdf_0.q3n(x, y);
            var tmp_1 = 2 === 3 ? -100.0 : value_1;
            // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
            var value_2 = msdf_0.r3n(x, y);
            var tmp$ret$3 = 3 === 3 ? -100.0 : value_2;
            msdf_0.s3n(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    msdf_0.z3n(-1.0);
    msdf_0.b3o(-1.0, 1.0);
    msdf_0.y3n();
    var msdfBitmap = msdf_0.g3a();
    return msdfBitmap;
  }
  function sdfBmp(_this__u8e3s4, width, height) {
    var tmp = NewSDF_instance;
    var newImage = tmp.z3q(NativeImageContext2d(width, height, VOID, sdfBmp$lambda(_this__u8e3s4)).g3a(), VOID, 0);
    return newImage.s3q_1.e3i();
  }
  function msdf(_this__u8e3s4, width, height) {
    return msdf_0(_this__u8e3s4, new FloatBitmap32(width, height));
  }
  function msdf_0(_this__u8e3s4, data) {
    var path = _this__u8e3s4;
    var curvesList = toCurvesList(path);
    var p = Vector2D_init_$Create$_1();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(curvesList, 10));
    var tmp0_iterator = curvesList.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
      var tmp$ret$0 = colorize(item.h2r_1, item.i2r_1);
      destination.r(tmp$ret$0);
    }
    var colorizedCurves = destination;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = colorizedCurves.u();
    while (tmp0_iterator_0.v()) {
      var element = tmp0_iterator_0.x();
      // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
      var list = element.u5i_1;
      addAll(destination_0, list);
    }
    var allColorizedCurves = new ColorizedBeziers(destination_0);
    var inductionVariable = 0;
    var last = data.u39_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = data.t39_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            p = new Vector2D(x + 0.5, y + 0.5);
            var inside = path.i34(p);
            var allDist = allColorizedCurves.c5j().g5j(p);
            var redDist = allColorizedCurves.h5j().g5j(p);
            var greenDist = allColorizedCurves.i5j().g5j(p);
            var blueDist = allColorizedCurves.j5j().g5j(p);
            var minR = redDist;
            var minG = greenDist;
            var minB = blueDist;
            var minA = allDist;
            if (inside) {
              minR = -minR;
              minG = -minG;
              minB = -minB;
              minA = -minA;
            }
            data.s3n(x, y, minR, minG, minB, minA);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    return data;
  }
  function ColorizedBeziers$red$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this$0.u5i_1;
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.image.vector.ColorizedBeziers.red$delegate.<anonymous>.<anonymous>' call
        if (!(_RGBA___get_r__impl__duz7mo(element.l5j_1) === 0)) {
          destination.r(element);
        }
      }
      return destination;
    };
  }
  function ColorizedBeziers$green$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this$0.u5i_1;
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.image.vector.ColorizedBeziers.green$delegate.<anonymous>.<anonymous>' call
        if (!(_RGBA___get_g__impl__o8pukr(element.l5j_1) === 0)) {
          destination.r(element);
        }
      }
      return destination;
    };
  }
  function ColorizedBeziers$blue$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this$0.u5i_1;
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.image.vector.ColorizedBeziers.blue$delegate.<anonymous>.<anonymous>' call
        if (!(_RGBA___get_b__impl__m6tl80(element.l5j_1) === 0)) {
          destination.r(element);
        }
      }
      return destination;
    };
  }
  function ColorizedBeziers$allProjected$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this$0.u5i_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.image.vector.ColorizedBeziers.allProjected$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item.k5j_1;
        destination.r(tmp$ret$0);
      }
      return new ProjectCurvesLookup(destination);
    };
  }
  function ColorizedBeziers$redProjected$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this$0.m5j();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.image.vector.ColorizedBeziers.redProjected$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item.k5j_1;
        destination.r(tmp$ret$0);
      }
      return new ProjectCurvesLookup(destination);
    };
  }
  function ColorizedBeziers$greenProjected$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this$0.n5j();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.image.vector.ColorizedBeziers.greenProjected$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item.k5j_1;
        destination.r(tmp$ret$0);
      }
      return new ProjectCurvesLookup(destination);
    };
  }
  function ColorizedBeziers$blueProjected$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this$0.o5j();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.image.vector.ColorizedBeziers.blueProjected$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item.k5j_1;
        destination.r(tmp$ret$0);
      }
      return new ProjectCurvesLookup(destination);
    };
  }
  function ColorizedBeziers(beziers) {
    this.u5i_1 = beziers;
    var tmp = this;
    tmp.v5i_1 = lazy(ColorizedBeziers$red$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.w5i_1 = lazy(ColorizedBeziers$green$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.x5i_1 = lazy(ColorizedBeziers$blue$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.y5i_1 = lazy(ColorizedBeziers$allProjected$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.z5i_1 = lazy(ColorizedBeziers$redProjected$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.a5j_1 = lazy(ColorizedBeziers$greenProjected$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.b5j_1 = lazy(ColorizedBeziers$blueProjected$delegate$lambda(this));
  }
  protoOf(ColorizedBeziers).m5j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v5i_1;
    red$factory();
    return this_0.m2();
  };
  protoOf(ColorizedBeziers).n5j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w5i_1;
    green$factory();
    return this_0.m2();
  };
  protoOf(ColorizedBeziers).o5j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x5i_1;
    blue$factory();
    return this_0.m2();
  };
  protoOf(ColorizedBeziers).c5j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y5i_1;
    allProjected$factory();
    return this_0.m2();
  };
  protoOf(ColorizedBeziers).h5j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z5i_1;
    redProjected$factory();
    return this_0.m2();
  };
  protoOf(ColorizedBeziers).i5j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a5j_1;
    greenProjected$factory();
    return this_0.m2();
  };
  protoOf(ColorizedBeziers).j5j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b5j_1;
    blueProjected$factory();
    return this_0.m2();
  };
  function colorize(_this__u8e3s4, closed) {
    closed = closed === VOID ? true : closed;
    // Inline function 'kotlin.collections.mapIndexed' call
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__u8e3s4, 10));
    var index = 0;
    var tmp0_iterator = _this__u8e3s4.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.image.vector.colorize.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var color = msdfColor(index_0, _this__u8e3s4.n(), closed);
      var tmp$ret$0 = new ColoredBezier(item, color);
      destination.r(tmp$ret$0);
    }
    return new ColorizedBeziers(destination);
  }
  function ColoredBezier(bezier, color) {
    this.k5j_1 = bezier;
    this.l5j_1 = color;
  }
  protoOf(ColoredBezier).toString = function () {
    return 'ColoredBezier(bezier=' + this.k5j_1 + ', color=' + new RGBA(this.l5j_1) + ')';
  };
  protoOf(ColoredBezier).hashCode = function () {
    var result = this.k5j_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.l5j_1) | 0;
    return result;
  };
  protoOf(ColoredBezier).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColoredBezier))
      return false;
    var tmp0_other_with_cast = other instanceof ColoredBezier ? other : THROW_CCE();
    if (!this.k5j_1.equals(tmp0_other_with_cast.k5j_1))
      return false;
    if (!(this.l5j_1 === tmp0_other_with_cast.l5j_1))
      return false;
    return true;
  };
  function ProjectCurvesLookup(beziers) {
    this.d5j_1 = beziers;
    this.e5j_1 = new ProjectedPoint();
    this.f5j_1 = Companion_getInstance_11().h2f();
  }
  protoOf(ProjectCurvesLookup).g5j = function (point) {
    return Companion_getInstance_4().c2n(point, this.c2u(point));
  };
  protoOf(ProjectCurvesLookup).c2u = function (point) {
    if (this.d5j_1.b1())
      return Vector2D_init_$Create$(0, 0);
    var minDistSq = Infinity;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.d5j_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var dist = this_0.f1(tmp0).o2t().n36(point);
      if (dist < minDistSq) {
        minDistSq = dist;
      }
    }
    var bminDistSq = Infinity;
    var out = Vector2D_init_$Create$_1();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.d5j_1;
    var n_0 = 0;
    while (n_0 < this_1.n()) {
      $l$block: {
        // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
        var tmp0_0 = n_0;
        n_0 = tmp0_0 + 1 | 0;
        var it = this_1.f1(tmp0_0);
        if (it.o2t().m36(point) > minDistSq) {
          break $l$block;
        }
        it.a2u(point, this.e5j_1);
        if (this.e5j_1.x2s_1 < bminDistSq) {
          bminDistSq = this.e5j_1.x2s_1;
          out = this.e5j_1.v2s_1;
        }
      }
    }
    return out;
  };
  function msdfColor(index, size, closed) {
    if (size === 1)
      return Colors_getInstance().l3b_1;
    if (index === 0)
      return Colors_getInstance().n3d_1;
    return ((index - 1 | 0) % 2 | 0) === 0 ? Colors_getInstance().b3h_1 : Colors_getInstance().l3c_1;
  }
  function sdfBmp$lambda($this_sdfBmp) {
    return function ($this$NativeImageContext2d) {
      var paint = new RGBA(Colors_getInstance().l3b_1);
      if (true) {
        $this$NativeImageContext2d.c43();
      }
      // Inline function 'korlibs.image.vector.sdfBmp.<anonymous>.<anonymous>' call
      write($this$NativeImageContext2d, $this_sdfBmp);
      $this$NativeImageContext2d.n5i(paint, null);
      return Unit_instance;
    };
  }
  function red$factory() {
    return getPropertyCallableRef('red', 1, KProperty1, function (receiver) {
      return receiver.m5j();
    }, null);
  }
  function green$factory() {
    return getPropertyCallableRef('green', 1, KProperty1, function (receiver) {
      return receiver.n5j();
    }, null);
  }
  function blue$factory() {
    return getPropertyCallableRef('blue', 1, KProperty1, function (receiver) {
      return receiver.o5j();
    }, null);
  }
  function allProjected$factory() {
    return getPropertyCallableRef('allProjected', 1, KProperty1, function (receiver) {
      return receiver.c5j();
    }, null);
  }
  function redProjected$factory() {
    return getPropertyCallableRef('redProjected', 1, KProperty1, function (receiver) {
      return receiver.h5j();
    }, null);
  }
  function greenProjected$factory() {
    return getPropertyCallableRef('greenProjected', 1, KProperty1, function (receiver) {
      return receiver.i5j();
    }, null);
  }
  function blueProjected$factory() {
    return getPropertyCallableRef('blueProjected', 1, KProperty1, function (receiver) {
      return receiver.j5j();
    }, null);
  }
  function Shape() {
  }
  function toContext2dCommands(_this__u8e3s4, prefix, suffix, decimalPlaces) {
    prefix = prefix === VOID ? 'ctx.' : prefix;
    suffix = suffix === VOID ? ';' : suffix;
    decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = _this__u8e3s4.u2u_1;
    var n_0 = 0;
    while (n_0 < this_1.n()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var tmp0_subject = this_1.b1r(tmp0);
      if (tmp0_subject === 0) {
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var tmp = _this__u8e3s4.v2u_1.f1(tmp1);
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var name_for_destructuring_parameter_0_fjsvno = new Vector2D(tmp, _this__u8e3s4.v2u_1.f1(tmp2));
        var x = name_for_destructuring_parameter_0_fjsvno.cg();
        var y = name_for_destructuring_parameter_0_fjsvno.dg();
        this_0.r('moveTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y, decimalPlaces) + ')');
      } else {
        if (tmp0_subject === 1) {
          // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call
          var tmp3 = n;
          n = tmp3 + 1 | 0;
          var tmp_0 = _this__u8e3s4.v2u_1.f1(tmp3);
          var tmp4 = n;
          n = tmp4 + 1 | 0;
          var name_for_destructuring_parameter_0_fjsvno_0 = new Vector2D(tmp_0, _this__u8e3s4.v2u_1.f1(tmp4));
          var x_0 = name_for_destructuring_parameter_0_fjsvno_0.cg();
          var y_0 = name_for_destructuring_parameter_0_fjsvno_0.dg();
          this_0.r('lineTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y_0, decimalPlaces) + ')');
        } else {
          if (tmp0_subject === 2) {
            // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call
            var tmp5 = n;
            n = tmp5 + 1 | 0;
            var tmp_1 = _this__u8e3s4.v2u_1.f1(tmp5);
            var tmp6 = n;
            n = tmp6 + 1 | 0;
            var name_for_destructuring_parameter_0_fjsvno_1 = new Vector2D(tmp_1, _this__u8e3s4.v2u_1.f1(tmp6));
            var tmp7 = n;
            n = tmp7 + 1 | 0;
            var tmp_2 = _this__u8e3s4.v2u_1.f1(tmp7);
            var tmp8 = n;
            n = tmp8 + 1 | 0;
            var name_for_destructuring_parameter_1_fjsvnn = new Vector2D(tmp_2, _this__u8e3s4.v2u_1.f1(tmp8));
            var cx = name_for_destructuring_parameter_0_fjsvno_1.cg();
            var cy = name_for_destructuring_parameter_0_fjsvno_1.dg();
            var ax = name_for_destructuring_parameter_1_fjsvnn.cg();
            var ay = name_for_destructuring_parameter_1_fjsvnn.dg();
            this_0.r('quadTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay, decimalPlaces) + ')');
          } else {
            if (tmp0_subject === 3) {
              // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call
              var tmp9 = n;
              n = tmp9 + 1 | 0;
              var tmp_3 = _this__u8e3s4.v2u_1.f1(tmp9);
              var tmp10 = n;
              n = tmp10 + 1 | 0;
              var name_for_destructuring_parameter_0_fjsvno_2 = new Vector2D(tmp_3, _this__u8e3s4.v2u_1.f1(tmp10));
              var tmp11 = n;
              n = tmp11 + 1 | 0;
              var tmp_4 = _this__u8e3s4.v2u_1.f1(tmp11);
              var tmp12 = n;
              n = tmp12 + 1 | 0;
              var name_for_destructuring_parameter_1_fjsvnn_0 = new Vector2D(tmp_4, _this__u8e3s4.v2u_1.f1(tmp12));
              var tmp13 = n;
              n = tmp13 + 1 | 0;
              var tmp_5 = _this__u8e3s4.v2u_1.f1(tmp13);
              var tmp14 = n;
              n = tmp14 + 1 | 0;
              var name_for_destructuring_parameter_2_fjsvnm = new Vector2D(tmp_5, _this__u8e3s4.v2u_1.f1(tmp14));
              var cx1 = name_for_destructuring_parameter_0_fjsvno_2.cg();
              var cy1 = name_for_destructuring_parameter_0_fjsvno_2.dg();
              var cx2 = name_for_destructuring_parameter_1_fjsvnn_0.cg();
              var cy2 = name_for_destructuring_parameter_1_fjsvnn_0.dg();
              var ax_0 = name_for_destructuring_parameter_2_fjsvnm.cg();
              var ay_0 = name_for_destructuring_parameter_2_fjsvnm.dg();
              this_0.r('cubicTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay_0, decimalPlaces) + ')');
            } else {
              if (tmp0_subject === 4) {
                // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call
                this_0.r('close()');
              }
            }
          }
        }
      }
    }
    var this_2 = this_0.z2();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator = this_2.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
      var tmp$ret$3 = prefix + item + suffix;
      destination.r(tmp$ret$3);
    }
    return destination;
  }
  function FillShape$pathCurvesList$delegate$lambda(this$0) {
    return function () {
      return toCurvesList(this$0.r5j_1);
    };
  }
  function FillShape$clipCurvesList$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.s5j_1;
      return tmp0_safe_receiver == null ? null : toCurvesList(tmp0_safe_receiver);
    };
  }
  function FillShape(path, clip, paint, transform, globalAlpha) {
    transform = transform === VOID ? Companion_getInstance_3().e2f_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.r5j_1 = path;
    this.s5j_1 = clip;
    this.t5j_1 = paint;
    this.u5j_1 = transform;
    this.v5j_1 = globalAlpha;
    var tmp = this;
    tmp.w5j_1 = lazy(FillShape$pathCurvesList$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.x5j_1 = lazy(FillShape$clipCurvesList$delegate$lambda(this));
  }
  protoOf(FillShape).f4o = function () {
    return this.r5j_1;
  };
  protoOf(FillShape).y5j = function () {
    return this.s5j_1;
  };
  protoOf(FillShape).p46 = function () {
    return this.u5j_1;
  };
  protoOf(FillShape).z5j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w5j_1;
    pathCurvesList$factory();
    return this_0.m2();
  };
  protoOf(FillShape).a5k = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x5j_1;
    clipCurvesList$factory();
    return this_0.m2();
  };
  protoOf(FillShape).b5k = function () {
    return (this.z5j().n() === 1 ? get_isConvex(first_0(this.z5j())) : false) ? this.a5k() == null : false;
  };
  protoOf(FillShape).c5k = function (c) {
    c.n5i(this.t5j_1, this.r5j_1.w2u_1);
  };
  protoOf(FillShape).toString = function () {
    return 'FillShape(path=' + this.r5j_1 + ', clip=' + this.s5j_1 + ', paint=' + this.t5j_1 + ', transform=' + this.u5j_1 + ', globalAlpha=' + this.v5j_1 + ')';
  };
  protoOf(FillShape).hashCode = function () {
    var result = this.r5j_1.hashCode();
    result = imul(result, 31) + (this.s5j_1 == null ? 0 : this.s5j_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.t5j_1) | 0;
    result = imul(result, 31) + this.u5j_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.v5j_1) | 0;
    return result;
  };
  protoOf(FillShape).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!this.r5j_1.equals(tmp0_other_with_cast.r5j_1))
      return false;
    if (!equals(this.s5j_1, tmp0_other_with_cast.s5j_1))
      return false;
    if (!equals(this.t5j_1, tmp0_other_with_cast.t5j_1))
      return false;
    if (!this.u5j_1.equals(tmp0_other_with_cast.u5j_1))
      return false;
    if (!equals(this.v5j_1, tmp0_other_with_cast.v5j_1))
      return false;
    return true;
  };
  function CompoundShape(components) {
    this.d5k_1 = components;
  }
  protoOf(CompoundShape).q5j = function (includeStrokes) {
    var bb = Companion_getInstance_5().a2e();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.d5k_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getBounds.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = this_0.f1(tmp0);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it.q5j(includeStrokes));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  };
  protoOf(CompoundShape).x47 = function (c) {
    $l$block: {
      // Inline function 'korlibs.image.vector.Context2d.buffering' call
      c.a5i();
      try {
        var this_0 = this.d5k_1;
        var n = 0;
        while (n < this_0.n()) {
          // Inline function 'korlibs.image.vector.CompoundShape.draw.<anonymous>.<anonymous>' call
          var tmp0 = n;
          n = tmp0 + 1 | 0;
          this_0.f1(tmp0).x47(c);
        }
        break $l$block;
      }finally {
        c.b5i();
      }
    }
    return Unit_instance;
  };
  protoOf(CompoundShape).p5j = function (path) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.d5k_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      this_0.f1(tmp0).p5j(path);
    }
    return path;
  };
  protoOf(CompoundShape).toString = function () {
    return 'CompoundShape(\n  ' + joinToString(this.d5k_1, ',\n  ') + '\n)';
  };
  function toSvgPathString(_this__u8e3s4, separator, decimalPlaces) {
    separator = separator === VOID ? ' ' : separator;
    decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
    return SvgPath_instance.e5k(_this__u8e3s4, separator, decimalPlaces);
  }
  function StyledShape() {
  }
  function PolylineShape$fillShape$delegate$lambda(this$0) {
    return function () {
      return new FillShape(strokeToFill_0(this$0.f5k_1, this$0.j5k_1), this$0.g5k_1, this$0.h5k_1, this$0.i5k_1, this$0.k5k_1);
    };
  }
  function PolylineShape(path, clip, paint, transform, strokeInfo, globalAlpha) {
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.f5k_1 = path;
    this.g5k_1 = clip;
    this.h5k_1 = paint;
    this.i5k_1 = transform;
    this.j5k_1 = strokeInfo;
    this.k5k_1 = globalAlpha;
    this.l5k_1 = thickness$factory(this.j5k_1);
    this.m5k_1 = scaleMode$factory(this.j5k_1);
    this.n5k_1 = startCap$factory(this.j5k_1);
    this.o5k_1 = endCap$factory(this.j5k_1);
    this.p5k_1 = join$factory(this.j5k_1);
    this.q5k_1 = miterLimit$factory(this.j5k_1);
    this.r5k_1 = dash$factory(this.j5k_1);
    this.s5k_1 = dashOffset$factory(this.j5k_1);
    var tmp = this;
    tmp.t5k_1 = lazy(PolylineShape$fillShape$delegate$lambda(this));
  }
  protoOf(PolylineShape).f4o = function () {
    return this.f5k_1;
  };
  protoOf(PolylineShape).y5j = function () {
    return this.g5k_1;
  };
  protoOf(PolylineShape).p46 = function () {
    return this.i5k_1;
  };
  protoOf(PolylineShape).q5j = function (includeStrokes) {
    var tmp0_safe_receiver = BoundsBuilder__boundsOrNull_impl_se9lyg(plus_0(Companion_getInstance_5().a2e(), this.f5k_1));
    var bounds = tmp0_safe_receiver == null ? null : get_mutable(tmp0_safe_receiver);
    if (includeStrokes) {
      // Inline function 'kotlin.math.max' call
      var a = this.j5k_1.y2p_1 / 2.0;
      var halfThickness = Math.max(a, 0.0);
      if (bounds == null)
        null;
      else
        bounds.g36(halfThickness, halfThickness);
    }
    var tmp3_elvis_lhs = bounds == null ? null : bounds.m35();
    return tmp3_elvis_lhs == null ? Companion_getInstance_2().w2d_1 : tmp3_elvis_lhs;
  };
  protoOf(PolylineShape).u5k = function (c) {
    c.c5i(this.j5k_1.a2q_1);
    c.w44(this.j5k_1.y2p_1);
    c.d5i(this.j5k_1.b2q_1);
    c.e5i(this.j5k_1.c2q_1);
    c.y44(this.j5k_1.d2q_1);
    c.z44(this.j5k_1.e2q_1);
    c.a45(this.j5k_1.f2q_1);
    c.b45(this.j5k_1.g2q_1);
  };
  protoOf(PolylineShape).c5k = function (c) {
    this.u5k(c);
    c.c45(this.h5k_1);
  };
  protoOf(PolylineShape).toString = function () {
    return 'PolylineShape(path=' + this.f5k_1 + ', clip=' + this.g5k_1 + ', paint=' + this.h5k_1 + ', transform=' + this.i5k_1 + ', strokeInfo=' + this.j5k_1 + ', globalAlpha=' + this.k5k_1 + ')';
  };
  protoOf(PolylineShape).hashCode = function () {
    var result = this.f5k_1.hashCode();
    result = imul(result, 31) + (this.g5k_1 == null ? 0 : this.g5k_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.h5k_1) | 0;
    result = imul(result, 31) + this.i5k_1.hashCode() | 0;
    result = imul(result, 31) + this.j5k_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.k5k_1) | 0;
    return result;
  };
  protoOf(PolylineShape).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!this.f5k_1.equals(tmp0_other_with_cast.f5k_1))
      return false;
    if (!equals(this.g5k_1, tmp0_other_with_cast.g5k_1))
      return false;
    if (!equals(this.h5k_1, tmp0_other_with_cast.h5k_1))
      return false;
    if (!this.i5k_1.equals(tmp0_other_with_cast.i5k_1))
      return false;
    if (!this.j5k_1.equals(tmp0_other_with_cast.j5k_1))
      return false;
    if (!equals(this.k5k_1, tmp0_other_with_cast.k5k_1))
      return false;
    return true;
  };
  function TextShape() {
  }
  protoOf(TextShape).w5k = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v5k_1;
    primitiveShapes$factory();
    return this_0.m2();
  };
  function EmptyShape() {
  }
  protoOf(EmptyShape).q5j = function (includeStrokes) {
    return Companion_getInstance_2().z2d();
  };
  protoOf(EmptyShape).x47 = function (c) {
    return Unit_instance;
  };
  var EmptyShape_instance;
  function EmptyShape_getInstance() {
    return EmptyShape_instance;
  }
  function toContext2dCommands$_anonymous_$round$0_5f3kr1(_this__u8e3s4, $decimalPlaces) {
    return niceStr(_this__u8e3s4, $decimalPlaces);
  }
  function pathCurvesList$factory() {
    return getPropertyCallableRef('pathCurvesList', 1, KProperty1, function (receiver) {
      return receiver.z5j();
    }, null);
  }
  function clipCurvesList$factory() {
    return getPropertyCallableRef('clipCurvesList', 1, KProperty1, function (receiver) {
      return receiver.a5k();
    }, null);
  }
  function thickness$factory($b0) {
    return getPropertyCallableRef('thickness', 0, KProperty0, function () {
      return $b0.y2p_1;
    }, null);
  }
  function scaleMode$factory($b0) {
    return getPropertyCallableRef('scaleMode', 0, KProperty0, function () {
      return $b0.a2q_1;
    }, null);
  }
  function startCap$factory($b0) {
    return getPropertyCallableRef('startCap', 0, KProperty0, function () {
      return $b0.b2q_1;
    }, null);
  }
  function endCap$factory($b0) {
    return getPropertyCallableRef('endCap', 0, KProperty0, function () {
      return $b0.c2q_1;
    }, null);
  }
  function join$factory($b0) {
    return getPropertyCallableRef('join', 0, KProperty0, function () {
      return $b0.d2q_1;
    }, null);
  }
  function miterLimit$factory($b0) {
    return getPropertyCallableRef('miterLimit', 0, KProperty0, function () {
      return $b0.e2q_1;
    }, null);
  }
  function dash$factory($b0) {
    return getPropertyCallableRef('dash', 0, KProperty0, function () {
      return $b0.f2q_1;
    }, null);
  }
  function dashOffset$factory($b0) {
    return getPropertyCallableRef('dashOffset', 0, KProperty0, function () {
      return $b0.g2q_1;
    }, null);
  }
  function primitiveShapes$factory() {
    return getPropertyCallableRef('primitiveShapes', 1, KProperty1, function (receiver) {
      return receiver.w5k();
    }, null);
  }
  function ShapeBuilder(width, height) {
    Context2d.call(this, Companion_getInstance_55());
    var tmp = this;
    tmp.h41_1 = width == null ? 256 : width;
    var tmp_0 = this;
    tmp_0.i41_1 = height == null ? 256 : height;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.j41_1 = ArrayList_init_$Create$();
  }
  protoOf(ShapeBuilder).s5h = function () {
    return this.h41_1;
  };
  protoOf(ShapeBuilder).t5h = function () {
    return this.i41_1;
  };
  protoOf(ShapeBuilder).u5h = function (state, fill, winding) {
    if (state.t3u_1.b1())
      return Unit_instance;
    // Inline function 'kotlin.also' call
    var this_0 = state.t3u_1.g1s();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
    var tmp = this_0;
    tmp.w2u_1 = winding == null ? this_0.w2u_1 : winding;
    var path = this_0;
    var tmp0_safe_receiver = state.s3u_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g1s();
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
      var tmp_1 = tmp1_safe_receiver;
      tmp_1.w2u_1 = winding == null ? tmp1_safe_receiver.w2u_1 : winding;
      tmp_0 = tmp1_safe_receiver;
    }
    var clip = tmp_0;
    var transform = state.r3u_1;
    if (fill) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.j41_1;
      var element = new FillShape(path, clip, state.b3v_1.g1s(), transform, state.h3v_1);
      this_1.r(element);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_2 = this.j41_1;
      var tmp_2 = state.a3v_1.g1s();
      var tmp4_thickness = state.v3u_1;
      var tmp5_scaleMode = state.u3u_1;
      var tmp6_startCap = state.w3u_1;
      var tmp7_endCap = state.x3u_1;
      var tmp8_join = state.y3u_1;
      var tmp9_dash = state.j3v_1;
      var tmp10_dashOffset = state.k3v_1;
      var tmp11_miterLimit = state.z3u_1;
      var element_0 = new PolylineShape(path, clip, tmp_2, transform, new StrokeInfo(tmp4_thickness, true, tmp5_scaleMode, tmp6_startCap, tmp7_endCap, tmp8_join, tmp11_miterLimit, tmp9_dash, tmp10_dashOffset), state.h3v_1);
      this_2.r(element_0);
    }
  };
  protoOf(ShapeBuilder).w5h = function (image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererDrawImage.<anonymous>' call
    this_0.s33(pos, size);
    this.v5h(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, Companion_getInstance_3().e2f_1.d2g(size.h2m(toFloat(image.n()))).m2g(pos))), true);
  };
  protoOf(ShapeBuilder).x5h = function () {
  };
  protoOf(ShapeBuilder).y5h = function () {
    return 0;
  };
  protoOf(ShapeBuilder).z5h = function () {
  };
  protoOf(ShapeBuilder).k41 = function () {
    return this.j41_1.n() === 1 ? first_0(this.j41_1) : new CompoundShape(toList(this.j41_1));
  };
  protoOf(ShapeBuilder).x47 = function (c) {
    c.y47(this.k41());
  };
  function toSvgPathString$fixX(_this__u8e3s4, $decimalPlaces) {
    return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
  }
  function toSvgPathString$fixY(_this__u8e3s4, $decimalPlaces) {
    return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
  }
  function SvgPath() {
  }
  protoOf(SvgPath).e5k = function (path, separator, decimalPlaces) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var parts = ArrayList_init_$Create$();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.u2u_1;
    var n_0 = 0;
    while (n_0 < this_0.n()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var tmp0_subject = this_0.b1r(tmp0);
      if (tmp0_subject === 0) {
        // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var tmp = path.v2u_1.f1(tmp1);
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var name_for_destructuring_parameter_0_fjsvno = new Vector2D(tmp, path.v2u_1.f1(tmp2));
        var x = name_for_destructuring_parameter_0_fjsvno.cg();
        var y = name_for_destructuring_parameter_0_fjsvno.dg();
        // Inline function 'kotlin.collections.plusAssign' call
        var element = 'M' + toSvgPathString$fixX(x, decimalPlaces) + ' ' + toSvgPathString$fixY(y, decimalPlaces);
        parts.r(element);
      } else {
        if (tmp0_subject === 1) {
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call
          var tmp3 = n;
          n = tmp3 + 1 | 0;
          var tmp_0 = path.v2u_1.f1(tmp3);
          var tmp4 = n;
          n = tmp4 + 1 | 0;
          var name_for_destructuring_parameter_0_fjsvno_0 = new Vector2D(tmp_0, path.v2u_1.f1(tmp4));
          var x_0 = name_for_destructuring_parameter_0_fjsvno_0.cg();
          var y_0 = name_for_destructuring_parameter_0_fjsvno_0.dg();
          // Inline function 'kotlin.collections.plusAssign' call
          var element_0 = 'L' + toSvgPathString$fixX(x_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y_0, decimalPlaces);
          parts.r(element_0);
        } else {
          if (tmp0_subject === 2) {
            // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call
            var tmp5 = n;
            n = tmp5 + 1 | 0;
            var tmp_1 = path.v2u_1.f1(tmp5);
            var tmp6 = n;
            n = tmp6 + 1 | 0;
            var name_for_destructuring_parameter_0_fjsvno_1 = new Vector2D(tmp_1, path.v2u_1.f1(tmp6));
            var tmp7 = n;
            n = tmp7 + 1 | 0;
            var tmp_2 = path.v2u_1.f1(tmp7);
            var tmp8 = n;
            n = tmp8 + 1 | 0;
            var name_for_destructuring_parameter_1_fjsvnn = new Vector2D(tmp_2, path.v2u_1.f1(tmp8));
            var x1 = name_for_destructuring_parameter_0_fjsvno_1.cg();
            var y1 = name_for_destructuring_parameter_0_fjsvno_1.dg();
            var x2 = name_for_destructuring_parameter_1_fjsvnn.cg();
            var y2 = name_for_destructuring_parameter_1_fjsvnn.dg();
            // Inline function 'kotlin.collections.plusAssign' call
            var element_1 = 'Q' + toSvgPathString$fixX(x1, decimalPlaces) + ' ' + toSvgPathString$fixY(y1, decimalPlaces) + ', ' + toSvgPathString$fixX(x2, decimalPlaces) + ' ' + toSvgPathString$fixY(y2, decimalPlaces);
            parts.r(element_1);
          } else {
            if (tmp0_subject === 3) {
              // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call
              var tmp9 = n;
              n = tmp9 + 1 | 0;
              var tmp_3 = path.v2u_1.f1(tmp9);
              var tmp10 = n;
              n = tmp10 + 1 | 0;
              var name_for_destructuring_parameter_0_fjsvno_2 = new Vector2D(tmp_3, path.v2u_1.f1(tmp10));
              var tmp11 = n;
              n = tmp11 + 1 | 0;
              var tmp_4 = path.v2u_1.f1(tmp11);
              var tmp12 = n;
              n = tmp12 + 1 | 0;
              var name_for_destructuring_parameter_1_fjsvnn_0 = new Vector2D(tmp_4, path.v2u_1.f1(tmp12));
              var tmp13 = n;
              n = tmp13 + 1 | 0;
              var tmp_5 = path.v2u_1.f1(tmp13);
              var tmp14 = n;
              n = tmp14 + 1 | 0;
              var name_for_destructuring_parameter_2_fjsvnm = new Vector2D(tmp_5, path.v2u_1.f1(tmp14));
              var x1_0 = name_for_destructuring_parameter_0_fjsvno_2.cg();
              var y1_0 = name_for_destructuring_parameter_0_fjsvno_2.dg();
              var x2_0 = name_for_destructuring_parameter_1_fjsvnn_0.cg();
              var y2_0 = name_for_destructuring_parameter_1_fjsvnn_0.dg();
              var x3 = name_for_destructuring_parameter_2_fjsvnm.cg();
              var y3 = name_for_destructuring_parameter_2_fjsvnm.dg();
              // Inline function 'kotlin.collections.plusAssign' call
              var element_2 = 'C' + toSvgPathString$fixX(x1_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y1_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x2_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y2_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x3, decimalPlaces) + ' ' + toSvgPathString$fixY(y3, decimalPlaces);
              parts.r(element_2);
            } else {
              if (tmp0_subject === 4) {
                // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call
                // Inline function 'kotlin.collections.plusAssign' call
                parts.r('Z');
              }
            }
          }
        }
      }
    }
    return joinToString(parts, '');
  };
  var SvgPath_instance;
  function SvgPath_getInstance() {
    return SvgPath_instance;
  }
  function Rasterizer$rasterizeFill$lambda($xmax, $xmin, this$0, $callback) {
    return function (a, b, y) {
      var tmp;
      if (a <= $xmax ? b >= $xmin : false) {
        var a0 = coerceIn(a, $xmin, $xmax);
        var b0 = coerceIn(b, $xmin, $xmax);
        if (this$0.m5g_1) {
          println('RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
        }
        tmp = $callback(a0, b0, y);
      } else {
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Rasterizer() {
    RastScale.call(this);
    this.m5g_1 = false;
    this.n5g_1 = 2;
    this.o5g_1 = 1;
    this.p5g_1 = new PolygonScanline();
    this.q5g_1 = new PolygonScanline();
    this.r5g_1 = new IntSegmentSet();
    this.s5g_1 = new IntSegmentSet();
    this.t5g_1 = new IntSegmentSet();
    this.u5g_1 = new IntArrayList(1024);
  }
  protoOf(Rasterizer).n1y = function () {
    this.p5g_1.n1y();
    this.q5g_1.n1y();
  };
  protoOf(Rasterizer).x5k = function (bounds, quality, stats, winding, callback) {
    if (stats == null)
      null;
    else {
      stats.n1y();
    }
    var xmin = this.x30(bounds.r2d());
    var xmax = this.x30(bounds.s2d());
    var tempRect = this.p5g_1.u2r();
    // Inline function 'kotlin.math.max' call
    var a = bounds.t2d();
    var b = tempRect.t2d();
    var tmp$ret$0 = Math.max(a, b);
    var startY = this.x30(tmp$ret$0);
    // Inline function 'kotlin.math.min' call
    var a_0 = bounds.u2d();
    var b_0 = tempRect.u2d();
    var tmp$ret$1 = Math.min(a_0, b_0);
    var endY = this.x30(tmp$ret$1);
    var func = Rasterizer$rasterizeFill$lambda(xmax, xmin, this, callback);
    this.u5g_1.b3();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this.p31() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this.p31()) / this.o5g_1 | 0) / q | 0) | 0;
        this.u5g_1.m1s(y);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>' call
    var edgesEmitted = 0;
    var edgesChecked = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.u5g_1;
    var n_0 = 0;
    while (n_0 < this_0.n()) {
      // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var y_0 = this_0.b1r(tmp0);
      this.p5g_1.k31(y_0, winding, this.r5g_1);
      edgesChecked = edgesChecked + this.p5g_1.v30_1 | 0;
      if (this.q5g_1.t1s()) {
        this.q5g_1.k31(y_0, this.q5g_1.g30_1, this.s5g_1);
        edgesChecked = edgesChecked + this.q5g_1.v30_1 | 0;
        this.t5g_1.e2c(this.r5g_1, this.s5g_1);
      }
      // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
      var this_1 = this.q5g_1.t1s() ? this.t5g_1 : this.r5g_1;
      var inductionVariable_0 = 0;
      var last_0 = this_1.n();
      if (inductionVariable_0 < last_0)
        do {
          var n_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>.<anonymous>' call
          func(this_1.u2b_1.b1r(n_1), this_1.v2b_1.b1r(n_1), y_0);
          edgesEmitted = edgesEmitted + 1 | 0;
        }
         while (inductionVariable_0 < last_0);
    }
    var tmp;
    if (stats == null) {
      tmp = null;
    } else {
      stats.b5l(edgesChecked, edgesEmitted, yCount);
      tmp = Unit_instance;
    }
  };
  protoOf(Rasterizer).v5g = function (bounds, quality, stats, winding, callback, $super) {
    quality = quality === VOID ? this.n5g_1 : quality;
    stats = stats === VOID ? null : stats;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.x5k(bounds, quality, stats, winding, callback);
      tmp = Unit_instance;
    } else {
      tmp = $super.x5k.call(this, bounds, quality, stats, winding, callback);
    }
    return tmp;
  };
  function Renderer$drawImage$lambda($pos, $size) {
    return function ($this$transformed) {
      $this$transformed.s33($pos, $size);
      return Unit_instance;
    };
  }
  function Renderer() {
    this.x5g_1 = false;
    this.y5g_1 = 0;
  }
  protoOf(Renderer).m6 = function () {
    return Unit_instance;
  };
  protoOf(Renderer).a5h = function () {
    var tmp1 = this.y5g_1;
    this.y5g_1 = tmp1 + 1 | 0;
    return tmp1;
  };
  protoOf(Renderer).b5h = function () {
    this.y5g_1 = this.y5g_1 - 1 | 0;
    if (this.y5g_1 === 0) {
      this.m6();
    }
  };
  protoOf(Renderer).c5h = function (state, fill, winding) {
    var rstate = state;
    if (fill ? !this.e5h(state.b3v_1) : false) {
      rstate = state.g1s();
      rstate.b3v_1 = toBitmapPaint(rstate.b3v_1, state);
    }
    this.w5g(rstate, fill, winding);
  };
  protoOf(Renderer).d5h = function (state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.c5h(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.c5h.call(this, state, fill, winding);
    }
    return tmp;
  };
  protoOf(Renderer).w5g = function (state, fill, winding) {
    return Unit_instance;
  };
  protoOf(Renderer).e5h = function (_this__u8e3s4) {
    return true;
  };
  protoOf(Renderer).f5h = function (image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.renderer.Renderer.drawImage.<anonymous>' call
    if (transform.u2f().equals(MatrixType_IDENTITY_getInstance())) {
      this_0.s33(pos, size);
    } else {
      this_0.z33(transform, Renderer$drawImage$lambda(pos, size));
    }
    this.d5h(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, Companion_getInstance_3().e2f_1.d2g(size.h2m(toFloat(image.n()))).m2g(pos))), true);
  };
  protoOf(Renderer).f1e = function () {
    this.m6();
  };
  function Companion_40() {
    Companion_instance_48 = this;
    DummyRenderer.call(this, 128, 128);
  }
  var Companion_instance_48;
  function Companion_getInstance_55() {
    if (Companion_instance_48 == null)
      new Companion_40();
    return Companion_instance_48;
  }
  function DummyRenderer(width, height) {
    Companion_getInstance_55();
    Renderer.call(this);
    this.e5l_1 = width;
    this.f5l_1 = height;
  }
  protoOf(DummyRenderer).x1q = function () {
    return this.e5l_1;
  };
  protoOf(DummyRenderer).y1q = function () {
    return this.f5l_1;
  };
  function get_logger() {
    _init_properties_AsyncExt_kt__ahev1h();
    return logger;
  }
  var logger;
  var DEFAULT_SUSPEND_TEST_TIMEOUT;
  var DEFAULT_TEST_SYNC_IO;
  function get_DEBUG_ASYNC_LAUNCH_ERRORS() {
    _init_properties_AsyncExt_kt__ahev1h();
    // Inline function 'kotlin.getValue' call
    var this_0 = DEBUG_ASYNC_LAUNCH_ERRORS$delegate;
    DEBUG_ASYNC_LAUNCH_ERRORS$factory();
    return this_0.m2();
  }
  var DEBUG_ASYNC_LAUNCH_ERRORS$delegate;
  function asyncImmediately(context, callback) {
    _init_properties_AsyncExt_kt__ahev1h();
    return asyncImmediately_0(CoroutineScope(context), callback);
  }
  function launchImmediately(context, callback) {
    _init_properties_AsyncExt_kt__ahev1h();
    return launchImmediately_0(CoroutineScope(context), callback);
  }
  function launchUnscoped(_this__u8e3s4, block) {
    _init_properties_AsyncExt_kt__ahev1h();
    startCoroutine(block, new launchUnscoped$1(_this__u8e3s4));
  }
  function asyncImmediately_0(_this__u8e3s4, callback) {
    _init_properties_AsyncExt_kt__ahev1h();
    return _async(_this__u8e3s4, CoroutineStart_UNDISPATCHED_getInstance(), callback);
  }
  function launchImmediately_0(_this__u8e3s4, callback) {
    _init_properties_AsyncExt_kt__ahev1h();
    return _launch(_this__u8e3s4, CoroutineStart_UNDISPATCHED_getInstance(), callback);
  }
  function _async(_this__u8e3s4, start, callback) {
    _init_properties_AsyncExt_kt__ahev1h();
    var tmp = _this__u8e3s4.w1a();
    return async(_this__u8e3s4, tmp, start, _async$slambda_0(callback, null));
  }
  function _launch(_this__u8e3s4, start, callback) {
    _init_properties_AsyncExt_kt__ahev1h();
    var tmp = _this__u8e3s4.w1a();
    return launch(_this__u8e3s4, tmp, start, _launch$slambda_0(callback, null));
  }
  function async_0(context, callback) {
    _init_properties_AsyncExt_kt__ahev1h();
    return asyncImmediately_0(CoroutineScope(context), callback);
  }
  function launchUnscopedAndWait(_this__u8e3s4, block, $completion) {
    var deferred = CompletableDeferred();
    startCoroutine(block, new launchUnscopedAndWait$1(_this__u8e3s4, deferred));
    return deferred.q1d($completion);
  }
  function launchUnscoped_0(_this__u8e3s4, block) {
    _init_properties_AsyncExt_kt__ahev1h();
    return launchUnscoped(_this__u8e3s4.w1a(), block);
  }
  function DEBUG_ASYNC_LAUNCH_ERRORS$delegate$lambda() {
    _init_properties_AsyncExt_kt__ahev1h();
    return Companion_instance_60.s13('DEBUG_ASYNC_LAUNCH_ERRORS') === 'true';
  }
  function launchUnscoped$1($this_launchUnscoped) {
    this.g5l_1 = $this_launchUnscoped;
  }
  protoOf(launchUnscoped$1).q6 = function () {
    return this.g5l_1;
  };
  protoOf(launchUnscoped$1).ng = function (result) {
    if (_Result___get_isFailure__impl__jpiriv(result)) {
      var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(result);
      if (tmp0_safe_receiver == null)
        null;
      else {
        printStackTrace(tmp0_safe_receiver);
      }
    }
  };
  protoOf(launchUnscoped$1).s6 = function (result) {
    return this.ng(result);
  };
  function _async$slambda($callback, resultContinuation) {
    this.p5l_1 = $callback;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(_async$slambda).s5l = function ($this$async, $completion) {
    var tmp = this.t5l($this$async, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(_async$slambda).ne = function (p1, $completion) {
    return this.s5l((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(_async$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.p5l_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.r5l_1 = suspendResult;
            this.gd_1 = 3;
            this.fd_1 = 4;
            continue $sm;
          case 2:
            this.gd_1 = 3;
            var tmp_0 = this.id_1;
            if (tmp_0 instanceof Error) {
              var e = this.id_1;
              var tmp_1 = this;
              if (e instanceof CancellationException)
                throw e;
              if (get_DEBUG_ASYNC_LAUNCH_ERRORS()) {
                var this_0 = get_logger();
                var level = Level_ERROR_getInstance();
                if (this_0.f25(level)) {
                  this_0.g25(level, 'CoroutineScope._async.catch:');
                }
                printStackTrace(e);
              }
              throw e;
            } else {
              throw this.id_1;
            }

          case 3:
            throw this.id_1;
          case 4:
            this.gd_1 = 3;
            return this.r5l_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 3) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(_async$slambda).t5l = function ($this$async, completion) {
    var i = new _async$slambda(this.p5l_1, completion);
    i.q5l_1 = $this$async;
    return i;
  };
  function _async$slambda_0($callback, resultContinuation) {
    var i = new _async$slambda($callback, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.s5l($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function _launch$slambda($callback, resultContinuation) {
    this.c5m_1 = $callback;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(_launch$slambda).e5m = function ($this$launch, $completion) {
    var tmp = this.t5l($this$launch, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(_launch$slambda).ne = function (p1, $completion) {
    return this.e5m((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(_launch$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.c5m_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.gd_1 = 3;
            this.fd_1 = 4;
            continue $sm;
          case 2:
            this.gd_1 = 3;
            var tmp_0 = this.id_1;
            if (tmp_0 instanceof CancellationException) {
              var e = this.id_1;
              throw e;
            } else {
              var tmp_1 = this.id_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.id_1;
                if (get_DEBUG_ASYNC_LAUNCH_ERRORS()) {
                  var this_0 = get_logger();
                  var level = Level_ERROR_getInstance();
                  if (this_0.f25(level)) {
                    this_0.g25(level, 'CoroutineScope._launch.catch:');
                  }
                  printStackTrace(e_0);
                }
                throw e_0;
              } else {
                throw this.id_1;
              }
            }

          case 3:
            throw this.id_1;
          case 4:
            this.gd_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.gd_1 === 3) {
          throw e_1;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(_launch$slambda).t5l = function ($this$launch, completion) {
    var i = new _launch$slambda(this.c5m_1, completion);
    i.d5m_1 = $this$launch;
    return i;
  };
  function _launch$slambda_0($callback, resultContinuation) {
    var i = new _launch$slambda($callback, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e5m($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function launchUnscopedAndWait$1($this_launchUnscopedAndWait, $deferred) {
    this.g5m_1 = $deferred;
    this.f5m_1 = $this_launchUnscopedAndWait;
  }
  protoOf(launchUnscopedAndWait$1).q6 = function () {
    return this.f5m_1;
  };
  protoOf(launchUnscopedAndWait$1).s6 = function (result) {
    completeWith(this.g5m_1, result);
  };
  function DEBUG_ASYNC_LAUNCH_ERRORS$factory() {
    return getPropertyCallableRef('DEBUG_ASYNC_LAUNCH_ERRORS', 0, KProperty0, function () {
      return get_DEBUG_ASYNC_LAUNCH_ERRORS();
    }, null);
  }
  var properties_initialized_AsyncExt_kt_7k2grr;
  function _init_properties_AsyncExt_kt__ahev1h() {
    if (!properties_initialized_AsyncExt_kt_7k2grr) {
      properties_initialized_AsyncExt_kt_7k2grr = true;
      logger = Companion_getInstance_6().r24('AsyncExt');
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      DEFAULT_SUSPEND_TEST_TIMEOUT = toDuration(20, DurationUnit_SECONDS_getInstance());
      DEFAULT_TEST_SYNC_IO = false;
      DEBUG_ASYNC_LAUNCH_ERRORS$delegate = lazy(DEBUG_ASYNC_LAUNCH_ERRORS$delegate$lambda);
    }
  }
  function AsyncThread$sync$slambda($oldPromise, $func, resultContinuation) {
    this.p5m_1 = $oldPromise;
    this.q5m_1 = $func;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncThread$sync$slambda).t5m = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(AsyncThread$sync$slambda).be = function ($completion) {
    return this.t5m($completion);
  };
  protoOf(AsyncThread$sync$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.r5m_1 = this.p5m_1;
            if (this.r5m_1 == null) {
              this.s5m_1 = null;
              this.fd_1 = 2;
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = this.r5m_1.q1d(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.s5m_1 = suspendResult;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.fd_1 = 3;
            suspendResult = this.q5m_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncThread$sync$slambda).g5a = function (completion) {
    return new AsyncThread$sync$slambda(this.p5m_1, this.q5m_1, completion);
  };
  function AsyncThread$sync$slambda_0($oldPromise, $func, resultContinuation) {
    var i = new AsyncThread$sync$slambda($oldPromise, $func, resultContinuation);
    var l = function ($completion) {
      return i.t5m($completion);
    };
    l.$arity = 0;
    return l;
  }
  function AsyncThread() {
    this.u5m_1 = null;
  }
  protoOf(AsyncThread).v5m = function (func, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.q6();
    var task = this.w5m(tmp$ret$0, func);
    return task.q1d($completion);
  };
  protoOf(AsyncThread).w5m = function (context, func) {
    var oldPromise = this.u5m_1;
    var promise = asyncImmediately(context, AsyncThread$sync$slambda_0(oldPromise, func, null));
    this.u5m_1 = promise;
    return promise;
  };
  function delay_0(_this__u8e3s4, time, $completion) {
    return delay(get_millisecondsLong(time), $completion);
  }
  function withTimeoutNullable(time, block, $completion) {
    var tmp = new $withTimeoutNullableCOROUTINE$85(time, block, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function $withTimeoutNullableCOROUTINE$85(time, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f5n_1 = time;
    this.g5n_1 = block;
  }
  protoOf($withTimeoutNullableCOROUTINE$85).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            var tmp_0;
            var tmp_1 = this.f5n_1;
            if ((tmp_1 == null ? null : new Duration(tmp_1)) == null) {
              tmp_0 = true;
            } else {
              tmp_0 = get_isNil(this.f5n_1);
            }

            if (tmp_0) {
              this.fd_1 = 2;
              suspendResult = this.g5n_1(CoroutineScope(this.q6()), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = withTimeout(get_millisecondsLong(this.f5n_1), this.g5n_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.h5n_1 = suspendResult;
            this.fd_1 = 3;
            continue $sm;
          case 2:
            this.h5n_1 = suspendResult;
            this.fd_1 = 3;
            continue $sm;
          case 3:
            return this.h5n_1;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function Companion_41() {
    Companion_instance_49 = this;
    this.i5n_1 = new PreferSyncIo(true);
    this.j5n_1 = new PreferSyncIo(false);
  }
  protoOf(Companion_41).k5n = function (preferSyncIo) {
    return preferSyncIo === true ? this.i5n_1 : this.j5n_1;
  };
  var Companion_instance_49;
  function Companion_getInstance_56() {
    if (Companion_instance_49 == null)
      new Companion_41();
    return Companion_instance_49;
  }
  function PreferSyncIo(preferSyncIo) {
    Companion_getInstance_56();
    this.l5n_1 = preferSyncIo;
  }
  protoOf(PreferSyncIo).l2 = function () {
    return Companion_getInstance_56();
  };
  protoOf(PreferSyncIo).toString = function () {
    return 'PreferSyncIo(preferSyncIo=' + this.l5n_1 + ')';
  };
  protoOf(PreferSyncIo).hashCode = function () {
    return getBooleanHashCode(this.l5n_1);
  };
  protoOf(PreferSyncIo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PreferSyncIo))
      return false;
    var tmp0_other_with_cast = other instanceof PreferSyncIo ? other : THROW_CCE();
    if (!(this.l5n_1 === tmp0_other_with_cast.l5n_1))
      return false;
    return true;
  };
  function Signal$_init_$lambda_6vimhp() {
    return Unit_instance;
  }
  function Signal(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = Signal$_init_$lambda_6vimhp;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    BaseSignal.call(this, onRegister);
  }
  protoOf(Signal).q5n = function (handler) {
    return this.v5n(false, handler);
  };
  protoOf(Signal).w5n = function (handler) {
    return this.q5n(handler);
  };
  protoOf(Signal).x5n = function (value) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
      if (this.s5n_1.b1()) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
      try {
        this.u5n_1 = this.u5n_1 + 1 | 0;
        // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
        var this_0 = this.s5n_1;
        var n = 0;
        var m = 0;
        while (n < this_0.n()) {
          if (m >= 0 ? !(m === n) : false) {
            this_0.o(m, this_0.f1(n));
          }
          // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
          var node = this_0.f1(n);
          var remove = node.y5n_1;
          // Inline function 'korlibs.io.async.Signal.invoke.<anonymous>' call
          node.z5n_1(value);
          if (remove) {
            m = m - 1 | 0;
          }
          n = n + 1 | 0;
          m = m + 1 | 0;
        }
        while (this_0.n() > m) {
          this_0.h1(this_0.n() - 1 | 0);
        }
      }finally {
        this.u5n_1 = this.u5n_1 - 1 | 0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.t5n_1.b1()) {
          // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
          var this_1 = this.t5n_1;
          var n_0 = 0;
          var m_0 = 0;
          while (n_0 < this_1.n()) {
            if (m_0 >= 0 ? !(m_0 === n_0) : false) {
              this_1.o(m_0, this_1.f1(n_0));
            }
            // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
            var it = this_1.f1(n_0);
            this.s5n_1.s(it);
            if (true) {
              m_0 = m_0 - 1 | 0;
            }
            n_0 = n_0 + 1 | 0;
            m_0 = m_0 + 1 | 0;
          }
          while (this_1.n() > m_0) {
            this_1.h1(this_1.n() - 1 | 0);
          }
        }
      }
    }
    return tmp$ret$0;
  };
  function Node($outer, once, item) {
    this.a5o_1 = $outer;
    this.y5n_1 = once;
    this.z5n_1 = item;
  }
  protoOf(Node).p21 = function () {
    if (this.a5o_1.u5n_1 > 0) {
      this.a5o_1.t5n_1.r(this);
    } else {
      this.a5o_1.s5n_1.s(this);
    }
  };
  function BaseSignal$_init_$lambda_tuu04y() {
    return Unit_instance;
  }
  function BaseSignal(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = BaseSignal$_init_$lambda_tuu04y;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    this.r5n_1 = onRegister;
    this.s5n_1 = FastArrayList_init_$Create$();
    this.t5n_1 = FastArrayList_init_$Create$();
    this.u5n_1 = 0;
  }
  protoOf(BaseSignal).b5o = function () {
    return this.s5n_1.n();
  };
  protoOf(BaseSignal).c5o = function () {
    return this.b5o() > 0;
  };
  protoOf(BaseSignal).v5n = function (once, handler) {
    this.r5n_1();
    var node = new Node(this, once, handler);
    this.s5n_1.r(node);
    return node;
  };
  function invoke_0(_this__u8e3s4) {
    return _this__u8e3s4.x5n(Unit_instance);
  }
  function AsyncSignal$_init_$lambda_rsv6fb() {
    return Unit_instance;
  }
  function $invokeCOROUTINE$86(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l5o_1 = _this__u8e3s4;
    this.m5o_1 = value;
  }
  protoOf($invokeCOROUTINE$86).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 11;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.o5o_1 = this.l5o_1;
            if (this.o5o_1.s5n_1.b1()) {
              this.n5o_1 = Unit_instance;
              this.fd_1 = 10;
              continue $sm;
            } else {
              this.fd_1 = 2;
              continue $sm;
            }

          case 2:
            this.fd_1 = 3;
            continue $sm;
          case 3:
            this.gd_1 = 9;
            var tmp0_this = this.o5o_1;
            tmp0_this.u5n_1 = tmp0_this.u5n_1 + 1 | 0;
            var tmp_1 = this;
            tmp_1.q5o_1 = this.o5o_1.s5n_1;
            this.r5o_1 = 0;
            this.s5o_1 = 0;
            this.fd_1 = 4;
            continue $sm;
          case 4:
            if (!(this.r5o_1 < this.q5o_1.n())) {
              this.fd_1 = 7;
              continue $sm;
            }

            if (this.s5o_1 >= 0 ? !(this.s5o_1 === this.r5o_1) : false) {
              this.q5o_1.o(this.s5o_1, this.q5o_1.f1(this.r5o_1));
            }

            var tmp_2 = this;
            tmp_2.t5o_1 = this.q5o_1.f1(this.r5o_1);
            this.u5o_1 = this.t5o_1.y5n_1;
            var tmp_3 = this;
            tmp_3.v5o_1 = this.t5o_1.z5n_1;
            this.fd_1 = 5;
            suspendResult = this.v5o_1(this.m5o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (this.u5o_1) {
              this.s5o_1 = this.s5o_1 - 1 | 0;
              this.fd_1 = 6;
              continue $sm;
            } else {
              this.fd_1 = 6;
              continue $sm;
            }

          case 6:
            this.r5o_1 = this.r5o_1 + 1 | 0;
            this.s5o_1 = this.s5o_1 + 1 | 0;
            this.fd_1 = 4;
            continue $sm;
          case 7:
            while (this.q5o_1.n() > this.s5o_1) {
              this.q5o_1.h1(this.q5o_1.n() - 1 | 0);
            }

            var tmp_4 = this;
            tmp_4.p5o_1 = Unit_instance;
            this.gd_1 = 11;
            this.fd_1 = 8;
            continue $sm;
          case 8:
            this.gd_1 = 11;
            var tmp2_this = this.o5o_1;
            tmp2_this.u5n_1 = tmp2_this.u5n_1 - 1 | 0;
            if (!this.o5o_1.t5n_1.b1()) {
              var this_0 = this.o5o_1.t5n_1;
              var n = 0;
              var m = 0;
              while (n < this_0.n()) {
                if (m >= 0 ? !(m === n) : false) {
                  this_0.o(m, this_0.f1(n));
                }
                var it = this_0.f1(n);
                this.o5o_1.s5n_1.s(it);
                m = m - 1 | 0;
                n = n + 1 | 0;
                m = m + 1 | 0;
              }
              while (this_0.n() > m) {
                this_0.h1(this_0.n() - 1 | 0);
              }
            }

            if (false) {
              this.fd_1 = 1;
              continue $sm;
            }

            this.fd_1 = 10;
            continue $sm;
          case 9:
            this.gd_1 = 11;
            var t = this.id_1;
            var tmp2_this_0 = this.o5o_1;
            tmp2_this_0.u5n_1 = tmp2_this_0.u5n_1 - 1 | 0;
            if (!this.o5o_1.t5n_1.b1()) {
              var this_1 = this.o5o_1.t5n_1;
              var n_0 = 0;
              var m_0 = 0;
              while (n_0 < this_1.n()) {
                if (m_0 >= 0 ? !(m_0 === n_0) : false) {
                  this_1.o(m_0, this_1.f1(n_0));
                }
                var it_0 = this_1.f1(n_0);
                this.o5o_1.s5n_1.s(it_0);
                m_0 = m_0 - 1 | 0;
                n_0 = n_0 + 1 | 0;
                m_0 = m_0 + 1 | 0;
              }
              while (this_1.n() > m_0) {
                this_1.h1(this_1.n() - 1 | 0);
              }
            }

            throw t;
          case 10:
            return Unit_instance;
          case 11:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 11) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function AsyncSignal(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = AsyncSignal$_init_$lambda_rsv6fb;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    BaseSignal.call(this, onRegister);
  }
  protoOf(AsyncSignal).a5p = function (value, $completion) {
    var tmp = new $invokeCOROUTINE$86(this, value, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function runBlockingNoSuspensions(callback) {
    var completed = {_v: false};
    var rresult = {_v: null};
    var resultEx = {_v: null};
    var suspendCount = {_v: 0};
    startCoroutineUndispatched(callback, new runBlockingNoSuspensions$1(suspendCount, resultEx, completed, rresult));
    if (!completed._v) {
      invalidOp('runBlockingNoSuspensions was not completed synchronously! suspendCount=' + suspendCount._v);
    }
    if (!(resultEx._v == null))
      throw ensureNotNull(resultEx._v);
    var tmp;
    if (rresult._v == null) {
      throwUninitializedPropertyAccessException('rresult');
    } else {
      tmp = rresult._v;
    }
    return tmp;
  }
  function startCoroutineUndispatched(_this__u8e3s4, completion) {
    $l$block: {
      // Inline function 'korlibs.io.async.startDirect' call
      var tmp;
      try {
        // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>' call
        // Inline function 'korlibs.io.async.withCoroutineContext' call
        completion.q6();
        // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
        // Inline function 'kotlin.js.asDynamic' call
        var a = _this__u8e3s4;
        tmp = typeof a === 'function' ? a(completion) : _this__u8e3s4.be(completion);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(e));
          completion.s6(tmp$ret$5);
          break $l$block;
        } else {
          throw $p;
        }
      }
      var value = tmp;
      if (!(value === get_COROUTINE_SUSPENDED())) {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
        var tmp$ret$8 = _Result___init__impl__xyqfz8(value_0);
        completion.s6(tmp$ret$8);
      }
    }
  }
  function _get_unitInstance__yoa8mq($this) {
    return Unit_instance;
  }
  function runBlockingNoSuspensions$1$context$1($suspendCount) {
    this.d5p_1 = $suspendCount;
    AbstractCoroutineContextElement.call(this, Key_instance);
    this.c5p_1 = Key_instance;
  }
  protoOf(runBlockingNoSuspensions$1$context$1).l2 = function () {
    return this.c5p_1;
  };
  protoOf(runBlockingNoSuspensions$1$context$1).pd = function (continuation) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.async.<no name provided>.interceptContinuation.<anonymous>' call
    var tmp0 = this.d5p_1._v;
    this.d5p_1._v = tmp0 + 1 | 0;
    return continuation;
  };
  protoOf(runBlockingNoSuspensions$1$context$1).d1h = function (timeMillis, continuation) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    continuation.s6(tmp$ret$0);
    return Unit_instance;
  };
  function runBlockingNoSuspensions$1($suspendCount, $resultEx, $completed, $rresult) {
    this.f5p_1 = $resultEx;
    this.g5p_1 = $completed;
    this.h5p_1 = $rresult;
    var tmp = this;
    tmp.e5p_1 = new runBlockingNoSuspensions$1$context$1($suspendCount);
  }
  protoOf(runBlockingNoSuspensions$1).q6 = function () {
    return this.e5p_1;
  };
  protoOf(runBlockingNoSuspensions$1).i5p = function (result) {
    var exception = Result__exceptionOrNull_impl_p6xea9(result);
    if (!(exception == null)) {
      this.f5p_1._v = exception;
      this.g5p_1._v = true;
      printStackTrace(exception);
    } else {
      // Inline function 'kotlin.getOrThrow' call
      throwOnFailure(result);
      var tmp = _Result___get_value__impl__bjfvqg(result);
      var tmp0_elvis_lhs = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        _get_unitInstance__yoa8mq(this);
        var tmp_1 = Unit_instance;
        var tmp_2;
        if (!(Unit_instance == null)) {
          tmp_2 = Unit_instance;
        } else {
          tmp_2 = THROW_CCE();
        }
        tmp_0 = tmp_2;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var rvalue = tmp_0;
      this.h5p_1._v = rvalue;
      this.g5p_1._v = true;
    }
  };
  protoOf(runBlockingNoSuspensions$1).s6 = function (result) {
    return this.i5p(result);
  };
  function uncompress_0(_this__u8e3s4, method, outputSizeHint) {
    outputSizeHint = outputSizeHint === VOID ? imul(_this__u8e3s4.length, 2) : outputSizeHint;
    return uncompress_1(method, _this__u8e3s4, outputSizeHint);
  }
  function CompressionMethod() {
  }
  function uncompress_1(_this__u8e3s4, bytes, outputSizeHint) {
    outputSizeHint = outputSizeHint === VOID ? imul(bytes.length, 2) : outputSizeHint;
    // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
    var buffer = ByteArrayBuilder_init_$Create$(outputSizeHint);
    var s = MemorySyncStream(buffer);
    // Inline function 'korlibs.io.compression.uncompress.<anonymous>' call
    uncompress_2(_this__u8e3s4, openSync(bytes), s);
    return buffer.t37();
  }
  function uncompress_2(_this__u8e3s4, i, o) {
    return runBlockingNoSuspensions(uncompress$slambda_0(_this__u8e3s4, i, o, null));
  }
  function uncompress_3(_this__u8e3s4, i, o, $completion) {
    var tmp = new $uncompressCOROUTINE$88(_this__u8e3s4, i, o, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function uncompress$slambda($this_uncompress, $i, $o, resultContinuation) {
    this.e5q_1 = $this_uncompress;
    this.f5q_1 = $i;
    this.g5q_1 = $o;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(uncompress$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(uncompress$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(uncompress$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = uncompress_3(this.e5q_1, toAsyncInputStream(this.f5q_1), toAsyncOutputStream(this.g5q_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(uncompress$slambda).g5a = function (completion) {
    return new uncompress$slambda(this.e5q_1, this.f5q_1, this.g5q_1, completion);
  };
  function uncompress$slambda_0($this_uncompress, $i, $o, resultContinuation) {
    var i = new uncompress$slambda($this_uncompress, $i, $o, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $uncompressCOROUTINE$88(_this__u8e3s4, i, o, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s5p_1 = _this__u8e3s4;
    this.t5p_1 = i;
    this.u5p_1 = o;
  }
  protoOf($uncompressCOROUTINE$88).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = Companion_instance_53.k5q(this.t5p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.v5p_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = this.s5p_1.j5p(this.v5p_1, this.u5p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function Companion_42() {
    this.l5q_1 = 8388608;
    this.m5q_1 = 131072;
  }
  var Companion_instance_50;
  function Companion_getInstance_57() {
    return Companion_instance_50;
  }
  function SlidingWindowWithOutput(sliding, out, flushSize, extraSize) {
    flushSize = flushSize === VOID ? 8388608 : flushSize;
    extraSize = extraSize === VOID ? 131072 : extraSize;
    this.n5q_1 = sliding;
    this.o5q_1 = out;
    this.p5q_1 = flushSize;
    this.q5q_1 = extraSize;
    this.r5q_1 = FixedSizeByteArrayBuilder_init_$Create$(this.p5q_1 + this.q5q_1 | 0);
  }
  protoOf(SlidingWindowWithOutput).s5q = function () {
    return this.r5q_1.v37_1 >= this.p5q_1;
  };
  protoOf(SlidingWindowWithOutput).t5q = function (distance, length) {
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = this.n5q_1.y5q(distance);
        this.r5q_1.s37(toByte(v));
      }
       while (inductionVariable < length);
  };
  protoOf(SlidingWindowWithOutput).z5q = function (bytes, offset, len) {
    this.r5q_1.q37(bytes, offset, len);
    this.n5q_1.a5r(bytes, offset, len);
  };
  protoOf(SlidingWindowWithOutput).b5r = function (byte) {
    this.r5q_1.s37(byte);
    // Inline function 'korlibs.math.unsigned' call
    var tmp$ret$0 = byte & 255;
    this.n5q_1.c5r(tmp$ret$0);
  };
  function Companion_43() {
    Companion_instance_51 = this;
    DeflatePortable.call(this, 15);
    var tmp = this;
    var tmp_0 = new HuffmanTree();
    // Inline function 'kotlin.apply' call
    var this_0 = new Int32Array(288);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.compression.deflate.Companion.FIXED_TREE.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable <= 143)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0[n] = 8;
      }
       while (inductionVariable <= 143);
    var inductionVariable_0 = 144;
    if (inductionVariable_0 <= 255)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_0[n_0] = 9;
      }
       while (inductionVariable_0 <= 255);
    var inductionVariable_1 = 256;
    if (inductionVariable_1 <= 279)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        this_0[n_1] = 7;
      }
       while (inductionVariable_1 <= 279);
    var inductionVariable_2 = 280;
    if (inductionVariable_2 <= 287)
      do {
        var n_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        this_0[n_2] = 8;
      }
       while (inductionVariable_2 <= 287);
    tmp.e5r_1 = tmp_0.x5r(this_0);
    var tmp_1 = this;
    var tmp_2 = new HuffmanTree();
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(32);
    while (tmp_3 < 32) {
      tmp_4[tmp_3] = 5;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_1.f5r_1 = tmp_2.x5r(tmp_4);
    var tmp_5 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_5.g5r_1 = new Int32Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0]);
    var tmp_6 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_6.h5r_1 = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]);
    var tmp_7 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_7.i5r_1 = new Int32Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
    var tmp_8 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_8.j5r_1 = new Int32Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]);
    var tmp_9 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_9.k5r_1 = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  }
  var Companion_instance_51;
  function Companion_getInstance_58() {
    if (Companion_instance_51 == null)
      new Companion_43();
    return Companion_instance_51;
  }
  function $uncompressCOROUTINE$90(_this__u8e3s4, reader, out, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h5s_1 = _this__u8e3s4;
    this.i5s_1 = reader;
    this.j5s_1 = out;
  }
  protoOf($uncompressCOROUTINE$90).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 20;
            this.k5s_1 = new SlidingWindowWithOutput(new SlidingWindow(this.h5s_1.y5r_1), this.j5s_1, this.i5s_1.n5t_1, this.i5s_1.o5t_1);
            this.l5s_1 = false;
            this.m5s_1 = new HuffmanTree();
            this.n5s_1 = new HuffmanTree();
            this.o5s_1 = new Int32Array(32);
            this.p5s_1 = new Int32Array(512);
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!!this.l5s_1) {
              this.fd_1 = 17;
              continue $sm;
            }

            var tmp_0 = this;
            tmp_0.q5s_1 = this.k5s_1;
            var tmp_1 = this;
            tmp_1.r5s_1 = false;
            if (this.r5s_1 ? true : this.q5s_1.s5q()) {
              var tmp_2 = this;
              tmp_2.s5s_1 = this.q5s_1;
              this.fd_1 = 2;
              suspendResult = this.s5s_1.o5q_1.v5t(this.s5s_1.r5q_1.u37_1, 0, this.s5s_1.r5q_1.v37_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 3;
              continue $sm;
            }

          case 2:
            this.s5s_1.r5q_1.b3();
            this.fd_1 = 3;
            continue $sm;
          case 3:
            var tmp_3 = this;
            tmp_3.t5s_1 = this.i5s_1;
            if (this.t5s_1.x5t()) {
              this.fd_1 = 4;
              suspendResult = this.t5s_1.w5t(this.t5s_1.n5t_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 5;
              continue $sm;
            }

          case 4:
            this.fd_1 = 5;
            continue $sm;
          case 5:
            this.l5s_1 = this.i5s_1.y5t();
            this.u5s_1 = this.i5s_1.z5t(2);
            var containsArg = this.u5s_1;
            if (!(0 <= containsArg ? containsArg <= 2 : false)) {
              var message = 'invalid bit';
              throw IllegalStateException_init_$Create$(toString(message));
            }

            if (this.u5s_1 === 0) {
              this.v5s_1 = this.i5s_1.d5u();
              this.w5s_1 = this.i5s_1.d5u();
              this.x5s_1 = ~this.w5s_1 & 65535;
              if (!(this.v5s_1 === this.x5s_1)) {
                var message_0 = 'Invalid deflate stream: len(' + this.v5s_1 + ') != ~nlen(' + this.x5s_1 + ') :: nlen=' + this.w5s_1;
                throw IllegalStateException_init_$Create$(toString(message_0));
              }
              this.fd_1 = 13;
              suspendResult = this.i5s_1.e5u(this.v5s_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (this.u5s_1 === 1) {
                this.y5s_1 = Companion_getInstance_58().e5r_1;
                this.z5s_1 = Companion_getInstance_58().f5r_1;
              } else {
                var hlit = this.i5s_1.z5t(5) + 257 | 0;
                var hdist = this.i5s_1.z5t(5) + 1 | 0;
                var hclen = this.i5s_1.z5t(4) + 4 | 0;
                fill(this.o5s_1, 0);
                var inductionVariable = 0;
                if (inductionVariable < hclen)
                  do {
                    var i = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    this.o5s_1[Companion_getInstance_58().k5r_1[i]] = this.i5s_1.z5t(3);
                  }
                   while (inductionVariable < hclen);
                this.m5s_1.a5u(this.o5s_1);
                var codeLen = this.m5s_1;
                var hlithdist = hlit + hdist | 0;
                var n = 0;
                fill(this.p5s_1, 0);
                while (n < hlithdist) {
                  this.h5s_1;
                  var this_0 = this.i5s_1;
                  var value = codeLen.b5u(this_0);
                  if (!(0 <= value ? value <= 18 : false)) {
                    throw IllegalStateException_init_$Create$(toString('Invalid'));
                  }
                  var len;
                  switch (value) {
                    case 16:
                      len = this.i5s_1.z5t(2) + 3 | 0;
                      break;
                    case 17:
                      len = this.i5s_1.z5t(3) + 3 | 0;
                      break;
                    case 18:
                      len = this.i5s_1.z5t(7) + 11 | 0;
                      break;
                    default:
                      len = 1;
                      break;
                  }
                  var vv;
                  switch (value) {
                    case 16:
                      vv = this.p5s_1[n - 1 | 0];
                      break;
                    case 17:
                      vv = 0;
                      break;
                    case 18:
                      vv = 0;
                      break;
                    default:
                      vv = value;
                      break;
                  }
                  fill(this.p5s_1, vv, n, n + len | 0);
                  n = n + len | 0;
                }
                this.m5s_1.c5u(this.p5s_1, 0, hlit);
                this.n5s_1.c5u(this.p5s_1, hlit, hlithdist);
                this.y5s_1 = this.m5s_1;
                this.z5s_1 = this.n5s_1;
              }
              this.fd_1 = 6;
              continue $sm;
            }

          case 6:
            if (!true) {
              this.fd_1 = 12;
              continue $sm;
            }

            var tmp_4 = this;
            tmp_4.a5t_1 = this.i5s_1;
            if (this.a5t_1.x5t()) {
              this.fd_1 = 7;
              suspendResult = this.a5t_1.w5t(this.a5t_1.n5t_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 8;
              continue $sm;
            }

          case 7:
            this.fd_1 = 8;
            continue $sm;
          case 8:
            this.b5t_1 = this.y5s_1.b5u(this.i5s_1);
            if (this.b5t_1 === 256) {
              this.fd_1 = 12;
              continue $sm;
            } else {
              this.fd_1 = 9;
              continue $sm;
            }

          case 9:
            if (this.b5t_1 < 256) {
              this.k5s_1.b5r(toByte(this.b5t_1));
            } else {
              var zlenof = this.b5t_1 - 257 | 0;
              var lengthExtra = this.i5s_1.z5t(Companion_getInstance_58().g5r_1[zlenof]);
              this.h5s_1;
              var this_1 = this.i5s_1;
              var distanceData = this.z5s_1.b5u(this_1);
              var distanceExtra = this.i5s_1.z5t(Companion_getInstance_58().i5r_1[distanceData]);
              var distance = Companion_getInstance_58().j5r_1[distanceData] + distanceExtra | 0;
              var length = Companion_getInstance_58().h5r_1[zlenof] + lengthExtra | 0;
              this.k5s_1.t5q(distance, length);
            }

            var tmp_5 = this;
            tmp_5.c5t_1 = this.k5s_1;
            var tmp_6 = this;
            tmp_6.d5t_1 = false;
            if (this.d5t_1 ? true : this.c5t_1.s5q()) {
              var tmp_7 = this;
              tmp_7.e5t_1 = this.c5t_1;
              this.fd_1 = 10;
              suspendResult = this.e5t_1.o5q_1.v5t(this.e5t_1.r5q_1.u37_1, 0, this.e5t_1.r5q_1.v37_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 11;
              continue $sm;
            }

          case 10:
            this.e5t_1.r5q_1.b3();
            this.fd_1 = 11;
            continue $sm;
          case 11:
            this.fd_1 = 6;
            continue $sm;
          case 12:
            this.fd_1 = 16;
            continue $sm;
          case 13:
            this.f5t_1 = suspendResult;
            this.k5s_1.z5q(this.f5t_1, 0, this.v5s_1);
            var tmp_8 = this;
            tmp_8.g5t_1 = this.k5s_1;
            var tmp_9 = this;
            tmp_9.h5t_1 = false;
            if (this.h5t_1 ? true : this.g5t_1.s5q()) {
              var tmp_10 = this;
              tmp_10.i5t_1 = this.g5t_1;
              this.fd_1 = 14;
              suspendResult = this.i5t_1.o5q_1.v5t(this.i5t_1.r5q_1.u37_1, 0, this.i5t_1.r5q_1.v37_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 15;
              continue $sm;
            }

          case 14:
            this.i5t_1.r5q_1.b3();
            this.fd_1 = 15;
            continue $sm;
          case 15:
            this.fd_1 = 16;
            continue $sm;
          case 16:
            this.fd_1 = 1;
            continue $sm;
          case 17:
            var tmp_11 = this;
            tmp_11.j5t_1 = this.k5s_1;
            var tmp_12 = this;
            tmp_12.k5t_1 = true;
            if (this.k5t_1 ? true : this.j5t_1.s5q()) {
              var tmp_13 = this;
              tmp_13.l5t_1 = this.j5t_1;
              this.fd_1 = 18;
              suspendResult = this.l5t_1.o5q_1.v5t(this.l5t_1.r5q_1.u37_1, 0, this.l5t_1.r5q_1.v37_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 19;
              continue $sm;
            }

          case 18:
            this.l5t_1.r5q_1.b3();
            this.fd_1 = 19;
            continue $sm;
          case 19:
            return Unit_instance;
          case 20:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 20) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function DeflatePortable(windowBits) {
    Companion_getInstance_58();
    this.y5r_1 = windowBits;
  }
  protoOf(DeflatePortable).j5p = function (reader, out, $completion) {
    var tmp = new $uncompressCOROUTINE$90(this, reader, out, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function ZLib$Companion$_init_$lambda_nrgg4o(it) {
    return Deflate(it);
  }
  function $writeCOROUTINE$99(_this__u8e3s4, buffer, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n5u_1 = _this__u8e3s4;
    this.o5u_1 = buffer;
    this.p5u_1 = offset;
    this.q5u_1 = len;
  }
  protoOf($writeCOROUTINE$99).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.n5u_1.r5u_1.v5t(this.o5u_1, this.p5u_1, this.q5u_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n5u_1.s5u_1._v = Adler32_instance.v5u(this.n5u_1.s5u_1._v, this.o5u_1, this.p5u_1, this.q5u_1);
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function Companion_44() {
    Companion_instance_52 = this;
    ZLib.call(this, ZLib$Companion$_init_$lambda_nrgg4o);
  }
  var Companion_instance_52;
  function Companion_getInstance_59() {
    if (Companion_instance_52 == null)
      new Companion_44();
    return Companion_instance_52;
  }
  function ZLib$uncompress$2($o, $chash) {
    this.r5u_1 = $o;
    this.s5u_1 = $chash;
  }
  protoOf(ZLib$uncompress$2).x5u = function ($completion) {
    return this.r5u_1.x5u($completion);
  };
  protoOf(ZLib$uncompress$2).v5t = function (buffer, offset, len, $completion) {
    var tmp = new $writeCOROUTINE$99(this, buffer, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function $uncompressCOROUTINE$97(_this__u8e3s4, reader, out, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g5v_1 = _this__u8e3s4;
    this.h5v_1 = reader;
    this.i5v_1 = out;
  }
  protoOf($uncompressCOROUTINE$97).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            this.j5v_1 = this.h5v_1;
            this.k5v_1 = this.i5v_1;
            var tmp_0 = this;
            tmp_0.l5v_1 = this.j5v_1;
            if (this.l5v_1.x5t()) {
              this.fd_1 = 1;
              suspendResult = this.l5v_1.w5t(this.l5v_1.n5t_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.m5v_1 = this.j5v_1.w5v();
            this.n5v_1 = this.j5v_1.w5v();
            if (!(((imul(this.m5v_1, 256) + this.n5v_1 | 0) % 31 | 0) === 0)) {
              var message = 'bad zlib header';
              throw IllegalStateException_init_$Create$(toString(message));
            }

            this.o5v_1 = extract(this.m5v_1, 0, 4);
            if (!(this.o5v_1 === 8)) {
              var message_0 = 'Invalid zlib stream compressionMethod=' + this.o5v_1;
              throw IllegalStateException_init_$Create$(toString(message_0));
            }

            this.p5v_1 = extract(this.m5v_1, 4, 4) + 8 | 0;
            this.q5v_1 = extract(this.n5v_1, 0, 5);
            var tmp_1 = this;
            tmp_1.r5v_1 = !(((this.n5v_1 >>> 5 | 0) & 1) === 0);
            this.s5v_1 = extract(this.n5v_1, 6, 2);
            this.t5v_1 = 0;
            if (this.r5v_1) {
              this.t5v_1 = this.j5v_1.x5v();
              var reason = 'Unsupported custom dictionaries (Provided DICTID=' + this.t5v_1 + ')';
              throw new NotImplementedError('An operation is not implemented: ' + reason);
            }

            this.u5v_1 = {_v: Adler32_instance.u5u_1};
            this.fd_1 = 3;
            var tmp_2 = this.g5v_1.w5u_1(this.p5v_1);
            suspendResult = tmp_2.j5p(this.j5v_1, new ZLib$uncompress$2(this.k5v_1, this.u5v_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp_3 = this;
            tmp_3.v5v_1 = this.j5v_1;
            if (this.v5v_1.x5t()) {
              this.fd_1 = 4;
              suspendResult = this.v5v_1.w5t(this.v5v_1.n5t_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 5;
              continue $sm;
            }

          case 4:
            this.fd_1 = 5;
            continue $sm;
          case 5:
            var adler32 = this.j5v_1.y5v();
            if (!(this.u5v_1._v === adler32)) {
              invalidOp("Adler32 doesn't match " + get_hex(this.u5v_1._v) + ' != ' + get_hex(adler32));
            }

            return Unit_instance;
          case 6:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 6) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function ZLib(deflater) {
    Companion_getInstance_59();
    this.w5u_1 = deflater;
  }
  protoOf(ZLib).j5p = function (reader, out, $completion) {
    var tmp = new $uncompressCOROUTINE$97(this, reader, out, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function $forInputCOROUTINE$101(_this__u8e3s4, s, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h5w_1 = _this__u8e3s4;
    this.i5w_1 = s;
  }
  protoOf($forInputCOROUTINE$101).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 5;
            var tmp_0 = this.i5w_1;
            if (isInterface(tmp_0, AsyncGetLengthStream)) {
              this.fd_1 = 1;
              suspendResult = this.i5w_1.l5w(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.j5w_1 = false;
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            this.j5w_1 = suspendResult;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            if (this.j5w_1) {
              var tmp_1 = this;
              tmp_1.k5w_1 = 32768;
              this.fd_1 = 4;
              suspendResult = this.i5w_1.m5w(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 3;
              continue $sm;
            }

          case 3:
            return new BitReader(this.i5w_1);
          case 4:
            var a = suspendResult;
            var b = new Long(8388608, 0);
            var ARGUMENT = a.t6(b) <= 0 ? a : b;
            var b_0 = ARGUMENT.kb();
            var bigChunkSize = Math.max(this.k5w_1, b_0);
            var a_0 = bigChunkSize / 2 | 0;
            var readWithSize = Math.max(a_0, 32768);
            return new BitReader(this.i5w_1, bigChunkSize, readWithSize);
          case 5:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 5) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function Companion_45() {
    this.i5q_1 = 8388608;
    this.j5q_1 = 32768;
  }
  protoOf(Companion_45).k5q = function (s, $completion) {
    var tmp = new $forInputCOROUTINE$101(this, s, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  var Companion_instance_53;
  function Companion_getInstance_60() {
    return Companion_instance_53;
  }
  function $prepareBytesUpToCOROUTINE$103(_this__u8e3s4, expectedBytes, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v5w_1 = _this__u8e3s4;
    this.w5w_1 = expectedBytes;
  }
  protoOf($prepareBytesUpToCOROUTINE$103).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!(this.v5w_1.r5t_1.n1z_1 < this.w5w_1)) {
              this.fd_1 = 5;
              continue $sm;
            }

            var tmp_0 = this;
            var a = this.w5w_1;
            var b = this.v5w_1.r5t_1.s1z();
            tmp_0.x5w_1 = Math.min(a, b);
            if (this.x5w_1 <= 0) {
              this.fd_1 = 5;
              continue $sm;
            } else {
              this.fd_1 = 2;
              continue $sm;
            }

          case 2:
            this.fd_1 = 3;
            suspendResult = this.v5w_1.m5t_1.y5w(this.v5w_1.r5t_1.o1z(), this.v5w_1.r5t_1.p1z(), this.x5w_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var transferred = suspendResult;
            if (transferred <= 0) {
              this.fd_1 = 5;
              continue $sm;
            } else {
              this.fd_1 = 4;
              continue $sm;
            }

          case 4:
            this.v5w_1.r5t_1.q1z(transferred);
            var tmp0_this = this.v5w_1;
            tmp0_this.t5t_1 = tmp0_this.t5t_1 + transferred;
            this.fd_1 = 1;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 6) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $abytesCOROUTINE$104(_this__u8e3s4, count, out, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h5x_1 = _this__u8e3s4;
    this.i5x_1 = count;
    this.j5x_1 = out;
  }
  protoOf($abytesCOROUTINE$104).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.h5x_1.w5t(this.i5x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.h5x_1.k5x(this.i5x_1, this.j5x_1);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readCOROUTINE$105(_this__u8e3s4, buffer, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t5x_1 = _this__u8e3s4;
    this.u5x_1 = buffer;
    this.v5x_1 = offset;
    this.w5x_1 = len;
  }
  protoOf($readCOROUTINE$105).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.t5x_1.w5t(this.w5x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var out = this.t5x_1.r5t_1.t1z(this.u5x_1, this.v5x_1, this.w5x_1);
            var tmp0_this = this.t5x_1;
            tmp0_this.s5t_1 = tmp0_this.s5t_1 + out;
            return out;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $hasLengthCOROUTINE$108(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f5y_1 = _this__u8e3s4;
  }
  protoOf($hasLengthCOROUTINE$108).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            var tmp_0 = this;
            var tmp_1 = this.f5y_1.m5t_1;
            tmp_0.g5y_1 = isInterface(tmp_1, AsyncGetLengthStream) ? tmp_1 : null;
            if (this.g5y_1 == null) {
              this.h5y_1 = null;
              this.fd_1 = 2;
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = this.g5y_1.l5w(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.h5y_1 = suspendResult;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            var tmp1_elvis_lhs = this.h5y_1;
            return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $getLengthCOROUTINE$109(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q5y_1 = _this__u8e3s4;
  }
  protoOf($getLengthCOROUTINE$109).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            var tmp_0 = this;
            var tmp_1 = this.q5y_1.m5t_1;
            tmp_0.r5y_1 = isInterface(tmp_1, AsyncGetLengthStream) ? tmp_1 : null;
            if (this.r5y_1 == null) {
              this.s5y_1 = null;
              this.fd_1 = 2;
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = this.r5y_1.m5w(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.s5y_1 = suspendResult;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            var tmp1_elvis_lhs = this.s5y_1;
            var tmp_2;
            if (tmp1_elvis_lhs == null) {
              var message = 'Length not available on Stream';
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }

            return tmp_2;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function BitReader(s, bigChunkSize, readWithSize) {
    bigChunkSize = bigChunkSize === VOID ? 8388608 : bigChunkSize;
    readWithSize = readWithSize === VOID ? 32768 : readWithSize;
    this.m5t_1 = s;
    this.n5t_1 = bigChunkSize;
    this.o5t_1 = readWithSize;
    this.p5t_1 = 0;
    this.q5t_1 = 0;
    this.r5t_1 = new RingBuffer(ilog2(get_nextPowerOfTwo(this.n5t_1)));
    this.s5t_1 = 0.0;
    this.t5t_1 = 0.0;
    this.u5t_1 = new Int8Array(4);
  }
  protoOf(BitReader).toString = function () {
    return 'BitReader(' + this.m5t_1 + ', bigChunkSize=' + this.n5t_1 + ', readWithSize=' + this.o5t_1 + ')';
  };
  protoOf(BitReader).x5t = function () {
    return this.r5t_1.n1z_1 < this.o5t_1;
  };
  protoOf(BitReader).w5t = function (expectedBytes, $completion) {
    var tmp = new $prepareBytesUpToCOROUTINE$103(this, expectedBytes, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(BitReader).t5y = function (bitcount) {
    while (this.q5t_1 < bitcount) {
      var tmp = this;
      var tmp_0 = this.p5t_1;
      // Inline function 'korlibs.io.compression.util.BitReader._su8' call
      this.s5t_1 = this.s5t_1 + 1;
      tmp.p5t_1 = tmp_0 | this.r5t_1.x1z() << this.q5t_1;
      this.q5t_1 = this.q5t_1 + 8 | 0;
    }
  };
  protoOf(BitReader).u5y = function (bitcount) {
    return this.p5t_1 & ((1 << bitcount) - 1 | 0);
  };
  protoOf(BitReader).v5y = function (bitcount) {
    this.p5t_1 = this.p5t_1 >>> bitcount | 0;
    this.q5t_1 = this.q5t_1 - bitcount | 0;
  };
  protoOf(BitReader).z5t = function (bitcount) {
    this.t5y(bitcount);
    var readed = this.u5y(bitcount);
    this.v5y(bitcount);
    return readed;
  };
  protoOf(BitReader).y5t = function () {
    return !(this.z5t(1) === 0);
  };
  protoOf(BitReader).w5y = function (count, out) {
    var offset = 0;
    var count_0 = count;
    if (this.q5t_1 >= 8) {
      if (!((this.q5t_1 % 8 | 0) === 0)) {
        var bits = this.q5t_1 % 8 | 0;
        this.v5y(bits);
      }
      while (this.q5t_1 >= 8) {
        var byte = toByte(this.z5t(8));
        var tmp0 = offset;
        offset = tmp0 + 1 | 0;
        out[tmp0] = byte;
        count_0 = count_0 - 1 | 0;
      }
    }
    // Inline function 'korlibs.io.compression.util.BitReader.discardBits' call
    this.p5t_1 = 0;
    this.q5t_1 = 0;
    var readCount = this.r5t_1.t1z(out, offset, count_0);
    if (readCount > 0) {
      this.s5t_1 = this.s5t_1 + readCount;
    }
  };
  protoOf(BitReader).k5x = function (count, out) {
    this.w5y(count, out);
    return out;
  };
  protoOf(BitReader).w5v = function () {
    // Inline function 'korlibs.io.compression.util.BitReader._su8' call
    // Inline function 'korlibs.io.compression.util.BitReader.discardBits' call
    this.p5t_1 = 0;
    this.q5t_1 = 0;
    this.s5t_1 = this.s5t_1 + 1;
    return this.r5t_1.x1z();
  };
  protoOf(BitReader).d5u = function () {
    this.w5y(2, this.u5t_1);
    return getU16LE(this.u5t_1, 0);
  };
  protoOf(BitReader).x5v = function () {
    this.w5y(4, this.u5t_1);
    return getS32LE(this.u5t_1, 0);
  };
  protoOf(BitReader).y5v = function () {
    this.w5y(4, this.u5t_1);
    return getS32BE(this.u5t_1, 0);
  };
  protoOf(BitReader).x5y = function (count, out, $completion) {
    var tmp = new $abytesCOROUTINE$104(this, count, out, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(BitReader).e5u = function (count, out, $completion, $super) {
    out = out === VOID ? new Int8Array(count) : out;
    return $super === VOID ? this.x5y(count, out, $completion) : $super.x5y.call(this, count, out, $completion);
  };
  protoOf(BitReader).y5w = function (buffer, offset, len, $completion) {
    var tmp = new $readCOROUTINE$105(this, buffer, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(BitReader).x5u = function ($completion) {
    return this.m5t_1.x5u($completion);
  };
  protoOf(BitReader).y5y = function ($completion) {
    return numberToLong(this.s5t_1);
  };
  protoOf(BitReader).l5w = function ($completion) {
    var tmp = new $hasLengthCOROUTINE$108(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(BitReader).m5w = function ($completion) {
    var tmp = new $getLengthCOROUTINE$109(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function Companion_46() {
    this.z5y_1 = -1;
    this.a5z_1 = -2;
    this.b5z_1 = 1023;
    this.c5z_1 = 16;
    this.d5z_1 = 288;
    this.e5z_1 = true;
    this.f5z_1 = true;
    this.g5z_1 = 10;
  }
  var Companion_instance_54;
  function Companion_getInstance_61() {
    return Companion_instance_54;
  }
  function resetAlloc($this) {
    $this.o5r_1 = 0;
  }
  function alloc($this, value, left, right) {
    // Inline function 'kotlin.apply' call
    var tmp1 = $this.o5r_1;
    $this.o5r_1 = tmp1 + 1 | 0;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.compression.util.HuffmanTree.alloc.<anonymous>' call
    $this.l5r_1[tmp1] = value;
    $this.m5r_1[tmp1] = left;
    $this.n5r_1[tmp1] = right;
    return tmp1;
  }
  function allocLeaf($this, value) {
    return alloc($this, value, 1023, 1023);
  }
  function allocNode($this, left, right) {
    return alloc($this, -1, left, right);
  }
  function computeFastLookup($this) {
    fill($this.r5r_1, -1);
    computeEncodedValues($this, $this.p5r_1, 0, 0);
  }
  function computeEncodedValues($this, node, encoded, encodedBits) {
    // Inline function 'korlibs.io.compression.util.HuffmanTree.value' call
    if ($this.l5r_1[node] === -1) {
      if (encodedBits < 10) {
        // Inline function 'korlibs.io.compression.util.HuffmanTree.left' call
        var tmp$ret$1 = $this.m5r_1[node];
        computeEncodedValues($this, tmp$ret$1, encoded, encodedBits + 1 | 0);
        // Inline function 'korlibs.io.compression.util.HuffmanTree.right' call
        var tmp$ret$2 = $this.n5r_1[node];
        computeEncodedValues($this, tmp$ret$2, encoded | 1 << encodedBits, encodedBits + 1 | 0);
      } else {
        writeVariants($this, encoded, encodedBits, node, -2);
      }
    } else {
      // Inline function 'korlibs.io.compression.util.HuffmanTree.value' call
      var tmp$ret$3 = $this.l5r_1[node];
      writeVariants($this, encoded, encodedBits, node, tmp$ret$3);
    }
  }
  function writeVariants($this, encoded, encodedBits, node, nvalue) {
    var encodedInfo = nvalue & 65535 | encodedBits << 16;
    var rangeCount = 1 << (10 - encodedBits | 0);
    var inductionVariable = 0;
    if (inductionVariable < rangeCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var i = encoded | n << encodedBits;
        $this.r5r_1[i] = encodedInfo;
        $this.s5r_1[i] = node;
      }
       while (inductionVariable < rangeCount);
  }
  function HuffmanTree() {
    this.l5r_1 = new Int32Array(1024);
    this.m5r_1 = new Int32Array(1024);
    this.n5r_1 = new Int32Array(1024);
    this.o5r_1 = 0;
    this.p5r_1 = 1023;
    this.q5r_1 = 0;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Int32Array(1024);
    while (tmp_0 < 1024) {
      tmp_1[tmp_0] = -1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.r5r_1 = tmp_1;
    var tmp_2 = this;
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(1024);
    while (tmp_3 < 1024) {
      tmp_4[tmp_3] = 0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_2.s5r_1 = tmp_4;
    this.t5r_1 = new Int32Array(17);
    this.u5r_1 = new Int32Array(17);
    this.v5r_1 = new Int32Array(17);
    this.w5r_1 = new Int32Array(288);
  }
  protoOf(HuffmanTree).b5u = function (reader) {
    reader.t5y(10);
    var node = this.p5r_1;
    if (reader.q5t_1 >= 10) {
      var bits = reader.u5y(10);
      var raw = this.r5r_1[bits];
      var value = toShort(raw);
      var len = raw >> 16;
      if (len > 0) {
        reader.v5y(len);
        if (value === -2) {
          node = this.s5r_1[bits];
        } else {
          return value;
        }
      }
    }
    $l$1: do {
      $l$0: do {
        var tmp;
        if (reader.y5t()) {
          // Inline function 'korlibs.io.compression.util.HuffmanTree.right' call
          var this_0 = node;
          tmp = this.n5r_1[this_0];
        } else {
          // Inline function 'korlibs.io.compression.util.HuffmanTree.left' call
          var this_1 = node;
          tmp = this.m5r_1[this_1];
        }
        node = tmp;
      }
       while (false);
      var tmp_0;
      if (!(node === 1023)) {
        // Inline function 'korlibs.io.compression.util.HuffmanTree.value' call
        var this_2 = node;
        tmp_0 = this.l5r_1[this_2] === -1;
      } else {
        tmp_0 = false;
      }
    }
     while (tmp_0);
    // Inline function 'korlibs.io.compression.util.HuffmanTree.value' call
    var this_3 = node;
    return this.l5r_1[this_3];
  };
  protoOf(HuffmanTree).h5z = function (codeLengths, start, end) {
    this.c5u(codeLengths, start, end);
    return this;
  };
  protoOf(HuffmanTree).x5r = function (codeLengths, start, end, $super) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? codeLengths.length : end;
    return $super === VOID ? this.h5z(codeLengths, start, end) : $super.h5z.call(this, codeLengths, start, end);
  };
  protoOf(HuffmanTree).c5u = function (codeLengths, start, end) {
    var oldOffset = 0;
    var oldCount = 0;
    var ncodes = end - start | 0;
    resetAlloc(this);
    fill(this.t5r_1, 0);
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var codeLen = codeLengths[n];
        if (!(0 <= codeLen ? codeLen <= 16 : false)) {
          // Inline function 'kotlin.error' call
          var message = 'Invalid HuffmanTree.codeLengths ' + codeLen;
          throw IllegalStateException_init_$Create$(toString(message));
        }
        var tmp1_array = this.t5r_1;
        tmp1_array[codeLen] = tmp1_array[codeLen] + 1 | 0;
      }
       while (inductionVariable < end);
    var currentOffset = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < 16)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var count = this.t5r_1[n_0];
        this.u5r_1[n_0] = currentOffset;
        this.v5r_1[n_0] = currentOffset;
        currentOffset = currentOffset + count | 0;
      }
       while (inductionVariable_0 < 16);
    var inductionVariable_1 = start;
    if (inductionVariable_1 < end)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var codeLen_0 = codeLengths[n_1];
        var tmp6_array = this.v5r_1;
        var tmp8 = tmp6_array[codeLen_0];
        tmp6_array[codeLen_0] = tmp8 + 1 | 0;
        this.w5r_1[tmp8] = n_1 - start | 0;
      }
       while (inductionVariable_1 < end);
    var inductionVariable_2 = 16;
    if (1 <= inductionVariable_2)
      do {
        var i = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + -1 | 0;
        var newOffset = this.o5r_1;
        var OFFSET = this.u5r_1[i];
        var SIZE = this.t5r_1[i];
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < SIZE)
          do {
            var j = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            allocLeaf(this, this.w5r_1[OFFSET + j | 0]);
          }
           while (inductionVariable_3 < SIZE);
        var progression = step(until(0, oldCount), 2);
        var inductionVariable_4 = progression.fb_1;
        var last = progression.gb_1;
        var step_0 = progression.hb_1;
        if ((step_0 > 0 ? inductionVariable_4 <= last : false) ? true : step_0 < 0 ? last <= inductionVariable_4 : false)
          do {
            var j_0 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + step_0 | 0;
            allocNode(this, oldOffset + j_0 | 0, (oldOffset + j_0 | 0) + 1 | 0);
          }
           while (!(j_0 === last));
        oldOffset = newOffset;
        oldCount = SIZE + (oldCount / 2 | 0) | 0;
        if (oldCount >= 2 ? !((oldCount % 2 | 0) === 0) : false) {
          // Inline function 'kotlin.error' call
          var message_0 = 'This canonical code does not represent a Huffman code tree: ' + oldCount;
          throw IllegalStateException_init_$Create$(toString(message_0));
        }
      }
       while (1 <= inductionVariable_2);
    if (!(oldCount === 2)) {
      // Inline function 'kotlin.error' call
      var message_1 = 'This canonical code does not represent a Huffman code tree';
      throw IllegalStateException_init_$Create$(toString(message_1));
    }
    this.p5r_1 = allocNode(this, this.o5r_1 - 2 | 0, this.o5r_1 - 1 | 0);
    this.q5r_1 = ncodes;
    computeFastLookup(this);
  };
  protoOf(HuffmanTree).a5u = function (codeLengths, start, end, $super) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? codeLengths.length : end;
    var tmp;
    if ($super === VOID) {
      this.c5u(codeLengths, start, end);
      tmp = Unit_instance;
    } else {
      tmp = $super.c5u.call(this, codeLengths, start, end);
    }
    return tmp;
  };
  function SlidingWindow(nbits) {
    this.u5q_1 = nbits;
    this.v5q_1 = new Int8Array(1 << this.u5q_1);
    this.w5q_1 = this.v5q_1.length - 1 | 0;
    this.x5q_1 = 0;
  }
  protoOf(SlidingWindow).f1 = function (offset) {
    return this.v5q_1[(this.x5q_1 - offset | 0) & this.w5q_1] & 255;
  };
  protoOf(SlidingWindow).y5q = function (offset) {
    return this.c5r(this.f1(offset));
  };
  protoOf(SlidingWindow).c5r = function (value) {
    this.v5q_1[this.x5q_1] = toByte(value);
    this.x5q_1 = (this.x5q_1 + 1 | 0) & this.w5q_1;
    return value;
  };
  protoOf(SlidingWindow).a5r = function (bytes, offset, len) {
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.unsigned' call
        var tmp$ret$0 = bytes[offset + n | 0] & 255;
        this.c5r(tmp$ret$0);
      }
       while (inductionVariable < len);
  };
  function KorAtomicRef(initial, dummy) {
    this.x52_1 = initial;
  }
  protoOf(KorAtomicRef).y52 = function (_set____db54di) {
    this.x52_1 = _set____db54di;
  };
  protoOf(KorAtomicRef).m2 = function () {
    return this.x52_1;
  };
  protoOf(KorAtomicRef).i5z = function (expect, update) {
    var tmp;
    if (equals(this.m2(), expect)) {
      this.y52(update);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(KorAtomicRef).toString = function () {
    return '' + this.m2();
  };
  function KorAtomicRef_0(initial) {
    return korAtomic_0(initial);
  }
  function KorAtomicLong(initial, dummy) {
    this.j5z_1 = initial;
  }
  protoOf(KorAtomicLong).k5z = function (_set____db54di) {
    this.j5z_1 = _set____db54di;
  };
  protoOf(KorAtomicLong).m2 = function () {
    return this.j5z_1;
  };
  protoOf(KorAtomicLong).l5z = function (expect, update) {
    var tmp;
    if (this.m2().equals(expect)) {
      this.k5z(update);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(KorAtomicLong).i5z = function (expect, update) {
    var tmp = expect instanceof Long ? expect : THROW_CCE();
    return this.l5z(tmp, update instanceof Long ? update : THROW_CCE());
  };
  protoOf(KorAtomicLong).m5z = function (delta) {
    this.k5z(this.m2().mc(delta));
    return this.m2();
  };
  protoOf(KorAtomicLong).toString = function () {
    return this.m2().toString();
  };
  function KorAtomicInt(initial, dummy) {
    this.n5z_1 = initial;
  }
  protoOf(KorAtomicInt).o5z = function (_set____db54di) {
    this.n5z_1 = _set____db54di;
  };
  protoOf(KorAtomicInt).m2 = function () {
    return this.n5z_1;
  };
  protoOf(KorAtomicInt).p5z = function (expect, update) {
    var tmp;
    if (this.m2() === expect) {
      this.o5z(update);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(KorAtomicInt).i5z = function (expect, update) {
    var tmp = (!(expect == null) ? typeof expect === 'number' : false) ? expect : THROW_CCE();
    return this.p5z(tmp, (!(update == null) ? typeof update === 'number' : false) ? update : THROW_CCE());
  };
  protoOf(KorAtomicInt).q5z = function (delta) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.concurrent.atomic.update' call
      while (true) {
        var value = this.m2();
        // Inline function 'korlibs.io.concurrent.atomic.KorAtomicInt.addAndGet.<anonymous>' call
        var next = value + delta | 0;
        if (this.i5z(value, next)) {
          tmp$ret$1 = next;
          break $l$block;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(KorAtomicInt).toString = function () {
    return '' + this.m2();
  };
  function incrementAndGet(_this__u8e3s4) {
    return _this__u8e3s4.q5z(1);
  }
  function _Dyn___init__impl__6cuxxc(value) {
    return value;
  }
  function _Dyn___get_value__impl__bemnlg($this) {
    return $this;
  }
  function _Dyn___get_isNotNull__impl__di7my3($this) {
    return !(_Dyn___get_value__impl__bemnlg($this) == null);
  }
  function Dyn__toComparable_impl_pfql3z($this) {
    var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
    var tmp;
    if (tmp0_subject == null) {
      tmp = isComparable(0) ? 0 : THROW_CCE();
    } else {
      if (!(tmp0_subject == null) ? isComparable(tmp0_subject) : false) {
        var tmp_0 = _Dyn___get_value__impl__bemnlg($this);
        tmp = (!(tmp_0 == null) ? isComparable(tmp_0) : false) ? tmp_0 : THROW_CCE();
      } else {
        var tmp_1 = toString(_Dyn___get_value__impl__bemnlg($this));
        tmp = isComparable(tmp_1) ? tmp_1 : THROW_CCE();
      }
    }
    return tmp;
  }
  function Dyn__compareTo_impl_7znl52($this, other) {
    var l = $this;
    var r = other;
    var tmp;
    var tmp_0 = _Dyn___get_value__impl__bemnlg(l);
    if (isNumber(tmp_0)) {
      var tmp_1 = _Dyn___get_value__impl__bemnlg(r);
      tmp = isNumber(tmp_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      return compareTo(numberToDouble(_Dyn___get_value__impl__bemnlg(l)), numberToDouble(_Dyn___get_value__impl__bemnlg(r)));
    }
    var lc = Dyn__toComparable_impl_pfql3z(l);
    var rc = Dyn__toComparable_impl_pfql3z(r);
    return getKClassFromExpression(lc).y6(rc) ? compareTo(lc, rc) : -1;
  }
  function Dyn__compareTo_impl_7znl52_0($this, other) {
    return Dyn__compareTo_impl_7znl52($this.t40_1, other instanceof Dyn ? other.t40_1 : THROW_CCE());
  }
  function Dyn__toString_impl_9l0v3s($this) {
    return toString_2($this, _Dyn___get_value__impl__bemnlg($this));
  }
  function Dyn__toStringOrNull_impl_7e6cgy($this) {
    var tmp;
    if (_Dyn___get_isNotNull__impl__di7my3($this)) {
      tmp = Dyn__toString_impl_9l0v3s($this);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function Companion_47() {
  }
  protoOf(Companion_47).r5z = function () {
    return get_dyn(get_dynApi().s5z());
  };
  var Companion_instance_55;
  function Companion_getInstance_62() {
    return Companion_instance_55;
  }
  function Dyn__toList_impl_pxssgr($this) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = Dyn__toListAny_impl_f7wxv7($this);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.io.dynamic.Dyn.toList.<anonymous>' call
      var tmp$ret$0 = get_dyn(item);
      destination.r(new Dyn(tmp$ret$0));
    }
    return destination;
  }
  function Dyn__toListAny_impl_f7wxv7($this) {
    return toList(Dyn__toIterableAny_impl_fib3cp($this));
  }
  function Dyn__toIterableAny_impl_fib3cp($this) {
    var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
    var tmp;
    if (tmp0_subject == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Iterable) : false) {
        tmp = _Dyn___get_value__impl__bemnlg($this);
      } else {
        if (!(tmp0_subject == null) ? isCharSequence(tmp0_subject) : false) {
          tmp = toList_3(_Dyn___get_value__impl__bemnlg($this));
        } else {
          if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Map) : false) {
            tmp = toList_2(_Dyn___get_value__impl__bemnlg($this));
          } else {
            // Inline function 'kotlin.collections.listOf' call
            tmp = emptyList();
          }
        }
      }
    }
    return tmp;
  }
  function Dyn__set_impl_2ozvx8($this, key, value) {
    var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, MutableMap) : false) {
      // Inline function 'kotlin.collections.set' call
      var tmp = _Dyn___get_value__impl__bemnlg($this);
      ((!(tmp == null) ? isInterface(tmp, MutableMap) : false) ? tmp : THROW_CCE()).i2(key, value);
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, MutableList) : false) {
        var tmp_0 = _Dyn___get_value__impl__bemnlg($this);
        ((!(tmp_0 == null) ? isInterface(tmp_0, MutableList) : false) ? tmp_0 : THROW_CCE()).o(Dyn__toInt_impl_nu3u6q(get_dyn(key)), value);
      } else {
        get_dynApi().t5z(_Dyn___get_value__impl__bemnlg($this), toString_1(key), value);
      }
    }
  }
  function Dyn__get_impl_6l2p80($this, key) {
    return Dyn__get_impl_6l2p80_0($this, _Dyn___get_value__impl__bemnlg(key));
  }
  function Dyn__get_impl_6l2p80_0($this, key) {
    return _getOrThrow($this, key, false);
  }
  function _getOrThrow($this, key, doThrow) {
    var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
    var tmp;
    if (tmp0_subject == null) {
      var tmp_0;
      if (doThrow) {
        throw NullPointerException_init_$Create$("Trying to access '" + toString_1(key) + "'");
      } else {
        tmp_0 = get_dyn(null);
      }
      tmp = tmp_0;
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Map) : false) {
        var tmp_1 = _Dyn___get_value__impl__bemnlg($this);
        tmp = get_dyn(((!(tmp_1 == null) ? isInterface(tmp_1, Map) : false) ? tmp_1 : THROW_CCE()).s2(key));
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, List) : false) {
          tmp = get_dyn(getOrNull_1(_Dyn___get_value__impl__bemnlg($this), Dyn__toInt_impl_nu3u6q(get_dyn(key))));
        } else {
          tmp = get_dyn(get_dynApi().u5z(_Dyn___get_value__impl__bemnlg($this), toString_1(key)));
        }
      }
    }
    return tmp;
  }
  function _Dyn___get_listAny__impl__vrilgp($this) {
    var tmp;
    if (_Dyn___get_value__impl__bemnlg($this) == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      var tmp_0 = _Dyn___get_value__impl__bemnlg($this);
      if (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) {
        tmp = _Dyn___get_value__impl__bemnlg($this);
      } else {
        var tmp_1 = _Dyn___get_value__impl__bemnlg($this);
        if (!(tmp_1 == null) ? isInterface(tmp_1, Iterable) : false) {
          tmp = toList(_Dyn___get_value__impl__bemnlg($this));
        } else {
          tmp = listOf_0(_Dyn___get_value__impl__bemnlg($this));
        }
      }
    }
    return tmp;
  }
  function _Dyn___get_keysAny__impl__whx5cj($this) {
    var tmp;
    var tmp_0 = _Dyn___get_value__impl__bemnlg($this);
    if (!(tmp_0 == null) ? isInterface(tmp_0, Map) : false) {
      tmp = toList(_Dyn___get_value__impl__bemnlg($this).g2());
    } else {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    }
    return tmp;
  }
  function _Dyn___get_list__impl__qpwjp($this) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = _Dyn___get_listAny__impl__vrilgp($this);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.io.dynamic.Dyn.<get-list>.<anonymous>' call
      var tmp$ret$0 = get_dyn(item);
      destination.r(new Dyn(tmp$ret$0));
    }
    return destination;
  }
  function _Dyn___get_keys__impl__o4xmor($this) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = _Dyn___get_keysAny__impl__whx5cj($this);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.io.dynamic.Dyn.<get-keys>.<anonymous>' call
      var tmp$ret$0 = get_dyn(item);
      destination.r(new Dyn(tmp$ret$0));
    }
    return destination;
  }
  function Dyn__toNumber_impl_rlhtn4($this, $receiver) {
    var tmp = toIntOrNull($receiver);
    var tmp0_elvis_lhs = (tmp == null ? true : isNumber(tmp)) ? tmp : null;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? toDoubleOrNull($receiver) : tmp0_elvis_lhs;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      tmp_0 = NaN;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  function Dyn__toNumber_impl_rlhtn4_0($this) {
    var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
    var tmp;
    if (tmp0_subject == null) {
      tmp = 0;
    } else {
      if (isNumber(tmp0_subject)) {
        tmp = _Dyn___get_value__impl__bemnlg($this);
      } else {
        if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
          tmp = _Dyn___get_value__impl__bemnlg($this) ? 1 : 0;
        } else {
          if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
            var tmp1_elvis_lhs = toIntSafe(_Dyn___get_value__impl__bemnlg($this));
            var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? toDoubleSafe(_Dyn___get_value__impl__bemnlg($this)) : tmp1_elvis_lhs;
            tmp = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
          } else {
            tmp = Dyn__toNumber_impl_rlhtn4($this, toString(_Dyn___get_value__impl__bemnlg($this)));
          }
        }
      }
    }
    return tmp;
  }
  function toString_2($this, value) {
    var tmp;
    if (value == null) {
      tmp = '';
    } else {
      if (!(value == null) ? typeof value === 'string' : false) {
        tmp = value;
      } else {
        if (!(value == null) ? typeof value === 'number' : false) {
          var tmp_0;
          if (value === numberToInt(value)) {
            tmp_0 = numberToInt(value).toString();
          } else {
            tmp_0 = toString(value);
          }
          tmp = tmp_0;
        } else {
          if (!(value == null) ? isInterface(value, Iterable) : false) {
            tmp = '[' + joinToString(value, ', ', VOID, VOID, VOID, VOID, Dyn$toString$lambda($this)) + ']';
          } else {
            if (!(value == null) ? isInterface(value, Map) : false) {
              // Inline function 'kotlin.collections.map' call
              // Inline function 'kotlin.collections.mapTo' call
              var destination = ArrayList_init_$Create$_0(value.n());
              // Inline function 'kotlin.collections.iterator' call
              var tmp0_iterator = value.k2().u();
              while (tmp0_iterator.v()) {
                var item = tmp0_iterator.x();
                // Inline function 'korlibs.io.dynamic.Dyn.toString.<anonymous>' call
                var tmp$ret$1 = quote(toString_2($this, item.l2())) + ': ' + toString_2($this, item.m2());
                destination.r(tmp$ret$1);
              }
              tmp = '{' + joinToString(destination, ', ') + '}';
            } else {
              tmp = toString(value);
            }
          }
        }
      }
    }
    return tmp;
  }
  function Dyn__toInt_impl_nu3u6q($this) {
    return numberToInt(Dyn__toNumber_impl_rlhtn4_0($this));
  }
  function Dyn__toLong_impl_mq8zcz($this) {
    return numberToLong(Dyn__toNumber_impl_rlhtn4_0($this));
  }
  function Dyn__toDouble_impl_bcyrzs($this) {
    return numberToDouble(Dyn__toNumber_impl_rlhtn4_0($this));
  }
  function Dyn__toBoolOrNull_impl_2dk92d($this) {
    var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
    var tmp;
    if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
      tmp = _Dyn___get_value__impl__bemnlg($this);
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
        tmp = (equals(_Dyn___get_value__impl__bemnlg($this), '1') ? true : equals(_Dyn___get_value__impl__bemnlg($this), 'true')) ? true : equals(_Dyn___get_value__impl__bemnlg($this), 'on');
      } else {
        if (isNumber(tmp0_subject)) {
          tmp = !(Dyn__toInt_impl_nu3u6q($this) === 0);
        } else {
          tmp = null;
        }
      }
    }
    return tmp;
  }
  function Dyn__toLongOrNull_impl_ws7y8j($this) {
    var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
    var tmp;
    if (isNumber(tmp0_subject)) {
      tmp = Dyn__toLong_impl_mq8zcz($this);
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
        tmp = toLongSafe(_Dyn___get_value__impl__bemnlg($this));
      } else {
        tmp = null;
      }
    }
    return tmp;
  }
  function Dyn__toIntDefault_impl_x52w9z($this, default_0) {
    var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
    var tmp;
    if (isNumber(tmp0_subject)) {
      tmp = Dyn__toInt_impl_nu3u6q($this);
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
        var tmp1_elvis_lhs = toIntSafe(_Dyn___get_value__impl__bemnlg($this), 10);
        tmp = tmp1_elvis_lhs == null ? default_0 : tmp1_elvis_lhs;
      } else {
        tmp = default_0;
      }
    }
    return tmp;
  }
  function Dyn__toIntDefault$default_impl_hr0tbe($this, default_0, $super) {
    default_0 = default_0 === VOID ? 0 : default_0;
    return $super === VOID ? Dyn__toIntDefault_impl_x52w9z($this, default_0) : $super.v5z.call(new Dyn($this), default_0);
  }
  function Dyn__toLongDefault_impl_auunl0($this, default_0) {
    var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
    var tmp;
    if (isNumber(tmp0_subject)) {
      tmp = Dyn__toLong_impl_mq8zcz($this);
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
        var tmp1_elvis_lhs = toLongSafe(_Dyn___get_value__impl__bemnlg($this), 10);
        tmp = tmp1_elvis_lhs == null ? default_0 : tmp1_elvis_lhs;
      } else {
        tmp = default_0;
      }
    }
    return tmp;
  }
  function Dyn__toLongDefault$default_impl_w5acm9($this, default_0, $super) {
    default_0 = default_0 === VOID ? new Long(0, 0) : default_0;
    return $super === VOID ? Dyn__toLongDefault_impl_auunl0($this, default_0) : $super.w5z.call(new Dyn($this), default_0);
  }
  function Dyn__toDoubleDefault_impl_fspogf($this, default_0) {
    var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
    var tmp;
    if (isNumber(tmp0_subject)) {
      tmp = Dyn__toDouble_impl_bcyrzs($this);
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
        tmp = Dyn__toDouble_impl_bcyrzs($this);
      } else {
        tmp = default_0;
      }
    }
    return tmp;
  }
  function _Dyn___get_str__impl__dup4cs($this) {
    return Dyn__toString_impl_9l0v3s($this);
  }
  function _Dyn___get_int__impl__sh8lhm($this) {
    return Dyn__toIntDefault$default_impl_hr0tbe($this);
  }
  function _Dyn___get_bool__impl__nv3iun($this) {
    var tmp0_elvis_lhs = Dyn__toBoolOrNull_impl_2dk92d($this);
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  function _Dyn___get_long__impl__wdxl7n($this) {
    return Dyn__toLongDefault$default_impl_w5acm9($this);
  }
  function Dyn__hashCode_impl_vc6rwn($this) {
    return $this == null ? 0 : hashCode($this);
  }
  function Dyn__equals_impl_sp125n($this, other) {
    if (!(other instanceof Dyn))
      return false;
    var tmp0_other_with_cast = other instanceof Dyn ? other.t40_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function Dyn$toString$lambda(this$0) {
    return function (it) {
      return toString_2(this$0, it);
    };
  }
  function Dyn(value) {
    this.t40_1 = value;
  }
  protoOf(Dyn).x5z = function (other) {
    return Dyn__compareTo_impl_7znl52(this.t40_1, other);
  };
  protoOf(Dyn).d = function (other) {
    return Dyn__compareTo_impl_7znl52_0(this, other);
  };
  protoOf(Dyn).toString = function () {
    return Dyn__toString_impl_9l0v3s(this.t40_1);
  };
  protoOf(Dyn).hashCode = function () {
    return Dyn__hashCode_impl_vc6rwn(this.t40_1);
  };
  protoOf(Dyn).equals = function (other) {
    return Dyn__equals_impl_sp125n(this.t40_1, other);
  };
  function get_dyn(_this__u8e3s4) {
    return _Dyn___init__impl__6cuxxc(_this__u8e3s4);
  }
  function toIntSafe(_this__u8e3s4, radix) {
    radix = radix === VOID ? 10 : radix;
    return toIntOrNull_0(_this__u8e3s4, radix);
  }
  function toDoubleSafe(_this__u8e3s4) {
    return toDoubleOrNull(_this__u8e3s4);
  }
  function toLongSafe(_this__u8e3s4, radix) {
    radix = radix === VOID ? 10 : radix;
    return toLongOrNull(_this__u8e3s4, radix);
  }
  function get_dynApi() {
    _init_properties_DynApi_kt__g2fyyp();
    return dynApi;
  }
  var dynApi;
  function DynApi() {
  }
  var properties_initialized_DynApi_kt_kcoydf;
  function _init_properties_DynApi_kt__g2fyyp() {
    if (!properties_initialized_DynApi_kt_kcoydf) {
      properties_initialized_DynApi_kt_kcoydf = true;
      dynApi = DynamicInternal_instance;
    }
  }
  function get_extensionLC(_this__u8e3s4) {
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    return get_extension(_this__u8e3s4).toLowerCase();
  }
  function _PathInfo___init__impl__vpw96a(fullPath) {
    return fullPath;
  }
  function _PathInfo___get_fullPath__impl__21fx6x($this) {
    return $this;
  }
  function get_baseName(_this__u8e3s4) {
    return get_baseName_0(_this__u8e3s4.y5z());
  }
  function get_extension(_this__u8e3s4) {
    return substringAfterLast(get_baseName_0(_this__u8e3s4), _Char___init__impl__6a9atx(46), '');
  }
  function get_baseName_0(_this__u8e3s4) {
    return substringAfterLast(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
  }
  function get_fullPathNormalized(_this__u8e3s4) {
    return replace(_PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4), _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
  }
  function VfsNamed(pathInfo) {
    this.z5z_1 = pathInfo;
  }
  protoOf(VfsNamed).y5z = function () {
    return this.z5z_1;
  };
  function get_pathInfo(_this__u8e3s4) {
    return _PathInfo___init__impl__vpw96a(_this__u8e3s4);
  }
  function get_folder(_this__u8e3s4) {
    return get_folder_0(_this__u8e3s4.y5z());
  }
  function combine(_this__u8e3s4, access) {
    var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
    var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
    return get_pathInfo(isAbsolute(get_pathInfo(access_0)) ? normalize(get_pathInfo(access_0)) : normalize(get_pathInfo(base + '/' + access_0)));
  }
  function normalize(_this__u8e3s4, removeEndSlash) {
    removeEndSlash = removeEndSlash === VOID ? true : removeEndSlash;
    var path = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
    var schemeIndex = indexOf(path, ':');
    var tmp;
    if (schemeIndex >= 0) {
      var tmp_0;
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = path.substring(schemeIndex);
      if (startsWith(tmp$ret$1, '://')) {
        tmp_0 = 3;
      } else {
        tmp_0 = 1;
      }
      var take = tmp_0;
      // Inline function 'kotlin.text.substring' call
      var endIndex = schemeIndex + take | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_1 = path.substring(0, endIndex);
      // Inline function 'kotlin.text.substring' call
      var startIndex = schemeIndex + take | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$5 = path.substring(startIndex);
      tmp = tmp_1 + normalize(get_pathInfo(tmp$ret$5), removeEndSlash);
    } else {
      var path2 = replace(path, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
      var out = ArrayList_init_$Create$();
      var path2PathLength;
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
      // Inline function 'kotlin.also' call
      var this_0 = split(path2, ['/']);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.file.normalize.<anonymous>' call
      path2PathLength = this_0.n();
      var n = 0;
      while (n < this_0.n()) {
        // Inline function 'korlibs.io.file.normalize.<anonymous>' call
        var index = n;
        var part = this_0.f1(n);
        switch (part) {
          case '':
            if (out.b1() ? true : !removeEndSlash) {
              // Inline function 'kotlin.collections.plusAssign' call
              out.r('');
            }

            break;
          case '.':
            if (index === (path2PathLength - 1 | 0) ? !removeEndSlash : false) {
              // Inline function 'kotlin.collections.plusAssign' call
              out.r('');
            }

            break;
          case '..':
            var tmp_2;
            // Inline function 'kotlin.collections.isNotEmpty' call

            if (!out.b1()) {
              tmp_2 = !(index === 1);
            } else {
              tmp_2 = false;
            }

            if (tmp_2) {
              out.h1(out.n() - 1 | 0);
            }

            break;
          default:
            // Inline function 'kotlin.collections.plusAssign' call

            out.r(part);
            break;
        }
        n = n + 1 | 0;
      }
      tmp = joinToString(out, '/');
    }
    return tmp;
  }
  function get_parent(_this__u8e3s4) {
    return _PathInfo___init__impl__vpw96a(get_folder_0(_this__u8e3s4));
  }
  function get_extensionLC_0(_this__u8e3s4) {
    return get_extensionLC(_this__u8e3s4.y5z());
  }
  function get_folder_0(_this__u8e3s4) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
    var tmp0_elvis_lhs = lastIndexOfOrNull(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
    var endIndex = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    // Inline function 'kotlin.js.asDynamic' call
    return this_0.substring(0, endIndex);
  }
  function isAbsolute(_this__u8e3s4) {
    var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(base) === 0)
      return false;
    var b = substringBefore(replace(base, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(47));
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(b) === 0)
      return true;
    if (contains_1(b, _Char___init__impl__6a9atx(58)))
      return true;
    return false;
  }
  function lightCombine(_this__u8e3s4, access) {
    var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
    var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(base) > 0) {
      tmp = trimEnd(base, charArrayOf([_Char___init__impl__6a9atx(47)])) + '/' + trim_0(access_0, charArrayOf([_Char___init__impl__6a9atx(47)]));
    } else {
      tmp = access_0;
    }
    var res = tmp;
    return get_pathInfo(res);
  }
  function Vfs$Proxy$initOnce$slambda(this$0, resultContinuation) {
    this.i60_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Vfs$Proxy$initOnce$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Vfs$Proxy$initOnce$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(Vfs$Proxy$initOnce$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.i60_1.l60(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.gd_1 = 3;
            this.fd_1 = 4;
            continue $sm;
          case 2:
            this.gd_1 = 3;
            var tmp_0 = this.id_1;
            if (tmp_0 instanceof Error) {
              var e = this.id_1;
              var this_0 = this.i60_1.j60_1;
              var level = Level_ERROR_getInstance();
              if (this_0.f25(level)) {
                this_0.g25(level, 'Error initializing ' + this.i60_1);
              }
              printStackTrace(e);
              this.fd_1 = 4;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 3:
            throw this.id_1;
          case 4:
            this.gd_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 3) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(Vfs$Proxy$initOnce$slambda).g5a = function (completion) {
    return new Vfs$Proxy$initOnce$slambda(this.i60_1, completion);
  };
  function Vfs$Proxy$initOnce$slambda_0(this$0, resultContinuation) {
    var i = new Vfs$Proxy$initOnce$slambda(this$0, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $getUnderlyingUnscapedFileCOROUTINE$124(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u60_1 = _this__u8e3s4;
    this.v60_1 = path;
  }
  protoOf($getUnderlyingUnscapedFileCOROUTINE$124).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.fd_1 = 1;
            suspendResult = this.u60_1.y60(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.w60_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = this.w60_1.z60(this.v60_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.x60_1 = suspendResult;
            this.fd_1 = 3;
            suspendResult = this.x60_1.l58(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $initOnceCOROUTINE$125(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i61_1 = _this__u8e3s4;
  }
  protoOf($initOnceCOROUTINE$125).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            if (this.i61_1.k60_1 == null) {
              var tmp_0 = this.i61_1;
              var tmp_1 = this.q6();
              tmp_0.k60_1 = async_0(tmp_1, Vfs$Proxy$initOnce$slambda_0(this.i61_1, null));
            }

            this.fd_1 = 1;
            suspendResult = ensureNotNull(this.i61_1.k60_1).q1d(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.i61_1;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $openCOROUTINE$127(_this__u8e3s4, path, mode, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r61_1 = _this__u8e3s4;
    this.s61_1 = path;
    this.t61_1 = mode;
  }
  protoOf($openCOROUTINE$127).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.fd_1 = 1;
            suspendResult = this.r61_1.y60(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u61_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = this.u61_1.z60(this.s61_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.v61_1 = suspendResult;
            this.fd_1 = 3;
            suspendResult = this.v61_1.w61(this.t61_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readRangeCOROUTINE$128(_this__u8e3s4, path, range, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f62_1 = _this__u8e3s4;
    this.g62_1 = path;
    this.h62_1 = range;
  }
  protoOf($readRangeCOROUTINE$128).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.fd_1 = 1;
            suspendResult = this.f62_1.y60(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.i62_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = this.i62_1.z60(this.g62_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.j62_1 = suspendResult;
            this.fd_1 = 3;
            suspendResult = this.j62_1.k62(this.h62_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $statCOROUTINE$131(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t62_1 = _this__u8e3s4;
    this.u62_1 = path;
  }
  protoOf($statCOROUTINE$131).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.fd_1 = 1;
            suspendResult = this.t62_1.y60(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.v62_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = this.v62_1.z60(this.u62_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.w62_1 = suspendResult;
            this.fd_1 = 3;
            suspendResult = this.w62_1.x62(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            return ARGUMENT.o63(this.t62_1.z56(this.u62_1));
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function unsupported($this) {
    unsupported_0('unsupported for ' + getKClassFromExpression($this) + ' : ' + $this);
  }
  function Proxy() {
    Vfs.call(this);
    this.j60_1 = Companion_getInstance_6().r24('Vfs.Proxy');
    this.k60_1 = null;
  }
  protoOf(Proxy).p63 = function (path, $completion) {
    var tmp = new $getUnderlyingUnscapedFileCOROUTINE$124(this, path, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Proxy).l60 = function ($completion) {
    return Unit_instance;
  };
  protoOf(Proxy).y60 = function ($completion) {
    var tmp = new $initOnceCOROUTINE$125(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Proxy).q63 = function (path, mode, $completion) {
    var tmp = new $openCOROUTINE$127(this, path, mode, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Proxy).r63 = function (path, range, $completion) {
    var tmp = new $readRangeCOROUTINE$128(this, path, range, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Proxy).s63 = function (path, $completion) {
    var tmp = new $statCOROUTINE$131(this, path, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function $readRangeCOROUTINE$115(_this__u8e3s4, path, range, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i64_1 = _this__u8e3s4;
    this.j64_1 = path;
    this.k64_1 = range;
  }
  protoOf($readRangeCOROUTINE$115).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            this.fd_1 = 1;
            suspendResult = this.i64_1.q63(this.j64_1, VfsOpenMode_READ_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.l64_1 = suspendResult;
            this.m64_1 = null;
            this.gd_1 = 3;
            var tmp_0 = this;
            tmp_0.o64_1 = this.l64_1;
            this.o64_1.r4z_1 = this.k64_1.h9();
            this.fd_1 = 2;
            var a = toLong(IntCompanionObject_instance.MAX_VALUE).cb(toLong(1));
            var b = this.k64_1.i9().cb(this.k64_1.h9());
            suspendResult = readBytesUpTo(this.o64_1, (a.t6(b) <= 0 ? a : b).kb() + 1 | 0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n64_1 = suspendResult;
            this.gd_1 = 6;
            this.fd_1 = 4;
            continue $sm;
          case 3:
            this.gd_1 = 6;
            var tmp_1 = this.id_1;
            if (tmp_1 instanceof Error) {
              this.p64_1 = this.id_1;
              var tmp_2 = this;
              this.m64_1 = this.p64_1;
              tmp_2.n64_1 = null;
              this.fd_1 = 4;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 4:
            this.gd_1 = 6;
            this.q64_1 = this.n64_1;
            this.fd_1 = 5;
            suspendResult = this.l64_1.x5u(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!(this.m64_1 == null))
              throw this.m64_1;
            var tmp_3 = this.q64_1;
            return (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
          case 6:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 6) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function Vfs() {
  }
  protoOf(Vfs).t63 = function () {
    return '';
  };
  protoOf(Vfs).u63 = function (path) {
    return _PathInfo___get_fullPath__impl__21fx6x(lightCombine(get_pathInfo(this.t63()), get_pathInfo(path)));
  };
  protoOf(Vfs).v63 = function () {
    return new VfsFile(this, '');
  };
  protoOf(Vfs).s13 = function (path) {
    return this.v63().s13(path);
  };
  protoOf(Vfs).z56 = function (path) {
    return this.v63().s13(path);
  };
  protoOf(Vfs).x5u = function ($completion) {
    return Unit_instance;
  };
  protoOf(Vfs).w63 = function (path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) {
    // Inline function 'kotlin.also' call
    var this_0 = new VfsStat(this.z56(path), true, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, VOID, id);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.Vfs.createExistsStat.<anonymous>' call
    if (cache)
      this_0.y62_1.e40_1 = this_0;
    return this_0;
  };
  protoOf(Vfs).x63 = function (path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache, $super) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance_12().a1q_1 : createTime;
    modifiedTime = modifiedTime === VOID ? Companion_getInstance_12().a1q_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    id = id === VOID ? null : id;
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.w63(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) : $super.w63.call(this, path, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, id, cache);
  };
  protoOf(Vfs).y63 = function (path, extraInfo, cache, exception) {
    return new VfsStat(this.z56(path), false, false, new Long(0, 0), new Long(-1, -1), new Long(-1, -1), 511, 'nobody', 'nobody', Companion_getInstance_12().a1q_1, Companion_getInstance_12().a1q_1, Companion_getInstance_12().a1q_1, extraInfo, VOID, VOID, exception);
  };
  protoOf(Vfs).z63 = function (path, extraInfo, cache, exception, $super) {
    extraInfo = extraInfo === VOID ? null : extraInfo;
    cache = cache === VOID ? false : cache;
    exception = exception === VOID ? null : exception;
    return $super === VOID ? this.y63(path, extraInfo, cache, exception) : $super.y63.call(this, path, extraInfo, cache, exception);
  };
  protoOf(Vfs).q63 = function (path, mode, $completion) {
    unsupported(this);
  };
  protoOf(Vfs).r63 = function (path, range, $completion) {
    var tmp = new $readRangeCOROUTINE$115(this, path, range, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Vfs).s63 = function (path, $completion) {
    return this.z63(path);
  };
  protoOf(Vfs).p63 = function (path, $completion) {
    return FinalVfsFile_init_$Create$(this, path);
  };
  protoOf(Vfs).toString = function () {
    return get_portableSimpleName(getKClassFromExpression(this));
  };
  function VfsStat(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance_12().a1q_1 : createTime;
    modifiedTime = modifiedTime === VOID ? createTime : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    kind = kind === VOID ? null : kind;
    id = id === VOID ? null : id;
    exception = exception === VOID ? null : exception;
    this.y62_1 = file;
    this.z62_1 = exists;
    this.a63_1 = isDirectory;
    this.b63_1 = size;
    this.c63_1 = device;
    this.d63_1 = inode;
    this.e63_1 = mode;
    this.f63_1 = owner;
    this.g63_1 = group;
    this.h63_1 = createTime;
    this.i63_1 = modifiedTime;
    this.j63_1 = lastAccessTime;
    this.k63_1 = extraInfo;
    this.l63_1 = kind;
    this.m63_1 = id;
    this.n63_1 = exception;
  }
  protoOf(VfsStat).y5z = function () {
    return this.y62_1.y5z();
  };
  protoOf(VfsStat).r64 = function (showFile) {
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList_init_$Create$_0(16);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.VfsStat.toString.<anonymous>' call
    if (showFile) {
      this_0.r('file=' + this.y62_1);
    } else {
      this_0.r('file=' + this.y62_1.t63());
    }
    this_0.r('exists=' + this.z62_1);
    this_0.r('isDirectory=' + this.a63_1);
    this_0.r('size=' + this.b63_1.toString());
    this_0.r('device=' + this.c63_1.toString());
    this_0.r('inode=' + this.d63_1.toString());
    this_0.r('mode=' + this.e63_1);
    this_0.r('owner=' + this.f63_1);
    this_0.r('group=' + this.g63_1);
    this_0.r('createTime=' + new DateTime(this.h63_1));
    this_0.r('modifiedTime=' + new DateTime(this.i63_1));
    this_0.r('lastAccessTime=' + new DateTime(this.j63_1));
    this_0.r('extraInfo=' + toString_1(this.k63_1));
    if (!(this.l63_1 == null)) {
      this_0.r('kind=' + this.l63_1);
    }
    this_0.r('id=' + this.m63_1);
    return 'VfsStat(' + joinToString(this_0, ', ') + ')';
  };
  protoOf(VfsStat).toString = function () {
    return this.r64(true);
  };
  protoOf(VfsStat).s64 = function (file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    return new VfsStat(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception);
  };
  protoOf(VfsStat).o63 = function (file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception, $super) {
    file = file === VOID ? this.y62_1 : file;
    exists = exists === VOID ? this.z62_1 : exists;
    isDirectory = isDirectory === VOID ? this.a63_1 : isDirectory;
    size = size === VOID ? this.b63_1 : size;
    device = device === VOID ? this.c63_1 : device;
    inode = inode === VOID ? this.d63_1 : inode;
    mode = mode === VOID ? this.e63_1 : mode;
    owner = owner === VOID ? this.f63_1 : owner;
    group = group === VOID ? this.g63_1 : group;
    createTime = createTime === VOID ? this.h63_1 : createTime;
    modifiedTime = modifiedTime === VOID ? this.i63_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? this.j63_1 : lastAccessTime;
    extraInfo = extraInfo === VOID ? this.k63_1 : extraInfo;
    kind = kind === VOID ? this.l63_1 : kind;
    id = id === VOID ? this.m63_1 : id;
    exception = exception === VOID ? this.n63_1 : exception;
    return $super === VOID ? this.s64(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) : $super.s64.call(this, file, exists, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, kind, id, exception);
  };
  protoOf(VfsStat).hashCode = function () {
    var result = this.y62_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.z62_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a63_1) | 0;
    result = imul(result, 31) + this.b63_1.hashCode() | 0;
    result = imul(result, 31) + this.c63_1.hashCode() | 0;
    result = imul(result, 31) + this.d63_1.hashCode() | 0;
    result = imul(result, 31) + this.e63_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.f63_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g63_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.h63_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.i63_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.j63_1) | 0;
    result = imul(result, 31) + (this.k63_1 == null ? 0 : hashCode(this.k63_1)) | 0;
    result = imul(result, 31) + (this.l63_1 == null ? 0 : hashCode(this.l63_1)) | 0;
    result = imul(result, 31) + (this.m63_1 == null ? 0 : getStringHashCode(this.m63_1)) | 0;
    result = imul(result, 31) + (this.n63_1 == null ? 0 : hashCode(this.n63_1)) | 0;
    return result;
  };
  protoOf(VfsStat).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsStat))
      return false;
    var tmp0_other_with_cast = other instanceof VfsStat ? other : THROW_CCE();
    if (!this.y62_1.equals(tmp0_other_with_cast.y62_1))
      return false;
    if (!(this.z62_1 === tmp0_other_with_cast.z62_1))
      return false;
    if (!(this.a63_1 === tmp0_other_with_cast.a63_1))
      return false;
    if (!this.b63_1.equals(tmp0_other_with_cast.b63_1))
      return false;
    if (!this.c63_1.equals(tmp0_other_with_cast.c63_1))
      return false;
    if (!this.d63_1.equals(tmp0_other_with_cast.d63_1))
      return false;
    if (!(this.e63_1 === tmp0_other_with_cast.e63_1))
      return false;
    if (!(this.f63_1 === tmp0_other_with_cast.f63_1))
      return false;
    if (!(this.g63_1 === tmp0_other_with_cast.g63_1))
      return false;
    if (!equals(this.h63_1, tmp0_other_with_cast.h63_1))
      return false;
    if (!equals(this.i63_1, tmp0_other_with_cast.i63_1))
      return false;
    if (!equals(this.j63_1, tmp0_other_with_cast.j63_1))
      return false;
    if (!equals(this.k63_1, tmp0_other_with_cast.k63_1))
      return false;
    if (!equals(this.l63_1, tmp0_other_with_cast.l63_1))
      return false;
    if (!(this.m63_1 == tmp0_other_with_cast.m63_1))
      return false;
    if (!equals(this.n63_1, tmp0_other_with_cast.n63_1))
      return false;
    return true;
  };
  var VfsOpenMode_READ_instance;
  var VfsOpenMode_WRITE_instance;
  var VfsOpenMode_APPEND_instance;
  var VfsOpenMode_CREATE_OR_TRUNCATE_instance;
  var VfsOpenMode_CREATE_instance;
  var VfsOpenMode_CREATE_NEW_instance;
  var VfsOpenMode_entriesInitialized;
  function VfsOpenMode_initEntries() {
    if (VfsOpenMode_entriesInitialized)
      return Unit_instance;
    VfsOpenMode_entriesInitialized = true;
    VfsOpenMode_READ_instance = new VfsOpenMode('READ', 0, 'rb', false);
    VfsOpenMode_WRITE_instance = new VfsOpenMode('WRITE', 1, 'r+b', true, true);
    VfsOpenMode_APPEND_instance = new VfsOpenMode('APPEND', 2, 'a+b', true, true, VOID, VOID, true);
    VfsOpenMode_CREATE_OR_TRUNCATE_instance = new VfsOpenMode('CREATE_OR_TRUNCATE', 3, 'w+b', true, true, true);
    VfsOpenMode_CREATE_instance = new VfsOpenMode('CREATE', 4, 'w+b', true, true);
    VfsOpenMode_CREATE_NEW_instance = new VfsOpenMode('CREATE_NEW', 5, 'w+b', true);
  }
  function VfsOpenMode(name, ordinal, cmode, write, createIfNotExists, truncate, read, append, createNew) {
    createIfNotExists = createIfNotExists === VOID ? false : createIfNotExists;
    truncate = truncate === VOID ? false : truncate;
    read = read === VOID ? true : read;
    append = append === VOID ? false : append;
    createNew = createNew === VOID ? false : createNew;
    Enum.call(this, name, ordinal);
    this.v64_1 = cmode;
    this.w64_1 = write;
    this.x64_1 = createIfNotExists;
    this.y64_1 = truncate;
    this.z64_1 = read;
    this.a65_1 = append;
    this.b65_1 = createNew;
  }
  function Companion_48() {
  }
  var Companion_instance_56;
  function Companion_getInstance_63() {
    return Companion_instance_56;
  }
  function VfsCachedStatContext(stat) {
    this.c65_1 = stat;
  }
  protoOf(VfsCachedStatContext).l2 = function () {
    return Companion_instance_56;
  };
  function VfsOpenMode_READ_getInstance() {
    VfsOpenMode_initEntries();
    return VfsOpenMode_READ_instance;
  }
  function $readStringCOROUTINE$147(_this__u8e3s4, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l65_1 = _this__u8e3s4;
    this.m65_1 = charset;
  }
  protoOf($readStringCOROUTINE$147).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.l65_1.n65(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return toString_3(ARGUMENT, this.m65_1);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readAsSyncStreamCOROUTINE$149(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w65_1 = _this__u8e3s4;
  }
  protoOf($readAsSyncStreamCOROUTINE$149).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.w65_1.n65(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return openSync(ARGUMENT);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $statCOROUTINE$150(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f66_1 = _this__u8e3s4;
  }
  protoOf($statCOROUTINE$150).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.g66_1 = this.f66_1.e40_1;
            if (this.g66_1 == null) {
              this.fd_1 = 1;
              suspendResult = this.f66_1.b40_1.s63(this.f66_1.c40_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.h66_1 = this.g66_1;
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            this.h66_1 = suspendResult;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            return this.h66_1;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function VfsFile(vfs, path) {
    VfsNamed.call(this, get_pathInfo(path));
    this.b40_1 = vfs;
    this.c40_1 = path;
    this.d40_1 = new Mixin();
    this.e40_1 = null;
  }
  protoOf(VfsFile).h23 = function (_set____db54di) {
    this.d40_1.h23(_set____db54di);
  };
  protoOf(VfsFile).i23 = function () {
    return this.d40_1.i23();
  };
  protoOf(VfsFile).r40 = function () {
    return new VfsFile(this.b40_1, get_folder(this));
  };
  protoOf(VfsFile).v63 = function () {
    return this.b40_1.v63();
  };
  protoOf(VfsFile).t63 = function () {
    return this.b40_1.u63(this.c40_1);
  };
  protoOf(VfsFile).s13 = function (path) {
    return new VfsFile(this.b40_1, _PathInfo___get_fullPath__impl__21fx6x(combine(get_pathInfo(this.c40_1), get_pathInfo(path))));
  };
  protoOf(VfsFile).w61 = function (mode, $completion) {
    return this.b40_1.q63(this.c40_1, mode, $completion);
  };
  protoOf(VfsFile).k62 = function (range, $completion) {
    return this.b40_1.r63(this.c40_1, range, $completion);
  };
  protoOf(VfsFile).o47 = function (range, $completion) {
    return this.b40_1.r63(this.c40_1, toLongRange(range), $completion);
  };
  protoOf(VfsFile).d4s = function ($completion) {
    return this.b40_1.r63(this.c40_1, get_LONG_ZERO_TO_MAX_RANGE(), $completion);
  };
  protoOf(VfsFile).n65 = function ($completion) {
    return this.d4s($completion);
  };
  protoOf(VfsFile).a57 = function ($completion) {
    return this.d4s($completion);
  };
  protoOf(VfsFile).i66 = function (charset, $completion) {
    var tmp = new $readStringCOROUTINE$147(this, charset, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(VfsFile).f40 = function (charset, $completion, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.i66(charset, $completion) : $super.i66.call(this, charset, $completion);
  };
  protoOf(VfsFile).x51 = function ($completion) {
    var tmp = new $readAsSyncStreamCOROUTINE$149(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(VfsFile).x62 = function ($completion) {
    var tmp = new $statCOROUTINE$150(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(VfsFile).j66 = function () {
    return Companion_instance_57.k66(this);
  };
  protoOf(VfsFile).l58 = function ($completion) {
    return this.b40_1.p63(this.c40_1, $completion);
  };
  protoOf(VfsFile).toString = function () {
    return '' + this.b40_1 + '[' + this.c40_1 + ']';
  };
  protoOf(VfsFile).hashCode = function () {
    var result = hashCode(this.b40_1);
    result = imul(result, 31) + getStringHashCode(this.c40_1) | 0;
    return result;
  };
  protoOf(VfsFile).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof VfsFile ? other : THROW_CCE();
    if (!equals(this.b40_1, tmp0_other_with_cast.b40_1))
      return false;
    if (!(this.c40_1 === tmp0_other_with_cast.c40_1))
      return false;
    return true;
  };
  function FinalVfsFile_init_$Init$(vfs, path, $this) {
    FinalVfsFile.call($this, vfs.s13(path));
    return $this;
  }
  function FinalVfsFile_init_$Create$(vfs, path) {
    return FinalVfsFile_init_$Init$(vfs, path, objectCreate(protoOf(FinalVfsFile)));
  }
  function FinalVfsFile(file) {
    this.x57_1 = file;
  }
  protoOf(FinalVfsFile).y57 = function () {
    return this.x57_1.b40_1;
  };
  protoOf(FinalVfsFile).f4o = function () {
    return this.x57_1.c40_1;
  };
  protoOf(FinalVfsFile).toString = function () {
    return 'FinalVfsFile(file=' + this.x57_1 + ')';
  };
  protoOf(FinalVfsFile).hashCode = function () {
    return this.x57_1.hashCode();
  };
  protoOf(FinalVfsFile).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FinalVfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof FinalVfsFile ? other : THROW_CCE();
    if (!this.x57_1.equals(tmp0_other_with_cast.x57_1))
      return false;
    return true;
  };
  function withCatalogJail(_this__u8e3s4) {
    return (new CatalogVfs(_this__u8e3s4.j66())).v63();
  }
  function $getLengthCOROUTINE$170(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t66_1 = _this__u8e3s4;
  }
  protoOf($getLengthCOROUTINE$170).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            var tmp0_safe_receiver = this.t66_1.w66_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z62_1) === true) {
              this.u66_1 = this.t66_1.w66_1.b63_1;
              this.fd_1 = 2;
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = this.t66_1.v66_1.m5w(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.u66_1 = suspendResult;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            return this.u66_1;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function CatalogVfs$open$slambda(this$0, $path, $mode, resultContinuation) {
    this.f67_1 = this$0;
    this.g67_1 = $path;
    this.h67_1 = $mode;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CatalogVfs$open$slambda).j67 = function ($this$withContext, $completion) {
    var tmp = this.t5l($this$withContext, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(CatalogVfs$open$slambda).ne = function (p1, $completion) {
    return this.j67((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CatalogVfs$open$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = protoOf(Proxy).q63.call(this.f67_1, this.g67_1, this.h67_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.q4z_1;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(CatalogVfs$open$slambda).t5l = function ($this$withContext, completion) {
    var i = new CatalogVfs$open$slambda(this.f67_1, this.g67_1, this.h67_1, completion);
    i.i67_1 = $this$withContext;
    return i;
  };
  function CatalogVfs$open$slambda_0(this$0, $path, $mode, resultContinuation) {
    var i = new CatalogVfs$open$slambda(this$0, $path, $mode, resultContinuation);
    var l = function ($this$withContext, $completion) {
      return i.j67($this$withContext, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CatalogVfs$open$2($base, $fstat) {
    this.v66_1 = $base;
    this.w66_1 = $fstat;
    AsyncStreamBase.call(this);
  }
  protoOf(CatalogVfs$open$2).k67 = function (position, buffer, offset, len, $completion) {
    return this.v66_1.k67(position, buffer, offset, len, $completion);
  };
  protoOf(CatalogVfs$open$2).l67 = function (position, buffer, offset, len, $completion) {
    return this.v66_1.l67(position, buffer, offset, len, $completion);
  };
  protoOf(CatalogVfs$open$2).m5w = function ($completion) {
    var tmp = new $getLengthCOROUTINE$170(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(CatalogVfs$open$2).x5u = function ($completion) {
    return this.v66_1.x5u($completion);
  };
  function $openCOROUTINE$163(_this__u8e3s4, path, mode, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u67_1 = _this__u8e3s4;
    this.v67_1 = path;
    this.w67_1 = mode;
  }
  protoOf($openCOROUTINE$163).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = this.u67_1.e68(this.v67_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x67_1 = suspendResult;
            this.fd_1 = 2;
            var tmp_0 = new VfsCachedStatContext(this.x67_1);
            suspendResult = withContext(tmp_0, CatalogVfs$open$slambda_0(this.u67_1, this.v67_1, this.w67_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var base = suspendResult;
            return buffered(toAsyncStream(new CatalogVfs$open$2(base, this.x67_1)));
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $statCOROUTINE$164(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n68_1 = _this__u8e3s4;
    this.o68_1 = path;
  }
  protoOf($statCOROUTINE$164).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.n68_1.e68(this.o68_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            return tmp0_elvis_lhs == null ? this.n68_1.z63(normalize(_PathInfo___init__impl__vpw96a(this.o68_1)), VOID, true) : tmp0_elvis_lhs;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $statOrNullCOROUTINE$165(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x68_1 = _this__u8e3s4;
    this.y68_1 = path;
  }
  protoOf($statOrNullCOROUTINE$165).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 5;
            this.z68_1 = normalize(_PathInfo___init__impl__vpw96a(this.y68_1));
            if (this.z68_1 === '/' ? true : this.z68_1 === '') {
              return this.x68_1.x63('/', true, new Long(0, 0), VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
            }

            this.a69_1 = get_baseName_0(_PathInfo___init__impl__vpw96a(this.z68_1));
            this.fd_1 = 1;
            suspendResult = this.x68_1.h69(_PathInfo___get_fullPath__impl__21fx6x(get_parent(_PathInfo___init__impl__vpw96a(this.z68_1))), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.b69_1 = suspendResult;
            if (this.b69_1 == null) {
              var tmp_0 = this;
              tmp_0.d69_1 = this.x68_1.c68_1;
              var tmp_1 = this;
              tmp_1.e69_1 = this.y68_1;
              this.f69_1 = this.d69_1.s2(this.e69_1);
              if (this.f69_1 == null) {
                this.fd_1 = 2;
                suspendResult = this.x68_1.a68_1.s13(this.y68_1).x62(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_2 = this;
                tmp_2.g69_1 = this.f69_1;
                this.fd_1 = 3;
                continue $sm;
              }
            } else {
              this.c69_1 = this.b69_1;
              this.fd_1 = 4;
              continue $sm;
            }

          case 2:
            var answer = suspendResult;
            this.d69_1.i2(this.e69_1, answer);
            this.g69_1 = answer;
            this.fd_1 = 3;
            continue $sm;
          case 3:
            var tmp_3 = this;
            return this.g69_1;
          case 4:
            var info = this.c69_1;
            var tmp1_elvis_lhs = info.s2(this.a69_1);
            return tmp1_elvis_lhs == null ? this.x68_1.z63(this.z68_1, VOID, true) : tmp1_elvis_lhs;
          case 5:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 5) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $cachedListSimpleStatsOrNullCOROUTINE$168(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q69_1 = _this__u8e3s4;
    this.r69_1 = path;
  }
  protoOf($cachedListSimpleStatsOrNullCOROUTINE$168).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 5;
            this.s69_1 = normalize(_PathInfo___init__impl__vpw96a(this.r69_1));
            this.fd_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.u69_1 = this.q69_1.d68_1;
            var tmp_1 = this;
            tmp_1.v69_1 = this.s69_1;
            var tmp_2 = this;
            var this_0 = this.u69_1;
            var key = this.v69_1;
            tmp_2.w69_1 = this_0.get(key);
            if (!(this.w69_1 == null)) {
              this.t69_1 = this.w69_1;
              this.fd_1 = 4;
              continue $sm;
            } else {
              this.fd_1 = 2;
              continue $sm;
            }

          case 2:
            this.fd_1 = 3;
            suspendResult = this.q69_1.x69(this.s69_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var out = suspendResult;
            var this_1 = this.u69_1;
            var key_0 = this.v69_1;
            this_1.set(key_0, out);
            this.t69_1 = out;
            if (false) {
              this.fd_1 = 1;
              continue $sm;
            }

            this.fd_1 = 4;
            continue $sm;
          case 4:
            return this.t69_1;
          case 5:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 5) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $listSimpleStatsOrNullCOROUTINE$169(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g6a_1 = _this__u8e3s4;
    this.h6a_1 = path;
  }
  protoOf($listSimpleStatsOrNullCOROUTINE$169).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.g6a_1.a68_1.s13(this.h6a_1).s13('$catalog.json').f40(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.i6a_1 = suspendResult;
            this.gd_1 = 3;
            this.fd_1 = 4;
            continue $sm;
          case 2:
            this.gd_1 = 3;
            var tmp_0 = this.id_1;
            if (tmp_0 instanceof Error) {
              var e = this.id_1;
              var tmp_1 = this;
              if (!(e instanceof FileNotFoundException)) {
                var this_0 = this.g6a_1.b68_1;
                var level = Level_ERROR_getInstance();
                if (this_0.f25(level)) {
                  this_0.g25(level, e);
                }
              }
              return null;
            } else {
              throw this.id_1;
            }

          case 3:
            throw this.id_1;
          case 4:
            this.gd_1 = 3;
            var catalogJsonString = this.i6a_1;
            var data = get_dyn(Json_instance.j6a(catalogJsonString));
            var tmp0_subject = _Dyn___get_value__impl__bemnlg(data);
            if (!(tmp0_subject == null) ? isInterface(tmp0_subject, List) : false) {
              var this_1 = _Dyn___get_list__impl__qpwjp(data);
              var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
              var tmp0_iterator = this_1.u();
              while (tmp0_iterator.v()) {
                var item = tmp0_iterator.x().t40_1;
                var localName = get_baseName_0(_PathInfo___init__impl__vpw96a(_Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80_0(item, 'name'))));
                destination.r(this.g6a_1.x63(this.h6a_1 + '/' + localName, _Dyn___get_bool__impl__nv3iun(Dyn__get_impl_6l2p80_0(item, 'isDirectory')), _Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(item, 'size')), VOID, VOID, VOID, VOID, VOID, Companion_getInstance_12().d1q(_Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(item, 'createTime'))), Companion_getInstance_12().d1q(_Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(item, 'modifiedTime'))), VOID, VOID, VOID, true));
              }
              var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
              var destination_0 = LinkedHashMap_init_$Create$_0(capacity);
              var tmp0_iterator_0 = destination.u();
              while (tmp0_iterator_0.v()) {
                var element = tmp0_iterator_0.x();
                destination_0.i2(get_baseName(element), element);
              }
              return destination_0;
            } else {
              var out = LinkedHashMap_init_$Create$();
              var tmp1_iterator = _Dyn___get_keys__impl__o4xmor(data).u();
              while (tmp1_iterator.v()) {
                var key = tmp1_iterator.x().t40_1;
                var fileName = _Dyn___get_str__impl__dup4cs(key);
                var info = Dyn__get_impl_6l2p80(data, key);
                var tmp2_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 0));
                var size = tmp2_elvis_lhs == null ? new Long(0, 0) : tmp2_elvis_lhs;
                var tmp3_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 1));
                var creationTime = tmp3_elvis_lhs == null ? new Long(0, 0) : tmp3_elvis_lhs;
                var tmp4_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 2));
                var modifiedTime = tmp4_elvis_lhs == null ? creationTime : tmp4_elvis_lhs;
                var isDirectory = endsWith(fileName, '/');
                var baseName = trimEnd(fileName, charArrayOf([_Char___init__impl__6a9atx(47)]));
                var value = this.g6a_1.x63(this.h6a_1 + '/' + baseName, isDirectory, size, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_12().d1q(creationTime), Companion_getInstance_12().d1q(modifiedTime), VOID, VOID, VOID, true);
                out.i2(baseName, value);
              }
              return out;
            }

        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 3) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  function CatalogVfs(parent) {
    Proxy.call(this);
    this.a68_1 = parent;
    this.b68_1 = Companion_getInstance_6().r24('CatalogVfs');
    this.c68_1 = LinkedHashMap_init_$Create$();
    this.d68_1 = FastStringMap();
  }
  protoOf(CatalogVfs).q63 = function (path, mode, $completion) {
    var tmp = new $openCOROUTINE$163(this, path, mode, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(CatalogVfs).z60 = function (path, $completion) {
    return this.a68_1.s13(path);
  };
  protoOf(CatalogVfs).s63 = function (path, $completion) {
    var tmp = new $statCOROUTINE$164(this, path, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(CatalogVfs).e68 = function (path, $completion) {
    var tmp = new $statOrNullCOROUTINE$165(this, path, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(CatalogVfs).h69 = function (path, $completion) {
    var tmp = new $cachedListSimpleStatsOrNullCOROUTINE$168(this, path, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(CatalogVfs).x69 = function (path, $completion) {
    var tmp = new $listSimpleStatsOrNullCOROUTINE$169(this, path, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function Companion_49() {
  }
  protoOf(Companion_49).k66 = function (jailRoot) {
    return (new JailVfs(jailRoot, Unit_instance)).v63();
  };
  var Companion_instance_57;
  function Companion_getInstance_64() {
    return Companion_instance_57;
  }
  function JailVfs(jailRoot, dummy) {
    Proxy.call(this);
    this.m6a_1 = jailRoot;
    this.n6a_1 = normalize(this.m6a_1.y5z());
  }
  protoOf(JailVfs).z60 = function (path, $completion) {
    return this.m6a_1.s13(trim_0(normalize(get_pathInfo(path)), charArrayOf([_Char___init__impl__6a9atx(47)])));
  };
  protoOf(JailVfs).t63 = function () {
    return this.m6a_1.t63();
  };
  protoOf(JailVfs).toString = function () {
    return 'JailVfs(' + this.m6a_1 + ')';
  };
  var resourcesVfsDebug;
  function Companion_50() {
  }
  var Companion_instance_58;
  function Companion_getInstance_65() {
    return Companion_instance_58;
  }
  function LocalVfs() {
    Vfs.call(this);
  }
  protoOf(LocalVfs).toString = function () {
    return 'LocalVfs';
  };
  function StandardVfs() {
  }
  protoOf(StandardVfs).o6a = function () {
    throw new NotImplementedError();
  };
  function get_localCurrentDirVfs() {
    return get_applicationVfs();
  }
  function get_resourcesVfs() {
    return get_standardVfs().o6a();
  }
  function unmountInternal($this, folder) {
    removeAll($this.s6a_1, MountableVfs$unmountInternal$lambda(folder));
  }
  function resort($this) {
    // Inline function 'kotlin.collections.sortByDescending' call
    var this_0 = $this.s6a_1;
    if (this_0.n() > 1) {
      // Inline function 'kotlin.comparisons.compareByDescending' call
      var tmp = MountableVfs$resort$lambda;
      var tmp$ret$0 = new sam$kotlin_Comparator$0_3(tmp);
      sortWith(this_0, tmp$ret$0);
    }
  }
  function sam$kotlin_Comparator$0_3(function_0) {
    this.t6a_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_3).aa = function (a, b) {
    return this.t6a_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_3).compare = function (a, b) {
    return this.aa(a, b);
  };
  function MountableVfs$unmountInternal$lambda($folder) {
    return function (it) {
      return it.ag_1 === normalize(get_pathInfo($folder));
    };
  }
  function MountableVfs$resort$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'korlibs.io.file.std.MountableVfs.resort.<anonymous>' call
    var tmp = b.ag_1.length;
    // Inline function 'korlibs.io.file.std.MountableVfs.resort.<anonymous>' call
    var tmp$ret$1 = a.ag_1.length;
    return compareValues(tmp, tmp$ret$1);
  }
  function $closeCOROUTINE$188(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c6b_1 = _this__u8e3s4;
  }
  protoOf($closeCOROUTINE$188).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 5;
            if (this.c6b_1.r6a_1) {
              var tmp_0 = this;
              tmp_0.d6b_1 = this.c6b_1.s6a_1;
              this.e6b_1 = 0;
              this.fd_1 = 1;
              continue $sm;
            } else {
              this.fd_1 = 4;
              continue $sm;
            }

          case 1:
            if (!(this.e6b_1 < this.d6b_1.n())) {
              this.fd_1 = 3;
              continue $sm;
            }

            var tmp_1 = this;
            var tmp0 = this.e6b_1;
            this.e6b_1 = tmp0 + 1 | 0;
            tmp_1.f6b_1 = this.d6b_1.f1(tmp0);
            this.fd_1 = 2;
            suspendResult = this.f6b_1.bg_1.b40_1.x5u(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.fd_1 = 1;
            continue $sm;
          case 3:
            this.fd_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 5) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function MountableVfs(closeMounts) {
    Proxy.call(this);
    this.r6a_1 = closeMounts;
    this.s6a_1 = ArrayList_init_$Create$();
  }
  protoOf(MountableVfs).x5u = function ($completion) {
    var tmp = new $closeCOROUTINE$188(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(MountableVfs).g6b = function (folder, file) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.MountableVfs.mount.<anonymous>' call
    unmountInternal(this, folder);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.s6a_1;
    var element = to(normalize(get_pathInfo(folder)), file);
    this_0.r(element);
    resort(this);
    return this;
  };
  protoOf(MountableVfs).z60 = function (path, $completion) {
    var rpath = normalize(get_pathInfo(path));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.s6a_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.io.file.std.MountableVfs.access.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var name_for_destructuring_parameter_0_fjsvno = this_0.f1(tmp0);
      var base = name_for_destructuring_parameter_0_fjsvno.cg();
      var file = name_for_destructuring_parameter_0_fjsvno.dg();
      if (startsWith(rpath, base)) {
        // Inline function 'kotlin.text.substring' call
        var startIndex = base.length;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = rpath.substring(startIndex);
        return file.s13(tmp$ret$1);
      }
    }
    throw new FileNotFoundException(path);
  };
  protoOf(MountableVfs).toString = function () {
    return 'MountableVfs';
  };
  function StandardPathsBase() {
  }
  function UrlVfs(url, client, failFromStatus) {
    client = client === VOID ? createHttpClient() : client;
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    return (new UrlVfs_0(url.u6b(VOID, VOID, VOID, VOID, VOID, '', null).v6b(), Unit_instance, client, failFromStatus)).s13(url.n6b_1);
  }
  function $readCOROUTINE$196(_this__u8e3s4, position, buffer, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e6c_1 = _this__u8e3s4;
    this.f6c_1 = position;
    this.g6c_1 = buffer;
    this.h6c_1 = offset;
    this.i6c_1 = len;
  }
  protoOf($readCOROUTINE$196).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            if (this.i6c_1 === 0)
              return 0;
            this.fd_1 = 1;
            var this_0 = this.f6c_1;
            var other = this.i6c_1;
            suspendResult = _readRangeBase(this.e6c_1.o6c_1, this.e6c_1.p6c_1, until_0(this.f6c_1, this_0.mc(toLong(other))), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.j6c_1 = suspendResult;
            this.k6c_1 = this.j6c_1.v6c_1;
            this.l6c_1 = this.h6c_1;
            this.m6c_1 = this.i6c_1;
            this.n6c_1 = 0;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            if (!(this.m6c_1 > 0)) {
              this.fd_1 = 5;
              continue $sm;
            }

            this.fd_1 = 3;
            suspendResult = this.k6c_1.y5w(this.g6c_1, this.l6c_1, this.m6c_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var read = suspendResult;
            if (read < 0 ? this.n6c_1 === 0 : false)
              return read;
            if (read <= 0) {
              this.fd_1 = 5;
              continue $sm;
            } else {
              this.fd_1 = 4;
              continue $sm;
            }

          case 4:
            this.m6c_1 = this.m6c_1 - read | 0;
            this.n6c_1 = this.n6c_1 + read | 0;
            this.l6c_1 = this.l6c_1 + read | 0;
            this.fd_1 = 2;
            continue $sm;
          case 5:
            return this.n6c_1;
          case 6:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 6) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $getLengthCOROUTINE$197(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g6d_1 = _this__u8e3s4;
  }
  protoOf($getLengthCOROUTINE$197).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = this.g6d_1.l5w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              this.h6d_1 = this.g6d_1.q6c_1.b63_1;
              this.fd_1 = 2;
              continue $sm;
            } else {
              var tmp_0 = this;
              unsupported_0();
            }

            break;
          case 2:
            return this.h6d_1;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function _readRangeBase($this, fullUrl, range, $completion) {
    var tmp = new $_readRangeBaseCOROUTINE$192($this, fullUrl, range, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function UrlVfs$open$2(this$0, $fullUrl, $stat) {
    this.o6c_1 = this$0;
    this.p6c_1 = $fullUrl;
    this.q6c_1 = $stat;
    AsyncStreamBase.call(this);
  }
  protoOf(UrlVfs$open$2).k67 = function (position, buffer, offset, len, $completion) {
    var tmp = new $readCOROUTINE$196(this, position, buffer, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(UrlVfs$open$2).l5w = function ($completion) {
    return this.q6c_1.b63_1.t6(new Long(0, 0)) >= 0;
  };
  protoOf(UrlVfs$open$2).m5w = function ($completion) {
    var tmp = new $getLengthCOROUTINE$197(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function $openCOROUTINE$190(_this__u8e3s4, path, mode, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d6e_1 = _this__u8e3s4;
    this.e6e_1 = path;
    this.f6e_1 = mode;
  }
  protoOf($openCOROUTINE$190).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            this.gd_1 = 5;
            this.g6e_1 = this.d6e_1.o6e(this.e6e_1);
            if (startsWith(this.g6e_1, 'file:')) {
              this.fd_1 = 4;
              suspendResult = this.d6e_1.l6e_1.q6e(this.g6e_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 1;
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            var tmp0_safe_receiver = this.q6().md(Companion_instance_56);
            tmp_0.h6e_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c65_1;
            if (this.h6e_1 == null) {
              this.fd_1 = 2;
              suspendResult = this.d6e_1.s63(this.e6e_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.i6e_1 = this.h6e_1;
              this.fd_1 = 3;
              continue $sm;
            }

          case 2:
            this.i6e_1 = suspendResult;
            this.fd_1 = 3;
            continue $sm;
          case 3:
            var stat = this.i6e_1;
            var tmp_1 = stat.k63_1;
            var response = tmp_1 instanceof Response ? tmp_1 : null;
            if (!stat.z62_1) {
              throw new FileNotFoundException('Unexistant ' + this.g6e_1 + ' : ' + response);
            }

            return buffered(toAsyncStream(new UrlVfs$open$2(this.d6e_1, this.g6e_1, stat)));
          case 4:
            var ARGUMENT = suspendResult;
            return openAsync(ARGUMENT);
          case 5:
            this.gd_1 = 6;
            var tmp_2 = this.id_1;
            if (tmp_2 instanceof RuntimeException) {
              var e = this.id_1;
              var tmp2_elvis_lhs = e.message;
              throw new FileNotFoundException(tmp2_elvis_lhs == null ? 'error' : tmp2_elvis_lhs);
            } else {
              throw this.id_1;
            }

          case 6:
            throw this.id_1;
          case 7:
            this.gd_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 6) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  function $_readRangeBaseCOROUTINE$192(_this__u8e3s4, fullUrl, range, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q6d_1 = _this__u8e3s4;
    this.r6d_1 = fullUrl;
    this.s6d_1 = range;
  }
  protoOf($_readRangeBaseCOROUTINE$192).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.fd_1 = 1;
            suspendResult = this.q6d_1.l6e_1.c6f(Companion_getInstance_70().s6e_1, this.r6d_1, Headers_init_$Create$_0(this.s6d_1.equals(get_LONG_ZERO_TO_MAX_RANGE()) ? LinkedHashMap_init_$Create$() : linkedHashMapOf([to('range', 'bytes=' + this.s6d_1.h9().toString() + '-' + this.s6d_1.i9().toString())])), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.t6d_1 = suspendResult;
            var tmp_0 = this;
            tmp_0.u6d_1 = this.t6d_1;
            if (this.q6d_1.m6e_1) {
              if (this.u6d_1.r6c_1 === 404)
                throw new FileNotFoundException(this.r6d_1 + ' not found');
              this.fd_1 = 2;
              suspendResult = this.u6d_1.d6f(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 3;
              continue $sm;
            }

          case 2:
            this.fd_1 = 3;
            continue $sm;
          case 3:
            return this.t6d_1;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readRangeCOROUTINE$193(_this__u8e3s4, path, range, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m6f_1 = _this__u8e3s4;
    this.n6f_1 = path;
    this.o6f_1 = range;
  }
  protoOf($readRangeCOROUTINE$193).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = _readRangeBase(this.m6f_1, this.m6f_1.o6e(this.n6f_1), this.o6f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.p6f_1 = suspendResult;
            this.q6f_1 = this.p6f_1.v6c_1;
            this.fd_1 = 2;
            suspendResult = readAll(this.q6f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $statCOROUTINE$195(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z6f_1 = _this__u8e3s4;
    this.a6g_1 = path;
  }
  protoOf($statCOROUTINE$195).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            this.b6g_1 = this.z6f_1.o6e(this.a6g_1);
            if (startsWith(this.b6g_1, 'file:')) {
              this.gd_1 = 3;
              this.fd_1 = 2;
              suspendResult = this.z6f_1.l6e_1.q6e(this.b6g_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = this.z6f_1.l6e_1.c6f(Companion_getInstance_70().t6e_1, this.b6g_1, VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var result = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (result.w6c_1) {
              var tmp0_safe_receiver = result.t6c_1.s13(Companion_instance_65.e6g_1);
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toLongOrNull_0(tmp0_safe_receiver);
              tmp_1 = this.z6f_1.x63(this.a6g_1, false, tmp1_elvis_lhs == null ? new Long(-1, -1) : tmp1_elvis_lhs, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, result);
            } else {
              tmp_1 = this.z6f_1.z63(this.a6g_1, result);
            }

            tmp_0.c6g_1 = tmp_1;
            this.fd_1 = 5;
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT.length;
            var size = toLong(ARGUMENT_0);
            this.d6g_1 = this.z6f_1.x63(this.a6g_1, false, size, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
            this.gd_1 = 6;
            this.fd_1 = 4;
            continue $sm;
          case 3:
            this.gd_1 = 6;
            var tmp_2 = this.id_1;
            if (tmp_2 instanceof Error) {
              var e = this.id_1;
              var tmp_3 = this;
              printStackTrace(e);
              tmp_3.d6g_1 = this.z6f_1.z63(this.a6g_1);
              this.fd_1 = 4;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 4:
            this.gd_1 = 6;
            this.c6g_1 = this.d6g_1;
            this.fd_1 = 5;
            continue $sm;
          case 5:
            return this.c6g_1;
          case 6:
            throw this.id_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 6) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  function UrlVfs_0(url, dummy, client, failFromStatus) {
    client = client === VOID ? createHttpClient() : client;
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    Vfs.call(this);
    this.j6e_1 = url;
    this.k6e_1 = dummy;
    this.l6e_1 = client;
    this.m6e_1 = failFromStatus;
    this.n6e_1 = this.j6e_1;
  }
  protoOf(UrlVfs_0).t63 = function () {
    return this.n6e_1;
  };
  protoOf(UrlVfs_0).o6e = function (path) {
    var result = trim_0(this.j6e_1, charArrayOf([_Char___init__impl__6a9atx(47)])) + toString_0(_Char___init__impl__6a9atx(47)) + trim_0(path, charArrayOf([_Char___init__impl__6a9atx(47)]));
    return result;
  };
  protoOf(UrlVfs_0).q63 = function (path, mode, $completion) {
    var tmp = new $openCOROUTINE$190(this, path, mode, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(UrlVfs_0).r63 = function (path, range, $completion) {
    var tmp = new $readRangeCOROUTINE$193(this, path, range, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(UrlVfs_0).s63 = function (path, $completion) {
    var tmp = new $statCOROUTINE$195(this, path, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(UrlVfs_0).toString = function () {
    return 'UrlVfs';
  };
  function UrlVfs_1(url, client, failFromStatus) {
    client = client === VOID ? createHttpClient() : client;
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    return UrlVfs(Companion_getInstance_69().r24(url), client, failFromStatus);
  }
  var bytesTempPool$delegate;
  function get_smallBytesPool() {
    _init_properties_TempBytes_kt__9ttz0b();
    // Inline function 'korlibs.io.lang.threadLocal.getValue' call
    var this_0 = smallBytesPool$delegate;
    smallBytesPool$factory();
    return this_0.k6g_1.u1h();
  }
  var smallBytesPool$delegate;
  function bytesTempPool$delegate$lambda() {
    _init_properties_TempBytes_kt__9ttz0b();
    return Pool_init_$Create$(1, bytesTempPool$delegate$lambda$lambda);
  }
  function bytesTempPool$delegate$lambda$lambda(it) {
    _init_properties_TempBytes_kt__9ttz0b();
    return new Int8Array(65536);
  }
  function smallBytesPool$delegate$lambda() {
    _init_properties_TempBytes_kt__9ttz0b();
    return Pool_init_$Create$(16, smallBytesPool$delegate$lambda$lambda);
  }
  function smallBytesPool$delegate$lambda$lambda(it) {
    _init_properties_TempBytes_kt__9ttz0b();
    return new Int8Array(16);
  }
  function smallBytesPool$factory() {
    return getPropertyCallableRef('smallBytesPool', 0, KProperty0, function () {
      return get_smallBytesPool();
    }, null);
  }
  var properties_initialized_TempBytes_kt_bjneux;
  function _init_properties_TempBytes_kt__9ttz0b() {
    if (!properties_initialized_TempBytes_kt_bjneux) {
      properties_initialized_TempBytes_kt_bjneux = true;
      bytesTempPool$delegate = new threadLocal(bytesTempPool$delegate$lambda);
      smallBytesPool$delegate = new threadLocal(smallBytesPool$delegate$lambda);
    }
  }
  var CHARSET_PROVIDERS;
  var CHARSET_PROVIDERS_LOCK;
  function get_LATIN1() {
    _init_properties_Charset_kt__c47y1m();
    return LATIN1;
  }
  var LATIN1;
  var UTF16_LE;
  function get_UTF16_BE() {
    _init_properties_Charset_kt__c47y1m();
    return UTF16_BE;
  }
  var UTF16_BE;
  function Companion_51() {
  }
  protoOf(Companion_51).m6g = function (_this__u8e3s4, codePoint) {
    if ((55296 <= codePoint ? codePoint <= 57343 : false) ? true : codePoint > 65535) {
      var U0 = codePoint - 65536 | 0;
      var hs = extract(U0, 10, 10);
      var ls = extract(U0, 0, 10);
      _this__u8e3s4.v5(numberToChar(55296 | hs));
      _this__u8e3s4.v5(numberToChar(56320 | ls));
    } else {
      _this__u8e3s4.v5(numberToChar(codePoint));
    }
  };
  var Companion_instance_59;
  function Companion_getInstance_66() {
    return Companion_instance_59;
  }
  function Charset(name) {
    this.n6g_1 = name;
  }
  protoOf(Charset).o6g = function (nbytes) {
    return imul(nbytes, 2);
  };
  function UTF16Charset(le) {
    Charset.call(this, 'UTF-16-' + (le ? 'LE' : 'BE'));
    this.r6g_1 = le;
  }
  protoOf(UTF16Charset).o6g = function (nbytes) {
    return imul(nbytes, 2);
  };
  protoOf(UTF16Charset).p6g = function (out, src, start, end) {
    var consumed = 0;
    var progression = step(until(start, end), 2);
    var inductionVariable = progression.fb_1;
    var last = progression.gb_1;
    var step_0 = progression.hb_1;
    if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var char = numberToChar(getS16(src, n, this.r6g_1));
        out.v5(char);
        consumed = consumed + 2 | 0;
      }
       while (!(n === last));
    return consumed;
  };
  function toString_3(_this__u8e3s4, charset, start, end) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? _this__u8e3s4.length : end;
    _init_properties_Charset_kt__c47y1m();
    var out = StringBuilder_init_$Create$_0(charset.o6g(end - start | 0));
    charset.p6g(out, _this__u8e3s4, start, end);
    return out.toString();
  }
  function ASCII() {
    ASCII_instance = this;
    var tmp = 0;
    var tmp_0 = charArray(128);
    while (tmp < 128) {
      var tmp_1 = tmp;
      tmp_0[tmp_1] = numberToChar(tmp_1);
      tmp = tmp + 1 | 0;
    }
    SingleByteCharset.call(this, 'ASCII', concatToString(tmp_0) + '\xC7\xFC\xE9\xE2\xE4\xE0\xE5\xE7\xEA\xEB\xE8\xEF\xEE\xEC\xC4\xC5\xC9\xE6\xC6\xF4\xF6\xF2\xFB\xF9\xFF\xD6\xDC\xF8\xA3\xD8\xD7\u0192\xE1\xED\xF3\xFA\xF1\xD1\xAA\xBA\xBF\xAE\xAC\xBD\xBC\xA1\xAB\xBB\u2591\u2592\u2593\u2502\u2524\xC1\xC2\xC0\xA9\u2563\u2551\u2557\u255D\xA2\xA5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xE3\xC3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xA4\xF0\xD0\xCA\xCB\xC8\u0131\xCD\xCE\xCF\u2518\u250C\u2588\u2584\xA6\xCC\u2580\xD3\xDF\xD4\xD2\xF5\xD5\xB5\xFE\xDE\xDA\xDB\xD9\xFD\xDD\xAF\xB4\xAD\xB1\u2017\xBE\xB6\xA7\xF7\xB8\xB0\xA8\xB7\xB9\xB3\xB2\u25A0\xA0');
  }
  var ASCII_instance;
  function ASCII_getInstance() {
    if (ASCII_instance == null)
      new ASCII();
    return ASCII_instance;
  }
  function ISO_8859_1() {
    ISO_8859_1_instance = this;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.lang.ISO_8859_1.<init>.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.v5(numberToChar(n));
      }
       while (inductionVariable < 256);
    var tmp$ret$1 = this_0.toString();
    SingleByteCharset.call(this, 'ISO-8859-1', tmp$ret$1);
  }
  var ISO_8859_1_instance;
  function ISO_8859_1_getInstance() {
    if (ISO_8859_1_instance == null)
      new ISO_8859_1();
    return ISO_8859_1_instance;
  }
  function SingleByteCharset(name, conv) {
    BaseSingleByteCharset.call(this, name);
    this.t6g_1 = conv;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = IntIntMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.lang.SingleByteCharset.v.<anonymous>' call
    var inductionVariable = 0;
    var last = this.t6g_1.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_1 = charSequenceGet(this.t6g_1, n);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_1);
        this_0.n1x(tmp$ret$0, n);
      }
       while (inductionVariable < last);
    tmp.u6g_1 = this_0;
  }
  protoOf(SingleByteCharset).p6g = function (out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out.v5(charSequenceGet(this.t6g_1, src[n] & 255));
      }
       while (inductionVariable < end);
    return end - start | 0;
  };
  function BaseSingleByteCharset(name) {
    Charset.call(this, name);
  }
  protoOf(BaseSingleByteCharset).o6g = function (nbytes) {
    return nbytes;
  };
  function UTC8CharsetBase(name) {
    Charset.call(this, name);
  }
  protoOf(UTC8CharsetBase).o6g = function (nbytes) {
    return imul(nbytes, 2);
  };
  protoOf(UTC8CharsetBase).p6g = function (out, src, start, end) {
    if ((start < 0 ? true : start > src.length) ? true : end < 0 ? true : end > src.length) {
      // Inline function 'kotlin.error' call
      var message = 'Out of bounds';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var i = start;
    loop: while (i < end) {
      var c = src[i] & 255;
      var tmp0_subject = c >> 4;
      if (0 <= tmp0_subject ? tmp0_subject <= 7 : false) {
        Companion_instance_59.m6g(out, c);
        i = i + 1 | 0;
      } else if (12 <= tmp0_subject ? tmp0_subject <= 13 : false) {
        if ((i + 1 | 0) >= end)
          break loop;
        Companion_instance_59.m6g(out, (c & 31) << 6 | src[i + 1 | 0] & 63);
        i = i + 2 | 0;
      } else if (tmp0_subject === 14) {
        if ((i + 2 | 0) >= end)
          break loop;
        Companion_instance_59.m6g(out, (c & 15) << 12 | (src[i + 1 | 0] & 63) << 6 | src[i + 2 | 0] & 63);
        i = i + 3 | 0;
      } else if (tmp0_subject === 15) {
        if ((i + 3 | 0) >= end)
          break loop;
        Companion_instance_59.m6g(out, insert(insert(insert(insert(0, extract(src[i + 0 | 0], 0, 3), 18, 3), extract(src[i + 1 | 0], 0, 6), 12, 6), extract(src[i + 2 | 0], 0, 6), 6, 6), extract(src[i + 3 | 0], 0, 6), 0, 6));
        i = i + 4 | 0;
      } else {
        out.v5(_Char___init__impl__6a9atx(65533));
        i = i + 1 | 0;
      }
    }
    return i - start | 0;
  };
  function Charsets() {
  }
  protoOf(Charsets).o4z = function () {
    return get_LATIN1();
  };
  var Charsets_instance;
  function Charsets_getInstance() {
    return Charsets_instance;
  }
  var properties_initialized_Charset_kt_dajgec;
  function _init_properties_Charset_kt__c47y1m() {
    if (!properties_initialized_Charset_kt_dajgec) {
      properties_initialized_Charset_kt_dajgec = true;
      // Inline function 'kotlin.collections.arrayListOf' call
      CHARSET_PROVIDERS = ArrayList_init_$Create$();
      CHARSET_PROVIDERS_LOCK = new NonRecursiveLock();
      LATIN1 = ISO_8859_1_getInstance();
      UTF16_LE = new UTF16Charset(true);
      UTF16_BE = new UTF16Charset(false);
    }
  }
  function cancel_0(_this__u8e3s4) {
    return _this__u8e3s4.x6g(CancellationException_init_$Create$(''));
  }
  function CloseableCancellable() {
  }
  function CancellableGroup() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.y6g_1 = ArrayList_init_$Create$();
  }
  protoOf(CancellableGroup).z6g = function (c) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.y6g_1;
    var element = cancellable(c);
    this_0.r(element);
  };
  protoOf(CancellableGroup).p21 = function () {
    this.x6g(CancellationException_init_$Create$_0());
  };
  protoOf(CancellableGroup).x6g = function (e) {
    cancel_1(this.y6g_1, e);
  };
  function toDisposable(_this__u8e3s4) {
    var tmp = toDisposable$lambda(_this__u8e3s4);
    return new sam$korlibs_io_lang_Disposable$0(tmp);
  }
  function cancellable(_this__u8e3s4) {
    var tmp = cancellable$lambda(_this__u8e3s4);
    return new sam$korlibs_io_lang_Cancellable$0(tmp);
  }
  function cancel_1(_this__u8e3s4, e) {
    e = e === VOID ? CancellationException_init_$Create$('') : e;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_iterator = _this__u8e3s4.u();
    while (tmp0_iterator.v()) {
      var c = tmp0_iterator.x();
      c.x6g(e);
    }
    return Unit_instance;
  }
  function sam$korlibs_io_lang_Disposable$0(function_0) {
    this.a6h_1 = function_0;
  }
  protoOf(sam$korlibs_io_lang_Disposable$0).f1e = function () {
    return this.a6h_1();
  };
  function sam$korlibs_io_lang_Cancellable$0(function_0) {
    this.b6h_1 = function_0;
  }
  protoOf(sam$korlibs_io_lang_Cancellable$0).x6g = function (e) {
    return this.b6h_1(e);
  };
  function toDisposable$lambda($this_toDisposable) {
    return function () {
      $this_toDisposable.p21();
      return Unit_instance;
    };
  }
  function cancellable$lambda($this_cancellable) {
    return function (it) {
      $this_cancellable.p21();
      return Unit_instance;
    };
  }
  var customEnvironments;
  function Companion_52() {
  }
  protoOf(Companion_52).s13 = function (key) {
    var tmp0_safe_receiver = customEnvironments;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s13(key);
    return tmp1_elvis_lhs == null ? EnvironmentInternal_instance.s13(key) : tmp1_elvis_lhs;
  };
  var Companion_instance_60;
  function Companion_getInstance_67() {
    return Companion_instance_60;
  }
  function unsupported_0(msg) {
    msg = msg === VOID ? 'unsupported' : msg;
    throw UnsupportedOperationException_init_$Create$(msg);
  }
  function invalidOp(msg) {
    throw new InvalidOperationException(msg);
  }
  function get_invalidOp() {
    throw new InvalidOperationException();
  }
  function InvalidOperationException(str) {
    str = str === VOID ? 'Invalid Operation' : str;
    Exception_init_$Init$(str, this);
    captureStack(this, InvalidOperationException);
  }
  function MalformedInputException(msg) {
    Exception_init_$Init$(msg, this);
    captureStack(this, MalformedInputException);
  }
  function currentStackTrace(msg) {
    msg = msg === VOID ? 'printStackTrace' : msg;
    return stackTraceToString(Exception_init_$Create$(msg));
  }
  function FileAlreadyExistsException(msg) {
    IOException.call(this, msg);
    captureStack(this, FileAlreadyExistsException);
  }
  function reserved(msg) {
    throw new ReservedException(msg);
  }
  function get_reserved() {
    throw new ReservedException();
  }
  function get_unreachable() {
    throw new UnreachableException();
  }
  function ReservedException(str) {
    str = str === VOID ? 'Reserved' : str;
    Exception_init_$Init$(str, this);
    captureStack(this, ReservedException);
  }
  function UnreachableException(str) {
    str = str === VOID ? 'Unreachable' : str;
    Exception_init_$Init$(str, this);
    captureStack(this, UnreachableException);
  }
  var replaceNonPrintableCharactersRegex$delegate;
  function substr(_this__u8e3s4, start) {
    _init_properties_StringExt_kt__eg42u6();
    return substr_0(_this__u8e3s4, start, _this__u8e3s4.length);
  }
  function substr_0(_this__u8e3s4, start, length) {
    _init_properties_StringExt_kt__eg42u6();
    var low = clamp(start >= 0 ? start : _this__u8e3s4.length + start | 0, 0, _this__u8e3s4.length);
    var high = clamp(length >= 0 ? low + length | 0 : _this__u8e3s4.length + length | 0, 0, _this__u8e3s4.length);
    var tmp;
    if (high >= low) {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.substring(low, high);
    } else {
      tmp = '';
    }
    return tmp;
  }
  function substringEquals(_this__u8e3s4, a, aIndex, b, bIndex, count) {
    _init_properties_StringExt_kt__eg42u6();
    if (count === 0)
      return true;
    if (aIndex < 0 ? true : bIndex < 0)
      return false;
    if ((aIndex + count | 0) > a.length)
      return false;
    if ((bIndex + count | 0) > b.length)
      return false;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charSequenceGet(a, aIndex + n | 0) === charSequenceGet(b, bIndex + n | 0)))
          return false;
      }
       while (inductionVariable < count);
    return true;
  }
  function String_fromCharArray(arrays, offset, size) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? arrays.length - offset | 0 : size;
    _init_properties_StringExt_kt__eg42u6();
    return concatToString_0(arrays, offset, offset + size | 0);
  }
  function lastIndexOfOrNull(_this__u8e3s4, char, startIndex) {
    startIndex = startIndex === VOID ? get_lastIndex_0(_this__u8e3s4) : startIndex;
    _init_properties_StringExt_kt__eg42u6();
    // Inline function 'kotlin.takeIf' call
    var this_0 = lastIndexOf(_this__u8e3s4, char, startIndex);
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.io.lang.lastIndexOfOrNull.<anonymous>' call
    if (this_0 >= 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function replaceNonPrintableCharactersRegex$delegate$lambda() {
    _init_properties_StringExt_kt__eg42u6();
    return Regex_init_$Create$('[^ -~]');
  }
  var properties_initialized_StringExt_kt_sd962o;
  function _init_properties_StringExt_kt__eg42u6() {
    if (!properties_initialized_StringExt_kt_sd962o) {
      properties_initialized_StringExt_kt_sd962o = true;
      replaceNonPrintableCharactersRegex$delegate = lazy(replaceNonPrintableCharactersRegex$delegate$lambda);
    }
  }
  function threadLocal$local$1(this$0) {
    this.d6h_1 = this$0;
    NativeThreadLocal.call(this);
  }
  protoOf(threadLocal$local$1).e6h = function () {
    return this.d6h_1.j6g_1();
  };
  function threadLocal(gen) {
    this.j6g_1 = gen;
    var tmp = this;
    tmp.k6g_1 = new threadLocal$local$1(this);
  }
  function WStringReader(str, position) {
    position = position === VOID ? 0 : position;
    this.z4q_1 = str;
    this.a4r_1 = position;
  }
  protoOf(WStringReader).m4r = function () {
    return this.z4q_1.a() - this.a4r_1 | 0;
  };
  protoOf(WStringReader).f6h = function () {
    return this.a4r_1 >= this.z4q_1.a();
  };
  protoOf(WStringReader).d4b = function () {
    return !this.f6h();
  };
  protoOf(WStringReader).b4r = function (offset) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.WString.getOrElse' call
      var this_0 = this.z4q_1;
      var index = this.a4r_1 + offset | 0;
      if (index < 0 ? true : index >= this_0.a()) {
        // Inline function 'korlibs.io.lang.WStringReader.peek.<anonymous>' call
        tmp$ret$1 = _WChar___init__impl__4vbl4k(0);
        break $l$block;
      }
      tmp$ret$1 = this_0.g6h(index);
    }
    return tmp$ret$1;
  };
  protoOf(WStringReader).e5e = function (offset, $super) {
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.b4r(offset) : $super.b4r.call(this, offset).h6h_1;
  };
  protoOf(WStringReader).v4b = function (count) {
    this.a4r_1 = this.a4r_1 + count | 0;
  };
  protoOf(WStringReader).n4r = function (offset, len) {
    return substr_1(this.z4q_1, this.a4r_1 + offset | 0, len);
  };
  function _WChar___init__impl__4vbl4k(codePoint) {
    return codePoint;
  }
  function _WChar___get_codePoint__impl__c8brwu($this) {
    return $this;
  }
  function Companion_53() {
    Companion_instance_61 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$0 = new Int32Array([]);
    tmp.l4r_1 = new WString(tmp$ret$0, '');
  }
  protoOf(Companion_53).p20 = function (codePoints) {
    return this.i6h(codePoints);
  };
  protoOf(Companion_53).r24 = function (string) {
    return this.j6h(string);
  };
  protoOf(Companion_53).j6h = function (string) {
    if (string === '')
      return this.l4r_1;
    var codePoints = new Int32Array(string.length);
    // Inline function 'korlibs.io.lang.forEachCodePoint' call
    var string_0 = string;
    var m = 0;
    var n = 0;
    while (n < string_0.length) {
      // Inline function 'kotlin.code' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var this_0 = charSequenceGet(string_0, tmp0);
      var value = Char__toInt_impl_vasixd(this_0);
      var error = false;
      if ((value & 63488) === 55296 ? n < string_0.length : false) {
        // Inline function 'kotlin.code' call
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var this_1 = charSequenceGet(string_0, tmp1);
        var extra = Char__toInt_impl_vasixd(this_1);
        if (!((extra & 64512) === 56320)) {
          n = n - 1 | 0;
          error = true;
        } else {
          var dataHigh = value & 1023;
          var dataLow = extra & 1023;
          value = (dataLow | dataHigh << 10) + 65536 | 0;
        }
      }
      // Inline function 'korlibs.io.lang.Companion.fromString.<anonymous>' call
      var tmp3 = m;
      m = tmp3 + 1 | 0;
      codePoints[tmp3] = value;
    }
    var length = m;
    return new WString(copyOf(codePoints, length), string);
  };
  protoOf(Companion_53).i6h = function (codePoints) {
    // Inline function 'kotlin.collections.count' call
    var count = 0;
    var inductionVariable = 0;
    var last = codePoints.length;
    while (inductionVariable < last) {
      var element = codePoints[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.io.lang.Companion.fromCodePoints.<anonymous>' call
      if (element >= 65536) {
        count = count + 1 | 0;
      }
    }
    var surrogateCount = count;
    var out = StringBuilder_init_$Create$_0(codePoints.length + surrogateCount | 0);
    var inductionVariable_0 = 0;
    var last_0 = codePoints.length;
    while (inductionVariable_0 < last_0) {
      var codePoint = codePoints[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      if (codePoint > 65535) {
        var U1 = codePoint - 65536 | 0;
        var W1 = 55296 | (U1 >>> 10 | 0) & 1023;
        var W2 = 56320 | (U1 >>> 0 | 0) & 1023;
        out.v5(numberToChar(W1));
        out.v5(numberToChar(W2));
      } else {
        out.v5(numberToChar(codePoint));
      }
    }
    return new WString(codePoints, out.toString());
  };
  var Companion_instance_61;
  function Companion_getInstance_68() {
    if (Companion_instance_61 == null)
      new Companion_53();
    return Companion_instance_61;
  }
  function WString(codePoints, string) {
    Companion_getInstance_68();
    this.o4r_1 = codePoints;
    this.p4r_1 = string;
    this.q4r_1 = 0;
    this.r4r_1 = false;
  }
  protoOf(WString).a = function () {
    return this.o4r_1.length;
  };
  protoOf(WString).g6h = function (index) {
    return _WChar___init__impl__4vbl4k(this.o4r_1[index]);
  };
  protoOf(WString).e1a = function (startIndex, endIndex) {
    var tmp = copyOfRange_0(this.o4r_1, startIndex, endIndex);
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.p4r_1.substring(startIndex, endIndex);
    return new WString(tmp, tmp$ret$1);
  };
  protoOf(WString).hashCode = function () {
    if (!this.r4r_1) {
      this.r4r_1 = true;
      this.q4r_1 = contentHashCode(this.o4r_1);
    }
    return this.q4r_1;
  };
  protoOf(WString).equals = function (other) {
    var tmp;
    if (other instanceof WString) {
      tmp = contentEquals(this.o4r_1, other.o4r_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(WString).toString = function () {
    return this.p4r_1;
  };
  function substr_1(_this__u8e3s4, start, length) {
    length = length === VOID ? _this__u8e3s4.a() : length;
    var low = clamp(start >= 0 ? start : _this__u8e3s4.a() + start | 0, 0, _this__u8e3s4.a());
    var high = clamp(length >= 0 ? low + length | 0 : _this__u8e3s4.a() + length | 0, 0, _this__u8e3s4.a());
    return high < low ? Companion_getInstance_68().r24('') : _this__u8e3s4.e1a(low, high);
  }
  function QueryString() {
  }
  protoOf(QueryString).k6h = function (str) {
    // Inline function 'kotlin.collections.linkedMapOf' call
    var out = LinkedHashMap_init_$Create$();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = split_0(str, charArrayOf([_Char___init__impl__6a9atx(38)]));
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.io.net.QueryString.decode.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var chunk = this_0.f1(tmp0);
      var parts = split_0(chunk, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      var key = Companion_getInstance_69().l6h(parts.f1(0), get_UTF8(), true);
      var tmp = Companion_getInstance_69();
      // Inline function 'kotlin.collections.getOrElse' call
      var tmp_0;
      if (1 >= 0 ? 1 <= get_lastIndex(parts) : false) {
        tmp_0 = parts.f1(1);
      } else {
        // Inline function 'korlibs.io.net.QueryString.decode.<anonymous>.<anonymous>' call
        tmp_0 = key;
      }
      var tmp$ret$2 = tmp_0;
      var value = tmp.l6h(tmp$ret$2, get_UTF8(), true);
      // Inline function 'kotlin.collections.getOrPut' call
      var value_0 = out.s2(key);
      var tmp_1;
      if (value_0 == null) {
        // Inline function 'korlibs.io.net.QueryString.decode.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.arrayListOf' call
        var answer = ArrayList_init_$Create$();
        out.i2(key, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value_0;
      }
      var list = tmp_1;
      // Inline function 'kotlin.collections.plusAssign' call
      list.r(value);
    }
    return out;
  };
  var QueryString_instance;
  function QueryString_getInstance() {
    return QueryString_instance;
  }
  function Companion_54() {
    Companion_instance_62 = this;
    this.h6g_1 = 0;
    this.i6g_1 = Regex_init_$Create$('^([a-zA-Z0-9+.-]+)(?::([a-zA-Z]+))?:');
  }
  protoOf(Companion_54).m6h = function (scheme) {
    switch (scheme) {
      case 'ftp':
        return 21;
      case 'ftps':
        return 990;
      case 'http':
      case 'ws':
        return 80;
      case 'https':
      case 'wss':
        return 443;
      default:
        return -1;
    }
  };
  protoOf(Companion_54).n6h = function (scheme, subScheme, userInfo, host, path, query, fragment, opaque, port) {
    var tmp;
    if (scheme == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = scheme.toLowerCase();
    }
    var tmp_0 = tmp;
    var tmp_1;
    if (subScheme == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = subScheme.toLowerCase();
    }
    return new URL_0(opaque, tmp_0, tmp_1, userInfo, host, path, query, fragment, port);
  };
  protoOf(Companion_54).o6h = function (scheme, subScheme, userInfo, host, path, query, fragment, opaque, port, $super) {
    scheme = scheme === VOID ? null : scheme;
    subScheme = subScheme === VOID ? null : subScheme;
    userInfo = userInfo === VOID ? null : userInfo;
    host = host === VOID ? null : host;
    path = path === VOID ? '' : path;
    query = query === VOID ? null : query;
    fragment = fragment === VOID ? null : fragment;
    opaque = opaque === VOID ? false : opaque;
    port = port === VOID ? this.h6g_1 : port;
    return $super === VOID ? this.n6h(scheme, subScheme, userInfo, host, path, query, fragment, opaque, port) : $super.n6h.call(this, scheme, subScheme, userInfo, host, path, query, fragment, opaque, port);
  };
  protoOf(Companion_54).r24 = function (url) {
    var r = new StrReader(url);
    var schemeColon = r.u6h(this.i6g_1);
    var tmp;
    if (!(schemeColon == null)) {
      var isHierarchical = !(r.v6h('//') == null);
      var nonScheme = r.w6h();
      var schemeParts = split(dropLast(schemeColon, 1), [':']);
      var scheme = schemeParts.f1(0);
      var subScheme = getOrNull_1(schemeParts, 1);
      var nonFragment = substringBefore(nonScheme, _Char___init__impl__6a9atx(35));
      var fragment = substringAfterOrNull(nonScheme, _Char___init__impl__6a9atx(35));
      var nonQuery = substringBefore(nonFragment, _Char___init__impl__6a9atx(63));
      var query = substringAfterOrNull(nonFragment, _Char___init__impl__6a9atx(63));
      var authority = substringBefore(nonQuery, _Char___init__impl__6a9atx(47));
      var path = substringAfterOrNull(nonQuery, _Char___init__impl__6a9atx(47));
      var hostWithPort = substringAfter(authority, _Char___init__impl__6a9atx(64));
      var userInfo = substringBeforeOrNull(authority, _Char___init__impl__6a9atx(64));
      var host = substringBefore(hostWithPort, _Char___init__impl__6a9atx(58));
      var port = substringAfterOrNull(hostWithPort, _Char___init__impl__6a9atx(58));
      var tmp2_opaque = !isHierarchical;
      // Inline function 'kotlin.takeIf' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      // Inline function 'korlibs.io.net.Companion.invoke.<anonymous>' call
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(host) > 0) {
        tmp_0 = host;
      } else {
        tmp_0 = null;
      }
      var tmp3_host = tmp_0;
      var tmp4_path = !(path == null) ? '/' + path : '';
      var tmp1_elvis_lhs = port == null ? null : toIntOrNull(port);
      var tmp5_port = tmp1_elvis_lhs == null ? this.h6g_1 : tmp1_elvis_lhs;
      tmp = this.n6h(scheme, subScheme, userInfo, tmp3_host, tmp4_path, query, fragment, tmp2_opaque, tmp5_port);
    } else {
      var nonFragment_0 = substringBefore(url, _Char___init__impl__6a9atx(35));
      var fragment_0 = substringAfterOrNull(url, _Char___init__impl__6a9atx(35));
      var path_0 = substringBefore(nonFragment_0, _Char___init__impl__6a9atx(63));
      var query_0 = substringAfterOrNull(nonFragment_0, _Char___init__impl__6a9atx(63));
      tmp = this.o6h(null, null, null, null, path_0, query_0, fragment_0, false);
    }
    return tmp;
  };
  protoOf(Companion_54).x6h = function (url) {
    return !((new StrReader(url)).u6h(this.i6g_1) == null);
  };
  protoOf(Companion_54).y6h = function (base, access) {
    var refinedAccess = (startsWith(access, '//') ? contains_0(base, ':') : false) ? substringBefore_0(base, ':') + ':' + access : access;
    if (this.x6h(refinedAccess))
      return refinedAccess;
    if (isBlank(base)) {
      throw new MalformedInputException('The base URL should not be empty, or the access URL must be absolute.');
    }
    if (!this.x6h(base)) {
      throw new MalformedInputException('At least one of the base URL or access URL must be absolute.');
    }
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(refinedAccess) === 0) {
      tmp = base;
    } else {
      if (startsWith(refinedAccess, '/')) {
        tmp = Companion_getInstance_69().r24(base).u6b(VOID, VOID, VOID, VOID, VOID, normalizeUrl(refinedAccess), null).v6b();
      } else {
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.io.net.Companion.resolve.<anonymous>' call
        var $this$run = Companion_getInstance_69().r24(base);
        var tmp_0;
        if (startsWith(refinedAccess, '?') ? true : startsWith(refinedAccess, '#')) {
          tmp_0 = $this$run.n6b_1 + refinedAccess;
        } else {
          tmp_0 = substringBeforeLast($this$run.n6b_1, _Char___init__impl__6a9atx(47)) + '/' + refinedAccess;
        }
        var refinedPath = tmp_0;
        tmp = $this$run.u6b(VOID, VOID, VOID, VOID, VOID, '/' + trimStart(normalizeUrl(refinedPath), charArrayOf([_Char___init__impl__6a9atx(47)])), null).v6b();
      }
    }
    return tmp;
  };
  protoOf(Companion_54).l6h = function (s, charset, formUrlEncoded) {
    var bos = ByteArrayBuilder_init_$Create$();
    var len = s.length;
    var n = 0;
    while (n < len) {
      var c = charSequenceGet(s, n);
      if (c === _Char___init__impl__6a9atx(37)) {
        // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
        var v = toByte(toInt(substr_0(s, n + 1 | 0, 2), 16));
        bos.s37(v);
        n = n + 2 | 0;
      } else if (c === _Char___init__impl__6a9atx(43))
        if (formUrlEncoded) {
          // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
          bos.s37(32);
        } else {
          // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
          bos.s37(43);
        }
       else {
        // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
        var v_0 = Char__toByte_impl_7s7yt0(c);
        bos.s37(v_0);
      }
      n = n + 1 | 0;
    }
    return toString_3(bos.t37(), charset);
  };
  var Companion_instance_62;
  function Companion_getInstance_69() {
    if (Companion_instance_62 == null)
      new Companion_54();
    return Companion_instance_62;
  }
  function URL$fullUrl$delegate$lambda(this$0) {
    return function () {
      return this$0.z6h().toString();
    };
  }
  function URL$fullUrlWithoutScheme$delegate$lambda(this$0) {
    return function () {
      return this$0.z6h(false).toString();
    };
  }
  function URL$pathWithQuery$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (!(this$0.o6b_1 == null)) {
        tmp = this$0.n6b_1 + '?' + this$0.o6b_1;
      } else {
        tmp = this$0.n6b_1;
      }
      return tmp;
    };
  }
  function URL_0(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) {
    Companion_getInstance_69();
    this.i6b_1 = isOpaque;
    this.j6b_1 = scheme;
    this.k6b_1 = subScheme;
    this.l6b_1 = userInfo;
    this.m6b_1 = host;
    this.n6b_1 = path;
    this.o6b_1 = query;
    this.p6b_1 = fragment;
    this.q6b_1 = defaultPort;
    var tmp = this;
    tmp.r6b_1 = lazy(URL$fullUrl$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.s6b_1 = lazy(URL$fullUrlWithoutScheme$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.t6b_1 = lazy(URL$pathWithQuery$delegate$lambda(this));
  }
  protoOf(URL_0).a6i = function () {
    return Companion_getInstance_69().m6h(this.j6b_1);
  };
  protoOf(URL_0).b6i = function () {
    return this.q6b_1 === Companion_getInstance_69().h6g_1 ? this.a6i() : this.q6b_1;
  };
  protoOf(URL_0).v6b = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r6b_1;
    fullUrl$factory();
    return this_0.m2();
  };
  protoOf(URL_0).c6i = function (includeScheme, out) {
    if (includeScheme ? !(this.j6b_1 == null) : false) {
      out.u5('' + this.j6b_1 + ':');
      if (!(this.k6b_1 == null)) {
        out.u5('' + this.k6b_1 + ':');
      }
      if (!this.i6b_1) {
        out.u5('//');
      }
    }
    if (!(this.l6b_1 == null)) {
      out.u5('' + this.l6b_1 + '@');
    }
    if (!(this.m6b_1 == null)) {
      out.u5(this.m6b_1);
    }
    if (!(this.b6i() === Companion_getInstance_69().h6g_1) ? !(this.b6i() === this.a6i()) : false) {
      out.v5(_Char___init__impl__6a9atx(58)).j8(this.b6i());
    }
    out.u5(this.n6b_1);
    if (!(this.o6b_1 == null)) {
      out.u5('?' + this.o6b_1);
    }
    if (!(this.p6b_1 == null)) {
      out.u5('#' + this.p6b_1);
    }
    return out;
  };
  protoOf(URL_0).z6h = function (includeScheme, out, $super) {
    includeScheme = includeScheme === VOID ? true : includeScheme;
    out = out === VOID ? StringBuilder_init_$Create$() : out;
    return $super === VOID ? this.c6i(includeScheme, out) : $super.c6i.call(this, includeScheme, out);
  };
  protoOf(URL_0).toString = function () {
    return this.v6b();
  };
  protoOf(URL_0).d6i = function (isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) {
    return new URL_0(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort);
  };
  protoOf(URL_0).u6b = function (isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort, $super) {
    isOpaque = isOpaque === VOID ? this.i6b_1 : isOpaque;
    scheme = scheme === VOID ? this.j6b_1 : scheme;
    subScheme = subScheme === VOID ? this.k6b_1 : subScheme;
    userInfo = userInfo === VOID ? this.l6b_1 : userInfo;
    host = host === VOID ? this.m6b_1 : host;
    path = path === VOID ? this.n6b_1 : path;
    query = query === VOID ? this.o6b_1 : query;
    fragment = fragment === VOID ? this.p6b_1 : fragment;
    defaultPort = defaultPort === VOID ? this.q6b_1 : defaultPort;
    return $super === VOID ? this.d6i(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) : $super.d6i.call(this, isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort);
  };
  protoOf(URL_0).hashCode = function () {
    var result = getBooleanHashCode(this.i6b_1);
    result = imul(result, 31) + (this.j6b_1 == null ? 0 : getStringHashCode(this.j6b_1)) | 0;
    result = imul(result, 31) + (this.k6b_1 == null ? 0 : getStringHashCode(this.k6b_1)) | 0;
    result = imul(result, 31) + (this.l6b_1 == null ? 0 : getStringHashCode(this.l6b_1)) | 0;
    result = imul(result, 31) + (this.m6b_1 == null ? 0 : getStringHashCode(this.m6b_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.n6b_1) | 0;
    result = imul(result, 31) + (this.o6b_1 == null ? 0 : getStringHashCode(this.o6b_1)) | 0;
    result = imul(result, 31) + (this.p6b_1 == null ? 0 : getStringHashCode(this.p6b_1)) | 0;
    result = imul(result, 31) + this.q6b_1 | 0;
    return result;
  };
  protoOf(URL_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof URL_0))
      return false;
    var tmp0_other_with_cast = other instanceof URL_0 ? other : THROW_CCE();
    if (!(this.i6b_1 === tmp0_other_with_cast.i6b_1))
      return false;
    if (!(this.j6b_1 == tmp0_other_with_cast.j6b_1))
      return false;
    if (!(this.k6b_1 == tmp0_other_with_cast.k6b_1))
      return false;
    if (!(this.l6b_1 == tmp0_other_with_cast.l6b_1))
      return false;
    if (!(this.m6b_1 == tmp0_other_with_cast.m6b_1))
      return false;
    if (!(this.n6b_1 === tmp0_other_with_cast.n6b_1))
      return false;
    if (!(this.o6b_1 == tmp0_other_with_cast.o6b_1))
      return false;
    if (!(this.p6b_1 == tmp0_other_with_cast.p6b_1))
      return false;
    if (!(this.q6b_1 === tmp0_other_with_cast.q6b_1))
      return false;
    return true;
  };
  function normalizeUrl(_this__u8e3s4) {
    // Inline function 'kotlin.text.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.firstOrNull' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
        var element = charSequenceGet(_this__u8e3s4, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.io.net.normalizeUrl.<anonymous>' call
        if (element === _Char___init__impl__6a9atx(63) ? true : element === _Char___init__impl__6a9atx(35)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
      tmp = _Char___init__impl__6a9atx(63);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var paramFlag = tmp;
    var pathParts = toMutableList(split_0(_this__u8e3s4, charArrayOf([paramFlag])));
    pathParts.o(0, normalize(get_pathInfo(pathParts.f1(0)), false));
    return joinToString(pathParts, toString_0(paramFlag));
  }
  function fullUrl$factory() {
    return getPropertyCallableRef('fullUrl', 1, KProperty1, function (receiver) {
      return receiver.v6b();
    }, null);
  }
  var Methods_ALL_instance;
  var Methods_OPTIONS_instance;
  var Methods_GET_instance;
  var Methods_HEAD_instance;
  var Methods_POST_instance;
  var Methods_PUT_instance;
  var Methods_DELETE_instance;
  var Methods_TRACE_instance;
  var Methods_CONNECT_instance;
  var Methods_PATCH_instance;
  var Methods_entriesInitialized;
  function Methods_initEntries() {
    if (Methods_entriesInitialized)
      return Unit_instance;
    Methods_entriesInitialized = true;
    Methods_ALL_instance = new Methods('ALL', 0);
    Methods_OPTIONS_instance = new Methods('OPTIONS', 1);
    Methods_GET_instance = new Methods('GET', 2);
    Methods_HEAD_instance = new Methods('HEAD', 3);
    Methods_POST_instance = new Methods('POST', 4);
    Methods_PUT_instance = new Methods('PUT', 5);
    Methods_DELETE_instance = new Methods('DELETE', 6);
    Methods_TRACE_instance = new Methods('TRACE', 7);
    Methods_CONNECT_instance = new Methods('CONNECT', 8);
    Methods_PATCH_instance = new Methods('PATCH', 9);
  }
  function Companion_55() {
    Companion_instance_63 = this;
    this.r6e_1 = Methods_OPTIONS_getInstance();
    this.s6e_1 = Methods_GET_getInstance();
    this.t6e_1 = Methods_HEAD_getInstance();
    this.u6e_1 = Methods_POST_getInstance();
    this.v6e_1 = Methods_PUT_getInstance();
    this.w6e_1 = Methods_DELETE_getInstance();
    this.x6e_1 = Methods_TRACE_getInstance();
    this.y6e_1 = Methods_CONNECT_getInstance();
    this.z6e_1 = Methods_PATCH_getInstance();
    this.a6f_1 = listOf([this.r6e_1, this.s6e_1, this.t6e_1, this.u6e_1, this.v6e_1, this.w6e_1, this.x6e_1, this.y6e_1, this.z6e_1]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.a6f_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.io.net.http.Companion.valuesMap.<anonymous>' call
      var tmp$ret$0 = to(item.ja_1, item);
      destination.r(tmp$ret$0);
    }
    tmp.b6f_1 = toMap(destination);
  }
  var Companion_instance_63;
  function Companion_getInstance_70() {
    if (Companion_instance_63 == null)
      new Companion_55();
    return Companion_instance_63;
  }
  function Companion_56() {
  }
  var Companion_instance_64;
  function Companion_getInstance_71() {
    return Companion_instance_64;
  }
  function Headers_init_$Init$(items, $this) {
    Headers.call($this, toList_1(items));
    return $this;
  }
  function Headers_init_$Create$(items) {
    return Headers_init_$Init$(items, objectCreate(protoOf(Headers)));
  }
  function Headers_init_$Init$_0(map, $this) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(map.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = map.k2().u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.io.net.http.Headers.<init>.<anonymous>' call
      var tmp$ret$1 = to(item.l2(), item.m2());
      destination.r(tmp$ret$1);
    }
    Headers.call($this, destination);
    return $this;
  }
  function Headers_init_$Create$_0(map) {
    return Headers_init_$Init$_0(map, objectCreate(protoOf(Headers)));
  }
  function Headers_init_$Init$_1(str, $this) {
    Headers.call($this, Companion_instance_65.e6i(str).g6g_1);
    return $this;
  }
  function Headers_init_$Create$_1(str) {
    return Headers_init_$Init$_1(str, objectCreate(protoOf(Headers)));
  }
  function Companion_57() {
    this.e6g_1 = 'Content-Length';
    this.f6g_1 = 'Content-Type';
  }
  protoOf(Companion_57).e6i = function (str) {
    if (str == null)
      return Headers_init_$Create$([]);
    // Inline function 'kotlin.collections.map' call
    var this_0 = split(str, ['\n']);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.io.net.http.Companion.parse.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$0 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
      var parts = split_0(tmp$ret$0, charArrayOf([_Char___init__impl__6a9atx(58)]), VOID, 2);
      var tmp;
      if (parts.n() >= 2) {
        // Inline function 'kotlin.text.trim' call
        var this_1 = parts.f1(0);
        var tmp_0 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        // Inline function 'kotlin.text.trim' call
        var this_2 = parts.f1(1);
        var tmp$ret$2 = toString(trim(isCharSequence(this_2) ? this_2 : THROW_CCE()));
        tmp = to(tmp_0, tmp$ret$2);
      } else {
        tmp = null;
      }
      var tmp$ret$3 = tmp;
      destination.r(tmp$ret$3);
    }
    return new Headers(filterNotNull(destination));
  };
  var Companion_instance_65;
  function Companion_getInstance_72() {
    return Companion_instance_65;
  }
  function sam$kotlin_Comparator$0_4(function_0) {
    this.f6i_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_4).aa = function (a, b) {
    return this.f6i_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_4).compare = function (a, b) {
    return this.aa(a, b);
  };
  function Http$Headers$toListGrouped$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = a.ag_1.toLowerCase();
    // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = b.ag_1.toLowerCase();
    return compareValues(tmp, tmp$ret$5);
  }
  function Methods(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function HttpException(statusCode, msg, statusText, headers) {
    msg = msg === VOID ? 'Error' + statusCode : msg;
    var tmp;
    if (statusText === VOID) {
      var tmp0_elvis_lhs = HttpStatusMessage_getInstance().g6i_1.s2(statusCode);
      tmp = tmp0_elvis_lhs == null ? 'Error' + statusCode : tmp0_elvis_lhs;
    } else {
      tmp = statusText;
    }
    statusText = tmp;
    headers = headers === VOID ? Headers_init_$Create$([]) : headers;
    IOException.call(this, '' + statusCode + ' ' + statusText + ' - ' + msg);
    captureStack(this, HttpException);
    this.h6i_1 = statusCode;
    this.i6i_1 = msg;
    this.j6i_1 = statusText;
    this.k6i_1 = headers;
  }
  function Headers(items) {
    this.g6g_1 = items;
  }
  protoOf(Headers).u = function () {
    return this.g6g_1.u();
  };
  protoOf(Headers).s13 = function (key) {
    return this.l6i(key);
  };
  protoOf(Headers).l6i = function (key) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.g6g_1.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.io.net.http.Headers.getFirst.<anonymous>' call
        if (equals_0(element.ag_1, key, true)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bg_1;
  };
  protoOf(Headers).m6i = function () {
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var this_0 = this.g6g_1;
    var destination = LinkedHashMap_init_$Create$();
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var key = element.ag_1.toLowerCase();
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.s2(key);
      var tmp;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList_init_$Create$();
        destination.i2(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.r(element);
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(destination.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = destination.k2().u();
    while (tmp0_iterator_0.v()) {
      var item = tmp0_iterator_0.x();
      // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
      var tmp_0 = first_0(item.m2()).ag_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = item.m2();
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_1 = this_1.u();
      while (tmp0_iterator_1.v()) {
        var item_0 = tmp0_iterator_1.x();
        // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>.<anonymous>' call
        var tmp$ret$8 = item_0.bg_1;
        destination_1.r(tmp$ret$8);
      }
      var tmp$ret$11 = to(tmp_0, destination_1);
      destination_0.r(tmp$ret$11);
    }
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = Http$Headers$toListGrouped$lambda;
    var tmp$ret$14 = new sam$kotlin_Comparator$0_4(tmp_1);
    return sortedWith(destination_0, tmp$ret$14);
  };
  protoOf(Headers).n6i = function (newHeaders) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(newHeaders, 10));
    var tmp0_iterator = newHeaders.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.io.net.http.Headers.withReplaceHeaders.<anonymous>' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = item.ag_1.toLowerCase();
      destination.r(tmp$ret$2);
    }
    var replaceKeys = toSet(destination);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.g6g_1;
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = this_0.u();
    while (tmp0_iterator_0.v()) {
      var element = tmp0_iterator_0.x();
      // Inline function 'korlibs.io.net.http.Headers.withReplaceHeaders.<anonymous>' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = element.ag_1.toLowerCase();
      if (!replaceKeys.z(tmp$ret$6)) {
        destination_0.r(element);
      }
    }
    return new Headers(plus(destination_0, toList(newHeaders)));
  };
  protoOf(Headers).o6i = function (newHeaders) {
    return this.n6i(toList_1(newHeaders));
  };
  protoOf(Headers).p6i = function (newHeaders) {
    return this.n6i(toList(newHeaders));
  };
  protoOf(Headers).toString = function () {
    return 'Headers(' + joinToString(this.m6i(), ', ') + ')';
  };
  protoOf(Headers).hashCode = function () {
    return hashCode(this.g6g_1);
  };
  protoOf(Headers).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Headers))
      return false;
    var tmp0_other_with_cast = other instanceof Headers ? other : THROW_CCE();
    if (!equals(this.g6g_1, tmp0_other_with_cast.g6g_1))
      return false;
    return true;
  };
  function Methods_OPTIONS_getInstance() {
    Methods_initEntries();
    return Methods_OPTIONS_instance;
  }
  function Methods_GET_getInstance() {
    Methods_initEntries();
    return Methods_GET_instance;
  }
  function Methods_HEAD_getInstance() {
    Methods_initEntries();
    return Methods_HEAD_instance;
  }
  function Methods_POST_getInstance() {
    Methods_initEntries();
    return Methods_POST_instance;
  }
  function Methods_PUT_getInstance() {
    Methods_initEntries();
    return Methods_PUT_instance;
  }
  function Methods_DELETE_getInstance() {
    Methods_initEntries();
    return Methods_DELETE_instance;
  }
  function Methods_TRACE_getInstance() {
    Methods_initEntries();
    return Methods_TRACE_instance;
  }
  function Methods_CONNECT_getInstance() {
    Methods_initEntries();
    return Methods_CONNECT_instance;
  }
  function Methods_PATCH_getInstance() {
    Methods_initEntries();
    return Methods_PATCH_instance;
  }
  function get__defaultHttpFactory() {
    _init_properties_HttpClient_kt__huy6s3();
    // Inline function 'kotlin.getValue' call
    var this_0 = _defaultHttpFactory$delegate;
    _defaultHttpFactory$factory();
    return this_0.m2();
  }
  var _defaultHttpFactory$delegate;
  function Companion_58() {
  }
  var Companion_instance_66;
  function Companion_getInstance_73() {
    return Companion_instance_66;
  }
  function HttpClient$Response$responseCharset$delegate$lambda() {
    return get_UTF8();
  }
  function $readAllBytesCOROUTINE$201(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y6i_1 = _this__u8e3s4;
  }
  protoOf($readAllBytesCOROUTINE$201).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = readAll(this.y6i_1.v6c_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var allContent = suspendResult;
            return allContent;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readAllStringCOROUTINE$202(_this__u8e3s4, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h6j_1 = _this__u8e3s4;
    this.i6j_1 = charset;
  }
  protoOf($readAllStringCOROUTINE$202).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.h6j_1.j6j(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var bytes = suspendResult;
            return toString_3(bytes, this.i6j_1);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $checkErrorsCOROUTINE$203(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s6j_1 = _this__u8e3s4;
  }
  protoOf($checkErrorsCOROUTINE$203).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            var tmp_0 = this;
            tmp_0.t6j_1 = this.s6j_1;
            var tmp_1 = this;
            tmp_1.u6j_1 = this.t6j_1;
            if (!this.u6j_1.w6c_1) {
              this.v6j_1 = this.u6j_1.r6c_1;
              this.fd_1 = 2;
              suspendResult = this.u6j_1.w6j(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 1;
              continue $sm;
            }

          case 1:
            return this.t6j_1;
          case 2:
            var ARGUMENT = suspendResult;
            throw new HttpException(this.v6j_1, ARGUMENT, this.u6j_1.s6c_1);
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function Companion_59() {
    Companion_instance_67 = this;
    this.x6j_1 = new RequestConfig();
  }
  var Companion_instance_67;
  function Companion_getInstance_74() {
    if (Companion_instance_67 == null)
      new Companion_59();
    return Companion_instance_67;
  }
  function Response(status, statusText, headers, rawContent, content) {
    this.r6c_1 = status;
    this.s6c_1 = statusText;
    this.t6c_1 = headers;
    this.u6c_1 = rawContent;
    this.v6c_1 = content;
    this.w6c_1 = this.r6c_1 < 400;
    var tmp = this;
    tmp.x6c_1 = lazy(HttpClient$Response$responseCharset$delegate$lambda);
  }
  protoOf(Response).j6j = function ($completion) {
    var tmp = new $readAllBytesCOROUTINE$201(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Response).y6j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x6c_1;
    responseCharset$factory();
    return this_0.m2();
  };
  protoOf(Response).z6j = function (charset, $completion) {
    var tmp = new $readAllStringCOROUTINE$202(this, charset, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Response).w6j = function (charset, $completion, $super) {
    charset = charset === VOID ? this.y6j() : charset;
    return $super === VOID ? this.z6j(charset, $completion) : $super.z6j.call(this, charset, $completion);
  };
  protoOf(Response).d6f = function ($completion) {
    var tmp = new $checkErrorsCOROUTINE$203(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Response).a6k = function (content) {
    return new CompletedResponse(this.r6c_1, this.s6c_1, this.t6c_1, content);
  };
  protoOf(Response).toString = function () {
    return 'Response(status=' + this.r6c_1 + ', statusText=' + this.s6c_1 + ', headers=' + this.t6c_1 + ', rawContent=' + this.u6c_1 + ', content=' + this.v6c_1 + ')';
  };
  protoOf(Response).hashCode = function () {
    var result = this.r6c_1;
    result = imul(result, 31) + getStringHashCode(this.s6c_1) | 0;
    result = imul(result, 31) + this.t6c_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.u6c_1) | 0;
    result = imul(result, 31) + hashCode(this.v6c_1) | 0;
    return result;
  };
  protoOf(Response).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Response))
      return false;
    var tmp0_other_with_cast = other instanceof Response ? other : THROW_CCE();
    if (!(this.r6c_1 === tmp0_other_with_cast.r6c_1))
      return false;
    if (!(this.s6c_1 === tmp0_other_with_cast.s6c_1))
      return false;
    if (!this.t6c_1.equals(tmp0_other_with_cast.t6c_1))
      return false;
    if (!equals(this.u6c_1, tmp0_other_with_cast.u6c_1))
      return false;
    if (!equals(this.v6c_1, tmp0_other_with_cast.v6c_1))
      return false;
    return true;
  };
  function CompletedResponse(status, statusText, headers, content) {
    this.b6k_1 = status;
    this.c6k_1 = statusText;
    this.d6k_1 = headers;
    this.e6k_1 = content;
    this.f6k_1 = this.b6k_1 < 400;
  }
  protoOf(CompletedResponse).toString = function () {
    return 'CompletedResponse(status=' + this.b6k_1 + ', statusText=' + this.c6k_1 + ', headers=' + this.d6k_1 + ', content=' + this.e6k_1 + ')';
  };
  protoOf(CompletedResponse).hashCode = function () {
    var result = this.b6k_1;
    result = imul(result, 31) + getStringHashCode(this.c6k_1) | 0;
    result = imul(result, 31) + this.d6k_1.hashCode() | 0;
    result = imul(result, 31) + (this.e6k_1 == null ? 0 : hashCode(this.e6k_1)) | 0;
    return result;
  };
  protoOf(CompletedResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedResponse))
      return false;
    var tmp0_other_with_cast = other instanceof CompletedResponse ? other : THROW_CCE();
    if (!(this.b6k_1 === tmp0_other_with_cast.b6k_1))
      return false;
    if (!(this.c6k_1 === tmp0_other_with_cast.c6k_1))
      return false;
    if (!this.d6k_1.equals(tmp0_other_with_cast.d6k_1))
      return false;
    if (!equals(this.e6k_1, tmp0_other_with_cast.e6k_1))
      return false;
    return true;
  };
  function RequestConfig(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    Companion_getInstance_74();
    followRedirects = followRedirects === VOID ? true : followRedirects;
    throwErrors = throwErrors === VOID ? false : throwErrors;
    maxRedirects = maxRedirects === VOID ? 10 : maxRedirects;
    referer = referer === VOID ? null : referer;
    simulateBrowser = simulateBrowser === VOID ? false : simulateBrowser;
    this.g6k_1 = followRedirects;
    this.h6k_1 = throwErrors;
    this.i6k_1 = maxRedirects;
    this.j6k_1 = referer;
    this.k6k_1 = simulateBrowser;
  }
  protoOf(RequestConfig).l6k = function (followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    return new RequestConfig(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  };
  protoOf(RequestConfig).m6k = function (followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $super) {
    followRedirects = followRedirects === VOID ? this.g6k_1 : followRedirects;
    throwErrors = throwErrors === VOID ? this.h6k_1 : throwErrors;
    maxRedirects = maxRedirects === VOID ? this.i6k_1 : maxRedirects;
    referer = referer === VOID ? this.j6k_1 : referer;
    simulateBrowser = simulateBrowser === VOID ? this.k6k_1 : simulateBrowser;
    return $super === VOID ? this.l6k(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) : $super.l6k.call(this, followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  };
  protoOf(RequestConfig).toString = function () {
    return 'RequestConfig(followRedirects=' + this.g6k_1 + ', throwErrors=' + this.h6k_1 + ', maxRedirects=' + this.i6k_1 + ', referer=' + this.j6k_1 + ', simulateBrowser=' + this.k6k_1 + ')';
  };
  protoOf(RequestConfig).hashCode = function () {
    var result = getBooleanHashCode(this.g6k_1);
    result = imul(result, 31) + getBooleanHashCode(this.h6k_1) | 0;
    result = imul(result, 31) + this.i6k_1 | 0;
    result = imul(result, 31) + (this.j6k_1 == null ? 0 : getStringHashCode(this.j6k_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k6k_1) | 0;
    return result;
  };
  protoOf(RequestConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestConfig))
      return false;
    var tmp0_other_with_cast = other instanceof RequestConfig ? other : THROW_CCE();
    if (!(this.g6k_1 === tmp0_other_with_cast.g6k_1))
      return false;
    if (!(this.h6k_1 === tmp0_other_with_cast.h6k_1))
      return false;
    if (!(this.i6k_1 === tmp0_other_with_cast.i6k_1))
      return false;
    if (!(this.j6k_1 == tmp0_other_with_cast.j6k_1))
      return false;
    if (!(this.k6k_1 === tmp0_other_with_cast.k6k_1))
      return false;
    return true;
  };
  function mergeUrls($this, base, append) {
    return Companion_getInstance_69().y6h(base, append);
  }
  function Companion_60() {
    this.n6k_1 = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.81 Safari/537.36';
    this.o6k_1 = 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8';
    this.p6k_1 = 'en-us';
    this.q6k_1 = 'gzip, deflate';
    this.r6k_1 = 'Close';
  }
  protoOf(Companion_60).s6k = function (headers, host) {
    var out = Headers_init_$Create$([to('User-Agent', this.n6k_1), to('Accept', this.o6k_1), to('Accept-Language', this.p6k_1), to('Accept-Encoding', this.q6k_1), to('Connection', this.r6k_1)]).p6i(headers);
    return !(host == null) ? out.o6i([to('Host', host)]) : out;
  };
  var Companion_instance_68;
  function Companion_getInstance_75() {
    return Companion_instance_68;
  }
  function $requestCOROUTINE$206(_this__u8e3s4, method, url, headers, content, config, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.b6l_1 = _this__u8e3s4;
    this.c6l_1 = method;
    this.d6l_1 = url;
    this.e6l_1 = headers;
    this.f6l_1 = content;
    this.g6l_1 = config;
  }
  protoOf($requestCOROUTINE$206).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 9;
            this.h6l_1 = this.f6l_1;
            if (this.h6l_1 == null) {
              this.i6l_1 = null;
              this.fd_1 = 2;
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = this.h6l_1.m5w(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.i6l_1 = suspendResult;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.j6l_1 = this.i6l_1;
            this.k6l_1 = this.j6l_1 == null ? new Long(0, 0) : this.j6l_1;
            this.l6l_1 = this.e6l_1;
            var tmp_0;
            if (!(this.f6l_1 == null)) {
              var tmp$ret$0;
              l$ret$1: do {
                var this_0 = this.e6l_1;
                var tmp_1;
                if (isInterface(this_0, Collection)) {
                  tmp_1 = this_0.b1();
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp$ret$0 = false;
                  break l$ret$1;
                }
                var tmp0_iterator = this_0.u();
                while (tmp0_iterator.v()) {
                  var element = tmp0_iterator.x();
                  if (equals_0(element.ag_1, Companion_instance_65.e6g_1, true)) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = false;
              }
               while (false);
              tmp_0 = !tmp$ret$0;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this.l6l_1 = this.l6l_1.o6i([to(Companion_instance_65.e6g_1, this.k6l_1.toString())]);
            }

            if (this.g6l_1.k6k_1) {
              this.l6l_1 = Companion_instance_68.s6k(this.l6l_1, null);
            }

            this.fd_1 = 3;
            suspendResult = this.b6l_1.q6l(this.c6l_1, this.d6l_1, this.l6l_1, this.f6l_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.m6l_1 = suspendResult;
            var tmp_2 = this;
            tmp_2.n6l_1 = this.m6l_1;
            if (this.g6l_1.h6k_1) {
              this.fd_1 = 4;
              suspendResult = this.n6l_1.d6f(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 5;
              continue $sm;
            }

          case 4:
            this.fd_1 = 5;
            continue $sm;
          case 5:
            this.o6l_1 = this.m6l_1;
            if (this.g6l_1.g6k_1 ? this.g6l_1.i6k_1 >= 0 : false) {
              this.p6l_1 = this.o6l_1.t6c_1.s13('location');
              if (!(this.p6l_1 == null)) {
                this.fd_1 = 8;
                suspendResult = this.b6l_1.r6l(this.c6l_1, mergeUrls(this.b6l_1, this.d6l_1, this.p6l_1), this.e6l_1.o6i([to('Referer', this.d6l_1)]), this.f6l_1, this.g6l_1.m6k(VOID, VOID, this.g6l_1.i6k_1 - 1 | 0), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.fd_1 = 6;
                continue $sm;
              }
            } else {
              this.fd_1 = 7;
              continue $sm;
            }

          case 6:
            this.fd_1 = 7;
            continue $sm;
          case 7:
            return this.o6l_1;
          case 8:
            return suspendResult;
          case 9:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 9) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $requestAsBytesCOROUTINE$208(_this__u8e3s4, method, url, headers, content, config, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a6m_1 = _this__u8e3s4;
    this.b6m_1 = method;
    this.c6m_1 = url;
    this.d6m_1 = headers;
    this.e6m_1 = content;
    this.f6m_1 = config;
  }
  protoOf($requestAsBytesCOROUTINE$208).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = this.a6m_1.r6l(this.b6m_1, this.c6m_1, this.d6m_1, this.e6m_1, this.f6m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g6m_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = this.g6m_1.j6j(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this.g6m_1.a6k(ARGUMENT);
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readBytesCOROUTINE$209(_this__u8e3s4, url, config, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.p6m_1 = _this__u8e3s4;
    this.q6m_1 = url;
    this.r6m_1 = config;
  }
  protoOf($readBytesCOROUTINE$209).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.p6m_1.s6m(Companion_getInstance_70().s6e_1, this.q6m_1, VOID, VOID, this.r6m_1.m6k(VOID, true), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.e6k_1;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function HttpClient() {
    this.p6e_1 = false;
  }
  protoOf(HttpClient).r6l = function (method, url, headers, content, config, $completion) {
    var tmp = new $requestCOROUTINE$206(this, method, url, headers, content, config, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(HttpClient).c6f = function (method, url, headers, content, config, $completion, $super) {
    headers = headers === VOID ? Headers_init_$Create$([]) : headers;
    content = content === VOID ? null : content;
    config = config === VOID ? Companion_getInstance_74().x6j_1 : config;
    return $super === VOID ? this.r6l(method, url, headers, content, config, $completion) : $super.r6l.call(this, method, url, headers, content, config, $completion);
  };
  protoOf(HttpClient).t6m = function (method, url, headers, content, config, $completion) {
    var tmp = new $requestAsBytesCOROUTINE$208(this, method, url, headers, content, config, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(HttpClient).s6m = function (method, url, headers, content, config, $completion, $super) {
    headers = headers === VOID ? Headers_init_$Create$([]) : headers;
    content = content === VOID ? null : content;
    config = config === VOID ? new RequestConfig() : config;
    return $super === VOID ? this.t6m(method, url, headers, content, config, $completion) : $super.t6m.call(this, method, url, headers, content, config, $completion);
  };
  protoOf(HttpClient).u6m = function (url, config, $completion) {
    var tmp = new $readBytesCOROUTINE$209(this, url, config, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(HttpClient).q6e = function (url, config, $completion, $super) {
    config = config === VOID ? new RequestConfig() : config;
    return $super === VOID ? this.u6m(url, config, $completion) : $super.u6m.call(this, url, config, $completion);
  };
  function createHttpClient() {
    _init_properties_HttpClient_kt__huy6s3();
    return get_defaultHttpFactory().v6m();
  }
  function HttpStatusMessage() {
    HttpStatusMessage_instance = this;
    this.g6i_1 = linkedMapOf([to(100, 'Continue'), to(101, 'Switching Protocols'), to(200, 'OK'), to(201, 'Created'), to(202, 'Accepted'), to(203, 'Non-Authoritative Information'), to(204, 'No Content'), to(205, 'Reset Content'), to(206, 'Partial Content'), to(300, 'Multiple Choices'), to(301, 'Moved Permanently'), to(302, 'Found'), to(303, 'See Other'), to(304, 'Not Modified'), to(305, 'Use Proxy'), to(307, 'Temporary Redirect'), to(400, 'Bad Request'), to(401, 'Unauthorized'), to(402, 'Payment Required'), to(403, 'Forbidden'), to(404, 'Not Found'), to(405, 'Method Not Allowed'), to(406, 'Not Acceptable'), to(407, 'Proxy Authentication Required'), to(408, 'Request Timeout'), to(409, 'Conflict'), to(410, 'Gone'), to(411, 'Length Required'), to(412, 'Precondition Failed'), to(413, 'Request Entity Too Large'), to(414, 'Request-URI Too Long'), to(415, 'Unsupported Media Type'), to(416, 'Requested Range Not Satisfiable'), to(417, 'Expectation Failed'), to(418, "I'm a teapot"), to(422, 'Unprocessable Entity (WebDAV - RFC 4918)'), to(423, 'Locked (WebDAV - RFC 4918)'), to(424, 'Failed Dependency (WebDAV) (RFC 4918)'), to(425, 'Unassigned'), to(426, 'Upgrade Required (RFC 7231)'), to(428, 'Precondition Required'), to(429, 'Too Many Requests'), to(431, 'Request Header Fileds Too Large)'), to(449, 'Error449'), to(451, 'Unavailable for Legal Reasons'), to(500, 'Internal Server Error'), to(501, 'Not Implemented'), to(502, 'Bad Gateway'), to(503, 'Service Unavailable'), to(504, 'Gateway Timeout'), to(505, 'HTTP Version Not Supported'), to(506, 'Variant Also Negotiates (RFC 2295)'), to(507, 'Insufficient Storage (WebDAV - RFC 4918)'), to(508, 'Loop Detected (WebDAV)'), to(509, 'Bandwidth Limit Exceeded'), to(510, 'Not Extended (RFC 2774)'), to(511, 'Network Authentication Required')]);
  }
  var HttpStatusMessage_instance;
  function HttpStatusMessage_getInstance() {
    if (HttpStatusMessage_instance == null)
      new HttpStatusMessage();
    return HttpStatusMessage_instance;
  }
  function ProxiedHttpFactory(parent) {
    this.w6m_1 = parent;
    this.x6m_1 = parent;
  }
  protoOf(ProxiedHttpFactory).v6m = function () {
    return this.x6m_1.v6m();
  };
  function get_defaultHttpFactory() {
    _init_properties_HttpClient_kt__huy6s3();
    return get__defaultHttpFactory();
  }
  function _defaultHttpFactory$delegate$lambda() {
    _init_properties_HttpClient_kt__huy6s3();
    return new ProxiedHttpFactory(get_httpFactory());
  }
  function _defaultHttpFactory$factory() {
    return getPropertyCallableRef('_defaultHttpFactory', 0, KProperty0, function () {
      return get__defaultHttpFactory();
    }, null);
  }
  function responseCharset$factory() {
    return getPropertyCallableRef('responseCharset', 1, KProperty1, function (receiver) {
      return receiver.y6j();
    }, null);
  }
  var properties_initialized_HttpClient_kt_t7kzvv;
  function _init_properties_HttpClient_kt__huy6s3() {
    if (!properties_initialized_HttpClient_kt_t7kzvv) {
      properties_initialized_HttpClient_kt_t7kzvv = true;
      _defaultHttpFactory$delegate = lazy(_defaultHttpFactory$delegate$lambda);
    }
  }
  function Fixed(value) {
    this.y6m_1 = value;
  }
  protoOf(Fixed).t3v = function () {
    return this.y6m_1;
  };
  protoOf(Fixed).toString = function () {
    return 'Fixed(value=' + this.y6m_1 + ')';
  };
  protoOf(Fixed).hashCode = function () {
    return hashCode(this.y6m_1);
  };
  protoOf(Fixed).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Fixed))
      return false;
    var tmp0_other_with_cast = other instanceof Fixed ? other : THROW_CCE();
    if (!equals(this.y6m_1, tmp0_other_with_cast.y6m_1))
      return false;
    return true;
  };
  function Resourceable(value) {
    return new Fixed(value);
  }
  function Resources(coroutineContext, root, parent) {
    root = root === VOID ? get_resourcesVfs() : root;
    parent = parent === VOID ? null : parent;
    this.z6m_1 = coroutineContext;
    this.a6n_1 = root;
    this.b6n_1 = parent;
    this.c6n_1 = LinkedHashMap_init_$Create$();
  }
  var EMPTY_BYTE_ARRAY;
  function readInternal($this, buffer, offset, len, $completion) {
    var tmp = new $readInternalCOROUTINE$232($this, buffer, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function writeInternal($this, buffer, offset, len, $completion) {
    var tmp = new $writeInternalCOROUTINE$233($this, buffer, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function AsyncStream$read$slambda(this$0, $buffer, $offset, $len, resultContinuation) {
    this.j6o_1 = this$0;
    this.k6o_1 = $buffer;
    this.l6o_1 = $offset;
    this.m6o_1 = $len;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncStream$read$slambda).n6o = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(AsyncStream$read$slambda).be = function ($completion) {
    return this.n6o($completion);
  };
  protoOf(AsyncStream$read$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = readInternal(this.j6o_1, this.k6o_1, this.l6o_1, this.m6o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncStream$read$slambda).g5a = function (completion) {
    return new AsyncStream$read$slambda(this.j6o_1, this.k6o_1, this.l6o_1, this.m6o_1, completion);
  };
  function AsyncStream$read$slambda_0(this$0, $buffer, $offset, $len, resultContinuation) {
    var i = new AsyncStream$read$slambda(this$0, $buffer, $offset, $len, resultContinuation);
    var l = function ($completion) {
      return i.n6o($completion);
    };
    l.$arity = 0;
    return l;
  }
  function AsyncStream$write$slambda(this$0, $buffer, $offset, $len, resultContinuation) {
    this.w6o_1 = this$0;
    this.x6o_1 = $buffer;
    this.y6o_1 = $offset;
    this.z6o_1 = $len;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncStream$write$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(AsyncStream$write$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(AsyncStream$write$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = writeInternal(this.w6o_1, this.x6o_1, this.y6o_1, this.z6o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncStream$write$slambda).g5a = function (completion) {
    return new AsyncStream$write$slambda(this.w6o_1, this.x6o_1, this.y6o_1, this.z6o_1, completion);
  };
  function AsyncStream$write$slambda_0(this$0, $buffer, $offset, $len, resultContinuation) {
    var i = new AsyncStream$write$slambda(this$0, $buffer, $offset, $len, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $readCOROUTINE$230(_this__u8e3s4, buffer, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i6p_1 = _this__u8e3s4;
    this.j6p_1 = buffer;
    this.k6p_1 = offset;
    this.l6p_1 = len;
  }
  protoOf($readCOROUTINE$230).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            if (this.i6p_1.s4z_1) {
              this.fd_1 = 2;
              suspendResult = this.i6p_1.u4z_1.v5m(AsyncStream$read$slambda_0(this.i6p_1, this.j6p_1, this.k6p_1, this.l6p_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = readInternal(this.i6p_1, this.j6p_1, this.k6p_1, this.l6p_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.m6p_1 = suspendResult;
            this.fd_1 = 3;
            continue $sm;
          case 2:
            this.m6p_1 = suspendResult;
            this.fd_1 = 3;
            continue $sm;
          case 3:
            return this.m6p_1;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $writeCOROUTINE$231(_this__u8e3s4, buffer, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v6p_1 = _this__u8e3s4;
    this.w6p_1 = buffer;
    this.x6p_1 = offset;
    this.y6p_1 = len;
  }
  protoOf($writeCOROUTINE$231).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            if (this.v6p_1.s4z_1) {
              this.fd_1 = 2;
              suspendResult = this.v6p_1.v4z_1.v5m(AsyncStream$write$slambda_0(this.v6p_1, this.w6p_1, this.x6p_1, this.y6p_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = writeInternal(this.v6p_1, this.w6p_1, this.x6p_1, this.y6p_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.fd_1 = 3;
            continue $sm;
          case 2:
            this.fd_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readInternalCOROUTINE$232(_this__u8e3s4, buffer, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l6n_1 = _this__u8e3s4;
    this.m6n_1 = buffer;
    this.n6n_1 = offset;
    this.o6n_1 = len;
  }
  protoOf($readInternalCOROUTINE$232).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.l6n_1.q4z_1.k67(this.l6n_1.r4z_1, this.m6n_1, this.n6n_1, this.o6n_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var read = suspendResult;
            if (read >= 0) {
              var tmp0_this = this.l6n_1;
              var tmp_0 = tmp0_this;
              tmp_0.r4z_1 = tmp0_this.r4z_1.mc(toLong(read));
            }

            return read;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $writeInternalCOROUTINE$233(_this__u8e3s4, buffer, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x6n_1 = _this__u8e3s4;
    this.y6n_1 = buffer;
    this.z6n_1 = offset;
    this.a6o_1 = len;
  }
  protoOf($writeInternalCOROUTINE$233).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.x6n_1.q4z_1.l67(this.x6n_1.r4z_1, this.y6n_1, this.z6n_1, this.a6o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_this = this.x6n_1;
            var tmp_0 = tmp0_this;
            var this_0 = tmp0_this.r4z_1;
            var other = this.a6o_1;
            tmp_0.r4z_1 = this_0.mc(toLong(other));
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $getAvailableCOROUTINE$234(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h6q_1 = _this__u8e3s4;
  }
  protoOf($getAvailableCOROUTINE$234).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = this.h6q_1.m5w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.i6q_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = this.h6q_1.y5y(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this.i6q_1.cb(ARGUMENT);
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function AsyncStream(base, position, queue) {
    position = position === VOID ? new Long(0, 0) : position;
    queue = queue === VOID ? false : queue;
    this.q4z_1 = base;
    this.r4z_1 = position;
    this.s4z_1 = queue;
    this.t4z_1 = new Mixin();
    this.u4z_1 = new AsyncThread();
    this.v4z_1 = new AsyncThread();
  }
  protoOf(AsyncStream).h23 = function (_set____db54di) {
    this.t4z_1.h23(_set____db54di);
  };
  protoOf(AsyncStream).i23 = function () {
    return this.t4z_1.i23();
  };
  protoOf(AsyncStream).toString = function () {
    return 'AsyncStream(' + this.q4z_1 + ', position=' + this.r4z_1.toString() + ')';
  };
  protoOf(AsyncStream).y5w = function (buffer, offset, len, $completion) {
    var tmp = new $readCOROUTINE$230(this, buffer, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(AsyncStream).v5t = function (buffer, offset, len, $completion) {
    var tmp = new $writeCOROUTINE$231(this, buffer, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(AsyncStream).y5y = function ($completion) {
    return this.r4z_1;
  };
  protoOf(AsyncStream).m5w = function ($completion) {
    return this.q4z_1.m5w($completion);
  };
  protoOf(AsyncStream).j6q = function ($completion) {
    return this.l5w($completion);
  };
  protoOf(AsyncStream).k6q = function ($completion) {
    var tmp = new $getAvailableCOROUTINE$234(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(AsyncStream).x5u = function ($completion) {
    return this.q4z_1.x5u($completion);
  };
  function readBytesUpTo(_this__u8e3s4, len, $completion) {
    var tmp = new $readBytesUpToCOROUTINE$237(_this__u8e3s4, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readS32LE(_this__u8e3s4, $completion) {
    var tmp = new $readS32LECOROUTINE$241(_this__u8e3s4, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readString(_this__u8e3s4, len, charset, $completion) {
    charset = charset === VOID ? get_UTF8() : charset;
    var tmp = new $readStringCOROUTINE$243(_this__u8e3s4, len, charset, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readAll(_this__u8e3s4, $completion) {
    var tmp = new $readAllCOROUTINE$246(_this__u8e3s4, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function toAsyncInputStream(_this__u8e3s4) {
    _init_properties_AsyncStream_kt__y7xune();
    return new toAsyncInputStream$1(_this__u8e3s4);
  }
  function toAsyncOutputStream(_this__u8e3s4) {
    _init_properties_AsyncStream_kt__y7xune();
    return new toAsyncOutputStream$1(_this__u8e3s4);
  }
  function $hasLengthCOROUTINE$248(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k6t_1 = _this__u8e3s4;
  }
  protoOf($hasLengthCOROUTINE$248).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.k6t_1.m5w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.l6t_1 = ARGUMENT.t6(new Long(0, 0)) >= 0;
            this.gd_1 = 3;
            this.fd_1 = 4;
            continue $sm;
          case 2:
            this.gd_1 = 3;
            var tmp_0 = this.id_1;
            if (tmp_0 instanceof UnsupportedOperationException) {
              var t = this.id_1;
              var tmp_1 = this;
              tmp_1.l6t_1 = false;
              this.fd_1 = 4;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 3:
            throw this.id_1;
          case 4:
            this.gd_1 = 3;
            return this.l6t_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function AsyncGetLengthStream() {
  }
  function buffered(_this__u8e3s4, blockSize, blocksToRead) {
    blockSize = blockSize === VOID ? 2048 : blockSize;
    blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
    _init_properties_AsyncStream_kt__y7xune();
    return toAsyncStream(new BufferedStreamBase(_this__u8e3s4.q4z_1, blockSize, blocksToRead), _this__u8e3s4.r4z_1);
  }
  function toAsyncStream(_this__u8e3s4, position) {
    position = position === VOID ? new Long(0, 0) : position;
    _init_properties_AsyncStream_kt__y7xune();
    return new AsyncStream(_this__u8e3s4, position);
  }
  function AsyncStreamBase() {
  }
  protoOf(AsyncStreamBase).k67 = function (position, buffer, offset, len, $completion) {
    throw UnsupportedOperationException_init_$Create$_0();
  };
  protoOf(AsyncStreamBase).l67 = function (position, buffer, offset, len, $completion) {
    throw UnsupportedOperationException_init_$Create$_0();
  };
  protoOf(AsyncStreamBase).m5w = function ($completion) {
    throw UnsupportedOperationException_init_$Create$_0();
  };
  protoOf(AsyncStreamBase).x5u = function ($completion) {
    return Unit_instance;
  };
  function readBytesExact(_this__u8e3s4, len, $completion) {
    var tmp = new $readBytesExactCOROUTINE$251(_this__u8e3s4, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readU16BE(_this__u8e3s4, $completion) {
    var tmp = new $readU16BECOROUTINE$252(_this__u8e3s4, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readS32BE(_this__u8e3s4, $completion) {
    var tmp = new $readS32BECOROUTINE$253(_this__u8e3s4, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function AsyncPositionLengthStream() {
  }
  function readBytesUpToCopy(_this__u8e3s4, out, $completion) {
    var tmp = new $readBytesUpToCopyCOROUTINE$254(_this__u8e3s4, out, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function getAvailable(_this__u8e3s4, $completion) {
    var tmp = new $getAvailableCOROUTINE$255(_this__u8e3s4, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function AsyncGetPositionStream() {
  }
  function MemoryAsyncStreamBase_init_$Init$(initialCapacity, $this) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    MemoryAsyncStreamBase.call($this, ByteArrayBuilder_init_$Create$(initialCapacity));
    return $this;
  }
  function MemoryAsyncStreamBase_init_$Create$(initialCapacity) {
    return MemoryAsyncStreamBase_init_$Init$(initialCapacity, objectCreate(protoOf(MemoryAsyncStreamBase)));
  }
  function MemoryAsyncStreamBase(data) {
    AsyncStreamBase.call(this);
    this.y6v_1 = data;
  }
  protoOf(MemoryAsyncStreamBase).z6v = function () {
    return this.y6v_1.n();
  };
  protoOf(MemoryAsyncStreamBase).m5w = function ($completion) {
    return toLong(this.z6v());
  };
  protoOf(MemoryAsyncStreamBase).a6w = function (position) {
    if (position.t6(new Long(0, 0)) < 0) {
      invalidOp('Invalid position ' + position.toString());
    }
  };
  protoOf(MemoryAsyncStreamBase).k67 = function (position, buffer, offset, len, $completion) {
    this.a6w(position);
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.z6v());
    if (!contains_2(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    // Inline function 'kotlin.math.min' call
    var a = toLong(this.z6v());
    // Inline function 'kotlin.Long.plus' call
    var b = position.mc(toLong(len));
    var end = a.t6(b) <= 0 ? a : b;
    // Inline function 'kotlin.math.max' call
    var a_0 = end.cb(position).kb();
    var actualLen = Math.max(a_0, 0);
    arraycopy_0(this.y6v_1.n37_1, position.kb(), buffer, offset, actualLen);
    return actualLen;
  };
  protoOf(MemoryAsyncStreamBase).l67 = function (position, buffer, offset, len, $completion) {
    this.a6w(position);
    var tmp = this.y6v_1;
    // Inline function 'kotlin.math.max' call
    var a = this.y6v_1.n();
    // Inline function 'kotlin.Long.plus' call
    var b = position.mc(toLong(len)).kb();
    var tmp$ret$1 = Math.max(a, b);
    tmp.r1r(tmp$ret$1);
    arraycopy_0(buffer, offset, this.y6v_1.n37_1, position.kb(), len);
    return Unit_instance;
  };
  protoOf(MemoryAsyncStreamBase).x5u = function ($completion) {
    return Unit_instance;
  };
  protoOf(MemoryAsyncStreamBase).toString = function () {
    return 'MemoryAsyncStreamBase(' + this.y6v_1.n() + ')';
  };
  function $_readCOROUTINE$260(_this__u8e3s4, position, buffer, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j6w_1 = _this__u8e3s4;
    this.k6w_1 = position;
    this.l6w_1 = buffer;
    this.m6w_1 = offset;
    this.n6w_1 = len;
  }
  protoOf($_readCOROUTINE$260).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 7;
            this.fd_1 = 1;
            suspendResult = this.j6w_1.r6w_1.l5w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              this.fd_1 = 2;
              suspendResult = this.j6w_1.r6w_1.m5w(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.o6w_1 = false;
              this.fd_1 = 3;
              continue $sm;
            }

          case 2:
            this.p6w_1 = suspendResult;
            this.o6w_1 = this.k6w_1.t6(this.p6w_1) >= 0;
            this.fd_1 = 3;
            continue $sm;
          case 3:
            if (this.o6w_1) {
              return -1;
            } else {
              this.fd_1 = 4;
              continue $sm;
            }

          case 4:
            var tmp_0 = this;
            var this_0 = this.k6w_1;
            var other = this.j6w_1.u6w_1;
            tmp_0.q6w_1 = this_0.ma(toLong(other));
            if (!this.j6w_1.w6w_1.equals(this.q6w_1)) {
              this.fd_1 = 5;
              var this_1 = this.q6w_1;
              var other_0 = this.j6w_1.u6w_1;
              suspendResult = readBytes(this.j6w_1.r6w_1, this_1.na(toLong(other_0)), this.j6w_1.u6w_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 6;
              continue $sm;
            }

          case 5:
            var ARGUMENT = suspendResult;
            this.j6w_1.v6w_1 = ARGUMENT;
            this.j6w_1.w6w_1 = this.q6w_1;
            this.fd_1 = 6;
            continue $sm;
          case 6:
            var this_2 = this.k6w_1;
            var other_1 = this.j6w_1.u6w_1;
            var soffset = this_2.nc(toLong(other_1)).kb();
            var available = this.j6w_1.v6w_1.length - soffset | 0;
            var b = this.n6w_1;
            var toRead = Math.min(available, b);
            arraycopy_0(this.j6w_1.v6w_1, soffset, this.l6w_1, this.m6w_1, toRead);
            return toRead;
          case 7:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 7) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function BufferedStreamBase(base, blockSize, blocksToRead) {
    blockSize = blockSize === VOID ? 2048 : blockSize;
    blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
    AsyncStreamBase.call(this);
    this.r6w_1 = base;
    this.s6w_1 = blockSize;
    this.t6w_1 = blocksToRead;
    this.u6w_1 = imul(this.s6w_1, this.t6w_1);
    var tmp = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.v6w_1 = new Int8Array([]);
    this.w6w_1 = new Long(-1, -1);
  }
  protoOf(BufferedStreamBase).k67 = function (position, buffer, offset, len, $completion) {
    return this.x6w(position, buffer, offset, len, $completion);
  };
  protoOf(BufferedStreamBase).x6w = function (position, buffer, offset, len, $completion) {
    var tmp = new $_readCOROUTINE$260(this, position, buffer, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(BufferedStreamBase).l67 = function (position, buffer, offset, len, $completion) {
    return this.r6w_1.l67(position, buffer, offset, len, $completion);
  };
  protoOf(BufferedStreamBase).m5w = function ($completion) {
    return this.r6w_1.m5w($completion);
  };
  protoOf(BufferedStreamBase).x5u = function ($completion) {
    return this.r6w_1.x5u($completion);
  };
  function readExact(_this__u8e3s4, buffer, offset, len, $completion) {
    var tmp = new $readExactCOROUTINE$261(_this__u8e3s4, buffer, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function sliceWithBounds(_this__u8e3s4, start, end, closeParent, $completion) {
    closeParent = closeParent === VOID ? false : closeParent;
    var tmp = new $sliceWithBoundsCOROUTINE$262(_this__u8e3s4, start, end, closeParent, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readBytesUpTo_0(_this__u8e3s4, out, offset, len, $completion) {
    var tmp = new $readBytesUpToCOROUTINE$263(_this__u8e3s4, out, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function sliceWithSize_0(_this__u8e3s4, start, length, closeParent, $completion) {
    closeParent = closeParent === VOID ? false : closeParent;
    return sliceWithBounds(_this__u8e3s4, start, start.mc(length), closeParent, $completion);
  }
  function readBytes(_this__u8e3s4, position, count, $completion) {
    var tmp = new $readBytesCOROUTINE$264(_this__u8e3s4, position, count, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function clampPosition($this, position) {
    return clamp_2(position, $this.c6z_1, $this.d6z_1);
  }
  function clampPositionLen($this, position, len) {
    if (position.t6(new Long(0, 0)) < 0)
      throw IllegalArgumentException_init_$Create$('Invalid position');
    var targetStartPosition = clampPosition($this, $this.c6z_1.mc(position));
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = targetStartPosition.mc(toLong(len));
    var targetEndPosition = clampPosition($this, tmp$ret$0);
    var targetLen = targetEndPosition.cb(targetStartPosition).kb();
    return new Pair(targetStartPosition, targetLen);
  }
  function $closeCOROUTINE$265(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o6z_1 = _this__u8e3s4;
  }
  protoOf($closeCOROUTINE$265).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            if (this.o6z_1.e6z_1) {
              this.fd_1 = 1;
              suspendResult = this.o6z_1.b6z_1.x5u(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            this.fd_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function SliceAsyncStreamBase(base, baseStart, baseEnd, closeParent) {
    AsyncStreamBase.call(this);
    this.b6z_1 = base;
    this.c6z_1 = baseStart;
    this.d6z_1 = baseEnd;
    this.e6z_1 = closeParent;
    this.f6z_1 = this.d6z_1.cb(this.c6z_1);
  }
  protoOf(SliceAsyncStreamBase).k67 = function (position, buffer, offset, len, $completion) {
    var tmp0_container = clampPositionLen(this, position, len);
    var targetStartPosition = tmp0_container.cg();
    var targetLen = tmp0_container.dg();
    return this.b6z_1.k67(targetStartPosition, buffer, offset, targetLen, $completion);
  };
  protoOf(SliceAsyncStreamBase).l67 = function (position, buffer, offset, len, $completion) {
    var tmp0_container = clampPositionLen(this, position, len);
    var targetStartPosition = tmp0_container.cg();
    var targetLen = tmp0_container.dg();
    return this.b6z_1.l67(targetStartPosition, buffer, offset, targetLen, $completion);
  };
  protoOf(SliceAsyncStreamBase).m5w = function ($completion) {
    return this.f6z_1;
  };
  protoOf(SliceAsyncStreamBase).x5u = function ($completion) {
    var tmp = new $closeCOROUTINE$265(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(SliceAsyncStreamBase).toString = function () {
    return 'SliceAsyncStreamBase(' + this.b6z_1 + ', ' + this.c6z_1.toString() + ', ' + this.d6z_1.toString() + ')';
  };
  function sliceStart(_this__u8e3s4, start, closeParent, $completion) {
    start = start === VOID ? new Long(0, 0) : start;
    closeParent = closeParent === VOID ? false : closeParent;
    var tmp = new $sliceStartCOROUTINE$266(_this__u8e3s4, start, closeParent, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function sliceHere(_this__u8e3s4, closeParent, $completion) {
    closeParent = closeParent === VOID ? false : closeParent;
    var tmp = new $sliceHereCOROUTINE$268(_this__u8e3s4, closeParent, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readU16(_this__u8e3s4, endian, $completion) {
    var tmp = new $readU16COROUTINE$269(_this__u8e3s4, endian, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readS32(_this__u8e3s4, endian, $completion) {
    var tmp = new $readS32COROUTINE$270(_this__u8e3s4, endian, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function readStringz(_this__u8e3s4, len, charset, $completion) {
    charset = charset === VOID ? get_UTF8() : charset;
    var tmp = new $readStringzCOROUTINE$271(_this__u8e3s4, len, charset, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function skipToAlign(_this__u8e3s4, alignment, offset) {
    _init_properties_AsyncStream_kt__y7xune();
    var tmp = _this__u8e3s4;
    // Inline function 'kotlin.Long.minus' call
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = _this__u8e3s4.r4z_1.mc(toLong(offset));
    tmp.r4z_1 = nextAlignedTo(tmp$ret$0, toLong(alignment)).cb(toLong(offset));
  }
  function readU16LE(_this__u8e3s4, $completion) {
    var tmp = new $readU16LECOROUTINE$274(_this__u8e3s4, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function $getPositionCOROUTINE$275(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s72_1 = _this__u8e3s4;
  }
  protoOf($getPositionCOROUTINE$275).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            var tmp_0 = this;
            var tmp_1 = this.s72_1.v72_1;
            var tmp0_safe_receiver = isInterface(tmp_1, SyncPositionStream) ? tmp_1 : null;
            tmp_0.t72_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ks();
            if (this.t72_1 == null) {
              this.fd_1 = 1;
              suspendResult = getPosition.call(this.s72_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.u72_1 = this.t72_1;
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            this.u72_1 = suspendResult;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            return this.u72_1;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $getLengthCOROUTINE$276(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e73_1 = _this__u8e3s4;
  }
  protoOf($getLengthCOROUTINE$276).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            var tmp_0 = this;
            var tmp_1 = this.e73_1.v72_1;
            var tmp0_safe_receiver = isInterface(tmp_1, SyncLengthStream) ? tmp_1 : null;
            tmp_0.f73_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a();
            if (this.f73_1 == null) {
              this.fd_1 = 1;
              suspendResult = getLength.call(this.e73_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.g73_1 = this.f73_1;
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            this.g73_1 = suspendResult;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            return this.g73_1;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function toAsyncInputStream$1($this_toAsyncInputStream) {
    this.v72_1 = $this_toAsyncInputStream;
  }
  protoOf(toAsyncInputStream$1).y5w = function (buffer, offset, len, $completion) {
    return this.v72_1.t1z(buffer, offset, len);
  };
  protoOf(toAsyncInputStream$1).x5u = function ($completion) {
    var tmp = this.v72_1;
    var tmp0_safe_receiver = isInterface(tmp, Closeable) ? tmp : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p21();
    }
    return Unit_instance;
  };
  protoOf(toAsyncInputStream$1).y5y = function ($completion) {
    var tmp = new $getPositionCOROUTINE$275(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(toAsyncInputStream$1).m5w = function ($completion) {
    var tmp = new $getLengthCOROUTINE$276(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function toAsyncOutputStream$1($this_toAsyncOutputStream) {
    this.h73_1 = $this_toAsyncOutputStream;
  }
  protoOf(toAsyncOutputStream$1).v5t = function (buffer, offset, len, $completion) {
    this.h73_1.i73(buffer, offset, len);
    return Unit_instance;
  };
  protoOf(toAsyncOutputStream$1).x5u = function ($completion) {
    var tmp = this.h73_1;
    var tmp0_safe_receiver = isInterface(tmp, Closeable) ? tmp : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p21();
    }
    return Unit_instance;
  };
  function $readBytesUpToCOROUTINE$237(_this__u8e3s4, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t6q_1 = _this__u8e3s4;
    this.u6q_1 = len;
  }
  protoOf($readBytesUpToCOROUTINE$237).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 10;
            this.v6q_1 = 4096;
            if (this.u6q_1 <= this.v6q_1) {
              this.fd_1 = 9;
              suspendResult = readBytesUpToCopy(this.t6q_1, new Int8Array(this.u6q_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 1;
              continue $sm;
            }

          case 1:
            var tmp_0 = this.t6q_1;
            if (isInterface(tmp_0, AsyncPositionLengthStream)) {
              var tmp_1 = this;
              tmp_1.w6q_1 = this.u6q_1;
              this.fd_1 = 7;
              suspendResult = getAvailable(this.t6q_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 2;
              continue $sm;
            }

          case 2:
            this.x6q_1 = this.u6q_1;
            this.y6q_1 = new Int8Array(this.v6q_1);
            this.z6q_1 = ByteArrayBuilder_init_$Create$();
            this.fd_1 = 3;
            continue $sm;
          case 3:
            if (!(this.x6q_1 > 0)) {
              this.fd_1 = 6;
              continue $sm;
            }

            this.fd_1 = 4;
            var a = this.y6q_1.length;
            var b = this.x6q_1;
            suspendResult = this.t6q_1.y5w(this.y6q_1, 0, Math.min(a, b), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.a6r_1 = suspendResult;
            if (this.a6r_1 <= 0) {
              this.fd_1 = 6;
              continue $sm;
            } else {
              this.fd_1 = 5;
              continue $sm;
            }

          case 5:
            this.z6q_1.q37(this.y6q_1, 0, this.a6r_1);
            this.x6q_1 = this.x6q_1 - this.a6r_1 | 0;
            this.fd_1 = 3;
            continue $sm;
          case 6:
            return this.z6q_1.t37();
          case 7:
            this.b6r_1 = suspendResult;
            this.c6r_1 = toIntClamp(this.b6r_1);
            this.d6r_1 = Math.min(this.w6q_1, this.c6r_1);
            this.e6r_1 = new Int8Array(this.d6r_1);
            this.fd_1 = 8;
            suspendResult = readBytesUpToCopy(this.t6q_1, this.e6r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            return suspendResult;
          case 9:
            return suspendResult;
          case 10:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 10) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readS32LECOROUTINE$241(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n6r_1 = _this__u8e3s4;
  }
  protoOf($readS32LECOROUTINE$241).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 9;
            var tmp_0 = this;
            tmp_0.o6r_1 = this.n6r_1;
            var tmp_1 = this;
            tmp_1.p6r_1 = 4;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            var tmp_2 = this;
            tmp_2.r6r_1 = get_smallBytesPool();
            this.s6r_1 = this.r6r_1.z1x();
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.fd_1 = 3;
            continue $sm;
          case 3:
            this.gd_1 = 8;
            var tmp_3 = this;
            tmp_3.u6r_1 = this.s6r_1;
            this.fd_1 = 4;
            suspendResult = this.o6r_1.y5w(this.u6r_1, 0, this.p6r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var read = suspendResult;
            if (!(read === this.p6r_1)) {
              var message = "Couldn't read exact size=" + this.p6r_1 + ' but read=' + read;
              throw IllegalStateException_init_$Create$(toString(message));
            }

            var tmp_4 = this;
            var $this$readSmallTempExact = this.u6r_1;
            tmp_4.t6r_1 = getS32LE($this$readSmallTempExact, 0);
            this.gd_1 = 9;
            this.fd_1 = 5;
            var tmp_5 = this;
            continue $sm;
          case 5:
            var tmp_6 = this.t6r_1;
            this.gd_1 = 9;
            this.r6r_1.e1y(this.s6r_1);
            this.q6r_1 = tmp_6;
            this.fd_1 = 7;
            continue $sm;
          case 6:
            this.gd_1 = 9;
            this.r6r_1.e1y(this.s6r_1);
            if (false) {
              this.fd_1 = 1;
              continue $sm;
            }

            this.fd_1 = 7;
            continue $sm;
          case 7:
            return this.q6r_1;
          case 8:
            this.gd_1 = 9;
            var t = this.id_1;
            this.r6r_1.e1y(this.s6r_1);
            throw t;
          case 9:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 9) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readStringCOROUTINE$243(_this__u8e3s4, len, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d6s_1 = _this__u8e3s4;
    this.e6s_1 = len;
    this.f6s_1 = charset;
  }
  protoOf($readStringCOROUTINE$243).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = readBytesExact(this.d6s_1, this.e6s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return toString_3(ARGUMENT, this.f6s_1);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readAllCOROUTINE$246(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o6s_1 = _this__u8e3s4;
  }
  protoOf($readAllCOROUTINE$246).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 18;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            this.gd_1 = 16;
            var tmp_0;
            var tmp_1 = this.o6s_1;
            if (isInterface(tmp_1, AsyncGetPositionStream)) {
              var tmp_2 = this.o6s_1;
              tmp_0 = isInterface(tmp_2, AsyncGetLengthStream);
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this.fd_1 = 10;
              suspendResult = this.o6s_1.m5w(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_3 = this.o6s_1;
              if (tmp_3 instanceof AsyncStream) {
                this.fd_1 = 2;
                suspendResult = this.o6s_1.j6q(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.r6s_1 = false;
                this.fd_1 = 3;
                continue $sm;
              }
            }

          case 2:
            this.r6s_1 = suspendResult;
            this.fd_1 = 3;
            continue $sm;
          case 3:
            if (this.r6s_1) {
              this.fd_1 = 8;
              suspendResult = this.o6s_1.k6q(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.s6s_1 = ByteArrayBuilder_init_$Create$();
              this.t6s_1 = new Int8Array(4096);
              this.fd_1 = 4;
              continue $sm;
            }

          case 4:
            if (!true) {
              this.fd_1 = 7;
              continue $sm;
            }

            this.fd_1 = 5;
            suspendResult = this.o6s_1.y5w(this.t6s_1, 0, this.t6s_1.length, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.u6s_1 = suspendResult;
            if (this.u6s_1 <= 0) {
              this.fd_1 = 7;
              continue $sm;
            } else {
              this.fd_1 = 6;
              continue $sm;
            }

          case 6:
            this.s6s_1.q37(this.t6s_1, 0, this.u6s_1);
            this.fd_1 = 4;
            continue $sm;
          case 7:
            this.q6s_1 = this.s6s_1.t37();
            this.fd_1 = 13;
            continue $sm;
          case 8:
            this.v6s_1 = suspendResult;
            this.w6s_1 = this.v6s_1.kb();
            this.fd_1 = 9;
            suspendResult = readBytesExact(this.o6s_1, this.w6s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            this.q6s_1 = suspendResult;
            this.fd_1 = 13;
            continue $sm;
          case 10:
            this.x6s_1 = suspendResult;
            this.fd_1 = 11;
            suspendResult = this.o6s_1.y5y(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            this.y6s_1 = suspendResult;
            this.z6s_1 = this.x6s_1.cb(this.y6s_1);
            this.fd_1 = 12;
            suspendResult = readBytesExact(this.o6s_1, this.z6s_1.kb(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            this.q6s_1 = suspendResult;
            this.fd_1 = 13;
            continue $sm;
          case 13:
            this.p6s_1 = this.q6s_1;
            this.gd_1 = 18;
            this.fd_1 = 14;
            continue $sm;
          case 14:
            this.a6t_1 = this.p6s_1;
            this.gd_1 = 18;
            this.fd_1 = 15;
            suspendResult = this.o6s_1.x5u(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 15:
            return this.a6t_1;
          case 16:
            this.gd_1 = 18;
            this.b6t_1 = this.id_1;
            this.fd_1 = 17;
            suspendResult = this.o6s_1.x5u(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 17:
            throw this.b6t_1;
          case 18:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 18) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readBytesExactCOROUTINE$251(_this__u8e3s4, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u6t_1 = _this__u8e3s4;
    this.v6t_1 = len;
  }
  protoOf($readBytesExactCOROUTINE$251).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            var tmp_0 = this;
            tmp_0.w6t_1 = new Int8Array(this.v6t_1);
            var tmp_1 = this;
            tmp_1.x6t_1 = this.w6t_1;
            this.fd_1 = 1;
            suspendResult = readExact(this.u6t_1, this.x6t_1, 0, this.v6t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.w6t_1;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readU16BECOROUTINE$252(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g6u_1 = _this__u8e3s4;
  }
  protoOf($readU16BECOROUTINE$252).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 9;
            var tmp_0 = this;
            tmp_0.h6u_1 = this.g6u_1;
            var tmp_1 = this;
            tmp_1.i6u_1 = 2;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            var tmp_2 = this;
            tmp_2.k6u_1 = get_smallBytesPool();
            this.l6u_1 = this.k6u_1.z1x();
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.fd_1 = 3;
            continue $sm;
          case 3:
            this.gd_1 = 8;
            var tmp_3 = this;
            tmp_3.n6u_1 = this.l6u_1;
            this.fd_1 = 4;
            suspendResult = this.h6u_1.y5w(this.n6u_1, 0, this.i6u_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var read = suspendResult;
            if (!(read === this.i6u_1)) {
              var message = "Couldn't read exact size=" + this.i6u_1 + ' but read=' + read;
              throw IllegalStateException_init_$Create$(toString(message));
            }

            var tmp_4 = this;
            var $this$readSmallTempExact = this.n6u_1;
            tmp_4.m6u_1 = getU16BE($this$readSmallTempExact, 0);
            this.gd_1 = 9;
            this.fd_1 = 5;
            var tmp_5 = this;
            continue $sm;
          case 5:
            var tmp_6 = this.m6u_1;
            this.gd_1 = 9;
            this.k6u_1.e1y(this.l6u_1);
            this.j6u_1 = tmp_6;
            this.fd_1 = 7;
            continue $sm;
          case 6:
            this.gd_1 = 9;
            this.k6u_1.e1y(this.l6u_1);
            if (false) {
              this.fd_1 = 1;
              continue $sm;
            }

            this.fd_1 = 7;
            continue $sm;
          case 7:
            return this.j6u_1;
          case 8:
            this.gd_1 = 9;
            var t = this.id_1;
            this.k6u_1.e1y(this.l6u_1);
            throw t;
          case 9:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 9) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readS32BECOROUTINE$253(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w6u_1 = _this__u8e3s4;
  }
  protoOf($readS32BECOROUTINE$253).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 9;
            var tmp_0 = this;
            tmp_0.x6u_1 = this.w6u_1;
            var tmp_1 = this;
            tmp_1.y6u_1 = 4;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            var tmp_2 = this;
            tmp_2.a6v_1 = get_smallBytesPool();
            this.b6v_1 = this.a6v_1.z1x();
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.fd_1 = 3;
            continue $sm;
          case 3:
            this.gd_1 = 8;
            var tmp_3 = this;
            tmp_3.d6v_1 = this.b6v_1;
            this.fd_1 = 4;
            suspendResult = this.x6u_1.y5w(this.d6v_1, 0, this.y6u_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var read = suspendResult;
            if (!(read === this.y6u_1)) {
              var message = "Couldn't read exact size=" + this.y6u_1 + ' but read=' + read;
              throw IllegalStateException_init_$Create$(toString(message));
            }

            var tmp_4 = this;
            var $this$readSmallTempExact = this.d6v_1;
            tmp_4.c6v_1 = getS32BE($this$readSmallTempExact, 0);
            this.gd_1 = 9;
            this.fd_1 = 5;
            var tmp_5 = this;
            continue $sm;
          case 5:
            var tmp_6 = this.c6v_1;
            this.gd_1 = 9;
            this.a6v_1.e1y(this.b6v_1);
            this.z6u_1 = tmp_6;
            this.fd_1 = 7;
            continue $sm;
          case 6:
            this.gd_1 = 9;
            this.a6v_1.e1y(this.b6v_1);
            if (false) {
              this.fd_1 = 1;
              continue $sm;
            }

            this.fd_1 = 7;
            continue $sm;
          case 7:
            return this.z6u_1;
          case 8:
            this.gd_1 = 9;
            var t = this.id_1;
            this.a6v_1.e1y(this.b6v_1);
            throw t;
          case 9:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 9) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readBytesUpToCopyCOROUTINE$254(_this__u8e3s4, out, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m6v_1 = _this__u8e3s4;
    this.n6v_1 = out;
  }
  protoOf($readBytesUpToCopyCOROUTINE$254).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = readBytesUpTo_0(this.m6v_1, this.n6v_1, 0, this.n6v_1.length, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var pos = suspendResult;
            return this.n6v_1.length === pos ? this.n6v_1 : copyOf_0(this.n6v_1, pos);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $getAvailableCOROUTINE$255(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w6v_1 = _this__u8e3s4;
  }
  protoOf($getAvailableCOROUTINE$255).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = this.w6v_1.m5w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x6v_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = this.w6v_1.y5y(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this.x6v_1.cb(ARGUMENT);
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readExactCOROUTINE$261(_this__u8e3s4, buffer, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g6x_1 = _this__u8e3s4;
    this.h6x_1 = buffer;
    this.i6x_1 = offset;
    this.j6x_1 = len;
  }
  protoOf($readExactCOROUTINE$261).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 5;
            this.k6x_1 = this.j6x_1;
            this.l6x_1 = this.i6x_1;
            this.m6x_1 = this.g6x_1;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!(this.k6x_1 > 0)) {
              this.fd_1 = 4;
              continue $sm;
            }

            this.fd_1 = 2;
            suspendResult = this.m6x_1.y5w(this.h6x_1, this.l6x_1, this.k6x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var read = suspendResult;
            if (read < 0) {
              this.fd_1 = 4;
              continue $sm;
            } else {
              this.fd_1 = 3;
              continue $sm;
            }

          case 3:
            if (read === 0)
              throw new EOFException('Not enough data. Expected=' + this.j6x_1 + ', Read=' + (this.j6x_1 - this.k6x_1 | 0) + ', Remaining=' + this.k6x_1);
            this.l6x_1 = this.l6x_1 + read | 0;
            this.k6x_1 = this.k6x_1 - read | 0;
            this.fd_1 = 1;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 5) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $sliceWithBoundsCOROUTINE$262(_this__u8e3s4, start, end, closeParent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v6x_1 = _this__u8e3s4;
    this.w6x_1 = start;
    this.x6x_1 = end;
    this.y6x_1 = closeParent;
  }
  protoOf($sliceWithBoundsCOROUTINE$262).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.fd_1 = 1;
            suspendResult = this.v6x_1.l5w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              this.fd_1 = 2;
              suspendResult = this.v6x_1.m5w(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.z6x_1 = this.x6x_1;
              this.fd_1 = 3;
              continue $sm;
            }

          case 2:
            this.z6x_1 = suspendResult;
            this.fd_1 = 3;
            continue $sm;
          case 3:
            var rlen = this.z6x_1;
            var len = rlen.t6(new Long(0, 0)) >= 0 ? rlen : this.x6x_1;
            var clampedStart = clamp_2(this.w6x_1, new Long(0, 0), len);
            var clampedEnd = clamp_2(this.x6x_1, new Long(0, 0), len);
            var tmp_0;
            if (this.v6x_1.q4z_1 instanceof SliceAsyncStreamBase) {
              tmp_0 = new SliceAsyncStreamBase(this.v6x_1.q4z_1.b6z_1, this.v6x_1.q4z_1.c6z_1.mc(clampedStart), this.v6x_1.q4z_1.c6z_1.mc(clampedEnd), this.y6x_1);
            } else {
              tmp_0 = new SliceAsyncStreamBase(this.v6x_1.q4z_1, clampedStart, clampedEnd, this.y6x_1);
            }

            return toAsyncStream(tmp_0);
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readBytesUpToCOROUTINE$263(_this__u8e3s4, out, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i6y_1 = _this__u8e3s4;
    this.j6y_1 = out;
    this.k6y_1 = offset;
    this.l6y_1 = len;
  }
  protoOf($readBytesUpToCOROUTINE$263).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.m6y_1 = 0;
            this.n6y_1 = this.l6y_1;
            this.o6y_1 = this.k6y_1;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.fd_1 = 5;
              continue $sm;
            }

            this.fd_1 = 2;
            suspendResult = this.i6y_1.y5w(this.j6y_1, this.o6y_1, this.n6y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var result = suspendResult;
            if (result <= 0) {
              this.fd_1 = 5;
              continue $sm;
            } else {
              this.fd_1 = 3;
              continue $sm;
            }

          case 3:
            this.o6y_1 = this.o6y_1 + result | 0;
            this.n6y_1 = this.n6y_1 - result | 0;
            this.m6y_1 = this.m6y_1 + result | 0;
            this.fd_1 = 1;
            continue $sm;
          case 4:
            throw this.id_1;
          case 5:
            return this.m6y_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readBytesCOROUTINE$264(_this__u8e3s4, position, count, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x6y_1 = _this__u8e3s4;
    this.y6y_1 = position;
    this.z6y_1 = count;
  }
  protoOf($readBytesCOROUTINE$264).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.a6z_1 = new Int8Array(this.z6y_1);
            this.fd_1 = 1;
            suspendResult = this.x6y_1.k67(this.y6y_1, this.a6z_1, 0, this.a6z_1.length, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var readLen = suspendResult;
            return copyOf_0(this.a6z_1, readLen);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $sliceStartCOROUTINE$266(_this__u8e3s4, start, closeParent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x6z_1 = _this__u8e3s4;
    this.y6z_1 = start;
    this.z6z_1 = closeParent;
  }
  protoOf($sliceStartCOROUTINE$266).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = this.x6z_1.m5w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.a70_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = sliceWithBounds(this.x6z_1, this.y6z_1, this.a70_1, this.z6z_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $sliceHereCOROUTINE$268(_this__u8e3s4, closeParent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j70_1 = _this__u8e3s4;
    this.k70_1 = closeParent;
  }
  protoOf($sliceHereCOROUTINE$268).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.l70_1 = this.j70_1.r4z_1;
            this.fd_1 = 1;
            suspendResult = this.j70_1.m5w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.m70_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = sliceWithSize_0(this.j70_1, this.l70_1, this.m70_1, this.k70_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readU16COROUTINE$269(_this__u8e3s4, endian, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v70_1 = _this__u8e3s4;
    this.w70_1 = endian;
  }
  protoOf($readU16COROUTINE$269).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            if (this.w70_1.equals(Endian_LITTLE_ENDIAN_getInstance())) {
              this.fd_1 = 2;
              suspendResult = readU16LE(this.v70_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = readU16BE(this.v70_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.x70_1 = suspendResult;
            this.fd_1 = 3;
            continue $sm;
          case 2:
            this.x70_1 = suspendResult;
            this.fd_1 = 3;
            continue $sm;
          case 3:
            return this.x70_1;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readS32COROUTINE$270(_this__u8e3s4, endian, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g71_1 = _this__u8e3s4;
    this.h71_1 = endian;
  }
  protoOf($readS32COROUTINE$270).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            if (this.h71_1.equals(Endian_LITTLE_ENDIAN_getInstance())) {
              this.fd_1 = 2;
              suspendResult = readS32LE(this.g71_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = readS32BE(this.g71_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.i71_1 = suspendResult;
            this.fd_1 = 3;
            continue $sm;
          case 2:
            this.i71_1 = suspendResult;
            this.fd_1 = 3;
            continue $sm;
          case 3:
            return this.i71_1;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readStringzCOROUTINE$271(_this__u8e3s4, len, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r71_1 = _this__u8e3s4;
    this.s71_1 = len;
    this.t71_1 = charset;
  }
  protoOf($readStringzCOROUTINE$271).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = readBytesExact(this.r71_1, this.s71_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var res = suspendResult;
            var index = indexOf_2(res, 0);
            return toString_3(copyOf_0(res, index < 0 ? this.s71_1 : index), this.t71_1);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $readU16LECOROUTINE$274(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c72_1 = _this__u8e3s4;
  }
  protoOf($readU16LECOROUTINE$274).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 9;
            var tmp_0 = this;
            tmp_0.d72_1 = this.c72_1;
            var tmp_1 = this;
            tmp_1.e72_1 = 2;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            var tmp_2 = this;
            tmp_2.g72_1 = get_smallBytesPool();
            this.h72_1 = this.g72_1.z1x();
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.fd_1 = 3;
            continue $sm;
          case 3:
            this.gd_1 = 8;
            var tmp_3 = this;
            tmp_3.j72_1 = this.h72_1;
            this.fd_1 = 4;
            suspendResult = this.d72_1.y5w(this.j72_1, 0, this.e72_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var read = suspendResult;
            if (!(read === this.e72_1)) {
              var message = "Couldn't read exact size=" + this.e72_1 + ' but read=' + read;
              throw IllegalStateException_init_$Create$(toString(message));
            }

            var tmp_4 = this;
            var $this$readSmallTempExact = this.j72_1;
            tmp_4.i72_1 = getU16LE($this$readSmallTempExact, 0);
            this.gd_1 = 9;
            this.fd_1 = 5;
            var tmp_5 = this;
            continue $sm;
          case 5:
            var tmp_6 = this.i72_1;
            this.gd_1 = 9;
            this.g72_1.e1y(this.h72_1);
            this.f72_1 = tmp_6;
            this.fd_1 = 7;
            continue $sm;
          case 6:
            this.gd_1 = 9;
            this.g72_1.e1y(this.h72_1);
            if (false) {
              this.fd_1 = 1;
              continue $sm;
            }

            this.fd_1 = 7;
            continue $sm;
          case 7:
            return this.f72_1;
          case 8:
            this.gd_1 = 9;
            var t = this.id_1;
            this.g72_1.e1y(this.h72_1);
            throw t;
          case 9:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 9) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_AsyncStream_kt_gaoyh8;
  function _init_properties_AsyncStream_kt__y7xune() {
    if (!properties_initialized_AsyncStream_kt_gaoyh8) {
      properties_initialized_AsyncStream_kt_gaoyh8 = true;
      EMPTY_BYTE_ARRAY = new Int8Array(0);
    }
  }
  function offset($this, count) {
    var out = $this.s4a_1;
    $this.s4a_1 = $this.s4a_1 + count | 0;
    return out;
  }
  function FastByteArrayInputStream(ba, offset, start, end) {
    offset = offset === VOID ? 0 : offset;
    start = start === VOID ? 0 : start;
    end = end === VOID ? ba.length : end;
    this.p4a_1 = ba;
    this.q4a_1 = start;
    this.r4a_1 = end;
    this.s4a_1 = offset + this.q4a_1 | 0;
  }
  protoOf(FastByteArrayInputStream).y4j = function (value) {
    this.s4a_1 = this.q4a_1 + value | 0;
  };
  protoOf(FastByteArrayInputStream).ks = function () {
    return this.s4a_1 - this.q4a_1 | 0;
  };
  protoOf(FastByteArrayInputStream).a = function () {
    return this.r4a_1 - this.q4a_1 | 0;
  };
  protoOf(FastByteArrayInputStream).m4r = function () {
    return this.r4a_1 - this.s4a_1 | 0;
  };
  protoOf(FastByteArrayInputStream).d4b = function () {
    return this.m4r() > 0;
  };
  protoOf(FastByteArrayInputStream).j73 = function (_this__u8e3s4) {
    return coerceIn(_this__u8e3s4, this.q4a_1, this.r4a_1);
  };
  protoOf(FastByteArrayInputStream).l4j = function (offset, length, charset) {
    var start = this.q4a_1 + offset | 0;
    var end = start + length | 0;
    return toString_3(this.p4a_1, charset, start, end);
  };
  protoOf(FastByteArrayInputStream).i4r = function (size) {
    var out = this.t4a(this.ks(), size);
    this.s4a_1 = this.s4a_1 + size | 0;
    return out;
  };
  protoOf(FastByteArrayInputStream).u4a = function (offset) {
    return new FastByteArrayInputStream(this.p4a_1, 0, this.j73(this.q4a_1 + offset | 0), this.r4a_1);
  };
  protoOf(FastByteArrayInputStream).u4g = function (offset, $super) {
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.u4a(offset) : $super.u4a.call(this, offset);
  };
  protoOf(FastByteArrayInputStream).g1s = function () {
    return new FastByteArrayInputStream(this.p4a_1, this.ks(), this.q4a_1, this.r4a_1);
  };
  protoOf(FastByteArrayInputStream).t4a = function (offset, len) {
    return new FastByteArrayInputStream(this.p4a_1, 0, this.j73(this.q4a_1 + offset | 0), this.j73((this.q4a_1 + offset | 0) + len | 0));
  };
  protoOf(FastByteArrayInputStream).v4b = function (count) {
    this.s4a_1 = coerceIn(this.s4a_1 + count | 0, this.q4a_1, this.r4a_1);
  };
  protoOf(FastByteArrayInputStream).w4j = function (count) {
    return this.v4b(-count | 0);
  };
  protoOf(FastByteArrayInputStream).c4b = function (len) {
    var out = copyOfRange(this.p4a_1, this.s4a_1, this.s4a_1 + len | 0);
    this.s4a_1 = this.s4a_1 + len | 0;
    return out;
  };
  protoOf(FastByteArrayInputStream).h4r = function () {
    return getS8(this.p4a_1, offset(this, 1));
  };
  protoOf(FastByteArrayInputStream).v4a = function () {
    return getU8(this.p4a_1, offset(this, 1));
  };
  protoOf(FastByteArrayInputStream).c4r = function () {
    return getS16BE(this.p4a_1, offset(this, 2));
  };
  protoOf(FastByteArrayInputStream).z4a = function () {
    return getU16BE(this.p4a_1, offset(this, 2));
  };
  protoOf(FastByteArrayInputStream).a4b = function () {
    return getU24BE(this.p4a_1, offset(this, 3));
  };
  protoOf(FastByteArrayInputStream).b4b = function () {
    return getS32BE(this.p4a_1, offset(this, 4));
  };
  protoOf(FastByteArrayInputStream).e4r = function () {
    return getS64BE(this.p4a_1, offset(this, 8));
  };
  protoOf(FastByteArrayInputStream).k73 = function (count) {
    return getS8Array(this.p4a_1, offset(this, count), count);
  };
  protoOf(FastByteArrayInputStream).f4r = function (count) {
    return getS16ArrayBE(this.p4a_1, offset(this, imul(count, 2)), count);
  };
  protoOf(FastByteArrayInputStream).d4r = function (count) {
    return getU16ArrayBE(this.p4a_1, offset(this, imul(count, 2)), count);
  };
  protoOf(FastByteArrayInputStream).g4r = function (count) {
    return getS32ArrayLE(this.p4a_1, offset(this, imul(count, 4)), count);
  };
  protoOf(FastByteArrayInputStream).x4j = function (count) {
    return getS32ArrayBE(this.p4a_1, offset(this, imul(count, 4)), count);
  };
  protoOf(FastByteArrayInputStream).l73 = function (len, charset) {
    var res = this.k73(len);
    var index = indexOf_2(res, 0);
    return toString_3(copyOf_0(res, index < 0 ? len : index), charset);
  };
  protoOf(FastByteArrayInputStream).z4j = function (len, charset, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.l73(len, charset) : $super.l73.call(this, len, charset);
  };
  function openFastStream(_this__u8e3s4, offset) {
    offset = offset === VOID ? 0 : offset;
    return new FastByteArrayInputStream(_this__u8e3s4, offset);
  }
  function toSyncStream(_this__u8e3s4) {
    return (new ReadonlySyncStreamBase(_this__u8e3s4.p4a_1, _this__u8e3s4.q4a_1, _this__u8e3s4.r4a_1 - _this__u8e3s4.q4a_1 | 0)).n73();
  }
  function openAsync(_this__u8e3s4, mode) {
    mode = mode === VOID ? 'r' : mode;
    return toAsyncStream(new MemoryAsyncStreamBase(new ByteArrayBuilder(_this__u8e3s4, VOID, true)), new Long(0, 0));
  }
  function SyncStream(base, position) {
    position = position === VOID ? new Long(0, 0) : position;
    this.a4w_1 = base;
    this.b4w_1 = new Mixin();
    this.c4w_1 = this.a4w_1.m73_1;
    this.d4w_1 = this.a4w_1.o73();
    this.e4w_1 = position;
    this.f4w_1 = position;
    this.g4w_1 = position;
    this.h4w_1 = new Long(0, 0);
  }
  protoOf(SyncStream).h23 = function (_set____db54di) {
    this.b4w_1.h23(_set____db54di);
  };
  protoOf(SyncStream).i23 = function () {
    return this.b4w_1.i23();
  };
  protoOf(SyncStream).p73 = function (value) {
    if (this.d4w_1)
      this.e4w_1 = value;
    else {
      this.q73(value);
    }
  };
  protoOf(SyncStream).r73 = function () {
    return this.d4w_1 ? this.e4w_1 : this.ks();
  };
  protoOf(SyncStream).s73 = function (value) {
    if (this.d4w_1)
      this.f4w_1 = value;
    else {
      this.q73(value);
    }
  };
  protoOf(SyncStream).t73 = function () {
    return this.d4w_1 ? this.f4w_1 : this.ks();
  };
  protoOf(SyncStream).q73 = function (value) {
    var tmp;
    if (this.d4w_1) {
      this.p73(value);
      tmp = Unit_instance;
    } else {
      this.g4w_1 = value;
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(SyncStream).ks = function () {
    return this.d4w_1 ? this.r73() : this.g4w_1;
  };
  protoOf(SyncStream).t1z = function (buffer, offset, len) {
    var read = this.a4w_1.u73(this.r73(), buffer, offset, len);
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = this.r73().mc(toLong(read));
    this.p73(tmp$ret$0);
    return read;
  };
  protoOf(SyncStream).v4b = function (count) {
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = this.r73().mc(toLong(count));
    this.p73(tmp$ret$0);
  };
  protoOf(SyncStream).m15 = function () {
    var size = this.t1z(this.c4w_1, 0, 1);
    if (size <= 0)
      return -1;
    // Inline function 'korlibs.math.unsigned' call
    return this.c4w_1[0] & 255;
  };
  protoOf(SyncStream).i73 = function (buffer, offset, len) {
    this.a4w_1.v73(this.t73(), buffer, offset, len);
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = this.t73().mc(toLong(len));
    this.s73(tmp$ret$0);
  };
  protoOf(SyncStream).a = function () {
    return this.a4w_1.a();
  };
  protoOf(SyncStream).w73 = function () {
    return this.a().cb(this.r73());
  };
  protoOf(SyncStream).m4r = function () {
    return this.w73();
  };
  protoOf(SyncStream).p21 = function () {
    return this.a4w_1.p21();
  };
  protoOf(SyncStream).g1s = function () {
    return new SyncStream(this.a4w_1, this.ks());
  };
  protoOf(SyncStream).toString = function () {
    return 'SyncStream(' + this.a4w_1 + ', ' + this.ks().toString() + ')';
  };
  function openSync(_this__u8e3s4, mode) {
    mode = mode === VOID ? 'r' : mode;
    return toSyncStream_0(new MemorySyncStreamBase(new ByteArrayBuilder(_this__u8e3s4)), new Long(0, 0));
  }
  function readS32BE_0(_this__u8e3s4) {
    return readU8(_this__u8e3s4) << 24 | readU8(_this__u8e3s4) << 16 | readU8(_this__u8e3s4) << 8 | readU8(_this__u8e3s4);
  }
  function get_eof(_this__u8e3s4) {
    return _this__u8e3s4.m4r().t6(new Long(0, 0)) <= 0;
  }
  function readStringz_0(_this__u8e3s4, len, charset) {
    charset = charset === VOID ? get_UTF8() : charset;
    var res = readBytes_0(_this__u8e3s4, len);
    var index = indexOf_0(res, 0);
    return toString_3(copyOf_0(res, index < 0 ? len : index), charset);
  }
  function readStream(_this__u8e3s4, length) {
    return readSlice(_this__u8e3s4, length);
  }
  function readU8(_this__u8e3s4) {
    return _this__u8e3s4.m15();
  }
  function readAll_0(_this__u8e3s4) {
    return readBytes_0(_this__u8e3s4, _this__u8e3s4.m4r().kb());
  }
  function SyncInputStream() {
  }
  function readString_0(_this__u8e3s4, len, charset) {
    charset = charset === VOID ? get_UTF8() : charset;
    return toString_3(readBytes_0(_this__u8e3s4, len), charset);
  }
  function SyncStreamBase() {
    this.m73_1 = new Int8Array(16);
  }
  protoOf(SyncStreamBase).o73 = function () {
    return false;
  };
  protoOf(SyncStreamBase).u73 = function (position, buffer, offset, len) {
    unsupported_0();
  };
  protoOf(SyncStreamBase).v73 = function (position, buffer, offset, len) {
    unsupported_0();
  };
  protoOf(SyncStreamBase).a = function () {
    unsupported_0();
  };
  protoOf(SyncStreamBase).p21 = function () {
    return Unit_instance;
  };
  protoOf(SyncStreamBase).x73 = function (position) {
    return new SyncStream(this, position);
  };
  protoOf(SyncStreamBase).n73 = function (position, $super) {
    position = position === VOID ? new Long(0, 0) : position;
    return $super === VOID ? this.x73(position) : $super.x73.call(this, position);
  };
  function SyncPositionStream() {
  }
  function SyncLengthStream() {
  }
  function MemorySyncStreamBase_init_$Init$(initialCapacity, $this) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    MemorySyncStreamBase.call($this, ByteArrayBuilder_init_$Create$(initialCapacity));
    return $this;
  }
  function MemorySyncStreamBase_init_$Create$(initialCapacity) {
    return MemorySyncStreamBase_init_$Init$(initialCapacity, objectCreate(protoOf(MemorySyncStreamBase)));
  }
  function MemorySyncStreamBase(data) {
    SyncStreamBase.call(this);
    this.z73_1 = data;
  }
  protoOf(MemorySyncStreamBase).z6v = function () {
    return this.z73_1.n();
  };
  protoOf(MemorySyncStreamBase).a = function () {
    return toLong(this.z73_1.n());
  };
  protoOf(MemorySyncStreamBase).a6w = function (position) {
    if (position.t6(new Long(0, 0)) < 0) {
      invalidOp('Invalid position ' + position.toString());
    }
  };
  protoOf(MemorySyncStreamBase).u73 = function (position, buffer, offset, len) {
    this.a6w(position);
    var ipos = position.kb();
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.z6v());
    if (!contains_2(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    // Inline function 'kotlin.math.min' call
    var a = this.z6v();
    var b = ipos + len | 0;
    var end = Math.min(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = end - ipos | 0;
    var actualLen = Math.max(a_0, 0);
    arraycopy_0(this.z73_1.n37_1, ipos, buffer, offset, actualLen);
    return actualLen;
  };
  protoOf(MemorySyncStreamBase).v73 = function (position, buffer, offset, len) {
    this.a6w(position);
    var tmp = this.z73_1;
    // Inline function 'kotlin.math.max' call
    var a = this.z73_1.n();
    // Inline function 'kotlin.Long.plus' call
    var b = position.mc(toLong(len)).kb();
    var tmp$ret$1 = Math.max(a, b);
    tmp.r1r(tmp$ret$1);
    arraycopy_0(buffer, offset, this.z73_1.n37_1, position.kb(), len);
  };
  protoOf(MemorySyncStreamBase).p21 = function () {
    return Unit_instance;
  };
  protoOf(MemorySyncStreamBase).toString = function () {
    return 'MemorySyncStreamBase(' + this.z73_1.n() + ')';
  };
  function ReadonlySyncStreamBase(data, offset, size) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? data.length - offset | 0 : size;
    SyncStreamBase.call(this);
    this.b74_1 = data;
    this.c74_1 = offset;
    this.d74_1 = size;
  }
  protoOf(ReadonlySyncStreamBase).z6v = function () {
    return this.d74_1;
  };
  protoOf(ReadonlySyncStreamBase).a = function () {
    return toLong(this.b74_1.length);
  };
  protoOf(ReadonlySyncStreamBase).a6w = function (position) {
    if (position.t6(new Long(0, 0)) < 0) {
      invalidOp('Invalid position ' + position.toString());
    }
  };
  protoOf(ReadonlySyncStreamBase).u73 = function (position, buffer, offset, len) {
    this.a6w(position);
    var ipos = position.kb();
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.z6v());
    if (!contains_2(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    // Inline function 'kotlin.math.min' call
    var a = this.z6v();
    var b = ipos + len | 0;
    var end = Math.min(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = end - ipos | 0;
    var actualLen = Math.max(a_0, 0);
    arraycopy_0(this.b74_1, ipos + this.c74_1 | 0, buffer, offset, actualLen);
    return actualLen;
  };
  protoOf(ReadonlySyncStreamBase).p21 = function () {
    return Unit_instance;
  };
  protoOf(ReadonlySyncStreamBase).toString = function () {
    return 'ReadonlySyncStreamBase(' + this.b74_1.length + ')';
  };
  function MemorySyncStream(data) {
    return toSyncStream_0(new MemorySyncStreamBase(data));
  }
  function toSyncStream_0(_this__u8e3s4, position) {
    position = position === VOID ? new Long(0, 0) : position;
    return new SyncStream(_this__u8e3s4, position);
  }
  function sliceWithBounds_0(_this__u8e3s4, start, end) {
    var len = _this__u8e3s4.a();
    var clampedStart = clamp_2(start, new Long(0, 0), len);
    var clampedEnd = clamp_2(end, new Long(0, 0), len);
    var tmp = _this__u8e3s4.a4w_1;
    if (tmp instanceof SliceSyncStreamBase) {
      return toSyncStream_0(new SliceSyncStreamBase(_this__u8e3s4.a4w_1.f74_1, _this__u8e3s4.a4w_1.g74_1.mc(clampedStart), _this__u8e3s4.a4w_1.g74_1.mc(clampedEnd)));
    } else {
      return toSyncStream_0(new SliceSyncStreamBase(_this__u8e3s4.a4w_1, clampedStart, clampedEnd));
    }
  }
  function readBytes_0(_this__u8e3s4, len) {
    var bytes = new Int8Array(len);
    var out = _this__u8e3s4.t1z(bytes, 0, len);
    return !(out === len) ? copyOf_0(bytes, out) : bytes;
  }
  function readSlice(_this__u8e3s4, length) {
    // Inline function 'kotlin.apply' call
    var this_0 = sliceWithSize_1(_this__u8e3s4, _this__u8e3s4.ks(), length);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.stream.readSlice.<anonymous>' call
    _this__u8e3s4.q73(_this__u8e3s4.ks().mc(length));
    return this_0;
  }
  function clampPosition_0($this, position) {
    return clamp_2(position, $this.g74_1, $this.h74_1);
  }
  function clampPositionLen_0($this, position, len) {
    if (position.t6(new Long(0, 0)) < 0)
      throw IllegalArgumentException_init_$Create$('Invalid position');
    var targetStartPosition = clampPosition_0($this, $this.g74_1.mc(position));
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = targetStartPosition.mc(toLong(len));
    var targetEndPosition = clampPosition_0($this, tmp$ret$0);
    var targetLen = targetEndPosition.cb(targetStartPosition).kb();
    return new Pair(targetStartPosition, targetLen);
  }
  function SliceSyncStreamBase(base, baseStart, baseEnd) {
    SyncStreamBase.call(this);
    this.f74_1 = base;
    this.g74_1 = baseStart;
    this.h74_1 = baseEnd;
    this.i74_1 = this.h74_1.cb(this.g74_1);
  }
  protoOf(SliceSyncStreamBase).o73 = function () {
    return this.f74_1.o73();
  };
  protoOf(SliceSyncStreamBase).a = function () {
    return this.i74_1;
  };
  protoOf(SliceSyncStreamBase).u73 = function (position, buffer, offset, len) {
    var tmp0_container = clampPositionLen_0(this, position, len);
    var targetStartPosition = tmp0_container.cg();
    var targetLen = tmp0_container.dg();
    return this.f74_1.u73(targetStartPosition, buffer, offset, targetLen);
  };
  protoOf(SliceSyncStreamBase).v73 = function (position, buffer, offset, len) {
    var tmp0_container = clampPositionLen_0(this, position, len);
    var targetStartPosition = tmp0_container.cg();
    var targetLen = tmp0_container.dg();
    return this.f74_1.v73(targetStartPosition, buffer, offset, targetLen);
  };
  protoOf(SliceSyncStreamBase).p21 = function () {
    return Unit_instance;
  };
  protoOf(SliceSyncStreamBase).toString = function () {
    return 'SliceAsyncStreamBase(' + this.f74_1 + ', ' + this.g74_1.toString() + ', ' + this.h74_1.toString() + ')';
  };
  function sliceWithSize_1(_this__u8e3s4, position, length) {
    return sliceWithBounds_0(_this__u8e3s4, position, position.mc(length));
  }
  function sliceStart_0(_this__u8e3s4, start) {
    start = start === VOID ? new Long(0, 0) : start;
    return sliceWithBounds_0(_this__u8e3s4, start, _this__u8e3s4.a());
  }
  function readBytesExact_0(_this__u8e3s4, len) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Int8Array(len);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.stream.readBytesExact.<anonymous>' call
    readExact_0(_this__u8e3s4, this_0, 0, len);
    return this_0;
  }
  function readU16LE_0(_this__u8e3s4) {
    return readU8(_this__u8e3s4) | readU8(_this__u8e3s4) << 8;
  }
  function readS32LE_0(_this__u8e3s4) {
    return readU8(_this__u8e3s4) | readU8(_this__u8e3s4) << 8 | readU8(_this__u8e3s4) << 16 | readU8(_this__u8e3s4) << 24;
  }
  function readU32LE(_this__u8e3s4) {
    return toLong(readU8(_this__u8e3s4) | readU8(_this__u8e3s4) << 8 | readU8(_this__u8e3s4) << 16 | readU8(_this__u8e3s4) << 24).tc(new Long(-1, 0));
  }
  function readS16LE(_this__u8e3s4) {
    return signExtend(readU16LE_0(_this__u8e3s4), 16);
  }
  function readStream_0(_this__u8e3s4, length) {
    return readSlice(_this__u8e3s4, toLong(length));
  }
  function readAvailable(_this__u8e3s4) {
    return readBytes_0(_this__u8e3s4, _this__u8e3s4.m4r().kb());
  }
  function readExact_0(_this__u8e3s4, out, offset, len) {
    var ooffset = offset;
    var remaining = len;
    while (remaining > 0) {
      var read = _this__u8e3s4.t1z(out, ooffset, remaining);
      if (read <= 0) {
        throw RuntimeException_init_$Create$('EOF');
      }
      remaining = remaining - read | 0;
      ooffset = ooffset + read | 0;
    }
  }
  function indexOf_2(_this__u8e3s4, v, startOffset, endOffset, default_0) {
    startOffset = startOffset === VOID ? 0 : startOffset;
    endOffset = endOffset === VOID ? _this__u8e3s4.length : endOffset;
    default_0 = default_0 === VOID ? -1 : default_0;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.util._indexOf' call
      var inductionVariable = startOffset;
      if (inductionVariable < endOffset)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.io.util.indexOf.<anonymous>' call
          var tmp$ret$0 = _this__u8e3s4[n];
          if (equals(tmp$ret$0, v)) {
            tmp$ret$1 = n;
            break $l$block;
          }
        }
         while (inductionVariable < endOffset);
      tmp$ret$1 = default_0;
    }
    return tmp$ret$1;
  }
  function isWhitespaceFast(_this__u8e3s4) {
    return ((_this__u8e3s4 === _Char___init__impl__6a9atx(32) ? true : _this__u8e3s4 === _Char___init__impl__6a9atx(9)) ? true : _this__u8e3s4 === _Char___init__impl__6a9atx(13)) ? true : _this__u8e3s4 === _Char___init__impl__6a9atx(10);
  }
  function isDigit(_this__u8e3s4) {
    return _Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false;
  }
  function isLetterDigitOrUnderscore(_this__u8e3s4) {
    return (isLetterOrDigit(_this__u8e3s4) ? true : _this__u8e3s4 === _Char___init__impl__6a9atx(95)) ? true : _this__u8e3s4 === _Char___init__impl__6a9atx(36);
  }
  function isLetterOrDigit(_this__u8e3s4) {
    return isLetter(_this__u8e3s4) ? true : isDigit(_this__u8e3s4);
  }
  function isLetter(_this__u8e3s4) {
    return (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) ? true : _Char___init__impl__6a9atx(65) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(90) : false;
  }
  function isPrintable(_this__u8e3s4) {
    return (_Char___init__impl__6a9atx(32) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(126) : false) ? true : _Char___init__impl__6a9atx(161) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(255) : false;
  }
  function Text() {
  }
  function Marker() {
  }
  function Line(str) {
    this.k74_1 = str;
  }
  protoOf(Line).j74 = function () {
    return this.k74_1;
  };
  protoOf(Line).toString = function () {
    return 'Line(str=' + this.k74_1 + ')';
  };
  protoOf(Line).hashCode = function () {
    return getStringHashCode(this.k74_1);
  };
  protoOf(Line).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Line))
      return false;
    var tmp0_other_with_cast = other instanceof Line ? other : THROW_CCE();
    if (!(this.k74_1 === tmp0_other_with_cast.k74_1))
      return false;
    return true;
  };
  function LineDeferred() {
  }
  function EmptyLineOnce() {
  }
  var EmptyLineOnce_instance;
  function EmptyLineOnce_getInstance() {
    return EmptyLineOnce_instance;
  }
  function Indent() {
  }
  var Indent_instance;
  function Indent_getInstance() {
    return Indent_instance;
  }
  function Unindent() {
  }
  var Unindent_instance;
  function Unindent_getInstance() {
    return Unindent_instance;
  }
  function INDENTS() {
    INDENTS_instance = this;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(1024), null);
    while (tmp_0 < 1024) {
      tmp_1[tmp_0] = '';
      tmp_0 = tmp_0 + 1 | 0;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.INDENTS.INDENTS.<anonymous>' call
    var indent = StringBuilder_init_$Create$();
    var inductionVariable = 0;
    var last = tmp_1.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp_1[n] = indent.toString();
        indent.u5('\t');
      }
       while (inductionVariable < last);
    tmp.l74_1 = tmp_1;
  }
  protoOf(INDENTS).f1 = function (index) {
    if (index >= this.l74_1.length) {
      // Inline function 'kotlin.TODO' call
      var reason = 'Too much indentation ' + index;
      throw new NotImplementedError('An operation is not implemented: ' + reason);
    }
    return index <= 0 ? '' : this.l74_1[index];
  };
  var INDENTS_instance;
  function INDENTS_getInstance() {
    if (INDENTS_instance == null)
      new INDENTS();
    return INDENTS_instance;
  }
  function Companion_61() {
    Companion_instance_69 = this;
    var tmp = this;
    // Inline function 'korlibs.io.util.Companion.gen' call
    Companion_getInstance_76();
    var indenter = new Indenter();
    // Inline function 'korlibs.io.util.Companion.EMPTY.<anonymous>' call
    tmp.m74_1 = indenter;
  }
  protoOf(Companion_61).n74 = function (init) {
    // Inline function 'korlibs.io.util.Companion.gen' call
    var indenter = new Indenter();
    init(indenter);
    return indenter;
  };
  var Companion_instance_69;
  function Companion_getInstance_76() {
    if (Companion_instance_69 == null)
      new Companion_61();
    return Companion_instance_69;
  }
  function IndenterEvaluator(markHandler, indentEmptyLines, doIndent) {
    this.o74_1 = markHandler;
    this.p74_1 = indentEmptyLines;
    this.q74_1 = doIndent;
    this.r74_1 = StringBuilder_init_$Create$();
    this.s74_1 = 0;
    this.t74_1 = true;
    this.u74_1 = 0;
    this.v74_1 = false;
  }
  protoOf(IndenterEvaluator).w74 = function (str) {
    return this.r74_1.u5(str);
  };
  protoOf(IndenterEvaluator).x74 = function (str) {
    return this.r74_1.v5(str);
  };
  protoOf(IndenterEvaluator).y74 = function () {
    if (this.q74_1) {
      this.x74(_Char___init__impl__6a9atx(10));
    }
    this.s74_1 = this.s74_1 + 1 | 0;
    this.t74_1 = true;
  };
  protoOf(IndenterEvaluator).z74 = function (actions) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < actions.n()) {
      // Inline function 'korlibs.io.util.IndenterEvaluator.eval.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var action = actions.f1(tmp0);
      if (isInterface(action, Text)) {
        if (this.t74_1) {
          var tmp;
          if (!this.p74_1) {
            // Inline function 'kotlin.text.isEmpty' call
            var this_0 = action.j74();
            tmp = charSequenceLength(this_0) === 0;
          } else {
            tmp = false;
          }
          if (tmp) {
            this.y74();
          } else {
            if (this.q74_1) {
              this.w74(INDENTS_getInstance().f1(this.u74_1));
            } else {
              this.w74(' ');
            }
          }
        }
        this.w74(action.j74());
        if (action instanceof Line) {
          var tmp_0 = this;
          var tmp_1 = this.s74_1;
          // Inline function 'kotlin.text.count' call
          var count = 0;
          var indexedObject = action.j74();
          var inductionVariable = 0;
          while (inductionVariable < charSequenceLength(indexedObject)) {
            var element = charSequenceGet(indexedObject, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.io.util.IndenterEvaluator.eval.<anonymous>.<anonymous>' call
            if (element === _Char___init__impl__6a9atx(10)) {
              count = count + 1 | 0;
            }
          }
          tmp_0.s74_1 = tmp_1 + count | 0;
          this.y74();
        } else {
          this.t74_1 = false;
        }
        this.v74_1 = true;
      } else {
        if (action instanceof LineDeferred) {
          this.z74(action.e75_1().b75_1);
        } else {
          if (equals(action, Indent_instance) ? true : equals(action, Unindent_instance)) {
            this.v74_1 = false;
            this.u74_1 = this.u74_1 + (equals(action, Indent_instance) ? 1 : -1) | 0;
          } else {
            if (equals(action, EmptyLineOnce_instance)) {
              if (this.v74_1) {
                this.y74();
                this.v74_1 = false;
              }
            } else {
              if (action instanceof Marker) {
                var tmp3_safe_receiver = this.o74_1;
                if (tmp3_safe_receiver == null)
                  null;
                else
                  tmp3_safe_receiver(this.r74_1, this.s74_1, action.a75_1);
              }
            }
          }
        }
      }
    }
  };
  function Indenter(actions) {
    Companion_getInstance_76();
    var tmp;
    if (actions === VOID) {
      // Inline function 'kotlin.collections.arrayListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = actions;
    }
    actions = tmp;
    this.b75_1 = actions;
    this.c75_1 = true;
    this.d75_1 = '';
  }
  protoOf(Indenter).f75 = function (indenter) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.Indenter.line.<anonymous>' call
    this.b75_1.y(indenter.b75_1);
    return this;
  };
  protoOf(Indenter).g75 = function (str) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.Indenter.line.<anonymous>' call
    this.b75_1.r(new Line(str));
    return this;
  };
  protoOf(Indenter).h75 = function () {
    this.b75_1.r(Indent_instance);
  };
  protoOf(Indenter).i75 = function () {
    this.b75_1.r(Unindent_instance);
  };
  protoOf(Indenter).j75 = function (markHandler, doIndent) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IndenterEvaluator(markHandler, this.c75_1, doIndent);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.Indenter.toString.<anonymous>' call
    this_0.z74(this.b75_1);
    return this_0.r74_1.toString();
  };
  protoOf(Indenter).toString = function () {
    return this.j75(null, true);
  };
  var MINUS_ZERO_D;
  function toStringDecimal(_this__u8e3s4, decimalPlaces, skipTrailingZeros) {
    skipTrailingZeros = skipTrailingZeros === VOID ? false : skipTrailingZeros;
    if (isNanOrInfinite(_this__u8e3s4))
      return _this__u8e3s4.toString();
    var res = normalizeZero(roundDecimalPlaces(_this__u8e3s4, decimalPlaces)).toString();
    var eup = indexOf_1(res, _Char___init__impl__6a9atx(69));
    var elo = indexOf_1(res, _Char___init__impl__6a9atx(101));
    var eIndex = eup >= 0 ? eup : elo;
    var tmp;
    if (eIndex >= 0) {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      var base = res.substring(0, eIndex);
      // Inline function 'kotlin.text.substring' call
      var startIndex = eIndex + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = res.substring(startIndex);
      var exp = toInt_0(tmp$ret$3);
      var rbase = contains_0(base, '.') ? base : base + '.0';
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp$ret$4 = abs(exp);
      var zeros = repeat('0', tmp$ret$4 + 2 | 0);
      var part = exp > 0 ? rbase + zeros : zeros + rbase;
      var pointIndex2 = indexOf(part, '.');
      var pointIndex = pointIndex2 < 0 ? part.length : pointIndex2;
      var outIndex = pointIndex + exp | 0;
      var part2 = replace_0(part, '.', '');
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.util.toStringDecimal.<anonymous>' call
      var tmp$ret$5;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var this_1 = until(0, outIndex);
        var tmp_0;
        if (isInterface(this_1, Collection)) {
          tmp_0 = this_1.b1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$5 = true;
          break $l$block_0;
        }
        var tmp0_iterator = this_1.u();
        while (tmp0_iterator.v()) {
          var element = tmp0_iterator.x();
          // Inline function 'korlibs.io.util.toStringDecimal.<anonymous>.<anonymous>' call
          if (!(charSequenceGet(part2, element) === _Char___init__impl__6a9atx(48))) {
            tmp$ret$5 = false;
            break $l$block_0;
          }
        }
        tmp$ret$5 = true;
      }
      if (tmp$ret$5) {
        this_0.v5(_Char___init__impl__6a9atx(48));
      } else {
        this_0.h8(part2, 0, outIndex);
      }
      this_0.v5(_Char___init__impl__6a9atx(46));
      this_0.h8(part2, outIndex, part2.length);
      tmp = this_0.toString();
    } else {
      tmp = res;
    }
    var rez = tmp;
    var pointIndex_0 = indexOf_1(rez, _Char___init__impl__6a9atx(46));
    var tmp_1;
    if (pointIndex_0 >= 0) {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = rez.substring(0, pointIndex_0);
    } else {
      tmp_1 = rez;
    }
    var integral = tmp_1;
    if (decimalPlaces === 0)
      return integral;
    var tmp_2;
    if (pointIndex_0 >= 0) {
      // Inline function 'kotlin.text.substring' call
      var startIndex_0 = pointIndex_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$12 = rez.substring(startIndex_0);
      tmp_2 = trimEnd(tmp$ret$12, charArrayOf([_Char___init__impl__6a9atx(48)]));
    } else {
      tmp_2 = '';
    }
    var decimal = tmp_2;
    // Inline function 'kotlin.text.buildString' call
    var capacity = (2 + integral.length | 0) + decimalPlaces | 0;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_2 = StringBuilder_init_$Create$_0(capacity);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.toStringDecimal.<anonymous>' call
    this_2.u5(integral);
    var tmp_3;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(decimal) > 0) {
      tmp_3 = true;
    } else {
      tmp_3 = !skipTrailingZeros;
    }
    if (tmp_3) {
      // Inline function 'kotlin.math.min' call
      var a = decimal.length;
      var decimalCount = Math.min(a, decimalPlaces);
      var tmp$ret$15;
      $l$block_2: {
        // Inline function 'kotlin.collections.all' call
        var this_3 = until(0, decimalCount);
        var tmp_4;
        if (isInterface(this_3, Collection)) {
          tmp_4 = this_3.b1();
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          tmp$ret$15 = true;
          break $l$block_2;
        }
        var tmp0_iterator_0 = this_3.u();
        while (tmp0_iterator_0.v()) {
          var element_0 = tmp0_iterator_0.x();
          // Inline function 'korlibs.io.util.toStringDecimal.<anonymous>.<anonymous>' call
          if (!(charSequenceGet(decimal, element_0) === _Char___init__impl__6a9atx(48))) {
            tmp$ret$15 = false;
            break $l$block_2;
          }
        }
        tmp$ret$15 = true;
      }
      var allZeros = tmp$ret$15;
      if (!skipTrailingZeros ? true : !allZeros) {
        this_2.v5(_Char___init__impl__6a9atx(46));
        this_2.h8(decimal, 0, decimalCount);
        if (!skipTrailingZeros) {
          // Inline function 'kotlin.repeat' call
          var times = decimalPlaces - decimalCount | 0;
          // Inline function 'kotlin.contracts.contract' call
          var inductionVariable = 0;
          if (inductionVariable < times)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.io.util.toStringDecimal.<anonymous>.<anonymous>' call
              this_2.v5(_Char___init__impl__6a9atx(48));
            }
             while (inductionVariable < times);
        }
      }
    }
    return this_2.toString();
  }
  function normalizeZero(_this__u8e3s4) {
    return _this__u8e3s4 === MINUS_ZERO_D ? 0.0 : _this__u8e3s4;
  }
  function NumberParser() {
  }
  protoOf(NumberParser).k75 = function (str, start, end, radix) {
    var positive = true;
    var out = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(str, n);
        if (c === _Char___init__impl__6a9atx(45) ? true : c === _Char___init__impl__6a9atx(43)) {
          positive = c === _Char___init__impl__6a9atx(43);
        } else {
          var value = ctypeAsInt(c);
          if (value < 0)
            break loop;
          out = imul(out, radix);
          out = out + value | 0;
        }
      }
       while (inductionVariable < end);
    return positive ? out : -out | 0;
  };
  protoOf(NumberParser).l75 = function (str, start, end) {
    var out = 0.0;
    var frac = 1.0;
    var pointSeen = false;
    var eSeen = false;
    var negate = false;
    var negateExponent = false;
    var exponent = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(str, n);
        if (c === _Char___init__impl__6a9atx(101) ? true : c === _Char___init__impl__6a9atx(69))
          eSeen = true;
        else if (c === _Char___init__impl__6a9atx(45)) {
          if (eSeen)
            negateExponent = true;
          else
            negate = true;
        } else if (c === _Char___init__impl__6a9atx(46))
          pointSeen = true;
        else {
          if (eSeen) {
            exponent = imul(exponent, 10);
            exponent = exponent + ctypeAsInt(c) | 0;
          } else {
            if (pointSeen)
              frac = frac / 10;
            out = out * 10;
            out = out + ctypeAsInt(c);
          }
        }
      }
       while (inductionVariable < end);
    var tmp = out * frac;
    // Inline function 'kotlin.math.pow' call
    var n_0 = negateExponent ? -exponent | 0 : exponent;
    var res = tmp * Math.pow(10.0, n_0);
    return negate ? -res : res;
  };
  var NumberParser_instance;
  function NumberParser_getInstance() {
    return NumberParser_instance;
  }
  function ctypeAsInt(_this__u8e3s4) {
    return (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(48)) >= 0 ? Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(57)) <= 0 : false) ? Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(48)) : (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(97)) >= 0 ? Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(122)) <= 0 : false) ? Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(97)) + 10 | 0 : (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(65)) >= 0 ? Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(90)) <= 0 : false) ? Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(65)) + 10 | 0 : -1;
  }
  function get_LONG_ZERO_TO_MAX_RANGE() {
    _init_properties_RangeExt_kt__vz0y4k();
    return LONG_ZERO_TO_MAX_RANGE;
  }
  var LONG_ZERO_TO_MAX_RANGE;
  function toLongRange(_this__u8e3s4) {
    _init_properties_RangeExt_kt__vz0y4k();
    return toLong(_this__u8e3s4.h9()).eb(toLong(_this__u8e3s4.i9()));
  }
  var properties_initialized_RangeExt_kt_dqkq5i;
  function _init_properties_RangeExt_kt__vz0y4k() {
    if (!properties_initialized_RangeExt_kt_dqkq5i) {
      properties_initialized_RangeExt_kt_dqkq5i = true;
      var tmp = new Long(0, 0);
      Companion_getInstance_13();
      LONG_ZERO_TO_MAX_RANGE = tmp.eb(new Long(-1, 2147483647));
    }
  }
  function get_length(_this__u8e3s4) {
    return (_this__u8e3s4.gb_1 - _this__u8e3s4.fb_1 | 0) + 1 | 0;
  }
  function Companion_62() {
  }
  protoOf(Companion_62).m75 = function (lits) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(lits.length);
    var inductionVariable = 0;
    var last = lits.length;
    while (inductionVariable < last) {
      var item = lits[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.io.util.Companion.fromList.<anonymous>' call
      var tmp$ret$0 = item.length;
      destination.r(tmp$ret$0);
    }
    var this_0 = distinct(reversed(sorted(destination)));
    var lengths = copyToArray(this_0);
    // Inline function 'kotlin.collections.linkedMapOf' call
    var map = LinkedHashMap_init_$Create$();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < lits.length) {
      // Inline function 'korlibs.io.util.Companion.fromList.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = lits[tmp0];
      map.i2(key, true);
    }
    return new Literals(lits, map, lengths);
  };
  var Companion_instance_70;
  function Companion_getInstance_77() {
    return Companion_instance_70;
  }
  function Companion_63() {
  }
  var Companion_instance_71;
  function Companion_getInstance_78() {
    return Companion_instance_71;
  }
  function posSkip($this, count) {
    var out = $this.r6h_1;
    $this.r6h_1 = $this.r6h_1 + count | 0;
    return out;
  }
  function substr_2($this, pos, length) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = $this.p6h_1;
    // Inline function 'kotlin.math.min' call
    var b = $this.t6h_1;
    var startIndex = Math.min(pos, b);
    // Inline function 'kotlin.math.min' call
    var a = pos + length | 0;
    var b_0 = $this.t6h_1;
    var endIndex = Math.min(a, b_0);
    // Inline function 'kotlin.js.asDynamic' call
    return this_0.substring(startIndex, endIndex);
  }
  function Literals(lits, map, lengths) {
    this.n75_1 = lits;
    this.o75_1 = map;
    this.p75_1 = lengths;
  }
  protoOf(Literals).toString = function () {
    return 'Literals(' + joinToString_0(this.n75_1, ' ') + ')';
  };
  function StrReader(str, file, pos) {
    file = file === VOID ? 'file' : file;
    pos = pos === VOID ? 0 : pos;
    BaseStrReader.call(this);
    this.p6h_1 = str;
    this.q6h_1 = file;
    this.r6h_1 = pos;
    this.s6h_1 = charArray(this.p6h_1.length);
    this.t6h_1 = this.p6h_1.length;
  }
  protoOf(StrReader).n46 = function () {
    return this.r6h_1;
  };
  protoOf(StrReader).m4r = function () {
    return this.t6h_1 - this.r6h_1 | 0;
  };
  protoOf(StrReader).f6h = function () {
    return this.r6h_1 >= this.p6h_1.length;
  };
  protoOf(StrReader).q75 = function (start) {
    return this.r75(start, this.r6h_1);
  };
  protoOf(StrReader).s75 = function () {
    protoOf(BaseStrReader).s75.call(this);
    return this;
  };
  protoOf(StrReader).r75 = function (start, end) {
    if (start === end)
      return '';
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.p6h_1.substring(start, end);
  };
  protoOf(StrReader).w1z = function (count) {
    return substr_2(this, this.r6h_1, count);
  };
  protoOf(StrReader).t75 = function () {
    return this.d4b() ? charSequenceGet(this.p6h_1, this.r6h_1) : _Char___init__impl__6a9atx(0);
  };
  protoOf(StrReader).u75 = function (char) {
    var skipPos = indexOf_1(this.p6h_1, char, this.r6h_1);
    this.r6h_1 = skipPos >= 0 ? skipPos : this.t6h_1;
  };
  protoOf(StrReader).v75 = function (char) {
    this.u75(char);
    if (this.d4b() ? this.t75() === char : false) {
      this.u1z(1);
    }
  };
  protoOf(StrReader).w75 = function (char) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.io.util.BaseStrReader.slice' call
      var start = this.x75();
      try {
        // Inline function 'korlibs.io.util.StrReader.readUntil.<anonymous>' call
        this.u75(char);
      }finally {
        tmp$ret$0 = this.q75(start);
        break $l$block;
      }
    }
    return tmp$ret$0;
  };
  protoOf(StrReader).y75 = function (char) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.io.util.BaseStrReader.slice' call
      var start = this.x75();
      try {
        // Inline function 'korlibs.io.util.StrReader.readUntilIncluded.<anonymous>' call
        this.v75(char);
      }finally {
        tmp$ret$0 = this.q75(start);
        break $l$block;
      }
    }
    return tmp$ret$0;
  };
  protoOf(StrReader).z75 = function (count) {
    this.r6h_1 = this.r6h_1 - count | 0;
    return this;
  };
  protoOf(StrReader).a76 = function (count, $super) {
    count = count === VOID ? 1 : count;
    return $super === VOID ? this.z75(count) : $super.z75.call(this, count);
  };
  protoOf(StrReader).b76 = function () {
    return this.d4b() ? charSequenceGet(this.p6h_1, posSkip(this, 1)) : _Char___init__impl__6a9atx(0);
  };
  protoOf(StrReader).c76 = function () {
    return this.d4b() ? charSequenceGet(this.p6h_1, posSkip(this, 1)) : _Char___init__impl__6a9atx(0);
  };
  protoOf(StrReader).w6h = function () {
    return this.d76(this.m4r());
  };
  protoOf(StrReader).u1z = function (count) {
    this.r6h_1 = this.r6h_1 + count | 0;
    return this;
  };
  protoOf(StrReader).e76 = function (lit, consume) {
    if (!substringEquals(StringCompanionObject_instance, this.p6h_1, this.r6h_1, lit, 0, lit.length))
      return null;
    if (consume) {
      this.r6h_1 = this.r6h_1 + lit.length | 0;
    }
    return lit;
  };
  protoOf(StrReader).u6h = function (v) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.p6h_1;
    var startIndex = this.r6h_1;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this_0.substring(startIndex);
    var tmp0_elvis_lhs = v.b9(tmp$ret$1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var result = tmp;
    var m = ensureNotNull(result.x9().f1(0)).j9_1;
    this.r6h_1 = this.r6h_1 + m.length | 0;
    return m;
  };
  protoOf(StrReader).g1s = function () {
    return new StrReader(this.p6h_1, this.q6h_1, this.r6h_1);
  };
  protoOf(StrReader).f76 = function (count, radix) {
    // Inline function 'kotlin.math.min' call
    var a = this.m4r();
    var readCount = Math.min(a, count);
    this.u1z(readCount);
    return NumberParser_instance.k75(this.p6h_1, this.r6h_1 - readCount | 0, this.r6h_1, radix);
  };
  protoOf(StrReader).g76 = function (reportErrors) {
    var out = this.s6h_1;
    var outp = 0;
    var quotec = this.c76();
    if (!(quotec === _Char___init__impl__6a9atx(34) ? true : quotec === _Char___init__impl__6a9atx(39))) {
      invalidOp('Invalid string literal');
    }
    var closed = false;
    loop: while (this.d4b()) {
      var c = this.c76();
      if (c === _Char___init__impl__6a9atx(92)) {
        var cc = this.c76();
        var tmp2 = outp;
        outp = tmp2 + 1 | 0;
        var tmp;
        if (cc === _Char___init__impl__6a9atx(92)) {
          tmp = _Char___init__impl__6a9atx(92);
        } else if (cc === _Char___init__impl__6a9atx(47)) {
          tmp = _Char___init__impl__6a9atx(47);
        } else if (cc === _Char___init__impl__6a9atx(39)) {
          tmp = _Char___init__impl__6a9atx(39);
        } else if (cc === _Char___init__impl__6a9atx(34)) {
          tmp = _Char___init__impl__6a9atx(34);
        } else if (cc === _Char___init__impl__6a9atx(98)) {
          tmp = _Char___init__impl__6a9atx(8);
        } else if (cc === _Char___init__impl__6a9atx(102)) {
          tmp = _Char___init__impl__6a9atx(12);
        } else if (cc === _Char___init__impl__6a9atx(110)) {
          tmp = _Char___init__impl__6a9atx(10);
        } else if (cc === _Char___init__impl__6a9atx(114)) {
          tmp = _Char___init__impl__6a9atx(13);
        } else if (cc === _Char___init__impl__6a9atx(116)) {
          tmp = _Char___init__impl__6a9atx(9);
        } else if (cc === _Char___init__impl__6a9atx(117)) {
          tmp = numberToChar(this.f76(4, 16));
        } else {
          throw new IOException("Invalid char '" + toString_0(cc) + "'");
        }
        out[tmp2] = tmp;
      } else if (c === quotec) {
        closed = true;
        break loop;
      } else {
        var tmp3 = outp;
        outp = tmp3 + 1 | 0;
        out[tmp3] = c;
      }
    }
    if (!closed ? reportErrors : false) {
      throw RuntimeException_init_$Create$("String literal not closed! '" + this.p6h_1 + "'");
    }
    return String_fromCharArray(out, 0, outp);
  };
  protoOf(StrReader).h76 = function (reportErrors, $super) {
    reportErrors = reportErrors === VOID ? true : reportErrors;
    return $super === VOID ? this.g76(reportErrors) : $super.g76.call(this, reportErrors);
  };
  protoOf(StrReader).i76 = function (offset) {
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = this.p6h_1;
    var index = this.r6h_1 + offset | 0;
    var tmp;
    if (index >= 0 ? index <= get_lastIndex_0(this_0) : false) {
      tmp = charSequenceGet(this_0, index);
    } else {
      // Inline function 'korlibs.io.util.StrReader.peekOffset.<anonymous>' call
      tmp = _Char___init__impl__6a9atx(0);
    }
    return tmp;
  };
  function BaseStrReader() {
  }
  protoOf(BaseStrReader).d4b = function () {
    return !this.f6h();
  };
  protoOf(BaseStrReader).t75 = function () {
    return this.i76(0);
  };
  protoOf(BaseStrReader).b76 = function () {
    var out = this.t75();
    this.u1z(1);
    return out;
  };
  protoOf(BaseStrReader).w75 = function (char) {
    var out = StringBuilder_init_$Create$();
    $l$loop: while (this.d4b()) {
      var result = this.t75();
      if (result === char)
        break $l$loop;
      out.v5(result);
      this.u1z(1);
    }
    return out.toString();
  };
  protoOf(BaseStrReader).j76 = function (expected) {
    var readed = this.b76();
    if (!(readed === expected))
      throw IllegalArgumentException_init_$Create$("Expected '" + toString_0(expected) + "' but found '" + toString_0(readed) + "' at " + this.n46());
  };
  protoOf(BaseStrReader).v6h = function (lit, consume, $super) {
    consume = consume === VOID ? true : consume;
    return $super === VOID ? this.e76(lit, consume) : $super.e76.call(this, lit, consume);
  };
  protoOf(BaseStrReader).x75 = function () {
    return this.n46();
  };
  protoOf(BaseStrReader).s75 = function () {
    // Inline function 'korlibs.io.util.BaseStrReader.skipWhile' call
    $l$loop: while (true) {
      var tmp;
      if (this.d4b()) {
        // Inline function 'korlibs.io.util.BaseStrReader.skipSpaces.<anonymous>' call
        var it = this.t75();
        tmp = isWhitespaceFast(it);
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      this.b76();
    }
    return this;
  };
  protoOf(BaseStrReader).k76 = function (str) {
    return !(this.e76(str, true) == null);
  };
  protoOf(BaseStrReader).l76 = function () {
    // Inline function 'kotlin.takeIf' call
    // Inline function 'korlibs.io.util.BaseStrReader.matchWhile' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.util.BaseStrReader.slice' call
      var start = this.x75();
      try {
        // Inline function 'korlibs.io.util.BaseStrReader.matchWhile.<anonymous>' call
        // Inline function 'korlibs.io.util.BaseStrReader.skipWhile' call
        $l$loop: while (true) {
          var tmp;
          if (this.d4b()) {
            // Inline function 'korlibs.io.util.BaseStrReader.matchIdentifier.<anonymous>' call
            var it = this.t75();
            tmp = ((isLetterDigitOrUnderscore(it) ? true : it === _Char___init__impl__6a9atx(45)) ? true : it === _Char___init__impl__6a9atx(126)) ? true : it === _Char___init__impl__6a9atx(58);
          } else {
            tmp = false;
          }
          if (!tmp) {
            break $l$loop;
          }
          this.b76();
        }
      }finally {
        tmp$ret$1 = this.q75(start);
        break $l$block;
      }
    }
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.io.util.BaseStrReader.matchIdentifier.<anonymous>' call
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(tmp$ret$1) > 0) {
      tmp_0 = tmp$ret$1;
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  };
  protoOf(BaseStrReader).m76 = function () {
    var tmp0_subject = this.t75();
    var tmp;
    if (tmp0_subject === _Char___init__impl__6a9atx(39) ? true : tmp0_subject === _Char___init__impl__6a9atx(34)) {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.io.util.BaseStrReader.slice' call
        var start = this.x75();
        try {
          // Inline function 'korlibs.io.util.BaseStrReader.matchSingleOrDoubleQuoteString.<anonymous>' call
          var quoteType = this.b76();
          this.w75(quoteType);
          this.b76();
        }finally {
          tmp$ret$0 = this.q75(start);
          break $l$block;
        }
      }
      tmp = tmp$ret$0;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(BaseStrReader).n76 = function (str, consume) {
    var inductionVariable = 0;
    var last = str.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.i76(n) === charSequenceGet(str, n)))
          return false;
      }
       while (inductionVariable < last);
    if (consume) {
      this.u1z(str.length);
    }
    return true;
  };
  protoOf(BaseStrReader).o76 = function (str, consume, $super) {
    consume = consume === VOID ? true : consume;
    return $super === VOID ? this.n76(str, consume) : $super.n76.call(this, str, consume);
  };
  protoOf(BaseStrReader).p76 = function (str) {
    if (!(this.t75() === str))
      return false;
    this.u1z(1);
    return true;
  };
  protoOf(BaseStrReader).d76 = function (count) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.w1z(count);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.BaseStrReader.read.<anonymous>' call
    this.u1z(count);
    return this_0;
  };
  protoOf(BaseStrReader).q76 = function (expected) {
    var readed = this.d76(expected.length);
    if (!(readed === expected))
      throw IllegalArgumentException_init_$Create$("Expected '" + expected + "' but found '" + readed + "' at " + this.n46());
    return readed;
  };
  function quote(_this__u8e3s4) {
    return quote_0(_this__u8e3s4, false);
  }
  function quote_0(_this__u8e3s4, unicode) {
    return !(_this__u8e3s4 == null) ? '"' + escape(_this__u8e3s4, unicode) + '"' : 'null';
  }
  function escape(_this__u8e3s4, unicode) {
    var out = StringBuilder_init_$Create$_0(_this__u8e3s4.length + 16 | 0);
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    while (inductionVariable < last) {
      var c = charSequenceGet(_this__u8e3s4, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (c === _Char___init__impl__6a9atx(92)) {
        out.u5('\\\\');
      } else if (c === _Char___init__impl__6a9atx(34)) {
        out.u5('\\"');
      } else if (c === _Char___init__impl__6a9atx(10)) {
        out.u5('\\n');
      } else if (c === _Char___init__impl__6a9atx(13)) {
        out.u5('\\r');
      } else if (c === _Char___init__impl__6a9atx(9)) {
        out.u5('\\t');
      } else if (!unicode ? _Char___init__impl__6a9atx(0) <= c ? c <= _Char___init__impl__6a9atx(31) : false : false) {
        out.u5('\\x');
        // Inline function 'kotlin.code' call
        var tmp$ret$0 = Char__toInt_impl_vasixd(c);
        out.v5(charSequenceGet('0123456789abcdef', (tmp$ret$0 >>> 4 | 0) & 15));
        // Inline function 'kotlin.code' call
        var tmp$ret$1 = Char__toInt_impl_vasixd(c);
        out.v5(charSequenceGet('0123456789abcdef', (tmp$ret$1 >>> 0 | 0) & 15));
      } else if (unicode ? !isPrintable(c) : false) {
        out.u5('\\u');
        // Inline function 'kotlin.code' call
        var tmp$ret$2 = Char__toInt_impl_vasixd(c);
        out.v5(charSequenceGet('0123456789abcdef', (tmp$ret$2 >>> 12 | 0) & 15));
        // Inline function 'kotlin.code' call
        var tmp$ret$3 = Char__toInt_impl_vasixd(c);
        out.v5(charSequenceGet('0123456789abcdef', (tmp$ret$3 >>> 8 | 0) & 15));
        // Inline function 'kotlin.code' call
        var tmp$ret$4 = Char__toInt_impl_vasixd(c);
        out.v5(charSequenceGet('0123456789abcdef', (tmp$ret$4 >>> 4 | 0) & 15));
        // Inline function 'kotlin.code' call
        var tmp$ret$5 = Char__toInt_impl_vasixd(c);
        out.v5(charSequenceGet('0123456789abcdef', (tmp$ret$5 >>> 0 | 0) & 15));
      } else {
        out.v5(c);
      }
    }
    return out.toString();
  }
  function unquote(_this__u8e3s4) {
    var tmp;
    if (isQuoted(_this__u8e3s4)) {
      // Inline function 'kotlin.text.substring' call
      var endIndex = _this__u8e3s4.length - 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = _this__u8e3s4.substring(1, endIndex);
      tmp = unescape(tmp$ret$1);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function isQuoted(_this__u8e3s4) {
    return startsWith_0(_this__u8e3s4, _Char___init__impl__6a9atx(34)) ? endsWith_0(_this__u8e3s4, _Char___init__impl__6a9atx(34)) : false;
  }
  function unescape(_this__u8e3s4) {
    var out = StringBuilder_init_$Create$_0(_this__u8e3s4.length);
    var n = 0;
    while (n < _this__u8e3s4.length) {
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var c = charSequenceGet(_this__u8e3s4, tmp0);
      if (c === _Char___init__impl__6a9atx(92)) {
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var c2 = charSequenceGet(_this__u8e3s4, tmp2);
        if (c2 === _Char___init__impl__6a9atx(92)) {
          out.v5(_Char___init__impl__6a9atx(92));
        } else if (c2 === _Char___init__impl__6a9atx(34)) {
          out.v5(_Char___init__impl__6a9atx(34));
        } else if (c2 === _Char___init__impl__6a9atx(110)) {
          out.v5(_Char___init__impl__6a9atx(10));
        } else if (c2 === _Char___init__impl__6a9atx(114)) {
          out.v5(_Char___init__impl__6a9atx(13));
        } else if (c2 === _Char___init__impl__6a9atx(116)) {
          out.v5(_Char___init__impl__6a9atx(9));
        } else if (c2 === _Char___init__impl__6a9atx(120) ? true : c2 === _Char___init__impl__6a9atx(117)) {
          var N = c2 === _Char___init__impl__6a9atx(117) ? 4 : 2;
          // Inline function 'kotlin.text.substring' call
          var startIndex = n;
          var endIndex = n + N | 0;
          // Inline function 'kotlin.js.asDynamic' call
          var chars = _this__u8e3s4.substring(startIndex, endIndex);
          n = n + N | 0;
          out.v5(numberToChar(toInt(chars, 16)));
        } else {
          out.u5('\\' + toString_0(c2));
        }
      } else {
        out.v5(c);
      }
    }
    return out.toString();
  }
  function substringAfterOrNull(_this__u8e3s4, delimiter) {
    return contains_1(_this__u8e3s4, delimiter) ? substringAfter(_this__u8e3s4, delimiter) : null;
  }
  function substringBeforeOrNull(_this__u8e3s4, delimiter) {
    return contains_1(_this__u8e3s4, delimiter) ? substringBefore(_this__u8e3s4, delimiter) : null;
  }
  function Adler32() {
    this.t5u_1 = 65521;
    this.u5u_1 = 1;
  }
  protoOf(Adler32).v5u = function (old, data, offset, len) {
    var s1 = (old >>> 0 | 0) & 65535;
    var s2 = (old >>> 16 | 0) & 65535;
    var inductionVariable = offset;
    var last = offset + len | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        s1 = (s1 + (data[n] & 255) | 0) % 65521 | 0;
        s2 = (s2 + s1 | 0) % 65521 | 0;
      }
       while (inductionVariable < last);
    return s2 << 16 | s1;
  };
  var Adler32_instance;
  function Adler32_getInstance() {
    return Adler32_instance;
  }
  function get_DEBUG_WORKER() {
    _init_properties_Worker_kt__eidt7m();
    return DEBUG_WORKER;
  }
  var DEBUG_WORKER;
  function DemoWorkerTask$execute$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DemoWorkerTask$execute$slambda).a77 = function (params, $completion) {
    var tmp = this.b77(params, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(DemoWorkerTask$execute$slambda).ne = function (p1, $completion) {
    return this.a77((!(p1 == null) ? isInterface(p1, List) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DemoWorkerTask$execute$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        if (tmp === 0) {
          this.gd_1 = 1;
          println('TEST!!!!! ' + this.z76_1);
          return 11;
        } else if (tmp === 1) {
          throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(DemoWorkerTask$execute$slambda).b77 = function (params, completion) {
    var i = new DemoWorkerTask$execute$slambda(completion);
    i.z76_1 = params;
    return i;
  };
  function DemoWorkerTask$execute$slambda_0(resultContinuation) {
    var i = new DemoWorkerTask$execute$slambda(resultContinuation);
    var l = function (params, $completion) {
      return i.a77(params, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DemoWorkerTask() {
    WorkerTask.call(this);
  }
  protoOf(DemoWorkerTask).h77 = function () {
    return this.n77(DemoWorkerTask$execute$slambda_0(null));
  };
  function WorkerTask$runSuspend$slambda($deferred, this$0, $block, resultContinuation) {
    this.b78_1 = $deferred;
    this.c78_1 = this$0;
    this.d78_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WorkerTask$runSuspend$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(WorkerTask$runSuspend$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(WorkerTask$runSuspend$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            var tmp_0 = this;
            tmp_0.e78_1 = this.c78_1;
            this.gd_1 = 2;
            var tmp_1 = this;
            tmp_1.g78_1 = Companion_instance_4;
            var tmp_2 = this;
            tmp_2.h78_1 = this.e78_1;
            this.fd_1 = 1;
            suspendResult = this.d78_1(this.h78_1.p77(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var value = suspendResult;
            this.f78_1 = _Result___init__impl__xyqfz8(value);
            this.gd_1 = 4;
            this.fd_1 = 3;
            continue $sm;
          case 2:
            this.gd_1 = 4;
            var tmp_3 = this.id_1;
            if (tmp_3 instanceof Error) {
              var e = this.id_1;
              var tmp_4 = this;
              tmp_4.f78_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.fd_1 = 3;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 3:
            this.gd_1 = 4;
            var ARGUMENT = this.f78_1;
            completeWith(this.b78_1, ARGUMENT);
            return Unit_instance;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 4) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(WorkerTask$runSuspend$slambda).g5a = function (completion) {
    return new WorkerTask$runSuspend$slambda(this.b78_1, this.c78_1, this.d78_1, completion);
  };
  function WorkerTask$runSuspend$slambda_0($deferred, this$0, $block, resultContinuation) {
    var i = new WorkerTask$runSuspend$slambda($deferred, this$0, $block, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function WorkerTask() {
    this.i77_1 = null;
    this.j77_1 = false;
    var tmp = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp.k77_1 = emptyList();
    this.l77_1 = null;
    this.m77_1 = false;
  }
  protoOf(WorkerTask).o77 = function (_set____db54di) {
    this.k77_1 = _set____db54di;
  };
  protoOf(WorkerTask).p77 = function () {
    if (!this.m77_1) {
      // Inline function 'kotlin.error' call
      var message = 'Must wrap function around runSuspend';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return this.k77_1;
  };
  protoOf(WorkerTask).q77 = function (_set____db54di) {
    this.l77_1 = _set____db54di;
  };
  protoOf(WorkerTask).r77 = function () {
    return this.l77_1;
  };
  protoOf(WorkerTask).n77 = function (block) {
    this.m77_1 = true;
    try {
      if (this.j77_1) {
        this.i77_1 = currentStackTrace();
        return Unit_instance;
      }
      var deferred = CompletableDeferred();
      var tmp = EmptyCoroutineContext_getInstance();
      launchImmediately(tmp, WorkerTask$runSuspend$slambda_0(deferred, this, block, null));
      this.l77_1 = deferred;
    }finally {
      this.m77_1 = false;
    }
  };
  protoOf(WorkerTask).h77 = function () {
    return Unit_instance;
  };
  protoOf(WorkerTask).s77 = function () {
    this.j77_1 = true;
    try {
      this.h77();
      return ensureNotNull(this.i77_1);
    }finally {
      this.j77_1 = false;
    }
  };
  function _WorkerImpl() {
  }
  protoOf(_WorkerImpl).i78 = function () {
    return Unit_instance;
  };
  protoOf(_WorkerImpl).j78 = function () {
    return false;
  };
  function Companion_64() {
  }
  var Companion_instance_72;
  function Companion_getInstance_79() {
    return Companion_instance_72;
  }
  var properties_initialized_Worker_kt_gr88g0;
  function _init_properties_Worker_kt__eidt7m() {
    if (!properties_initialized_Worker_kt_gr88g0) {
      properties_initialized_Worker_kt_gr88g0 = true;
      DEBUG_WORKER = Companion_instance_60.s13('DEBUG_WORKER') === 'true';
    }
  }
  function Companion_65() {
    Companion_instance_73 = this;
    this.k78_1 = new Context(false, false);
    this.l78_1 = new Context(true, true);
  }
  var Companion_instance_73;
  function Companion_getInstance_80() {
    if (Companion_instance_73 == null)
      new Companion_65();
    return Companion_instance_73;
  }
  function Context(optimizedNumericLists, useFastArrayList) {
    Companion_getInstance_80();
    useFastArrayList = useFastArrayList === VOID ? false : useFastArrayList;
    this.m78_1 = optimizedNumericLists;
    this.n78_1 = useFastArrayList;
  }
  protoOf(Context).o78 = function () {
    return this.n78_1 ? FastArrayList_init_$Create$() : ArrayList_init_$Create$();
  };
  protoOf(Context).toString = function () {
    return 'Context(optimizedNumericLists=' + this.m78_1 + ', useFastArrayList=' + this.n78_1 + ')';
  };
  protoOf(Context).hashCode = function () {
    var result = getBooleanHashCode(this.m78_1);
    result = imul(result, 31) + getBooleanHashCode(this.n78_1) | 0;
    return result;
  };
  protoOf(Context).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Context))
      return false;
    var tmp0_other_with_cast = other instanceof Context ? other : THROW_CCE();
    if (!(this.m78_1 === tmp0_other_with_cast.m78_1))
      return false;
    if (!(this.n78_1 === tmp0_other_with_cast.n78_1))
      return false;
    return true;
  };
  function parseBooleanOrNull($this, s, context) {
    var tmp;
    if (s.k76('true')) {
      tmp = true;
    } else if (s.k76('false')) {
      tmp = false;
    } else if (s.k76('null')) {
      tmp = null;
    } else if (s.k76('undefined')) {
      tmp = null;
    } else {
      invalidJson$default($this);
    }
    return tmp;
  }
  function parseObject($this, s, context) {
    s.j76(_Char___init__impl__6a9atx(123));
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.serialization.json.Json.parseObject.<anonymous>' call
    obj: while (true) {
      var tmp0_subject = s.s75().c76();
      if (tmp0_subject === _Char___init__impl__6a9atx(125))
        break obj;
      else if (tmp0_subject === _Char___init__impl__6a9atx(44))
        continue obj;
      else {
        s.a76();
      }
      var tmp = Json_instance.p78(s, context);
      var key = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
      s.s75().j76(_Char___init__impl__6a9atx(58));
      var value = Json_instance.p78(s, context);
      // Inline function 'kotlin.collections.set' call
      this_0.i2(key, value);
    }
    return this_0;
  }
  function parseArray($this, s, context) {
    var out = null;
    var outNumber = null;
    s.j76(_Char___init__impl__6a9atx(91));
    array: while (true) {
      var tmp0_subject = s.s75().c76();
      if (tmp0_subject === _Char___init__impl__6a9atx(93))
        break array;
      else if (tmp0_subject === _Char___init__impl__6a9atx(44))
        continue array;
      else {
        s.a76();
      }
      var v = s.t75();
      if ((out == null ? context.m78_1 : false) ? (_Char___init__impl__6a9atx(48) <= v ? v <= _Char___init__impl__6a9atx(57) : false) ? true : v === _Char___init__impl__6a9atx(45) : false) {
        if (outNumber == null) {
          outNumber = new DoubleArrayList();
        }
        outNumber.s1r(parseNumber($this, s));
      } else {
        if (out == null)
          out = context.o78();
        if (!(outNumber == null)) {
          // Inline function 'korlibs.datastructure.iterators.fastForEach' call
          var this_0 = outNumber;
          var n = 0;
          while (n < this_0.n()) {
            // Inline function 'korlibs.io.serialization.json.Json.parseArray.<anonymous>' call
            var tmp0 = n;
            n = tmp0 + 1 | 0;
            var it = this_0.b1r(tmp0);
            out.r(it);
          }
          outNumber = null;
        }
        out.r($this.p78(s, context));
      }
    }
    var tmp1_elvis_lhs = outNumber;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? out : tmp1_elvis_lhs;
    return tmp2_elvis_lhs == null ? context.o78() : tmp2_elvis_lhs;
  }
  function parseNumber($this, s) {
    var start = s.r6h_1;
    // Inline function 'korlibs.io.util.BaseStrReader.skipWhile' call
    $l$loop: while (true) {
      var tmp;
      if (s.d4b()) {
        // Inline function 'korlibs.io.serialization.json.Json.parseNumber.<anonymous>' call
        var it = s.t75();
        tmp = (((((Char__compareTo_impl_ypi4mb(it, _Char___init__impl__6a9atx(48)) >= 0 ? Char__compareTo_impl_ypi4mb(it, _Char___init__impl__6a9atx(57)) <= 0 : false) ? true : it === _Char___init__impl__6a9atx(46)) ? true : it === _Char___init__impl__6a9atx(101)) ? true : it === _Char___init__impl__6a9atx(69)) ? true : it === _Char___init__impl__6a9atx(45)) ? true : it === _Char___init__impl__6a9atx(43);
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      s.b76();
    }
    var end = s.r6h_1;
    return NumberParser_instance.l75(s.p6h_1, start, end);
  }
  function invalidJson($this, msg) {
    throw new IOException(msg);
  }
  function invalidJson$default($this, msg, $super) {
    msg = msg === VOID ? 'Invalid JSON' : msg;
    return invalidJson($this, msg);
  }
  function Json() {
  }
  protoOf(Json).q78 = function (s, context) {
    return this.p78(new StrReader(s), context);
  };
  protoOf(Json).j6a = function (s, context, $super) {
    context = context === VOID ? Companion_getInstance_80().k78_1 : context;
    return $super === VOID ? this.q78(s, context) : $super.q78.call(this, s, context);
  };
  protoOf(Json).r78 = function (s, context) {
    return get_dyn(this.q78(s, context));
  };
  protoOf(Json).s40 = function (s, context, $super) {
    context = context === VOID ? Companion_getInstance_80().k78_1 : context;
    return $super === VOID ? this.r78(s, context) : $super.r78.call(this, s, context).t40_1;
  };
  protoOf(Json).p78 = function (s, context) {
    var ic = s.s75().t75();
    var tmp;
    if (ic === _Char___init__impl__6a9atx(123)) {
      tmp = parseObject(this, s, context);
    } else if (ic === _Char___init__impl__6a9atx(91)) {
      tmp = parseArray(this, s, context);
    } else if (((((((((((ic === _Char___init__impl__6a9atx(45) ? true : ic === _Char___init__impl__6a9atx(43)) ? true : ic === _Char___init__impl__6a9atx(48)) ? true : ic === _Char___init__impl__6a9atx(49)) ? true : ic === _Char___init__impl__6a9atx(50)) ? true : ic === _Char___init__impl__6a9atx(51)) ? true : ic === _Char___init__impl__6a9atx(52)) ? true : ic === _Char___init__impl__6a9atx(53)) ? true : ic === _Char___init__impl__6a9atx(54)) ? true : ic === _Char___init__impl__6a9atx(55)) ? true : ic === _Char___init__impl__6a9atx(56)) ? true : ic === _Char___init__impl__6a9atx(57)) {
      var dres = parseNumber(this, s);
      tmp = numberToInt(dres) === dres ? numberToInt(dres) : dres;
    } else if (((ic === _Char___init__impl__6a9atx(116) ? true : ic === _Char___init__impl__6a9atx(102)) ? true : ic === _Char___init__impl__6a9atx(110)) ? true : ic === _Char___init__impl__6a9atx(117)) {
      tmp = parseBooleanOrNull(this, s, context);
    } else if (ic === _Char___init__impl__6a9atx(34)) {
      tmp = s.h76();
    } else {
      invalidJson(this, "Not expected '" + toString_0(ic) + "'");
    }
    return tmp;
  };
  var Json_instance;
  function Json_getInstance() {
    return Json_instance;
  }
  function parse$level(stream) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var children = ArrayList_init_$Create$();
    while (stream.v()) {
      var tag = stream.x();
      if (!(tag instanceof ProcessingInstructionTag)) {
        if (tag instanceof CommentTag) {
          children.r(Companion_instance_74.j79(tag.i79_1));
        } else {
          if (tag instanceof Text_0) {
            children.r(tag.f79_1 ? Companion_instance_74.h79(tag.e79_1) : Companion_instance_74.g79(tag.e79_1));
          } else {
            if (tag instanceof OpenCloseTag) {
              var tmp = Companion_instance_74;
              // Inline function 'kotlin.collections.listOf' call
              var tmp$ret$1 = emptyList();
              children.r(tmp.d79(tag.x78_1, tag.y78_1, tmp$ret$1));
            } else {
              if (tag instanceof OpenTag) {
                var out = parse$level(stream);
                var tmp1_safe_receiver = out.t78_1;
                if (!((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w78_1) === tag.u78_1)) {
                  var tmp2_safe_receiver = out.t78_1;
                  throw IllegalArgumentException_init_$Create$('Expected ' + tag.u78_1 + ' but was ' + (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w78_1));
                }
                children.r(new Xml(Type_NODE_getInstance(), tag.u78_1, tag.v78_1, out.s78_1, ''));
              } else {
                if (tag instanceof CloseTag)
                  return new Xml$Companion$parse$Level(children, tag);
                else {
                  throw IllegalArgumentException_init_$Create$('Unhandled ' + tag);
                }
              }
            }
          }
        }
      }
    }
    return new Xml$Companion$parse$Level(children, null);
  }
  function Xml$Companion$parse$Level(children, close) {
    this.s78_1 = children;
    this.t78_1 = close;
  }
  protoOf(Xml$Companion$parse$Level).toString = function () {
    return 'Level(children=' + this.s78_1 + ', close=' + this.t78_1 + ')';
  };
  protoOf(Xml$Companion$parse$Level).hashCode = function () {
    var result = hashCode(this.s78_1);
    result = imul(result, 31) + (this.t78_1 == null ? 0 : this.t78_1.hashCode()) | 0;
    return result;
  };
  protoOf(Xml$Companion$parse$Level).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Xml$Companion$parse$Level))
      return false;
    var tmp0_other_with_cast = other instanceof Xml$Companion$parse$Level ? other : THROW_CCE();
    if (!equals(this.s78_1, tmp0_other_with_cast.s78_1))
      return false;
    if (!equals(this.t78_1, tmp0_other_with_cast.t78_1))
      return false;
    return true;
  };
  var Type_NODE_instance;
  var Type_TEXT_instance;
  var Type_COMMENT_instance;
  var Type_entriesInitialized_0;
  function Type_initEntries_0() {
    if (Type_entriesInitialized_0)
      return Unit_instance;
    Type_entriesInitialized_0 = true;
    Type_NODE_instance = new Type_0('NODE', 0);
    Type_TEXT_instance = new Type_0('TEXT', 1);
    Type_COMMENT_instance = new Type_0('COMMENT', 2);
  }
  function ProcessingInstructionTag(name, attributes) {
    Element_0.call(this);
    this.k79_1 = name;
    this.l79_1 = attributes;
  }
  protoOf(ProcessingInstructionTag).toString = function () {
    return 'ProcessingInstructionTag(name=' + this.k79_1 + ', attributes=' + this.l79_1 + ')';
  };
  protoOf(ProcessingInstructionTag).hashCode = function () {
    var result = getStringHashCode(this.k79_1);
    result = imul(result, 31) + hashCode(this.l79_1) | 0;
    return result;
  };
  protoOf(ProcessingInstructionTag).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessingInstructionTag))
      return false;
    var tmp0_other_with_cast = other instanceof ProcessingInstructionTag ? other : THROW_CCE();
    if (!(this.k79_1 === tmp0_other_with_cast.k79_1))
      return false;
    if (!equals(this.l79_1, tmp0_other_with_cast.l79_1))
      return false;
    return true;
  };
  function OpenCloseTag(name, attributes) {
    Element_0.call(this);
    this.x78_1 = name;
    this.y78_1 = attributes;
  }
  protoOf(OpenCloseTag).toString = function () {
    return 'OpenCloseTag(name=' + this.x78_1 + ', attributes=' + this.y78_1 + ')';
  };
  protoOf(OpenCloseTag).hashCode = function () {
    var result = getStringHashCode(this.x78_1);
    result = imul(result, 31) + hashCode(this.y78_1) | 0;
    return result;
  };
  protoOf(OpenCloseTag).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OpenCloseTag))
      return false;
    var tmp0_other_with_cast = other instanceof OpenCloseTag ? other : THROW_CCE();
    if (!(this.x78_1 === tmp0_other_with_cast.x78_1))
      return false;
    if (!equals(this.y78_1, tmp0_other_with_cast.y78_1))
      return false;
    return true;
  };
  function OpenTag(name, attributes) {
    Element_0.call(this);
    this.u78_1 = name;
    this.v78_1 = attributes;
  }
  protoOf(OpenTag).toString = function () {
    return 'OpenTag(name=' + this.u78_1 + ', attributes=' + this.v78_1 + ')';
  };
  protoOf(OpenTag).hashCode = function () {
    var result = getStringHashCode(this.u78_1);
    result = imul(result, 31) + hashCode(this.v78_1) | 0;
    return result;
  };
  protoOf(OpenTag).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OpenTag))
      return false;
    var tmp0_other_with_cast = other instanceof OpenTag ? other : THROW_CCE();
    if (!(this.u78_1 === tmp0_other_with_cast.u78_1))
      return false;
    if (!equals(this.v78_1, tmp0_other_with_cast.v78_1))
      return false;
    return true;
  };
  function CommentTag(text) {
    Element_0.call(this);
    this.i79_1 = text;
  }
  protoOf(CommentTag).toString = function () {
    return 'CommentTag(text=' + this.i79_1 + ')';
  };
  protoOf(CommentTag).hashCode = function () {
    return getStringHashCode(this.i79_1);
  };
  protoOf(CommentTag).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CommentTag))
      return false;
    var tmp0_other_with_cast = other instanceof CommentTag ? other : THROW_CCE();
    if (!(this.i79_1 === tmp0_other_with_cast.i79_1))
      return false;
    return true;
  };
  function CloseTag(name) {
    Element_0.call(this);
    this.w78_1 = name;
  }
  protoOf(CloseTag).toString = function () {
    return 'CloseTag(name=' + this.w78_1 + ')';
  };
  protoOf(CloseTag).hashCode = function () {
    return getStringHashCode(this.w78_1);
  };
  protoOf(CloseTag).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CloseTag))
      return false;
    var tmp0_other_with_cast = other instanceof CloseTag ? other : THROW_CCE();
    if (!(this.w78_1 === tmp0_other_with_cast.w78_1))
      return false;
    return true;
  };
  function Text_0(text, cdata) {
    cdata = cdata === VOID ? false : cdata;
    Element_0.call(this);
    this.e79_1 = text;
    this.f79_1 = cdata;
  }
  protoOf(Text_0).toString = function () {
    return 'Text(text=' + this.e79_1 + ', cdata=' + this.f79_1 + ')';
  };
  protoOf(Text_0).hashCode = function () {
    var result = getStringHashCode(this.e79_1);
    result = imul(result, 31) + getBooleanHashCode(this.f79_1) | 0;
    return result;
  };
  protoOf(Text_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Text_0))
      return false;
    var tmp0_other_with_cast = other instanceof Text_0 ? other : THROW_CCE();
    if (!(this.e79_1 === tmp0_other_with_cast.e79_1))
      return false;
    if (!(this.f79_1 === tmp0_other_with_cast.f79_1))
      return false;
    return true;
  };
  function matchStringOrId(_this__u8e3s4, $this) {
    var tmp0_elvis_lhs = _this__u8e3s4.m76();
    return tmp0_elvis_lhs == null ? _this__u8e3s4.l76() : tmp0_elvis_lhs;
  }
  function xmlSequence($this, r) {
    return sequence(Xml$Stream$xmlSequence$slambda_0(r, null));
  }
  function Xml2Iterable(reader2) {
    this.m79_1 = reader2;
    this.n79_1 = this.m79_1.g1s();
  }
  protoOf(Xml2Iterable).u = function () {
    return xmlSequence(Stream_instance, this.n79_1).u();
  };
  function Element_0() {
  }
  function Xml$Stream$xmlSequence$slambda($r, resultContinuation) {
    this.w79_1 = $r;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Xml$Stream$xmlSequence$slambda).a7a = function ($this$sequence, $completion) {
    var tmp = this.b7a($this$sequence, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Xml$Stream$xmlSequence$slambda).ne = function (p1, $completion) {
    return this.a7a(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Xml$Stream$xmlSequence$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 7;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!!this.w79_1.f6h()) {
              this.fd_1 = 6;
              continue $sm;
            }

            var tmp_0 = this;
            var tmp0_elvis_lhs = this.w79_1.w75(_Char___init__impl__6a9atx(60));
            tmp_0.y79_1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            var this_0 = this.y79_1;
            if (charSequenceLength(this_0) > 0) {
              this.fd_1 = 2;
              suspendResult = this.x79_1.ig(new Text_0(Entities_getInstance().f7a(this.y79_1)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 3;
              continue $sm;
            }

          case 2:
            this.fd_1 = 3;
            continue $sm;
          case 3:
            if (this.w79_1.f6h()) {
              this.fd_1 = 6;
              continue $sm;
            } else {
              this.fd_1 = 4;
              continue $sm;
            }

          case 4:
            this.w79_1.j76(_Char___init__impl__6a9atx(60));
            var tmp_1 = this;
            var tmp_2;
            if (this.w79_1.o76('![CDATA[')) {
              var tmp$ret$2;
              l$ret$3: do {
                var this_1 = this.w79_1;
                var start = this_1.x75();
                l$ret$1: do {
                  try {
                    $l$loop: while (!this.w79_1.f6h() && !this.w79_1.n76(']]>', false)) {
                      this.w79_1.u1z(1);
                    }
                    break l$ret$1;
                  } catch ($p) {
                    var t = $p;
                    tmp$ret$2 = this_1.q75(start);
                    break l$ret$3;
                  }
                }
                 while (false);
                tmp$ret$2 = this_1.q75(start);
                break l$ret$3;
              }
               while (false);
              var text = tmp$ret$2;
              this.w79_1.q76(']]>');
              var this_2 = new Text_0(text);
              this_2.f79_1 = true;
              tmp_2 = this_2;
            } else if (this.w79_1.o76('!--')) {
              var tmp$ret$6;
              l$ret$7: do {
                var this_3 = this.w79_1;
                var start_0 = this_3.x75();
                l$ret$5: do {
                  try {
                    $l$loop_0: while (!this.w79_1.f6h() && !this.w79_1.n76('-->', false)) {
                      this.w79_1.u1z(1);
                    }
                    break l$ret$5;
                  } catch ($p) {
                    var t_0 = $p;
                    tmp$ret$6 = this_3.q75(start_0);
                    break l$ret$7;
                  }
                }
                 while (false);
                tmp$ret$6 = this_3.q75(start_0);
                break l$ret$7;
              }
               while (false);
              var text_0 = tmp$ret$6;
              this.w79_1.q76('-->');
              tmp_2 = new CommentTag(text_0);
            } else {
              this.w79_1.s75();
              var processingInstruction = this.w79_1.p76(_Char___init__impl__6a9atx(63));
              var processingEntityOrDocType = this.w79_1.p76(_Char___init__impl__6a9atx(33));
              var close = this.w79_1.p76(_Char___init__impl__6a9atx(47)) ? true : processingEntityOrDocType;
              this.w79_1.s75();
              var tmp1_elvis_lhs = this.w79_1.l76();
              var tmp_3;
              if (tmp1_elvis_lhs == null) {
                var message = "Couldn't match identifier after '<', offset=" + this.w79_1.n46() + ", around='" + this.w79_1.w1z(10) + "'";
                throw IllegalStateException_init_$Create$(toString(message));
              } else {
                tmp_3 = tmp1_elvis_lhs;
              }
              var name = tmp_3;
              this.w79_1.s75();
              var attributes = LinkedHashMap_init_$Create$();
              while ((!(this.w79_1.t75() === _Char___init__impl__6a9atx(63)) ? !(this.w79_1.t75() === _Char___init__impl__6a9atx(47)) : false) ? !(this.w79_1.t75() === _Char___init__impl__6a9atx(62)) : false) {
                var tmp2_elvis_lhs = matchStringOrId(this.w79_1, Stream_instance);
                var tmp_4;
                if (tmp2_elvis_lhs == null) {
                  throw IllegalArgumentException_init_$Create$('Malformed document or unsupported xml construct around ~' + this.w79_1.w1z(10) + "~ for name '" + name + "'");
                } else {
                  tmp_4 = tmp2_elvis_lhs;
                }
                var key = tmp_4;
                this.w79_1.s75();
                if (this.w79_1.o76('=')) {
                  this.w79_1.s75();
                  var argsQuote = matchStringOrId(this.w79_1, Stream_instance);
                  var tmp_5;
                  if (!(argsQuote == null) ? !(startsWith(argsQuote, "'") ? true : startsWith(argsQuote, '"')) : false) {
                    tmp_5 = argsQuote;
                  } else if (!(argsQuote == null)) {
                    var tmp_6 = Entities_getInstance();
                    var endIndex = argsQuote.length - 1 | 0;
                    tmp_5 = tmp_6.f7a(argsQuote.substring(1, endIndex));
                  } else {
                    tmp_5 = Entities_getInstance().f7a(ensureNotNull(this.w79_1.l76()));
                  }
                  var value = tmp_5;
                  attributes.i2(key, value);
                } else {
                  attributes.i2(key, key);
                }
                this.w79_1.s75();
              }
              var openclose = this.w79_1.p76(_Char___init__impl__6a9atx(47));
              var processingInstructionEnd = this.w79_1.p76(_Char___init__impl__6a9atx(63));
              this.w79_1.j76(_Char___init__impl__6a9atx(62));
              tmp_2 = (processingInstruction ? true : processingEntityOrDocType) ? new ProcessingInstructionTag(name, attributes) : openclose ? new OpenCloseTag(name, attributes) : close ? new CloseTag(name) : new OpenTag(name, attributes);
            }

            tmp_1.z79_1 = tmp_2;
            this.fd_1 = 5;
            suspendResult = this.x79_1.ig(this.z79_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.fd_1 = 1;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 7) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(Xml$Stream$xmlSequence$slambda).b7a = function ($this$sequence, completion) {
    var i = new Xml$Stream$xmlSequence$slambda(this.w79_1, completion);
    i.x79_1 = $this$sequence;
    return i;
  };
  function Xml$Stream$xmlSequence$slambda_0($r, resultContinuation) {
    var i = new Xml$Stream$xmlSequence$slambda($r, resultContinuation);
    var l = function ($this$sequence, $completion) {
      return i.a7a($this$sequence, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function Companion_66() {
    this.z78_1 = '_raw_';
    this.a79_1 = '_text_';
    this.b79_1 = '_cdata_';
    this.c79_1 = '_comment_';
  }
  protoOf(Companion_66).d79 = function (tagName, attributes, children) {
    var tmp = Type_NODE_getInstance();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = attributes.k2().u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.io.serialization.xml.Companion.Tag.<anonymous>' call
      if (!(element.m2() == null)) {
        destination.i2(element.l2(), element.m2());
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(destination.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = destination.k2().u();
    while (tmp0_iterator_0.v()) {
      var item = tmp0_iterator_0.x();
      // Inline function 'korlibs.io.serialization.xml.Companion.Tag.<anonymous>' call
      var tmp$ret$5 = to(item.l2(), toString_1(item.m2()));
      destination_0.r(tmp$ret$5);
    }
    return new Xml(tmp, tagName, toMap(destination_0), children, '');
  };
  protoOf(Companion_66).g79 = function (text) {
    var tmp = Type_TEXT_getInstance();
    var tmp_0 = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    return new Xml(tmp, '_text_', tmp_0, tmp$ret$0, text);
  };
  protoOf(Companion_66).h79 = function (text) {
    var tmp = Type_TEXT_getInstance();
    var tmp_0 = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    return new Xml(tmp, '_cdata_', tmp_0, tmp$ret$0, text);
  };
  protoOf(Companion_66).j79 = function (text) {
    var tmp = Type_COMMENT_getInstance();
    var tmp_0 = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    return new Xml(tmp, '_comment_', tmp_0, tmp$ret$0, text);
  };
  protoOf(Companion_66).g7a = function (str) {
    try {
      var stream = Stream_instance.g7a(str).u();
      var children = parse$level(stream).s78_1;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = children.u();
        while (tmp0_iterator.v()) {
          var element = tmp0_iterator.x();
          // Inline function 'korlibs.io.serialization.xml.Companion.parse.<anonymous>' call
          if (element.g40_1.equals(Type_NODE_getInstance())) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var tmp0_elvis_lhs = tmp$ret$1;
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull_0(children) : tmp0_elvis_lhs;
      return tmp1_elvis_lhs == null ? Companion_instance_74.g79('') : tmp1_elvis_lhs;
    } catch ($p) {
      if ($p instanceof NoSuchElementException) {
        var t = $p;
        println('ERROR: XML: ' + str + ' thrown a NoSuchElementException');
        return Companion_instance_74.g79('!!ERRORED!!');
      } else {
        throw $p;
      }
    }
  };
  var Companion_instance_74;
  function Companion_getInstance_81() {
    return Companion_instance_74;
  }
  function Type_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Entities() {
    Entities_instance = this;
    this.c7a_1 = linkedMapOf([to(new Char(_Char___init__impl__6a9atx(34)), '&quot;'), to(new Char(_Char___init__impl__6a9atx(39)), '&apos;'), to(new Char(_Char___init__impl__6a9atx(60)), '&lt;'), to(new Char(_Char___init__impl__6a9atx(62)), '&gt;'), to(new Char(_Char___init__impl__6a9atx(38)), '&amp;')]);
    var tmp = this;
    var tmp_0 = Companion_instance_70;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.c7a_1.h2();
    var tmp$ret$0 = copyToArray(this_0);
    tmp.d7a_1 = tmp_0.m75(tmp$ret$0);
    this.e7a_1 = flip(this.c7a_1);
  }
  protoOf(Entities).h7a = function (str) {
    // Inline function 'korlibs.io.lang.eachBuilder' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.lang.eachBuilder.<anonymous>' call
    var inductionVariable = 0;
    var last = str.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.io.serialization.xml.Entities.encode.<anonymous>' call
        var it = charSequenceGet(str, n);
        var entry = Entities_getInstance().c7a_1.s2(new Char(it));
        if (!(entry == null)) {
          this_0.u5(entry);
        } else {
          this_0.v5(it);
        }
      }
       while (inductionVariable < last);
    return this_0.toString();
  };
  protoOf(Entities).f7a = function (str) {
    return this.i7a(new StrReader(str));
  };
  protoOf(Entities).i7a = function (r) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.serialization.xml.Entities.decode.<anonymous>' call
    $l$loop: while (!r.f6h()) {
      this_0.u5(r.w75(_Char___init__impl__6a9atx(38)));
      if (r.f6h())
        break $l$loop;
      r.j76(_Char___init__impl__6a9atx(38));
      var tmp0_elvis_lhs = r.y75(_Char___init__impl__6a9atx(59));
      var value = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      var full = '&' + value;
      if (startsWith_0(value, _Char___init__impl__6a9atx(35))) {
        var base = 10;
        // Inline function 'kotlin.text.substring' call
        var endIndex = value.length - 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        var str = value.substring(1, endIndex);
        if (startsWith(str, 'x')) {
          base = 16;
          // Inline function 'kotlin.text.substring' call
          // Inline function 'kotlin.js.asDynamic' call
          str = str.substring(1);
        }
        var tmp1_safe_receiver = toIntOrNull_0(str, base);
        var tmp = tmp1_safe_receiver == null ? null : numberToChar(tmp1_safe_receiver);
        this_0.t5(tmp == null ? null : new Char(tmp));
      } else {
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var this_1 = Entities_getInstance().e7a_1;
        if ((isInterface(this_1, Map) ? this_1 : THROW_CCE()).p2(full)) {
          this_0.t5(Entities_getInstance().e7a_1.s2(full));
        } else {
          this_0.u5(full);
        }
      }
    }
    return this_0.toString();
  };
  var Entities_instance;
  function Entities_getInstance() {
    if (Entities_instance == null)
      new Entities();
    return Entities_instance;
  }
  function Stream() {
  }
  protoOf(Stream).g7a = function (str) {
    return this.j7a(new StrReader(str));
  };
  protoOf(Stream).j7a = function (r) {
    return new Xml2Iterable(r);
  };
  var Stream_instance;
  function Stream_getInstance() {
    return Stream_instance;
  }
  function Type_NODE_getInstance() {
    Type_initEntries_0();
    return Type_NODE_instance;
  }
  function Type_TEXT_getInstance() {
    Type_initEntries_0();
    return Type_TEXT_instance;
  }
  function Type_COMMENT_getInstance() {
    Type_initEntries_0();
    return Type_COMMENT_instance;
  }
  function Xml(type, name, attributes, allChildren, content) {
    this.g40_1 = type;
    this.h40_1 = name;
    this.i40_1 = attributes;
    this.j40_1 = allChildren;
    this.k40_1 = content;
    this.l40_1 = toCaseInsensitiveMap(this.i40_1);
    var tmp = this;
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = this.h40_1.toLowerCase();
    tmp.m40_1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  }
  protoOf(Xml).k7a = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = toList_2(this.i40_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.io.serialization.xml.Xml.<get-attributesStr>.<anonymous>' call
      var tmp$ret$0 = ' ' + item.ag_1 + '="' + item.bg_1 + '"';
      destination.r(tmp$ret$0);
    }
    return joinToString(destination, '');
  };
  protoOf(Xml).l7a = function () {
    var tmp;
    switch (this.g40_1.ka_1) {
      case 0:
        var tmp_0;
        if (this.j40_1.b1()) {
          tmp_0 = '<' + this.h40_1 + this.k7a() + '/>';
        } else {
          // Inline function 'kotlin.collections.map' call
          var this_0 = this.j40_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
          var tmp0_iterator = this_0.u();
          while (tmp0_iterator.v()) {
            var item = tmp0_iterator.x();
            // Inline function 'korlibs.io.serialization.xml.Xml.<get-outerXml>.<anonymous>' call
            var tmp$ret$0 = item.l7a();
            destination.r(tmp$ret$0);
          }
          var children = joinToString(destination, '');
          tmp_0 = '<' + this.h40_1 + this.k7a() + '>' + children + '<\/' + this.h40_1 + '>';
        }

        tmp = tmp_0;
        break;
      case 1:
        switch (this.h40_1) {
          case '_text_':
            tmp = Entities_getInstance().h7a(this.k40_1);
            break;
          case '_cdata_':
            tmp = '<![CDATA[' + this.k40_1 + ']]>';
            break;
          case '_raw_':
            tmp = this.k40_1;
            break;
          default:
            tmp = this.k40_1;
            break;
        }

        break;
      case 2:
        tmp = '<!--' + this.k40_1 + '-->';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(Xml).s13 = function (name) {
    return this.m7a(name);
  };
  protoOf(Xml).m7a = function (name) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.j40_1;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.io.serialization.xml.Xml.children.<anonymous>' call
      if (equals_0(element.h40_1, name, true)) {
        destination.r(element);
      }
    }
    return destination;
  };
  protoOf(Xml).n7a = function (name, defaultValue) {
    var tmp0_safe_receiver = this.l40_1.s2(name);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? defaultValue : tmp1_elvis_lhs;
  };
  protoOf(Xml).p40 = function (name, defaultValue, $super) {
    defaultValue = defaultValue === VOID ? 0 : defaultValue;
    return $super === VOID ? this.n7a(name, defaultValue) : $super.n7a.call(this, name, defaultValue);
  };
  protoOf(Xml).o7a = function (name, defaultValue) {
    var tmp0_elvis_lhs = this.l40_1.s2(name);
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  };
  protoOf(Xml).q40 = function (name, defaultValue, $super) {
    defaultValue = defaultValue === VOID ? '' : defaultValue;
    return $super === VOID ? this.o7a(name, defaultValue) : $super.o7a.call(this, name, defaultValue);
  };
  protoOf(Xml).n40 = function (name) {
    var tmp0_safe_receiver = this.l40_1.s2(name);
    return tmp0_safe_receiver == null ? null : toDoubleOrNull(tmp0_safe_receiver);
  };
  protoOf(Xml).o40 = function (name) {
    return this.l40_1.s2(name);
  };
  protoOf(Xml).toString = function () {
    return this.l7a();
  };
  protoOf(Xml).hashCode = function () {
    var result = this.g40_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.h40_1) | 0;
    result = imul(result, 31) + hashCode(this.i40_1) | 0;
    result = imul(result, 31) + hashCode(this.j40_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k40_1) | 0;
    return result;
  };
  protoOf(Xml).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Xml))
      return false;
    var tmp0_other_with_cast = other instanceof Xml ? other : THROW_CCE();
    if (!this.g40_1.equals(tmp0_other_with_cast.g40_1))
      return false;
    if (!(this.h40_1 === tmp0_other_with_cast.h40_1))
      return false;
    if (!equals(this.i40_1, tmp0_other_with_cast.i40_1))
      return false;
    if (!equals(this.j40_1, tmp0_other_with_cast.j40_1))
      return false;
    if (!(this.k40_1 === tmp0_other_with_cast.k40_1))
      return false;
    return true;
  };
  function Xml_0(str) {
    return Companion_instance_74.g7a(str);
  }
  function get_2(_this__u8e3s4, name) {
    return children(_this__u8e3s4, name);
  }
  function children(_this__u8e3s4, name) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = _this__u8e3s4.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.io.serialization.xml.children.<anonymous>' call
      var list = element.m7a(name);
      addAll(destination, list);
    }
    return destination;
  }
  function get_nativeSoundProvider() {
    _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
    // Inline function 'kotlin.getValue' call
    var this_0 = nativeSoundProvider$delegate;
    nativeSoundProvider$factory();
    return this_0.m2();
  }
  var nativeSoundProvider$delegate;
  function HtmlNativeSoundProvider() {
    NativeSoundProviderNew.call(this);
    HtmlSimpleSound_getInstance().u7a();
  }
  function nativeSoundProvider$delegate$lambda() {
    _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
    var tmp;
    if (Companion_instance_5.s1p()) {
      tmp = new HtmlNativeSoundProvider();
    } else {
      tmp = Companion_getInstance_18();
    }
    return tmp;
  }
  function nativeSoundProvider$factory() {
    return getPropertyCallableRef('nativeSoundProvider', 0, KProperty0, function () {
      return get_nativeSoundProvider();
    }, null);
  }
  var properties_initialized_HtmlNativeSoundProvider_kt_uyp32m;
  function _init_properties_HtmlNativeSoundProvider_kt__ocy1lg() {
    if (!properties_initialized_HtmlNativeSoundProvider_kt_uyp32m) {
      properties_initialized_HtmlNativeSoundProvider_kt_uyp32m = true;
      nativeSoundProvider$delegate = lazy(nativeSoundProvider$delegate$lambda);
    }
  }
  function HtmlSimpleSound$lambda$lambda($source) {
    return function () {
      $source.disconnect(0);
      HtmlSimpleSound_getInstance().r7a_1 = true;
      // Inline function 'korlibs.logger.Logger.info' call
      var this_0 = HtmlSimpleSound_getInstance().p7a_1;
      var level = Level_INFO_getInstance();
      var tmp;
      if (this_0.f25(level)) {
        // Inline function 'korlibs.audio.sound.HtmlSimpleSound.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$0 = 'Web Audio was successfully unlocked';
        this_0.g25(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      HtmlSimpleSound_getInstance().s7a_1.d1g(Unit_instance);
      return Unit_instance;
    };
  }
  function HtmlSimpleSound$lambda($unlock, $_scratchBuffer) {
    return function (it) {
      var tmp = document;
      var tmp_0;
      if ($unlock._v == null) {
        throwUninitializedPropertyAccessException('unlock');
      } else {
        tmp_0 = $unlock._v;
      }
      tmp.removeEventListener('keydown', tmp_0, true);
      var tmp_1 = document;
      var tmp_2;
      if ($unlock._v == null) {
        throwUninitializedPropertyAccessException('unlock');
      } else {
        tmp_2 = $unlock._v;
      }
      tmp_1.removeEventListener('touchstart', tmp_2, true);
      var tmp_3 = document;
      var tmp_4;
      if ($unlock._v == null) {
        throwUninitializedPropertyAccessException('unlock');
      } else {
        tmp_4 = $unlock._v;
      }
      tmp_3.removeEventListener('touchend', tmp_4, true);
      var tmp_5 = document;
      var tmp_6;
      if ($unlock._v == null) {
        throwUninitializedPropertyAccessException('unlock');
      } else {
        tmp_6 = $unlock._v;
      }
      tmp_5.removeEventListener('mousedown', tmp_6, true);
      var tmp_7;
      if (!(HtmlSimpleSound_getInstance().q7a_1 == null)) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = window.globalAudioContext;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.resume();
        }
        var source = HtmlSimpleSound_getInstance().q7a_1.createBufferSource();
        source.buffer = $_scratchBuffer;
        source.connect(HtmlSimpleSound_getInstance().q7a_1.destination);
        source.start(0.0);
        // Inline function 'kotlin.js.asDynamic' call
        if (typeof HtmlSimpleSound_getInstance().q7a_1.resume === 'function') {
          // Inline function 'kotlin.js.asDynamic' call
          HtmlSimpleSound_getInstance().q7a_1.resume();
        }
        source.onended = HtmlSimpleSound$lambda$lambda(source);
        tmp_7 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HtmlSimpleSound() {
    HtmlSimpleSound_instance = this;
    this.p7a_1 = Companion_getInstance_6().r24('HtmlSimpleSound');
    var tmp = this;
    var tmp_0;
    try {
      // Inline function 'kotlin.also' call
      var tmp_1;
      // Inline function 'kotlin.js.asDynamic' call
      if (!(typeof window.AudioContext === 'undefined')) {
        tmp_1 = new AudioContext();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        if (!(typeof window.webkitAudioContext === 'undefined')) {
          tmp_1 = new webkitAudioContext();
        } else {
          tmp_1 = null;
        }
      }
      var this_0 = tmp_1;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.audio.sound.HtmlSimpleSound.ctx.<anonymous>' call
      // Inline function 'kotlin.js.asDynamic' call
      window.globalAudioContext = this_0;
      tmp_0 = this_0;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = this.p7a_1;
        var level = Level_ERROR_getInstance();
        var tmp_3;
        if (this_1.f25(level)) {
          // Inline function 'korlibs.audio.sound.HtmlSimpleSound.ctx.<anonymous>' call
          this_1.g25(level, e);
          tmp_3 = Unit_instance;
        }
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    tmp.q7a_1 = tmp_0;
    this.r7a_1 = false;
    this.s7a_1 = CompletableDeferred(Job());
    var tmp_4 = this;
    var tmp_5 = this.s7a_1;
    tmp_4.t7a_1 = isInterface(tmp_5, Deferred) ? tmp_5 : THROW_CCE();
    var tmp0_safe_receiver = this.q7a_1;
    var _scratchBuffer = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createBuffer(1, 1, 22050);
    var unlock = {_v: null};
    unlock._v = HtmlSimpleSound$lambda(unlock, _scratchBuffer);
    var tmp_6 = document;
    var tmp_7;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_7 = unlock._v;
    }
    tmp_6.addEventListener('keydown', tmp_7, true);
    var tmp_8 = document;
    var tmp_9;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_9 = unlock._v;
    }
    tmp_8.addEventListener('touchstart', tmp_9, true);
    var tmp_10 = document;
    var tmp_11;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_11 = unlock._v;
    }
    tmp_10.addEventListener('touchend', tmp_11, true);
    var tmp_12 = document;
    var tmp_13;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_13 = unlock._v;
    }
    tmp_12.addEventListener('mousedown', tmp_13, true);
  }
  protoOf(HtmlSimpleSound).u7a = function () {
  };
  var HtmlSimpleSound_instance;
  function HtmlSimpleSound_getInstance() {
    if (HtmlSimpleSound_instance == null)
      new HtmlSimpleSound();
    return HtmlSimpleSound_instance;
  }
  function HtmlCanvas() {
  }
  protoOf(HtmlCanvas).v7a = function (width, height) {
    if (Companion_instance_5.r1p()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on Node.JS';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    return toLike(out);
  };
  var HtmlCanvas_instance;
  function HtmlCanvas_getInstance() {
    return HtmlCanvas_instance;
  }
  function toLike(_this__u8e3s4) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4;
  }
  function toHtmlNative(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof HtmlNativeImage) {
      tmp = _this__u8e3s4;
    } else {
      tmp = HtmlNativeImage_init_$Create$_0(HtmlImage_instance.w7a(_this__u8e3s4.g3a()));
    }
    return tmp;
  }
  function HtmlImage() {
  }
  protoOf(HtmlImage).x7a = function (width, height) {
    return HtmlCanvas_instance.v7a(width, height);
  };
  protoOf(HtmlImage).y7a = function (bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        // Inline function 'org.khronos.webgl.set' call
        var tmp1 = m;
        m = tmp1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[tmp1] = _RGBA___get_r__impl__duz7mo(c);
        // Inline function 'org.khronos.webgl.set' call
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[tmp2] = _RGBA___get_g__impl__o8pukr(c);
        // Inline function 'org.khronos.webgl.set' call
        var tmp3 = m;
        m = tmp3 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[tmp3] = _RGBA___get_b__impl__m6tl80(c);
        // Inline function 'org.khronos.webgl.set' call
        var tmp4 = m;
        m = tmp4 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[tmp4] = _RGBA___get_a__impl__6msvu7(c);
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  };
  protoOf(HtmlImage).z7a = function (bmp, canvas) {
    return this.y7a(_RgbaArray___init__impl__oib4y4(bmp.c3l().v3a_1), bmp.t39_1, bmp.u39_1, canvas);
  };
  protoOf(HtmlImage).w7a = function (bmp) {
    return this.z7a(bmp, this.x7a(bmp.t39_1, bmp.u39_1));
  };
  var HtmlImage_instance;
  function HtmlImage_getInstance() {
    return HtmlImage_instance;
  }
  function get_nativeImageFormatProvider() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return nativeImageFormatProvider;
  }
  var nativeImageFormatProvider;
  function get_tempB() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return tempB;
  }
  var tempB;
  function get_tempI() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return tempI;
  }
  var tempI;
  function get_temp8() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return temp8;
  }
  var temp8;
  function get_isLittleEndian() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    // Inline function 'kotlin.getValue' call
    var this_0 = isLittleEndian$delegate;
    isLittleEndian$factory();
    return this_0.m2();
  }
  var isLittleEndian$delegate;
  function NodeJsNativeImageFormatProvider() {
    NodeJsNativeImageFormatProvider_instance = this;
    BaseNativeImageFormatProvider.call(this);
  }
  protoOf(NodeJsNativeImageFormatProvider).v52 = function () {
    return get_RegisteredImageFormats();
  };
  var NodeJsNativeImageFormatProvider_instance;
  function NodeJsNativeImageFormatProvider_getInstance() {
    if (NodeJsNativeImageFormatProvider_instance == null)
      new NodeJsNativeImageFormatProvider();
    return NodeJsNativeImageFormatProvider_instance;
  }
  function $decodeInternalCOROUTINE$286(_this__u8e3s4, data, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i7b_1 = _this__u8e3s4;
    this.j7b_1 = data;
    this.k7b_1 = props;
  }
  protoOf($decodeInternalCOROUTINE$286).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = BrowserImage_instance.l7b(this.j7b_1, this.k7b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = HtmlNativeImage_init_$Create$_0(ARGUMENT);
            return new NativeImageResult(ARGUMENT_0);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $decodeInternalCOROUTINE$287(_this__u8e3s4, vfs, path, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u7b_1 = _this__u8e3s4;
    this.v7b_1 = vfs;
    this.w7b_1 = path;
    this.x7b_1 = props;
  }
  protoOf($decodeInternalCOROUTINE$287).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            this.y7b_1 = this.v7b_1;
            var tmp_0 = this.y7b_1;
            if (tmp_0 instanceof LocalVfs) {
              this.fd_1 = 4;
              suspendResult = BrowserImage_instance.d7c(this.w7b_1, this.x7b_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this.y7b_1;
              if (tmp_1 instanceof UrlVfs_0) {
                this.a7c_1 = this.v7b_1.o6e(this.w7b_1);
                this.fd_1 = 3;
                suspendResult = BrowserImage_instance.d7c(this.a7c_1, this.x7b_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.b7c_1 = BrowserImage_instance;
                this.fd_1 = 1;
                suspendResult = this.v7b_1.s13(this.w7b_1).d4s(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 1:
            this.c7c_1 = suspendResult;
            this.fd_1 = 2;
            suspendResult = this.b7c_1.l7b(this.c7c_1, this.x7b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.z7b_1 = HtmlNativeImage_init_$Create$_0(ARGUMENT);
            this.fd_1 = 5;
            continue $sm;
          case 3:
            var ARGUMENT_0 = suspendResult;
            this.z7b_1 = HtmlNativeImage_init_$Create$(ARGUMENT_0);
            this.fd_1 = 5;
            continue $sm;
          case 4:
            var ARGUMENT_1 = suspendResult;
            this.z7b_1 = HtmlNativeImage_init_$Create$(ARGUMENT_1);
            this.fd_1 = 5;
            continue $sm;
          case 5:
            var ARGUMENT_2 = this.z7b_1;
            return new NativeImageResult(ARGUMENT_2);
          case 6:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 6) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function HtmlNativeImageFormatProvider() {
    HtmlNativeImageFormatProvider_instance = this;
    NativeImageFormatProvider.call(this);
  }
  protoOf(HtmlNativeImageFormatProvider).n55 = function (data, props, $completion) {
    var tmp = new $decodeInternalCOROUTINE$286(this, data, props, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(HtmlNativeImageFormatProvider).q55 = function (vfs, path, props, $completion) {
    var tmp = new $decodeInternalCOROUTINE$287(this, vfs, path, props, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(HtmlNativeImageFormatProvider).r3o = function (width, height, premultiplied) {
    return HtmlNativeImage_init_$Create$_0(HtmlCanvas_instance.v7a(width, height));
  };
  protoOf(HtmlNativeImageFormatProvider).q3o = function (bmp) {
    return HtmlNativeImage_init_$Create$_0(HtmlImage_instance.w7a(bmp.g3a()));
  };
  var HtmlNativeImageFormatProvider_instance;
  function HtmlNativeImageFormatProvider_getInstance() {
    if (HtmlNativeImageFormatProvider_instance == null)
      new HtmlNativeImageFormatProvider();
    return HtmlNativeImageFormatProvider_instance;
  }
  function HtmlNativeImage_init_$Init$(img, $this) {
    HtmlNativeImage.call($this, img, img.width, img.height);
    return $this;
  }
  function HtmlNativeImage_init_$Create$(img) {
    return HtmlNativeImage_init_$Init$(img, objectCreate(protoOf(HtmlNativeImage)));
  }
  function HtmlNativeImage_init_$Init$_0(canvas, $this) {
    HtmlNativeImage.call($this, canvas, canvas.width, canvas.height);
    return $this;
  }
  function HtmlNativeImage_init_$Create$_0(canvas) {
    return HtmlNativeImage_init_$Init$_0(canvas, objectCreate(protoOf(HtmlNativeImage)));
  }
  function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
    return function () {
      // Inline function 'kotlin.also' call
      var tmp;
      // Inline function 'kotlin.js.asDynamic' call
      if (this$0.t7c_1.src !== undefined) {
        var tmp_0 = BrowserImage_instance;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = this$0.t7c_1;
        tmp = tmp_0.x7c(tmp$ret$2, $width, $height);
      } else {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = this$0.t7c_1;
      }
      var this_0 = tmp;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.HtmlNativeImage.lazyCanvasElement$delegate.<anonymous>.<anonymous>' call
      this$0.t7c_1 = this_0;
      return this_0;
    };
  }
  function HtmlNativeImage$ctx$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      return this$0.y7c().getContext('2d');
    };
  }
  function HtmlNativeImage(texSourceBase, width, height) {
    NativeImage.call(this, width, height, texSourceBase, true);
    this.s7c_1 = texSourceBase;
    this.t7c_1 = this.s7c_1;
    var tmp = this;
    tmp.u7c_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda(this, width, height));
    var tmp_0 = this;
    tmp_0.v7c_1 = lazy(HtmlNativeImage$ctx$delegate$lambda(this));
    var tmp_1 = this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_1.w7c_1 = toDuration(0.0, DurationUnit_MILLISECONDS_getInstance());
  }
  protoOf(HtmlNativeImage).zb = function () {
    return 'HtmlNativeImage';
  };
  protoOf(HtmlNativeImage).y7c = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u7c_1;
    lazyCanvasElement$factory();
    return this_0.m2();
  };
  protoOf(HtmlNativeImage).z7c = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v7c_1;
    ctx$factory();
    return this_0.m2();
  };
  protoOf(HtmlNativeImage).g3b = function (x, y, width, height, out, offset) {
    if (width <= 0 ? true : height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var tmp = this.s7c_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = PerformanceCounter_instance.n1q();
      var elapsedTime = Duration__minus_impl_q5cfm7(now, this.w7c_1);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance_7();
      var tmp$ret$1 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$1) >= 0) {
        this.w7c_1 = now;
        this.z7c().clearRect(0.0, 0.0, width, height);
        this.z7c().drawImage(this.s7c_1, 0.0, 0.0);
      }
    }
    var idata = this.z7c().getImageData(x, y, width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.b3a_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  };
  protoOf(HtmlNativeImage).i3b = function (x, y, width, height, out, offset) {
    if (width <= 0 ? true : height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var idata = this.z7c().createImageData(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(out, offset, data, 0, size);
    if (!this.b3a_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.z7c().putImageData(idata, x, y);
  };
  protoOf(HtmlNativeImage).d3i = function (antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this.y7c()));
  };
  protoOf(HtmlNativeImage).a7d = function (type, quality) {
    return this.y7c().toDataURL(type, quality);
  };
  protoOf(HtmlNativeImage).b7d = function (type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.a7d(type, quality) : $super.a7d.call(this, type, quality);
  };
  function BrowserImage$loadImage$lambda($c, $img) {
    return function (it) {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = $c;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.Companion.success' call
      var value = $img;
      var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
      this_0.s6(tmp$ret$2);
      return Unit_instance;
    };
  }
  function BrowserImage$loadImage$lambda_0($c, $jsUrl) {
    return function (_anonymous_parameter_0__qggqh8, _anonymous_parameter_1__qggqgd, _anonymous_parameter_2__qggqfi, _anonymous_parameter_3__qggqen, _anonymous_parameter_4__qggqds) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $c;
      // Inline function 'kotlin.Companion.failure' call
      var exception = RuntimeException_init_$Create$('error loading image ' + $jsUrl);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      this_0.s6(tmp$ret$0);
      return Unit_instance;
    };
  }
  function $decodeToCanvasCOROUTINE$288(_this__u8e3s4, bytes, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k7d_1 = _this__u8e3s4;
    this.l7d_1 = bytes;
    this.m7d_1 = props;
  }
  protoOf($decodeToCanvasCOROUTINE$288).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 7;
            if (Companion_instance_5.r1p()) {
              var message = 'Canvas not available on NodeJS';
              throw IllegalStateException_init_$Create$(toString(message));
            }

            var tmp_0 = this;
            var this_0 = [this.l7d_1];
            var type = 'image/png';
            var o = {};
            o['type'] = type;
            tmp_0.n7d_1 = new Blob(this_0, o);
            this.o7d_1 = URL.createObjectURL(this.n7d_1);
            this.fd_1 = 1;
            continue $sm;
          case 1:
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.gd_1 = 6;
            this.fd_1 = 3;
            suspendResult = this.k7d_1.q7d(this.o7d_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.p7d_1 = suspendResult;
            this.gd_1 = 7;
            this.fd_1 = 4;
            var tmp_1 = this;
            continue $sm;
          case 4:
            var tmp_2 = this.p7d_1;
            this.gd_1 = 7;
            URL.revokeObjectURL(this.o7d_1);
            return tmp_2;
          case 5:
            this.gd_1 = 7;
            URL.revokeObjectURL(this.o7d_1);
            return Unit_instance;
          case 6:
            this.gd_1 = 7;
            var t = this.id_1;
            URL.revokeObjectURL(this.o7d_1);
            throw t;
          case 7:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 7) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $loadCanvasCOROUTINE$289(_this__u8e3s4, jsUrl, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z7d_1 = _this__u8e3s4;
    this.a7e_1 = jsUrl;
  }
  protoOf($loadCanvasCOROUTINE$289).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.z7d_1.b7e(this.a7e_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return this.z7d_1.c7e(ARGUMENT);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function BrowserImage() {
  }
  protoOf(BrowserImage).l7b = function (bytes, props, $completion) {
    var tmp = new $decodeToCanvasCOROUTINE$288(this, bytes, props, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(BrowserImage).c7e = function (img) {
    return this.x7c(img, img.width, img.height);
  };
  protoOf(BrowserImage).x7c = function (img, width, height) {
    var canvas = HtmlCanvas_instance.v7a(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  };
  protoOf(BrowserImage).d7c = function (jsUrl, props, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), get_MODE_CANCELLABLE());
    cancellable.m1f();
    // Inline function 'korlibs.image.format.BrowserImage.loadImage.<anonymous>' call
    if (Companion_instance_5.r1p()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on NodeJS';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var img = document.createElement('img');
    img.onload = BrowserImage$loadImage$lambda(cancellable, img);
    img.onerror = BrowserImage$loadImage$lambda_0(cancellable, jsUrl);
    img.src = jsUrl;
    return cancellable.y1c();
  };
  protoOf(BrowserImage).b7e = function (jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_42().i3w_1 : props;
    return $super === VOID ? this.d7c(jsUrl, props, $completion) : $super.d7c.call(this, jsUrl, props, $completion);
  };
  protoOf(BrowserImage).q7d = function (jsUrl, $completion) {
    var tmp = new $loadCanvasCOROUTINE$289(this, jsUrl, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  var BrowserImage_instance;
  function BrowserImage_getInstance() {
    return BrowserImage_instance;
  }
  function get_isBigEndian() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return !get_isLittleEndian();
  }
  function bswap32(v, offset, size) {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    var inductionVariable = offset;
    var last = offset + size | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        v[n] = bswap32_0(v[n]);
      }
       while (inductionVariable < last);
  }
  function setFont($this, font, fontSize) {
    var tmp;
    if ((font == null ? null : font.zb()) == $this.i7e_1) {
      tmp = fontSize === $this.h7e_1;
    } else {
      tmp = false;
    }
    if (tmp)
      return Unit_instance;
    var tmp_0 = $this;
    tmp_0.i7e_1 = font == null ? null : font.zb();
    $this.h7e_1 = fontSize;
    var tmp3_elvis_lhs = font == null ? null : font.zb();
    $this.g7e_1.font = '' + fontSize + "px '" + (tmp3_elvis_lhs == null ? 'default' : tmp3_elvis_lhs) + "'";
  }
  function setState($this, state, fill, doSetFont) {
    $this.g7e_1.globalAlpha = state.h3v_1;
    $this.g7e_1.globalCompositeOperation = $this.j7e(state.i3v_1);
    if (doSetFont) {
      setFont($this, state.d3v_1, state.e3v_1);
    }
    if (fill) {
      $this.g7e_1.fillStyle = $this.k7e(state.b3v_1);
    } else {
      $this.g7e_1.lineWidth = state.v3u_1;
      var tmp;
      switch (state.y3u_1.ka_1) {
        case 0:
          // Inline function 'org.w3c.dom.BEVEL' call

          null;
          // Inline function 'kotlin.js.unsafeCast' call

          // Inline function 'kotlin.js.asDynamic' call

          tmp = 'bevel';
          break;
        case 2:
          // Inline function 'org.w3c.dom.MITER' call

          null;
          // Inline function 'kotlin.js.unsafeCast' call

          // Inline function 'kotlin.js.asDynamic' call

          tmp = 'miter';
          break;
        case 1:
          // Inline function 'org.w3c.dom.ROUND' call

          null;
          // Inline function 'kotlin.js.unsafeCast' call

          // Inline function 'kotlin.js.asDynamic' call

          tmp = 'round';
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      $this.g7e_1.lineJoin = tmp;
      var tmp_0;
      switch (state.q44().ka_1) {
        case 0:
          // Inline function 'org.w3c.dom.BUTT' call

          null;
          // Inline function 'kotlin.js.unsafeCast' call

          // Inline function 'kotlin.js.asDynamic' call

          tmp_0 = 'butt';
          break;
        case 2:
          // Inline function 'org.w3c.dom.ROUND' call

          null;
          // Inline function 'kotlin.js.unsafeCast' call

          // Inline function 'kotlin.js.asDynamic' call

          tmp_0 = 'round';
          break;
        case 1:
          // Inline function 'org.w3c.dom.SQUARE' call

          null;
          // Inline function 'kotlin.js.unsafeCast' call

          // Inline function 'kotlin.js.asDynamic' call

          tmp_0 = 'square';
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      $this.g7e_1.lineCap = tmp_0;
      $this.g7e_1.strokeStyle = $this.k7e(state.a3v_1);
    }
  }
  function transformPaint($this, paint) {
    if (isInterface(paint, TransformedPaint)) {
      $this.l7e($this.g7e_1, paint.p46());
    }
  }
  function CanvasContext2dRenderer(canvas) {
    Renderer.call(this);
    this.f7e_1 = canvas;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g7e_1 = this.f7e_1.getContext('2d');
    var tmp_0 = this;
    tmp_0.h7e_1 = NaN;
    this.i7e_1 = null;
  }
  protoOf(CanvasContext2dRenderer).x1q = function () {
    return this.f7e_1.width;
  };
  protoOf(CanvasContext2dRenderer).y1q = function () {
    return this.f7e_1.height;
  };
  protoOf(CanvasContext2dRenderer).m7e = function (_this__u8e3s4, paint) {
    var grad = _this__u8e3s4;
    var inductionVariable = 0;
    var last = paint.g4m_1.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var stop = paint.g4m_1.b1r(n);
        var color = paint.h4m_1.b1r(n);
        grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl__l4nu0u(_RGBA___init__impl__lqpay5(color)));
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  };
  protoOf(CanvasContext2dRenderer).k7e = function (_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (_this__u8e3s4 instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl__bzw5k6(_RGBA___get_color__impl__8x3sb3(_this__u8e3s4.b3s_1));
      } else {
        if (_this__u8e3s4 instanceof GradientPaint) {
          var tmp_0;
          switch (_this__u8e3s4.z4l_1.ka_1) {
            case 0:
              tmp_0 = this.m7e(this.g7e_1.createLinearGradient(_this__u8e3s4.a4m_1, _this__u8e3s4.b4m_1, _this__u8e3s4.d4m_1, _this__u8e3s4.e4m_1), _this__u8e3s4);
              break;
            case 1:
              tmp_0 = this.m7e(this.g7e_1.createRadialGradient(_this__u8e3s4.a4m_1, _this__u8e3s4.b4m_1, _this__u8e3s4.c4m_1, _this__u8e3s4.d4m_1, _this__u8e3s4.e4m_1, _this__u8e3s4.f4m_1), _this__u8e3s4);
              break;
            case 2:
              var tmp_1;
              if (!equals(this.g7e_1.createConicGradient, undefined)) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$1 = this.g7e_1.createConicGradient(_Angle___get_radians__impl__n00yt5(_this__u8e3s4.m4m_1), _this__u8e3s4.a4m_1, _this__u8e3s4.b4m_1);
                tmp_1 = this.m7e(tmp$ret$1, _this__u8e3s4);
              } else {
                tmp_1 = 'fuchsia';
              }

              tmp_0 = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if (_this__u8e3s4 instanceof BitmapPaint) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$3 = toHtmlNative(_this__u8e3s4.g5b_1).t7c_1;
            tmp = this.g7e_1.createPattern(tmp$ret$3, (_this__u8e3s4.v5b() ? _this__u8e3s4.x5b() : false) ? 'repeat' : _this__u8e3s4.v5b() ? 'repeat-x' : _this__u8e3s4.x5b() ? 'repeat-y' : 'no-repeat');
          } else {
            tmp = 'black';
          }
        }
      }
    }
    return tmp;
  };
  protoOf(CanvasContext2dRenderer).n7e = function (_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.ka_1) {
      case 0:
        tmp = 'clear';
        break;
      case 1:
        tmp = 'copy';
        break;
      case 2:
        tmp = 'source-over';
        break;
      case 3:
        tmp = 'destination-over';
        break;
      case 4:
        tmp = 'source-in';
        break;
      case 5:
        tmp = 'destination-in';
        break;
      case 6:
        tmp = 'source-out';
        break;
      case 7:
        tmp = 'destination-out';
        break;
      case 8:
        tmp = 'source-atop';
        break;
      case 9:
        tmp = 'destination-atop';
        break;
      case 10:
        tmp = 'xor';
        break;
      case 11:
        tmp = 'lighter';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(CanvasContext2dRenderer).o7e = function (_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.ka_1) {
      case 0:
        tmp = 'normal';
        break;
      case 1:
        tmp = 'multiply';
        break;
      case 2:
        tmp = 'screen';
        break;
      case 3:
        tmp = 'overlay';
        break;
      case 4:
        tmp = 'darken';
        break;
      case 5:
        tmp = 'lighten';
        break;
      case 6:
        tmp = 'color-dodge';
        break;
      case 7:
        tmp = 'color-burn';
        break;
      case 8:
        tmp = 'hard-light';
        break;
      case 9:
        tmp = 'soft-light';
        break;
      case 10:
        tmp = 'difference';
        break;
      case 11:
        tmp = 'exclusion';
        break;
      case 12:
        tmp = 'hue';
        break;
      case 13:
        tmp = 'saturation';
        break;
      case 14:
        tmp = 'color';
        break;
      case 15:
        tmp = 'luminosity';
        break;
      default:
        // Inline function 'kotlin.text.lowercase' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = _this__u8e3s4.ja_1.toLowerCase();
        break;
    }
    return tmp;
  };
  protoOf(CanvasContext2dRenderer).j7e = function (_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof CompositeMode) {
      tmp = this.n7e(_this__u8e3s4);
    } else {
      if (_this__u8e3s4 instanceof BlendMode) {
        tmp = this.o7e(_this__u8e3s4);
      } else {
        tmp = 'source-over';
      }
    }
    return tmp;
  };
  protoOf(CanvasContext2dRenderer).l7e = function (_this__u8e3s4, m) {
    _this__u8e3s4.transform(m.j2f_1, m.k2f_1, m.l2f_1, m.m2f_1, m.n2f_1, m.o2f_1);
  };
  protoOf(CanvasContext2dRenderer).f5h = function (image, pos, size, transform) {
    this.g7e_1.save();
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      this.g7e_1.setTransform(transform.j2f_1, transform.k2f_1, transform.l2f_1, transform.m2f_1, transform.n2f_1, transform.o2f_1);
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp = ensureNative(image);
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE()).t7c_1;
      this.g7e_1.drawImage(tmp$ret$2, pos.g28_1, pos.h28_1, size.r2k_1, size.s2k_1);
    }finally {
      this.g7e_1.restore();
    }
  };
  protoOf(CanvasContext2dRenderer).p7e = function (path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.u2u_1;
    var n_0 = 0;
    while (n_0 < this_0.n()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var tmp0_subject = this_0.b1r(tmp0);
      if (tmp0_subject === 0) {
        // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var tmp = path.v2u_1.f1(tmp1);
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var name_for_destructuring_parameter_0_fjsvno = new Vector2D(tmp, path.v2u_1.f1(tmp2));
        var x = name_for_destructuring_parameter_0_fjsvno.cg();
        var y = name_for_destructuring_parameter_0_fjsvno.dg();
        this.g7e_1.moveTo(x, y);
      } else {
        if (tmp0_subject === 1) {
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call
          var tmp3 = n;
          n = tmp3 + 1 | 0;
          var tmp_0 = path.v2u_1.f1(tmp3);
          var tmp4 = n;
          n = tmp4 + 1 | 0;
          var name_for_destructuring_parameter_0_fjsvno_0 = new Vector2D(tmp_0, path.v2u_1.f1(tmp4));
          var x_0 = name_for_destructuring_parameter_0_fjsvno_0.cg();
          var y_0 = name_for_destructuring_parameter_0_fjsvno_0.dg();
          this.g7e_1.lineTo(x_0, y_0);
        } else {
          if (tmp0_subject === 2) {
            // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call
            var tmp5 = n;
            n = tmp5 + 1 | 0;
            var tmp_1 = path.v2u_1.f1(tmp5);
            var tmp6 = n;
            n = tmp6 + 1 | 0;
            var name_for_destructuring_parameter_0_fjsvno_1 = new Vector2D(tmp_1, path.v2u_1.f1(tmp6));
            var tmp7 = n;
            n = tmp7 + 1 | 0;
            var tmp_2 = path.v2u_1.f1(tmp7);
            var tmp8 = n;
            n = tmp8 + 1 | 0;
            var name_for_destructuring_parameter_1_fjsvnn = new Vector2D(tmp_2, path.v2u_1.f1(tmp8));
            var cx = name_for_destructuring_parameter_0_fjsvno_1.cg();
            var cy = name_for_destructuring_parameter_0_fjsvno_1.dg();
            var ax = name_for_destructuring_parameter_1_fjsvnn.cg();
            var ay = name_for_destructuring_parameter_1_fjsvnn.dg();
            this.g7e_1.quadraticCurveTo(cx, cy, ax, ay);
          } else {
            if (tmp0_subject === 3) {
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call
              var tmp9 = n;
              n = tmp9 + 1 | 0;
              var tmp_3 = path.v2u_1.f1(tmp9);
              var tmp10 = n;
              n = tmp10 + 1 | 0;
              var name_for_destructuring_parameter_0_fjsvno_2 = new Vector2D(tmp_3, path.v2u_1.f1(tmp10));
              var tmp11 = n;
              n = tmp11 + 1 | 0;
              var tmp_4 = path.v2u_1.f1(tmp11);
              var tmp12 = n;
              n = tmp12 + 1 | 0;
              var name_for_destructuring_parameter_1_fjsvnn_0 = new Vector2D(tmp_4, path.v2u_1.f1(tmp12));
              var tmp13 = n;
              n = tmp13 + 1 | 0;
              var tmp_5 = path.v2u_1.f1(tmp13);
              var tmp14 = n;
              n = tmp14 + 1 | 0;
              var name_for_destructuring_parameter_2_fjsvnm = new Vector2D(tmp_5, path.v2u_1.f1(tmp14));
              var cx1 = name_for_destructuring_parameter_0_fjsvno_2.cg();
              var cy1 = name_for_destructuring_parameter_0_fjsvno_2.dg();
              var cx2 = name_for_destructuring_parameter_1_fjsvnn_0.cg();
              var cy2 = name_for_destructuring_parameter_1_fjsvnn_0.dg();
              var ax_0 = name_for_destructuring_parameter_2_fjsvnm.cg();
              var ay_0 = name_for_destructuring_parameter_2_fjsvnm.dg();
              this.g7e_1.bezierCurveTo(cx1, cy1, cx2, cy2, ax_0, ay_0);
            } else {
              if (tmp0_subject === 4) {
                // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call
                this.g7e_1.closePath();
              }
            }
          }
        }
      }
    }
  };
  protoOf(CanvasContext2dRenderer).w5g = function (state, fill, winding) {
    if (state.t3u_1.b1())
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.image.format.CanvasContext2dRenderer.keep' call
      this.g7e_1.save();
      try {
        setState(this, state, fill, false);
        var clip = state.s3u_1;
        if (!(clip == null)) {
          this.g7e_1.beginPath();
          this.p7e(clip);
          this.g7e_1.clip(this.q7e(winding == null ? clip.w2u_1 : winding));
        }
        this.g7e_1.beginPath();
        this.p7e(state.t3u_1);
        this.l7e(this.g7e_1, state.r3u_1);
        var tmp;
        if (fill) {
          transformPaint(this, state.b3v_1);
          this.g7e_1.fill(this.q7e(winding == null ? state.t3u_1.w2u_1 : winding));
          tmp = Unit_instance;
        } else {
          transformPaint(this, state.a3v_1);
          var lineDash = state.j3v_1;
          if (!(lineDash == null)) {
            this.g7e_1.lineDashOffset = state.k3v_1;
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'korlibs.datastructure.mapDouble' call
            // Inline function 'kotlin.also' call
            var this_0 = new DoubleArrayList();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
            var tmp0_iterator = lineDash.u();
            while (tmp0_iterator.v()) {
              var v = tmp0_iterator.x();
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.renderFinal.<anonymous>.<anonymous>' call
              this_0.s1r(v);
            }
            var tmp$ret$3 = copyToArray(this_0);
            this.g7e_1.setLineDash(tmp$ret$3);
          }
          this.g7e_1.stroke();
          tmp = Unit_instance;
        }
        break $l$block;
      }finally {
        this.g7e_1.restore();
      }
    }
  };
  protoOf(CanvasContext2dRenderer).q7e = function (_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.ka_1) {
      case 1:
        // Inline function 'org.w3c.dom.NONZERO' call

        null;
        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'nonzero';
        break;
      case 0:
        // Inline function 'org.w3c.dom.EVENODD' call

        null;
        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'evenodd';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  function bswap32_0(v) {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
  }
  function isLittleEndian$delegate$lambda() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    get_tempI()[0] = 1;
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.js.asDynamic' call
    return get_temp8()[0] === 1;
  }
  function isLittleEndian$factory() {
    return getPropertyCallableRef('isLittleEndian', 0, KProperty0, function () {
      return get_isLittleEndian();
    }, null);
  }
  function lazyCanvasElement$factory() {
    return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
      return receiver.y7c();
    }, null);
  }
  function ctx$factory() {
    return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
      return receiver.z7c();
    }, null);
  }
  var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
  function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
    if (!properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
      properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
      nativeImageFormatProvider = Companion_instance_5.r1p() ? NodeJsNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
      tempB = new ArrayBuffer(4);
      tempI = new Int32Array(get_tempB());
      temp8 = new Uint8Array(get_tempB());
      isLittleEndian$delegate = lazy(isLittleEndian$delegate$lambda);
    }
  }
  function get_jsGlobalDynamic() {
    _init_properties_KorioNativeJs_kt__151su();
    return jsGlobalDynamic;
  }
  var jsGlobalDynamic;
  function get_jsGlobal() {
    _init_properties_KorioNativeJs_kt__151su();
    return jsGlobal;
  }
  var jsGlobal;
  function get_isDenoJs() {
    _init_properties_KorioNativeJs_kt__151su();
    // Inline function 'kotlin.getValue' call
    var this_0 = isDenoJs$delegate;
    isDenoJs$factory();
    return this_0.m2();
  }
  var isDenoJs$delegate;
  function get_isWeb() {
    _init_properties_KorioNativeJs_kt__151su();
    // Inline function 'kotlin.getValue' call
    var this_0 = isWeb$delegate;
    isWeb$factory();
    return this_0.m2();
  }
  var isWeb$delegate;
  function get_isWorker() {
    _init_properties_KorioNativeJs_kt__151su();
    // Inline function 'kotlin.getValue' call
    var this_0 = isWorker$delegate;
    isWorker$factory();
    return this_0.m2();
  }
  var isWorker$delegate;
  function get_isNodeJs() {
    _init_properties_KorioNativeJs_kt__151su();
    // Inline function 'kotlin.getValue' call
    var this_0 = isNodeJs$delegate;
    isNodeJs$factory();
    return this_0.m2();
  }
  var isNodeJs$delegate;
  function get_jsRuntime() {
    _init_properties_KorioNativeJs_kt__151su();
    // Inline function 'kotlin.getValue' call
    var this_0 = jsRuntime$delegate;
    jsRuntime$factory();
    return this_0.m2();
  }
  var jsRuntime$delegate;
  function jsObject(pairs) {
    _init_properties_KorioNativeJs_kt__151su();
    var out = jsEmptyObj();
    var inductionVariable = 0;
    var last = pairs.length;
    while (inductionVariable < last) {
      var pair = pairs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      out[pair.ag_1] = pair.bg_1;
    }
    return out;
  }
  function jsEmptyObj() {
    _init_properties_KorioNativeJs_kt__151su();
    return {};
  }
  function get_isShell() {
    _init_properties_KorioNativeJs_kt__151su();
    return (!get_isWeb() ? !get_isNodeJs() : false) ? !get_isWorker() : false;
  }
  function jsObjectToMap(obj) {
    _init_properties_KorioNativeJs_kt__151su();
    // Inline function 'kotlin.collections.associate' call
    var this_0 = jsObjectKeysArray(obj);
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.io.jsObjectToMap.<anonymous>' call
      var pair = to(element, obj[element]);
      destination.i2(pair.ag_1, pair.bg_1);
    }
    return destination;
  }
  function jsEmptyArray() {
    _init_properties_KorioNativeJs_kt__151su();
    return [];
  }
  function jsToObjectMap(obj) {
    _init_properties_KorioNativeJs_kt__151su();
    if (obj == null)
      return null;
    // Inline function 'kotlin.collections.linkedMapOf' call
    var out = LinkedHashMap_init_$Create$();
    var keys = jsObjectKeys(obj);
    var inductionVariable = 0;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var key = keys[n];
        // Inline function 'kotlin.collections.set' call
        var key_0 = '' + key;
        var value = obj[key];
        out.i2(key_0, value);
      }
       while (inductionVariable < last);
    return out;
  }
  function jsToArray(obj) {
    _init_properties_KorioNativeJs_kt__151su();
    var tmp = 0;
    var tmp_0 = obj.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = obj[tmp_2];
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function jsNew(clazz) {
    _init_properties_KorioNativeJs_kt__151su();
    return (new clazz())();
  }
  function jsObjectKeysArray(obj) {
    _init_properties_KorioNativeJs_kt__151su();
    var tmp = jsToArray(jsObjectKeys(obj));
    return isArray(tmp) ? tmp : THROW_CCE();
  }
  function jsObjectKeys(obj) {
    _init_properties_KorioNativeJs_kt__151su();
    return Object.keys(obj);
  }
  function isDenoJs$delegate$lambda() {
    _init_properties_KorioNativeJs_kt__151su();
    // Inline function 'kotlin.js.unsafeCast' call
    return typeof Deno === 'object' && Deno.statSync;
  }
  function isWeb$delegate$lambda() {
    _init_properties_KorioNativeJs_kt__151su();
    // Inline function 'kotlin.js.unsafeCast' call
    return typeof window === 'object';
  }
  function isWorker$delegate$lambda() {
    _init_properties_KorioNativeJs_kt__151su();
    // Inline function 'kotlin.js.unsafeCast' call
    return typeof importScripts === 'function';
  }
  function isNodeJs$delegate$lambda() {
    _init_properties_KorioNativeJs_kt__151su();
    // Inline function 'kotlin.js.unsafeCast' call
    return typeof process !== 'undefined' && process.release && process.release.name.search(/node|io.js/) !== -1;
  }
  function jsRuntime$delegate$lambda() {
    _init_properties_KorioNativeJs_kt__151su();
    return get_isDenoJs() ? JsRuntimeDeno_getInstance() : get_isNodeJs() ? JsRuntimeNode_getInstance() : JsRuntimeBrowser_getInstance();
  }
  function isDenoJs$factory() {
    return getPropertyCallableRef('isDenoJs', 0, KProperty0, function () {
      return get_isDenoJs();
    }, null);
  }
  function isWeb$factory() {
    return getPropertyCallableRef('isWeb', 0, KProperty0, function () {
      return get_isWeb();
    }, null);
  }
  function isWorker$factory() {
    return getPropertyCallableRef('isWorker', 0, KProperty0, function () {
      return get_isWorker();
    }, null);
  }
  function isNodeJs$factory() {
    return getPropertyCallableRef('isNodeJs', 0, KProperty0, function () {
      return get_isNodeJs();
    }, null);
  }
  function jsRuntime$factory() {
    return getPropertyCallableRef('jsRuntime', 0, KProperty0, function () {
      return get_jsRuntime();
    }, null);
  }
  var properties_initialized_KorioNativeJs_kt_y4p8os;
  function _init_properties_KorioNativeJs_kt__151su() {
    if (!properties_initialized_KorioNativeJs_kt_y4p8os) {
      properties_initialized_KorioNativeJs_kt_y4p8os = true;
      jsGlobalDynamic = typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : self;
      jsGlobal = get_jsGlobalDynamic();
      isDenoJs$delegate = lazy(isDenoJs$delegate$lambda);
      isWeb$delegate = lazy(isWeb$delegate$lambda);
      isWorker$delegate = lazy(isWorker$delegate$lambda);
      isNodeJs$delegate = lazy(isNodeJs$delegate$lambda);
      jsRuntime$delegate = lazy(jsRuntime$delegate$lambda);
    }
  }
  function Deflate(windowBits) {
    return new DeflatePortable(windowBits);
  }
  function korAtomic(initial) {
    return new KorAtomicLong(initial, true);
  }
  function korAtomic_0(initial) {
    return new KorAtomicRef(initial, true);
  }
  function korAtomic_1(initial) {
    return new KorAtomicInt(initial, true);
  }
  function DynamicInternal() {
  }
  protoOf(DynamicInternal).s5z = function () {
    return get_jsGlobalDynamic();
  };
  protoOf(DynamicInternal).u5z = function (instance, key) {
    // Inline function 'kotlin.js.asDynamic' call
    return instance[key];
  };
  protoOf(DynamicInternal).t5z = function (instance, key, value) {
    // Inline function 'kotlin.js.asDynamic' call
    instance[key] = value;
  };
  var DynamicInternal_instance;
  function DynamicInternal_getInstance() {
    return DynamicInternal_instance;
  }
  function toVfs(_this__u8e3s4) {
    var file = _this__u8e3s4;
    return (new toVfs$1(file)).s13(file.name);
  }
  function openAsync_0(_this__u8e3s4) {
    return buffered(toAsyncStream(new BlobAsyncBaseStream(_this__u8e3s4)), 65536, 16);
  }
  function BlobAsyncBaseStream$read$lambda($reader, $len, $buffer, $offset, $deferred) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      var ab = $reader.result;
      // Inline function 'kotlin.math.min' call
      var a = ab.byteLength;
      var b = $len;
      var minLen = Math.min(a, b);
      arraycopy_0(toByteArray(new Int8Array(ab)), 0, $buffer, $offset, minLen);
      return $deferred.d1g(minLen);
    };
  }
  function BlobAsyncBaseStream$read$lambda_0($deferred, $reader) {
    return function (it) {
      return $deferred.c1g(newThrowable('' + $reader.error));
    };
  }
  function BlobAsyncBaseStream(blob) {
    AsyncStreamBase.call(this);
    this.r7e_1 = blob;
  }
  protoOf(BlobAsyncBaseStream).x5u = function ($completion) {
    return Unit_instance;
  };
  protoOf(BlobAsyncBaseStream).k67 = function (position, buffer, offset, len, $completion) {
    var deferred = CompletableDeferred();
    var reader = new FileReader();
    reader.onload = BlobAsyncBaseStream$read$lambda(reader, len, buffer, offset, deferred);
    reader.onerror = BlobAsyncBaseStream$read$lambda_0(deferred, reader);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.r7e_1;
    reader.readAsArrayBuffer(tmp$ret$1.slice(position.u6(), position.u6() + len));
    return deferred.q1d($completion);
  };
  protoOf(BlobAsyncBaseStream).m5w = function ($completion) {
    return numberToLong(this.r7e_1.size);
  };
  function toVfs$1($file) {
    this.t7e_1 = $file;
    Vfs.call(this);
    this.s7e_1 = $file.name;
  }
  protoOf(toVfs$1).t63 = function () {
    return this.s7e_1;
  };
  protoOf(toVfs$1).q63 = function (path, mode, $completion) {
    return openAsync_0(this.t7e_1);
  };
  var File_separatorChar;
  function get_standardVfs() {
    _init_properties_LocalVfsJs_kt__kywvdr();
    return standardVfs;
  }
  var standardVfs;
  function get_applicationVfs() {
    _init_properties_LocalVfsJs_kt__kywvdr();
    // Inline function 'kotlin.getValue' call
    var this_0 = applicationVfs$delegate;
    applicationVfs$factory();
    return this_0.m2();
  }
  var applicationVfs$delegate;
  var applicationDataVfsOrNull;
  var cacheVfsOrNull;
  var externalStorageVfs$delegate;
  var userHomeVfs$delegate;
  var tempVfsOrNull;
  function localVfs(path, async) {
    async = async === VOID ? true : async;
    _init_properties_LocalVfsJs_kt__kywvdr();
    return get_jsRuntime().y7e(path);
  }
  function standardVfs$o$resourcesVfs$delegate$lambda() {
    return get_applicationVfs().j66();
  }
  function standardVfs$o$rootLocalVfs$delegate$lambda() {
    return localVfs('.');
  }
  function standardVfs$1() {
    StandardVfs.call(this);
    var tmp = this;
    tmp.z7e_1 = lazy(standardVfs$o$resourcesVfs$delegate$lambda);
    var tmp_0 = this;
    tmp_0.a7f_1 = lazy(standardVfs$o$rootLocalVfs$delegate$lambda);
  }
  protoOf(standardVfs$1).o6a = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z7e_1;
    resourcesVfs$factory();
    return this_0.m2();
  };
  function applicationVfs$delegate$lambda() {
    _init_properties_LocalVfsJs_kt__kywvdr();
    return localVfs('.');
  }
  function externalStorageVfs$delegate$lambda() {
    _init_properties_LocalVfsJs_kt__kywvdr();
    return localVfs('.');
  }
  function userHomeVfs$delegate$lambda() {
    _init_properties_LocalVfsJs_kt__kywvdr();
    return localVfs('.');
  }
  function applicationVfs$factory() {
    return getPropertyCallableRef('applicationVfs', 0, KProperty0, function () {
      return get_applicationVfs();
    }, null);
  }
  function resourcesVfs$factory() {
    return getPropertyCallableRef('resourcesVfs', 1, KProperty1, function (receiver) {
      return receiver.o6a();
    }, null);
  }
  var properties_initialized_LocalVfsJs_kt_51m659;
  function _init_properties_LocalVfsJs_kt__kywvdr() {
    if (!properties_initialized_LocalVfsJs_kt_51m659) {
      properties_initialized_LocalVfsJs_kt_51m659 = true;
      standardVfs = new standardVfs$1();
      applicationVfs$delegate = lazy(applicationVfs$delegate$lambda);
      applicationDataVfsOrNull = null;
      cacheVfsOrNull = null;
      externalStorageVfs$delegate = lazy(externalStorageVfs$delegate$lambda);
      userHomeVfs$delegate = lazy(userHomeVfs$delegate$lambda);
      tempVfsOrNull = null;
    }
  }
  function StandardPaths() {
  }
  var StandardPaths_instance;
  function StandardPaths_getInstance() {
    return StandardPaths_instance;
  }
  function get_portableSimpleName(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4.x6();
    return tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs;
  }
  function EnvironmentInternal() {
  }
  protoOf(EnvironmentInternal).s13 = function (key) {
    return get_jsRuntime().b7f(key);
  };
  var EnvironmentInternal_instance;
  function EnvironmentInternal_getInstance() {
    return EnvironmentInternal_instance;
  }
  function FileNotFoundException(msg) {
    IOException.call(this, msg);
    captureStack(this, FileNotFoundException);
  }
  function IOException(msg) {
    Exception_init_$Init$(msg, this);
    captureStack(this, IOException);
  }
  function EOFException(msg) {
    IOException.call(this, msg);
    captureStack(this, EOFException);
  }
  function NativeThreadLocal() {
    this.l6g_1 = this.e6h();
  }
  protoOf(NativeThreadLocal).u1h = function () {
    return this.l6g_1;
  };
  function get_UTF8() {
    _init_properties_UTF8_kt__b4hq3z();
    return UTF8;
  }
  var UTF8;
  var JS_UTF8;
  function JS_UTF8$1() {
    UTC8CharsetBase.call(this, 'UTF-8');
    var tmp = this;
    var tmp_0;
    try {
      tmp_0 = new TextDecoder('utf-8');
    } catch ($p) {
      var tmp_1;
      var e = $p;
      tmp_1 = null;
      tmp_0 = tmp_1;
    }
    tmp.d7f_1 = tmp_0;
    var tmp_2 = this;
    var tmp_3;
    try {
      tmp_3 = new TextEncoder('utf-8');
    } catch ($p) {
      var tmp_4;
      var e_0 = $p;
      tmp_4 = null;
      tmp_3 = tmp_4;
    }
    tmp_2.e7f_1 = tmp_3;
  }
  protoOf(JS_UTF8$1).p6g = function (out, src, start, end) {
    if (!(this.d7f_1 == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var srcBuffer = src;
      out.u5(this.d7f_1.decode(new Int8Array(srcBuffer.buffer, start, end - start | 0)));
    } else {
      protoOf(UTC8CharsetBase).p6g.call(this, out, src, start, end);
    }
    return end - start | 0;
  };
  var properties_initialized_UTF8_kt_emb36b;
  function _init_properties_UTF8_kt__b4hq3z() {
    if (!properties_initialized_UTF8_kt_emb36b) {
      properties_initialized_UTF8_kt_emb36b = true;
      UTF8 = new UTC8CharsetBase('UTF-8');
      JS_UTF8 = new JS_UTF8$1();
    }
  }
  function get_httpFactory() {
    _init_properties_HttpFactoryJs_kt__a3ro2v();
    // Inline function 'kotlin.getValue' call
    var this_0 = httpFactory$delegate;
    httpFactory$factory();
    return this_0.m2();
  }
  var httpFactory$delegate;
  function httpFactory$delegate$lambda() {
    _init_properties_HttpFactoryJs_kt__a3ro2v();
    return new httpFactory$2$1();
  }
  function httpFactory$2$1() {
  }
  protoOf(httpFactory$2$1).v6m = function () {
    return get_jsRuntime().f7f();
  };
  function httpFactory$factory() {
    return getPropertyCallableRef('httpFactory', 0, KProperty0, function () {
      return get_httpFactory();
    }, null);
  }
  var properties_initialized_HttpFactoryJs_kt_on1x9h;
  function _init_properties_HttpFactoryJs_kt__a3ro2v() {
    if (!properties_initialized_HttpFactoryJs_kt_on1x9h) {
      properties_initialized_HttpFactoryJs_kt_on1x9h = true;
      httpFactory$delegate = lazy(httpFactory$delegate$lambda);
    }
  }
  function Companion_67() {
    Companion_instance_75 = this;
    this.g7f_1 = Companion_getInstance_6().r24('JsRuntime');
  }
  var Companion_instance_75;
  function Companion_getInstance_82() {
    if (Companion_instance_75 == null)
      new Companion_67();
    return Companion_instance_75;
  }
  function _get__envs__kxwcr8($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.w7e_1;
    _envs$factory();
    return this_0.m2();
  }
  function _get__envsUC__n5sgyq($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.x7e_1;
    _envsUC$factory();
    return this_0.m2();
  }
  function JsRuntime$_envs$delegate$lambda(this$0) {
    return function () {
      return this$0.h7f();
    };
  }
  function JsRuntime$_envsUC$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.mapKeys' call
      var this_0 = _get__envs__kxwcr8(this$0);
      // Inline function 'kotlin.collections.mapKeysTo' call
      var destination = LinkedHashMap_init_$Create$_0(mapCapacity(this_0.n()));
      // Inline function 'kotlin.collections.associateByTo' call
      var tmp0_iterator = this_0.k2().u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.io.runtime.JsRuntime._envsUC$delegate.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.text.uppercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = element.l2().toUpperCase();
        // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
        var tmp$ret$3 = element.m2();
        destination.i2(tmp, tmp$ret$3);
      }
      return toMap_0(destination);
    };
  }
  function JsRuntime() {
    Companion_getInstance_82();
    this.u7e_1 = 'unknown';
    this.v7e_1 = get_isDenoJs() ? 'deno.js' : get_isWeb() ? 'web.js' : get_isNodeJs() ? 'node.js' : get_isWorker() ? 'worker.js' : get_isShell() ? 'shell.js' : 'js';
    var tmp = this;
    tmp.w7e_1 = lazy(JsRuntime$_envs$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.x7e_1 = lazy(JsRuntime$_envsUC$delegate$lambda(this));
  }
  protoOf(JsRuntime).j7f = function () {
    return '.';
  };
  protoOf(JsRuntime).b7f = function (key) {
    var tmp = _get__envsUC__n5sgyq(this);
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = key.toUpperCase();
    return tmp.s2(tmp$ret$1);
  };
  protoOf(JsRuntime).y7e = function (path) {
    throw new NotImplementedError();
  };
  protoOf(JsRuntime).f7f = function () {
    throw new NotImplementedError();
  };
  function _envs$factory() {
    return getPropertyCallableRef('_envs', 1, KProperty1, function (receiver) {
      return _get__envs__kxwcr8(receiver);
    }, null);
  }
  function _envsUC$factory() {
    return getPropertyCallableRef('_envsUC', 1, KProperty1, function (receiver) {
      return _get__envsUC__n5sgyq(receiver);
    }, null);
  }
  function JsRuntimeBrowser$href$delegate$lambda() {
    var tmp0_safe_receiver = document.location;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.href;
    return tmp1_elvis_lhs == null ? '.' : tmp1_elvis_lhs;
  }
  function JsRuntimeBrowser$baseUrl$delegate$lambda() {
    return endsWith(JsRuntimeBrowser_getInstance().r7f(), '/') ? JsRuntimeBrowser_getInstance().r7f() : substringBeforeLast(JsRuntimeBrowser_getInstance().r7f(), _Char___init__impl__6a9atx(47));
  }
  function JsRuntimeBrowser() {
    JsRuntimeBrowser_instance = this;
    JsRuntime.call(this);
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    tmp.o7f_1 = navigator.platform;
    var tmp_0 = this;
    tmp_0.p7f_1 = lazy(JsRuntimeBrowser$href$delegate$lambda);
    var tmp_1 = this;
    tmp_1.q7f_1 = lazy(JsRuntimeBrowser$baseUrl$delegate$lambda);
  }
  protoOf(JsRuntimeBrowser).r7f = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p7f_1;
    href$factory();
    return this_0.m2();
  };
  protoOf(JsRuntimeBrowser).s7f = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q7f_1;
    baseUrl$factory();
    return this_0.m2();
  };
  protoOf(JsRuntimeBrowser).i7f = function (path) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not yet implemented';
    throw new NotImplementedError('An operation is not implemented: ' + reason);
  };
  protoOf(JsRuntimeBrowser).j7f = function () {
    return this.s7f();
  };
  protoOf(JsRuntimeBrowser).h7f = function () {
    // Inline function 'kotlin.collections.map' call
    var tmp = QueryString_instance;
    var tmp0_safe_receiver = document.location;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.search;
    var this_0 = tmp.k6h(trimStart(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs, charArrayOf([_Char___init__impl__6a9atx(63)])));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.k2().u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.io.runtime.browser.JsRuntimeBrowser.envs.<anonymous>' call
      var tmp_0 = item.l2();
      var tmp0_elvis_lhs = firstOrNull_0(item.m2());
      var tmp$ret$1 = to(tmp_0, tmp0_elvis_lhs == null ? item.l2() : tmp0_elvis_lhs);
      destination.r(tmp$ret$1);
    }
    return toMap(destination);
  };
  protoOf(JsRuntimeBrowser).y7e = function (path) {
    // Inline function 'kotlin.also' call
    var this_0 = withCatalogJail(UrlVfs_1(this.j7f()).s13(path)).v63();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.runtime.browser.JsRuntimeBrowser.openVfs.<anonymous>' call
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_82().g7f_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_1.f25(level)) {
      // Inline function 'korlibs.io.runtime.browser.JsRuntimeBrowser.openVfs.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'BROWSER openVfs: currentDir=' + JsRuntimeBrowser_getInstance().j7f() + ', path=' + path + ', urlVfs=' + this_0;
      this_1.g25(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    return this_0;
  };
  protoOf(JsRuntimeBrowser).f7f = function () {
    return new HttpClientBrowserJs();
  };
  var JsRuntimeBrowser_instance;
  function JsRuntimeBrowser_getInstance() {
    if (JsRuntimeBrowser_instance == null)
      new JsRuntimeBrowser();
    return JsRuntimeBrowser_instance;
  }
  function Companion_68() {
    Companion_instance_76 = this;
    var tmp = this;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = Companion_instance_65.e6g_1.toLowerCase();
    tmp.t7f_1 = setOf(['connection', tmp$ret$1]);
  }
  var Companion_instance_76;
  function Companion_getInstance_83() {
    if (Companion_instance_76 == null)
      new Companion_68();
    return Companion_instance_76;
  }
  function HttpClientBrowserJs$requestInternal$lambda($xhr, $deferred) {
    return function (e) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = $xhr.response;
      // Inline function 'kotlin.js.asDynamic' call
      var out = new Int8Array(tmp$ret$1);
      return $deferred.d1g(new Response($xhr.status, $xhr.statusText, Headers_init_$Create$_1($xhr.getAllResponseHeaders()), openAsync(out), openAsync(out)));
    };
  }
  function HttpClientBrowserJs$requestInternal$lambda_0($deferred, $xhr, $url) {
    return function (e) {
      return $deferred.c1g(RuntimeException_init_$Create$('Error status=' + $xhr.status + ",'" + $xhr.statusText + "' opening " + $url));
    };
  }
  function HttpClientBrowserJs$requestInternal$lambda_1($deferred, $xhr) {
    return function (it) {
      var tmp;
      if ($deferred.q1g()) {
        $xhr.abort();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function $requestInternalCOROUTINE$290(_this__u8e3s4, method, url, headers, content, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c7g_1 = _this__u8e3s4;
    this.d7g_1 = method;
    this.e7g_1 = url;
    this.f7g_1 = headers;
    this.g7g_1 = content;
  }
  protoOf($requestInternalCOROUTINE$290).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            this.h7g_1 = CompletableDeferred(Job());
            this.i7g_1 = new XMLHttpRequest();
            this.i7g_1.open(this.d7g_1.zb(), this.e7g_1, true);
            null;
            var this_0 = 'arraybuffer';
            this.i7g_1.responseType = this_0;
            this.i7g_1.onload = HttpClientBrowserJs$requestInternal$lambda(this.i7g_1, this.h7g_1);
            this.i7g_1.onerror = HttpClientBrowserJs$requestInternal$lambda_0(this.h7g_1, this.i7g_1, this.e7g_1);
            var tmp0_iterator = this.f7g_1.u();
            while (tmp0_iterator.v()) {
              var header = tmp0_iterator.x();
              var this_1 = header.ag_1.toLowerCase();
              var hnname = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
              if (!Companion_getInstance_83().t7f_1.z(hnname)) {
                this.i7g_1.setRequestHeader(header.ag_1, header.bg_1);
              }
            }

            this.h7g_1.x1b(HttpClientBrowserJs$requestInternal$lambda_1(this.h7g_1, this.i7g_1));
            if (!(this.g7g_1 == null)) {
              this.fd_1 = 1;
              suspendResult = readAll(this.g7g_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.i7g_1.send();
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            this.j7g_1 = suspendResult;
            this.i7g_1.send(this.j7g_1);
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.k7g_1 = this.g7g_1;
            if (this.k7g_1 == null) {
              this.l7g_1 = null;
              this.fd_1 = 4;
              continue $sm;
            } else {
              this.fd_1 = 3;
              suspendResult = this.k7g_1.x5u(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            var tmp_0 = this;
            tmp_0.l7g_1 = Unit_instance;
            this.fd_1 = 4;
            continue $sm;
          case 4:
            this.fd_1 = 5;
            suspendResult = this.h7g_1.q1d(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            return suspendResult;
          case 6:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 6) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function HttpClientBrowserJs() {
    Companion_getInstance_83();
    HttpClient.call(this);
  }
  protoOf(HttpClientBrowserJs).q6l = function (method, url, headers, content, $completion) {
    var tmp = new $requestInternalCOROUTINE$290(this, method, url, headers, content, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function href$factory() {
    return getPropertyCallableRef('href', 1, KProperty1, function (receiver) {
      return receiver.r7f();
    }, null);
  }
  function baseUrl$factory() {
    return getPropertyCallableRef('baseUrl', 1, KProperty1, function (receiver) {
      return receiver.s7f();
    }, null);
  }
  function JsRuntimeDeno() {
    JsRuntimeDeno_instance = this;
    JsRuntime.call(this);
  }
  protoOf(JsRuntimeDeno).i7f = function (path) {
    var tmp;
    try {
      Deno.statSync(path);
      tmp = true;
    } catch ($p) {
      var tmp_0;
      var e = $p;
      tmp_0 = false;
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(JsRuntimeDeno).j7f = function () {
    try {
      var str = (new URL('.', Deno.mainModule)).pathname;
      var tmp;
      if (Companion_instance_5.i1p()) {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = str.substring(1);
      } else {
        tmp = str;
      }
      return tmp;
    } catch ($p) {
      var e = $p;
      return '.';
    }
  };
  protoOf(JsRuntimeDeno).b7f = function (key) {
    return Deno.env.get(key);
  };
  protoOf(JsRuntimeDeno).h7f = function () {
    return jsObjectToMap(Deno.env.toObject());
  };
  protoOf(JsRuntimeDeno).y7e = function (path) {
    return (new DenoLocalVfs()).s13(path === '.' ? this.j7f() : path);
  };
  var JsRuntimeDeno_instance;
  function JsRuntimeDeno_getInstance() {
    if (JsRuntimeDeno_instance == null)
      new JsRuntimeDeno();
    return JsRuntimeDeno_instance;
  }
  function getFullPath($this, path) {
    return normalize(get_pathInfo(path));
  }
  function $openCOROUTINE$291(_this__u8e3s4, path, mode, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z7g_1 = _this__u8e3s4;
    this.a7h_1 = path;
    this.b7h_1 = mode;
  }
  protoOf($openCOROUTINE$291).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.c7h_1 = jsObject([to('read', this.b7h_1.z64_1), to('write', this.b7h_1.w64_1), to('append', this.b7h_1.a65_1), to('truncate', this.b7h_1.y64_1), to('create', this.b7h_1.w64_1), to('createNew', this.b7h_1.x64_1), to('mode', toInt('666', 8))]);
            this.fd_1 = 1;
            suspendResult = await_0(Deno.open(getFullPath(this.z7g_1, this.a7h_1), this.c7h_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var file = suspendResult;
            return toAsyncStream(new DenoAsyncStreamBase(file));
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $statCOROUTINE$296(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l7h_1 = _this__u8e3s4;
    this.m7h_1 = path;
  }
  protoOf($statCOROUTINE$296).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = await_0(Deno.stat(getFullPath(this.l7h_1, this.m7h_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            var it = suspendResult;
            var tmp_1 = it.isDirectory;
            var tmp_2 = numberToLong(it.size);
            var tmp_3 = numberToLong(it.dev);
            var tmp0_safe_receiver = it.ino;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : numberToLong(tmp0_safe_receiver);
            var tmp_4 = tmp1_elvis_lhs == null ? new Long(-1, -1) : tmp1_elvis_lhs;
            var tmp2_safe_receiver = it.mode;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : numberToInt(tmp2_safe_receiver);
            tmp_0.n7h_1 = this.l7h_1.x63(this.m7h_1, tmp_1, tmp_2, tmp_3, tmp_4, tmp3_elvis_lhs == null ? toInt('777', 8) : tmp3_elvis_lhs);
            this.gd_1 = 3;
            this.fd_1 = 4;
            continue $sm;
          case 2:
            this.gd_1 = 3;
            var tmp_5 = this.id_1;
            if (tmp_5 instanceof Error) {
              var e = this.id_1;
              var tmp_6 = this;
              tmp_6.n7h_1 = this.l7h_1.z63(this.m7h_1);
              this.fd_1 = 4;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 3:
            throw this.id_1;
          case 4:
            this.gd_1 = 3;
            return this.n7h_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 3) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  function DenoLocalVfs() {
    Vfs.call(this);
  }
  protoOf(DenoLocalVfs).q63 = function (path, mode, $completion) {
    var tmp = new $openCOROUTINE$291(this, path, mode, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(DenoLocalVfs).s63 = function (path, $completion) {
    var tmp = new $statCOROUTINE$296(this, path, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function $readCOROUTINE$298(_this__u8e3s4, position, buffer, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w7h_1 = _this__u8e3s4;
    this.x7h_1 = position;
    this.y7h_1 = buffer;
    this.z7h_1 = offset;
    this.a7i_1 = len;
  }
  protoOf($readCOROUTINE$298).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = await_0(this.w7h_1.b7i_1.seek(this.x7h_1.u6(), Deno.SeekMode.Start), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.fd_1 = 2;
            suspendResult = await_0(this.w7h_1.b7i_1.read(new Uint8Array(asUint8Array(this.y7h_1).buffer, this.z7h_1, this.a7i_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var read = suspendResult;
            var tmp1_elvis_lhs = read == null ? null : numberToInt(read);
            return tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $writeCOROUTINE$299(_this__u8e3s4, position, buffer, offset, len, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k7i_1 = _this__u8e3s4;
    this.l7i_1 = position;
    this.m7i_1 = buffer;
    this.n7i_1 = offset;
    this.o7i_1 = len;
  }
  protoOf($writeCOROUTINE$299).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = await_0(this.k7i_1.b7i_1.seek(this.l7i_1.u6(), Deno.SeekMode.Start), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.fd_1 = 2;
            suspendResult = await_0(this.k7i_1.b7i_1.write(new Uint8Array(asUint8Array(this.m7i_1).buffer, this.n7i_1, this.o7i_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $getLengthCOROUTINE$300(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x7i_1 = _this__u8e3s4;
  }
  protoOf($getLengthCOROUTINE$300).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = await_0(this.x7i_1.b7i_1.stat(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT.size;
            return numberToLong(ARGUMENT_0);
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function DenoAsyncStreamBase(file) {
    AsyncStreamBase.call(this);
    this.b7i_1 = file;
  }
  protoOf(DenoAsyncStreamBase).k67 = function (position, buffer, offset, len, $completion) {
    var tmp = new $readCOROUTINE$298(this, position, buffer, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(DenoAsyncStreamBase).l67 = function (position, buffer, offset, len, $completion) {
    var tmp = new $writeCOROUTINE$299(this, position, buffer, offset, len, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(DenoAsyncStreamBase).m5w = function ($completion) {
    var tmp = new $getLengthCOROUTINE$300(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(DenoAsyncStreamBase).x5u = function ($completion) {
    this.b7i_1.close();
    return Unit_instance;
  };
  function get_nodeFS() {
    _init_properties_JsRuntimeNode_kt__v0s2kf();
    // Inline function 'kotlin.getValue' call
    var this_0 = nodeFS$delegate;
    nodeFS$factory();
    return this_0.m2();
  }
  var nodeFS$delegate;
  function _get_fs__ndc19a($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.d7j_1;
    fs$factory();
    return this_0.m2();
  }
  function _get_path__dbvv7q($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.e7j_1;
    path$factory();
    return this_0.m2();
  }
  function JsRuntimeNode$fs$delegate$lambda() {
    return require_node('fs');
  }
  function JsRuntimeNode$path$delegate$lambda() {
    return require_node('path');
  }
  function JsRuntimeNode() {
    JsRuntimeNode_instance = this;
    JsRuntime.call(this);
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    tmp.c7j_1 = process.platform;
    var tmp_0 = this;
    tmp_0.d7j_1 = lazy(JsRuntimeNode$fs$delegate$lambda);
    var tmp_1 = this;
    tmp_1.e7j_1 = lazy(JsRuntimeNode$path$delegate$lambda);
  }
  protoOf(JsRuntimeNode).i7f = function (path) {
    return _get_fs__ndc19a(this).existsSync(path);
  };
  protoOf(JsRuntimeNode).j7f = function () {
    return _get_path__dbvv7q(this).resolve('.');
  };
  protoOf(JsRuntimeNode).b7f = function (key) {
    return process.env[key];
  };
  protoOf(JsRuntimeNode).h7f = function () {
    return jsObjectToMap(process.env);
  };
  protoOf(JsRuntimeNode).y7e = function (path) {
    var tmp;
    if (path === '.') {
      var path_0 = get_jsRuntime().j7f();
      tmp = ((get_jsRuntime().i7f(path_0 + '/node_modules') ? get_jsRuntime().i7f(path_0 + '/kotlin') : false) ? get_jsRuntime().i7f(path_0 + '/package.json') : false) ? path_0 + '/kotlin' : path_0;
    } else {
      tmp = path;
    }
    var rpath = tmp;
    return (new NodeJsLocalVfs()).s13(rpath);
  };
  protoOf(JsRuntimeNode).f7f = function () {
    return new HttpClientNodeJs();
  };
  var JsRuntimeNode_instance;
  function JsRuntimeNode_getInstance() {
    if (JsRuntimeNode_instance == null)
      new JsRuntimeNode();
    return JsRuntimeNode_instance;
  }
  function asUint8Array(_this__u8e3s4) {
    _init_properties_JsRuntimeNode_kt__v0s2kf();
    var i = asInt8Array(_this__u8e3s4);
    return new Uint8Array(i.buffer, i.byteOffset, i.length);
  }
  function require_node(name) {
    _init_properties_JsRuntimeNode_kt__v0s2kf();
    return eval('(' + get_REQ() + "uire('" + name + "'))");
  }
  function getFullPath_0($this, path) {
    return normalize(get_pathInfo(path));
  }
  function NodeJsLocalVfs$stat$lambda($deferred, this$0, $path) {
    return function (err, stats) {
      // Inline function 'kotlin.runCatching' call
      var tmp;
      try {
        // Inline function 'kotlin.Companion.success' call
        // Inline function 'korlibs.io.runtime.node.NodeJsLocalVfs.stat.<anonymous>.<anonymous>' call
        var value = this$0.f7j(stats, $path);
        tmp = _Result___init__impl__xyqfz8(value);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var tmp$ret$3 = tmp;
      completeWith($deferred, tmp$ret$3);
      return Unit_instance;
    };
  }
  function NodeJsLocalVfs$_open$lambda($cc, $path, $cmode, $file) {
    return function (err, fd) {
      var tmp;
      if (!(err == null) ? true : fd == null) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        var this_0 = $cc;
        // Inline function 'kotlin.Companion.failure' call
        var exception = new FileNotFoundException("Can't open '" + $path + "' with mode '" + $cmode + "': err=" + err);
        var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
        this_0.s6(tmp$ret$0);
        tmp = Unit_instance;
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        var this_1 = $cc;
        // Inline function 'kotlin.Companion.success' call
        var value = toAsyncStream(new NodeFDStream($file, fd));
        var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
        this_1.s6(tmp$ret$2);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NodeJsLocalVfs$_open$lambda_0(it) {
    return Unit_instance;
  }
  function $openCOROUTINE$304(_this__u8e3s4, path, mode, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o7j_1 = _this__u8e3s4;
    this.p7j_1 = path;
    this.q7j_1 = mode;
  }
  protoOf($openCOROUTINE$304).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 5;
            this.r7j_1 = this.q7j_1;
            this.s7j_1 = this.r7j_1.ka_1;
            if (this.s7j_1 === 0) {
              this.t7j_1 = 'r';
              this.fd_1 = 3;
              continue $sm;
            } else {
              if (this.s7j_1 === 1) {
                this.t7j_1 = 'r+';
                this.fd_1 = 3;
                continue $sm;
              } else {
                if (this.s7j_1 === 3) {
                  this.t7j_1 = 'w+';
                  this.fd_1 = 3;
                  continue $sm;
                } else {
                  if (this.s7j_1 === 5) {
                    this.fd_1 = 1;
                    suspendResult = this.o7j_1.s63(this.p7j_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (this.s7j_1 === 4) {
                      this.t7j_1 = 'wx+';
                      this.fd_1 = 3;
                      continue $sm;
                    } else {
                      if (this.s7j_1 === 2) {
                        this.t7j_1 = 'a';
                        this.fd_1 = 3;
                        continue $sm;
                      } else {
                        var tmp_0 = this;
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            this.u7j_1 = suspendResult;
            if (this.u7j_1.z62_1) {
              throw new FileAlreadyExistsException(this.p7j_1);
            } else {
              this.fd_1 = 2;
              continue $sm;
            }

          case 2:
            this.t7j_1 = 'w+';
            this.fd_1 = 3;
            continue $sm;
          case 3:
            this.v7j_1 = this.t7j_1;
            this.fd_1 = 4;
            suspendResult = this.o7j_1.w7j(this.p7j_1, this.v7j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 5) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function NodeJsLocalVfs() {
    LocalVfs.call(this);
  }
  protoOf(NodeJsLocalVfs).f7j = function (_this__u8e3s4, path) {
    var tmp;
    if (_this__u8e3s4 == null) {
      return this.z63(path);
    } else {
      tmp = _this__u8e3s4;
    }
    var stats = tmp;
    return this.x63(path, stats.isDirectory(), numberToLong(stats.size), numberToLong(stats.dev), numberToLong(stats.ino), numberToInt(stats.mode), VOID, VOID, Companion_getInstance_12().c1q(stats.ctimeMs), Companion_getInstance_12().c1q(stats.mtimeMs), Companion_getInstance_12().c1q(stats.atimeMs));
  };
  protoOf(NodeJsLocalVfs).s63 = function (path, $completion) {
    var deferred = CompletableDeferred();
    var tmp = get_nodeFS();
    tmp.stat(path, NodeJsLocalVfs$stat$lambda(deferred, this, path));
    return deferred.q1d($completion);
  };
  protoOf(NodeJsLocalVfs).q63 = function (path, mode, $completion) {
    var tmp = new $openCOROUTINE$304(this, path, mode, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(NodeJsLocalVfs).w7j = function (path, cmode, $completion) {
    var file = this.z56(path);
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), get_MODE_CANCELLABLE());
    cancellable.m1f();
    // Inline function 'korlibs.io.runtime.node.NodeJsLocalVfs._open.<anonymous>' call
    var tmp = get_nodeFS();
    var tmp_0 = getFullPath_0(this, path);
    tmp.open(tmp_0, cmode, NodeJsLocalVfs$_open$lambda(cancellable, path, cmode, file));
    cancellable.c1e(NodeJsLocalVfs$_open$lambda_0);
    return cancellable.y1c();
  };
  protoOf(NodeJsLocalVfs).toString = function () {
    return 'NodeJsLocalVfs';
  };
  function HttpClientNodeJs$requestInternal$lambda$lambda($body) {
    return function (d) {
      return $body.push(d);
    };
  }
  function HttpClientNodeJs$requestInternal$lambda$lambda_0($body, $statusCode, $statusMessage, $jsHeadersObj, $deferred) {
    return function () {
      // Inline function 'kotlin.js.asDynamic' call
      var r = get_jsGlobal().Buffer.concat($body);
      // Inline function 'kotlin.js.unsafeCast' call
      var u8array = new Int8Array(r);
      var out = new Int8Array(u8array.length);
      var inductionVariable = 0;
      var last = u8array.length;
      var tmp;
      if (inductionVariable < last) {
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'org.khronos.webgl.get' call
          // Inline function 'kotlin.js.asDynamic' call
          out[n] = u8array[n];
        }
         while (inductionVariable < last);
        tmp = Unit_instance;
      }
      // Inline function 'kotlin.collections.mapValues' call
      var tmp1_elvis_lhs = jsToObjectMap($jsHeadersObj);
      var this_0 = tmp1_elvis_lhs == null ? LinkedHashMap_init_$Create$() : tmp1_elvis_lhs;
      // Inline function 'kotlin.collections.mapValuesTo' call
      var destination = LinkedHashMap_init_$Create$_0(mapCapacity(this_0.n()));
      // Inline function 'kotlin.collections.associateByTo' call
      var tmp0_iterator = this_0.k2().u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
        var tmp_0 = element.l2();
        // Inline function 'korlibs.io.runtime.node.HttpClientNodeJs.requestInternal.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$5 = toString_1(element.m2());
        destination.i2(tmp_0, tmp$ret$5);
      }
      var response = new Response($statusCode, $statusMessage, Headers_init_$Create$_0(destination), openAsync(out), openAsync(out));
      return $deferred.d1g(response);
    };
  }
  function HttpClientNodeJs$requestInternal$lambda($deferred) {
    return function (res) {
      var statusCode = res.statusCode;
      var tmp0_elvis_lhs = res.statusMessage;
      var statusMessage = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      var jsHeadersObj = res.headers;
      var body = jsEmptyArray();
      res.on('data', HttpClientNodeJs$requestInternal$lambda$lambda(body));
      return res.on('end', HttpClientNodeJs$requestInternal$lambda$lambda_0(body, statusCode, statusMessage, jsHeadersObj, $deferred));
    };
  }
  function HttpClientNodeJs$requestInternal$lambda_0($deferred) {
    return function (e) {
      return $deferred.c1g(RuntimeException_init_$Create$('Error: ' + e));
    };
  }
  function HttpClientNodeJs$requestInternal$lambda_1($deferred, $r) {
    return function (it) {
      var tmp;
      if ($deferred.q1g()) {
        tmp = $r.abort();
      }
      return Unit_instance;
    };
  }
  function $requestInternalCOROUTINE$309(_this__u8e3s4, method, url, headers, content, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f7k_1 = _this__u8e3s4;
    this.g7k_1 = method;
    this.h7k_1 = url;
    this.i7k_1 = headers;
    this.j7k_1 = content;
  }
  protoOf($requestInternalCOROUTINE$309).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            this.k7k_1 = CompletableDeferred(Job());
            this.l7k_1 = require_node('http');
            this.m7k_1 = require_node('url');
            this.n7k_1 = this.m7k_1.parse(this.h7k_1);
            this.o7k_1 = jsEmptyObj();
            var tmp0_iterator = this.i7k_1.u();
            while (tmp0_iterator.v()) {
              var header = tmp0_iterator.x();
              this.o7k_1[header.ag_1] = header.bg_1;
            }

            this.p7k_1 = jsEmptyObj();
            this.p7k_1.method = this.g7k_1.zb();
            this.p7k_1.host = this.n7k_1['hostname'];
            this.p7k_1.port = this.n7k_1['port'];
            this.p7k_1.path = this.n7k_1['path'];
            this.p7k_1.agent = false;
            this.p7k_1.encoding = null;
            this.p7k_1.headers = this.o7k_1;
            var tmp_0 = this;
            tmp_0.q7k_1 = this.l7k_1.request(this.p7k_1, HttpClientNodeJs$requestInternal$lambda(this.k7k_1)).on('error', HttpClientNodeJs$requestInternal$lambda_0(this.k7k_1));
            this.k7k_1.x1b(HttpClientNodeJs$requestInternal$lambda_1(this.k7k_1, this.q7k_1));
            if (!(this.j7k_1 == null)) {
              this.fd_1 = 1;
              suspendResult = readAll(this.j7k_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.q7k_1.end();
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            this.r7k_1 = suspendResult;
            this.s7k_1 = toTypedArray(this.r7k_1);
            this.q7k_1.end(this.s7k_1);
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.t7k_1 = this.j7k_1;
            if (this.t7k_1 == null) {
              this.u7k_1 = null;
              this.fd_1 = 4;
              continue $sm;
            } else {
              this.fd_1 = 3;
              suspendResult = this.t7k_1.x5u(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            var tmp_1 = this;
            tmp_1.u7k_1 = Unit_instance;
            this.fd_1 = 4;
            continue $sm;
          case 4:
            this.fd_1 = 5;
            suspendResult = this.k7k_1.q1d(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            return suspendResult;
          case 6:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 6) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function HttpClientNodeJs() {
    HttpClient.call(this);
  }
  protoOf(HttpClientNodeJs).q6l = function (method, url, headers, content, $completion) {
    var tmp = new $requestInternalCOROUTINE$309(this, method, url, headers, content, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function asInt8Array(_this__u8e3s4) {
    _init_properties_JsRuntimeNode_kt__v0s2kf();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4;
  }
  function get_REQ() {
    _init_properties_JsRuntimeNode_kt__v0s2kf();
    return 'req';
  }
  function checkFd($this) {
    if ($this.x7k_1 == null) {
      // Inline function 'kotlin.error' call
      var message = 'File ' + $this.w7k_1 + ' already closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function NodeFDStream$read$lambda($c, this$0) {
    return function (err, bytesRead, buf) {
      var tmp;
      if (!(err == null)) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        var this_0 = $c;
        // Inline function 'kotlin.Companion.failure' call
        var exception = new IOException('Error reading from ' + this$0.w7k_1 + ' :: err=' + err);
        var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
        this_0.s6(tmp$ret$0);
        tmp = Unit_instance;
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        var this_1 = $c;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$2 = _Result___init__impl__xyqfz8(bytesRead);
        this_1.s6(tmp$ret$2);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NodeFDStream$read$lambda_0(it) {
    return Unit_instance;
  }
  function NodeFDStream$write$lambda($c, this$0) {
    return function (err, bytesWritten, buffer) {
      var tmp;
      if (!(err == null)) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        var this_0 = $c;
        // Inline function 'kotlin.Companion.failure' call
        var exception = new IOException('Error writting to ' + this$0.w7k_1 + ' :: err=' + err);
        var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
        this_0.s6(tmp$ret$0);
        tmp = Unit_instance;
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        var this_1 = $c;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
        this_1.s6(tmp$ret$2);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NodeFDStream$write$lambda_0(it) {
    return Unit_instance;
  }
  function NodeFDStream$getLength$lambda($c, this$0) {
    return function (err, stats) {
      var tmp;
      if (!(err == null)) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        var this_0 = $c;
        // Inline function 'kotlin.Companion.failure' call
        var exception = new IOException('Error getting length from ' + this$0.w7k_1 + ' :: err=' + err);
        var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
        this_0.s6(tmp$ret$0);
        tmp = Unit_instance;
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        var this_1 = $c;
        // Inline function 'kotlin.Companion.success' call
        var value = numberToLong(stats.size);
        var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
        this_1.s6(tmp$ret$2);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NodeFDStream$getLength$lambda_0(it) {
    return Unit_instance;
  }
  function NodeFDStream$close$lambda(this$0, $c) {
    return function (err) {
      this$0.x7k_1 = null;
      var tmp;
      if (!(err == null)) {
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = $c;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
        this_0.s6(tmp$ret$0);
        tmp = Unit_instance;
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        var this_1 = $c;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
        this_1.s6(tmp$ret$2);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NodeFDStream$close$lambda_0(it) {
    return Unit_instance;
  }
  function $closeCOROUTINE$312(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g7l_1 = _this__u8e3s4;
  }
  protoOf($closeCOROUTINE$312).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            if (!(this.g7l_1.x7k_1 == null)) {
              this.fd_1 = 2;
              var cancellable = new CancellableContinuationImpl(intercepted(this), get_MODE_CANCELLABLE());
              cancellable.m1f();
              var tmp_0 = get_nodeFS();
              var tmp_1 = this.g7l_1.x7k_1;
              tmp_0.close(tmp_1, NodeFDStream$close$lambda(this.g7l_1, cancellable));
              cancellable.c1e(NodeFDStream$close$lambda_0);
              suspendResult = returnIfSuspended(cancellable.y1c(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 1;
              continue $sm;
            }

          case 1:
            return Unit_instance;
          case 2:
            return Unit_instance;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function NodeFDStream(file, fd) {
    AsyncStreamBase.call(this);
    this.w7k_1 = file;
    this.x7k_1 = fd;
  }
  protoOf(NodeFDStream).k67 = function (position, buffer, offset, len, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), get_MODE_CANCELLABLE());
    cancellable.m1f();
    // Inline function 'korlibs.io.runtime.node.NodeFDStream.read.<anonymous>' call
    checkFd(this);
    var tmp = get_nodeFS();
    var tmp_0 = this.x7k_1;
    var tmp_1 = toNodeJsBuffer(buffer);
    var tmp_2 = position.u6();
    tmp.read(tmp_0, tmp_1, offset, len, tmp_2, NodeFDStream$read$lambda(cancellable, this));
    cancellable.c1e(NodeFDStream$read$lambda_0);
    return cancellable.y1c();
  };
  protoOf(NodeFDStream).l67 = function (position, buffer, offset, len, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), get_MODE_CANCELLABLE());
    cancellable.m1f();
    // Inline function 'korlibs.io.runtime.node.NodeFDStream.write.<anonymous>' call
    checkFd(this);
    var tmp = get_nodeFS();
    var tmp_0 = this.x7k_1;
    var tmp_1 = toNodeJsBuffer(buffer);
    var tmp_2 = position.u6();
    tmp.write(tmp_0, tmp_1, offset, len, tmp_2, NodeFDStream$write$lambda(cancellable, this));
    cancellable.c1e(NodeFDStream$write$lambda_0);
    return cancellable.y1c();
  };
  protoOf(NodeFDStream).m5w = function ($completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), get_MODE_CANCELLABLE());
    cancellable.m1f();
    // Inline function 'korlibs.io.runtime.node.NodeFDStream.getLength.<anonymous>' call
    checkFd(this);
    var tmp = get_nodeFS();
    var tmp_0 = this.x7k_1;
    tmp.fstat(tmp_0, NodeFDStream$getLength$lambda(cancellable, this));
    cancellable.c1e(NodeFDStream$getLength$lambda_0);
    return cancellable.y1c();
  };
  protoOf(NodeFDStream).x5u = function ($completion) {
    var tmp = new $closeCOROUTINE$312(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function toNodeJsBuffer(_this__u8e3s4) {
    _init_properties_JsRuntimeNode_kt__v0s2kf();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return asUint8Array(_this__u8e3s4);
  }
  function nodeFS$delegate$lambda() {
    _init_properties_JsRuntimeNode_kt__v0s2kf();
    return require_node('fs');
  }
  function nodeFS$factory() {
    return getPropertyCallableRef('nodeFS', 0, KProperty0, function () {
      return get_nodeFS();
    }, null);
  }
  function fs$factory() {
    return getPropertyCallableRef('fs', 1, KProperty1, function (receiver) {
      return _get_fs__ndc19a(receiver);
    }, null);
  }
  function path$factory() {
    return getPropertyCallableRef('path', 1, KProperty1, function (receiver) {
      return _get_path__dbvv7q(receiver);
    }, null);
  }
  var properties_initialized_JsRuntimeNode_kt_f9ymrl;
  function _init_properties_JsRuntimeNode_kt__v0s2kf() {
    if (!properties_initialized_JsRuntimeNode_kt_f9ymrl) {
      properties_initialized_JsRuntimeNode_kt_f9ymrl = true;
      nodeFS$delegate = lazy(nodeFS$delegate$lambda);
    }
  }
  function toByteArray(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var tout = _this__u8e3s4;
    var tmp;
    if (!(tout == null) ? isByteArray(tout) : false) {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = tout;
    } else {
      var out = new Int8Array(_this__u8e3s4.length);
      var inductionVariable = 0;
      var last = out.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'org.khronos.webgl.get' call
          // Inline function 'kotlin.js.asDynamic' call
          out[n] = _this__u8e3s4[n];
        }
         while (inductionVariable <= last);
      tmp = out;
    }
    return tmp;
  }
  function set_workerUrl(_set____db54di) {
    _init_properties_Worker_js_kt__6mcbpj();
    workerUrl = _set____db54di;
  }
  function get_workerUrl() {
    _init_properties_Worker_js_kt__6mcbpj();
    return workerUrl;
  }
  var workerUrl;
  function get_workerImpl() {
    _init_properties_Worker_js_kt__6mcbpj();
    return workerImpl;
  }
  var workerImpl;
  function get_isWorker_0() {
    _init_properties_Worker_js_kt__6mcbpj();
    // Inline function 'kotlin.js.unsafeCast' call
    return typeof DedicatedWorkerGlobalScope === 'function';
  }
  function workerImpl$o$insideWorker$lambda(evt) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var input = evt.data;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var id = input[0];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = input[1];
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? get_workerUrl() : tmp0_elvis_lhs;
    var moduleUrl = tmp1_elvis_lhs == null ? '.' : tmp1_elvis_lhs;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var clazzName = input[2];
    var params = drop(input, 3);
    var tmp = import(moduleUrl);
    var tmp_0 = tmp instanceof Promise ? tmp : THROW_CCE();
    var imported = tmp_0.then(workerImpl$o$insideWorker$lambda$lambda(clazzName, params, id));
    return Unit_instance;
  }
  function workerImpl$o$insideWorker$lambda$lambda$slambda($workerTask, $id, resultContinuation) {
    this.p7l_1 = $workerTask;
    this.q7l_1 = $id;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(workerImpl$o$insideWorker$lambda$lambda$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(workerImpl$o$insideWorker$lambda$lambda$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(workerImpl$o$insideWorker$lambda$lambda$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.gd_1 = 3;
            this.p7l_1.h77();
            this.r7l_1 = this.p7l_1.l77_1;
            this.s7l_1 = this.r7l_1;
            var tmp_0 = this.s7l_1;
            if (!(tmp_0 == null) ? isInterface(tmp_0, Deferred) : false) {
              this.fd_1 = 1;
              suspendResult = this.r7l_1.q1d(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var this_0 = get_jsGlobalThis();
              var this_1 = [this.q7l_1, 'ok', this.r7l_1];
              this_0.postMessage(this_1);
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = [this.q7l_1, 'ok', ARGUMENT];
            get_jsGlobalThis().postMessage(ARGUMENT_0);
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.gd_1 = 4;
            this.fd_1 = 5;
            continue $sm;
          case 3:
            this.gd_1 = 4;
            var e = this.id_1;
            var this_2 = get_jsGlobalThis();
            var this_3 = [this.q7l_1, 'error', e.stack];
            this_2.postMessage(this_3);
            this.fd_1 = 5;
            continue $sm;
          case 4:
            throw this.id_1;
          case 5:
            this.gd_1 = 4;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 4) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(workerImpl$o$insideWorker$lambda$lambda$slambda).g5a = function (completion) {
    return new workerImpl$o$insideWorker$lambda$lambda$slambda(this.p7l_1, this.q7l_1, completion);
  };
  function workerImpl$o$insideWorker$lambda$lambda$slambda_0($workerTask, $id, resultContinuation) {
    var i = new workerImpl$o$insideWorker$lambda$lambda$slambda($workerTask, $id, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function workerImpl$o$insideWorker$lambda$lambda($clazzName, $params, $id) {
    return function (imported) {
      // Inline function 'kotlin.js.asDynamic' call
      var taskClass = imported[$clazzName];
      // Inline function 'kotlin.js.unsafeCast' call
      var workerTask = jsNew(taskClass);
      workerTask.k77_1 = toList($params);
      var tmp = EmptyCoroutineContext_getInstance();
      return launchImmediately(tmp, workerImpl$o$insideWorker$lambda$lambda$slambda_0(workerTask, $id, null));
    };
  }
  function workerImpl$1() {
    _WorkerImpl.call(this);
    this.t7l_1 = 0;
  }
  protoOf(workerImpl$1).u7l = function () {
    return !(get_workerUrl() == null);
  };
  protoOf(workerImpl$1).j78 = function () {
    var tmp;
    if (get_isDenoJs()) {
      tmp = Deno.mainModule;
    } else {
      var tmp0_safe_receiver = lastOrNull_0(Companion_instance_6.g38().i38_1);
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b38_1;
    }
    set_workerUrl(tmp);
    if (get_workerUrl() == null) {
      println('workerUrl = null, STACKTRACE:' + stackTraceToString(Exception_init_$Create$_0()));
    }
    if (get_isWorker_0() ? this.u7l() : false) {
      // Inline function 'kotlin.js.asDynamic' call
      get_jsGlobalThis().onmessage = workerImpl$o$insideWorker$lambda;
    }
    return get_isWorker_0();
  };
  var properties_initialized_Worker_js_kt_gnq77b;
  function _init_properties_Worker_js_kt__6mcbpj() {
    if (!properties_initialized_Worker_js_kt_gnq77b) {
      properties_initialized_Worker_js_kt_gnq77b = true;
      var tmp0_elvis_lhs = globalThis.location;
      workerUrl = tmp0_elvis_lhs == null ? get_isDenoJs() ? Deno.mainModule : '.' : tmp0_elvis_lhs;
      workerImpl = new workerImpl$1();
    }
  }
  //region block: post-declaration
  protoOf(BitmapFontImpl).p3t = get_baseBmp;
  protoOf(BitmapFontImpl).t3t = getFontMetrics;
  protoOf(BitmapFontImpl).e3u = getFontMetrics$default;
  protoOf(BitmapFontImpl).f3u = getGlyphMetrics;
  protoOf(BitmapFontImpl).n3u = getGlyphMetrics$default;
  protoOf(BitmapFontImpl).s3v = getKerning;
  protoOf(BitmapFontImpl).p3u = getTextScale;
  protoOf(BitmapFontImpl).f1 = get_1;
  protoOf(BitmapFontImpl).q3u = renderGlyph;
  protoOf(BitmapFontImpl).r3v = renderGlyph$default;
  protoOf(TextRendererActions).n1y = reset;
  protoOf(TextRendererActions).x46 = advance;
  protoOf(TextRendererActions).y46 = newLine;
  protoOf(LazyBitmapFont).p3t = get_baseBmp;
  protoOf(LazyBitmapFont).t3t = getFontMetrics;
  protoOf(LazyBitmapFont).e3u = getFontMetrics$default;
  protoOf(LazyBitmapFont).f3u = getGlyphMetrics;
  protoOf(LazyBitmapFont).n3u = getGlyphMetrics$default;
  protoOf(LazyBitmapFont).s3v = getKerning;
  protoOf(LazyBitmapFont).p3u = getTextScale;
  protoOf(LazyBitmapFont).t3v = getOrNull_2;
  protoOf(LazyBitmapFont).f1 = get_1;
  protoOf(LazyBitmapFont).q3u = renderGlyph;
  protoOf(LazyBitmapFont).r3v = renderGlyph$default;
  protoOf(BaseTtfFont).e3u = getFontMetrics$default;
  protoOf(BaseTtfFont).n3u = getGlyphMetrics$default;
  protoOf(BaseTtfFont).y4g = getGlyphPath$default;
  protoOf(BaseTtfFont).q3u = renderGlyph_0;
  protoOf(BaseTtfFont).r3v = renderGlyph$default;
  protoOf(BaseTtfFont).t3v = getOrNull_2;
  protoOf(ColrGlyphInfoV1).j4o = getColorShape$default;
  protoOf(ColrGlyphInfoV0).j4o = getColorShape$default;
  protoOf(GlyphGraphicsPath).v33 = arc$default;
  protoOf(AseBitmapCell).x4s = resolve;
  protoOf(AseTilemapCell).x4s = resolve;
  protoOf(Context2d).q33 = line;
  protoOf(Context2d).b1 = isEmpty;
  protoOf(Context2d).r33 = rect;
  protoOf(Context2d).s33 = rect_0;
  protoOf(Context2d).t33 = rect_1;
  protoOf(Context2d).u33 = arc;
  protoOf(Context2d).v33 = arc$default;
  protoOf(Context2d).w33 = circle;
  protoOf(Context2d).x33 = rMoveTo;
  protoOf(Context2d).y33 = rLineTo;
  protoOf(Context2d).p2l = transformed;
  protoOf(FillShape).q5j = getBounds;
  protoOf(FillShape).p5j = getPath_0;
  protoOf(FillShape).q48 = getPath$default;
  protoOf(FillShape).x47 = draw;
  protoOf(FillShape).s4o = get_bounds;
  protoOf(CompoundShape).q48 = getPath$default;
  protoOf(CompoundShape).s4o = get_bounds;
  protoOf(PolylineShape).p5j = getPath_0;
  protoOf(PolylineShape).q48 = getPath$default;
  protoOf(PolylineShape).x47 = draw;
  protoOf(PolylineShape).s4o = get_bounds;
  protoOf(EmptyShape).p5j = getPath;
  protoOf(EmptyShape).q48 = getPath$default;
  protoOf(EmptyShape).s4o = get_bounds;
  protoOf(PreferSyncIo).md = get;
  protoOf(PreferSyncIo).ch = fold;
  protoOf(PreferSyncIo).bh = minusKey;
  protoOf(PreferSyncIo).dh = plus_2;
  protoOf(runBlockingNoSuspensions$1$context$1).md = get_0;
  protoOf(runBlockingNoSuspensions$1$context$1).bh = minusKey_0;
  protoOf(runBlockingNoSuspensions$1$context$1).nd = releaseInterceptedContinuation;
  protoOf(runBlockingNoSuspensions$1$context$1).e1h = invokeOnTimeout;
  protoOf(VfsCachedStatContext).md = get;
  protoOf(VfsCachedStatContext).ch = fold;
  protoOf(VfsCachedStatContext).bh = minusKey;
  protoOf(VfsCachedStatContext).dh = plus_2;
  protoOf(AsyncStreamBase).l5w = hasLength;
  protoOf(AsyncStream).l5w = hasLength;
  protoOf(toAsyncInputStream$1).l5w = hasLength;
  protoOf(StandardPaths).h6b = appPreferencesFolder;
  //endregion
  //region block: init
  Companion_instance_7 = new Companion();
  DEFAULT_MAX_SAMPLES = 39690000;
  Companion_instance_13 = new Companion_5();
  Bitmaps_instance = new Bitmaps();
  Companion_instance_15 = new Companion_7();
  Companion_instance_16 = new Companion_8();
  NewSDF_instance = new NewSDF();
  Companion_instance_18 = new Companion_10();
  Companion_instance_20 = new Companion_12();
  Companion_instance_21 = new Companion_13();
  Companion_instance_22 = new Companion_14();
  Companion_instance_23 = new Companion_15();
  DefaultTtfFontOrNull = null;
  SystemFontRegistryOrNull = null;
  _nativeSystemFontProvider = null;
  CFF_instance = new CFF();
  CharStringType2_instance = new CharStringType2();
  Companion_instance_28 = new Companion_20();
  Companion_instance_30 = new Companion_22();
  Companion_instance_31 = new Companion_23();
  Companion_instance_32 = new Companion_24();
  Companion_instance_34 = new Companion_26();
  Companion_instance_36 = new Companion_28();
  Companion_instance_39 = new Companion_31();
  Companion_instance_40 = new Companion_32();
  NonePaint_instance = new NonePaint();
  Companion_instance_46 = new Companion_38();
  EmptyShape_instance = new EmptyShape();
  SvgPath_instance = new SvgPath();
  Companion_instance_50 = new Companion_42();
  Companion_instance_53 = new Companion_45();
  Companion_instance_54 = new Companion_46();
  Companion_instance_55 = new Companion_47();
  Companion_instance_56 = new Companion_48();
  Companion_instance_57 = new Companion_49();
  resourcesVfsDebug = false;
  Companion_instance_58 = new Companion_50();
  Companion_instance_59 = new Companion_51();
  Charsets_instance = new Charsets();
  customEnvironments = null;
  Companion_instance_60 = new Companion_52();
  QueryString_instance = new QueryString();
  Companion_instance_64 = new Companion_56();
  Companion_instance_65 = new Companion_57();
  Companion_instance_66 = new Companion_58();
  Companion_instance_68 = new Companion_60();
  EmptyLineOnce_instance = new EmptyLineOnce();
  Indent_instance = new Indent();
  Unindent_instance = new Unindent();
  MINUS_ZERO_D = -0.0;
  NumberParser_instance = new NumberParser();
  Companion_instance_70 = new Companion_62();
  Companion_instance_71 = new Companion_63();
  Adler32_instance = new Adler32();
  Companion_instance_72 = new Companion_64();
  Json_instance = new Json();
  Companion_instance_74 = new Companion_66();
  Stream_instance = new Stream();
  HtmlCanvas_instance = new HtmlCanvas();
  HtmlImage_instance = new HtmlImage();
  BrowserImage_instance = new BrowserImage();
  DynamicInternal_instance = new DynamicInternal();
  File_separatorChar = _Char___init__impl__6a9atx(47);
  StandardPaths_instance = new StandardPaths();
  EnvironmentInternal_instance = new EnvironmentInternal();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $korlibs = _.korlibs || (_.korlibs = {});
    var $korlibs$io = $korlibs.io || ($korlibs.io = {});
    var $korlibs$io$worker = $korlibs$io.worker || ($korlibs$io.worker = {});
    $korlibs$io$worker.DemoWorkerTask = DemoWorkerTask;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = Direction_FORWARD_getInstance;
  _.$_$.b = Direction_ONCE_REVERSE_getInstance;
  _.$_$.c = Direction_REVERSE_getInstance;
  _.$_$.d = readFont;
  _.$_$.e = readBitmapSlice;
  _.$_$.f = readBitmap;
  _.$_$.g = readBitmap_0;
  _.$_$.h = readImageDataContainer;
  _.$_$.i = delay_0;
  _.$_$.j = launchUnscopedAndWait;
  _.$_$.k = withTimeoutNullable;
  _.$_$.l = MutableAtlas_init_$Create$;
  _.$_$.m = _RGBA___get_af__impl__vu36qv;
  _.$_$.n = _RGBA___get_bf__impl__1xz5yg;
  _.$_$.o = _RGBA___get_gf__impl__5gcu1f;
  _.$_$.p = RGBA__hashCode_impl_h59qf6;
  _.$_$.q = _RGBA___get_hexString__impl__kocngm;
  _.$_$.r = _RGBA___get_premultiplied__impl__3bulqc;
  _.$_$.s = _RGBA___get_rf__impl__kvz75k;
  _.$_$.t = _RGBA___get_rgb__impl__tijaqt;
  _.$_$.u = _RGBA___get_value__impl__hhco8v;
  _.$_$.v = _RGBAPremultiplied___get_af__impl__euwcjn;
  _.$_$.w = _RGBAPremultiplied___get_bf__impl__qa3on2;
  _.$_$.x = _RGBAPremultiplied___get_gf__impl__ivron7;
  _.$_$.y = _RGBAPremultiplied___get_rf__impl__pt0c4y;
  _.$_$.z = _RgbaPremultipliedArray___init__impl__lx83hy;
  _.$_$.a1 = HorizontalAlign__getOffsetX_impl_urzzxf;
  _.$_$.b1 = VerticalAlign__getOffsetY_impl_iso0y6;
  _.$_$.c1 = _VerticalAlign___get_ratioFake__impl__1h2fwv;
  _.$_$.d1 = Dyn__set_impl_2ozvx8;
  _.$_$.e1 = Bitmaps_instance;
  _.$_$.f1 = Colors_getInstance;
  _.$_$.g1 = Companion_instance_23;
  _.$_$.h1 = Companion_instance_22;
  _.$_$.i1 = ASE_getInstance;
  _.$_$.j1 = Companion_getInstance_50;
  _.$_$.k1 = Companion_getInstance_48;
  _.$_$.l1 = Companion_getInstance_51;
  _.$_$.m1 = EmptyShape_instance;
  _.$_$.n1 = Companion_getInstance_56;
  _.$_$.o1 = Companion_instance_55;
  _.$_$.p1 = StandardPaths_instance;
  _.$_$.q1 = Companion_instance_60;
  _.$_$.r1 = Companion_getInstance_76;
  _.$_$.s1 = Companion_instance_72;
  _.$_$.t1 = get_nativeSoundProvider;
  _.$_$.u1 = Bitmap32;
  _.$_$.v1 = Bitmap8;
  _.$_$.w1 = get_Bitmaps_transparent;
  _.$_$.x1 = get_Bitmaps_white;
  _.$_$.y1 = FloatBitmap32;
  _.$_$.z1 = ForcedTexId;
  _.$_$.a2 = MultiBitmap;
  _.$_$.b2 = NativeImageOrBitmap32;
  _.$_$.c2 = NativeImage;
  _.$_$.d2 = NullBitmap;
  _.$_$.e2 = get_baseMipmapLevel;
  _.$_$.f2 = get_bmp;
  _.$_$.g2 = extract_0;
  _.$_$.h2 = get_maxMipmapLevel;
  _.$_$.i2 = slice_0;
  _.$_$.j2 = ColorTransformMul;
  _.$_$.k2 = RGBA;
  _.$_$.l2 = Glyph;
  _.$_$.m2 = BitmapFontImpl;
  _.$_$.n2 = BitmapFont;
  _.$_$.o2 = get_DefaultTtfFontAsBitmap;
  _.$_$.p2 = FontMetrics;
  _.$_$.q2 = Font;
  _.$_$.r2 = TextMetricsResult;
  _.$_$.s2 = TextMetrics;
  _.$_$.t2 = getTextBounds;
  _.$_$.u2 = HtmlNativeImage;
  _.$_$.v2 = ImageDecodingProps;
  _.$_$.w2 = get_RegisteredImageFormats;
  _.$_$.x2 = toHtmlNative;
  _.$_$.y2 = toProps;
  _.$_$.z2 = BitmapPaint;
  _.$_$.a3 = GradientPaint;
  _.$_$.b3 = NonePaint;
  _.$_$.c3 = get_DefaultStringTextRenderer;
  _.$_$.d3 = Entry_0;
  _.$_$.e3 = LineInfo;
  _.$_$.f3 = Text2TextRendererActions;
  _.$_$.g3 = invoke;
  _.$_$.h3 = TileSetTileInfo;
  _.$_$.i3 = CompoundShape;
  _.$_$.j3 = FillShape;
  _.$_$.k3 = PolylineShape;
  _.$_$.l3 = ShapeBuilder;
  _.$_$.m3 = TextShape;
  _.$_$.n3 = get_isLow;
  _.$_$.o3 = AsyncSignal;
  _.$_$.p3 = Signal;
  _.$_$.q3 = invoke_0;
  _.$_$.r3 = launchImmediately;
  _.$_$.s3 = launchImmediately_0;
  _.$_$.t3 = launchUnscoped_0;
  _.$_$.u3 = launchUnscoped;
  _.$_$.v3 = incrementAndGet;
  _.$_$.w3 = korAtomic_1;
  _.$_$.x3 = korAtomic;
  _.$_$.y3 = MountableVfs;
  _.$_$.z3 = get_localCurrentDirVfs;
  _.$_$.a4 = get_resourcesVfs;
  _.$_$.b4 = toVfs;
  _.$_$.c4 = CancellableGroup;
  _.$_$.d4 = cancel;
  _.$_$.e4 = CloseableCancellable;
  _.$_$.f4 = cancel_0;
  _.$_$.g4 = get_invalidOp;
  _.$_$.h4 = invalidOp;
  _.$_$.i4 = get_portableSimpleName;
  _.$_$.j4 = toDisposable;
  _.$_$.k4 = get_unreachable;
  _.$_$.l4 = unsupported_0;
  _.$_$.m4 = Resourceable;
  _.$_$.n4 = Resources;
  _.$_$.o4 = openAsync;
  _.$_$.p4 = Indenter;
  _.$_$.q4 = toStringDecimal;
  _.$_$.r4 = get_DEBUG_WORKER;
  _.$_$.s4 = get_workerImpl;
  //endregion
  return _;
}));
